/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 940);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(47);
var hide = __webpack_require__(36);
var redefine = __webpack_require__(37);
var ctx = __webpack_require__(48);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportedLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* unused harmony export i18nTranslate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return translate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return translateLangToLang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return xml; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find_index_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_object_values_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_object_values_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_object_values_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_keys_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_symbol_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_from_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_to_string_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sha1__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_render_html__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_render_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_render_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translations_zh_TW_i10n_json__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translations_zh_TW_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__translations_zh_TW_i10n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__translations_zh_CN_i10n_json__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__translations_zh_CN_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__translations_zh_CN_i10n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__translations_it_IT_i10n_json__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__translations_it_IT_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__translations_it_IT_i10n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__translations_vi_VN_i10n_json__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__translations_vi_VN_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__translations_vi_VN_i10n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__translations_pl_PL_i10n_json__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__translations_pl_PL_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__translations_pl_PL_i10n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__translations_ru_RU_i10n_json__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__translations_ru_RU_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__translations_ru_RU_i10n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__translations_pt_PT_i10n_json__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__translations_pt_PT_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__translations_pt_PT_i10n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__translations_es_ES_i10n_json__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__translations_es_ES_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__translations_es_ES_i10n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__translations_fr_FR_i10n_json__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__translations_fr_FR_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__translations_fr_FR_i10n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__translations_en_i10n_json__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__translations_en_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__translations_en_i10n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__translations_ach_UG_i10n_json__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__translations_ach_UG_i10n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__translations_ach_UG_i10n_json__);























var supportedLanguages = {
  zh_tw: __WEBPACK_IMPORTED_MODULE_12__translations_zh_TW_i10n_json___default.a,
  zh_cn: __WEBPACK_IMPORTED_MODULE_13__translations_zh_CN_i10n_json___default.a,
  it: __WEBPACK_IMPORTED_MODULE_14__translations_it_IT_i10n_json___default.a,
  vi: __WEBPACK_IMPORTED_MODULE_15__translations_vi_VN_i10n_json___default.a,
  pl: __WEBPACK_IMPORTED_MODULE_16__translations_pl_PL_i10n_json___default.a,
  ru: __WEBPACK_IMPORTED_MODULE_17__translations_ru_RU_i10n_json___default.a,
  pt: __WEBPACK_IMPORTED_MODULE_18__translations_pt_PT_i10n_json___default.a,
  es: __WEBPACK_IMPORTED_MODULE_19__translations_es_ES_i10n_json___default.a,
  fr: __WEBPACK_IMPORTED_MODULE_20__translations_fr_FR_i10n_json___default.a,
  en: __WEBPACK_IMPORTED_MODULE_21__translations_en_i10n_json___default.a,
  ach: __WEBPACK_IMPORTED_MODULE_22__translations_ach_UG_i10n_json___default.a
};
var fallbackLang = __WEBPACK_IMPORTED_MODULE_21__translations_en_i10n_json___default.a;
var translation = {};

var t = function t(key) {
  return key in translation ? translation[key] : fallbackLang[key];
};

var init = function init(lang) {
  translation = supportedLanguages[lang];
};
var i18nTranslate = function i18nTranslate(str) {
  return str && t(__WEBPACK_IMPORTED_MODULE_10_sha1___default()(str)) || str;
};
var translate = function translate(input) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (params.length) {
    var stringToBeTranslated = input.replace(/\{\$({0-9])\}/gi, '%$1');
    var translatedString = i18nTranslate(stringToBeTranslated);
    params.forEach(function (replacement, index) {
      if (translatedString && typeof translatedString === 'string') {
        translatedString = translatedString.replaceAll("{$".concat(index, "}"), replacement);
      }
    });
    return __WEBPACK_IMPORTED_MODULE_11_react_render_html___default()(translatedString);
  }

  return i18nTranslate(input);
};
var translateLangToLang = function translateLangToLang(str, fromLang, toLang) {
  if (supportedLanguages[fromLang]) {
    var hashIndex = Object.values(supportedLanguages[fromLang]).findIndex(function (translatedStr) {
      return str === translatedStr;
    });

    if (hashIndex !== -1) {
      var hash = Object.keys(supportedLanguages[fromLang])[hashIndex];
      var translatedStr = supportedLanguages[toLang][hash];

      if (translatedStr) {
        return translatedStr;
      }
    }
  }

  return str;
};
var xml = function xml(dom) {
  var categories = Array.from(dom.getElementsByTagName('category') || []);
  categories.forEach(function (child) {
    var text = child.getAttribute('i18n-text');

    if (text) {
      child.setAttribute('name', translate(text));
    }

    xml(child);
  });
  return dom;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(226);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(10);
var has = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(22);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(37);
var META = __webpack_require__(82).KEY;
var $fails = __webpack_require__(15);
var shared = __webpack_require__(89);
var setToStringTag = __webpack_require__(81);
var uid = __webpack_require__(69);
var wks = __webpack_require__(13);
var wksExt = __webpack_require__(162);
var wksDefine = __webpack_require__(149);
var enumKeys = __webpack_require__(225);
var isArray = __webpack_require__(124);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(16);
var toObject = __webpack_require__(29);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(65);
var createDesc = __webpack_require__(70);
var _create = __webpack_require__(92);
var gOPNExt = __webpack_require__(194);
var $GOPD = __webpack_require__(52);
var $GOPS = __webpack_require__(103);
var $DP = __webpack_require__(26);
var $keys = __webpack_require__(59);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(77).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(83).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(64)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(36)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(71);
var step = __webpack_require__(195);
var Iterators = __webpack_require__(76);
var toIObject = __webpack_require__(38);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(151)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(80);
var test = {};
test[__webpack_require__(13)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(37)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(120)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(151)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(5);
var getKeys = __webpack_require__(59);
var redefine = __webpack_require__(37);
var global = __webpack_require__(10);
var hide = __webpack_require__(36);
var Iterators = __webpack_require__(76);
var wks = __webpack_require__(13);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur as it's already being fired
		// in leverageNative.
		_default: function() {
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(29);
var $getPrototypeOf = __webpack_require__(60);

__webpack_require__(61)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(89)('wks');
var uid = __webpack_require__(69);
var Symbol = __webpack_require__(10).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(154).set });


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(64);
var global = __webpack_require__(10);
var ctx = __webpack_require__(48);
var classof = __webpack_require__(80);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(16);
var aFunction = __webpack_require__(45);
var anInstance = __webpack_require__(100);
var forOf = __webpack_require__(101);
var speciesConstructor = __webpack_require__(113);
var task = __webpack_require__(146).set;
var microtask = __webpack_require__(161)();
var newPromiseCapabilityModule = __webpack_require__(147);
var perform = __webpack_require__(191);
var userAgent = __webpack_require__(148);
var promiseResolve = __webpack_require__(192);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(13)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(102)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(81)($Promise, PROMISE);
__webpack_require__(91)(PROMISE);
Wrapper = __webpack_require__(47)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(126)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(22) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(125);
var cof = __webpack_require__(46);
var toAbsoluteIndex = __webpack_require__(90);
var toLength = __webpack_require__(23);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(15)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(58)(1);

$export($export.P + $export.F * !__webpack_require__(66)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(29);
var $keys = __webpack_require__(59);

__webpack_require__(61)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(15)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(55);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(123)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(71)('includes');


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(58)(2);

$export($export.P + $export.F * !__webpack_require__(66)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(158);
var toPrimitive = __webpack_require__(65);
var dP = Object.defineProperty;

exports.f = __webpack_require__(22) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(54);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(48);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(29);
var call = __webpack_require__(160);
var isArrayIter = __webpack_require__(144);
var toLength = __webpack_require__(23);
var createProperty = __webpack_require__(150);
var getIterFn = __webpack_require__(145);

$export($export.S + $export.F * !__webpack_require__(126)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(142);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(143)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(38);
var $getOwnPropertyDescriptor = __webpack_require__(52).f;

__webpack_require__(61)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(196);
var toIObject = __webpack_require__(38);
var gOPD = __webpack_require__(52);
var createProperty = __webpack_require__(150);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26);
var createDesc = __webpack_require__(70);
module.exports = __webpack_require__(22) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var hide = __webpack_require__(36);
var has = __webpack_require__(44);
var SRC = __webpack_require__(69)('src');
var $toString = __webpack_require__(223);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(47).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(99);
var defined = __webpack_require__(54);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTokenList; });
/* unused harmony export setTokenList */
/* unused harmony export findToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeAllTokens; });
/* unused harmony export isDone */
/* unused harmony export setDone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return remove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_index_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_index_js__);

var store = {};

if (typeof localStorage !== 'undefined') {
  store = localStorage;
}

var getTokenList = function getTokenList() {
  store.tokenList = !('tokenList' in store) ? '[]' : store.tokenList;

  try {
    return JSON.parse(store.tokenList);
  } catch (e) {
    store.tokenList = '[]';
    return [];
  }
};
var setTokenList = function setTokenList() {
  var tokenList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  store.tokenList = JSON.stringify(tokenList);
};

var findAccount = function findAccount() {
  var accountName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return getTokenList().findIndex(function (tokenInfo) {
    return tokenInfo.accountName === accountName;
  });
};

var findToken = function findToken() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return getTokenList().findIndex(function (tokenInfo) {
    return tokenInfo.token === token;
  });
};
var addToken = function addToken() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var loginInfo = arguments.length > 1 ? arguments[1] : undefined;
  var hasRealityCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hasTradeLimitation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var accountName = loginInfo.loginid;
  var tokenList = getTokenList();
  var tokenIndex = findToken(token);
  var accountIndex = findAccount(accountName);

  if (tokenIndex < 0 && accountIndex < 0) {
    tokenList.push({
      accountName: accountName,
      token: token,
      loginInfo: loginInfo,
      hasRealityCheck: hasRealityCheck,
      hasTradeLimitation: hasTradeLimitation
    });
    setTokenList(tokenList);
  }
};
var getToken = function getToken(token) {
  var tokenList = getTokenList();
  var index = findToken(token);
  return index >= 0 ? tokenList[index] : {};
};
var removeToken = function removeToken(token) {
  var index = findToken(token);

  if (index > -1) {
    var tokenList = getTokenList();
    tokenList.splice(index, 1);
    store.tokenList = tokenList;
  }
};
var removeAllTokens = function removeAllTokens() {
  delete store.tokenList;
};
var isDone = function isDone(varName) {
  return varName in store;
};
var setDone = function setDone(varName) {
  store[varName] = true;
};
var set = function set(varName, value) {
  store[varName] = value;
};
var get = function get(varName) {
  return store[varName];
};
var remove = function remove(varName) {
  return delete store[varName];
};

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var NS = exports.NAMESPACES = {
    HTML: 'http://www.w3.org/1999/xhtml',
    MATHML: 'http://www.w3.org/1998/Math/MathML',
    SVG: 'http://www.w3.org/2000/svg',
    XLINK: 'http://www.w3.org/1999/xlink',
    XML: 'http://www.w3.org/XML/1998/namespace',
    XMLNS: 'http://www.w3.org/2000/xmlns/'
};

exports.ATTRS = {
    TYPE: 'type',
    ACTION: 'action',
    ENCODING: 'encoding',
    PROMPT: 'prompt',
    NAME: 'name',
    COLOR: 'color',
    FACE: 'face',
    SIZE: 'size'
};

exports.DOCUMENT_MODE = {
    NO_QUIRKS: 'no-quirks',
    QUIRKS: 'quirks',
    LIMITED_QUIRKS: 'limited-quirks'
};

var $ = exports.TAG_NAMES = {
    A: 'a',
    ADDRESS: 'address',
    ANNOTATION_XML: 'annotation-xml',
    APPLET: 'applet',
    AREA: 'area',
    ARTICLE: 'article',
    ASIDE: 'aside',

    B: 'b',
    BASE: 'base',
    BASEFONT: 'basefont',
    BGSOUND: 'bgsound',
    BIG: 'big',
    BLOCKQUOTE: 'blockquote',
    BODY: 'body',
    BR: 'br',
    BUTTON: 'button',

    CAPTION: 'caption',
    CENTER: 'center',
    CODE: 'code',
    COL: 'col',
    COLGROUP: 'colgroup',

    DD: 'dd',
    DESC: 'desc',
    DETAILS: 'details',
    DIALOG: 'dialog',
    DIR: 'dir',
    DIV: 'div',
    DL: 'dl',
    DT: 'dt',

    EM: 'em',
    EMBED: 'embed',

    FIELDSET: 'fieldset',
    FIGCAPTION: 'figcaption',
    FIGURE: 'figure',
    FONT: 'font',
    FOOTER: 'footer',
    FOREIGN_OBJECT: 'foreignObject',
    FORM: 'form',
    FRAME: 'frame',
    FRAMESET: 'frameset',

    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
    HEAD: 'head',
    HEADER: 'header',
    HGROUP: 'hgroup',
    HR: 'hr',
    HTML: 'html',

    I: 'i',
    IMG: 'img',
    IMAGE: 'image',
    INPUT: 'input',
    IFRAME: 'iframe',

    KEYGEN: 'keygen',

    LABEL: 'label',
    LI: 'li',
    LINK: 'link',
    LISTING: 'listing',

    MAIN: 'main',
    MALIGNMARK: 'malignmark',
    MARQUEE: 'marquee',
    MATH: 'math',
    MENU: 'menu',
    MENUITEM: 'menuitem',
    META: 'meta',
    MGLYPH: 'mglyph',
    MI: 'mi',
    MO: 'mo',
    MN: 'mn',
    MS: 'ms',
    MTEXT: 'mtext',

    NAV: 'nav',
    NOBR: 'nobr',
    NOFRAMES: 'noframes',
    NOEMBED: 'noembed',
    NOSCRIPT: 'noscript',

    OBJECT: 'object',
    OL: 'ol',
    OPTGROUP: 'optgroup',
    OPTION: 'option',

    P: 'p',
    PARAM: 'param',
    PLAINTEXT: 'plaintext',
    PRE: 'pre',

    RB: 'rb',
    RP: 'rp',
    RT: 'rt',
    RTC: 'rtc',
    RUBY: 'ruby',

    S: 's',
    SCRIPT: 'script',
    SECTION: 'section',
    SELECT: 'select',
    SOURCE: 'source',
    SMALL: 'small',
    SPAN: 'span',
    STRIKE: 'strike',
    STRONG: 'strong',
    STYLE: 'style',
    SUB: 'sub',
    SUMMARY: 'summary',
    SUP: 'sup',

    TABLE: 'table',
    TBODY: 'tbody',
    TEMPLATE: 'template',
    TEXTAREA: 'textarea',
    TFOOT: 'tfoot',
    TD: 'td',
    TH: 'th',
    THEAD: 'thead',
    TITLE: 'title',
    TR: 'tr',
    TRACK: 'track',
    TT: 'tt',

    U: 'u',
    UL: 'ul',

    SVG: 'svg',

    VAR: 'var',

    WBR: 'wbr',

    XMP: 'xmp'
};

var SPECIAL_ELEMENTS = exports.SPECIAL_ELEMENTS = Object.create(null);

SPECIAL_ELEMENTS[NS.HTML] = Object.create(null);
SPECIAL_ELEMENTS[NS.HTML][$.ADDRESS] = true;
SPECIAL_ELEMENTS[NS.HTML][$.APPLET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.AREA] = true;
SPECIAL_ELEMENTS[NS.HTML][$.ARTICLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.ASIDE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BASE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BASEFONT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BGSOUND] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BLOCKQUOTE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BODY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BUTTON] = true;
SPECIAL_ELEMENTS[NS.HTML][$.CAPTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.CENTER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.COL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.COLGROUP] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DETAILS] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DIR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DIV] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.EMBED] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIELDSET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIGCAPTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIGURE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FOOTER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FORM] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FRAME] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FRAMESET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H1] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H2] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H3] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H4] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H5] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H6] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HEAD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HEADER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HGROUP] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HTML] = true;
SPECIAL_ELEMENTS[NS.HTML][$.IFRAME] = true;
SPECIAL_ELEMENTS[NS.HTML][$.IMG] = true;
SPECIAL_ELEMENTS[NS.HTML][$.INPUT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LI] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LINK] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LISTING] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MAIN] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MARQUEE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MENU] = true;
SPECIAL_ELEMENTS[NS.HTML][$.META] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NAV] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOEMBED] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOFRAMES] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOSCRIPT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.OBJECT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.OL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.P] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PARAM] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PLAINTEXT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PRE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SCRIPT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SECTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SELECT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SOURCE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.STYLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SUMMARY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TABLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TBODY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TEMPLATE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TEXTAREA] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TFOOT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TH] = true;
SPECIAL_ELEMENTS[NS.HTML][$.THEAD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TITLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TRACK] = true;
SPECIAL_ELEMENTS[NS.HTML][$.UL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.WBR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.XMP] = true;

SPECIAL_ELEMENTS[NS.MATHML] = Object.create(null);
SPECIAL_ELEMENTS[NS.MATHML][$.MI] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MO] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MN] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MS] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MTEXT] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.ANNOTATION_XML] = true;

SPECIAL_ELEMENTS[NS.SVG] = Object.create(null);
SPECIAL_ELEMENTS[NS.SVG][$.TITLE] = true;
SPECIAL_ELEMENTS[NS.SVG][$.FOREIGN_OBJECT] = true;
SPECIAL_ELEMENTS[NS.SVG][$.DESC] = true;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(45);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return parseQueryString; });
/* unused harmony export generateURL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return serialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getObjectValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUTCTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationToSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUrl; });
/* unused harmony export getExtension */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return showSpinnerInButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removeSpinnerInButton; });
/* unused harmony export loadExternalScript */
/* unused harmony export errLogger */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isBinaryDomain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_search_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_search_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_search_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_keys_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_slice_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_match_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_from_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_promise_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_includes_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es7_array_includes_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_lang__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_appIdResolver__ = __webpack_require__(137);


















var parseQueryString = function parseQueryString() {
  if (typeof window === 'undefined') {
    return {};
  }

  var str = window.location.search;
  var objURL = {};
  str.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function (a0, a1, a2, a3) {
    objURL[a1] = a3;
  });
  return objURL || false;
};
var generateURL = function generateURL(url) {
  if (url.split('?').length !== null && url.split('?').length !== undefined) {
    var baseUrl = url.split('?')[0];
    var queryParams = url.split('?')[1];

    if (queryParams !== undefined) {
      return "".concat(baseUrl, "bot.html?").concat(queryParams);
    }

    return "".concat(baseUrl, "bot.html");
  }

  return "".concat(url.replace(/\/+$/, ''), "/bot.html");
};
var serialize = function serialize(obj) {
  var str = [];
  Object.keys(obj).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(obj[key])) {
      // eslint-disable-next-line prefer-template
      str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
    }
  });
  return str === null || str === void 0 ? void 0 : str.join('&');
};
var getObjectValue = function getObjectValue(obj) {
  return obj[Object.keys(obj)[0]];
};
var getUTCTime = function getUTCTime(date) {
  var dateObject = new Date(date);
  return "".concat("0".concat(dateObject.getUTCHours()).slice(-2), ":").concat("0".concat(dateObject.getUTCMinutes()).slice(-2), ":").concat("0".concat(dateObject.getUTCSeconds()).slice(-2));
};
var durationToSecond = function durationToSecond(duration) {
  var parsedDuration = duration.match(/^([0-9]+)([stmhd])$/);

  if (!parsedDuration) {
    return 0;
  }

  var durationValue = parseFloat(parsedDuration[1]);
  var durationType = parsedDuration[2];

  if (durationType === 's') {
    return durationValue;
  }

  if (durationType === 't') {
    return durationValue * 2;
  }

  if (durationType === 'm') {
    return durationValue * 60;
  }

  if (durationType === 'h') {
    return durationValue * 60 * 60;
  }

  if (durationType === 'd') {
    return durationValue * 60 * 60 * 24;
  }

  return 0;
};
var isProduction = function isProduction() {
  return document.location.hostname.replace(/^www./, '') in __WEBPACK_IMPORTED_MODULE_17__common_appIdResolver__["a" /* default */];
};
var createUrl = function createUrl(options) {
  var getOption = function getOption(property) {
    return Object.prototype.hasOwnProperty.call(options, property) && options[property];
  };

  var language = getOption('addLanguage') ? "/".concat(Object(__WEBPACK_IMPORTED_MODULE_16__common_lang__["a" /* getLanguage */])()) : '';
  var path = getOption('path') ? "/".concat(getOption('path')) : '';
  var htmlExtension = getOption('addHtmlExtension') ? '.html' : '';
  var subdomain = getOption('subdomain') ? "".concat(getOption('subdomain'), ".") : 'www.';

  if (isProduction()) {
    var domainExtension = ".".concat(getExtension());

    if (getOption('isNonBotPage')) {
      switch (document.location.hostname.replace(/^www./, '')) {
        case 'bot.binary.me':
        case 'binary.bot':
          domainExtension = '.me';
          break;

        default:
          domainExtension = '.com';
          break;
      }
    }

    return "".concat(document.location.protocol, "//").concat(subdomain, "binary").concat(domainExtension).concat(language).concat(path).concat(htmlExtension);
  }

  return "https://".concat(subdomain, "binary.com").concat(language).concat(path).concat(htmlExtension);
};
var getExtension = function getExtension() {
  var host = document.location.hostname;
  var extension = host.split('.').slice(-1)[0];
  return host !== extension ? extension : '';
};
var showSpinnerInButton = function showSpinnerInButton($buttonElement) {
  $buttonElement.html(function () {
    var barspinner = $('<div class="barspinner white" />');
    Array.from(new Array(5)).forEach(function (x, i) {
      var rect = $("<div class=\"rect".concat(i + 1, "\" />"));
      barspinner.append(rect);
    });
    return barspinner;
  }).prop('disabled', true);
};
var removeSpinnerInButton = function removeSpinnerInButton($buttonElement, initialText) {
  $buttonElement.html(function () {
    return initialText;
  }).prop('disabled', false);
};
var loadExternalScript = function loadExternalScript(src) {
  var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var defer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.onerror = reject;

    function handleLoad() {
      var loadState = this.readyState;
      if (loadState && !/loaded|complete/.test(loadState)) return;
      script.onload = null;
      script.onreadystatechange = null;
      resolve();
    }

    script.onload = handleLoad;
    script.onreadystatechange = handleLoad;
    document.head.appendChild(script);
  });
};
var errLogger = function errLogger(err, msg) {
  var errStr = JSON.stringify(err);
  var errMsg = "".concat(msg, " - Error: ").concat(errStr);
  console.warn(errMsg);
};
var isBinaryDomain = document.location.hostname === 'localhost' || document.location.hostname === 'bot.binary.com' || document.location.hostname.includes('binary-bot-git-fork');
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(244);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(245);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)))

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return oauthLogin; });
/* unused harmony export getCustomEndpoint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDefaultEndpoint; });
/* unused harmony export getServerAddressFallback */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAppIdFallback; });
/* unused harmony export getWebSocketURL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateWebSocketURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getOAuthURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getOAuthURLDeriv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateLiveApiInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return generateTestLiveApiInstance; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addTokenIfValid;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return logoutAllTokens; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_freeze_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_freeze_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_freeze_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_string_starts_with_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_string_starts_with_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_string_starts_with_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_to_string_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_promise_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es7_symbol_async_iterator_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es7_symbol_async_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es7_symbol_async_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_function_name_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_binary_live_api__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_binary_live_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_binary_live_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_utils_tools__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lang__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__appIdResolver__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__elevio__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__gtm__ = __webpack_require__(84);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

























var AppConstants = Object.freeze({
  STORAGE_ACTIVE_TOKEN: 'activeToken'
});
var hostName = document.location.hostname;

var queryToObjectArray = function queryToObjectArray(queryStr) {
  var tokens = [];
  Object.keys(queryStr).forEach(function (o) {
    if (!/\d$/.test(o)) return;
    var index = parseInt(o.slice(-1));
    var key = o.slice(0, -1);
    key = key === 'acct' ? 'accountName' : key; // Make it consistent with storageManage naming

    if (index <= tokens.length) {
      tokens[index - 1][key] = queryStr[o];
    } else {
      tokens.push({});
      tokens[index - 1][key] = queryStr[o];
    }
  });
  return tokens;
};

var oauthLogin = function oauthLogin() {
  var done = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return 0;
  };
  var queryStr = Object(__WEBPACK_IMPORTED_MODULE_19__common_utils_tools__["g" /* parseQueryString */])();
  var tokenObjectList = queryToObjectArray(queryStr);

  if (tokenObjectList.length) {
    $('#main').hide();
    addTokenIfValid(tokenObjectList[0].token, tokenObjectList).then(function () {
      var accounts = Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["d" /* getTokenList */])();

      if (accounts.length) {
        Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["h" /* set */])(AppConstants.STORAGE_ACTIVE_TOKEN, accounts[0].token);
      }

      document.location = 'bot.html';
    });
  } else {
    done();
  }
};
var getCustomEndpoint = function getCustomEndpoint() {
  return {
    url: Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["b" /* get */])('config.server_url'),
    appId: Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["b" /* get */])('config.app_id')
  };
};

var isRealAccount = function isRealAccount() {
  var accountList = JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["b" /* get */])('tokenList') || '{}');
  var activeToken = Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["b" /* get */])(AppConstants.STORAGE_ACTIVE_TOKEN) || [];
  var activeAccount = null;
  var isReal = false;

  try {
    activeAccount = accountList.filter(function (account) {
      return account.token === activeToken;
    });
    isReal = !activeAccount[0].accountName.startsWith('VRT');
  } catch (e) {} // eslint-disable-line no-empty


  return isReal;
}; // const getDomainAppId = () => AppIdMap[hostName.replace(/^www./, '')];


var getDefaultEndpoint = function getDefaultEndpoint() {
  return {
    url: isRealAccount() ? 'ws.derivws.com' : 'ws.derivws.com',
    appId: 37985
  };
};

var generateOAuthDomain = function generateOAuthDomain() {
  var endpointUrl = getCustomEndpoint().url;

  if (endpointUrl) {
    return endpointUrl;
  } else if (Object(__WEBPACK_IMPORTED_MODULE_19__common_utils_tools__["f" /* isProduction */])()) {
    return 'oauth.deriv.com';
  }

  return 'oauth.deriv.com';
};

var getServerAddressFallback = function getServerAddressFallback() {
  return getCustomEndpoint().url || getDefaultEndpoint().url;
};
var getAppIdFallback = function getAppIdFallback() {
  return getCustomEndpoint().appId || getDefaultEndpoint().appId;
};
var getWebSocketURL = function getWebSocketURL() {
  return "wss://".concat(getServerAddressFallback(), "/websockets/v3");
};
var generateWebSocketURL = function generateWebSocketURL(serverUrl) {
  return "wss://".concat(serverUrl, "/websockets/v3");
};
var getOAuthURL = function getOAuthURL() {
  return "https://".concat(generateOAuthDomain(), "/oauth2/authorize?app_id=").concat(getAppIdFallback(), "&l=").concat(Object(__WEBPACK_IMPORTED_MODULE_20__lang__["a" /* getLanguage */])().toUpperCase());
};
var getOAuthURLDeriv = function getOAuthURLDeriv() {
  return "https://oauth.deriv.com/oauth2/authorize?app_id=".concat(getAppIdFallback(), "&l=").concat(Object(__WEBPACK_IMPORTED_MODULE_20__lang__["a" /* getLanguage */])().toUpperCase());
}; // 19111

var options = {
  apiUrl: getWebSocketURL(),
  language: Object(__WEBPACK_IMPORTED_MODULE_20__lang__["a" /* getLanguage */])().toUpperCase(),
  appId: 37985,
  keepAlive: true
};
var generateLiveApiInstance = function generateLiveApiInstance() {
  return new __WEBPACK_IMPORTED_MODULE_17_binary_live_api__["LiveApi"](options);
};
var generateTestLiveApiInstance = function generateTestLiveApiInstance(overrideOptions) {
  return new __WEBPACK_IMPORTED_MODULE_17_binary_live_api__["LiveApi"](Object.assign({}, options, overrideOptions));
};
function addTokenIfValid(_x, _x2) {
  return _addTokenIfValid.apply(this, arguments);
}

function _addTokenIfValid() {
  _addTokenIfValid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(token, tokenObjectList) {
    var api, _yield$api$authorize, authorize, lcName, _yield$api$getLanding, hasRealityCheck, accountList;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api = generateLiveApiInstance();
            console.log(api, token, tokenObjectList);
            _context.prev = 2;
            _context.next = 5;
            return api.authorize(token);

          case 5:
            _yield$api$authorize = _context.sent;
            authorize = _yield$api$authorize.authorize;
            lcName = authorize.landing_company_name;
            _context.next = 10;
            return api.getLandingCompanyDetails(lcName);

          case 10:
            _yield$api$getLanding = _context.sent;
            hasRealityCheck = _yield$api$getLanding.landing_company_details.has_reality_check;
            Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["a" /* addToken */])(token, authorize, !!hasRealityCheck, ['iom', 'malta'].includes(lcName) && authorize.country === 'gb');
            accountList = authorize.account_list;

            if (accountList.length > 1) {
              tokenObjectList.forEach(function (tokenObject) {
                if (tokenObject.token !== token) {
                  var account = accountList.filter(function (o) {
                    return o.loginid === tokenObject.accountName;
                  });

                  if (account.length) {
                    Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["a" /* addToken */])(tokenObject.token, account[0], false, false);
                  }
                }
              });
            }

            _context.next = 23;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](2);
            console.log(JSON.stringify(_context.t0));
            Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["g" /* removeToken */])(tokenObjectList[0].token); // Elevio.logoutUser();

            __WEBPACK_IMPORTED_MODULE_23__gtm__["a" /* default */].setVisitorId();
            throw _context.t0;

          case 23:
            return _context.abrupt("return", api.disconnect());

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 17]]);
  }));
  return _addTokenIfValid.apply(this, arguments);
}

var logoutAllTokens = function logoutAllTokens() {
  return new Promise(function (resolve) {
    var api = generateLiveApiInstance();
    var tokenList = Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["d" /* getTokenList */])();

    var logout = function logout() {
      Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_storageManager__["f" /* removeAllTokens */])();
      api.disconnect();
      resolve();
    };

    if (tokenList.length === 0) {
      logout();
    } else {
      api.authorize(tokenList[0].token).then(function () {
        api.logOut().then(logout, logout);
      }, logout);
    }
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(83);
var createDesc = __webpack_require__(70);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(65);
var has = __webpack_require__(44);
var IE8_DOM_DEFINE = __webpack_require__(158);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(22) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(149)('asyncIterator');


/***/ }),
/* 54 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toObject = __webpack_require__(29);
var toLength = __webpack_require__(23);
var toInteger = __webpack_require__(55);
var advanceStringIndex = __webpack_require__(119);
var regExpExec = __webpack_require__(97);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(98)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(48);
var IObject = __webpack_require__(99);
var toObject = __webpack_require__(29);
var toLength = __webpack_require__(23);
var asc = __webpack_require__(159);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(163);
var enumBugKeys = __webpack_require__(128);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(44);
var toObject = __webpack_require__(29);
var IE_PROTO = __webpack_require__(127)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(47);
var fails = __webpack_require__(15);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(106);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(87));
util.inherits = __webpack_require__(74);
/*</replacement>*/

var Readable = __webpack_require__(175);
var Writable = __webpack_require__(136);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(16);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(15);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(58)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(71)(KEY);


/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(13)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(36)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return load; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showBanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_search_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_search_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_search_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es7_symbol_async_iterator_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es7_symbol_async_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es7_symbol_async_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_name_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_slice_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_utils_tools__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_utils_storageManager__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_utils_cookieManager__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__i18n__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_utility__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__indexPage_react_components_bot_landing__ = __webpack_require__(203);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }























var elements = ['#notification-banner', '#main', '#footer', '#header'];
var getLanguage = function getLanguage() {
  var queryLang = Object(__WEBPACK_IMPORTED_MODULE_16__common_utils_tools__["g" /* parseQueryString */])().l || 'en';
  var checkIsSupported = (queryLang in __WEBPACK_IMPORTED_MODULE_19__i18n__["b" /* supportedLanguages */]); // eslint-disable-next-line camelcase

  var un_supported_languages = ['id', 'tr'];

  var checkLanguageNotSupported = function checkLanguageNotSupported() {
    return un_supported_languages.includes(queryLang) ? 'en' : Object(__WEBPACK_IMPORTED_MODULE_17__common_utils_storageManager__["b" /* get */])('lang') || 'en';
  };

  var lang = checkIsSupported ? queryLang : checkLanguageNotSupported();
  Object(__WEBPACK_IMPORTED_MODULE_17__common_utils_storageManager__["h" /* set */])('lang', lang);
  Object(__WEBPACK_IMPORTED_MODULE_18__common_utils_cookieManager__["a" /* setCookieLanguage */])(lang);
  return lang;
};

var addUiLang = function addUiLang() {
  $('[data-i18n-text]').each(function each() {
    var el = $(this);
    var contents = el.contents();
    el.text(Object(__WEBPACK_IMPORTED_MODULE_19__i18n__["c" /* translate */])($(this).attr('data-i18n-text'))).append(contents);
  });
  document.querySelectorAll('[data-i18n-title]').forEach(function (titleNode) {
    titleNode.setAttribute('title', Object(__WEBPACK_IMPORTED_MODULE_19__i18n__["c" /* translate */])(titleNode.getAttribute('data-i18n-title')));
  });
};

var load = function load() {
  if (typeof $ !== 'function') return; // Adding this check to skip unit test

  var lang = getLanguage();
  $('#select_language li:not(:first)').click(function click() {
    var newLang = $(this).attr('class');

    if (document.getElementById('bot-landing') !== null && document.getElementById('bot-landing') !== undefined && document.getElementById('bot-landing').classList.contains('hidden') === false) {
      Object(__WEBPACK_IMPORTED_MODULE_17__common_utils_storageManager__["e" /* remove */])('setDueDateForBanner');
      Object(__WEBPACK_IMPORTED_MODULE_15_react_dom__["render"])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__indexPage_react_components_bot_landing__["a" /* default */], null), document.getElementById('bot-landing'));
      elements.map(function (elem) {
        return document.querySelector(elem).classList.add('hidden');
      });
      document.getElementById('bot-landing').classList.remove('hidden'); // document.getElementById('bot-main').classList.add('hidden');

      document.location.search = "l=".concat(newLang);
      $('.barspinner').hide();
    } else {
      document.location.search = "l=".concat(newLang);
    }
  });
  $('.language').text($(".".concat(lang)).hide().text());
  $('.actual_flag').text("".concat(lang));
  $('.language_background_flag').addClass("".concat(lang, "_flag_mtd"));

  if (lang === 'ach') {
    // eslint-disable-next-line no-underscore-dangle
    window._jipt = [['project', 'binary-bot']];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "".concat(document.location.protocol, "//cdn.crowdin.com/jipt/jipt.js");
    $('body').append(script);
  }

  Object(__WEBPACK_IMPORTED_MODULE_19__i18n__["a" /* init */])(lang);
  addUiLang();
};
var showBanner = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var location;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_20__utils_utility__["a" /* getClientsCountryByIP */])();

          case 2:
            location = _context.sent;

            if (getLanguage() === 'pt' || location === 'br') {
              document.querySelectorAll('.pt-show').forEach(function (el) {
                el.classList.remove('invisible');
              }); // TODO: Whenever banners for all languages were added remove else part of the condition.
            } else {
              document.querySelectorAll('.any-show').forEach(function (el) {
                el.classList.remove('invisible');
              });
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function showBanner() {
    return _ref.apply(this, arguments);
  };
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Preprocessor = __webpack_require__(239),
    UNICODE = __webpack_require__(86),
    neTree = __webpack_require__(240);

//Aliases
var $ = UNICODE.CODE_POINTS,
    $$ = UNICODE.CODE_POINT_SEQUENCES;

//Replacement code points for numeric entities
var NUMERIC_ENTITY_REPLACEMENTS = {
    0x00: 0xFFFD, 0x0D: 0x000D, 0x80: 0x20AC, 0x81: 0x0081, 0x82: 0x201A, 0x83: 0x0192, 0x84: 0x201E,
    0x85: 0x2026, 0x86: 0x2020, 0x87: 0x2021, 0x88: 0x02C6, 0x89: 0x2030, 0x8A: 0x0160, 0x8B: 0x2039,
    0x8C: 0x0152, 0x8D: 0x008D, 0x8E: 0x017D, 0x8F: 0x008F, 0x90: 0x0090, 0x91: 0x2018, 0x92: 0x2019,
    0x93: 0x201C, 0x94: 0x201D, 0x95: 0x2022, 0x96: 0x2013, 0x97: 0x2014, 0x98: 0x02DC, 0x99: 0x2122,
    0x9A: 0x0161, 0x9B: 0x203A, 0x9C: 0x0153, 0x9D: 0x009D, 0x9E: 0x017E, 0x9F: 0x0178
};

// Named entity tree flags
var HAS_DATA_FLAG = 1 << 0;
var DATA_DUPLET_FLAG = 1 << 1;
var HAS_BRANCHES_FLAG = 1 << 2;
var MAX_BRANCH_MARKER_VALUE = HAS_DATA_FLAG | DATA_DUPLET_FLAG | HAS_BRANCHES_FLAG;


//States
var DATA_STATE = 'DATA_STATE',
    CHARACTER_REFERENCE_IN_DATA_STATE = 'CHARACTER_REFERENCE_IN_DATA_STATE',
    RCDATA_STATE = 'RCDATA_STATE',
    CHARACTER_REFERENCE_IN_RCDATA_STATE = 'CHARACTER_REFERENCE_IN_RCDATA_STATE',
    RAWTEXT_STATE = 'RAWTEXT_STATE',
    SCRIPT_DATA_STATE = 'SCRIPT_DATA_STATE',
    PLAINTEXT_STATE = 'PLAINTEXT_STATE',
    TAG_OPEN_STATE = 'TAG_OPEN_STATE',
    END_TAG_OPEN_STATE = 'END_TAG_OPEN_STATE',
    TAG_NAME_STATE = 'TAG_NAME_STATE',
    RCDATA_LESS_THAN_SIGN_STATE = 'RCDATA_LESS_THAN_SIGN_STATE',
    RCDATA_END_TAG_OPEN_STATE = 'RCDATA_END_TAG_OPEN_STATE',
    RCDATA_END_TAG_NAME_STATE = 'RCDATA_END_TAG_NAME_STATE',
    RAWTEXT_LESS_THAN_SIGN_STATE = 'RAWTEXT_LESS_THAN_SIGN_STATE',
    RAWTEXT_END_TAG_OPEN_STATE = 'RAWTEXT_END_TAG_OPEN_STATE',
    RAWTEXT_END_TAG_NAME_STATE = 'RAWTEXT_END_TAG_NAME_STATE',
    SCRIPT_DATA_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_END_TAG_OPEN_STATE = 'SCRIPT_DATA_END_TAG_OPEN_STATE',
    SCRIPT_DATA_END_TAG_NAME_STATE = 'SCRIPT_DATA_END_TAG_NAME_STATE',
    SCRIPT_DATA_ESCAPE_START_STATE = 'SCRIPT_DATA_ESCAPE_START_STATE',
    SCRIPT_DATA_ESCAPE_START_DASH_STATE = 'SCRIPT_DATA_ESCAPE_START_DASH_STATE',
    SCRIPT_DATA_ESCAPED_STATE = 'SCRIPT_DATA_ESCAPED_STATE',
    SCRIPT_DATA_ESCAPED_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_STATE',
    SCRIPT_DATA_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_DASH_STATE',
    SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE',
    SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE',
    BEFORE_ATTRIBUTE_NAME_STATE = 'BEFORE_ATTRIBUTE_NAME_STATE',
    ATTRIBUTE_NAME_STATE = 'ATTRIBUTE_NAME_STATE',
    AFTER_ATTRIBUTE_NAME_STATE = 'AFTER_ATTRIBUTE_NAME_STATE',
    BEFORE_ATTRIBUTE_VALUE_STATE = 'BEFORE_ATTRIBUTE_VALUE_STATE',
    ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE',
    ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE',
    ATTRIBUTE_VALUE_UNQUOTED_STATE = 'ATTRIBUTE_VALUE_UNQUOTED_STATE',
    CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE = 'CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE',
    AFTER_ATTRIBUTE_VALUE_QUOTED_STATE = 'AFTER_ATTRIBUTE_VALUE_QUOTED_STATE',
    SELF_CLOSING_START_TAG_STATE = 'SELF_CLOSING_START_TAG_STATE',
    BOGUS_COMMENT_STATE = 'BOGUS_COMMENT_STATE',
    BOGUS_COMMENT_STATE_CONTINUATION = 'BOGUS_COMMENT_STATE_CONTINUATION',
    MARKUP_DECLARATION_OPEN_STATE = 'MARKUP_DECLARATION_OPEN_STATE',
    COMMENT_START_STATE = 'COMMENT_START_STATE',
    COMMENT_START_DASH_STATE = 'COMMENT_START_DASH_STATE',
    COMMENT_STATE = 'COMMENT_STATE',
    COMMENT_END_DASH_STATE = 'COMMENT_END_DASH_STATE',
    COMMENT_END_STATE = 'COMMENT_END_STATE',
    COMMENT_END_BANG_STATE = 'COMMENT_END_BANG_STATE',
    DOCTYPE_STATE = 'DOCTYPE_STATE',
    DOCTYPE_NAME_STATE = 'DOCTYPE_NAME_STATE',
    AFTER_DOCTYPE_NAME_STATE = 'AFTER_DOCTYPE_NAME_STATE',
    BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE',
    DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE',
    DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE',
    BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE = 'BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE',
    BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE',
    DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE',
    DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE',
    AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE',
    BOGUS_DOCTYPE_STATE = 'BOGUS_DOCTYPE_STATE',
    CDATA_SECTION_STATE = 'CDATA_SECTION_STATE';

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isWhitespace(cp) {
    return cp === $.SPACE || cp === $.LINE_FEED || cp === $.TABULATION || cp === $.FORM_FEED;
}

function isAsciiDigit(cp) {
    return cp >= $.DIGIT_0 && cp <= $.DIGIT_9;
}

function isAsciiUpper(cp) {
    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_Z;
}

function isAsciiLower(cp) {
    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_Z;
}

function isAsciiLetter(cp) {
    return isAsciiLower(cp) || isAsciiUpper(cp);
}

function isAsciiAlphaNumeric(cp) {
    return isAsciiLetter(cp) || isAsciiDigit(cp);
}

function isDigit(cp, isHex) {
    return isAsciiDigit(cp) || isHex && (cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_F ||
                                         cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_F);
}

function isReservedCodePoint(cp) {
    return cp >= 0xD800 && cp <= 0xDFFF || cp > 0x10FFFF;
}

function toAsciiLowerCodePoint(cp) {
    return cp + 0x0020;
}

//NOTE: String.fromCharCode() function can handle only characters from BMP subset.
//So, we need to workaround this manually.
//(see: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/String/fromCharCode#Getting_it_to_work_with_higher_values)
function toChar(cp) {
    if (cp <= 0xFFFF)
        return String.fromCharCode(cp);

    cp -= 0x10000;
    return String.fromCharCode(cp >>> 10 & 0x3FF | 0xD800) + String.fromCharCode(0xDC00 | cp & 0x3FF);
}

function toAsciiLowerChar(cp) {
    return String.fromCharCode(toAsciiLowerCodePoint(cp));
}

function findNamedEntityTreeBranch(nodeIx, cp) {
    var branchCount = neTree[++nodeIx],
        lo = ++nodeIx,
        hi = lo + branchCount - 1;

    while (lo <= hi) {
        var mid = lo + hi >>> 1,
            midCp = neTree[mid];

        if (midCp < cp)
            lo = mid + 1;

        else if (midCp > cp)
            hi = mid - 1;

        else
            return neTree[mid + branchCount];
    }

    return -1;
}


//Tokenizer
var Tokenizer = module.exports = function () {
    this.preprocessor = new Preprocessor();

    this.tokenQueue = [];

    this.allowCDATA = false;

    this.state = DATA_STATE;
    this.returnState = '';

    this.tempBuff = [];
    this.additionalAllowedCp = void 0;
    this.lastStartTagName = '';

    this.consumedAfterSnapshot = -1;
    this.active = false;

    this.currentCharacterToken = null;
    this.currentToken = null;
    this.currentAttr = null;
};

//Token types
Tokenizer.CHARACTER_TOKEN = 'CHARACTER_TOKEN';
Tokenizer.NULL_CHARACTER_TOKEN = 'NULL_CHARACTER_TOKEN';
Tokenizer.WHITESPACE_CHARACTER_TOKEN = 'WHITESPACE_CHARACTER_TOKEN';
Tokenizer.START_TAG_TOKEN = 'START_TAG_TOKEN';
Tokenizer.END_TAG_TOKEN = 'END_TAG_TOKEN';
Tokenizer.COMMENT_TOKEN = 'COMMENT_TOKEN';
Tokenizer.DOCTYPE_TOKEN = 'DOCTYPE_TOKEN';
Tokenizer.EOF_TOKEN = 'EOF_TOKEN';
Tokenizer.HIBERNATION_TOKEN = 'HIBERNATION_TOKEN';

//Tokenizer initial states for different modes
Tokenizer.MODE = {
    DATA: DATA_STATE,
    RCDATA: RCDATA_STATE,
    RAWTEXT: RAWTEXT_STATE,
    SCRIPT_DATA: SCRIPT_DATA_STATE,
    PLAINTEXT: PLAINTEXT_STATE
};

//Static
Tokenizer.getTokenAttr = function (token, attrName) {
    for (var i = token.attrs.length - 1; i >= 0; i--) {
        if (token.attrs[i].name === attrName)
            return token.attrs[i].value;
    }

    return null;
};

//API
Tokenizer.prototype.getNextToken = function () {
    while (!this.tokenQueue.length && this.active) {
        this._hibernationSnapshot();

        var cp = this._consume();

        if (!this._ensureHibernation())
            this[this.state](cp);
    }

    return this.tokenQueue.shift();
};

Tokenizer.prototype.write = function (chunk, isLastChunk) {
    this.active = true;
    this.preprocessor.write(chunk, isLastChunk);
};

Tokenizer.prototype.insertHtmlAtCurrentPos = function (chunk) {
    this.active = true;
    this.preprocessor.insertHtmlAtCurrentPos(chunk);
};

//Hibernation
Tokenizer.prototype._hibernationSnapshot = function () {
    this.consumedAfterSnapshot = 0;
};

Tokenizer.prototype._ensureHibernation = function () {
    if (this.preprocessor.endOfChunkHit) {
        for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
            this.preprocessor.retreat();

        this.active = false;
        this.tokenQueue.push({type: Tokenizer.HIBERNATION_TOKEN});

        return true;
    }

    return false;
};


//Consumption
Tokenizer.prototype._consume = function () {
    this.consumedAfterSnapshot++;
    return this.preprocessor.advance();
};

Tokenizer.prototype._unconsume = function () {
    this.consumedAfterSnapshot--;
    this.preprocessor.retreat();
};

Tokenizer.prototype._unconsumeSeveral = function (count) {
    while (count--)
        this._unconsume();
};

Tokenizer.prototype._reconsumeInState = function (state) {
    this.state = state;
    this._unconsume();
};

Tokenizer.prototype._consumeSubsequentIfMatch = function (pattern, startCp, caseSensitive) {
    var consumedCount = 0,
        isMatch = true,
        patternLength = pattern.length,
        patternPos = 0,
        cp = startCp,
        patternCp = void 0;

    for (; patternPos < patternLength; patternPos++) {
        if (patternPos > 0) {
            cp = this._consume();
            consumedCount++;
        }

        if (cp === $.EOF) {
            isMatch = false;
            break;
        }

        patternCp = pattern[patternPos];

        if (cp !== patternCp && (caseSensitive || cp !== toAsciiLowerCodePoint(patternCp))) {
            isMatch = false;
            break;
        }
    }

    if (!isMatch)
        this._unconsumeSeveral(consumedCount);

    return isMatch;
};

//Lookahead
Tokenizer.prototype._lookahead = function () {
    var cp = this._consume();

    this._unconsume();

    return cp;
};

//Temp buffer
Tokenizer.prototype.isTempBufferEqualToScriptString = function () {
    if (this.tempBuff.length !== $$.SCRIPT_STRING.length)
        return false;

    for (var i = 0; i < this.tempBuff.length; i++) {
        if (this.tempBuff[i] !== $$.SCRIPT_STRING[i])
            return false;
    }

    return true;
};

//Token creation
Tokenizer.prototype._createStartTagToken = function () {
    this.currentToken = {
        type: Tokenizer.START_TAG_TOKEN,
        tagName: '',
        selfClosing: false,
        attrs: []
    };
};

Tokenizer.prototype._createEndTagToken = function () {
    this.currentToken = {
        type: Tokenizer.END_TAG_TOKEN,
        tagName: '',
        attrs: []
    };
};

Tokenizer.prototype._createCommentToken = function () {
    this.currentToken = {
        type: Tokenizer.COMMENT_TOKEN,
        data: ''
    };
};

Tokenizer.prototype._createDoctypeToken = function (initialName) {
    this.currentToken = {
        type: Tokenizer.DOCTYPE_TOKEN,
        name: initialName,
        forceQuirks: false,
        publicId: null,
        systemId: null
    };
};

Tokenizer.prototype._createCharacterToken = function (type, ch) {
    this.currentCharacterToken = {
        type: type,
        chars: ch
    };
};

//Tag attributes
Tokenizer.prototype._createAttr = function (attrNameFirstCh) {
    this.currentAttr = {
        name: attrNameFirstCh,
        value: ''
    };
};

Tokenizer.prototype._isDuplicateAttr = function () {
    return Tokenizer.getTokenAttr(this.currentToken, this.currentAttr.name) !== null;
};

Tokenizer.prototype._leaveAttrName = function (toState) {
    this.state = toState;

    if (!this._isDuplicateAttr())
        this.currentToken.attrs.push(this.currentAttr);
};

Tokenizer.prototype._leaveAttrValue = function (toState) {
    this.state = toState;
};

//Appropriate end tag token
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html#appropriate-end-tag-token)
Tokenizer.prototype._isAppropriateEndTagToken = function () {
    return this.lastStartTagName === this.currentToken.tagName;
};

//Token emission
Tokenizer.prototype._emitCurrentToken = function () {
    this._emitCurrentCharacterToken();

    //NOTE: store emited start tag's tagName to determine is the following end tag token is appropriate.
    if (this.currentToken.type === Tokenizer.START_TAG_TOKEN)
        this.lastStartTagName = this.currentToken.tagName;

    this.tokenQueue.push(this.currentToken);
    this.currentToken = null;
};

Tokenizer.prototype._emitCurrentCharacterToken = function () {
    if (this.currentCharacterToken) {
        this.tokenQueue.push(this.currentCharacterToken);
        this.currentCharacterToken = null;
    }
};

Tokenizer.prototype._emitEOFToken = function () {
    this._emitCurrentCharacterToken();
    this.tokenQueue.push({type: Tokenizer.EOF_TOKEN});
};

//Characters emission

//OPTIMIZATION: specification uses only one type of character tokens (one token per character).
//This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
//If we have a sequence of characters that belong to the same group, parser can process it
//as a single solid character token.
//So, there are 3 types of character tokens in parse5:
//1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
//2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
//3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
Tokenizer.prototype._appendCharToCurrentCharacterToken = function (type, ch) {
    if (this.currentCharacterToken && this.currentCharacterToken.type !== type)
        this._emitCurrentCharacterToken();

    if (this.currentCharacterToken)
        this.currentCharacterToken.chars += ch;

    else
        this._createCharacterToken(type, ch);
};

Tokenizer.prototype._emitCodePoint = function (cp) {
    var type = Tokenizer.CHARACTER_TOKEN;

    if (isWhitespace(cp))
        type = Tokenizer.WHITESPACE_CHARACTER_TOKEN;

    else if (cp === $.NULL)
        type = Tokenizer.NULL_CHARACTER_TOKEN;

    this._appendCharToCurrentCharacterToken(type, toChar(cp));
};

Tokenizer.prototype._emitSeveralCodePoints = function (codePoints) {
    for (var i = 0; i < codePoints.length; i++)
        this._emitCodePoint(codePoints[i]);
};

//NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
//So we can avoid additional checks here.
Tokenizer.prototype._emitChar = function (ch) {
    this._appendCharToCurrentCharacterToken(Tokenizer.CHARACTER_TOKEN, ch);
};

//Character reference tokenization
Tokenizer.prototype._consumeNumericEntity = function (isHex) {
    var digits = '',
        nextCp = void 0;

    do {
        digits += toChar(this._consume());
        nextCp = this._lookahead();
    } while (nextCp !== $.EOF && isDigit(nextCp, isHex));

    if (this._lookahead() === $.SEMICOLON)
        this._consume();

    var referencedCp = parseInt(digits, isHex ? 16 : 10),
        replacement = NUMERIC_ENTITY_REPLACEMENTS[referencedCp];

    if (replacement)
        return replacement;

    if (isReservedCodePoint(referencedCp))
        return $.REPLACEMENT_CHARACTER;

    return referencedCp;
};

// NOTE: for the details on this algorithm see
// https://github.com/inikulin/parse5/tree/master/scripts/generate_named_entity_data/README.md
Tokenizer.prototype._consumeNamedEntity = function (inAttr) {
    var referencedCodePoints = null,
        referenceSize = 0,
        cp = null,
        consumedCount = 0,
        semicolonTerminated = false;

    for (var i = 0; i > -1;) {
        var current = neTree[i],
            inNode = current < MAX_BRANCH_MARKER_VALUE,
            nodeWithData = inNode && current & HAS_DATA_FLAG;

        if (nodeWithData) {
            referencedCodePoints = current & DATA_DUPLET_FLAG ? [neTree[++i], neTree[++i]] : [neTree[++i]];
            referenceSize = consumedCount;

            if (cp === $.SEMICOLON) {
                semicolonTerminated = true;
                break;
            }
        }

        cp = this._consume();
        consumedCount++;

        if (cp === $.EOF)
            break;

        if (inNode)
            i = current & HAS_BRANCHES_FLAG ? findNamedEntityTreeBranch(i, cp) : -1;

        else
            i = cp === current ? ++i : -1;
    }


    if (referencedCodePoints) {
        if (!semicolonTerminated) {
            //NOTE: unconsume excess (e.g. 'it' in '&notit')
            this._unconsumeSeveral(consumedCount - referenceSize);

            //NOTE: If the character reference is being consumed as part of an attribute and the next character
            //is either a U+003D EQUALS SIGN character (=) or an alphanumeric ASCII character, then, for historical
            //reasons, all the characters that were matched after the U+0026 AMPERSAND character (&) must be
            //unconsumed, and nothing is returned.
            //However, if this next character is in fact a U+003D EQUALS SIGN character (=), then this is a
            //parse error, because some legacy user agents will misinterpret the markup in those cases.
            //(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html#tokenizing-character-references)
            if (inAttr) {
                var nextCp = this._lookahead();

                if (nextCp === $.EQUALS_SIGN || isAsciiAlphaNumeric(nextCp)) {
                    this._unconsumeSeveral(referenceSize);
                    return null;
                }
            }
        }

        return referencedCodePoints;
    }

    this._unconsumeSeveral(consumedCount);

    return null;
};

Tokenizer.prototype._consumeCharacterReference = function (startCp, inAttr) {
    if (isWhitespace(startCp) || startCp === $.GREATER_THAN_SIGN ||
        startCp === $.AMPERSAND || startCp === this.additionalAllowedCp || startCp === $.EOF) {
        //NOTE: not a character reference. No characters are consumed, and nothing is returned.
        this._unconsume();
        return null;
    }

    if (startCp === $.NUMBER_SIGN) {
        //NOTE: we have a numeric entity candidate, now we should determine if it's hex or decimal
        var isHex = false,
            nextCp = this._lookahead();

        if (nextCp === $.LATIN_SMALL_X || nextCp === $.LATIN_CAPITAL_X) {
            this._consume();
            isHex = true;
        }

        nextCp = this._lookahead();

        //NOTE: if we have at least one digit this is a numeric entity for sure, so we consume it
        if (nextCp !== $.EOF && isDigit(nextCp, isHex))
            return [this._consumeNumericEntity(isHex)];

        //NOTE: otherwise this is a bogus number entity and a parse error. Unconsume the number sign
        //and the 'x'-character if appropriate.
        this._unconsumeSeveral(isHex ? 2 : 1);
        return null;
    }

    this._unconsume();

    return this._consumeNamedEntity(inAttr);
};

//State machine
var _ = Tokenizer.prototype;

//12.2.4.1 Data state
//------------------------------------------------------------------
_[DATA_STATE] = function dataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.AMPERSAND)
        this.state = CHARACTER_REFERENCE_IN_DATA_STATE;

    else if (cp === $.LESS_THAN_SIGN)
        this.state = TAG_OPEN_STATE;

    else if (cp === $.NULL)
        this._emitCodePoint(cp);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.2 Character reference in data state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_DATA_STATE] = function characterReferenceInDataState(cp) {
    this.additionalAllowedCp = void 0;

    var referencedCodePoints = this._consumeCharacterReference(cp, false);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints)
            this._emitSeveralCodePoints(referencedCodePoints);

        else
            this._emitChar('&');

        this.state = DATA_STATE;
    }
};


//12.2.4.3 RCDATA state
//------------------------------------------------------------------
_[RCDATA_STATE] = function rcdataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.AMPERSAND)
        this.state = CHARACTER_REFERENCE_IN_RCDATA_STATE;

    else if (cp === $.LESS_THAN_SIGN)
        this.state = RCDATA_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.4 Character reference in RCDATA state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_RCDATA_STATE] = function characterReferenceInRcdataState(cp) {
    this.additionalAllowedCp = void 0;

    var referencedCodePoints = this._consumeCharacterReference(cp, false);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints)
            this._emitSeveralCodePoints(referencedCodePoints);

        else
            this._emitChar('&');

        this.state = RCDATA_STATE;
    }
};


//12.2.4.5 RAWTEXT state
//------------------------------------------------------------------
_[RAWTEXT_STATE] = function rawtextState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.LESS_THAN_SIGN)
        this.state = RAWTEXT_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.6 Script data state
//------------------------------------------------------------------
_[SCRIPT_DATA_STATE] = function scriptDataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.7 PLAINTEXT state
//------------------------------------------------------------------
_[PLAINTEXT_STATE] = function plaintextState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.8 Tag open state
//------------------------------------------------------------------
_[TAG_OPEN_STATE] = function tagOpenState(cp) {
    if (cp === $.EXCLAMATION_MARK)
        this.state = MARKUP_DECLARATION_OPEN_STATE;

    else if (cp === $.SOLIDUS)
        this.state = END_TAG_OPEN_STATE;

    else if (isAsciiLetter(cp)) {
        this._createStartTagToken();
        this._reconsumeInState(TAG_NAME_STATE);
    }

    else if (cp === $.QUESTION_MARK)
        this._reconsumeInState(BOGUS_COMMENT_STATE);

    else {
        this._emitChar('<');
        this._reconsumeInState(DATA_STATE);
    }
};


//12.2.4.9 End tag open state
//------------------------------------------------------------------
_[END_TAG_OPEN_STATE] = function endTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(TAG_NAME_STATE);
    }

    else if (cp === $.GREATER_THAN_SIGN)
        this.state = DATA_STATE;

    else if (cp === $.EOF) {
        this._reconsumeInState(DATA_STATE);
        this._emitChar('<');
        this._emitChar('/');
    }

    else
        this._reconsumeInState(BOGUS_COMMENT_STATE);
};


//12.2.4.10 Tag name state
//------------------------------------------------------------------
_[TAG_NAME_STATE] = function tagNameState(cp) {
    if (isWhitespace(cp))
        this.state = BEFORE_ATTRIBUTE_NAME_STATE;

    else if (cp === $.SOLIDUS)
        this.state = SELF_CLOSING_START_TAG_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (isAsciiUpper(cp))
        this.currentToken.tagName += toAsciiLowerChar(cp);

    else if (cp === $.NULL)
        this.currentToken.tagName += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentToken.tagName += toChar(cp);
};


//12.2.4.11 RCDATA less-than sign state
//------------------------------------------------------------------
_[RCDATA_LESS_THAN_SIGN_STATE] = function rcdataLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = RCDATA_END_TAG_OPEN_STATE;
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.12 RCDATA end tag open state
//------------------------------------------------------------------
_[RCDATA_END_TAG_OPEN_STATE] = function rcdataEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(RCDATA_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.13 RCDATA end tag name state
//------------------------------------------------------------------
_[RCDATA_END_TAG_NAME_STATE] = function rcdataEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this.state = DATA_STATE;
                this._emitCurrentToken();
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.14 RAWTEXT less-than sign state
//------------------------------------------------------------------
_[RAWTEXT_LESS_THAN_SIGN_STATE] = function rawtextLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = RAWTEXT_END_TAG_OPEN_STATE;
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.15 RAWTEXT end tag open state
//------------------------------------------------------------------
_[RAWTEXT_END_TAG_OPEN_STATE] = function rawtextEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(RAWTEXT_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.16 RAWTEXT end tag name state
//------------------------------------------------------------------
_[RAWTEXT_END_TAG_NAME_STATE] = function rawtextEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.17 Script data less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_LESS_THAN_SIGN_STATE] = function scriptDataLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_END_TAG_OPEN_STATE;
    }

    else if (cp === $.EXCLAMATION_MARK) {
        this.state = SCRIPT_DATA_ESCAPE_START_STATE;
        this._emitChar('<');
        this._emitChar('!');
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.18 Script data end tag open state
//------------------------------------------------------------------
_[SCRIPT_DATA_END_TAG_OPEN_STATE] = function scriptDataEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(SCRIPT_DATA_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.19 Script data end tag name state
//------------------------------------------------------------------
_[SCRIPT_DATA_END_TAG_NAME_STATE] = function scriptDataEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            else if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            else if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.20 Script data escape start state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPE_START_STATE] = function scriptDataEscapeStartState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPE_START_DASH_STATE;
        this._emitChar('-');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_STATE);
};


//12.2.4.21 Script data escape start dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPE_START_DASH_STATE] = function scriptDataEscapeStartDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_STATE);
};


//12.2.4.22 Script data escaped state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_STATE] = function scriptDataEscapedState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._emitCodePoint(cp);
};


//12.2.4.23 Script data escaped dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_DASH_STATE] = function scriptDataEscapedDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.24 Script data escaped dash dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_DASH_DASH_STATE] = function scriptDataEscapedDashDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this._emitChar('-');

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = SCRIPT_DATA_STATE;
        this._emitChar('>');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.25 Script data escaped less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE] = function scriptDataEscapedLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE;
    }

    else if (isAsciiLetter(cp)) {
        this.tempBuff = [];
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE);
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.26 Script data escaped end tag open state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE] = function scriptDataEscapedEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.27 Script data escaped end tag name state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE] = function scriptDataEscapedEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.28 Script data double escape start state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE] = function scriptDataDoubleEscapeStartState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
        this.state = this.isTempBufferEqualToScriptString() ? SCRIPT_DATA_DOUBLE_ESCAPED_STATE : SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }

    else if (isAsciiUpper(cp)) {
        this.tempBuff.push(toAsciiLowerCodePoint(cp));
        this._emitCodePoint(cp);
    }

    else if (isAsciiLower(cp)) {
        this.tempBuff.push(cp);
        this._emitCodePoint(cp);
    }

    else
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
};


//12.2.4.29 Script data double escaped state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_STATE] = function scriptDataDoubleEscapedState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._emitCodePoint(cp);
};


//12.2.4.30 Script data double escaped dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE] = function scriptDataDoubleEscapedDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.31 Script data double escaped dash dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE] = function scriptDataDoubleEscapedDashDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this._emitChar('-');

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = SCRIPT_DATA_STATE;
        this._emitChar('>');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.32 Script data double escaped less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE] = function scriptDataDoubleEscapedLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE;
        this._emitChar('/');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
};


//12.2.4.33 Script data double escape end state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE] = function scriptDataDoubleEscapeEndState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
        this.state = this.isTempBufferEqualToScriptString() ? SCRIPT_DATA_ESCAPED_STATE : SCRIPT_DATA_DOUBLE_ESCAPED_STATE;

        this._emitCodePoint(cp);
    }

    else if (isAsciiUpper(cp)) {
        this.tempBuff.push(toAsciiLowerCodePoint(cp));
        this._emitCodePoint(cp);
    }

    else if (isAsciiLower(cp)) {
        this.tempBuff.push(cp);
        this._emitCodePoint(cp);
    }

    else
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
};


//12.2.4.34 Before attribute name state
//------------------------------------------------------------------
_[BEFORE_ATTRIBUTE_NAME_STATE] = function beforeAttributeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF)
        this._reconsumeInState(AFTER_ATTRIBUTE_NAME_STATE);

    else if (cp === $.EQUALS_SIGN) {
        this._createAttr('=');
        this.state = ATTRIBUTE_NAME_STATE;
    }

    else {
        this._createAttr('');
        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
    }
};


//12.2.4.35 Attribute name state
//------------------------------------------------------------------
_[ATTRIBUTE_NAME_STATE] = function attributeNameState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
        this._leaveAttrName(AFTER_ATTRIBUTE_NAME_STATE);
        this._unconsume();
    }

    else if (cp === $.EQUALS_SIGN)
        this._leaveAttrName(BEFORE_ATTRIBUTE_VALUE_STATE);

    else if (isAsciiUpper(cp))
        this.currentAttr.name += toAsciiLowerChar(cp);

    else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN)
        this.currentAttr.name += toChar(cp);

    else if (cp === $.NULL)
        this.currentAttr.name += UNICODE.REPLACEMENT_CHARACTER;

    else
        this.currentAttr.name += toChar(cp);
};


//12.2.4.36 After attribute name state
//------------------------------------------------------------------
_[AFTER_ATTRIBUTE_NAME_STATE] = function afterAttributeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.SOLIDUS)
        this.state = SELF_CLOSING_START_TAG_STATE;

    else if (cp === $.EQUALS_SIGN)
        this.state = BEFORE_ATTRIBUTE_VALUE_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this._createAttr('');
        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
    }
};


//12.2.4.37 Before attribute value state
//------------------------------------------------------------------
_[BEFORE_ATTRIBUTE_VALUE_STATE] = function beforeAttributeValueState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK)
        this.state = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;

    else if (cp === $.APOSTROPHE)
        this.state = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;

    else
        this._reconsumeInState(ATTRIBUTE_VALUE_UNQUOTED_STATE);
};


//12.2.4.38 Attribute value (double-quoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE] = function attributeValueDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.QUOTATION_MARK;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.39 Attribute value (single-quoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE] = function attributeValueSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.APOSTROPHE;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.40 Attribute value (unquoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_UNQUOTED_STATE] = function attributeValueUnquotedState(cp) {
    if (isWhitespace(cp))
        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.GREATER_THAN_SIGN;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this._leaveAttrValue(DATA_STATE);
        this._emitCurrentToken();
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN ||
             cp === $.EQUALS_SIGN || cp === $.GRAVE_ACCENT)
        this.currentAttr.value += toChar(cp);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.41 Character reference in attribute value state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE] = function characterReferenceInAttributeValueState(cp) {
    var referencedCodePoints = this._consumeCharacterReference(cp, true);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints) {
            for (var i = 0; i < referencedCodePoints.length; i++)
                this.currentAttr.value += toChar(referencedCodePoints[i]);
        }
        else
            this.currentAttr.value += '&';

        this.state = this.returnState;
    }
};


//12.2.4.42 After attribute value (quoted) state
//------------------------------------------------------------------
_[AFTER_ATTRIBUTE_VALUE_QUOTED_STATE] = function afterAttributeValueQuotedState(cp) {
    if (isWhitespace(cp))
        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);

    else if (cp === $.SOLIDUS)
        this._leaveAttrValue(SELF_CLOSING_START_TAG_STATE);

    else if (cp === $.GREATER_THAN_SIGN) {
        this._leaveAttrValue(DATA_STATE);
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
};


//12.2.4.43 Self-closing start tag state
//------------------------------------------------------------------
_[SELF_CLOSING_START_TAG_STATE] = function selfClosingStartTagState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.selfClosing = true;
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
};


//12.2.4.44 Bogus comment state
//------------------------------------------------------------------
_[BOGUS_COMMENT_STATE] = function bogusCommentState() {
    this._createCommentToken();
    this._reconsumeInState(BOGUS_COMMENT_STATE_CONTINUATION);
};

//HACK: to support streaming and make BOGUS_COMMENT_STATE reentrant we've
//introduced BOGUS_COMMENT_STATE_CONTINUATION state which will not produce
//comment token on each call.
_[BOGUS_COMMENT_STATE_CONTINUATION] = function bogusCommentStateContinuation(cp) {
    while (true) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            break;
        }

        else if (cp === $.EOF) {
            this._reconsumeInState(DATA_STATE);
            break;
        }

        else {
            this.currentToken.data += cp === $.NULL ? UNICODE.REPLACEMENT_CHARACTER : toChar(cp);

            this._hibernationSnapshot();
            cp = this._consume();

            if (this._ensureHibernation())
                return;
        }
    }

    this._emitCurrentToken();
};

//12.2.4.45 Markup declaration open state
//------------------------------------------------------------------
_[MARKUP_DECLARATION_OPEN_STATE] = function markupDeclarationOpenState(cp) {
    var dashDashMatch = this._consumeSubsequentIfMatch($$.DASH_DASH_STRING, cp, true),
        doctypeMatch = !dashDashMatch && this._consumeSubsequentIfMatch($$.DOCTYPE_STRING, cp, false),
        cdataMatch = !dashDashMatch && !doctypeMatch &&
                     this.allowCDATA &&
                     this._consumeSubsequentIfMatch($$.CDATA_START_STRING, cp, true);

    if (!this._ensureHibernation()) {
        if (dashDashMatch) {
            this._createCommentToken();
            this.state = COMMENT_START_STATE;
        }

        else if (doctypeMatch)
            this.state = DOCTYPE_STATE;

        else if (cdataMatch)
            this.state = CDATA_SECTION_STATE;

        else
            this._reconsumeInState(BOGUS_COMMENT_STATE);
    }
};


//12.2.4.46 Comment start state
//------------------------------------------------------------------
_[COMMENT_START_STATE] = function commentStartState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_START_DASH_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.47 Comment start dash state
//------------------------------------------------------------------
_[COMMENT_START_DASH_STATE] = function commentStartDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += '-';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '-';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.48 Comment state
//------------------------------------------------------------------
_[COMMENT_STATE] = function commentState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_DASH_STATE;

    else if (cp === $.NULL)
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.data += toChar(cp);
};


//12.2.4.49 Comment end dash state
//------------------------------------------------------------------
_[COMMENT_END_DASH_STATE] = function commentEndDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += '-';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '-';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.50 Comment end state
//------------------------------------------------------------------
_[COMMENT_END_STATE] = function commentEndState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EXCLAMATION_MARK)
        this.state = COMMENT_END_BANG_STATE;

    else if (cp === $.HYPHEN_MINUS)
        this.currentToken.data += '-';

    else if (cp === $.NULL) {
        this.currentToken.data += '--';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._reconsumeInState(DATA_STATE);
        this._emitCurrentToken();
    }

    else {
        this.currentToken.data += '--';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.51 Comment end bang state
//------------------------------------------------------------------
_[COMMENT_END_BANG_STATE] = function commentEndBangState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.currentToken.data += '--!';
        this.state = COMMENT_END_DASH_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.NULL) {
        this.currentToken.data += '--!';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '--!';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.52 DOCTYPE state
//------------------------------------------------------------------
_[DOCTYPE_STATE] = function doctypeState(cp) {
    if (isWhitespace(cp))
        return;

    else if (cp === $.GREATER_THAN_SIGN) {
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }
    else {
        this._createDoctypeToken('');
        this._reconsumeInState(DOCTYPE_NAME_STATE);
    }
};


//12.2.4.54 DOCTYPE name state
//------------------------------------------------------------------
_[DOCTYPE_NAME_STATE] = function doctypeNameState(cp) {
    if (isWhitespace(cp) || cp === $.GREATER_THAN_SIGN || cp === $.EOF)
        this._reconsumeInState(AFTER_DOCTYPE_NAME_STATE);

    else if (isAsciiUpper(cp))
        this.currentToken.name += toAsciiLowerChar(cp);

    else if (cp === $.NULL)
        this.currentToken.name += UNICODE.REPLACEMENT_CHARACTER;

    else
        this.currentToken.name += toChar(cp);
};


//12.2.4.55 After DOCTYPE name state
//------------------------------------------------------------------
_[AFTER_DOCTYPE_NAME_STATE] = function afterDoctypeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else {
        var publicMatch = this._consumeSubsequentIfMatch($$.PUBLIC_STRING, cp, false),
            systemMatch = !publicMatch && this._consumeSubsequentIfMatch($$.SYSTEM_STRING, cp, false);

        if (!this._ensureHibernation()) {
            if (publicMatch)
                this.state = BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE;

            else if (systemMatch)
                this.state = BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

            else {
                this.currentToken.forceQuirks = true;
                this.state = BOGUS_DOCTYPE_STATE;
            }
        }
    }
};


//12.2.4.57 Before DOCTYPE public identifier state
//------------------------------------------------------------------
_[BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE] = function beforeDoctypePublicIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK) {
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }

    else if (cp === $.APOSTROPHE) {
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.58 DOCTYPE public identifier (double-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE] = function doctypePublicIdentifierDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;

    else if (cp === $.NULL)
        this.currentToken.publicId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.publicId += toChar(cp);
};


//12.2.4.59 DOCTYPE public identifier (single-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE] = function doctypePublicIdentifierSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;

    else if (cp === $.NULL)
        this.currentToken.publicId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.publicId += toChar(cp);
};


//12.2.4.61 Between DOCTYPE public and system identifiers state
//------------------------------------------------------------------
_[BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE] = function betweenDoctypePublicAndSystemIdentifiersState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.QUOTATION_MARK) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }


    else if (cp === $.APOSTROPHE) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.63 Before DOCTYPE system identifier state
//------------------------------------------------------------------
_[BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE] = function beforeDoctypeSystemIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }

    else if (cp === $.APOSTROPHE) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.64 DOCTYPE system identifier (double-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE] = function doctypeSystemIdentifierDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.NULL)
        this.currentToken.systemId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.systemId += toChar(cp);
};


//12.2.4.65 DOCTYPE system identifier (single-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE] = function doctypeSystemIdentifierSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.NULL)
        this.currentToken.systemId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.systemId += toChar(cp);
};


//12.2.4.66 After DOCTYPE system identifier state
//------------------------------------------------------------------
_[AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE] = function afterDoctypeSystemIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.state = BOGUS_DOCTYPE_STATE;
};


//12.2.4.67 Bogus DOCTYPE state
//------------------------------------------------------------------
_[BOGUS_DOCTYPE_STATE] = function bogusDoctypeState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }
};


//12.2.4.68 CDATA section state
//------------------------------------------------------------------
_[CDATA_SECTION_STATE] = function cdataSectionState(cp) {
    while (true) {
        if (cp === $.EOF) {
            this._reconsumeInState(DATA_STATE);
            break;
        }

        else {
            var cdataEndMatch = this._consumeSubsequentIfMatch($$.CDATA_END_STRING, cp, true);

            if (this._ensureHibernation())
                break;

            if (cdataEndMatch) {
                this.state = DATA_STATE;
                break;
            }

            this._emitCodePoint(cp);

            this._hibernationSnapshot();
            cp = this._consume();

            if (this._ensureHibernation())
                break;
        }
    }
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 75 */,
/* 76 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(163);
var hiddenKeys = __webpack_require__(128).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(46);
var TAG = __webpack_require__(13)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(26).f;
var has = __webpack_require__(44);
var TAG = __webpack_require__(13)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(69)('meta');
var isObject = __webpack_require__(16);
var has = __webpack_require__(44);
var setDesc = __webpack_require__(26).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(15)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_object_values_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_object_values_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_object_values_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_keys_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_symbol_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_filter_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appId__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appIdResolver__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_storageManager__ = __webpack_require__(39);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var GTM = function () {
  var isGtmApplicable = function isGtmApplicable() {
    return Object.values(__WEBPACK_IMPORTED_MODULE_9__appIdResolver__["a" /* default */]).includes("".concat(Object(__WEBPACK_IMPORTED_MODULE_8__appId__["f" /* getAppIdFallback */])()));
  };

  var init = function init() {
    if (isGtmApplicable()) {
      var gtmTag = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src= \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f); })(window,document,\'script\',\'dataLayer\',\'G-D6HE5EXHTF\');';
      var script = document.createElement('script');
      script.innerHTML = gtmTag;
      document.body.appendChild(script);
      var interval = setInterval(function () {
        var _window;

        if ((_window = window) !== null && _window !== void 0 && _window.dataLayer) {
          setVisitorId();
          clearInterval(interval);
        }
      }, 500);
    }
  };

  var pushDataLayer = function pushDataLayer(data) {
    var _window2;

    if (isGtmApplicable() && ((_window2 = window) !== null && _window2 !== void 0 && _window2.dataLayer || data.is_elevio)) {
      window.dataLayer.push(_objectSpread({}, data));
    }
  };

  var setVisitorId = function setVisitorId() {
    var tokenList = Object(__WEBPACK_IMPORTED_MODULE_10__utils_storageManager__["d" /* getTokenList */])();

    if (tokenList.length > 0) {
      pushDataLayer({
        visitorId: tokenList[0].loginInfo.loginid
      });
    } else {
      pushDataLayer({
        visitorId: undefined
      });
    }
  };

  return {
    init: init,
    pushDataLayer: pushDataLayer,
    setVisitorId: setVisitorId
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (GTM);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(58)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(71)(KEY);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.REPLACEMENT_CHARACTER = '\uFFFD';

exports.CODE_POINTS = {
    EOF: -1,
    NULL: 0x00,
    TABULATION: 0x09,
    CARRIAGE_RETURN: 0x0D,
    LINE_FEED: 0x0A,
    FORM_FEED: 0x0C,
    SPACE: 0x20,
    EXCLAMATION_MARK: 0x21,
    QUOTATION_MARK: 0x22,
    NUMBER_SIGN: 0x23,
    AMPERSAND: 0x26,
    APOSTROPHE: 0x27,
    HYPHEN_MINUS: 0x2D,
    SOLIDUS: 0x2F,
    DIGIT_0: 0x30,
    DIGIT_9: 0x39,
    SEMICOLON: 0x3B,
    LESS_THAN_SIGN: 0x3C,
    EQUALS_SIGN: 0x3D,
    GREATER_THAN_SIGN: 0x3E,
    QUESTION_MARK: 0x3F,
    LATIN_CAPITAL_A: 0x41,
    LATIN_CAPITAL_F: 0x46,
    LATIN_CAPITAL_X: 0x58,
    LATIN_CAPITAL_Z: 0x5A,
    GRAVE_ACCENT: 0x60,
    LATIN_SMALL_A: 0x61,
    LATIN_SMALL_F: 0x66,
    LATIN_SMALL_X: 0x78,
    LATIN_SMALL_Z: 0x7A,
    REPLACEMENT_CHARACTER: 0xFFFD
};

exports.CODE_POINT_SEQUENCES = {
    DASH_DASH_STRING: [0x2D, 0x2D], //--
    DOCTYPE_STRING: [0x44, 0x4F, 0x43, 0x54, 0x59, 0x50, 0x45], //DOCTYPE
    CDATA_START_STRING: [0x5B, 0x43, 0x44, 0x41, 0x54, 0x41, 0x5B], //[CDATA[
    CDATA_END_STRING: [0x5D, 0x5D, 0x3E], //]]>
    SCRIPT_STRING: [0x73, 0x63, 0x72, 0x69, 0x70, 0x74], //script
    PUBLIC_STRING: [0x50, 0x55, 0x42, 0x4C, 0x49, 0x43], //PUBLIC
    SYSTEM_STRING: [0x53, 0x59, 0x53, 0x54, 0x45, 0x4D] //SYSTEM
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96).Buffer))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkSpecKeys = exports.checkNavigable = exports.changeSlide = exports.canUseDOM = exports.canGoNext = void 0;
exports.clamp = clamp;
exports.swipeStart = exports.swipeMove = exports.swipeEnd = exports.slidesOnRight = exports.slidesOnLeft = exports.slideHandler = exports.siblingDirection = exports.safePreventDefault = exports.lazyStartIndex = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.keyHandler = exports.initializedState = exports.getWidth = exports.getTrackLeft = exports.getTrackCSS = exports.getTrackAnimateCSS = exports.getTotalSlides = exports.getSwipeDirection = exports.getSlideCount = exports.getRequiredLazySlides = exports.getPreClones = exports.getPostClones = exports.getOnDemandLazySlides = exports.getNavigableIndexes = exports.getHeight = exports.extractObject = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}

var safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];

  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};

exports.safePreventDefault = safePreventDefault;

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread(_objectSpread({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread(_objectSpread({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(47);
var global = __webpack_require__(10);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(64) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(55);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var dP = __webpack_require__(26);
var DESCRIPTORS = __webpack_require__(22);
var SPECIES = __webpack_require__(13)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(9);
var dPs = __webpack_require__(193);
var enumBugKeys = __webpack_require__(128);
var IE_PROTO = __webpack_require__(127)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(122)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(125).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toLength = __webpack_require__(23);
var advanceStringIndex = __webpack_require__(119);
var regExpExec = __webpack_require__(97);

// @@match logic
__webpack_require__(98)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(227);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(199) });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(234)
var ieee754 = __webpack_require__(235)
var isArray = __webpack_require__(167)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(80);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(189);
var redefine = __webpack_require__(37);
var hide = __webpack_require__(36);
var fails = __webpack_require__(15);
var defined = __webpack_require__(54);
var wks = __webpack_require__(13);
var regexpExec = __webpack_require__(121);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(46);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(48);
var call = __webpack_require__(160);
var isArrayIter = __webpack_require__(144);
var anObject = __webpack_require__(9);
var toLength = __webpack_require__(23);
var getIterFn = __webpack_require__(145);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(37);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = module.exports = function (host) {
    var originalMethods = {},
        overriddenMethods = this._getOverriddenMethods(this, originalMethods);

    Object.keys(overriddenMethods).forEach(function (key) {
        if (typeof overriddenMethods[key] === 'function') {
            originalMethods[key] = host[key];
            host[key] = overriddenMethods[key];
        }
    });
};

Mixin.prototype._getOverriddenMethods = function () {
    throw new Error('Not implemented');
};



/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(133).EventEmitter;
var inherits = __webpack_require__(74);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(134);
Stream.Writable = __webpack_require__(256);
Stream.Duplex = __webpack_require__(257);
Stream.Transform = __webpack_require__(258);
Stream.PassThrough = __webpack_require__(259);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)))

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(9);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(16);
var cof = __webpack_require__(46);
var MATCH = __webpack_require__(13)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(45);
var SPECIES = __webpack_require__(13)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(112);
var anObject = __webpack_require__(9);
var speciesConstructor = __webpack_require__(113);
var advanceStringIndex = __webpack_require__(119);
var toLength = __webpack_require__(23);
var callRegExpExec = __webpack_require__(97);
var regexpExec = __webpack_require__(121);
var fails = __webpack_require__(15);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(98)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(120)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(55);
var defined = __webpack_require__(54);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(111);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var document = __webpack_require__(10).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(23);
var toAbsoluteIndex = __webpack_require__(90);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(46);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(10).document;
module.exports = document && document.documentElement;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(13)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(89)('keys');
var uid = __webpack_require__(69);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var inheritIfRequired = __webpack_require__(166);
var dP = __webpack_require__(26).f;
var gOPN = __webpack_require__(77).f;
var isRegExp = __webpack_require__(112);
var $flags = __webpack_require__(111);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(22) && (!CORRECT_NEW || __webpack_require__(15)(function () {
  re2[__webpack_require__(13)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(37)(global, 'RegExp', $RegExp);
}

__webpack_require__(91)('RegExp');


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOCUMENT_MODE = __webpack_require__(43).DOCUMENT_MODE;

//Node construction
exports.createDocument = function () {
    return {
        nodeName: '#document',
        mode: DOCUMENT_MODE.NO_QUIRKS,
        childNodes: []
    };
};

exports.createDocumentFragment = function () {
    return {
        nodeName: '#document-fragment',
        childNodes: []
    };
};

exports.createElement = function (tagName, namespaceURI, attrs) {
    return {
        nodeName: tagName,
        tagName: tagName,
        attrs: attrs,
        namespaceURI: namespaceURI,
        childNodes: [],
        parentNode: null
    };
};

exports.createCommentNode = function (data) {
    return {
        nodeName: '#comment',
        data: data,
        parentNode: null
    };
};

var createTextNode = function (value) {
    return {
        nodeName: '#text',
        value: value,
        parentNode: null
    };
};


//Tree mutation
var appendChild = exports.appendChild = function (parentNode, newNode) {
    parentNode.childNodes.push(newNode);
    newNode.parentNode = parentNode;
};

var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
    var insertionIdx = parentNode.childNodes.indexOf(referenceNode);

    parentNode.childNodes.splice(insertionIdx, 0, newNode);
    newNode.parentNode = parentNode;
};

exports.setTemplateContent = function (templateElement, contentElement) {
    templateElement.content = contentElement;
};

exports.getTemplateContent = function (templateElement) {
    return templateElement.content;
};

exports.setDocumentType = function (document, name, publicId, systemId) {
    var doctypeNode = null;

    for (var i = 0; i < document.childNodes.length; i++) {
        if (document.childNodes[i].nodeName === '#documentType') {
            doctypeNode = document.childNodes[i];
            break;
        }
    }

    if (doctypeNode) {
        doctypeNode.name = name;
        doctypeNode.publicId = publicId;
        doctypeNode.systemId = systemId;
    }

    else {
        appendChild(document, {
            nodeName: '#documentType',
            name: name,
            publicId: publicId,
            systemId: systemId
        });
    }
};

exports.setDocumentMode = function (document, mode) {
    document.mode = mode;
};

exports.getDocumentMode = function (document) {
    return document.mode;
};

exports.detachNode = function (node) {
    if (node.parentNode) {
        var idx = node.parentNode.childNodes.indexOf(node);

        node.parentNode.childNodes.splice(idx, 1);
        node.parentNode = null;
    }
};

exports.insertText = function (parentNode, text) {
    if (parentNode.childNodes.length) {
        var prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];

        if (prevNode.nodeName === '#text') {
            prevNode.value += text;
            return;
        }
    }

    appendChild(parentNode, createTextNode(text));
};

exports.insertTextBefore = function (parentNode, text, referenceNode) {
    var prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];

    if (prevNode && prevNode.nodeName === '#text')
        prevNode.value += text;
    else
        insertBefore(parentNode, createTextNode(text), referenceNode);
};

exports.adoptAttributes = function (recipient, attrs) {
    var recipientAttrsMap = [];

    for (var i = 0; i < recipient.attrs.length; i++)
        recipientAttrsMap.push(recipient.attrs[i].name);

    for (var j = 0; j < attrs.length; j++) {
        if (recipientAttrsMap.indexOf(attrs[j].name) === -1)
            recipient.attrs.push(attrs[j]);
    }
};


//Tree traversing
exports.getFirstChild = function (node) {
    return node.childNodes[0];
};

exports.getChildNodes = function (node) {
    return node.childNodes;
};

exports.getParentNode = function (node) {
    return node.parentNode;
};

exports.getAttrList = function (element) {
    return element.attrs;
};

//Node data
exports.getTagName = function (element) {
    return element.tagName;
};

exports.getNamespaceURI = function (element) {
    return element.namespaceURI;
};

exports.getTextNodeContent = function (textNode) {
    return textNode.value;
};

exports.getCommentNodeContent = function (commentNode) {
    return commentNode.data;
};

exports.getDocumentTypeNodeName = function (doctypeNode) {
    return doctypeNode.name;
};

exports.getDocumentTypeNodePublicId = function (doctypeNode) {
    return doctypeNode.publicId;
};

exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
    return doctypeNode.systemId;
};

//Node types
exports.isTextNode = function (node) {
    return node.nodeName === '#text';
};

exports.isCommentNode = function (node) {
    return node.nodeName === '#comment';
};

exports.isDocumentTypeNode = function (node) {
    return node.nodeName === '#documentType';
};

exports.isElementNode = function (node) {
    return !!node.tagName;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function mergeOptions(defaults, options) {
    options = options || Object.create(null);

    return [defaults, options].reduce(function (merged, optObj) {
        Object.keys(optObj).forEach(function (key) {
            merged[key] = optObj[key];
        });

        return merged;
    }, Object.create(null));
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOCUMENT_MODE = __webpack_require__(43).DOCUMENT_MODE;

//Const
var VALID_DOCTYPE_NAME = 'html',
    QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd',
    QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
        '+//silmaril//dtd html pro v0r11 19970101//en',
        '-//advasoft ltd//dtd html 3.0 aswedit + extensions//en',
        '-//as//dtd html 3.0 aswedit + extensions//en',
        '-//ietf//dtd html 2.0 level 1//en',
        '-//ietf//dtd html 2.0 level 2//en',
        '-//ietf//dtd html 2.0 strict level 1//en',
        '-//ietf//dtd html 2.0 strict level 2//en',
        '-//ietf//dtd html 2.0 strict//en',
        '-//ietf//dtd html 2.0//en',
        '-//ietf//dtd html 2.1e//en',
        '-//ietf//dtd html 3.0//en',
        '-//ietf//dtd html 3.0//en//',
        '-//ietf//dtd html 3.2 final//en',
        '-//ietf//dtd html 3.2//en',
        '-//ietf//dtd html 3//en',
        '-//ietf//dtd html level 0//en',
        '-//ietf//dtd html level 0//en//2.0',
        '-//ietf//dtd html level 1//en',
        '-//ietf//dtd html level 1//en//2.0',
        '-//ietf//dtd html level 2//en',
        '-//ietf//dtd html level 2//en//2.0',
        '-//ietf//dtd html level 3//en',
        '-//ietf//dtd html level 3//en//3.0',
        '-//ietf//dtd html strict level 0//en',
        '-//ietf//dtd html strict level 0//en//2.0',
        '-//ietf//dtd html strict level 1//en',
        '-//ietf//dtd html strict level 1//en//2.0',
        '-//ietf//dtd html strict level 2//en',
        '-//ietf//dtd html strict level 2//en//2.0',
        '-//ietf//dtd html strict level 3//en',
        '-//ietf//dtd html strict level 3//en//3.0',
        '-//ietf//dtd html strict//en',
        '-//ietf//dtd html strict//en//2.0',
        '-//ietf//dtd html strict//en//3.0',
        '-//ietf//dtd html//en',
        '-//ietf//dtd html//en//2.0',
        '-//ietf//dtd html//en//3.0',
        '-//metrius//dtd metrius presentational//en',
        '-//microsoft//dtd internet explorer 2.0 html strict//en',
        '-//microsoft//dtd internet explorer 2.0 html//en',
        '-//microsoft//dtd internet explorer 2.0 tables//en',
        '-//microsoft//dtd internet explorer 3.0 html strict//en',
        '-//microsoft//dtd internet explorer 3.0 html//en',
        '-//microsoft//dtd internet explorer 3.0 tables//en',
        '-//netscape comm. corp.//dtd html//en',
        '-//netscape comm. corp.//dtd strict html//en',
        '-//o\'reilly and associates//dtd html 2.0//en',
        '-//o\'reilly and associates//dtd html extended 1.0//en',
        '-//spyglass//dtd html 2.0 extended//en',
        '-//sq//dtd html 2.0 hotmetal + extensions//en',
        '-//sun microsystems corp.//dtd hotjava html//en',
        '-//sun microsystems corp.//dtd hotjava strict html//en',
        '-//w3c//dtd html 3 1995-03-24//en',
        '-//w3c//dtd html 3.2 draft//en',
        '-//w3c//dtd html 3.2 final//en',
        '-//w3c//dtd html 3.2//en',
        '-//w3c//dtd html 3.2s draft//en',
        '-//w3c//dtd html 4.0 frameset//en',
        '-//w3c//dtd html 4.0 transitional//en',
        '-//w3c//dtd html experimental 19960712//en',
        '-//w3c//dtd html experimental 970421//en',
        '-//w3c//dtd w3 html//en',
        '-//w3o//dtd w3 html 3.0//en',
        '-//w3o//dtd w3 html 3.0//en//',
        '-//webtechs//dtd mozilla html 2.0//en',
        '-//webtechs//dtd mozilla html//en'
    ],
    QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = QUIRKS_MODE_PUBLIC_ID_PREFIXES.concat([
        '-//w3c//dtd html 4.01 frameset//',
        '-//w3c//dtd html 4.01 transitional//'
    ]),
    QUIRKS_MODE_PUBLIC_IDS = [
        '-//w3o//dtd w3 html strict 3.0//en//',
        '-/w3c/dtd html 4.0 transitional/en',
        'html'
    ],
    LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = [
        '-//W3C//DTD XHTML 1.0 Frameset//',
        '-//W3C//DTD XHTML 1.0 Transitional//'
    ],
    LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = LIMITED_QUIRKS_PUBLIC_ID_PREFIXES.concat([
        '-//W3C//DTD HTML 4.01 Frameset//',
        '-//W3C//DTD HTML 4.01 Transitional//'
    ]);


//Utils
function enquoteDoctypeId(id) {
    var quote = id.indexOf('"') !== -1 ? '\'' : '"';

    return quote + id + quote;
}

function hasPrefix(publicId, prefixes) {
    for (var i = 0; i < prefixes.length; i++) {
        if (publicId.indexOf(prefixes[i]) === 0)
            return true;
    }

    return false;
}


//API
exports.getDocumentMode = function (name, publicId, systemId) {
    if (name !== VALID_DOCTYPE_NAME)
        return DOCUMENT_MODE.QUIRKS;

    if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID)
        return DOCUMENT_MODE.QUIRKS;

    if (publicId !== null) {
        publicId = publicId.toLowerCase();

        if (QUIRKS_MODE_PUBLIC_IDS.indexOf(publicId) > -1)
            return DOCUMENT_MODE.QUIRKS;

        var prefixes = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes))
            return DOCUMENT_MODE.QUIRKS;

        prefixes = systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes))
            return DOCUMENT_MODE.LIMITED_QUIRKS;
    }

    return DOCUMENT_MODE.NO_QUIRKS;
};

exports.serializeContent = function (name, publicId, systemId) {
    var str = '!DOCTYPE ';

    if (name)
        str += name;

    if (publicId !== null)
        str += ' PUBLIC ' + enquoteDoctypeId(publicId);

    else if (systemId !== null)
        str += ' SYSTEM';

    if (systemId !== null)
        str += ' ' + enquoteDoctypeId(systemId);

    return str;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(175);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(136);
exports.Duplex = __webpack_require__(62);
exports.Transform = __webpack_require__(179);
exports.PassThrough = __webpack_require__(255);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(96)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(106);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(87));
util.inherits = __webpack_require__(74);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(253)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(176);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(135).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(177);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(62);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(62);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78), __webpack_require__(251).setImmediate, __webpack_require__(32)))

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_freeze_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_freeze_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_freeze_js__);

var AppIdMap = Object.freeze({
  'bot.binary.com': '37985',
  'bot.binary.me': '37985',
  'binary.bot': '37985'
});
/* harmony default export */ __webpack_exports__["a"] = (AppIdMap);

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(112);
var defined = __webpack_require__(54);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(13)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(76);
var ITERATOR = __webpack_require__(13)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(80);
var ITERATOR = __webpack_require__(13)('iterator');
var Iterators = __webpack_require__(76);
module.exports = __webpack_require__(47).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(48);
var invoke = __webpack_require__(190);
var html = __webpack_require__(125);
var cel = __webpack_require__(122);
var global = __webpack_require__(10);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(46)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(45);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(47);
var LIBRARY = __webpack_require__(64);
var wksExt = __webpack_require__(162);
var defineProperty = __webpack_require__(26).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(26);
var createDesc = __webpack_require__(70);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(64);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(37);
var hide = __webpack_require__(36);
var Iterators = __webpack_require__(76);
var $iterCreate = __webpack_require__(164);
var setToStringTag = __webpack_require__(81);
var getPrototypeOf = __webpack_require__(60);
var ITERATOR = __webpack_require__(13)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(197)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(16);
var meta = __webpack_require__(82).onFreeze;

__webpack_require__(61)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(16);
var anObject = __webpack_require__(9);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(48)(Function.call, __webpack_require__(52).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var sameValue = __webpack_require__(201);
var regExpExec = __webpack_require__(97);

// @@search logic
__webpack_require__(98)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(22) && !__webpack_require__(15)(function () {
  return Object.defineProperty(__webpack_require__(122)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(224);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(9);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var macrotask = __webpack_require__(146).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(46)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(13);


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(44);
var toIObject = __webpack_require__(38);
var arrayIndexOf = __webpack_require__(123)(false);
var IE_PROTO = __webpack_require__(127)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(92);
var descriptor = __webpack_require__(70);
var setToStringTag = __webpack_require__(81);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(36)(IteratorPrototype, __webpack_require__(13)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var setPrototypeOf = __webpack_require__(154).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 168 */
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__(73),
    OpenElementStack = __webpack_require__(241),
    FormattingElementList = __webpack_require__(242),
    LocationInfoParserMixin = __webpack_require__(243),
    defaultTreeAdapter = __webpack_require__(130),
    mergeOptions = __webpack_require__(131),
    doctype = __webpack_require__(132),
    foreignContent = __webpack_require__(172),
    UNICODE = __webpack_require__(86),
    HTML = __webpack_require__(43);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES,
    ATTRS = HTML.ATTRS;

var DEFAULT_OPTIONS = {
    locationInfo: false,
    treeAdapter: defaultTreeAdapter
};

//Misc constants
var HIDDEN_INPUT_TYPE = 'hidden';

//Adoption agency loops iteration count
var AA_OUTER_LOOP_ITER = 8,
    AA_INNER_LOOP_ITER = 3;

//Insertion modes
var INITIAL_MODE = 'INITIAL_MODE',
    BEFORE_HTML_MODE = 'BEFORE_HTML_MODE',
    BEFORE_HEAD_MODE = 'BEFORE_HEAD_MODE',
    IN_HEAD_MODE = 'IN_HEAD_MODE',
    AFTER_HEAD_MODE = 'AFTER_HEAD_MODE',
    IN_BODY_MODE = 'IN_BODY_MODE',
    TEXT_MODE = 'TEXT_MODE',
    IN_TABLE_MODE = 'IN_TABLE_MODE',
    IN_TABLE_TEXT_MODE = 'IN_TABLE_TEXT_MODE',
    IN_CAPTION_MODE = 'IN_CAPTION_MODE',
    IN_COLUMN_GROUP_MODE = 'IN_COLUMN_GROUP_MODE',
    IN_TABLE_BODY_MODE = 'IN_TABLE_BODY_MODE',
    IN_ROW_MODE = 'IN_ROW_MODE',
    IN_CELL_MODE = 'IN_CELL_MODE',
    IN_SELECT_MODE = 'IN_SELECT_MODE',
    IN_SELECT_IN_TABLE_MODE = 'IN_SELECT_IN_TABLE_MODE',
    IN_TEMPLATE_MODE = 'IN_TEMPLATE_MODE',
    AFTER_BODY_MODE = 'AFTER_BODY_MODE',
    IN_FRAMESET_MODE = 'IN_FRAMESET_MODE',
    AFTER_FRAMESET_MODE = 'AFTER_FRAMESET_MODE',
    AFTER_AFTER_BODY_MODE = 'AFTER_AFTER_BODY_MODE',
    AFTER_AFTER_FRAMESET_MODE = 'AFTER_AFTER_FRAMESET_MODE';

//Insertion mode reset map
var INSERTION_MODE_RESET_MAP = Object.create(null);

INSERTION_MODE_RESET_MAP[$.TR] = IN_ROW_MODE;
INSERTION_MODE_RESET_MAP[$.TBODY] =
INSERTION_MODE_RESET_MAP[$.THEAD] =
INSERTION_MODE_RESET_MAP[$.TFOOT] = IN_TABLE_BODY_MODE;
INSERTION_MODE_RESET_MAP[$.CAPTION] = IN_CAPTION_MODE;
INSERTION_MODE_RESET_MAP[$.COLGROUP] = IN_COLUMN_GROUP_MODE;
INSERTION_MODE_RESET_MAP[$.TABLE] = IN_TABLE_MODE;
INSERTION_MODE_RESET_MAP[$.BODY] = IN_BODY_MODE;
INSERTION_MODE_RESET_MAP[$.FRAMESET] = IN_FRAMESET_MODE;

//Template insertion mode switch map
var TEMPLATE_INSERTION_MODE_SWITCH_MAP = Object.create(null);

TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.CAPTION] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.COLGROUP] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TBODY] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TFOOT] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.THEAD] = IN_TABLE_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.COL] = IN_COLUMN_GROUP_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TR] = IN_TABLE_BODY_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TD] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TH] = IN_ROW_MODE;

//Token handlers map for insertion modes
var _ = Object.create(null);

_[INITIAL_MODE] = Object.create(null);
_[INITIAL_MODE][Tokenizer.CHARACTER_TOKEN] =
_[INITIAL_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInInitialMode;
_[INITIAL_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[INITIAL_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[INITIAL_MODE][Tokenizer.DOCTYPE_TOKEN] = doctypeInInitialMode;
_[INITIAL_MODE][Tokenizer.START_TAG_TOKEN] =
_[INITIAL_MODE][Tokenizer.END_TAG_TOKEN] =
_[INITIAL_MODE][Tokenizer.EOF_TOKEN] = tokenInInitialMode;

_[BEFORE_HTML_MODE] = Object.create(null);
_[BEFORE_HTML_MODE][Tokenizer.CHARACTER_TOKEN] =
_[BEFORE_HTML_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[BEFORE_HTML_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[BEFORE_HTML_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[BEFORE_HTML_MODE][Tokenizer.START_TAG_TOKEN] = startTagBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.END_TAG_TOKEN] = endTagBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.EOF_TOKEN] = tokenBeforeHtml;

_[BEFORE_HEAD_MODE] = Object.create(null);
_[BEFORE_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[BEFORE_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[BEFORE_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[BEFORE_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[BEFORE_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenBeforeHead;

_[IN_HEAD_MODE] = Object.create(null);
_[IN_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInHead;
_[IN_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagInHead;
_[IN_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagInHead;
_[IN_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenInHead;

_[AFTER_HEAD_MODE] = Object.create(null);
_[AFTER_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[AFTER_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[AFTER_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenAfterHead;

_[IN_BODY_MODE] = Object.create(null);
_[IN_BODY_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagInBody;
_[IN_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagInBody;
_[IN_BODY_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[TEXT_MODE] = Object.create(null);
_[TEXT_MODE][Tokenizer.CHARACTER_TOKEN] =
_[TEXT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[TEXT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[TEXT_MODE][Tokenizer.COMMENT_TOKEN] =
_[TEXT_MODE][Tokenizer.DOCTYPE_TOKEN] =
_[TEXT_MODE][Tokenizer.START_TAG_TOKEN] = ignoreToken;
_[TEXT_MODE][Tokenizer.END_TAG_TOKEN] = endTagInText;
_[TEXT_MODE][Tokenizer.EOF_TOKEN] = eofInText;

_[IN_TABLE_MODE] = Object.create(null);
_[IN_TABLE_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_TABLE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_TABLE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_TABLE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TABLE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TABLE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTable;
_[IN_TABLE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTable;
_[IN_TABLE_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TABLE_TEXT_MODE] = Object.create(null);
_[IN_TABLE_TEXT_MODE][Tokenizer.CHARACTER_TOKEN] = characterInTableText;
_[IN_TABLE_TEXT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_TABLE_TEXT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInTableText;
_[IN_TABLE_TEXT_MODE][Tokenizer.COMMENT_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.DOCTYPE_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.START_TAG_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.END_TAG_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.EOF_TOKEN] = tokenInTableText;

_[IN_CAPTION_MODE] = Object.create(null);
_[IN_CAPTION_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_CAPTION_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_CAPTION_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_CAPTION_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_CAPTION_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_CAPTION_MODE][Tokenizer.START_TAG_TOKEN] = startTagInCaption;
_[IN_CAPTION_MODE][Tokenizer.END_TAG_TOKEN] = endTagInCaption;
_[IN_CAPTION_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_COLUMN_GROUP_MODE] = Object.create(null);
_[IN_COLUMN_GROUP_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_COLUMN_GROUP_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_COLUMN_GROUP_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_COLUMN_GROUP_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_COLUMN_GROUP_MODE][Tokenizer.START_TAG_TOKEN] = startTagInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.END_TAG_TOKEN] = endTagInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TABLE_BODY_MODE] = Object.create(null);
_[IN_TABLE_BODY_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_TABLE_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_TABLE_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_TABLE_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TABLE_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TABLE_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTableBody;
_[IN_TABLE_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTableBody;
_[IN_TABLE_BODY_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_ROW_MODE] = Object.create(null);
_[IN_ROW_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_ROW_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_ROW_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_ROW_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_ROW_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_ROW_MODE][Tokenizer.START_TAG_TOKEN] = startTagInRow;
_[IN_ROW_MODE][Tokenizer.END_TAG_TOKEN] = endTagInRow;
_[IN_ROW_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_CELL_MODE] = Object.create(null);
_[IN_CELL_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_CELL_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_CELL_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_CELL_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_CELL_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_CELL_MODE][Tokenizer.START_TAG_TOKEN] = startTagInCell;
_[IN_CELL_MODE][Tokenizer.END_TAG_TOKEN] = endTagInCell;
_[IN_CELL_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_SELECT_MODE] = Object.create(null);
_[IN_SELECT_MODE][Tokenizer.CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_SELECT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_SELECT_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_SELECT_MODE][Tokenizer.START_TAG_TOKEN] = startTagInSelect;
_[IN_SELECT_MODE][Tokenizer.END_TAG_TOKEN] = endTagInSelect;
_[IN_SELECT_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_SELECT_IN_TABLE_MODE] = Object.create(null);
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInSelectInTable;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInSelectInTable;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TEMPLATE_MODE] = Object.create(null);
_[IN_TEMPLATE_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_TEMPLATE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_TEMPLATE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_TEMPLATE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TEMPLATE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TEMPLATE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTemplate;
_[IN_TEMPLATE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTemplate;
_[IN_TEMPLATE_MODE][Tokenizer.EOF_TOKEN] = eofInTemplate;

_[AFTER_BODY_MODE] = Object.create(null);
_[AFTER_BODY_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterBody;
_[AFTER_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToRootHtmlElement;
_[AFTER_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterBody;
_[AFTER_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterBody;
_[AFTER_BODY_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[IN_FRAMESET_MODE] = Object.create(null);
_[IN_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagInFrameset;
_[IN_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = endTagInFrameset;
_[IN_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_FRAMESET_MODE] = Object.create(null);
_[AFTER_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[AFTER_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[AFTER_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[AFTER_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterFrameset;
_[AFTER_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterFrameset;
_[AFTER_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_AFTER_BODY_MODE] = Object.create(null);
_[AFTER_AFTER_BODY_MODE][Tokenizer.CHARACTER_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToDocument;
_[AFTER_AFTER_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_AFTER_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.END_TAG_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_AFTER_FRAMESET_MODE] = Object.create(null);
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToDocument;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterAfterFrameset;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;


//Parser
var Parser = module.exports = function (options) {
    this.options = mergeOptions(DEFAULT_OPTIONS, options);

    this.treeAdapter = this.options.treeAdapter;
    this.pendingScript = null;

    if (this.options.locationInfo)
        new LocationInfoParserMixin(this);
};

// API
Parser.prototype.parse = function (html) {
    var document = this.treeAdapter.createDocument();

    this._bootstrap(document, null);
    this.tokenizer.write(html, true);
    this._runParsingLoop(null);

    return document;
};

Parser.prototype.parseFragment = function (html, fragmentContext) {
    //NOTE: use <template> element as a fragment context if context element was not provided,
    //so we will parse in "forgiving" manner
    if (!fragmentContext)
        fragmentContext = this.treeAdapter.createElement($.TEMPLATE, NS.HTML, []);

    //NOTE: create fake element which will be used as 'document' for fragment parsing.
    //This is important for jsdom there 'document' can't be recreated, therefore
    //fragment parsing causes messing of the main `document`.
    var documentMock = this.treeAdapter.createElement('documentmock', NS.HTML, []);

    this._bootstrap(documentMock, fragmentContext);

    if (this.treeAdapter.getTagName(fragmentContext) === $.TEMPLATE)
        this._pushTmplInsertionMode(IN_TEMPLATE_MODE);

    this._initTokenizerForFragmentParsing();
    this._insertFakeRootElement();
    this._resetInsertionMode();
    this._findFormInFragmentContext();
    this.tokenizer.write(html, true);
    this._runParsingLoop(null);

    var rootElement = this.treeAdapter.getFirstChild(documentMock),
        fragment = this.treeAdapter.createDocumentFragment();

    this._adoptNodes(rootElement, fragment);

    return fragment;
};

//Bootstrap parser
Parser.prototype._bootstrap = function (document, fragmentContext) {
    this.tokenizer = new Tokenizer(this.options);

    this.stopped = false;

    this.insertionMode = INITIAL_MODE;
    this.originalInsertionMode = '';

    this.document = document;
    this.fragmentContext = fragmentContext;

    this.headElement = null;
    this.formElement = null;

    this.openElements = new OpenElementStack(this.document, this.treeAdapter);
    this.activeFormattingElements = new FormattingElementList(this.treeAdapter);

    this.tmplInsertionModeStack = [];
    this.tmplInsertionModeStackTop = -1;
    this.currentTmplInsertionMode = null;

    this.pendingCharacterTokens = [];
    this.hasNonWhitespacePendingCharacterToken = false;

    this.framesetOk = true;
    this.skipNextNewLine = false;
    this.fosterParentingEnabled = false;
};

//Parsing loop
Parser.prototype._runParsingLoop  = function (scriptHandler) {
    while (!this.stopped) {
        this._setupTokenizerCDATAMode();

        var token = this.tokenizer.getNextToken();

        if (token.type === Tokenizer.HIBERNATION_TOKEN)
            break;

        if (this.skipNextNewLine) {
            this.skipNextNewLine = false;

            if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
                if (token.chars.length === 1)
                    continue;

                token.chars = token.chars.substr(1);
            }
        }

        this._processInputToken(token);

        if (scriptHandler && this.pendingScript)
            break;
    }
};

Parser.prototype.runParsingLoopForCurrentChunk = function (writeCallback, scriptHandler) {
    this._runParsingLoop(scriptHandler);

    if (scriptHandler && this.pendingScript) {
        var script = this.pendingScript;

        this.pendingScript = null;

        scriptHandler(script);

        return;
    }

    if (writeCallback)
        writeCallback();
};

//Text parsing
Parser.prototype._setupTokenizerCDATAMode = function () {
    var current = this._getAdjustedCurrentElement();

    this.tokenizer.allowCDATA = current && current !== this.document &&
                                this.treeAdapter.getNamespaceURI(current) !== NS.HTML && !this._isIntegrationPoint(current);
};

Parser.prototype._switchToTextParsing = function (currentToken, nextTokenizerState) {
    this._insertElement(currentToken, NS.HTML);
    this.tokenizer.state = nextTokenizerState;
    this.originalInsertionMode = this.insertionMode;
    this.insertionMode = TEXT_MODE;
};

Parser.prototype.switchToPlaintextParsing = function () {
    this.insertionMode = TEXT_MODE;
    this.originalInsertionMode = IN_BODY_MODE;
    this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
};

//Fragment parsing
Parser.prototype._getAdjustedCurrentElement = function () {
    return this.openElements.stackTop === 0 && this.fragmentContext ?
        this.fragmentContext :
        this.openElements.current;
};

Parser.prototype._findFormInFragmentContext = function () {
    var node = this.fragmentContext;

    do {
        if (this.treeAdapter.getTagName(node) === $.FORM) {
            this.formElement = node;
            break;
        }

        node = this.treeAdapter.getParentNode(node);
    } while (node);
};

Parser.prototype._initTokenizerForFragmentParsing = function () {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === NS.HTML) {
        var tn = this.treeAdapter.getTagName(this.fragmentContext);

        if (tn === $.TITLE || tn === $.TEXTAREA)
            this.tokenizer.state = Tokenizer.MODE.RCDATA;

        else if (tn === $.STYLE || tn === $.XMP || tn === $.IFRAME ||
                 tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT)
            this.tokenizer.state = Tokenizer.MODE.RAWTEXT;

        else if (tn === $.SCRIPT)
            this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;

        else if (tn === $.PLAINTEXT)
            this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
    }
};

//Tree mutation
Parser.prototype._setDocumentType = function (token) {
    this.treeAdapter.setDocumentType(this.document, token.name, token.publicId, token.systemId);
};

Parser.prototype._attachElementToTree = function (element) {
    if (this._shouldFosterParentOnInsertion())
        this._fosterParentElement(element);

    else {
        var parent = this.openElements.currentTmplContent || this.openElements.current;

        this.treeAdapter.appendChild(parent, element);
    }
};

Parser.prototype._appendElement = function (token, namespaceURI) {
    var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

    this._attachElementToTree(element);
};

Parser.prototype._insertElement = function (token, namespaceURI) {
    var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

    this._attachElementToTree(element);
    this.openElements.push(element);
};

Parser.prototype._insertFakeElement = function (tagName) {
    var element = this.treeAdapter.createElement(tagName, NS.HTML, []);

    this._attachElementToTree(element);
    this.openElements.push(element);
};

Parser.prototype._insertTemplate = function (token) {
    var tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs),
        content = this.treeAdapter.createDocumentFragment();

    this.treeAdapter.setTemplateContent(tmpl, content);
    this._attachElementToTree(tmpl);
    this.openElements.push(tmpl);
};

Parser.prototype._insertFakeRootElement = function () {
    var element = this.treeAdapter.createElement($.HTML, NS.HTML, []);

    this.treeAdapter.appendChild(this.openElements.current, element);
    this.openElements.push(element);
};

Parser.prototype._appendCommentNode = function (token, parent) {
    var commentNode = this.treeAdapter.createCommentNode(token.data);

    this.treeAdapter.appendChild(parent, commentNode);
};

Parser.prototype._insertCharacters = function (token) {
    if (this._shouldFosterParentOnInsertion())
        this._fosterParentText(token.chars);

    else {
        var parent = this.openElements.currentTmplContent || this.openElements.current;

        this.treeAdapter.insertText(parent, token.chars);
    }
};

Parser.prototype._adoptNodes = function (donor, recipient) {
    while (true) {
        var child = this.treeAdapter.getFirstChild(donor);

        if (!child)
            break;

        this.treeAdapter.detachNode(child);
        this.treeAdapter.appendChild(recipient, child);
    }
};

//Token processing
Parser.prototype._shouldProcessTokenInForeignContent = function (token) {
    var current = this._getAdjustedCurrentElement();

    if (!current || current === this.document)
        return false;

    var ns = this.treeAdapter.getNamespaceURI(current);

    if (ns === NS.HTML)
        return false;

    if (this.treeAdapter.getTagName(current) === $.ANNOTATION_XML && ns === NS.MATHML &&
        token.type === Tokenizer.START_TAG_TOKEN && token.tagName === $.SVG)
        return false;

    var isCharacterToken = token.type === Tokenizer.CHARACTER_TOKEN ||
                           token.type === Tokenizer.NULL_CHARACTER_TOKEN ||
                           token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN,
        isMathMLTextStartTag = token.type === Tokenizer.START_TAG_TOKEN &&
                               token.tagName !== $.MGLYPH &&
                               token.tagName !== $.MALIGNMARK;

    if ((isMathMLTextStartTag || isCharacterToken) && this._isIntegrationPoint(current, NS.MATHML))
        return false;

    if ((token.type === Tokenizer.START_TAG_TOKEN || isCharacterToken) && this._isIntegrationPoint(current, NS.HTML))
        return false;

    return token.type !== Tokenizer.EOF_TOKEN;
};

Parser.prototype._processToken = function (token) {
    _[this.insertionMode][token.type](this, token);
};

Parser.prototype._processTokenInBodyMode = function (token) {
    _[IN_BODY_MODE][token.type](this, token);
};

Parser.prototype._processTokenInForeignContent = function (token) {
    if (token.type === Tokenizer.CHARACTER_TOKEN)
        characterInForeignContent(this, token);

    else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN)
        nullCharacterInForeignContent(this, token);

    else if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN)
        insertCharacters(this, token);

    else if (token.type === Tokenizer.COMMENT_TOKEN)
        appendComment(this, token);

    else if (token.type === Tokenizer.START_TAG_TOKEN)
        startTagInForeignContent(this, token);

    else if (token.type === Tokenizer.END_TAG_TOKEN)
        endTagInForeignContent(this, token);
};

Parser.prototype._processInputToken = function (token) {
    if (this._shouldProcessTokenInForeignContent(token))
        this._processTokenInForeignContent(token);

    else
        this._processToken(token);
};

//Integration points
Parser.prototype._isIntegrationPoint = function (element, foreignNS) {
    var tn = this.treeAdapter.getTagName(element),
        ns = this.treeAdapter.getNamespaceURI(element),
        attrs = this.treeAdapter.getAttrList(element);

    return foreignContent.isIntegrationPoint(tn, ns, attrs, foreignNS);
};

//Active formatting elements reconstruction
Parser.prototype._reconstructActiveFormattingElements = function () {
    var listLength = this.activeFormattingElements.length;

    if (listLength) {
        var unopenIdx = listLength,
            entry = null;

        do {
            unopenIdx--;
            entry = this.activeFormattingElements.entries[unopenIdx];

            if (entry.type === FormattingElementList.MARKER_ENTRY || this.openElements.contains(entry.element)) {
                unopenIdx++;
                break;
            }
        } while (unopenIdx > 0);

        for (var i = unopenIdx; i < listLength; i++) {
            entry = this.activeFormattingElements.entries[i];
            this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
            entry.element = this.openElements.current;
        }
    }
};

//Close elements
Parser.prototype._closeTableCell = function () {
    this.openElements.generateImpliedEndTags();
    this.openElements.popUntilTableCellPopped();
    this.activeFormattingElements.clearToLastMarker();
    this.insertionMode = IN_ROW_MODE;
};

Parser.prototype._closePElement = function () {
    this.openElements.generateImpliedEndTagsWithExclusion($.P);
    this.openElements.popUntilTagNamePopped($.P);
};

//Insertion modes
Parser.prototype._resetInsertionMode = function () {
    for (var i = this.openElements.stackTop, last = false; i >= 0; i--) {
        var element = this.openElements.items[i];

        if (i === 0) {
            last = true;

            if (this.fragmentContext)
                element = this.fragmentContext;
        }

        var tn = this.treeAdapter.getTagName(element),
            newInsertionMode = INSERTION_MODE_RESET_MAP[tn];

        if (newInsertionMode) {
            this.insertionMode = newInsertionMode;
            break;
        }

        else if (!last && (tn === $.TD || tn === $.TH)) {
            this.insertionMode = IN_CELL_MODE;
            break;
        }

        else if (!last && tn === $.HEAD) {
            this.insertionMode = IN_HEAD_MODE;
            break;
        }

        else if (tn === $.SELECT) {
            this._resetInsertionModeForSelect(i);
            break;
        }

        else if (tn === $.TEMPLATE) {
            this.insertionMode = this.currentTmplInsertionMode;
            break;
        }

        else if (tn === $.HTML) {
            this.insertionMode = this.headElement ? AFTER_HEAD_MODE : BEFORE_HEAD_MODE;
            break;
        }

        else if (last) {
            this.insertionMode = IN_BODY_MODE;
            break;
        }
    }
};

Parser.prototype._resetInsertionModeForSelect = function (selectIdx) {
    if (selectIdx > 0) {
        for (var i = selectIdx - 1; i > 0; i--) {
            var ancestor = this.openElements.items[i],
                tn = this.treeAdapter.getTagName(ancestor);

            if (tn === $.TEMPLATE)
                break;

            else if (tn === $.TABLE) {
                this.insertionMode = IN_SELECT_IN_TABLE_MODE;
                return;
            }
        }
    }

    this.insertionMode = IN_SELECT_MODE;
};

Parser.prototype._pushTmplInsertionMode = function (mode) {
    this.tmplInsertionModeStack.push(mode);
    this.tmplInsertionModeStackTop++;
    this.currentTmplInsertionMode = mode;
};

Parser.prototype._popTmplInsertionMode = function () {
    this.tmplInsertionModeStack.pop();
    this.tmplInsertionModeStackTop--;
    this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
};

//Foster parenting
Parser.prototype._isElementCausesFosterParenting = function (element) {
    var tn = this.treeAdapter.getTagName(element);

    return tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR;
};

Parser.prototype._shouldFosterParentOnInsertion = function () {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
};

Parser.prototype._findFosterParentingLocation = function () {
    var location = {
        parent: null,
        beforeElement: null
    };

    for (var i = this.openElements.stackTop; i >= 0; i--) {
        var openElement = this.openElements.items[i],
            tn = this.treeAdapter.getTagName(openElement),
            ns = this.treeAdapter.getNamespaceURI(openElement);

        if (tn === $.TEMPLATE && ns === NS.HTML) {
            location.parent = this.treeAdapter.getTemplateContent(openElement);
            break;
        }

        else if (tn === $.TABLE) {
            location.parent = this.treeAdapter.getParentNode(openElement);

            if (location.parent)
                location.beforeElement = openElement;
            else
                location.parent = this.openElements.items[i - 1];

            break;
        }
    }

    if (!location.parent)
        location.parent = this.openElements.items[0];

    return location;
};

Parser.prototype._fosterParentElement = function (element) {
    var location = this._findFosterParentingLocation();

    if (location.beforeElement)
        this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
    else
        this.treeAdapter.appendChild(location.parent, element);
};

Parser.prototype._fosterParentText = function (chars) {
    var location = this._findFosterParentingLocation();

    if (location.beforeElement)
        this.treeAdapter.insertTextBefore(location.parent, chars, location.beforeElement);
    else
        this.treeAdapter.insertText(location.parent, chars);
};

//Special elements
Parser.prototype._isSpecialElement = function (element) {
    var tn = this.treeAdapter.getTagName(element),
        ns = this.treeAdapter.getNamespaceURI(element);

    return HTML.SPECIAL_ELEMENTS[ns][tn];
};

//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------

//Steps 5-8 of the algorithm
function aaObtainFormattingElementEntry(p, token) {
    var formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);

    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        }

        else if (!p.openElements.hasInScope(token.tagName))
            formattingElementEntry = null;
    }

    else
        genericEndTagInBody(p, token);

    return formattingElementEntry;
}

//Steps 9 and 10 of the algorithm
function aaObtainFurthestBlock(p, formattingElementEntry) {
    var furthestBlock = null;

    for (var i = p.openElements.stackTop; i >= 0; i--) {
        var element = p.openElements.items[i];

        if (element === formattingElementEntry.element)
            break;

        if (p._isSpecialElement(element))
            furthestBlock = element;
    }

    if (!furthestBlock) {
        p.openElements.popUntilElementPopped(formattingElementEntry.element);
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }

    return furthestBlock;
}

//Step 13 of the algorithm
function aaInnerLoop(p, furthestBlock, formattingElement) {
    var lastElement = furthestBlock,
        nextElement = p.openElements.getCommonAncestor(furthestBlock);

    for (var i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
        //NOTE: store next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);

        var elementEntry = p.activeFormattingElements.getElementEntry(element),
            counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER,
            shouldRemoveFromOpenElements = !elementEntry || counterOverflow;

        if (shouldRemoveFromOpenElements) {
            if (counterOverflow)
                p.activeFormattingElements.removeEntry(elementEntry);

            p.openElements.remove(element);
        }

        else {
            element = aaRecreateElementFromEntry(p, elementEntry);

            if (lastElement === furthestBlock)
                p.activeFormattingElements.bookmark = elementEntry;

            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }

    return lastElement;
}

//Step 13.7 of the algorithm
function aaRecreateElementFromEntry(p, elementEntry) {
    var ns = p.treeAdapter.getNamespaceURI(elementEntry.element),
        newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);

    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;

    return newElement;
}

//Step 14 of the algorithm
function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    if (p._isElementCausesFosterParenting(commonAncestor))
        p._fosterParentElement(lastElement);

    else {
        var tn = p.treeAdapter.getTagName(commonAncestor),
            ns = p.treeAdapter.getNamespaceURI(commonAncestor);

        if (tn === $.TEMPLATE && ns === NS.HTML)
            commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);

        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}

//Steps 15-19 of the algorithm
function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    var ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element),
        token = formattingElementEntry.token,
        newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);

    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);

    p.activeFormattingElements.insertElementAfterBookmark(newElement, formattingElementEntry.token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);

    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement);
}

//Algorithm entry point
function callAdoptionAgency(p, token) {
    var formattingElementEntry;

    for (var i = 0; i < AA_OUTER_LOOP_ITER; i++) {
        formattingElementEntry = aaObtainFormattingElementEntry(p, token, formattingElementEntry);

        if (!formattingElementEntry)
            break;

        var furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);

        if (!furthestBlock)
            break;

        p.activeFormattingElements.bookmark = formattingElementEntry;

        var lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element),
            commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);

        p.treeAdapter.detachNode(lastElement);
        aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}


//Generic token handlers
//------------------------------------------------------------------
function ignoreToken() {
    //NOTE: do nothing =)
}

function appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContent || p.openElements.current);
}

function appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}

function appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}

function insertCharacters(p, token) {
    p._insertCharacters(token);
}

function stopParsing(p) {
    p.stopped = true;
}

//12.2.5.4.1 The "initial" insertion mode
//------------------------------------------------------------------
function doctypeInInitialMode(p, token) {
    p._setDocumentType(token);

    var mode = token.forceQuirks ?
        HTML.DOCUMENT_MODE.QUIRKS :
        doctype.getDocumentMode(token.name, token.publicId, token.systemId);

    p.treeAdapter.setDocumentMode(p.document, mode);

    p.insertionMode = BEFORE_HTML_MODE;
}

function tokenInInitialMode(p, token) {
    p.treeAdapter.setDocumentMode(p.document, HTML.DOCUMENT_MODE.QUIRKS);
    p.insertionMode = BEFORE_HTML_MODE;
    p._processToken(token);
}


//12.2.5.4.2 The "before html" insertion mode
//------------------------------------------------------------------
function startTagBeforeHtml(p, token) {
    if (token.tagName === $.HTML) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = BEFORE_HEAD_MODE;
    }

    else
        tokenBeforeHtml(p, token);
}

function endTagBeforeHtml(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML || tn === $.HEAD || tn === $.BODY || tn === $.BR)
        tokenBeforeHtml(p, token);
}

function tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = BEFORE_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.3 The "before head" insertion mode
//------------------------------------------------------------------
function startTagBeforeHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.HEAD) {
        p._insertElement(token, NS.HTML);
        p.headElement = p.openElements.current;
        p.insertionMode = IN_HEAD_MODE;
    }

    else
        tokenBeforeHead(p, token);
}

function endTagBeforeHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HEAD || tn === $.BODY || tn === $.HTML || tn === $.BR)
        tokenBeforeHead(p, token);
}

function tokenBeforeHead(p, token) {
    p._insertFakeElement($.HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = IN_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.4 The "in head" insertion mode
//------------------------------------------------------------------
function startTagInHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META)
        p._appendElement(token, NS.HTML);

    else if (tn === $.TITLE)
        p._switchToTextParsing(token, Tokenizer.MODE.RCDATA);

    //NOTE: here we assume that we always act as an interactive user agent with enabled scripting, so we parse
    //<noscript> as a rawtext.
    else if (tn === $.NOSCRIPT || tn === $.NOFRAMES || tn === $.STYLE)
        p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);

    else if (tn === $.SCRIPT)
        p._switchToTextParsing(token, Tokenizer.MODE.SCRIPT_DATA);

    else if (tn === $.TEMPLATE) {
        p._insertTemplate(token, NS.HTML);
        p.activeFormattingElements.insertMarker();
        p.framesetOk = false;
        p.insertionMode = IN_TEMPLATE_MODE;
        p._pushTmplInsertionMode(IN_TEMPLATE_MODE);
    }

    else if (tn !== $.HEAD)
        tokenInHead(p, token);
}

function endTagInHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HEAD) {
        p.openElements.pop();
        p.insertionMode = AFTER_HEAD_MODE;
    }

    else if (tn === $.BODY || tn === $.BR || tn === $.HTML)
        tokenInHead(p, token);

    else if (tn === $.TEMPLATE && p.openElements.tmplCount > 0) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
    }
}

function tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = AFTER_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.6 The "after head" insertion mode
//------------------------------------------------------------------
function startTagAfterHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.BODY) {
        p._insertElement(token, NS.HTML);
        p.framesetOk = false;
        p.insertionMode = IN_BODY_MODE;
    }

    else if (tn === $.FRAMESET) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    }

    else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META ||
             tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE) {
        p.openElements.push(p.headElement);
        startTagInHead(p, token);
        p.openElements.remove(p.headElement);
    }

    else if (tn !== $.HEAD)
        tokenAfterHead(p, token);
}

function endTagAfterHead(p, token) {
    var tn = token.tagName;

    if (tn === $.BODY || tn === $.HTML || tn === $.BR)
        tokenAfterHead(p, token);

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);
}

function tokenAfterHead(p, token) {
    p._insertFakeElement($.BODY);
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}


//12.2.5.4.7 The "in body" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}

function characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}

function htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0)
        p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
}

function bodyStartTagInBody(p, token) {
    var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}

function framesetStartTagInBody(p, token) {
    var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    }
}

function addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
}

function numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    var tn = p.openElements.currentTagName;

    if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
        p.openElements.pop();

    p._insertElement(token, NS.HTML);
}

function preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}

function formStartTagInBody(p, token) {
    var inTemplate = p.openElements.tmplCount > 0;

    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope($.P))
            p._closePElement();

        p._insertElement(token, NS.HTML);

        if (!inTemplate)
            p.formElement = p.openElements.current;
    }
}

function listItemStartTagInBody(p, token) {
    p.framesetOk = false;

    var tn = token.tagName;

    for (var i = p.openElements.stackTop; i >= 0; i--) {
        var element = p.openElements.items[i],
            elementTn = p.treeAdapter.getTagName(element),
            closeTn = null;

        if (tn === $.LI && elementTn === $.LI)
            closeTn = $.LI;

        else if ((tn === $.DD || tn === $.DT) && (elementTn === $.DD || elementTn === $.DT))
            closeTn = elementTn;

        if (closeTn) {
            p.openElements.generateImpliedEndTagsWithExclusion(closeTn);
            p.openElements.popUntilTagNamePopped(closeTn);
            break;
        }

        if (elementTn !== $.ADDRESS && elementTn !== $.DIV && elementTn !== $.P && p._isSpecialElement(element))
            break;
    }

    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
}

function plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    p.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
}

function buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.BUTTON);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
}

function aStartTagInBody(p, token) {
    var activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName($.A);

    if (activeElementEntry) {
        callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    if (p.openElements.hasInScope($.NOBR)) {
        callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }

    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}

function tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== HTML.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    p.insertionMode = IN_TABLE_MODE;
}

function areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
}

function inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);

    var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (!inputType || inputType.toLowerCase() !== HIDDEN_INPUT_TYPE)
        p.framesetOk = false;

}

function paramStartTagInBody(p, token) {
    p._appendElement(token, NS.HTML);
}

function hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
}

function imageStartTagInBody(p, token) {
    token.tagName = $.IMG;
    areaStartTagInBody(p, token);
}

function textareaStartTagInBody(p, token) {
    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = Tokenizer.MODE.RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = TEXT_MODE;
}

function xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

//NOTE: here we assume that we always act as an user agent with enabled plugins, so we parse
//<noembed> as a rawtext.
function noembedStartTagInBody(p, token) {
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;

    if (p.insertionMode === IN_TABLE_MODE ||
        p.insertionMode === IN_CAPTION_MODE ||
        p.insertionMode === IN_TABLE_BODY_MODE ||
        p.insertionMode === IN_ROW_MODE ||
        p.insertionMode === IN_CELL_MODE)

        p.insertionMode = IN_SELECT_IN_TABLE_MODE;

    else
        p.insertionMode = IN_SELECT_MODE;
}

function optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.OPTION)
        p.openElements.pop();

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

function rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY))
        p.openElements.generateImpliedEndTags();

    p._insertElement(token, NS.HTML);
}

function rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY))
        p.openElements.generateImpliedEndTagsWithExclusion($.RTC);

    p._insertElement(token, NS.HTML);
}

function menuitemStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    // TODO needs clarification, see https://github.com/whatwg/html/pull/907/files#r73505877
    p._reconstructActiveFormattingElements();

    p._insertElement(token, NS.HTML);
}

function menuStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    p._insertElement(token, NS.HTML);
}

function mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenMathMLAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing)
        p._appendElement(token, NS.MATHML);
    else
        p._insertElement(token, NS.MATHML);
}

function svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenSVGAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing)
        p._appendElement(token, NS.SVG);
    else
        p._insertElement(token, NS.SVG);
}

function genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function startTagInBody(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.I || tn === $.S || tn === $.B || tn === $.U)
                bStartTagInBody(p, token);

            else if (tn === $.P)
                addressStartTagInBody(p, token);

            else if (tn === $.A)
                aStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 2:
            if (tn === $.DL || tn === $.OL || tn === $.UL)
                addressStartTagInBody(p, token);

            else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
                numberedHeaderStartTagInBody(p, token);

            else if (tn === $.LI || tn === $.DD || tn === $.DT)
                listItemStartTagInBody(p, token);

            else if (tn === $.EM || tn === $.TT)
                bStartTagInBody(p, token);

            else if (tn === $.BR)
                areaStartTagInBody(p, token);

            else if (tn === $.HR)
                hrStartTagInBody(p, token);

            else if (tn === $.RB)
                rbStartTagInBody(p, token);

            else if (tn === $.RT || tn === $.RP)
                rtStartTagInBody(p, token);

            else if (tn !== $.TH && tn !== $.TD && tn !== $.TR)
                genericStartTagInBody(p, token);

            break;

        case 3:
            if (tn === $.DIV || tn === $.DIR || tn === $.NAV)
                addressStartTagInBody(p, token);

            else if (tn === $.PRE)
                preStartTagInBody(p, token);

            else if (tn === $.BIG)
                bStartTagInBody(p, token);

            else if (tn === $.IMG || tn === $.WBR)
                areaStartTagInBody(p, token);

            else if (tn === $.XMP)
                xmpStartTagInBody(p, token);

            else if (tn === $.SVG)
                svgStartTagInBody(p, token);

            else if (tn === $.RTC)
                rbStartTagInBody(p, token);

            else if (tn !== $.COL)
                genericStartTagInBody(p, token);

            break;

        case 4:
            if (tn === $.HTML)
                htmlStartTagInBody(p, token);

            else if (tn === $.BASE || tn === $.LINK || tn === $.META)
                startTagInHead(p, token);

            else if (tn === $.BODY)
                bodyStartTagInBody(p, token);

            else if (tn === $.MAIN)
                addressStartTagInBody(p, token);

            else if (tn === $.FORM)
                formStartTagInBody(p, token);

            else if (tn === $.CODE || tn === $.FONT)
                bStartTagInBody(p, token);

            else if (tn === $.NOBR)
                nobrStartTagInBody(p, token);

            else if (tn === $.AREA)
                areaStartTagInBody(p, token);

            else if (tn === $.MATH)
                mathStartTagInBody(p, token);

            else if (tn === $.MENU)
                menuStartTagInBody(p, token);

            else if (tn !== $.HEAD)
                genericStartTagInBody(p, token);

            break;

        case 5:
            if (tn === $.STYLE || tn === $.TITLE)
                startTagInHead(p, token);

            else if (tn === $.ASIDE)
                addressStartTagInBody(p, token);

            else if (tn === $.SMALL)
                bStartTagInBody(p, token);

            else if (tn === $.TABLE)
                tableStartTagInBody(p, token);

            else if (tn === $.EMBED)
                areaStartTagInBody(p, token);

            else if (tn === $.INPUT)
                inputStartTagInBody(p, token);

            else if (tn === $.PARAM || tn === $.TRACK)
                paramStartTagInBody(p, token);

            else if (tn === $.IMAGE)
                imageStartTagInBody(p, token);

            else if (tn !== $.FRAME && tn !== $.TBODY && tn !== $.TFOOT && tn !== $.THEAD)
                genericStartTagInBody(p, token);

            break;

        case 6:
            if (tn === $.SCRIPT)
                startTagInHead(p, token);

            else if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP)
                addressStartTagInBody(p, token);

            else if (tn === $.BUTTON)
                buttonStartTagInBody(p, token);

            else if (tn === $.STRIKE || tn === $.STRONG)
                bStartTagInBody(p, token);

            else if (tn === $.APPLET || tn === $.OBJECT)
                appletStartTagInBody(p, token);

            else if (tn === $.KEYGEN)
                areaStartTagInBody(p, token);

            else if (tn === $.SOURCE)
                paramStartTagInBody(p, token);

            else if (tn === $.IFRAME)
                iframeStartTagInBody(p, token);

            else if (tn === $.SELECT)
                selectStartTagInBody(p, token);

            else if (tn === $.OPTION)
                optgroupStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 7:
            if (tn === $.BGSOUND)
                startTagInHead(p, token);

            else if (tn === $.DETAILS || tn === $.ADDRESS || tn === $.ARTICLE || tn === $.SECTION || tn === $.SUMMARY)
                addressStartTagInBody(p, token);

            else if (tn === $.LISTING)
                preStartTagInBody(p, token);

            else if (tn === $.MARQUEE)
                appletStartTagInBody(p, token);

            else if (tn === $.NOEMBED)
                noembedStartTagInBody(p, token);

            else if (tn !== $.CAPTION)
                genericStartTagInBody(p, token);

            break;

        case 8:
            if (tn === $.BASEFONT)
                startTagInHead(p, token);

            else if (tn === $.MENUITEM)
                menuitemStartTagInBody(p, token);

            else if (tn === $.FRAMESET)
                framesetStartTagInBody(p, token);

            else if (tn === $.FIELDSET)
                addressStartTagInBody(p, token);

            else if (tn === $.TEXTAREA)
                textareaStartTagInBody(p, token);

            else if (tn === $.TEMPLATE)
                startTagInHead(p, token);

            else if (tn === $.NOSCRIPT)
                noembedStartTagInBody(p, token);

            else if (tn === $.OPTGROUP)
                optgroupStartTagInBody(p, token);

            else if (tn !== $.COLGROUP)
                genericStartTagInBody(p, token);

            break;

        case 9:
            if (tn === $.PLAINTEXT)
                plaintextStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION)
                addressStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        default:
            genericStartTagInBody(p, token);
    }
}

function bodyEndTagInBody(p) {
    if (p.openElements.hasInScope($.BODY))
        p.insertionMode = AFTER_BODY_MODE;
}

function htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope($.BODY)) {
        p.insertionMode = AFTER_BODY_MODE;
        p._processToken(token);
    }
}

function addressEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function formEndTagInBody(p) {
    var inTemplate = p.openElements.tmplCount > 0,
        formElement = p.formElement;

    if (!inTemplate)
        p.formElement = null;

    if ((formElement || inTemplate) && p.openElements.hasInScope($.FORM)) {
        p.openElements.generateImpliedEndTags();

        if (inTemplate)
            p.openElements.popUntilTagNamePopped($.FORM);

        else
            p.openElements.remove(formElement);
    }
}

function pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope($.P))
        p._insertFakeElement($.P);

    p._closePElement();
}

function liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope($.LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion($.LI);
        p.openElements.popUntilTagNamePopped($.LI);
    }
}

function ddEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}

function appletEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}

function brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement($.BR);
    p.openElements.pop();
    p.framesetOk = false;
}

function genericEndTagInBody(p, token) {
    var tn = token.tagName;

    for (var i = p.openElements.stackTop; i > 0; i--) {
        var element = p.openElements.items[i];

        if (p.treeAdapter.getTagName(element) === tn) {
            p.openElements.generateImpliedEndTagsWithExclusion(tn);
            p.openElements.popUntilElementPopped(element);
            break;
        }

        if (p._isSpecialElement(element))
            break;
    }
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function endTagInBody(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.A || tn === $.B || tn === $.I || tn === $.S || tn === $.U)
                callAdoptionAgency(p, token);

            else if (tn === $.P)
                pEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 2:
            if (tn === $.DL || tn === $.UL || tn === $.OL)
                addressEndTagInBody(p, token);

            else if (tn === $.LI)
                liEndTagInBody(p, token);

            else if (tn === $.DD || tn === $.DT)
                ddEndTagInBody(p, token);

            else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
                numberedHeaderEndTagInBody(p, token);

            else if (tn === $.BR)
                brEndTagInBody(p, token);

            else if (tn === $.EM || tn === $.TT)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 3:
            if (tn === $.BIG)
                callAdoptionAgency(p, token);

            else if (tn === $.DIR || tn === $.DIV || tn === $.NAV)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 4:
            if (tn === $.BODY)
                bodyEndTagInBody(p, token);

            else if (tn === $.HTML)
                htmlEndTagInBody(p, token);

            else if (tn === $.FORM)
                formEndTagInBody(p, token);

            else if (tn === $.CODE || tn === $.FONT || tn === $.NOBR)
                callAdoptionAgency(p, token);

            else if (tn === $.MAIN || tn === $.MENU)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 5:
            if (tn === $.ASIDE)
                addressEndTagInBody(p, token);

            else if (tn === $.SMALL)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 6:
            if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP)
                addressEndTagInBody(p, token);

            else if (tn === $.APPLET || tn === $.OBJECT)
                appletEndTagInBody(p, token);

            else if (tn === $.STRIKE || tn === $.STRONG)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 7:
            if (tn === $.ADDRESS || tn === $.ARTICLE || tn === $.DETAILS || tn === $.SECTION || tn === $.SUMMARY)
                addressEndTagInBody(p, token);

            else if (tn === $.MARQUEE)
                appletEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 8:
            if (tn === $.FIELDSET)
                addressEndTagInBody(p, token);

            else if (tn === $.TEMPLATE)
                endTagInHead(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        default :
            genericEndTagInBody(p, token);
    }
}

function eofInBody(p, token) {
    if (p.tmplInsertionModeStackTop > -1)
        eofInTemplate(p, token);

    else
        p.stopped = true;
}

//12.2.5.4.8 The "text" insertion mode
//------------------------------------------------------------------
function endTagInText(p, token) {
    if (token.tagName === $.SCRIPT)
        p.pendingScript = p.openElements.current;

    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}


function eofInText(p, token) {
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}


//12.2.5.4.9 The "in table" insertion mode
//------------------------------------------------------------------
function characterInTable(p, token) {
    var curTn = p.openElements.currentTagName;

    if (curTn === $.TABLE || curTn === $.TBODY || curTn === $.TFOOT || curTn === $.THEAD || curTn === $.TR) {
        p.pendingCharacterTokens = [];
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = IN_TABLE_TEXT_MODE;
        p._processToken(token);
    }

    else
        tokenInTable(p, token);
}

function captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_CAPTION_MODE;
}

function colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
}

function colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.COLGROUP);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
    p._processToken(token);
}

function tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_TABLE_BODY_MODE;
}

function tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.TBODY);
    p.insertionMode = IN_TABLE_BODY_MODE;
    p._processToken(token);
}

function tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope($.TABLE)) {
        p.openElements.popUntilTagNamePopped($.TABLE);
        p._resetInsertionMode();
        p._processToken(token);
    }
}

function inputStartTagInTable(p, token) {
    var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (inputType && inputType.toLowerCase() === HIDDEN_INPUT_TYPE)
        p._appendElement(token, NS.HTML);

    else
        tokenInTable(p, token);
}

function formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, NS.HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}

function startTagInTable(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH || tn === $.TR)
                tdStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 3:
            if (tn === $.COL)
                colStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 4:
            if (tn === $.FORM)
                formStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 5:
            if (tn === $.TABLE)
                tableStartTagInTable(p, token);

            else if (tn === $.STYLE)
                startTagInHead(p, token);

            else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD)
                tbodyStartTagInTable(p, token);

            else if (tn === $.INPUT)
                inputStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 6:
            if (tn === $.SCRIPT)
                startTagInHead(p, token);

            else
                tokenInTable(p, token);

            break;

        case 7:
            if (tn === $.CAPTION)
                captionStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 8:
            if (tn === $.COLGROUP)
                colgroupStartTagInTable(p, token);

            else if (tn === $.TEMPLATE)
                startTagInHead(p, token);

            else
                tokenInTable(p, token);

            break;

        default:
            tokenInTable(p, token);
    }

}

function endTagInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TABLE)) {
            p.openElements.popUntilTagNamePopped($.TABLE);
            p._resetInsertionMode();
        }
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML &&
             tn !== $.TBODY && tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR)
        tokenInTable(p, token);
}

function tokenInTable(p, token) {
    var savedFosterParentingState = p.fosterParentingEnabled;

    p.fosterParentingEnabled = true;
    p._processTokenInBodyMode(token);
    p.fosterParentingEnabled = savedFosterParentingState;
}


//12.2.5.4.10 The "in table text" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}

function characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}

function tokenInTableText(p, token) {
    var i = 0;

    if (p.hasNonWhitespacePendingCharacterToken) {
        for (; i < p.pendingCharacterTokens.length; i++)
            tokenInTable(p, p.pendingCharacterTokens[i]);
    }

    else {
        for (; i < p.pendingCharacterTokens.length; i++)
            p._insertCharacters(p.pendingCharacterTokens[i]);
    }

    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}


//12.2.5.4.11 The "in caption" insertion mode
//------------------------------------------------------------------
function startTagInCaption(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
        tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInBody(p, token);
}

function endTagInCaption(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;

            if (tn === $.TABLE)
                p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML && tn !== $.TBODY &&
             tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR)
        endTagInBody(p, token);
}


//12.2.5.4.12 The "in column group" insertion mode
//------------------------------------------------------------------
function startTagInColumnGroup(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.COL)
        p._appendElement(token, NS.HTML);

    else if (tn === $.TEMPLATE)
        startTagInHead(p, token);

    else
        tokenInColumnGroup(p, token);
}

function endTagInColumnGroup(p, token) {
    var tn = token.tagName;

    if (tn === $.COLGROUP) {
        if (p.openElements.currentTagName === $.COLGROUP) {
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);

    else if (tn !== $.COL)
        tokenInColumnGroup(p, token);
}

function tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagName === $.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = IN_TABLE_MODE;
        p._processToken(token);
    }
}

//12.2.5.4.13 The "in table body" insertion mode
//------------------------------------------------------------------
function startTagInTableBody(p, token) {
    var tn = token.tagName;

    if (tn === $.TR) {
        p.openElements.clearBackToTableBodyContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_ROW_MODE;
    }

    else if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableBodyContext();
        p._insertFakeElement($.TR);
        p.insertionMode = IN_ROW_MODE;
        p._processToken(token);
    }

    else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP ||
             tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {

        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInTable(p, token);
}

function endTagInTableBody(p, token) {
    var tn = token.tagName;

    if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    }

    else if (tn === $.TABLE) {
        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP ||
             tn !== $.HTML && tn !== $.TD && tn !== $.TH && tn !== $.TR)
        endTagInTable(p, token);
}

//12.2.5.4.14 The "in row" insertion mode
//------------------------------------------------------------------
function startTagInRow(p, token) {
    var tn = token.tagName;

    if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableRowContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_CELL_MODE;
        p.activeFormattingElements.insertMarker();
    }

    else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
             tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInTable(p, token);
}

function endTagInRow(p, token) {
    var tn = token.tagName;

    if (tn === $.TR) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
        }
    }

    else if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn) || p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP ||
             tn !== $.HTML && tn !== $.TD && tn !== $.TH)
        endTagInTable(p, token);
}


//12.2.5.4.15 The "in cell" insertion mode
//------------------------------------------------------------------
function startTagInCell(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
        tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {

        if (p.openElements.hasInTableScope($.TD) || p.openElements.hasInTableScope($.TH)) {
            p._closeTableCell();
            p._processToken(token);
        }
    }

    else
        startTagInBody(p, token);
}

function endTagInCell(p, token) {
    var tn = token.tagName;

    if (tn === $.TD || tn === $.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped(tn);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_ROW_MODE;
        }
    }

    else if (tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope(tn)) {
            p._closeTableCell();
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML)
        endTagInBody(p, token);
}

//12.2.5.4.16 The "in select" insertion mode
//------------------------------------------------------------------
function startTagInSelect(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();

        p._insertElement(token, NS.HTML);
    }

    else if (tn === $.OPTGROUP) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();

        if (p.openElements.currentTagName === $.OPTGROUP)
            p.openElements.pop();

        p._insertElement(token, NS.HTML);
    }

    else if (tn === $.INPUT || tn === $.KEYGEN || tn === $.TEXTAREA || tn === $.SELECT) {
        if (p.openElements.hasInSelectScope($.SELECT)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();

            if (tn !== $.SELECT)
                p._processToken(token);
        }
    }

    else if (tn === $.SCRIPT || tn === $.TEMPLATE)
        startTagInHead(p, token);
}

function endTagInSelect(p, token) {
    var tn = token.tagName;

    if (tn === $.OPTGROUP) {
        var prevOpenElement = p.openElements.items[p.openElements.stackTop - 1],
            prevOpenElementTn = prevOpenElement && p.treeAdapter.getTagName(prevOpenElement);

        if (p.openElements.currentTagName === $.OPTION && prevOpenElementTn === $.OPTGROUP)
            p.openElements.pop();

        if (p.openElements.currentTagName === $.OPTGROUP)
            p.openElements.pop();
    }

    else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();
    }

    else if (tn === $.SELECT && p.openElements.hasInSelectScope($.SELECT)) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);
}

//12.2.5.4.17 The "in select in table" insertion mode
//------------------------------------------------------------------
function startTagInSelectInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT ||
        tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
        p._processToken(token);
    }

    else
        startTagInSelect(p, token);
}

function endTagInSelectInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT ||
        tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();
            p._processToken(token);
        }
    }

    else
        endTagInSelect(p, token);
}

//12.2.5.4.18 The "in template" insertion mode
//------------------------------------------------------------------
function startTagInTemplate(p, token) {
    var tn = token.tagName;

    if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META ||
        tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE)
        startTagInHead(p, token);

    else {
        var newInsertionMode = TEMPLATE_INSERTION_MODE_SWITCH_MAP[tn] || IN_BODY_MODE;

        p._popTmplInsertionMode();
        p._pushTmplInsertionMode(newInsertionMode);
        p.insertionMode = newInsertionMode;
        p._processToken(token);
    }
}

function endTagInTemplate(p, token) {
    if (token.tagName === $.TEMPLATE)
        endTagInHead(p, token);
}

function eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
        p._processToken(token);
    }

    else
        p.stopped = true;
}


//12.2.5.4.19 The "after body" insertion mode
//------------------------------------------------------------------
function startTagAfterBody(p, token) {
    if (token.tagName === $.HTML)
        startTagInBody(p, token);

    else
        tokenAfterBody(p, token);
}

function endTagAfterBody(p, token) {
    if (token.tagName === $.HTML) {
        if (!p.fragmentContext)
            p.insertionMode = AFTER_AFTER_BODY_MODE;
    }

    else
        tokenAfterBody(p, token);
}

function tokenAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

//12.2.5.4.20 The "in frameset" insertion mode
//------------------------------------------------------------------
function startTagInFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.FRAMESET)
        p._insertElement(token, NS.HTML);

    else if (tn === $.FRAME)
        p._appendElement(token, NS.HTML);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}

function endTagInFrameset(p, token) {
    if (token.tagName === $.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();

        if (!p.fragmentContext && p.openElements.currentTagName !== $.FRAMESET)
            p.insertionMode = AFTER_FRAMESET_MODE;
    }
}

//12.2.5.4.21 The "after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}

function endTagAfterFrameset(p, token) {
    if (token.tagName === $.HTML)
        p.insertionMode = AFTER_AFTER_FRAMESET_MODE;
}

//12.2.5.4.22 The "after after body" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterBody(p, token) {
    if (token.tagName === $.HTML)
        startTagInBody(p, token);

    else
        tokenAfterAfterBody(p, token);
}

function tokenAfterAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

//12.2.5.4.23 The "after after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}


//12.2.5.5 The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function nullCharacterInForeignContent(p, token) {
    token.chars = UNICODE.REPLACEMENT_CHARACTER;
    p._insertCharacters(token);
}

function characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}

function startTagInForeignContent(p, token) {
    if (foreignContent.causesExit(token) && !p.fragmentContext) {
        while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML && !p._isIntegrationPoint(p.openElements.current))
            p.openElements.pop();

        p._processToken(token);
    }

    else {
        var current = p._getAdjustedCurrentElement(),
            currentNs = p.treeAdapter.getNamespaceURI(current);

        if (currentNs === NS.MATHML)
            foreignContent.adjustTokenMathMLAttrs(token);

        else if (currentNs === NS.SVG) {
            foreignContent.adjustTokenSVGTagName(token);
            foreignContent.adjustTokenSVGAttrs(token);
        }

        foreignContent.adjustTokenXMLAttrs(token);

        if (token.selfClosing)
            p._appendElement(token, currentNs);
        else
            p._insertElement(token, currentNs);
    }
}

function endTagInForeignContent(p, token) {
    for (var i = p.openElements.stackTop; i > 0; i--) {
        var element = p.openElements.items[i];

        if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
            p._processToken(token);
            break;
        }

        if (p.treeAdapter.getTagName(element).toLowerCase() === token.tagName) {
            p.openElements.popUntilElementPopped(element);
            break;
        }
    }
}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(104),
    Tokenizer = __webpack_require__(73),
    PositionTrackingPreprocessorMixin = __webpack_require__(171),
    inherits = __webpack_require__(50).inherits;

var LocationInfoTokenizerMixin = module.exports = function (tokenizer) {
    Mixin.call(this, tokenizer);

    this.tokenizer = tokenizer;
    this.posTracker = new PositionTrackingPreprocessorMixin(tokenizer.preprocessor);
    this.currentAttrLocation = null;
    this.currentTokenLocation = null;
};

inherits(LocationInfoTokenizerMixin, Mixin);

LocationInfoTokenizerMixin.prototype._getCurrentLocation = function () {
    return {
        line: this.posTracker.line,
        col: this.posTracker.col,
        startOffset: this.posTracker.offset,
        endOffset: -1
    };
};

LocationInfoTokenizerMixin.prototype._attachCurrentAttrLocationInfo = function () {
    this.currentAttrLocation.endOffset = this.posTracker.offset;

    var currentToken = this.tokenizer.currentToken,
        currentAttr = this.tokenizer.currentAttr;

    if (!currentToken.location.attrs)
        currentToken.location.attrs = Object.create(null);

    currentToken.location.attrs[currentAttr.name] = this.currentAttrLocation;
};

LocationInfoTokenizerMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    var methods = {
        _createStartTagToken: function () {
            orig._createStartTagToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createEndTagToken: function () {
            orig._createEndTagToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createCommentToken: function () {
            orig._createCommentToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createDoctypeToken: function (initialName) {
            orig._createDoctypeToken.call(this, initialName);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createCharacterToken: function (type, ch) {
            orig._createCharacterToken.call(this, type, ch);
            this.currentCharacterToken.location = mxn.currentTokenLocation;
        },

        _createAttr: function (attrNameFirstCh) {
            orig._createAttr.call(this, attrNameFirstCh);
            mxn.currentAttrLocation = mxn._getCurrentLocation();
        },

        _leaveAttrName: function (toState) {
            orig._leaveAttrName.call(this, toState);
            mxn._attachCurrentAttrLocationInfo();
        },

        _leaveAttrValue: function (toState) {
            orig._leaveAttrValue.call(this, toState);
            mxn._attachCurrentAttrLocationInfo();
        },

        _emitCurrentToken: function () {
            //NOTE: if we have pending character token make it's end location equal to the
            //current token's start location.
            if (this.currentCharacterToken)
                this.currentCharacterToken.location.endOffset = this.currentToken.location.startOffset;

            this.currentToken.location.endOffset = mxn.posTracker.offset + 1;
            orig._emitCurrentToken.call(this);
        },

        _emitCurrentCharacterToken: function () {
            //NOTE: if we have character token and it's location wasn't set in the _emitCurrentToken(),
            //then set it's location at the current preprocessor position.
            //We don't need to increment preprocessor position, since character token
            //emission is always forced by the start of the next character token here.
            //So, we already have advanced position.
            if (this.currentCharacterToken && this.currentCharacterToken.location.endOffset === -1)
                this.currentCharacterToken.location.endOffset = mxn.posTracker.offset;

            orig._emitCurrentCharacterToken.call(this);
        }
    };

    //NOTE: patch initial states for each mode to obtain token start position
    Object.keys(Tokenizer.MODE).forEach(function (modeName) {
        var state = Tokenizer.MODE[modeName];

        methods[state] = function (cp) {
            mxn.currentTokenLocation = mxn._getCurrentLocation();
            orig[state].call(this, cp);
        };
    });

    return methods;
};



/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(104),
    inherits = __webpack_require__(50).inherits,
    UNICODE = __webpack_require__(86);

//Aliases
var $ = UNICODE.CODE_POINTS;

var PositionTrackingPreprocessorMixin = module.exports = function (preprocessor) {
    // NOTE: avoid installing tracker twice
    if (!preprocessor.__locTracker) {
        preprocessor.__locTracker = this;

        Mixin.call(this, preprocessor);

        this.preprocessor = preprocessor;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;

        this.col = -1;
        this.line = 1;
    }

    return preprocessor.__locTracker;
};

inherits(PositionTrackingPreprocessorMixin, Mixin);

Object.defineProperty(PositionTrackingPreprocessorMixin.prototype, 'offset', {
    get: function () {
        return this.droppedBufferSize + this.preprocessor.pos;
    }
});

PositionTrackingPreprocessorMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        advance: function () {
            var cp = orig.advance.call(this);

            //NOTE: LF should be in the last column of the line
            if (mxn.isEol) {
                mxn.isEol = false;
                mxn.line++;
                mxn.lineStartPos = mxn.offset;
            }

            if (cp === $.LINE_FEED)
                mxn.isEol = true;

            mxn.col = mxn.offset - mxn.lineStartPos + 1;

            return cp;
        },

        retreat: function () {
            orig.retreat.call(this);
            mxn.isEol = false;

            mxn.col = mxn.offset - mxn.lineStartPos + 1;
        },

        dropParsedChunk: function () {
            var prevPos = this.pos;

            orig.dropParsedChunk.call(this);

            mxn.droppedBufferSize += prevPos - this.pos;
        }
    };
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__(73),
    HTML = __webpack_require__(43);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES,
    ATTRS = HTML.ATTRS;


//MIME types
var MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml'
};

//Attributes
var DEFINITION_URL_ATTR = 'definitionurl',
    ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL',
    SVG_ATTRS_ADJUSTMENT_MAP = {
        'attributename': 'attributeName',
        'attributetype': 'attributeType',
        'basefrequency': 'baseFrequency',
        'baseprofile': 'baseProfile',
        'calcmode': 'calcMode',
        'clippathunits': 'clipPathUnits',
        'diffuseconstant': 'diffuseConstant',
        'edgemode': 'edgeMode',
        'filterunits': 'filterUnits',
        'glyphref': 'glyphRef',
        'gradienttransform': 'gradientTransform',
        'gradientunits': 'gradientUnits',
        'kernelmatrix': 'kernelMatrix',
        'kernelunitlength': 'kernelUnitLength',
        'keypoints': 'keyPoints',
        'keysplines': 'keySplines',
        'keytimes': 'keyTimes',
        'lengthadjust': 'lengthAdjust',
        'limitingconeangle': 'limitingConeAngle',
        'markerheight': 'markerHeight',
        'markerunits': 'markerUnits',
        'markerwidth': 'markerWidth',
        'maskcontentunits': 'maskContentUnits',
        'maskunits': 'maskUnits',
        'numoctaves': 'numOctaves',
        'pathlength': 'pathLength',
        'patterncontentunits': 'patternContentUnits',
        'patterntransform': 'patternTransform',
        'patternunits': 'patternUnits',
        'pointsatx': 'pointsAtX',
        'pointsaty': 'pointsAtY',
        'pointsatz': 'pointsAtZ',
        'preservealpha': 'preserveAlpha',
        'preserveaspectratio': 'preserveAspectRatio',
        'primitiveunits': 'primitiveUnits',
        'refx': 'refX',
        'refy': 'refY',
        'repeatcount': 'repeatCount',
        'repeatdur': 'repeatDur',
        'requiredextensions': 'requiredExtensions',
        'requiredfeatures': 'requiredFeatures',
        'specularconstant': 'specularConstant',
        'specularexponent': 'specularExponent',
        'spreadmethod': 'spreadMethod',
        'startoffset': 'startOffset',
        'stddeviation': 'stdDeviation',
        'stitchtiles': 'stitchTiles',
        'surfacescale': 'surfaceScale',
        'systemlanguage': 'systemLanguage',
        'tablevalues': 'tableValues',
        'targetx': 'targetX',
        'targety': 'targetY',
        'textlength': 'textLength',
        'viewbox': 'viewBox',
        'viewtarget': 'viewTarget',
        'xchannelselector': 'xChannelSelector',
        'ychannelselector': 'yChannelSelector',
        'zoomandpan': 'zoomAndPan'
    },
    XML_ATTRS_ADJUSTMENT_MAP = {
        'xlink:actuate': {prefix: 'xlink', name: 'actuate', namespace: NS.XLINK},
        'xlink:arcrole': {prefix: 'xlink', name: 'arcrole', namespace: NS.XLINK},
        'xlink:href': {prefix: 'xlink', name: 'href', namespace: NS.XLINK},
        'xlink:role': {prefix: 'xlink', name: 'role', namespace: NS.XLINK},
        'xlink:show': {prefix: 'xlink', name: 'show', namespace: NS.XLINK},
        'xlink:title': {prefix: 'xlink', name: 'title', namespace: NS.XLINK},
        'xlink:type': {prefix: 'xlink', name: 'type', namespace: NS.XLINK},
        'xml:base': {prefix: 'xml', name: 'base', namespace: NS.XML},
        'xml:lang': {prefix: 'xml', name: 'lang', namespace: NS.XML},
        'xml:space': {prefix: 'xml', name: 'space', namespace: NS.XML},
        'xmlns': {prefix: '', name: 'xmlns', namespace: NS.XMLNS},
        'xmlns:xlink': {prefix: 'xmlns', name: 'xlink', namespace: NS.XMLNS}

    };

//SVG tag names adjustment map
var SVG_TAG_NAMES_ADJUSTMENT_MAP = exports.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
    'altglyph': 'altGlyph',
    'altglyphdef': 'altGlyphDef',
    'altglyphitem': 'altGlyphItem',
    'animatecolor': 'animateColor',
    'animatemotion': 'animateMotion',
    'animatetransform': 'animateTransform',
    'clippath': 'clipPath',
    'feblend': 'feBlend',
    'fecolormatrix': 'feColorMatrix',
    'fecomponenttransfer': 'feComponentTransfer',
    'fecomposite': 'feComposite',
    'feconvolvematrix': 'feConvolveMatrix',
    'fediffuselighting': 'feDiffuseLighting',
    'fedisplacementmap': 'feDisplacementMap',
    'fedistantlight': 'feDistantLight',
    'feflood': 'feFlood',
    'fefunca': 'feFuncA',
    'fefuncb': 'feFuncB',
    'fefuncg': 'feFuncG',
    'fefuncr': 'feFuncR',
    'fegaussianblur': 'feGaussianBlur',
    'feimage': 'feImage',
    'femerge': 'feMerge',
    'femergenode': 'feMergeNode',
    'femorphology': 'feMorphology',
    'feoffset': 'feOffset',
    'fepointlight': 'fePointLight',
    'fespecularlighting': 'feSpecularLighting',
    'fespotlight': 'feSpotLight',
    'fetile': 'feTile',
    'feturbulence': 'feTurbulence',
    'foreignobject': 'foreignObject',
    'glyphref': 'glyphRef',
    'lineargradient': 'linearGradient',
    'radialgradient': 'radialGradient',
    'textpath': 'textPath'
};

//Tags that causes exit from foreign content
var EXITS_FOREIGN_CONTENT = Object.create(null);

EXITS_FOREIGN_CONTENT[$.B] = true;
EXITS_FOREIGN_CONTENT[$.BIG] = true;
EXITS_FOREIGN_CONTENT[$.BLOCKQUOTE] = true;
EXITS_FOREIGN_CONTENT[$.BODY] = true;
EXITS_FOREIGN_CONTENT[$.BR] = true;
EXITS_FOREIGN_CONTENT[$.CENTER] = true;
EXITS_FOREIGN_CONTENT[$.CODE] = true;
EXITS_FOREIGN_CONTENT[$.DD] = true;
EXITS_FOREIGN_CONTENT[$.DIV] = true;
EXITS_FOREIGN_CONTENT[$.DL] = true;
EXITS_FOREIGN_CONTENT[$.DT] = true;
EXITS_FOREIGN_CONTENT[$.EM] = true;
EXITS_FOREIGN_CONTENT[$.EMBED] = true;
EXITS_FOREIGN_CONTENT[$.H1] = true;
EXITS_FOREIGN_CONTENT[$.H2] = true;
EXITS_FOREIGN_CONTENT[$.H3] = true;
EXITS_FOREIGN_CONTENT[$.H4] = true;
EXITS_FOREIGN_CONTENT[$.H5] = true;
EXITS_FOREIGN_CONTENT[$.H6] = true;
EXITS_FOREIGN_CONTENT[$.HEAD] = true;
EXITS_FOREIGN_CONTENT[$.HR] = true;
EXITS_FOREIGN_CONTENT[$.I] = true;
EXITS_FOREIGN_CONTENT[$.IMG] = true;
EXITS_FOREIGN_CONTENT[$.LI] = true;
EXITS_FOREIGN_CONTENT[$.LISTING] = true;
EXITS_FOREIGN_CONTENT[$.MENU] = true;
EXITS_FOREIGN_CONTENT[$.META] = true;
EXITS_FOREIGN_CONTENT[$.NOBR] = true;
EXITS_FOREIGN_CONTENT[$.OL] = true;
EXITS_FOREIGN_CONTENT[$.P] = true;
EXITS_FOREIGN_CONTENT[$.PRE] = true;
EXITS_FOREIGN_CONTENT[$.RUBY] = true;
EXITS_FOREIGN_CONTENT[$.S] = true;
EXITS_FOREIGN_CONTENT[$.SMALL] = true;
EXITS_FOREIGN_CONTENT[$.SPAN] = true;
EXITS_FOREIGN_CONTENT[$.STRONG] = true;
EXITS_FOREIGN_CONTENT[$.STRIKE] = true;
EXITS_FOREIGN_CONTENT[$.SUB] = true;
EXITS_FOREIGN_CONTENT[$.SUP] = true;
EXITS_FOREIGN_CONTENT[$.TABLE] = true;
EXITS_FOREIGN_CONTENT[$.TT] = true;
EXITS_FOREIGN_CONTENT[$.U] = true;
EXITS_FOREIGN_CONTENT[$.UL] = true;
EXITS_FOREIGN_CONTENT[$.VAR] = true;

//Check exit from foreign content
exports.causesExit = function (startTagToken) {
    var tn = startTagToken.tagName;
    var isFontWithAttrs = tn === $.FONT && (Tokenizer.getTokenAttr(startTagToken, ATTRS.COLOR) !== null ||
                                            Tokenizer.getTokenAttr(startTagToken, ATTRS.SIZE) !== null ||
                                            Tokenizer.getTokenAttr(startTagToken, ATTRS.FACE) !== null);

    return isFontWithAttrs ? true : EXITS_FOREIGN_CONTENT[tn];
};

//Token adjustments
exports.adjustTokenMathMLAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        if (token.attrs[i].name === DEFINITION_URL_ATTR) {
            token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
            break;
        }
    }
};

exports.adjustTokenSVGAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        var adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrName)
            token.attrs[i].name = adjustedAttrName;
    }
};

exports.adjustTokenXMLAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        var adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
};

exports.adjustTokenSVGTagName = function (token) {
    var adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP[token.tagName];

    if (adjustedTagName)
        token.tagName = adjustedTagName;
};

//Integration points
function isMathMLTextIntegrationPoint(tn, ns) {
    return ns === NS.MATHML && (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS || tn === $.MTEXT);
}

function isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === NS.MATHML && tn === $.ANNOTATION_XML) {
        for (var i = 0; i < attrs.length; i++) {
            if (attrs[i].name === ATTRS.ENCODING) {
                var value = attrs[i].value.toLowerCase();

                return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
            }
        }
    }

    return ns === NS.SVG && (tn === $.FOREIGN_OBJECT || tn === $.DESC || tn === $.TITLE);
}

exports.isIntegrationPoint = function (tn, ns, attrs, foreignNS) {
    if ((!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs))
        return true;

    if ((!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns))
        return true;

    return false;
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaultTreeAdapter = __webpack_require__(130),
    mergeOptions = __webpack_require__(131),
    doctype = __webpack_require__(132),
    HTML = __webpack_require__(43);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;

//Default serializer options
var DEFAULT_OPTIONS = {
    treeAdapter: defaultTreeAdapter
};

//Escaping regexes
var AMP_REGEX = /&/g,
    NBSP_REGEX = /\u00a0/g,
    DOUBLE_QUOTE_REGEX = /"/g,
    LT_REGEX = /</g,
    GT_REGEX = />/g;

//Serializer
var Serializer = module.exports = function (node, options) {
    this.options = mergeOptions(DEFAULT_OPTIONS, options);
    this.treeAdapter = this.options.treeAdapter;

    this.html = '';
    this.startNode = node;
};

// NOTE: exported as static method for the testing purposes
Serializer.escapeString = function (str, attrMode) {
    str = str
        .replace(AMP_REGEX, '&amp;')
        .replace(NBSP_REGEX, '&nbsp;');

    if (attrMode)
        str = str.replace(DOUBLE_QUOTE_REGEX, '&quot;');

    else {
        str = str
            .replace(LT_REGEX, '&lt;')
            .replace(GT_REGEX, '&gt;');
    }

    return str;
};


//API
Serializer.prototype.serialize = function () {
    this._serializeChildNodes(this.startNode);

    return this.html;
};


//Internals
Serializer.prototype._serializeChildNodes = function (parentNode) {
    var childNodes = this.treeAdapter.getChildNodes(parentNode);

    if (childNodes) {
        for (var i = 0, cnLength = childNodes.length; i < cnLength; i++) {
            var currentNode = childNodes[i];

            if (this.treeAdapter.isElementNode(currentNode))
                this._serializeElement(currentNode);

            else if (this.treeAdapter.isTextNode(currentNode))
                this._serializeTextNode(currentNode);

            else if (this.treeAdapter.isCommentNode(currentNode))
                this._serializeCommentNode(currentNode);

            else if (this.treeAdapter.isDocumentTypeNode(currentNode))
                this._serializeDocumentTypeNode(currentNode);
        }
    }
};

Serializer.prototype._serializeElement = function (node) {
    var tn = this.treeAdapter.getTagName(node),
        ns = this.treeAdapter.getNamespaceURI(node);

    this.html += '<' + tn;
    this._serializeAttributes(node);
    this.html += '>';

    if (tn !== $.AREA && tn !== $.BASE && tn !== $.BASEFONT && tn !== $.BGSOUND && tn !== $.BR && tn !== $.BR &&
        tn !== $.COL && tn !== $.EMBED && tn !== $.FRAME && tn !== $.HR && tn !== $.IMG && tn !== $.INPUT &&
        tn !== $.KEYGEN && tn !== $.LINK && tn !== $.MENUITEM && tn !== $.META && tn !== $.PARAM && tn !== $.SOURCE &&
        tn !== $.TRACK && tn !== $.WBR) {

        var childNodesHolder = tn === $.TEMPLATE && ns === NS.HTML ?
            this.treeAdapter.getTemplateContent(node) :
            node;

        this._serializeChildNodes(childNodesHolder);
        this.html += '</' + tn + '>';
    }
};

Serializer.prototype._serializeAttributes = function (node) {
    var attrs = this.treeAdapter.getAttrList(node);

    for (var i = 0, attrsLength = attrs.length; i < attrsLength; i++) {
        var attr = attrs[i],
            value = Serializer.escapeString(attr.value, true);

        this.html += ' ';

        if (!attr.namespace)
            this.html += attr.name;

        else if (attr.namespace === NS.XML)
            this.html += 'xml:' + attr.name;

        else if (attr.namespace === NS.XMLNS) {
            if (attr.name !== 'xmlns')
                this.html += 'xmlns:';

            this.html += attr.name;
        }

        else if (attr.namespace === NS.XLINK)
            this.html += 'xlink:' + attr.name;

        else
            this.html += attr.namespace + ':' + attr.name;

        this.html += '="' + value + '"';
    }
};

Serializer.prototype._serializeTextNode = function (node) {
    var content = this.treeAdapter.getTextNodeContent(node),
        parent = this.treeAdapter.getParentNode(node),
        parentTn = void 0;

    if (parent && this.treeAdapter.isElementNode(parent))
        parentTn = this.treeAdapter.getTagName(parent);

    if (parentTn === $.STYLE || parentTn === $.SCRIPT || parentTn === $.XMP || parentTn === $.IFRAME ||
        parentTn === $.NOEMBED || parentTn === $.NOFRAMES || parentTn === $.PLAINTEXT || parentTn === $.NOSCRIPT)

        this.html += content;

    else
        this.html += Serializer.escapeString(content, false);
};

Serializer.prototype._serializeCommentNode = function (node) {
    this.html += '<!--' + this.treeAdapter.getCommentNodeContent(node) + '-->';
};

Serializer.prototype._serializeDocumentTypeNode = function (node) {
    var name = this.treeAdapter.getDocumentTypeNodeName(node);

    this.html += '<' + doctype.serializeContent(name, null, null) + '>';
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WritableStream = __webpack_require__(105).Writable,
    inherits = __webpack_require__(50).inherits,
    Parser = __webpack_require__(169);

var ParserStream = module.exports = function (options) {
    WritableStream.call(this);

    this.parser = new Parser(options);

    this.lastChunkWritten = false;
    this.writeCallback = null;
    this.pausedByScript = false;

    this.document = this.parser.treeAdapter.createDocument();

    this.pendingHtmlInsertions = [];

    this._resume = this._resume.bind(this);
    this._documentWrite = this._documentWrite.bind(this);
    this._scriptHandler = this._scriptHandler.bind(this);

    this.parser._bootstrap(this.document, null);
};

inherits(ParserStream, WritableStream);

//WritableStream implementation
ParserStream.prototype._write = function (chunk, encoding, callback) {
    this.writeCallback = callback;
    this.parser.tokenizer.write(chunk.toString('utf8'), this.lastChunkWritten);
    this._runParsingLoop();
};

ParserStream.prototype.end = function (chunk, encoding, callback) {
    this.lastChunkWritten = true;
    WritableStream.prototype.end.call(this, chunk || '', encoding, callback);
};

//Scriptable parser implementation
ParserStream.prototype._runParsingLoop = function () {
    this.parser.runParsingLoopForCurrentChunk(this.writeCallback, this._scriptHandler);
};

ParserStream.prototype._resume = function () {
    if (!this.pausedByScript)
        throw new Error('Parser was already resumed');

    while (this.pendingHtmlInsertions.length) {
        var html = this.pendingHtmlInsertions.pop();

        this.parser.tokenizer.insertHtmlAtCurrentPos(html);
    }

    this.pausedByScript = false;

    //NOTE: keep parsing if we don't wait for the next input chunk
    if (this.parser.tokenizer.active)
        this._runParsingLoop();
};

ParserStream.prototype._documentWrite = function (html) {
    if (!this.parser.stopped)
        this.pendingHtmlInsertions.push(html);
};

ParserStream.prototype._scriptHandler = function (scriptElement) {
    if (this.listeners('script').length) {
        this.pausedByScript = true;
        this.emit('script', scriptElement, this._documentWrite, this._resume);
    }
    else
        this._runParsingLoop();
};



/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(106);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(167);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(133).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(176);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(135).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(87));
util.inherits = __webpack_require__(74);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(248);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(249);
var destroyImpl = __webpack_require__(177);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(62);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(178).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(62);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(178).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(78)))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(133).EventEmitter;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(106);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(254).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(62);

/*<replacement>*/
var util = Object.create(__webpack_require__(87));
util.inherits = __webpack_require__(74);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slider = _interopRequireDefault(__webpack_require__(281));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports["default"] = _default;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_i18n__ = __webpack_require__(2);

/* harmony default export */ __webpack_exports__["a"] = ({
  carouselContentArray: [{
    title: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Where to find Binary Bot on Deriv'),
    content: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('On the Deriv homepage, hit Trade at the top of the page and choose Binary Bot.'),
    action_text: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Try Binary Bot on Deriv'),
    img: 'image/1a.webm'
  }, {
    title: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('It’s the same Binary Bot you know and love'),
    content: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Everything is exactly the way you like it.'),
    action_text: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Try Binary Bot on Deriv'),
    img: 'image/2a.webm'
  }, {
    title: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Bring your bots across seamlessly'),
    content: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Your strategies from Binary.com can be used on Deriv. Just load your XML files and get trading.'),
    action_text: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Try Binary Bot on Deriv'),
    img: 'image/3a.webm'
  }],
  carouselContentArrayOne: [{
    title: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('7 trading platforms — old favourites and new ones, too'),
    content: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('You’ll find Binary Bot and SmartTrader alongside new platforms like DBot and DTrader. Whatever your trading style, we’ve got the platform for you.'),
    img: 'image/trading-platforms.svg'
  }, {
    title: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Cryptocurrency deposits via fiat on-ramp'),
    content: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Make crypto deposits easily via exchange services such as Changelly, Banxa, and XanPool.'),
    img: 'image/fiat-on-ramp.svg'
  }],
  carouselContentArrayTwo: [{
    title: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('3 trade types'),
    content: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Trade CFDs, digital options, and multipliers, a new, exciting trade type that boosts your potential profits with limited risk.'),
    img: 'image/trade-types.svg'
  }, {
    title: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Peer-to-peer deposits and withdrawals'),
    content: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Exchange your local currency with fellow traders to get funds in and out of your account with Deriv P2P.'),
    img: 'image/peer-to-peer.svg'
  }],
  carouselContentArrayThree: [{
    title: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('6 market types'),
    content: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Expand your portfolio with a wide range of markets such as forex, stocks, cryptocurrencies, synthetics, and more.'),
    img: 'image/market_types.svg'
  }, {
    title: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Learn with Deriv Academy'),
    content: Object(__WEBPACK_IMPORTED_MODULE_0__common_i18n__["c" /* translate */])('Enjoy complimentary articles and videos to help you learn the ropes of online trading.'),
    img: 'image/deriv_academy.svg'
  }]
});

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(121);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 190 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var isObject = __webpack_require__(16);
var newPromiseCapability = __webpack_require__(147);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26);
var anObject = __webpack_require__(9);
var getKeys = __webpack_require__(59);

module.exports = __webpack_require__(22) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(38);
var gOPN = __webpack_require__(77).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(77);
var gOPS = __webpack_require__(103);
var anObject = __webpack_require__(9);
var Reflect = __webpack_require__(10).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(22);
var getKeys = __webpack_require__(59);
var toIObject = __webpack_require__(38);
var isEnum = __webpack_require__(83).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(23);
var context = __webpack_require__(142);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(143)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(22);
var getKeys = __webpack_require__(59);
var gOPS = __webpack_require__(103);
var pIE = __webpack_require__(83);
var toObject = __webpack_require__(29);
var IObject = __webpack_require__(99);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(15)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["binary-live-api"] = factory();
	else
		root["binary-live-api"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 135);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dateAsLocalISOString = __webpack_require__(8);

var _dateAsLocalISOString2 = _interopRequireDefault(_dateAsLocalISOString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (date) {
    return (0, _dateAsLocalISOString2.default)(date).slice(0, 10);
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (x) {
    var secsAway = x * 60 * 60 * 24;
    return Math.floor(Date.now() / 1000) + secsAway;
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (epoch) {
    return new Date(epoch * 1000);
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (duration, unit) {
    switch (unit) {
        case 't':
        case 's':
            return duration;
        case 'm':
            return 60 * duration;
        case 'h':
            return 3600 * duration;
        case 'd':
            return 86400 * duration;
        default:
            throw new Error('Duration unit not valid: ' + unit + ', only allow [\'t\', \'s\', \'m\', \'h\', \'d\']');
    }
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr, key) {
    var result = {};
    arr.forEach(function (ele) {
        var kv = ele[key];
        if (!result[kv]) {
            result[kv] = [];
        }
        result[kv].push(ele);
    });
    return result;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = [{ value: 'CALL', text: 'Rise', img: 'img/trade-call.svg', ticks: true, barrier: false }, { value: 'PUT', text: 'Fall', img: 'img/trade-put.svg', ticks: true, barrier: false }, { value: 'HIGHER', text: 'Higher', img: 'img/trade-higher.svg', ticks: false, barrier: false }, { value: 'LOWER', text: 'Lower', img: 'img/trade-lower.svg', ticks: false, barrier: false }, { value: 'DIGITMATCH', text: 'Digit Match', img: 'img/trade-digitmatch.svg', ticks: true, barrier: true }, { value: 'DIGITDIFF', text: 'Digit Differs', img: 'img/trade-digitdiff.svg', tick: true, barrier: true }, { value: 'DIGITOVER', text: 'Digit Over', img: 'img/trade-digitover.svg', tick: true, barrier: true }, { value: 'DIGITUNDER', text: 'Digit Under', img: 'img/trade-digitunder.svg', tick: true, barrier: true }, { value: 'DIGITEVEN', text: 'Digit Even', img: 'img/trade-digiteven.svg', tick: true, barrier: false }, { value: 'DIGITODD', text: 'Digit Odd', img: 'img/trade-digitodd.svg', tick: true, barrier: false }, { value: 'ASIANU', text: 'Asian Up', img: 'img/trade-asianu.svg', ticks: true, barrier: false }, { value: 'ASIAND', text: 'Asian Down', img: 'img/trade-asiand.svg', ticks: true, barrier: false }, { value: 'EXPIRYRANGE', text: 'Ends Between', img: 'img/trade-expiryrange.svg', ticks: false, barrier: false }, { value: 'EXPIRYMISS', text: 'Ends Outside', img: 'img/trade-expirymiss.svg', ticks: false, barrier: false }, { value: 'RANGE', text: 'Stays Between', img: 'img/trade-range.svg', ticks: false, barrier: false }, { value: 'UPORDOWN', text: 'Goes Outside', img: 'img/trade-upordown.svg', ticks: false, barrier: false }, { value: 'ONETOUCH', text: 'Touches', img: 'img/trade-onetouch.svg', ticks: false, barrier: false }, { value: 'NOTOUCH', text: 'Does Not Touch', img: 'img/trade-notouch.svg', ticks: false, barrier: false }, { value: 'SPREADU', text: 'Spread Long', img: 'img/trade-spreadu.svg', ticks: false, barrier: false }, { value: 'SPREADD', text: 'Spread Short', img: 'img/trade-spreadu.svg', ticks: false, barrier: false }];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (barrier, entrySpot, lastTickQuote) {
    return +barrier + (+entrySpot || lastTickQuote);
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (contract, lastTickQuote) {
    var barrierEntryName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'barrier';

    var barrierValue = +contract[barrierEntryName];
    if (!barrierValue) {
        return lastTickQuote;
    }
    if (contract.barrierType !== 'relative') {
        return barrierValue;
    }
    if (typeof contract.entry_spot === 'undefined' && typeof lastTickQuote === 'undefined') {
        throw new Error('Relative barrier can not be calculated');
    }
    return barrierValue + (+contract.entry_spot || lastTickQuote);
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (date) {
    return new Date(date - date.getTimezoneOffset() * 60 * 1000).toISOString();
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return Math.floor(Date.now() / 1000);
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (a, b) {
    var aH = +a.slice(0, 2);
    var aM = +a.slice(3, 5);
    var aS = +a.slice(6);

    var bH = +b.slice(0, 2);
    var bM = +b.slice(3, 5);
    var bS = +b.slice(6);

    if (aH !== bH) {
        return aH > bH;
    } else if (aM !== bM) {
        return aM > bM;
    }
    return aS > bS;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDayEpoch = __webpack_require__(1);

var _xDayEpoch2 = _interopRequireDefault(_xDayEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return (0, _xDayEpoch2.default)(-1);
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _durationSecHelper = __webpack_require__(21);

var _durationSecHelper2 = _interopRequireDefault(_durationSecHelper);

var _extractMinMaxInUnits = __webpack_require__(23);

var _extractMinMaxInUnits2 = _interopRequireDefault(_extractMinMaxInUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contracts, type) {
    if (type.indexOf('SPREAD') > -1) {
        return [];
    }

    var tickContracts = contracts.filter(function (c) {
        return c.min_contract_duration.slice(-1) === 't';
    });
    var tickDuration = tickContracts.length > 0 ? { min: 5, max: 10, unit: 't' } : undefined;

    var nonTickContracts = contracts.filter(function (c) {
        return c.min_contract_duration.slice(-1) !== 't';
    });
    if (nonTickContracts.length === 0) {
        return tickDuration ? [tickDuration] : [];
    }
    var nonTickMinSec = nonTickContracts.map(function (c) {
        return (0, _durationSecHelper2.default)(c.min_contract_duration);
    }).filter(function (d) {
        return !!d;
    }).reduce(function (a, b) {
        return Math.min(a, b);
    });

    var nonTickMaxSec = nonTickContracts.map(function (c) {
        return (0, _durationSecHelper2.default)(c.max_contract_duration);
    }).filter(function (d) {
        return !!d;
    }).reduce(function (a, b) {
        return Math.max(a, b);
    });

    var nonTicksDuration = (0, _extractMinMaxInUnits2.default)(nonTickMinSec, nonTickMaxSec);
    if (tickDuration) {
        nonTicksDuration.unshift(tickDuration);
    }

    return nonTicksDuration;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr1, arr2) {
    var eq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a, b) {
        return a === b;
    };

    var len1 = arr1.length;
    var len2 = arr2.length;
    var lengthDiff = Math.abs(len1 - len2);

    switch (lengthDiff) {
        case 0:
            if (len1 === 0) return false;
            if (len1 === 1) return !eq(arr1[0], arr2[0]);

            return eq(arr1[arr1.length - 1], arr2[arr2.length - 2]) || eq(arr1[arr1.length - 2], arr2[arr2.length - 1]);

        case 1:
            if (len1 === 0 || len2 === 0) return true;

            return eq(arr1[arr1.length - 1], arr2[arr2.length - 2]) || eq(arr1[arr1.length - 2], arr2[arr2.length - 1]);

        default:
            return false;
    }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LiveEvents = function () {
    function LiveEvents() {
        _classCallCheck(this, LiveEvents);

        this.messageHandlers = {};
    }

    LiveEvents.prototype.emitSingle = function emitSingle(msgType, msgData) {
        var handlers = this.messageHandlers[msgType] || [];
        handlers.forEach(function (handler) {
            handler(msgData);
        });
    };

    LiveEvents.prototype.emitWildcard = function emitWildcard(msgData) {
        var handlers = this.messageHandlers['*'] || [];
        handlers.forEach(function (handler) {
            handler(msgData);
        });
    };

    LiveEvents.prototype.emit = function emit(msgType, msgData) {
        this.emitSingle(msgType, msgData);
        this.emitWildcard(msgData);
    };

    LiveEvents.prototype.on = function on(msgType, callback) {
        if (!this.messageHandlers[msgType]) {
            this.messageHandlers[msgType] = [callback];
        } else {
            this.messageHandlers[msgType].push(callback);
        }
    };

    LiveEvents.prototype.ignoreAll = function ignoreAll(msgType) {
        delete this.messageHandlers[msgType];
    };

    return LiveEvents;
}();

exports.default = LiveEvents;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.helpers = exports.autoAdjustGetData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getDataForSymbol = getDataForSymbol;
exports.getDataForContract = getDataForContract;

var _binaryUtils = __webpack_require__(25);

var responseSizeLimit = 700;

var granularities = [60, 120, 180, 300, 600, 900, 1800, 3600, 7200, 14400, 28800, 86400];

var ohlcDataToTicks = function ohlcDataToTicks(candles) {
    return candles.map(function (data) {
        return { quote: +data.open, epoch: +data.epoch };
    });
};

var autoAdjustGetData = exports.autoAdjustGetData = function autoAdjustGetData(api, symbol, start, end) {
    var style = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'ticks';
    var subscribe = arguments[5];
    var extra = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

    var secs = end - start;
    var ticksCount = secs / 2;
    if (ticksCount >= responseSizeLimit || style === 'candles') {
        var idealGranularity = secs / responseSizeLimit;
        var finalGranularity = 60;
        granularities.forEach(function (g, i) {
            if (idealGranularity > g && idealGranularity <= granularities[i + 1]) {
                finalGranularity = granularities[i + 1];
            }
        });
        finalGranularity = Math.min(86400, finalGranularity);

        return api.getTickHistory(symbol, {
            start: start,
            end: end,
            adjust_start_time: 1,
            count: responseSizeLimit,
            style: 'candles',
            granularity: finalGranularity,
            subscribe: subscribe ? 1 : undefined
        }).then(function (r) {
            if (style === 'ticks') {
                return _extends({}, extra, {
                    ticks: ohlcDataToTicks(r.candles),
                    symbol: symbol
                });
            }
            return _extends({}, extra, {
                candles: r.candles,
                symbol: symbol
            });
        });
    }
    return api.getTickHistory(symbol, {
        start: start,
        end: end,
        adjust_start_time: 1,
        count: responseSizeLimit,
        style: 'ticks',
        subscribe: subscribe ? 1 : undefined
    }).then(function (r) {
        var ticks = r.history.times.map(function (t, idx) {
            var quote = r.history.prices[idx];
            return { epoch: +t, quote: +quote };
        });
        return _extends({}, extra, {
            ticks: ticks,
            symbol: symbol
        });
    });
};

function getDataForSymbol(api, symbol) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 600;
    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ticks';
    var subscribe = arguments[4];

    var end = (0, _binaryUtils.nowAsEpoch)();
    var start = end - duration;
    return autoAdjustGetData(api, symbol, start, end, style, subscribe);
}

/**
 * get data of contract
 * @param api                      - will be injected by library
 * @param getContract              - function that accept nothing and return a Promise containing contract
 * @param durationCount            - number of duration
 * @param durationType             - type of duration, check http://api.highcharts.com/highstock#rangeSelector.buttons
 * @param style                    - one of ['ticks', 'candles'], this will affect the return data shape,
 *                                   internally library might not always use this param when requesting, eg. when data is too large,
 *                                   library will use `candles` instead of `ticks`, this is handle by library so user do not need to worry
 * @param granularity              - default to 60, check https://developers.binary.com/api/#ticks_history
 * @returns {*|Promise.<TResult>}
 */
function getDataForContract(api, getContract, duration) {
    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ticks';
    var subscribe = arguments[4];

    var getAllData = function getAllData() {
        return getContract().then(function (contract) {
            var symbol = contract.underlying;

            var _computeStartEndForCo = (0, _binaryUtils.computeStartEndForContract)(contract),
                start = _computeStartEndForCo.start,
                end = _computeStartEndForCo.end;

            return autoAdjustGetData(api, symbol, start, end, style, subscribe, { isSold: !!contract.sell_time });
        });
    };

    if (!duration) {
        return getAllData();
    }

    return getContract().then(function (contract) {
        var symbol = contract.underlying;
        var startTime = +contract.date_start;

        // handle Contract not started yet
        if (startTime > (0, _binaryUtils.nowAsEpoch)()) {
            return autoAdjustGetData(api, symbol, (0, _binaryUtils.nowAsEpoch)() - 600, (0, _binaryUtils.nowAsEpoch)(), style, subscribe, {
                isSold: !!contract.sell_time
            });
        }

        var sellT = contract.sell_time;
        var end = sellT || (0, _binaryUtils.nowAsEpoch)();

        var buffer = (end - startTime) * 0.05;

        var start = Math.min(startTime - buffer, end - duration);
        return autoAdjustGetData(api, symbol, Math.round(start), Math.round(end), style, subscribe, {
            isSold: !!contract.sell_time
        });
    });
}

var helpers = exports.helpers = {
    autoAdjustGetData: autoAdjustGetData
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr) {
    return arr.reduce(function (obj, x) {
        Object.keys(x).forEach(function (key) {
            if (Array.isArray(obj[key])) {
                obj[key].push(x[key]);
            } else {
                obj[key] = [x[key]];
            }
        });
        return obj;
    }, {});
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commonRelativeBarrier = __webpack_require__(6);

var _commonRelativeBarrier2 = _interopRequireDefault(_commonRelativeBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contract, lastTickQuote) {
    return (0, _commonRelativeBarrier2.default)(contract.barrier, contract.entry_spot, lastTickQuote);
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dateAsLocalISOString = __webpack_require__(8);

var _dateAsLocalISOString2 = _interopRequireDefault(_dateAsLocalISOString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (date) {
    return (0, _dateAsLocalISOString2.default)(date).slice(11, 19);
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (sec) {
    var minute = Math.floor(sec / 60);
    var hour = Math.floor(minute / 60);
    var day = Math.floor(hour / 24);

    return [sec, minute, hour, day];
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _timeStringBigger = __webpack_require__(10);

var _timeStringBigger2 = _interopRequireDefault(_timeStringBigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (a, b) {
    if (a === b) {
        return false;
    }
    return !(0, _timeStringBigger2.default)(a, b);
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _durationToSecs = __webpack_require__(3);

var _durationToSecs2 = _interopRequireDefault(_durationToSecs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (duration) {
    var d = +duration.slice(0, -1);
    var u = duration.slice(-1);
    return (0, _durationToSecs2.default)(d, u);
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['t', 's', 'm', 'h', 'd'];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _durationUnits = __webpack_require__(22);

var _durationUnits2 = _interopRequireDefault(_durationUnits);

var _splitSecsToUnits = __webpack_require__(19);

var _splitSecsToUnits2 = _interopRequireDefault(_splitSecsToUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// block is a structure that describes min and max of specific time unit
var blockIsValid = function blockIsValid(minArg, maxArg, unit) {
    if (maxArg <= 1) {
        return false;
    }
    switch (unit) {
        case 's':
            return minArg < 60;
        case 'm':
            return minArg < 60;
        case 'h':
            return minArg < 24;
        case 'd':
        default:
            return true;
    }
};

exports.default = function (minInSecs, maxInSecs) {
    var minInUnits = (0, _splitSecsToUnits2.default)(minInSecs);
    var maxInUnits = (0, _splitSecsToUnits2.default)(maxInSecs);

    var durations = [];
    for (var i = 0; i < minInUnits.length; i++) {
        var unit = _durationUnits2.default[i + 1];
        var minI = minInUnits[i];
        var maxI = maxInUnits[i];
        if (blockIsValid(minI, maxI, unit)) {
            durations.push({
                unit: unit,
                min: minI > 0 ? minI : 1,
                max: maxI });
        }
    }
    return durations;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (duration) {
    return !!duration && duration.slice(-1) === 't';
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayEqual = __webpack_require__(42);

Object.defineProperty(exports, 'arrayEqual', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_arrayEqual).default;
  }
});

var _arrayMax = __webpack_require__(43);

Object.defineProperty(exports, 'arrayMax', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_arrayMax).default;
  }
});

var _arrayMin = __webpack_require__(44);

Object.defineProperty(exports, 'arrayMin', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_arrayMin).default;
  }
});

var _arrayToObject = __webpack_require__(16);

Object.defineProperty(exports, 'arrayToObject', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_arrayToObject).default;
  }
});

var _getLast = __webpack_require__(45);

Object.defineProperty(exports, 'getLast', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLast).default;
  }
});

var _mergeSortedArrays = __webpack_require__(47);

Object.defineProperty(exports, 'mergeSortedArrays', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mergeSortedArrays).default;
  }
});

var _sequence = __webpack_require__(48);

Object.defineProperty(exports, 'sequence', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sequence).default;
  }
});

var _groupArrayToNestedArray = __webpack_require__(46);

Object.defineProperty(exports, 'groupArrayToNestedArray', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_groupArrayToNestedArray).default;
  }
});

var _barrier2FromContract = __webpack_require__(49);

Object.defineProperty(exports, 'barrier2FromContract', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_barrier2FromContract).default;
  }
});

var _barrierFromContract = __webpack_require__(50);

Object.defineProperty(exports, 'barrierFromContract', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_barrierFromContract).default;
  }
});

var _callPutBarrier = __webpack_require__(51);

Object.defineProperty(exports, 'callPutBarrier', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_callPutBarrier).default;
  }
});

var _commonRelativeBarrier = __webpack_require__(6);

Object.defineProperty(exports, 'commonRelativeBarrier', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_commonRelativeBarrier).default;
  }
});

var _extractBarrier = __webpack_require__(52);

Object.defineProperty(exports, 'extractBarrier', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_extractBarrier).default;
  }
});

var _getAbsoluteBarrierFromContract = __webpack_require__(7);

Object.defineProperty(exports, 'getAbsoluteBarrierFromContract', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getAbsoluteBarrierFromContract).default;
  }
});

var _relativeBarrier = __webpack_require__(17);

Object.defineProperty(exports, 'relativeBarrier', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_relativeBarrier).default;
  }
});

var _relativeBarrier2 = __webpack_require__(53);

Object.defineProperty(exports, 'relativeBarrier2', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_relativeBarrier2).default;
  }
});

var _dateAsLocalISOString = __webpack_require__(8);

Object.defineProperty(exports, 'dateAsLocalISOString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dateAsLocalISOString).default;
  }
});

var _dateToDateString = __webpack_require__(0);

Object.defineProperty(exports, 'dateToDateString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dateToDateString).default;
  }
});

var _dateToEpoch = __webpack_require__(54);

Object.defineProperty(exports, 'dateToEpoch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dateToEpoch).default;
  }
});

var _dateToGMTString = __webpack_require__(55);

Object.defineProperty(exports, 'dateToGMTString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dateToGMTString).default;
  }
});

var _dateToTimeString = __webpack_require__(18);

Object.defineProperty(exports, 'dateToTimeString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dateToTimeString).default;
  }
});

var _dateToUTCTimeString = __webpack_require__(56);

Object.defineProperty(exports, 'dateToUTCTimeString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dateToUTCTimeString).default;
  }
});

var _epochToDate = __webpack_require__(2);

Object.defineProperty(exports, 'epochToDate', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_epochToDate).default;
  }
});

var _epochToDateString = __webpack_require__(57);

Object.defineProperty(exports, 'epochToDateString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_epochToDateString).default;
  }
});

var _epochToDateTimeString = __webpack_require__(58);

Object.defineProperty(exports, 'epochToDateTimeString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_epochToDateTimeString).default;
  }
});

var _epochToTimeString = __webpack_require__(59);

Object.defineProperty(exports, 'epochToTimeString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_epochToTimeString).default;
  }
});

var _epochToUTCDateString = __webpack_require__(60);

Object.defineProperty(exports, 'epochToUTCDateString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_epochToUTCDateString).default;
  }
});

var _epochToUTCTimeString = __webpack_require__(61);

Object.defineProperty(exports, 'epochToUTCTimeString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_epochToUTCTimeString).default;
  }
});

var _getLastXMonthEpoch = __webpack_require__(62);

Object.defineProperty(exports, 'getLastXMonthEpoch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLastXMonthEpoch).default;
  }
});

var _isDateValid = __webpack_require__(63);

Object.defineProperty(exports, 'isDateValid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isDateValid).default;
  }
});

var _last30DaysEpoch = __webpack_require__(65);

Object.defineProperty(exports, 'last30DaysEpoch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_last30DaysEpoch).default;
  }
});

var _last7DaysEpoch = __webpack_require__(66);

Object.defineProperty(exports, 'last7DaysEpoch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_last7DaysEpoch).default;
  }
});

var _nextXDay = __webpack_require__(67);

Object.defineProperty(exports, 'nextXDay', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_nextXDay).default;
  }
});

var _nowAsEpoch = __webpack_require__(9);

Object.defineProperty(exports, 'nowAsEpoch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_nowAsEpoch).default;
  }
});

var _oneYearAfterStr = __webpack_require__(68);

Object.defineProperty(exports, 'oneYearAfterStr', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_oneYearAfterStr).default;
  }
});

var _secondsToTimeString = __webpack_require__(71);

Object.defineProperty(exports, 'secondsToTimeString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_secondsToTimeString).default;
  }
});

var _splitSecsToUnits = __webpack_require__(19);

Object.defineProperty(exports, 'splitSecsToUnits', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_splitSecsToUnits).default;
  }
});

var _timeStringBigger = __webpack_require__(10);

Object.defineProperty(exports, 'timeStringBigger', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_timeStringBigger).default;
  }
});

var _timeStringIsBetween = __webpack_require__(73);

Object.defineProperty(exports, 'timeStringIsBetween', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_timeStringIsBetween).default;
  }
});

var _timeStringSmaller = __webpack_require__(20);

Object.defineProperty(exports, 'timeStringSmaller', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_timeStringSmaller).default;
  }
});

var _timeStringToSeconds = __webpack_require__(74);

Object.defineProperty(exports, 'timeStringToSeconds', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_timeStringToSeconds).default;
  }
});

var _todayEpoch = __webpack_require__(75);

Object.defineProperty(exports, 'todayEpoch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_todayEpoch).default;
  }
});

var _todayLocaleString = __webpack_require__(76);

Object.defineProperty(exports, 'todayLocaleString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_todayLocaleString).default;
  }
});

var _todayUTCString = __webpack_require__(77);

Object.defineProperty(exports, 'todayUTCString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_todayUTCString).default;
  }
});

var _xDayEpoch = __webpack_require__(1);

Object.defineProperty(exports, 'xDayEpoch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_xDayEpoch).default;
  }
});

var _xMonthsAfter = __webpack_require__(78);

Object.defineProperty(exports, 'xMonthsAfter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_xMonthsAfter).default;
  }
});

var _yesterdayEpoch = __webpack_require__(11);

Object.defineProperty(exports, 'yesterdayEpoch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_yesterdayEpoch).default;
  }
});

var _yesterdayString = __webpack_require__(79);

Object.defineProperty(exports, 'yesterdayString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_yesterdayString).default;
  }
});

var _yesterdayUTCString = __webpack_require__(80);

Object.defineProperty(exports, 'yesterdayUTCString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_yesterdayUTCString).default;
  }
});

var _returnValidDate = __webpack_require__(69);

Object.defineProperty(exports, 'returnValidDate', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_returnValidDate).default;
  }
});

var _returnValidTime = __webpack_require__(70);

Object.defineProperty(exports, 'returnValidTime', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_returnValidTime).default;
  }
});

var _isValidTime = __webpack_require__(64);

Object.defineProperty(exports, 'isValidTime', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isValidTime).default;
  }
});

var _timeLeftToNextRealityCheck = __webpack_require__(72);

Object.defineProperty(exports, 'timeLeftToNextRealityCheck', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_timeLeftToNextRealityCheck).default;
  }
});

var _durationSecHelper = __webpack_require__(21);

Object.defineProperty(exports, 'durationSecHelper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_durationSecHelper).default;
  }
});

var _durationText = __webpack_require__(88);

Object.defineProperty(exports, 'durationText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_durationText).default;
  }
});

var _durationToSecs = __webpack_require__(3);

Object.defineProperty(exports, 'durationToSecs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_durationToSecs).default;
  }
});

var _durationUnits = __webpack_require__(22);

Object.defineProperty(exports, 'durationUnits', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_durationUnits).default;
  }
});

var _extractDuration = __webpack_require__(89);

Object.defineProperty(exports, 'extractDuration', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_extractDuration).default;
  }
});

var _extractDurationHelper = __webpack_require__(12);

Object.defineProperty(exports, 'extractDurationHelper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_extractDurationHelper).default;
  }
});

var _extractForwardStartingDuration = __webpack_require__(90);

Object.defineProperty(exports, 'extractForwardStartingDuration', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_extractForwardStartingDuration).default;
  }
});

var _extractMinMaxInUnits = __webpack_require__(23);

Object.defineProperty(exports, 'extractMinMaxInUnits', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_extractMinMaxInUnits).default;
  }
});

var _isDurationLessThan2Mins = __webpack_require__(91);

Object.defineProperty(exports, 'isDurationLessThan2Mins', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isDurationLessThan2Mins).default;
  }
});

var _isDurationTick = __webpack_require__(24);

Object.defineProperty(exports, 'isDurationTick', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isDurationTick).default;
  }
});

var _isDurationWithinRange = __webpack_require__(92);

Object.defineProperty(exports, 'isDurationWithinRange', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isDurationWithinRange).default;
  }
});

var _calculateLastDigitStats = __webpack_require__(101);

Object.defineProperty(exports, 'calculateLastDigitStats', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_calculateLastDigitStats).default;
  }
});

var _digitsToPips = __webpack_require__(102);

Object.defineProperty(exports, 'digitsToPips', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_digitsToPips).default;
  }
});

var _getLastDigit = __webpack_require__(26);

Object.defineProperty(exports, 'getLastDigit', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLastDigit).default;
  }
});

var _noOfDecimals = __webpack_require__(103);

Object.defineProperty(exports, 'noOfDecimals', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_noOfDecimals).default;
  }
});

var _numberToSignedString = __webpack_require__(104);

Object.defineProperty(exports, 'numberToSignedString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_numberToSignedString).default;
  }
});

var _pipSizeToStepSize = __webpack_require__(105);

Object.defineProperty(exports, 'pipSizeToStepSize', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pipSizeToStepSize).default;
  }
});

var _pipsToDigits = __webpack_require__(106);

Object.defineProperty(exports, 'pipsToDigits', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pipsToDigits).default;
  }
});

var _toMoney = __webpack_require__(107);

Object.defineProperty(exports, 'toMoney', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toMoney).default;
  }
});

var _filterDeep = __webpack_require__(108);

Object.defineProperty(exports, 'filterDeep', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_filterDeep).default;
  }
});

var _findDeep = __webpack_require__(109);

Object.defineProperty(exports, 'findDeep', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_findDeep).default;
  }
});

var _groupByKey = __webpack_require__(4);

Object.defineProperty(exports, 'groupByKey', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_groupByKey).default;
  }
});

var _immutableChildrenToJS = __webpack_require__(110);

Object.defineProperty(exports, 'immutableChildrenToJS', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_immutableChildrenToJS).default;
  }
});

var _areArraysEqual = __webpack_require__(111);

Object.defineProperty(exports, 'areArraysEqual', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_areArraysEqual).default;
  }
});

var _areCandleArrayEqual = __webpack_require__(112);

Object.defineProperty(exports, 'areCandleArrayEqual', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_areCandleArrayEqual).default;
  }
});

var _areTickArraysEqual = __webpack_require__(113);

Object.defineProperty(exports, 'areTickArraysEqual', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_areTickArraysEqual).default;
  }
});

var _doArrayDifferJustOneEntry = __webpack_require__(13);

Object.defineProperty(exports, 'doArrayDifferJustOneEntry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_doArrayDifferJustOneEntry).default;
  }
});

var _doCandleEqual = __webpack_require__(27);

Object.defineProperty(exports, 'doCandleEqual', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_doCandleEqual).default;
  }
});

var _doCandlesDifferJustOneEntry = __webpack_require__(114);

Object.defineProperty(exports, 'doCandlesDifferJustOneEntry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_doCandlesDifferJustOneEntry).default;
  }
});

var _doTicksDifferJustOneEntry = __webpack_require__(115);

Object.defineProperty(exports, 'doTicksDifferJustOneEntry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_doTicksDifferJustOneEntry).default;
  }
});

var _doTicksEqual = __webpack_require__(28);

Object.defineProperty(exports, 'doTicksEqual', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_doTicksEqual).default;
  }
});

var _getLastOHLCTick = __webpack_require__(116);

Object.defineProperty(exports, 'getLastOHLCTick', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLastOHLCTick).default;
  }
});

var _getLastTickQuote = __webpack_require__(117);

Object.defineProperty(exports, 'getLastTickQuote', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLastTickQuote).default;
  }
});

var _historyToTicks = __webpack_require__(118);

Object.defineProperty(exports, 'historyToTicks', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_historyToTicks).default;
  }
});

var _ohlcToData = __webpack_require__(119);

Object.defineProperty(exports, 'ohlcToData', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ohlcToData).default;
  }
});

var _ohlcToTicks = __webpack_require__(120);

Object.defineProperty(exports, 'ohlcToTicks', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ohlcToTicks).default;
  }
});

var _tickToData = __webpack_require__(121);

Object.defineProperty(exports, 'tickToData', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_tickToData).default;
  }
});

var _askPriceFromProposal = __webpack_require__(122);

Object.defineProperty(exports, 'askPriceFromProposal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_askPriceFromProposal).default;
  }
});

var _computeStartEndForContract = __webpack_require__(123);

Object.defineProperty(exports, 'computeStartEndForContract', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_computeStartEndForContract).default;
  }
});

var _contractCategoryToText = __webpack_require__(124);

Object.defineProperty(exports, 'contractCategoryToText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_contractCategoryToText).default;
  }
});

var _contractCodeToText = __webpack_require__(125);

Object.defineProperty(exports, 'contractCodeToText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_contractCodeToText).default;
  }
});

var _extractSpreadInfo = __webpack_require__(126);

Object.defineProperty(exports, 'extractSpreadInfo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_extractSpreadInfo).default;
  }
});

var _isIntraday = __webpack_require__(127);

Object.defineProperty(exports, 'isIntraday', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isIntraday).default;
  }
});

var _normalizedContractFor = __webpack_require__(128);

Object.defineProperty(exports, 'normalizedContractFor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_normalizedContractFor).default;
  }
});

var _tradeToFriendlyType = __webpack_require__(129);

Object.defineProperty(exports, 'tradeToFriendlyType', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_tradeToFriendlyType).default;
  }
});

var _tradeTypeCodeToText = __webpack_require__(29);

Object.defineProperty(exports, 'tradeTypeCodeToText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_tradeTypeCodeToText).default;
  }
});

var _tradeTypeTextToCode = __webpack_require__(130);

Object.defineProperty(exports, 'tradeTypeTextToCode', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_tradeTypeTextToCode).default;
  }
});

var _tradeTypes = __webpack_require__(5);

Object.defineProperty(exports, 'tradeTypes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_tradeTypes).default;
  }
});

var _typeHasBarrier = __webpack_require__(30);

Object.defineProperty(exports, 'typeHasBarrier', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_typeHasBarrier).default;
  }
});

var _Analytics = __webpack_require__(93);

Object.defineProperty(exports, 'Analytics', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Analytics).default;
  }
});

var _brandColor = __webpack_require__(94);

Object.defineProperty(exports, 'brandColor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_brandColor).default;
  }
});

var _directionClassName = __webpack_require__(95);

Object.defineProperty(exports, 'directionClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_directionClassName).default;
  }
});

var _errorToString = __webpack_require__(96);

Object.defineProperty(exports, 'errorToString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_errorToString).default;
  }
});

var _getUniqueId = __webpack_require__(97);

Object.defineProperty(exports, 'getUniqueId', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getUniqueId).default;
  }
});

var _isMobile = __webpack_require__(98);

Object.defineProperty(exports, 'isMobile', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isMobile).default;
  }
});

var _isValidEmail = __webpack_require__(99);

Object.defineProperty(exports, 'isValidEmail', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isValidEmail).default;
  }
});

var _isValidPassword = __webpack_require__(100);

Object.defineProperty(exports, 'isValidPassword', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isValidPassword).default;
  }
});

var _addFullscreenEventListener = __webpack_require__(81);

Object.defineProperty(exports, 'addFullscreenEventListener', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_addFullscreenEventListener).default;
  }
});

var _exitFullscreen = __webpack_require__(82);

Object.defineProperty(exports, 'exitFullscreen', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_exitFullscreen).default;
  }
});

var _removeFullscreenEventListener = __webpack_require__(83);

Object.defineProperty(exports, 'removeFullscreenEventListener', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_removeFullscreenEventListener).default;
  }
});

var _requestFullscreen = __webpack_require__(84);

Object.defineProperty(exports, 'requestFullscreen', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_requestFullscreen).default;
  }
});

var _showInfo = __webpack_require__(86);

Object.defineProperty(exports, 'showInfo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_showInfo).default;
  }
});

var _showError = __webpack_require__(85);

Object.defineProperty(exports, 'showError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_showError).default;
  }
});

var _windowResizeEvent = __webpack_require__(87);

Object.defineProperty(exports, 'windowResizeEvent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_windowResizeEvent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (value, pips) {
    return +value.toFixed(pips).slice(-1);
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (ohlc1, ohlc2) {
    return !ohlc1 && ohlc1 === ohlc2 || !!ohlc1 && !!ohlc2 && ohlc1.epoch === ohlc2.epoch && ohlc1.close === ohlc2.close;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (tick1, tick2) {
    return !tick1 && tick1 === tick2 || !!tick1 && !!tick2 && tick1.epoch === tick2.epoch && tick1.quote === tick2.quote;
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tradeTypes = __webpack_require__(5);

var _tradeTypes2 = _interopRequireDefault(_tradeTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (code) {
    var tradeType = _tradeTypes2.default.find(function (x) {
        return x.value === code;
    });
    return tradeType ? tradeType.text : 'Unknown';
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tradeTypes = __webpack_require__(5);

var _tradeTypes2 = _interopRequireDefault(_tradeTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (type) {
    var typeDetails = _tradeTypes2.default.find(function (x) {
        return x.value === type;
    });
    return !!(typeDetails && typeDetails.barrier);
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.OAuth = exports.helpers = exports.LiveApi = exports.LiveEvents = undefined;

var _LiveEvents = __webpack_require__(14);

Object.defineProperty(exports, 'LiveEvents', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LiveEvents).default;
  }
});

var _LiveApi = __webpack_require__(33);

Object.defineProperty(exports, 'LiveApi', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LiveApi).default;
  }
});

var _custom = __webpack_require__(15);

Object.defineProperty(exports, 'helpers', {
  enumerable: true,
  get: function get() {
    return _custom.helpers;
  }
});

var _OAuth2 = __webpack_require__(34);

var _OAuth = _interopRequireWildcard(_OAuth2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.OAuth = _OAuth;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var getInitialState = function getInitialState() {
    return {
        token: undefined,
        balance: false,
        contracts: new Set(),
        allContract: false,
        transactions: false,
        ticks: new Set(),
        ticksHistory: new Map(),
        candlesHistory: new Map(),
        proposals: new Set(),
        streamIdMapping: new Map()
    };
};

var ApiState = function ApiState() {
    var _this = this;

    _classCallCheck(this, ApiState);

    this.resetState = function () {
        _this.state = getInitialState();
    };

    this.getState = function () {
        return _this.state;
    };

    this.authorize = function (token) {
        _this.state.token = token;
    };

    this.subscribeToBalance = function () {
        _this.state.balance = true;
    };

    this.unsubscribeFromBalance = function () {
        _this.state.balance = false;
    };

    this.subscribeToOpenContract = function (contractId, streamId) {
        if (streamId) {
            _this.state.contracts.add(contractId);
            _this.state.streamIdMapping.set(streamId, contractId);
        }
    };

    this.unsubscribeFromAllOpenContracts = function () {
        _this.state.contracts.clear();
        _this.state.allContract = false;
    };

    this.subscribeToAllOpenContracts = function () {
        _this.state.allContract = true;
    };

    this.subscribeToTransactions = function () {
        _this.state.transactions = true;
    };

    this.unsubscribeFromTransactions = function () {
        _this.state.transactions = false;
    };

    this.subscribeToTick = function (symbol) {
        _this.state.ticks.add(symbol);
    };

    this.subscribeToTicks = function (symbols) {
        symbols.forEach(_this.subscribeToTick);
    };

    this.unsubscribeFromAllTicks = function () {
        _this.state.ticks.clear();
        _this.state.ticksHistory.clear();
    };

    this.unsubscribeFromAllCandles = function () {
        _this.state.candlesHistory.clear();
    };

    this.getTickHistory = function (symbol, params) {
        if (params && params.subscribe === 1) {
            if (params.style === 'candles') {
                _this.state.candlesHistory.set(symbol, params);
            } else {
                _this.state.ticksHistory.set(symbol, params);
            }
        }
    };

    this.subscribeToPriceForContractProposal = function (options, streamId) {
        if (streamId) {
            _this.state.proposals.add(options);
            _this.state.streamIdMapping.set(streamId, options);
        }
    };

    this.unsubscribeFromAllProposals = function () {
        _this.state.proposals.clear();
    };

    this.unsubscribeByID = function (id) {
        _this.state.streamIdMapping.forEach(function (payload, streamId) {
            if (streamId === id) {
                _this.state.contracts.delete(payload);
                _this.state.proposals.delete(payload);
            }
        });
        _this.state.streamIdMapping.delete(id);
    };

    this.state = getInitialState();
}

// special care needed to forget subscription, as backends rely on
// and id instead of more natural keys like symbol and payload
;

exports.default = ApiState;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _rxLite = __webpack_require__(132);

var _binaryUtils = __webpack_require__(25);

var _LiveEvents = __webpack_require__(14);

var _LiveEvents2 = _interopRequireDefault(_LiveEvents);

var _ServerError = __webpack_require__(35);

var _ServerError2 = _interopRequireDefault(_ServerError);

var _calls = __webpack_require__(37);

var calls = _interopRequireWildcard(_calls);

var _ApiState = __webpack_require__(32);

var _ApiState2 = _interopRequireDefault(_ApiState);

var _custom = __webpack_require__(15);

var customCalls = _interopRequireWildcard(_custom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(0, _binaryUtils.getUniqueId)(); // skip 0 value
var defaultApiUrl = 'wss://frontend.binaryws.com/websockets/v3';
var nullFunc = function nullFunc() {};
var MockWebSocket = nullFunc;
var WebSocket = typeof window !== 'undefined' ? window.WebSocket : MockWebSocket;

var shouldIgnoreError = function shouldIgnoreError(error) {
    return error.code === 'AlreadySubscribed';
};

var LiveApi = function () {
    function LiveApi(initParams) {
        var _this = this;

        _classCallCheck(this, LiveApi);

        this.onOpen = function () {
            _this.resubscribe();
            _this.executeBufferedExecutes();
        };

        this.disconnect = function () {
            _this.token = '';
            _this.socket.onclose = nullFunc;
            try {
                _this.socket.close();
            } catch (e) {
                // ignore the error
            }
        };

        this.resubscribe = function () {
            var _apiState$getState = _this.apiState.getState(),
                token = _apiState$getState.token;

            var _resubscriptions = _this.resubscriptions,
                authorized = _resubscriptions.authorized,
                unauthorized = _resubscriptions.unauthorized;


            _this.authStream.take(1).subscribe(function () {
                Object.keys(authorized).forEach(function (msgType) {
                    return authorized[msgType]();
                });
                _this.sendBufferedSends();
            });

            Object.keys(unauthorized).forEach(function (msgType) {
                return unauthorized[msgType]();
            });

            if (token) {
                _this.authorize(token);
            } else {
                // this need to be called last as it mayb mutate
                // ticksHistory, candlesHistory and proposals
                _this.sendBufferedSends();
            }
        };

        this.getInState = function (name) {
            return _this.apiState.getState()[name];
        };

        this.resubscriptions = {
            authorized: {
                balance: function balance() {
                    if (_this.getInState('balance')) {
                        _this.subscribeToBalance();
                    }
                },
                transaction: function transaction() {
                    if (_this.getInState('transactions')) {
                        _this.subscribeToTransactions();
                    }
                },
                proposal_open_contract: function proposal_open_contract() {
                    if (_this.getInState('allContract')) {
                        _this.subscribeToAllOpenContracts();
                    }
                    _this.getInState('contracts').forEach(function (id) {
                        return _this.subscribeToOpenContract(id);
                    });
                }
            },
            unauthorized: {
                tick: function tick() {
                    if (_this.getInState('ticks').size !== 0) {
                        _this.subscribeToTicks([].concat(_this.getInState('ticks')));
                    }

                    _this.getInState('ticksHistory').forEach(function (param, symbol) {
                        return _this.getTickHistory(symbol, param);
                    });
                },
                ohlc: function ohlc() {
                    _this.getInState('candlesHistory').forEach(function (param, symbol) {
                        return _this.getTickHistory(symbol, param);
                    });
                },
                proposal: function proposal() {
                    _this.getInState('proposals').forEach(function (proposal) {
                        return _this.subscribeToPriceForContractProposal(proposal);
                    });
                }
            }
        };
        this.queuedResubscriptions = new Set();

        this.shouldResubscribeOnError = function (json) {
            var msgType = json.msg_type,
                error = json.error;


            var shouldResubscribe = ['CallError', 'WrongResponse', 'GetProposalFailure', 'ProposalArrayFailure', 'ContractValidationError', 'ContractCreationFailure'].includes(error.code);

            if (!shouldResubscribe) {
                return false;
            }

            Object.keys(_this.resubscriptions).forEach(function (k) {
                var stream = _this.resubscriptions[k];
                var type = Object.keys(stream).find(function (t) {
                    return t === msgType;
                });

                if (type && !_this.queuedResubscriptions.has(type)) {
                    _this.queuedResubscriptions.add(type);
                    setTimeout(function () {
                        _this.queuedResubscriptions.delete(type);
                        stream[type]();
                    }, 500);
                }
            });

            return true;
        };

        this.changeLanguage = function (ln) {
            if (ln === _this.language) {
                return;
            }
            _this.socket.onclose = nullFunc;
            try {
                _this.socket.close();
            } catch (e) {
                // ignore the error
            }
            _this.language = ln;
            _this.connect();
        };

        this.isReady = function () {
            return !!_this.socket && _this.socket.readyState === 1;
        };

        this.sendBufferedSends = function () {
            while (_this.bufferedSends.length > 0) {
                _this.bufferedSends.shift()();
            }
        };

        this.executeBufferedExecutes = function () {
            while (_this.bufferedExecutes.length > 0) {
                _this.bufferedExecutes.shift()();
            }
        };

        this.resolvePromiseForResponse = function (json) {
            if (typeof json.req_id === 'undefined') {
                return Promise.resolve();
            }

            var reqId = json.req_id.toString();
            var promise = _this.unresolvedPromises[reqId];

            if (!promise) {
                if (json.error) {
                    _this.shouldResubscribeOnError(json);
                }

                return Promise.resolve();
            }

            delete _this.unresolvedPromises[reqId];
            if (!json.error) {
                return promise.resolve(json);
            }

            if (!shouldIgnoreError(json.error)) {
                return promise.reject(new _ServerError2.default(json));
            }

            return Promise.resolve();
        };

        this.publishToObservables = function (json) {
            if (typeof json.req_id === 'undefined') {
                return;
            }

            var reqId = json.req_id.toString();

            var onetimeObs = _this.uncompleteOneTimeObs[reqId];

            var streamObs = _this.uncompleteStreamObs[reqId];

            if (!onetimeObs && !streamObs) {
                return;
            }

            if (!json.error) {
                if (onetimeObs) {
                    onetimeObs.onNext(json);
                    onetimeObs.onCompleted();
                } else {
                    streamObs.onNext(json);
                }
                return;
            }

            if (!shouldIgnoreError(json.error)) {
                if (onetimeObs) {
                    onetimeObs.onError(new _ServerError2.default(json));
                } else {
                    streamObs.onError(new _ServerError2.default(json));
                }
            }
        };

        this.onMessage = function (message) {
            var json = JSON.parse(message.data);

            if (json.msg_type === 'authorize' && _this.onAuth) {
                if (!json.error) {
                    _this.onAuth.next();
                }
            }

            if (!json.error) {
                _this.events.emit(json.msg_type, json);
            } else {
                _this.events.emit('error', json);
            }

            if (_this.useRx) {
                return _this.publishToObservables(json);
            }

            return _this.resolvePromiseForResponse(json);
        };

        this.generatePromiseOrObservable = function (json) {
            var reqId = json.req_id.toString();

            if (_this.useRx) {
                var obs = _rxLite.Observable.create(function (observer) {
                    // if call is an subscription, store it in uncompleteStreamObs
                    // ticks is a special case that's a stream without subscribe keyword
                    if (json.subscribe || json.ticks) {
                        _this.uncompleteStreamObs[reqId] = observer;
                    } else {
                        _this.uncompleteOneTimeObs[reqId] = observer;
                    }

                    return function () {
                        delete _this.uncompleteOneTimeObs[reqId];
                        delete _this.uncompleteStreamObs[reqId];
                    };
                });

                var published = obs.publish();

                return published; // use hot observables
            }

            return new Promise(function (resolve, reject) {
                _this.unresolvedPromises[reqId] = { resolve: resolve, reject: reject };
            });
        };

        this.sendAndUpdateState = function (callName) {
            for (var _len = arguments.length, param = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                param[_key - 1] = arguments[_key];
            }

            var reqId = (0, _binaryUtils.getUniqueId)();
            var actualPaylod = calls[callName].apply(calls, param);
            var json = _extends({
                req_id: reqId
            }, actualPaylod);

            var socketSend = function socketSend() {
                _this.sendSpy(JSON.stringify(json));
                _this.socket.send(JSON.stringify(json));
                if (_this.apiState[callName]) {
                    var _apiState;

                    (_apiState = _this.apiState)[callName].apply(_apiState, param);
                }
            };

            if (_this.isReady()) {
                socketSend();
            } else {
                _this.bufferedSends.push(socketSend);
            }

            if (typeof json.req_id !== 'undefined') {
                // Set the stream id into ApiState so that we can unsubscribe later
                // TODO: hackish and need redo, this depends on object identity to works!!!
                var setState = function setState(r) {
                    if (!_this.apiState[callName]) return r;

                    if (r.proposal_open_contract && r.proposal_open_contract.id) {
                        var _apiState2;

                        (_apiState2 = _this.apiState)[callName].apply(_apiState2, param.concat([r.proposal_open_contract.id]));
                    } else if (r.proposal && r.proposal.id) {
                        var _apiState3;

                        (_apiState3 = _this.apiState)[callName].apply(_apiState3, param.concat([r.proposal.id]));
                    }
                    return r;
                };

                if (_this.useRx) {
                    var connectableObs = _this.generatePromiseOrObservable(json);
                    connectableObs.take(1).forEach(setState);
                    return connectableObs;
                }

                return _this.generatePromiseOrObservable(json).then(setState);
            }

            return undefined;
        };

        this.execute = function (func) {
            if (_this.isReady()) {
                func();
            } else {
                _this.bufferedExecutes.push(func);
            }
        };

        this.send = function (json) {
            console.warn('This method is deprecated, use high-level methods'); // eslint-disable-line
            var reqId = (0, _binaryUtils.getUniqueId)();
            return _this.sendRaw(_extends({
                req_id: reqId
            }, json));
        };

        this.sendRaw = function (json) {
            console.warn('This method is deprecated, use high-level methods'); // eslint-disable-line
            var socketSend = function socketSend() {
                _this.sendSpy(JSON.stringify(json));
                _this.socket.send(JSON.stringify(json));
            };
            if (_this.isReady()) {
                socketSend();
            } else {
                _this.bufferedSends.push(socketSend);
            }

            if (typeof json.req_id !== 'undefined') {
                return _this.generatePromiseOrObservable(json);
            }

            return undefined;
        };

        var _ref = initParams || {},
            _ref$apiUrl = _ref.apiUrl,
            apiUrl = _ref$apiUrl === undefined ? defaultApiUrl : _ref$apiUrl,
            _ref$language = _ref.language,
            language = _ref$language === undefined ? 'en' : _ref$language,
            _ref$appId = _ref.appId,
            appId = _ref$appId === undefined ? 0 : _ref$appId,
            _ref$brand = _ref.brand,
            brand = _ref$brand === undefined ? '' : _ref$brand,
            _ref$sendSpy = _ref.sendSpy,
            sendSpy = _ref$sendSpy === undefined ? function () {} : _ref$sendSpy,
            websocket = _ref.websocket,
            connection = _ref.connection,
            keepAlive = _ref.keepAlive,
            _ref$useRx = _ref.useRx,
            useRx = _ref$useRx === undefined ? false : _ref$useRx;

        this.apiUrl = apiUrl;
        this.language = language;
        this.appId = appId;
        this.brand = brand;
        this.sendSpy = sendSpy;

        // experimental: use at your own risk
        this.useRx = useRx;

        if (keepAlive) {
            setInterval(function () {
                return _this.ping();
            }, 60 * 1000);
        }

        if (websocket) {
            WebSocket = websocket;
        }

        this.bufferedSends = [];
        this.bufferedExecutes = [];
        this.unresolvedPromises = {};

        this.events = new _LiveEvents2.default();
        this.apiState = new _ApiState2.default();

        if (useRx) {
            this.uncompleteOneTimeObs = {};
            this.uncompleteStreamObs = {};
        }

        this.authStream = _rxLite.Observable.create(function (observer) {
            _this.onAuth = observer;

            return function () {
                _this.onAuth = null;
            };
        });

        this.bindCallsAndStateMutators();

        this.connect(connection);
    }

    LiveApi.prototype.bindCallsAndStateMutators = function bindCallsAndStateMutators() {
        var _this2 = this;

        Object.keys(calls).forEach(function (callName) {
            _this2[callName] = function () {
                for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    params[_key2] = arguments[_key2];
                }

                return _this2.sendAndUpdateState.apply(_this2, [callName].concat(params));
            };
        });

        Object.keys(customCalls).forEach(function (callName) {
            _this2[callName] = function () {
                for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    params[_key3] = arguments[_key3];
                }

                return customCalls[callName].apply(customCalls, [_this2].concat(params));
            }; // seems to be a good place to do some simple cache
        });
    };

    LiveApi.prototype.connect = function connect(connection) {
        var _this3 = this;

        var optionalParam = this.brand ? '&brand=' + this.brand : '';
        var urlPlusParams = this.apiUrl + '?l=' + this.language + '&app_id=' + this.appId + optionalParam;

        Object.keys(this.unresolvedPromises).forEach(function (reqId) {
            var disconnectedError = new Error('Websocket disconnected before response received.');
            disconnectedError.name = 'DisconnectError';
            _this3.unresolvedPromises[reqId].reject(disconnectedError);
            delete _this3.unresolvedPromises[reqId];
        });

        try {
            this.socket = connection || new WebSocket(urlPlusParams);
        } catch (err) {
            // swallow connection error, we can't do anything about it
        } finally {
            this.socket.onopen = this.onOpen;
            this.socket.onclose = function () {
                return _this3.connect();
            };
            this.socket.onmessage = this.onMessage;
        }
    };

    // TODO: should we deprecate this? preserve for backward compatibility


    // TODO: should we deprecate this? preserve for backward compatibility


    return LiveApi;
}();

exports.default = LiveApi;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var oauthUrl = exports.oauthUrl = function oauthUrl(appId) {
    return 'https://www.binary.com/oauth2/authorize?app_id=' + appId;
};

var oauthUrlWithLanguage = exports.oauthUrlWithLanguage = function oauthUrlWithLanguage(appId, langCode) {
    return 'https://www.binary.com/oauth2/authorize?app_id=' + appId + '&l=' + langCode;
};

var parseOAuthResponse = exports.parseOAuthResponse = function parseOAuthResponse(responseUrl) {
    var matcher = /acct\d=(\w+)&token\d=([\w-]+)/g;
    var urlParts = responseUrl.split('/redirect?');
    if (urlParts.length !== 2) throw new Error('Not a valid url');

    var params = urlParts[1].split(matcher);

    var accounts = [];

    for (var i = 1; i < params.length; i += 3) {
        accounts.push({
            account: params[i],
            token: params[i + 1]
        });
    }

    return accounts;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ServerError = function (_Error) {
    _inherits(ServerError, _Error);

    function ServerError(errorObj) {
        _classCallCheck(this, ServerError);

        var _this = _possibleConstructorReturn(this, _Error.call(this, errorObj));

        _this.stack = new Error().stack;
        _this.error = errorObj;
        _this.name = errorObj.error.code;

        var message = errorObj.error.message,
            echo_req = errorObj.echo_req;


        var echoStr = JSON.stringify(echo_req, null, 2);
        _this.message = "[ServerError] " + message + "\n" + echoStr;
        return _this;
    }

    return ServerError;
}(Error);

exports.default = ServerError;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var deleteApiToken = exports.deleteApiToken = function deleteApiToken(token) {
    return {
        api_token: 1,
        delete_token: token
    };
};

var getApiTokens = exports.getApiTokens = function getApiTokens() {
    return {
        api_token: 1
    };
};

var createApiToken = exports.createApiToken = function createApiToken(token, scopes) {
    return {
        api_token: 1,
        new_token: token,
        new_token_scopes: scopes
    };
};

var changePassword = exports.changePassword = function changePassword(oldPassword, newPassword) {
    return {
        change_password: 1,
        old_password: oldPassword,
        new_password: newPassword
    };
};

var registerApplication = exports.registerApplication = function registerApplication(options) {
    return _extends({
        app_register: 1
    }, options);
};

var getAllAppList = exports.getAllAppList = function getAllAppList() {
    return {
        app_list: 1
    };
};

var getAppslistById = exports.getAppslistById = function getAppslistById(appid) {
    return {
        app_get: appid
    };
};

var deleteApplication = exports.deleteApplication = function deleteApplication(appid) {
    return {
        app_delete: appid
    };
};

var createRealAccountMaltaInvest = exports.createRealAccountMaltaInvest = function createRealAccountMaltaInvest(options) {
    return _extends({
        new_account_maltainvest: 1
    }, options);
};

var createRealAccount = exports.createRealAccount = function createRealAccount(options) {
    return _extends({
        new_account_real: 1
    }, options);
};

var setAccountCurrency = exports.setAccountCurrency = function setAccountCurrency(currency) {
    return {
        set_account_currency: currency
    };
};

var setSelfExclusion = exports.setSelfExclusion = function setSelfExclusion(options) {
    return _extends({
        set_self_exclusion: 1
    }, options);
};

var setAccountSettings = exports.setAccountSettings = function setAccountSettings(options) {
    return _extends({
        set_settings: 1
    }, options);
};

var setTnCApproval = exports.setTnCApproval = function setTnCApproval() {
    return {
        tnc_approval: 1
    };
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _unauthenticated = __webpack_require__(41);

Object.keys(_unauthenticated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _unauthenticated[key];
    }
  });
});

var _read = __webpack_require__(39);

Object.keys(_read).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _read[key];
    }
  });
});

var _trade = __webpack_require__(40);

Object.keys(_trade).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _trade[key];
    }
  });
});

var _payments = __webpack_require__(38);

Object.keys(_payments).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _payments[key];
    }
  });
});

var _admin = __webpack_require__(36);

Object.keys(_admin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _admin[key];
    }
  });
});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getCashierLockStatus = exports.getCashierLockStatus = function getCashierLockStatus() {
    return {
        cashier_password: 1
    };
};

var setCashierLock = exports.setCashierLock = function setCashierLock(options) {
    return _extends({
        cashier_password: 1
    }, options);
};

var withdrawToPaymentAgent = exports.withdrawToPaymentAgent = function withdrawToPaymentAgent(options) {
    return _extends({
        paymentagent_withdraw: 1
    }, options);
};

var paymentAgentTransfer = exports.paymentAgentTransfer = function paymentAgentTransfer(options) {
    return _extends({
        paymentagent_transfer: 1
    }, options);
};

var transferBetweenAccounts = exports.transferBetweenAccounts = function transferBetweenAccounts(options) {
    return _extends({
        transfer_between_accounts: 1
    }, options);
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getAccountLimits = exports.getAccountLimits = function getAccountLimits() {
    return {
        get_limits: 1
    };
};

var getAccountSettings = exports.getAccountSettings = function getAccountSettings() {
    return {
        get_settings: 1
    };
};

var getAccountStatus = exports.getAccountStatus = function getAccountStatus() {
    return {
        get_account_status: 1
    };
};

var getSelfExclusion = exports.getSelfExclusion = function getSelfExclusion() {
    return {
        get_self_exclusion: 1
    };
};

var logOut = exports.logOut = function logOut() {
    return {
        logout: 1
    };
};

var getStatement = exports.getStatement = function getStatement(options) {
    return _extends({
        statement: 1
    }, options);
};

var getPortfolio = exports.getPortfolio = function getPortfolio() {
    return {
        portfolio: 1
    };
};

var getProfitTable = exports.getProfitTable = function getProfitTable(options) {
    return _extends({
        profit_table: 1
    }, options);
};

var getRealityCheckSummary = exports.getRealityCheckSummary = function getRealityCheckSummary() {
    return {
        reality_check: 1
    };
};

var subscribeToBalance = exports.subscribeToBalance = function subscribeToBalance() {
    return {
        balance: 1,
        subscribe: 1
    };
};

var unsubscribeFromBalance = exports.unsubscribeFromBalance = function unsubscribeFromBalance() {
    return {
        forget_all: 'balance'
    };
};

var subscribeToOpenContract = exports.subscribeToOpenContract = function subscribeToOpenContract(contractId) {
    return {
        proposal_open_contract: 1,
        subscribe: 1,
        contract_id: contractId
    };
};

var getContractInfo = exports.getContractInfo = function getContractInfo(contractId) {
    return {
        proposal_open_contract: 1,
        contract_id: contractId
    };
};

var subscribeToAllOpenContracts = exports.subscribeToAllOpenContracts = function subscribeToAllOpenContracts() {
    return {
        proposal_open_contract: 1,
        subscribe: 1
    };
};

var unsubscribeFromAllOpenContracts = exports.unsubscribeFromAllOpenContracts = function unsubscribeFromAllOpenContracts() {
    return {
        forget_all: 'proposal_open_contract'
    };
};

var subscribeToTransactions = exports.subscribeToTransactions = function subscribeToTransactions() {
    return {
        transaction: 1,
        subscribe: 1
    };
};

var unsubscribeFromTransactions = exports.unsubscribeFromTransactions = function unsubscribeFromTransactions() {
    return {
        forget_all: 'transaction'
    };
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var buyContract = exports.buyContract = function buyContract(contractId, price) {
    return {
        buy: contractId,
        price: price
    };
};

var buyContractParams = exports.buyContractParams = function buyContractParams(params, price) {
    return {
        buy: 1,
        price: price,
        parameters: params
    };
};

var sellContract = exports.sellContract = function sellContract(contractId, price) {
    return {
        sell: contractId,
        price: price
    };
};

var sellExpiredContracts = exports.sellExpiredContracts = function sellExpiredContracts() {
    return {
        sell_expired: 1
    };
};

var topUpVirtualAccount = exports.topUpVirtualAccount = function topUpVirtualAccount() {
    return {
        topup_virtual: 1
    };
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getActiveSymbolsBrief = exports.getActiveSymbolsBrief = function getActiveSymbolsBrief() {
    return {
        active_symbols: 'brief'
    };
};

var getActiveSymbolsFull = exports.getActiveSymbolsFull = function getActiveSymbolsFull() {
    return {
        active_symbols: 'full'
    };
};

var getAssetIndex = exports.getAssetIndex = function getAssetIndex() {
    return {
        asset_index: 1
    };
};

var authorize = exports.authorize = function authorize(token) {
    return {
        authorize: token
    };
};

var getContractsForSymbol = exports.getContractsForSymbol = function getContractsForSymbol(symbol) {
    return {
        contracts_for: symbol
    };
};

var unsubscribeFromTick = exports.unsubscribeFromTick = function unsubscribeFromTick(symbol) {
    return {
        forget: symbol
    };
};

var unsubscribeFromTicks = exports.unsubscribeFromTicks = function unsubscribeFromTicks(symbols) {
    return {
        forget: symbols
    };
};

var unsubscribeByID = exports.unsubscribeByID = function unsubscribeByID(id) {
    return {
        forget: id
    };
};

var unsubscribeFromAllTicks = exports.unsubscribeFromAllTicks = function unsubscribeFromAllTicks() {
    return {
        forget_all: 'ticks'
    };
};

var unsubscribeFromAllCandles = exports.unsubscribeFromAllCandles = function unsubscribeFromAllCandles() {
    return {
        forget_all: 'candles'
    };
};

var unsubscribeFromAllProposals = exports.unsubscribeFromAllProposals = function unsubscribeFromAllProposals() {
    return {
        forget_all: 'proposal'
    };
};

var unsubscribeFromAllPortfolios = exports.unsubscribeFromAllPortfolios = function unsubscribeFromAllPortfolios() {
    return {
        forget_all: 'portfolio'
    };
};

var getLandingCompany = exports.getLandingCompany = function getLandingCompany(landingCompany) {
    return {
        landing_company: landingCompany
    };
};

var getLandingCompanyDetails = exports.getLandingCompanyDetails = function getLandingCompanyDetails(landingCompany) {
    return {
        landing_company_details: landingCompany
    };
};

var createVirtualAccount = exports.createVirtualAccount = function createVirtualAccount(options) {
    return _extends({
        new_account_virtual: 1
    }, options);
};

var ping = exports.ping = function ping() {
    return {
        ping: 1
    };
};

var getPaymentAgentsForCountry = exports.getPaymentAgentsForCountry = function getPaymentAgentsForCountry(countryCode) {
    return {
        paymentagent_list: countryCode
    };
};

var getPayoutCurrencies = exports.getPayoutCurrencies = function getPayoutCurrencies() {
    return {
        payout_currencies: 1
    };
};

var getPriceProposalForContract = exports.getPriceProposalForContract = function getPriceProposalForContract(options) {
    return _extends({
        proposal: 1
    }, options);
};

var subscribeToPriceForContractProposal = exports.subscribeToPriceForContractProposal = function subscribeToPriceForContractProposal(options) {
    return _extends({
        proposal: 1,
        subscribe: 1
    }, options);
};

var getResidences = exports.getResidences = function getResidences() {
    return {
        residence_list: 1
    };
};

var getStatesForCountry = exports.getStatesForCountry = function getStatesForCountry(countryCode) {
    return {
        states_list: countryCode
    };
};

var subscribeToTick = exports.subscribeToTick = function subscribeToTick(symbol) {
    return {
        ticks: symbol
    };
};

var subscribeToTicks = exports.subscribeToTicks = function subscribeToTicks(symbols) {
    return {
        ticks: symbols
    };
};

var getTickHistory = exports.getTickHistory = function getTickHistory(symbol, options) {
    return _extends({
        ticks_history: symbol
    }, options || { end: 'latest' });
};

var getCandles = exports.getCandles = function getCandles(symbol, options) {
    return _extends({
        ticks_history: symbol,
        style: 'candles'
    }, options || { end: 'latest' });
};

var getCandlesForLastNDays = exports.getCandlesForLastNDays = function getCandlesForLastNDays(symbol, ndays) {
    return {
        ticks_history: symbol,
        style: 'candles',
        start: Math.floor(Date.now() / 1000) - (ndays - 1) * 60 * 60 * 24,
        end: 'latest',
        granularity: 60 * 60 * 24,
        count: 30
    };
};

var getServerTime = exports.getServerTime = function getServerTime() {
    return {
        time: 1
    };
};

var getTradingTimes = exports.getTradingTimes = function getTradingTimes(date) {
    return {
        trading_times: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    };
};

var verifyEmail = exports.verifyEmail = function verifyEmail(email, type) {
    return {
        verify_email: email,
        type: type
    };
};

var getWebsiteStatus = exports.getWebsiteStatus = function getWebsiteStatus() {
    return {
        website_status: 1
    };
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (a, b) {
    if (a.length !== b.length) {
        return false;
    }

    return !a.some(function (x, idx) {
        return x !== b[idx];
    });
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (arr) {
    return Math.max.apply(Math, _toConsumableArray(arr));
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (arr) {
    return Math.min.apply(Math, _toConsumableArray(arr));
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr) {
    return arr && (arr.length === 0 ? undefined : arr[arr.length - 1]);
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr, key) {
    return arr.reduce(function (a, b) {
        var kv = b[key];
        var idx = a.findIndex(function (g) {
            return g.some(function (e) {
                return e[key] === kv;
            });
        });

        if (idx > -1) {
            a[idx].push(b);
        } else {
            a.push([b]);
        }
        return a;
    }, []);
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr1, arr2) {
    var getter1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (x) {
        return x;
    };
    var getter2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
        return x;
    };
    var deduplication = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    /**
     * compare element using getter
     * @param a
     * @param b
     * @returns {number}
     *   0  -> equal
     *   1  -> `a` bigger than `b`
     *   -1 -> `b` bigger than `a`
     */
    var compare = function compare(a, b) {
        var valA = getter1(a);
        var valB = getter2(b);

        if (valA > valB) {
            return 1;
        }

        if (valA < valB) {
            return -1;
        }

        return 0;
    };

    // clone so that does not change arguments
    var a1Clone = arr1.slice(0);
    var a2Clone = arr2.slice(0);

    var result = [];

    // loop until both array is empty
    while (a1Clone.length > 0 || a2Clone.length > 0) {
        var a1Head = a1Clone[0];
        var a2Head = a2Clone[0];

        if (!a1Head) {
            result = result.concat(a2Clone);
            break; // break if one of the array is empty
        }

        if (!a2Head) {
            result = result.concat(a1Clone);
            break; // break if one of the array is empty
        }

        var last = result.length > 0 && result[result.length - 1];
        var toAdd = void 0;
        switch (compare(a1Head, a2Head)) {
            case 0:
                {
                    if (deduplication) a2Clone.shift();
                    toAdd = a1Clone.shift();
                    break;
                }
            // a2Head is smaller
            case 1:
                {
                    toAdd = a2Clone.shift();
                    break;
                }
            // a1Head is smaller
            case -1:
                {
                    toAdd = a1Clone.shift();
                    break;
                }
            default: // impossible
        }

        // if dedup is true, do not append same element
        if (deduplication && last && getter1(last) === getter2(toAdd)) {
            break;
        }
        result.push(toAdd);
    }

    return result;
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (n) {
    return Array.from(Array(n).keys());
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getAbsoluteBarrierFromContract = __webpack_require__(7);

var _getAbsoluteBarrierFromContract2 = _interopRequireDefault(_getAbsoluteBarrierFromContract);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contract, lastTickQuote) {
    return (0, _getAbsoluteBarrierFromContract2.default)(contract, lastTickQuote, 'barrier2');
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getAbsoluteBarrierFromContract = __webpack_require__(7);

var _getAbsoluteBarrierFromContract2 = _interopRequireDefault(_getAbsoluteBarrierFromContract);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contract, lastTickQuote) {
    return (0, _getAbsoluteBarrierFromContract2.default)(contract, lastTickQuote, 'barrier');
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _relativeBarrier = __webpack_require__(17);

var _relativeBarrier2 = _interopRequireDefault(_relativeBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contract, lastTickQuote) {
    return contract.barrier ? (0, _relativeBarrier2.default)(contract, lastTickQuote) : +contract.entry_spot || lastTickQuote;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _groupByKey = __webpack_require__(4);

var _groupByKey2 = _interopRequireDefault(_groupByKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extractDigitBarrierHelper = function extractDigitBarrierHelper(contractsGroupedByExpiry) {
    var expiryTypes = Object.keys(contractsGroupedByExpiry);
    var result = {};
    expiryTypes.forEach(function (et) {
        var contractsByExpiry = contractsGroupedByExpiry[et];
        result[et] = [{
            name: 'Digit',
            values: contractsByExpiry[0].last_digit_range,
            defaultValue: contractsByExpiry[0].last_digit_range[0]
        }];
    });
    return result;
};

var extract2BarriersHelper = function extract2BarriersHelper(contractsGroupedByExpiry) {
    var expiryTypes = Object.keys(contractsGroupedByExpiry);
    var result = {};
    expiryTypes.forEach(function (et) {
        var contractsByExpiry = contractsGroupedByExpiry[et];
        result[et] = [{ name: 'High barrier', defaultValue: contractsByExpiry[0].high_barrier }, { name: 'Low barrier', defaultValue: contractsByExpiry[0].low_barrier }];
    });
    return result;
};

var extract1BarrierHelper = function extract1BarrierHelper(contractGroupedByExpiry, barrierName) {
    var expiryTypes = Object.keys(contractGroupedByExpiry);
    var result = {};
    expiryTypes.forEach(function (et) {
        var contractsByExpiry = contractGroupedByExpiry[et];
        var contractWithBarrier = contractsByExpiry.find(function (c) {
            return !!c.barrier;
        });
        if (!contractWithBarrier) {
            return;
        }
        result[et] = [{ name: barrierName, defaultValue: contractWithBarrier.barrier }];
    });
    return result;
};

exports.default = function (contracts, type) {
    var groupByExpiryType = (0, _groupByKey2.default)(contracts, 'expiry_type');

    switch (type) {
        // types with 1 barrier
        case 'CALL':
            return extract1BarrierHelper(groupByExpiryType, 'Higher than');
        case 'PUT':
            return extract1BarrierHelper(groupByExpiryType, 'Lower than');
        case 'ONETOUCH':
        case 'NOTOUCH':
            return extract1BarrierHelper(groupByExpiryType, 'Touch spot');

        // types with 2 barriers
        case 'EXPIRYMISS':
        case 'EXPIRYRANGE':
        case 'RANGE':
        case 'UPORDOWN':
            return extract2BarriersHelper(groupByExpiryType);

        // special case: digit type
        case 'DIGITMATCH':
        case 'DIGITDIFF':
        case 'DIGITOVER':
        case 'DIGITUNDER':
            return extractDigitBarrierHelper(groupByExpiryType);

        // These types do not have barrier
        case 'DIGITODD':
        case 'DIGITEVEN':
        case 'ASIANU':
        case 'ASIAND':
        case 'SPREADU':
        case 'SPREADD':
        default:
            return undefined;
    }
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commonRelativeBarrier = __webpack_require__(6);

var _commonRelativeBarrier2 = _interopRequireDefault(_commonRelativeBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contract, lastTickQuote) {
    return (0, _commonRelativeBarrier2.default)(contract.barrier2, contract.entry_spot, lastTickQuote);
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (date) {
    return Math.floor(date.getTime() / 1000);
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (date) {
    return date.toISOString().replace(/T/, ' ').replace(/\..+/, '');
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (date) {
    return date.toISOString().slice(11, 19);
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _epochToDate = __webpack_require__(2);

var _epochToDate2 = _interopRequireDefault(_epochToDate);

var _dateToDateString = __webpack_require__(0);

var _dateToDateString2 = _interopRequireDefault(_dateToDateString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var epoch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return (0, _dateToDateString2.default)((0, _epochToDate2.default)(epoch));
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _epochToDate = __webpack_require__(2);

var _epochToDate2 = _interopRequireDefault(_epochToDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (epoch) {
    return (0, _epochToDate2.default)(epoch).toUTCString();
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dateToTimeString = __webpack_require__(18);

var _dateToTimeString2 = _interopRequireDefault(_dateToTimeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (epoch) {
    return (0, _dateToTimeString2.default)(new Date(epoch * 1000));
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _epochToDate = __webpack_require__(2);

var _epochToDate2 = _interopRequireDefault(_epochToDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var epoch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return (0, _epochToDate2.default)(epoch).toISOString().slice(0, 10);
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (epoch) {
    return new Date(epoch * 1000).toISOString().slice(11, 19);
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (x) {
	var d = new Date();
	d.setMonth(d.getMonth() - x);
	return Math.floor(d.getTime() / 1000);
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (date) {
    return !isNaN(date.getTime());
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (time) {
    var tokens = time.split(':');
    if (tokens.length < 2 || tokens.length > 3) {
        return false;
    }

    return tokens.map(function (val, ind) {
        switch (ind) {
            case 0:
                return parseInt(val, 0) < 24;
            case 1:
                return parseInt(val, 0) <= 59;
            default:
                return parseInt(val, 0) <= 59;
        }
    }).indexOf(false) === -1;
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDayEpoch = __webpack_require__(1);

var _xDayEpoch2 = _interopRequireDefault(_xDayEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return (0, _xDayEpoch2.default)(-29);
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDayEpoch = __webpack_require__(1);

var _xDayEpoch2 = _interopRequireDefault(_xDayEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return (0, _xDayEpoch2.default)(-6);
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (x) {
    var tmr = new Date();
    tmr.setDate(tmr.getDate() + x);
    return tmr;
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dateToDateString = __webpack_require__(0);

var _dateToDateString2 = _interopRequireDefault(_dateToDateString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	var d = new Date();
	d.setFullYear(new Date().getFullYear() + 1);
	return (0, _dateToDateString2.default)(d);
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (inputValue, bridge) {
    return inputValue.split(bridge).map(function (obj) {
        switch (obj.length) {
            case 0:
                return '01';
            case 1:
                return '0' + (obj === '0' ? '1' : obj);
            default:
                return obj;
        }
    }).join(bridge);
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (inputValue, bridge) {
    return inputValue.split(bridge).map(function (obj) {
        switch (obj.length) {
            case 0:
                return '00';
            case 1:
                return '0' + obj;
            default:
                return obj;
        }
    }).join(bridge);
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (secs) {
    var days = Math.floor(secs / 60 / 60 / 24);
    var hours = Math.floor(secs % (60 * 60 * 24) / (60 * 60));
    var minutes = Math.floor(secs % (60 * 60) / 60);
    var seconds = Math.floor(secs % 60);
    return (days > 0 ? days + ' day(s)' : '') + (hours > 0 ? hours + ' hour(s)' : '') + (minutes > 0 ? minutes + ' minute(s)' : '') + (seconds > 0 ? seconds + ' second(s)' : '');
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nowAsEpoch = __webpack_require__(9);

var _nowAsEpoch2 = _interopRequireDefault(_nowAsEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (loginTime, interval) {
    return interval - ((0, _nowAsEpoch2.default)() - loginTime) % interval;
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _timeStringBigger = __webpack_require__(10);

var _timeStringBigger2 = _interopRequireDefault(_timeStringBigger);

var _timeStringSmaller = __webpack_require__(20);

var _timeStringSmaller2 = _interopRequireDefault(_timeStringSmaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (start, end, target) {
    if ((0, _timeStringBigger2.default)(end, start)) {
        return (0, _timeStringBigger2.default)(target, start) && (0, _timeStringSmaller2.default)(target, end);
    }
    /**
     * if open time is bigger than close time
     * target should not between close and open time
     * eg. '09:00:00' is not between '23:00:00' (start) and '08:00:00'(close)
     * because it is between '08:00:00' to '23:00:00'
     * */

    return !((0, _timeStringBigger2.default)(target, end) && (0, _timeStringSmaller2.default)(target, start));
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

// only supported format = "hh:mm", seconds are not supported
exports.default = function (timeString) {
    var tokens = timeString.split(':');
    if (tokens.length !== 2) {
        throw new Error('Time string format incorrect, expecting HH:mm, actual: ' + timeString);
    }
    var h = +tokens[0];
    var m = +tokens[1];

    return h * 3600 + m * 60;
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDayEpoch = __webpack_require__(1);

var _xDayEpoch2 = _interopRequireDefault(_xDayEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return (0, _xDayEpoch2.default)(0);
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dateToDateString = __webpack_require__(0);

var _dateToDateString2 = _interopRequireDefault(_dateToDateString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _dateToDateString2.default)(new Date());
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return new Date().toISOString().slice(0, 10);
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (m) {
	return new Date(new Date().setMonth(new Date().getMonth() + m));
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dateToDateString = __webpack_require__(0);

var _dateToDateString2 = _interopRequireDefault(_dateToDateString);

var _yesterdayEpoch = __webpack_require__(11);

var _yesterdayEpoch2 = _interopRequireDefault(_yesterdayEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _dateToDateString2.default)(new Date((0, _yesterdayEpoch2.default)() * 1000));
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _yesterdayEpoch = __webpack_require__(11);

var _yesterdayEpoch2 = _interopRequireDefault(_yesterdayEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return new Date((0, _yesterdayEpoch2.default)() * 1000).toISOString().slice(0, 10);
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (handler) {
    document.addEventListener('fullscreenchange', function () {
        return handler(document.fullscreen);
    });
    document.addEventListener('webkitfullscreenchange', function () {
        return handler(document.webkitIsFullScreen);
    });
    document.addEventListener('mozfullscreenchange', function () {
        return handler(document.mozFullScreen);
    });
    document.addEventListener('MSFullscreenChange', function () {
        return handler(document.msFullscreenElement);
    });
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    }
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (handler) {
    document.removeEventListener('fullscreenchange', handler);
    document.removeEventListener('webkitfullscreenchange', handler);
    document.removeEventListener('mozfullscreenchange', handler);
    document.removeEventListener('MSFullscreenChange', handler);
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (elem) {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
    }
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = typeof alert !== 'undefined' ? alert : function () {};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = typeof alert !== 'undefined' ? alert : function () {};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    if (typeof window === 'undefined') return;
    setTimeout(function () {
        return window.dispatchEvent(new Event('resize'));
    }, 100);
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (unit) {
    return {
        t: 'Ticks',
        s: 'Seconds',
        m: 'Minutes',
        h: 'Hours',
        d: 'Days'
    }[unit];
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extractDurationHelper = __webpack_require__(12);

var _extractDurationHelper2 = _interopRequireDefault(_extractDurationHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contracts, type) {
    var contractsOfType = contracts.filter(function (c) {
        return c.contract_type === type;
    });
    var nonForwardStartingContracts = contractsOfType.filter(function (c) {
        return !c.forward_starting_options;
    });

    if (nonForwardStartingContracts.length === 0) {
        return undefined;
    }

    return (0, _extractDurationHelper2.default)(nonForwardStartingContracts, type);
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _arrayToObject = __webpack_require__(16);

var _arrayToObject2 = _interopRequireDefault(_arrayToObject);

var _groupByKey = __webpack_require__(4);

var _groupByKey2 = _interopRequireDefault(_groupByKey);

var _extractDurationHelper = __webpack_require__(12);

var _extractDurationHelper2 = _interopRequireDefault(_extractDurationHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contracts, type) {
    var forwardStartingContracts = contracts.filter(function (c) {
        return !!c.forward_starting_options && c.contract_type === type;
    });
    if (forwardStartingContracts.length === 0) {
        return undefined;
    }

    var forwardOptions = forwardStartingContracts[0].forward_starting_options;
    var groupByDate = (0, _groupByKey2.default)(forwardOptions || [], 'date');
    var forwardStartingRange = [];
    Object.keys(groupByDate).sort(function (a, b) {
        return +a - +b;
    }).forEach(function (date) {
        var timesPerDateArr = groupByDate[date].map(function (obj) {
            var open = new Date(obj.open * 1000);
            var close = new Date(obj.close * 1000);
            return { open: open, close: close };
        });
        var timesPerDateObj = (0, _arrayToObject2.default)(timesPerDateArr);
        forwardStartingRange.push(_extends({ date: new Date(date * 1000) }, timesPerDateObj));
    });

    var forwardStartingDurations = (0, _extractDurationHelper2.default)(forwardStartingContracts, type);
    return {
        range: forwardStartingRange,
        options: forwardStartingDurations
    };
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isDurationTick = __webpack_require__(24);

var _isDurationTick2 = _interopRequireDefault(_isDurationTick);

var _durationToSecs = __webpack_require__(3);

var _durationToSecs2 = _interopRequireDefault(_durationToSecs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (duration, durationUnit) {
    return (0, _isDurationTick2.default)(durationUnit) || (0, _durationToSecs2.default)(duration, durationUnit) < 120;
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (duration, durationUnit, ranges) {
    var relatedBlock = ranges.find(function (r) {
        return r.unit === durationUnit;
    });

    if (!relatedBlock) {
        return false;
    }

    return duration <= relatedBlock.max && duration >= relatedBlock.min;
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var nullFunc = function nullFunc() {};

var analytics = function analytics(ga) {
    return ga || typeof window !== 'undefined' && window.ga || nullFunc;
};

var trackUserId = exports.trackUserId = function trackUserId(userId, ga) {
    return analytics(ga)('set', 'userId', userId);
};

var trackRoute = exports.trackRoute = function trackRoute(route, ga) {
    return analytics(ga)('send', 'pageview', route);
};

var trackEvent = exports.trackEvent = function trackEvent(category, action, label, ga) {
    return analytics(ga)('send', {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    });
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (percentage) {
    return "rgba(42, 48, 82, " + percentage + ")";
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (value) {
    return value < 0 && 'number-negative' || value > 0 && 'number-positive' || '';
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (text) {
    return text.split(')').length > 1 ? text.split(')')[1] : text;
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var uniqueId = 0;

exports.default = function () {
  return uniqueId++;
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable wrap-iife, no-useless-escape, space-infix-ops */
function isMobileBrowser() {
    var check = false;
    (function (a) {
        // This regex is retrieved from http://detectmobilebrowsers.com/ on 27 Nov 2017.
        // If this code below doesn't detect accordingly, update the regex from there.
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

exports.default = function () {
    return typeof window !== 'undefined' && (isMobileBrowser() || !!window.cordova);
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (email) {
    return (/\S+@\S+\.\S+/.test(email)
    );
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (password) {
    return (/^[ -~]{6,25}$/.test(password)
    );
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getLastDigit = __webpack_require__(26);

var _getLastDigit2 = _interopRequireDefault(_getLastDigit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (ticks, pips) {
    return ticks.reduce(function (acc, x) {
        var digit = (0, _getLastDigit2.default)(x.quote, pips);
        acc[digit]++;
        return acc;
    }, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]).map(function (x) {
        return ticks.length && x / ticks.length * 100;
    });
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (digits) {
    return Math.pow(10, -digits);
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (n) {
    var numStr = n.toString();
    return numStr.includes('.') ? numStr.split('.')[1].length : 0;
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (n) {
    return n > 0 ? '+' + n : n.toString();
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (pipSize) {
    if (isNaN(pipSize)) {
        return '0.01';
    }
    var zeros = Array(pipSize).join('0');
    return '0.' + zeros + 1;
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (pips) {
    return Math.abs(Math.log10(pips));
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (value) {
    return (+value).toFixed(2);
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (obj, predicate) {
    return Object.keys(obj).reduce(function (acc, key) {
        if (predicate(obj[key])) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Find if certain value is true in the object
 * @param obj
 * @param predicate     (object, index) => true|false
 * @returns {boolean}
 */
var findDeep = function findDeep(obj, predicate) {
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null || obj === undefined) {
        return false;
    }

    var allChildren = Object.keys(obj).map(function (k) {
        return obj[k];
    });
    var childrenMeetPredicate = allChildren.map(function (child, k) {
        return predicate(child, k);
    });
    if (childrenMeetPredicate.indexOf(true) > -1) {
        return true;
    }
    var childrenResult = allChildren.map(function (child) {
        return findDeep(child, predicate);
    });
    return childrenResult.indexOf(true) > -1;
};

exports.default = findDeep;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var toPlainJS = exports.toPlainJS = function toPlainJS(obj) {
    return obj && (typeof obj.toJS === 'undefined' ? obj : obj.toJS());
};

exports.default = function (obj) {
    return obj && Object.keys(obj).reduce(function (acc, key) {
        acc[key] = toPlainJS(obj[key]);
        return acc;
    }, {});
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr1, arr2) {
    return arr1.length === arr2.length && arr1.every(function (x, idx) {
        return x === arr2[idx];
    });
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (ohlc1, ohlc2) {
    var o1Len = ohlc1.length;
    var o2Len = ohlc2.length;

    if (o1Len !== o2Len) {
        return false;
    }

    if (o1Len === 0) {
        return true;
    }

    var o1Last = ohlc1[o1Len - 1];
    var o2Last = ohlc2[o2Len - 1];

    return o1Last.epoch === o2Last.epoch && o1Last.close === o2Last.close;
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (ticks1, ticks2) {
    return ticks1.length === ticks2.length && (ticks1.length === 0 || ticks1[ticks1.length - 1].epoch === ticks2[ticks2.length - 1].epoch);
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _doCandleEqual = __webpack_require__(27);

var _doCandleEqual2 = _interopRequireDefault(_doCandleEqual);

var _doArrayDifferJustOneEntry = __webpack_require__(13);

var _doArrayDifferJustOneEntry2 = _interopRequireDefault(_doArrayDifferJustOneEntry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (candles1, candles2) {
    return (0, _doArrayDifferJustOneEntry2.default)(candles1, candles2, _doCandleEqual2.default);
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _doTicksEqual = __webpack_require__(28);

var _doTicksEqual2 = _interopRequireDefault(_doTicksEqual);

var _doArrayDifferJustOneEntry = __webpack_require__(13);

var _doArrayDifferJustOneEntry2 = _interopRequireDefault(_doArrayDifferJustOneEntry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (ticks1, ticks2) {
    return (0, _doArrayDifferJustOneEntry2.default)(ticks1, ticks2, _doTicksEqual2.default);
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (candles) {
    return candles && (candles.length === 0 ? undefined : +candles[candles.length - 1].close);
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (ticks) {
    return ticks && ticks.length > 0 ? ticks[ticks.length - 1].quote : undefined;
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

// a zip + map, but I do not find we need it much, so no need to generalize
exports.default = function (history) {
    return history.times.map(function (t, idx) {
        return {
            epoch: +t,
            quote: +history.prices[idx]
        };
    });
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

// open_time is used when data is stream
exports.default = function (candle) {
    return [+(candle.open_time || candle.epoch) * 1000, +candle.open, +candle.high, +candle.low, +candle.close];
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (candles) {
    return candles.map(function (data) {
        return { quote: +data.open, epoch: +data.epoch };
    });
};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (tick) {
    return [+tick.epoch * 1000, +tick.quote];
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (proposal) {
    return proposal && +proposal.ask_price;
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nowAsEpoch = __webpack_require__(9);

var _nowAsEpoch2 = _interopRequireDefault(_nowAsEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contract) {
    var nowEpoch = (0, _nowAsEpoch2.default)();
    if (contract.tick_count) {
        var _start = +contract.date_start - 5;
        var exitTime = +contract.exit_tick_time + 5;
        var _end = exitTime || nowEpoch;
        return { start: _start, end: _end };
    }

    var bufferSize = 0.05; // 5 % buffer
    var contractStart = +contract.date_start;
    var contractEnd = +contract.exit_tick_time || +contract.date_expiry;

    if (contractEnd <= contractStart) {
        var e = new RangeError('Contract ends time is earlier than start time');
        e.name = 'ContractEndsBeforeStart';
        throw e;
    }

    var buffer = (contractEnd - contractStart) * bufferSize;
    var bufferedExitTime = contractEnd + buffer;

    var start = buffer ? contractStart - buffer : contractStart;
    var end = contractEnd ? bufferedExitTime : nowEpoch;

    return {
        end: Math.round(end),
        start: Math.round(start)
    };
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (category) {
    return {
        callput: 'Up/Down',
        risefall: 'Rise/Fall',
        higherlower: 'Higher/Lower',
        asian: 'Asians',
        digits: 'Digits',
        endsinout: 'Ends In/Out',
        staysinout: 'Stays In/Out',
        touchnotouch: 'Touch/No Touch',
        spreads: 'Spreads'
    }[category];
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (code) {
	return {
		contract_id: 'Contract ID',
		purchase_time: 'Purchase Time',
		ask_price: 'Ask Price',
		bid_price: 'Bid Price',
		date_start: 'Start Time',
		date_expiry: 'Expiry Time',
		date_settlement: 'Settlement Time',
		expiry_time: 'Expiry Time',

		current_spot: 'Current Spot',
		current_spot_time: 'Current Spot Time',
		entry_spot: 'Entry Spot',
		entry_tick_time: 'Entry Spot Time',
		sell_price: 'Sell Price',
		payout: 'Potential Payout',
		buy_price: 'Purchase Price',

		barrier: 'Barrier',
		low_barrier: 'Low Barrier',
		high_barrier: 'High Barrier',

		sell_time: 'Sell Time',

		exit_tick_time: 'Exit Spot Time', // to be confirmed
		exit_tick: 'Exit Spot', // to show both or not?

		sell_spot_time: 'DO NOT USE',
		entry_tick: 'DO NOT USE',
		sell_spot: 'DO NOT USE'
	}[code];
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (contracts) {
    return {
        amountPerPoint: contracts[0].amount_per_point,
        stopType: contracts[0].stop_type,
        stopLoss: contracts[0].stop_loss,
        stopProfit: contracts[0].stop_profit
    };
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _durationToSecs = __webpack_require__(3);

var _durationToSecs2 = _interopRequireDefault(_durationToSecs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (duration, unit) {
    return (0, _durationToSecs2.default)(duration, unit) < 60 * 60 * 24;
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _groupByKey = __webpack_require__(4);

var _groupByKey2 = _interopRequireDefault(_groupByKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contracts) {
    var extraRemoved = contracts.map(function (contract) {
        return {
            amount_per_point: contract.amount_per_point,
            barrier: contract.barrier,
            barriers: contract.barriers,
            contract_category: contract.contract_category,
            contract_category_display: contract.contract_category_display,
            contract_display: contract.contract_display,
            contract_type: contract.contract_type,
            expiry_type: contract.expiry_type,
            forward_starting_options: contract.forward_starting_options,
            high_barrier: contract.high_barrier,
            last_digit_range: contract.last_digit_range,
            low_barrier: contract.low_barrier,
            min_contract_duration: contract.min_contract_duration,
            max_contract_duration: contract.max_contract_duration,
            stop_type: contract.stop_type,
            stop_loss: contract.stop_loss,
            stop_profit: contract.stop_profit
        };
    });

    var groupByCategory = (0, _groupByKey2.default)(extraRemoved, 'contract_category');
    var allCategory = Object.keys(groupByCategory);
    allCategory.forEach(function (c) {
        var relatedContracts = groupByCategory[c];
        var groupByType = (0, _groupByKey2.default)(relatedContracts, 'contract_type');
        groupByCategory[c] = groupByType;
    });

    return groupByCategory;
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tradeTypeCodeToText = __webpack_require__(29);

var _tradeTypeCodeToText2 = _interopRequireDefault(_tradeTypeCodeToText);

var _typeHasBarrier = __webpack_require__(30);

var _typeHasBarrier2 = _interopRequireDefault(_typeHasBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (code, barrier) {
    return (0, _tradeTypeCodeToText2.default)(code) + ((0, _typeHasBarrier2.default)(code) ? ' ' + barrier : '');
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tradeTypes = __webpack_require__(5);

var _tradeTypes2 = _interopRequireDefault(_tradeTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (text) {
    var tradeType = _tradeTypes2.default.find(function (x) {
        return x.text === text;
    });
    if (!tradeType) throw new Error('Unknown trade type text');
    return tradeType.value;
};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global, process) {var __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) Microsoft, All rights reserved. See License.txt in the project root for license information.

;(function (undefined) {

  var objectTypes = {
    'function': true,
    'object': true
  };

  function checkGlobal(value) {
    return (value && value.Object === Object) ? value : null;
  }

  var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType) ? exports : null;
  var freeModule = (objectTypes[typeof module] && module && !module.nodeType) ? module : null;
  var freeGlobal = checkGlobal(freeExports && freeModule && typeof global === 'object' && global);
  var freeSelf = checkGlobal(objectTypes[typeof self] && self);
  var freeWindow = checkGlobal(objectTypes[typeof window] && window);
  var moduleExports = (freeModule && freeModule.exports === freeExports) ? freeExports : null;
  var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
  var root = freeGlobal || ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) || freeSelf || thisGlobal || Function('return this')();

  var Rx = {
    internals: {},
    config: {
      Promise: root.Promise
    },
    helpers: { }
  };

  // Defaults
  var noop = Rx.helpers.noop = function () { },
    identity = Rx.helpers.identity = function (x) { return x; },
    defaultNow = Rx.helpers.defaultNow = Date.now,
    defaultComparer = Rx.helpers.defaultComparer = function (x, y) { return isEqual(x, y); },
    defaultSubComparer = Rx.helpers.defaultSubComparer = function (x, y) { return x > y ? 1 : (x < y ? -1 : 0); },
    defaultKeySerializer = Rx.helpers.defaultKeySerializer = function (x) { return x.toString(); },
    defaultError = Rx.helpers.defaultError = function (err) { throw err; },
    isPromise = Rx.helpers.isPromise = function (p) { return !!p && typeof p.subscribe !== 'function' && typeof p.then === 'function'; },
    isFunction = Rx.helpers.isFunction = (function () {

      var isFn = function (value) {
        return typeof value == 'function' || false;
      };

      // fallback for older versions of Chrome and Safari
      if (isFn(/x/)) {
        isFn = function(value) {
          return typeof value == 'function' && toString.call(value) == '[object Function]';
        };
      }

      return isFn;
    }());

    function cloneArray(arr) {
      var len = arr.length, a = new Array(len);
      for(var i = 0; i < len; i++) { a[i] = arr[i]; }
      return a;
    }

  var errorObj = {e: {}};
  
  function tryCatcherGen(tryCatchTarget) {
    return function tryCatcher() {
      try {
        return tryCatchTarget.apply(this, arguments);
      } catch (e) {
        errorObj.e = e;
        return errorObj;
      }
    };
  }

  var tryCatch = Rx.internals.tryCatch = function tryCatch(fn) {
    if (!isFunction(fn)) { throw new TypeError('fn must be a function'); }
    return tryCatcherGen(fn);
  };

  function thrower(e) {
    throw e;
  }

  Rx.config.longStackSupport = false;
  var hasStacks = false, stacks = tryCatch(function () { throw new Error(); })();
  hasStacks = !!stacks.e && !!stacks.e.stack;

  // All code after this point will be filtered from stack traces reported by RxJS
  var rStartingLine = captureLine(), rFileName;

  var STACK_JUMP_SEPARATOR = 'From previous event:';

  function makeStackTraceLong(error, observable) {
    // If possible, transform the error stack trace by removing Node and RxJS
    // cruft, then concatenating with the stack trace of `observable`.
    if (hasStacks &&
        observable.stack &&
        typeof error === 'object' &&
        error !== null &&
        error.stack &&
        error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1
    ) {
      var stacks = [];
      for (var o = observable; !!o; o = o.source) {
        if (o.stack) {
          stacks.unshift(o.stack);
        }
      }
      stacks.unshift(error.stack);

      var concatedStacks = stacks.join('\n' + STACK_JUMP_SEPARATOR + '\n');
      error.stack = filterStackString(concatedStacks);
    }
  }

  function filterStackString(stackString) {
    var lines = stackString.split('\n'), desiredLines = [];
    for (var i = 0, len = lines.length; i < len; i++) {
      var line = lines[i];

      if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
        desiredLines.push(line);
      }
    }
    return desiredLines.join('\n');
  }

  function isInternalFrame(stackLine) {
    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);
    if (!fileNameAndLineNumber) {
      return false;
    }
    var fileName = fileNameAndLineNumber[0], lineNumber = fileNameAndLineNumber[1];

    return fileName === rFileName &&
      lineNumber >= rStartingLine &&
      lineNumber <= rEndingLine;
  }

  function isNodeFrame(stackLine) {
    return stackLine.indexOf('(module.js:') !== -1 ||
      stackLine.indexOf('(node.js:') !== -1;
  }

  function captureLine() {
    if (!hasStacks) { return; }

    try {
      throw new Error();
    } catch (e) {
      var lines = e.stack.split('\n');
      var firstLine = lines[0].indexOf('@') > 0 ? lines[1] : lines[2];
      var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
      if (!fileNameAndLineNumber) { return; }

      rFileName = fileNameAndLineNumber[0];
      return fileNameAndLineNumber[1];
    }
  }

  function getFileNameAndLineNumber(stackLine) {
    // Named functions: 'at functionName (filename:lineNumber:columnNumber)'
    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
    if (attempt1) { return [attempt1[1], Number(attempt1[2])]; }

    // Anonymous functions: 'at filename:lineNumber:columnNumber'
    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
    if (attempt2) { return [attempt2[1], Number(attempt2[2])]; }

    // Firefox style: 'function@filename:lineNumber or @filename:lineNumber'
    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
    if (attempt3) { return [attempt3[1], Number(attempt3[2])]; }
  }

  var EmptyError = Rx.EmptyError = function() {
    this.message = 'Sequence contains no elements.';
    Error.call(this);
  };
  EmptyError.prototype = Object.create(Error.prototype);
  EmptyError.prototype.name = 'EmptyError';

  var ObjectDisposedError = Rx.ObjectDisposedError = function() {
    this.message = 'Object has been disposed';
    Error.call(this);
  };
  ObjectDisposedError.prototype = Object.create(Error.prototype);
  ObjectDisposedError.prototype.name = 'ObjectDisposedError';

  var ArgumentOutOfRangeError = Rx.ArgumentOutOfRangeError = function () {
    this.message = 'Argument out of range';
    Error.call(this);
  };
  ArgumentOutOfRangeError.prototype = Object.create(Error.prototype);
  ArgumentOutOfRangeError.prototype.name = 'ArgumentOutOfRangeError';

  var NotSupportedError = Rx.NotSupportedError = function (message) {
    this.message = message || 'This operation is not supported';
    Error.call(this);
  };
  NotSupportedError.prototype = Object.create(Error.prototype);
  NotSupportedError.prototype.name = 'NotSupportedError';

  var NotImplementedError = Rx.NotImplementedError = function (message) {
    this.message = message || 'This operation is not implemented';
    Error.call(this);
  };
  NotImplementedError.prototype = Object.create(Error.prototype);
  NotImplementedError.prototype.name = 'NotImplementedError';

  var notImplemented = Rx.helpers.notImplemented = function () {
    throw new NotImplementedError();
  };

  var notSupported = Rx.helpers.notSupported = function () {
    throw new NotSupportedError();
  };

  // Shim in iterator support
  var $iterator$ = (typeof Symbol === 'function' && Symbol.iterator) ||
    '_es6shim_iterator_';
  // Bug for mozilla version
  if (root.Set && typeof new root.Set()['@@iterator'] === 'function') {
    $iterator$ = '@@iterator';
  }

  var doneEnumerator = Rx.doneEnumerator = { done: true, value: undefined };

  var isIterable = Rx.helpers.isIterable = function (o) {
    return o && o[$iterator$] !== undefined;
  };

  var isArrayLike = Rx.helpers.isArrayLike = function (o) {
    return o && o.length !== undefined;
  };

  Rx.helpers.iterator = $iterator$;

  var bindCallback = Rx.internals.bindCallback = function (func, thisArg, argCount) {
    if (typeof thisArg === 'undefined') { return func; }
    switch(argCount) {
      case 0:
        return function() {
          return func.call(thisArg)
        };
      case 1:
        return function(arg) {
          return func.call(thisArg, arg);
        };
      case 2:
        return function(value, index) {
          return func.call(thisArg, value, index);
        };
      case 3:
        return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
    }

    return function() {
      return func.apply(thisArg, arguments);
    };
  };

  /** Used to determine if values are of the language type Object */
  var dontEnums = ['toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'constructor'],
  dontEnumsLength = dontEnums.length;

var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dateTag] = typedArrayTags[errorTag] =
typedArrayTags[funcTag] = typedArrayTags[mapTag] =
typedArrayTags[numberTag] = typedArrayTags[objectTag] =
typedArrayTags[regexpTag] = typedArrayTags[setTag] =
typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

var objectProto = Object.prototype,
    hasOwnProperty = objectProto.hasOwnProperty,
    objToString = objectProto.toString,
    MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;

var keys = Object.keys || (function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

    return function(obj) {
      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [], prop, i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());

function equalObjects(object, other, equalFunc, isLoose, stackA, stackB) {
  var objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength !== othLength && !isLoose) {
    return false;
  }
  var index = objLength, key;
  while (index--) {
    key = objProps[index];
    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  var skipCtor = isLoose;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key],
        result;

    if (!(result === undefined ? equalFunc(objValue, othValue, isLoose, stackA, stackB) : result)) {
      return false;
    }
    skipCtor || (skipCtor = key === 'constructor');
  }
  if (!skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    if (objCtor !== othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor === 'function' && objCtor instanceof objCtor &&
          typeof othCtor === 'function' && othCtor instanceof othCtor)) {
      return false;
    }
  }
  return true;
}

function equalByTag(object, other, tag) {
  switch (tag) {
    case boolTag:
    case dateTag:
      return +object === +other;

    case errorTag:
      return object.name === other.name && object.message === other.message;

    case numberTag:
      return (object !== +object) ?
        other !== +other :
        object === +other;

    case regexpTag:
    case stringTag:
      return object === (other + '');
  }
  return false;
}

var isObject = Rx.internals.isObject = function(value) {
  var type = typeof value;
  return !!value && (type === 'object' || type === 'function');
};

function isObjectLike(value) {
  return !!value && typeof value === 'object';
}

function isLength(value) {
  return typeof value === 'number' && value > -1 && value % 1 === 0 && value <= MAX_SAFE_INTEGER;
}

var isHostObject = (function() {
  try {
    Object({ 'toString': 0 } + '');
  } catch(e) {
    return function() { return false; };
  }
  return function(value) {
    return typeof value.toString !== 'function' && typeof (value + '') === 'string';
  };
}());

function isTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
}

var isArray = Array.isArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) === arrayTag;
};

function arraySome (array, predicate) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

function equalArrays(array, other, equalFunc, isLoose, stackA, stackB) {
  var index = -1,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength !== othLength && !(isLoose && othLength > arrLength)) {
    return false;
  }
  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index],
        result;

    if (result !== undefined) {
      if (result) {
        continue;
      }
      return false;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (isLoose) {
      if (!arraySome(other, function(othValue) {
            return arrValue === othValue || equalFunc(arrValue, othValue, isLoose, stackA, stackB);
          })) {
        return false;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, isLoose, stackA, stackB))) {
      return false;
    }
  }
  return true;
}

function baseIsEqualDeep(object, other, equalFunc, isLoose, stackA, stackB) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = objToString.call(object);
    if (objTag === argsTag) {
      objTag = objectTag;
    } else if (objTag !== objectTag) {
      objIsArr = isTypedArray(object);
    }
  }
  if (!othIsArr) {
    othTag = objToString.call(other);
    if (othTag === argsTag) {
      othTag = objectTag;
    }
  }
  var objIsObj = objTag === objectTag && !isHostObject(object),
      othIsObj = othTag === objectTag && !isHostObject(other),
      isSameTag = objTag === othTag;

  if (isSameTag && !(objIsArr || objIsObj)) {
    return equalByTag(object, other, objTag);
  }
  if (!isLoose) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, isLoose, stackA, stackB);
    }
  }
  if (!isSameTag) {
    return false;
  }
  // Assume cyclic values are equal.
  // For more information on detecting circular references see https://es5.github.io/#JO.
  stackA || (stackA = []);
  stackB || (stackB = []);

  var length = stackA.length;
  while (length--) {
    if (stackA[length] === object) {
      return stackB[length] === other;
    }
  }
  // Add `object` and `other` to the stack of traversed objects.
  stackA.push(object);
  stackB.push(other);

  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, isLoose, stackA, stackB);

  stackA.pop();
  stackB.pop();

  return result;
}

function baseIsEqual(value, other, isLoose, stackA, stackB) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, isLoose, stackA, stackB);
}

var isEqual = Rx.internals.isEqual = function (value, other) {
  return baseIsEqual(value, other);
};

  var hasProp = {}.hasOwnProperty,
      slice = Array.prototype.slice;

  var inherits = Rx.internals.inherits = function (child, parent) {
    function __() { this.constructor = child; }
    __.prototype = parent.prototype;
    child.prototype = new __();
  };

  var addProperties = Rx.internals.addProperties = function (obj) {
    for(var sources = [], i = 1, len = arguments.length; i < len; i++) { sources.push(arguments[i]); }
    for (var idx = 0, ln = sources.length; idx < ln; idx++) {
      var source = sources[idx];
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  };

  // Rx Utils
  var addRef = Rx.internals.addRef = function (xs, r) {
    return new AnonymousObservable(function (observer) {
      return new BinaryDisposable(r.getDisposable(), xs.subscribe(observer));
    });
  };

  function arrayInitialize(count, factory) {
    var a = new Array(count);
    for (var i = 0; i < count; i++) {
      a[i] = factory();
    }
    return a;
  }

  /**
   * Represents a group of disposable resources that are disposed together.
   * @constructor
   */
  var CompositeDisposable = Rx.CompositeDisposable = function () {
    var args = [], i, len;
    if (Array.isArray(arguments[0])) {
      args = arguments[0];
    } else {
      len = arguments.length;
      args = new Array(len);
      for(i = 0; i < len; i++) { args[i] = arguments[i]; }
    }
    this.disposables = args;
    this.isDisposed = false;
    this.length = args.length;
  };

  var CompositeDisposablePrototype = CompositeDisposable.prototype;

  /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Mixed} item Disposable to add.
   */
  CompositeDisposablePrototype.add = function (item) {
    if (this.isDisposed) {
      item.dispose();
    } else {
      this.disposables.push(item);
      this.length++;
    }
  };

  /**
   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
   * @param {Mixed} item Disposable to remove.
   * @returns {Boolean} true if found; false otherwise.
   */
  CompositeDisposablePrototype.remove = function (item) {
    var shouldDispose = false;
    if (!this.isDisposed) {
      var idx = this.disposables.indexOf(item);
      if (idx !== -1) {
        shouldDispose = true;
        this.disposables.splice(idx, 1);
        this.length--;
        item.dispose();
      }
    }
    return shouldDispose;
  };

  /**
   *  Disposes all disposables in the group and removes them from the group.
   */
  CompositeDisposablePrototype.dispose = function () {
    if (!this.isDisposed) {
      this.isDisposed = true;
      var len = this.disposables.length, currentDisposables = new Array(len);
      for(var i = 0; i < len; i++) { currentDisposables[i] = this.disposables[i]; }
      this.disposables = [];
      this.length = 0;

      for (i = 0; i < len; i++) {
        currentDisposables[i].dispose();
      }
    }
  };

  /**
   * Provides a set of static methods for creating Disposables.
   * @param {Function} dispose Action to run during the first call to dispose. The action is guaranteed to be run at most once.
   */
  var Disposable = Rx.Disposable = function (action) {
    this.isDisposed = false;
    this.action = action || noop;
  };

  /** Performs the task of cleaning up resources. */
  Disposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this.action();
      this.isDisposed = true;
    }
  };

  /**
   * Creates a disposable object that invokes the specified action when disposed.
   * @param {Function} dispose Action to run during the first call to dispose. The action is guaranteed to be run at most once.
   * @return {Disposable} The disposable object that runs the given action upon disposal.
   */
  var disposableCreate = Disposable.create = function (action) { return new Disposable(action); };

  /**
   * Gets the disposable that does nothing when disposed.
   */
  var disposableEmpty = Disposable.empty = { dispose: noop };

  /**
   * Validates whether the given object is a disposable
   * @param {Object} Object to test whether it has a dispose method
   * @returns {Boolean} true if a disposable object, else false.
   */
  var isDisposable = Disposable.isDisposable = function (d) {
    return d && isFunction(d.dispose);
  };

  var checkDisposed = Disposable.checkDisposed = function (disposable) {
    if (disposable.isDisposed) { throw new ObjectDisposedError(); }
  };

  var disposableFixup = Disposable._fixup = function (result) {
    return isDisposable(result) ? result : disposableEmpty;
  };

  // Single assignment
  var SingleAssignmentDisposable = Rx.SingleAssignmentDisposable = function () {
    this.isDisposed = false;
    this.current = null;
  };
  SingleAssignmentDisposable.prototype.getDisposable = function () {
    return this.current;
  };
  SingleAssignmentDisposable.prototype.setDisposable = function (value) {
    if (this.current) { throw new Error('Disposable has already been assigned'); }
    var shouldDispose = this.isDisposed;
    !shouldDispose && (this.current = value);
    shouldDispose && value && value.dispose();
  };
  SingleAssignmentDisposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this.isDisposed = true;
      var old = this.current;
      this.current = null;
      old && old.dispose();
    }
  };

  // Multiple assignment disposable
  var SerialDisposable = Rx.SerialDisposable = function () {
    this.isDisposed = false;
    this.current = null;
  };
  SerialDisposable.prototype.getDisposable = function () {
    return this.current;
  };
  SerialDisposable.prototype.setDisposable = function (value) {
    var shouldDispose = this.isDisposed;
    if (!shouldDispose) {
      var old = this.current;
      this.current = value;
    }
    old && old.dispose();
    shouldDispose && value && value.dispose();
  };
  SerialDisposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this.isDisposed = true;
      var old = this.current;
      this.current = null;
    }
    old && old.dispose();
  };

  var BinaryDisposable = Rx.BinaryDisposable = function (first, second) {
    this._first = first;
    this._second = second;
    this.isDisposed = false;
  };

  BinaryDisposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this.isDisposed = true;
      var old1 = this._first;
      this._first = null;
      old1 && old1.dispose();
      var old2 = this._second;
      this._second = null;
      old2 && old2.dispose();
    }
  };

  var NAryDisposable = Rx.NAryDisposable = function (disposables) {
    this._disposables = disposables;
    this.isDisposed = false;
  };

  NAryDisposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this.isDisposed = true;
      for (var i = 0, len = this._disposables.length; i < len; i++) {
        this._disposables[i].dispose();
      }
      this._disposables.length = 0;
    }
  };

  /**
   * Represents a disposable resource that only disposes its underlying disposable resource when all dependent disposable objects have been disposed.
   */
  var RefCountDisposable = Rx.RefCountDisposable = (function () {

    function InnerDisposable(disposable) {
      this.disposable = disposable;
      this.disposable.count++;
      this.isInnerDisposed = false;
    }

    InnerDisposable.prototype.dispose = function () {
      if (!this.disposable.isDisposed && !this.isInnerDisposed) {
        this.isInnerDisposed = true;
        this.disposable.count--;
        if (this.disposable.count === 0 && this.disposable.isPrimaryDisposed) {
          this.disposable.isDisposed = true;
          this.disposable.underlyingDisposable.dispose();
        }
      }
    };

    /**
     * Initializes a new instance of the RefCountDisposable with the specified disposable.
     * @constructor
     * @param {Disposable} disposable Underlying disposable.
      */
    function RefCountDisposable(disposable) {
      this.underlyingDisposable = disposable;
      this.isDisposed = false;
      this.isPrimaryDisposed = false;
      this.count = 0;
    }

    /**
     * Disposes the underlying disposable only when all dependent disposables have been disposed
     */
    RefCountDisposable.prototype.dispose = function () {
      if (!this.isDisposed && !this.isPrimaryDisposed) {
        this.isPrimaryDisposed = true;
        if (this.count === 0) {
          this.isDisposed = true;
          this.underlyingDisposable.dispose();
        }
      }
    };

    /**
     * Returns a dependent disposable that when disposed decreases the refcount on the underlying disposable.
     * @returns {Disposable} A dependent disposable contributing to the reference count that manages the underlying disposable's lifetime.
     */
    RefCountDisposable.prototype.getDisposable = function () {
      return this.isDisposed ? disposableEmpty : new InnerDisposable(this);
    };

    return RefCountDisposable;
  })();

  var ScheduledItem = Rx.internals.ScheduledItem = function (scheduler, state, action, dueTime, comparer) {
    this.scheduler = scheduler;
    this.state = state;
    this.action = action;
    this.dueTime = dueTime;
    this.comparer = comparer || defaultSubComparer;
    this.disposable = new SingleAssignmentDisposable();
  };

  ScheduledItem.prototype.invoke = function () {
    this.disposable.setDisposable(this.invokeCore());
  };

  ScheduledItem.prototype.compareTo = function (other) {
    return this.comparer(this.dueTime, other.dueTime);
  };

  ScheduledItem.prototype.isCancelled = function () {
    return this.disposable.isDisposed;
  };

  ScheduledItem.prototype.invokeCore = function () {
    return disposableFixup(this.action(this.scheduler, this.state));
  };

  /** Provides a set of static properties to access commonly used schedulers. */
  var Scheduler = Rx.Scheduler = (function () {

    function Scheduler() { }

    /** Determines whether the given object is a scheduler */
    Scheduler.isScheduler = function (s) {
      return s instanceof Scheduler;
    };

    var schedulerProto = Scheduler.prototype;

    /**
   * Schedules an action to be executed.
   * @param state State passed to the action to be executed.
   * @param {Function} action Action to be executed.
   * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
   */
    schedulerProto.schedule = function (state, action) {
      throw new NotImplementedError();
    };

  /**
   * Schedules an action to be executed after dueTime.
   * @param state State passed to the action to be executed.
   * @param {Function} action Action to be executed.
   * @param {Number} dueTime Relative time after which to execute the action.
   * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
   */
    schedulerProto.scheduleFuture = function (state, dueTime, action) {
      var dt = dueTime;
      dt instanceof Date && (dt = dt - this.now());
      dt = Scheduler.normalize(dt);

      if (dt === 0) { return this.schedule(state, action); }

      return this._scheduleFuture(state, dt, action);
    };

    schedulerProto._scheduleFuture = function (state, dueTime, action) {
      throw new NotImplementedError();
    };

    /** Gets the current time according to the local machine's system clock. */
    Scheduler.now = defaultNow;

    /** Gets the current time according to the local machine's system clock. */
    Scheduler.prototype.now = defaultNow;

    /**
     * Normalizes the specified TimeSpan value to a positive value.
     * @param {Number} timeSpan The time span value to normalize.
     * @returns {Number} The specified TimeSpan value if it is zero or positive; otherwise, 0
     */
    Scheduler.normalize = function (timeSpan) {
      timeSpan < 0 && (timeSpan = 0);
      return timeSpan;
    };

    return Scheduler;
  }());

  var normalizeTime = Scheduler.normalize, isScheduler = Scheduler.isScheduler;

  (function (schedulerProto) {

    function invokeRecImmediate(scheduler, pair) {
      var state = pair[0], action = pair[1], group = new CompositeDisposable();
      action(state, innerAction);
      return group;

      function innerAction(state2) {
        var isAdded = false, isDone = false;

        var d = scheduler.schedule(state2, scheduleWork);
        if (!isDone) {
          group.add(d);
          isAdded = true;
        }

        function scheduleWork(_, state3) {
          if (isAdded) {
            group.remove(d);
          } else {
            isDone = true;
          }
          action(state3, innerAction);
          return disposableEmpty;
        }
      }
    }

    function invokeRecDate(scheduler, pair) {
      var state = pair[0], action = pair[1], group = new CompositeDisposable();
      action(state, innerAction);
      return group;

      function innerAction(state2, dueTime1) {
        var isAdded = false, isDone = false;

        var d = scheduler.scheduleFuture(state2, dueTime1, scheduleWork);
        if (!isDone) {
          group.add(d);
          isAdded = true;
        }

        function scheduleWork(_, state3) {
          if (isAdded) {
            group.remove(d);
          } else {
            isDone = true;
          }
          action(state3, innerAction);
          return disposableEmpty;
        }
      }
    }

    /**
     * Schedules an action to be executed recursively.
     * @param {Mixed} state State passed to the action to be executed.
     * @param {Function} action Action to execute recursively. The last parameter passed to the action is used to trigger recursive scheduling of the action, passing in recursive invocation state.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleRecursive = function (state, action) {
      return this.schedule([state, action], invokeRecImmediate);
    };

    /**
     * Schedules an action to be executed recursively after a specified relative or absolute due time.
     * @param {Mixed} state State passed to the action to be executed.
     * @param {Function} action Action to execute recursively. The last parameter passed to the action is used to trigger recursive scheduling of the action, passing in the recursive due time and invocation state.
     * @param {Number | Date} dueTime Relative or absolute time after which to execute the action for the first time.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleRecursiveFuture = function (state, dueTime, action) {
      return this.scheduleFuture([state, action], dueTime, invokeRecDate);
    };

  }(Scheduler.prototype));

  (function (schedulerProto) {

    /**
     * Schedules a periodic piece of work by dynamically discovering the scheduler's capabilities. The periodic task will be scheduled using window.setInterval for the base implementation.
     * @param {Mixed} state Initial state passed to the action upon the first iteration.
     * @param {Number} period Period for running the work periodically.
     * @param {Function} action Action to be executed, potentially updating the state.
     * @returns {Disposable} The disposable object used to cancel the scheduled recurring action (best effort).
     */
    schedulerProto.schedulePeriodic = function(state, period, action) {
      if (typeof root.setInterval === 'undefined') { throw new NotSupportedError(); }
      period = normalizeTime(period);
      var s = state, id = root.setInterval(function () { s = action(s); }, period);
      return disposableCreate(function () { root.clearInterval(id); });
    };

  }(Scheduler.prototype));

  /** Gets a scheduler that schedules work immediately on the current thread. */
   var ImmediateScheduler = (function (__super__) {
    inherits(ImmediateScheduler, __super__);
    function ImmediateScheduler() {
      __super__.call(this);
    }

    ImmediateScheduler.prototype.schedule = function (state, action) {
      return disposableFixup(action(this, state));
    };

    return ImmediateScheduler;
  }(Scheduler));

  var immediateScheduler = Scheduler.immediate = new ImmediateScheduler();

  /**
   * Gets a scheduler that schedules work as soon as possible on the current thread.
   */
  var CurrentThreadScheduler = (function (__super__) {
    var queue;

    function runTrampoline () {
      while (queue.length > 0) {
        var item = queue.dequeue();
        !item.isCancelled() && item.invoke();
      }
    }

    inherits(CurrentThreadScheduler, __super__);
    function CurrentThreadScheduler() {
      __super__.call(this);
    }

    CurrentThreadScheduler.prototype.schedule = function (state, action) {
      var si = new ScheduledItem(this, state, action, this.now());

      if (!queue) {
        queue = new PriorityQueue(4);
        queue.enqueue(si);

        var result = tryCatch(runTrampoline)();
        queue = null;
        if (result === errorObj) { thrower(result.e); }
      } else {
        queue.enqueue(si);
      }
      return si.disposable;
    };

    CurrentThreadScheduler.prototype.scheduleRequired = function () { return !queue; };

    return CurrentThreadScheduler;
  }(Scheduler));

  var currentThreadScheduler = Scheduler.currentThread = new CurrentThreadScheduler();

  var SchedulePeriodicRecursive = Rx.internals.SchedulePeriodicRecursive = (function () {
    function createTick(self) {
      return function tick(command, recurse) {
        recurse(0, self._period);
        var state = tryCatch(self._action)(self._state);
        if (state === errorObj) {
          self._cancel.dispose();
          thrower(state.e);
        }
        self._state = state;
      };
    }

    function SchedulePeriodicRecursive(scheduler, state, period, action) {
      this._scheduler = scheduler;
      this._state = state;
      this._period = period;
      this._action = action;
    }

    SchedulePeriodicRecursive.prototype.start = function () {
      var d = new SingleAssignmentDisposable();
      this._cancel = d;
      d.setDisposable(this._scheduler.scheduleRecursiveFuture(0, this._period, createTick(this)));

      return d;
    };

    return SchedulePeriodicRecursive;
  }());

  var scheduleMethod, clearMethod;

  var localTimer = (function () {
    var localSetTimeout, localClearTimeout = noop;
    if (!!root.setTimeout) {
      localSetTimeout = root.setTimeout;
      localClearTimeout = root.clearTimeout;
    } else if (!!root.WScript) {
      localSetTimeout = function (fn, time) {
        root.WScript.Sleep(time);
        fn();
      };
    } else {
      throw new NotSupportedError();
    }

    return {
      setTimeout: localSetTimeout,
      clearTimeout: localClearTimeout
    };
  }());
  var localSetTimeout = localTimer.setTimeout,
    localClearTimeout = localTimer.clearTimeout;

  (function () {

    var nextHandle = 1, tasksByHandle = {}, currentlyRunning = false;

    clearMethod = function (handle) {
      delete tasksByHandle[handle];
    };

    function runTask(handle) {
      if (currentlyRunning) {
        localSetTimeout(function () { runTask(handle); }, 0);
      } else {
        var task = tasksByHandle[handle];
        if (task) {
          currentlyRunning = true;
          var result = tryCatch(task)();
          clearMethod(handle);
          currentlyRunning = false;
          if (result === errorObj) { thrower(result.e); }
        }
      }
    }

    var reNative = new RegExp('^' +
      String(toString)
        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        .replace(/toString| for [^\]]+/g, '.*?') + '$'
    );

    var setImmediate = typeof (setImmediate = freeGlobal && moduleExports && freeGlobal.setImmediate) == 'function' &&
      !reNative.test(setImmediate) && setImmediate;

    function postMessageSupported () {
      // Ensure not in a worker
      if (!root.postMessage || root.importScripts) { return false; }
      var isAsync = false, oldHandler = root.onmessage;
      // Test for async
      root.onmessage = function () { isAsync = true; };
      root.postMessage('', '*');
      root.onmessage = oldHandler;

      return isAsync;
    }

    // Use in order, setImmediate, nextTick, postMessage, MessageChannel, script readystatechanged, setTimeout
    if (isFunction(setImmediate)) {
      scheduleMethod = function (action) {
        var id = nextHandle++;
        tasksByHandle[id] = action;
        setImmediate(function () { runTask(id); });

        return id;
      };
    } else if (typeof process !== 'undefined' && {}.toString.call(process) === '[object process]') {
      scheduleMethod = function (action) {
        var id = nextHandle++;
        tasksByHandle[id] = action;
        process.nextTick(function () { runTask(id); });

        return id;
      };
    } else if (postMessageSupported()) {
      var MSG_PREFIX = 'ms.rx.schedule' + Math.random();

      var onGlobalPostMessage = function (event) {
        // Only if we're a match to avoid any other global events
        if (typeof event.data === 'string' && event.data.substring(0, MSG_PREFIX.length) === MSG_PREFIX) {
          runTask(event.data.substring(MSG_PREFIX.length));
        }
      };

      root.addEventListener('message', onGlobalPostMessage, false);

      scheduleMethod = function (action) {
        var id = nextHandle++;
        tasksByHandle[id] = action;
        root.postMessage(MSG_PREFIX + id, '*');
        return id;
      };
    } else if (!!root.MessageChannel) {
      var channel = new root.MessageChannel();

      channel.port1.onmessage = function (e) { runTask(e.data); };

      scheduleMethod = function (action) {
        var id = nextHandle++;
        tasksByHandle[id] = action;
        channel.port2.postMessage(id);
        return id;
      };
    } else if ('document' in root && 'onreadystatechange' in root.document.createElement('script')) {

      scheduleMethod = function (action) {
        var scriptElement = root.document.createElement('script');
        var id = nextHandle++;
        tasksByHandle[id] = action;

        scriptElement.onreadystatechange = function () {
          runTask(id);
          scriptElement.onreadystatechange = null;
          scriptElement.parentNode.removeChild(scriptElement);
          scriptElement = null;
        };
        root.document.documentElement.appendChild(scriptElement);
        return id;
      };

    } else {
      scheduleMethod = function (action) {
        var id = nextHandle++;
        tasksByHandle[id] = action;
        localSetTimeout(function () {
          runTask(id);
        }, 0);

        return id;
      };
    }
  }());

  /**
   * Gets a scheduler that schedules work via a timed callback based upon platform.
   */
   var DefaultScheduler = (function (__super__) {
     inherits(DefaultScheduler, __super__);
     function DefaultScheduler() {
       __super__.call(this);
     }

     function scheduleAction(disposable, action, scheduler, state) {
       return function schedule() {
         disposable.setDisposable(Disposable._fixup(action(scheduler, state)));
       };
     }

     function ClearDisposable(id) {
       this._id = id;
       this.isDisposed = false;
     }

     ClearDisposable.prototype.dispose = function () {
       if (!this.isDisposed) {
         this.isDisposed = true;
         clearMethod(this._id);
       }
     };

     function LocalClearDisposable(id) {
       this._id = id;
       this.isDisposed = false;
     }

     LocalClearDisposable.prototype.dispose = function () {
       if (!this.isDisposed) {
         this.isDisposed = true;
         localClearTimeout(this._id);
       }
     };

    DefaultScheduler.prototype.schedule = function (state, action) {
      var disposable = new SingleAssignmentDisposable(),
          id = scheduleMethod(scheduleAction(disposable, action, this, state));
      return new BinaryDisposable(disposable, new ClearDisposable(id));
    };

    DefaultScheduler.prototype._scheduleFuture = function (state, dueTime, action) {
      if (dueTime === 0) { return this.schedule(state, action); }
      var disposable = new SingleAssignmentDisposable(),
          id = localSetTimeout(scheduleAction(disposable, action, this, state), dueTime);
      return new BinaryDisposable(disposable, new LocalClearDisposable(id));
    };

    return DefaultScheduler;
  }(Scheduler));

  var defaultScheduler = Scheduler['default'] = Scheduler.async = new DefaultScheduler();

  function IndexedItem(id, value) {
    this.id = id;
    this.value = value;
  }

  IndexedItem.prototype.compareTo = function (other) {
    var c = this.value.compareTo(other.value);
    c === 0 && (c = this.id - other.id);
    return c;
  };

  var PriorityQueue = Rx.internals.PriorityQueue = function (capacity) {
    this.items = new Array(capacity);
    this.length = 0;
  };

  var priorityProto = PriorityQueue.prototype;
  priorityProto.isHigherPriority = function (left, right) {
    return this.items[left].compareTo(this.items[right]) < 0;
  };

  priorityProto.percolate = function (index) {
    if (index >= this.length || index < 0) { return; }
    var parent = index - 1 >> 1;
    if (parent < 0 || parent === index) { return; }
    if (this.isHigherPriority(index, parent)) {
      var temp = this.items[index];
      this.items[index] = this.items[parent];
      this.items[parent] = temp;
      this.percolate(parent);
    }
  };

  priorityProto.heapify = function (index) {
    +index || (index = 0);
    if (index >= this.length || index < 0) { return; }
    var left = 2 * index + 1,
        right = 2 * index + 2,
        first = index;
    if (left < this.length && this.isHigherPriority(left, first)) {
      first = left;
    }
    if (right < this.length && this.isHigherPriority(right, first)) {
      first = right;
    }
    if (first !== index) {
      var temp = this.items[index];
      this.items[index] = this.items[first];
      this.items[first] = temp;
      this.heapify(first);
    }
  };

  priorityProto.peek = function () { return this.items[0].value; };

  priorityProto.removeAt = function (index) {
    this.items[index] = this.items[--this.length];
    this.items[this.length] = undefined;
    this.heapify();
  };

  priorityProto.dequeue = function () {
    var result = this.peek();
    this.removeAt(0);
    return result;
  };

  priorityProto.enqueue = function (item) {
    var index = this.length++;
    this.items[index] = new IndexedItem(PriorityQueue.count++, item);
    this.percolate(index);
  };

  priorityProto.remove = function (item) {
    for (var i = 0; i < this.length; i++) {
      if (this.items[i].value === item) {
        this.removeAt(i);
        return true;
      }
    }
    return false;
  };
  PriorityQueue.count = 0;

  /**
   *  Represents a notification to an observer.
   */
  var Notification = Rx.Notification = (function () {
    function Notification() {

    }

    Notification.prototype._accept = function (onNext, onError, onCompleted) {
      throw new NotImplementedError();
    };

    Notification.prototype._acceptObserver = function (onNext, onError, onCompleted) {
      throw new NotImplementedError();
    };

    /**
     * Invokes the delegate corresponding to the notification or the observer's method corresponding to the notification and returns the produced result.
     * @param {Function | Observer} observerOrOnNext Function to invoke for an OnNext notification or Observer to invoke the notification on..
     * @param {Function} onError Function to invoke for an OnError notification.
     * @param {Function} onCompleted Function to invoke for an OnCompleted notification.
     * @returns {Any} Result produced by the observation.
     */
    Notification.prototype.accept = function (observerOrOnNext, onError, onCompleted) {
      return observerOrOnNext && typeof observerOrOnNext === 'object' ?
        this._acceptObserver(observerOrOnNext) :
        this._accept(observerOrOnNext, onError, onCompleted);
    };

    /**
     * Returns an observable sequence with a single notification.
     *
     * @memberOf Notifications
     * @param {Scheduler} [scheduler] Scheduler to send out the notification calls on.
     * @returns {Observable} The observable sequence that surfaces the behavior of the notification upon subscription.
     */
    Notification.prototype.toObservable = function (scheduler) {
      var self = this;
      isScheduler(scheduler) || (scheduler = immediateScheduler);
      return new AnonymousObservable(function (o) {
        return scheduler.schedule(self, function (_, notification) {
          notification._acceptObserver(o);
          notification.kind === 'N' && o.onCompleted();
        });
      });
    };

    return Notification;
  })();

  var OnNextNotification = (function (__super__) {
    inherits(OnNextNotification, __super__);
    function OnNextNotification(value) {
      this.value = value;
      this.kind = 'N';
    }

    OnNextNotification.prototype._accept = function (onNext) {
      return onNext(this.value);
    };

    OnNextNotification.prototype._acceptObserver = function (o) {
      return o.onNext(this.value);
    };

    OnNextNotification.prototype.toString = function () {
      return 'OnNext(' + this.value + ')';
    };

    return OnNextNotification;
  }(Notification));

  var OnErrorNotification = (function (__super__) {
    inherits(OnErrorNotification, __super__);
    function OnErrorNotification(error) {
      this.error = error;
      this.kind = 'E';
    }

    OnErrorNotification.prototype._accept = function (onNext, onError) {
      return onError(this.error);
    };

    OnErrorNotification.prototype._acceptObserver = function (o) {
      return o.onError(this.error);
    };

    OnErrorNotification.prototype.toString = function () {
      return 'OnError(' + this.error + ')';
    };

    return OnErrorNotification;
  }(Notification));

  var OnCompletedNotification = (function (__super__) {
    inherits(OnCompletedNotification, __super__);
    function OnCompletedNotification() {
      this.kind = 'C';
    }

    OnCompletedNotification.prototype._accept = function (onNext, onError, onCompleted) {
      return onCompleted();
    };

    OnCompletedNotification.prototype._acceptObserver = function (o) {
      return o.onCompleted();
    };

    OnCompletedNotification.prototype.toString = function () {
      return 'OnCompleted()';
    };

    return OnCompletedNotification;
  }(Notification));

  /**
   * Creates an object that represents an OnNext notification to an observer.
   * @param {Any} value The value contained in the notification.
   * @returns {Notification} The OnNext notification containing the value.
   */
  var notificationCreateOnNext = Notification.createOnNext = function (value) {
    return new OnNextNotification(value);
  };

  /**
   * Creates an object that represents an OnError notification to an observer.
   * @param {Any} error The exception contained in the notification.
   * @returns {Notification} The OnError notification containing the exception.
   */
  var notificationCreateOnError = Notification.createOnError = function (error) {
    return new OnErrorNotification(error);
  };

  /**
   * Creates an object that represents an OnCompleted notification to an observer.
   * @returns {Notification} The OnCompleted notification.
   */
  var notificationCreateOnCompleted = Notification.createOnCompleted = function () {
    return new OnCompletedNotification();
  };

  /**
   * Supports push-style iteration over an observable sequence.
   */
  var Observer = Rx.Observer = function () { };

  /**
   *  Creates an observer from the specified OnNext, along with optional OnError, and OnCompleted actions.
   * @param {Function} [onNext] Observer's OnNext action implementation.
   * @param {Function} [onError] Observer's OnError action implementation.
   * @param {Function} [onCompleted] Observer's OnCompleted action implementation.
   * @returns {Observer} The observer object implemented using the given actions.
   */
  var observerCreate = Observer.create = function (onNext, onError, onCompleted) {
    onNext || (onNext = noop);
    onError || (onError = defaultError);
    onCompleted || (onCompleted = noop);
    return new AnonymousObserver(onNext, onError, onCompleted);
  };

  /**
   * Abstract base class for implementations of the Observer class.
   * This base class enforces the grammar of observers where OnError and OnCompleted are terminal messages.
   */
  var AbstractObserver = Rx.internals.AbstractObserver = (function (__super__) {
    inherits(AbstractObserver, __super__);

    /**
     * Creates a new observer in a non-stopped state.
     */
    function AbstractObserver() {
      this.isStopped = false;
    }

    // Must be implemented by other observers
    AbstractObserver.prototype.next = notImplemented;
    AbstractObserver.prototype.error = notImplemented;
    AbstractObserver.prototype.completed = notImplemented;

    /**
     * Notifies the observer of a new element in the sequence.
     * @param {Any} value Next element in the sequence.
     */
    AbstractObserver.prototype.onNext = function (value) {
      !this.isStopped && this.next(value);
    };

    /**
     * Notifies the observer that an exception has occurred.
     * @param {Any} error The error that has occurred.
     */
    AbstractObserver.prototype.onError = function (error) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.error(error);
      }
    };

    /**
     * Notifies the observer of the end of the sequence.
     */
    AbstractObserver.prototype.onCompleted = function () {
      if (!this.isStopped) {
        this.isStopped = true;
        this.completed();
      }
    };

    /**
     * Disposes the observer, causing it to transition to the stopped state.
     */
    AbstractObserver.prototype.dispose = function () { this.isStopped = true; };

    AbstractObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.error(e);
        return true;
      }

      return false;
    };

    return AbstractObserver;
  }(Observer));

  /**
   * Class to create an Observer instance from delegate-based implementations of the on* methods.
   */
  var AnonymousObserver = Rx.AnonymousObserver = (function (__super__) {
    inherits(AnonymousObserver, __super__);

    /**
     * Creates an observer from the specified OnNext, OnError, and OnCompleted actions.
     * @param {Any} onNext Observer's OnNext action implementation.
     * @param {Any} onError Observer's OnError action implementation.
     * @param {Any} onCompleted Observer's OnCompleted action implementation.
     */
    function AnonymousObserver(onNext, onError, onCompleted) {
      __super__.call(this);
      this._onNext = onNext;
      this._onError = onError;
      this._onCompleted = onCompleted;
    }

    /**
     * Calls the onNext action.
     * @param {Any} value Next element in the sequence.
     */
    AnonymousObserver.prototype.next = function (value) {
      this._onNext(value);
    };

    /**
     * Calls the onError action.
     * @param {Any} error The error that has occurred.
     */
    AnonymousObserver.prototype.error = function (error) {
      this._onError(error);
    };

    /**
     *  Calls the onCompleted action.
     */
    AnonymousObserver.prototype.completed = function () {
      this._onCompleted();
    };

    return AnonymousObserver;
  }(AbstractObserver));

  var observableProto;

  /**
   * Represents a push-style collection.
   */
  var Observable = Rx.Observable = (function () {

    function makeSubscribe(self, subscribe) {
      return function (o) {
        var oldOnError = o.onError;
        o.onError = function (e) {
          makeStackTraceLong(e, self);
          oldOnError.call(o, e);
        };

        return subscribe.call(self, o);
      };
    }

    function Observable() {
      if (Rx.config.longStackSupport && hasStacks) {
        var oldSubscribe = this._subscribe;
        var e = tryCatch(thrower)(new Error()).e;
        this.stack = e.stack.substring(e.stack.indexOf('\n') + 1);
        this._subscribe = makeSubscribe(this, oldSubscribe);
      }
    }

    observableProto = Observable.prototype;

    /**
    * Determines whether the given object is an Observable
    * @param {Any} An object to determine whether it is an Observable
    * @returns {Boolean} true if an Observable, else false.
    */
    Observable.isObservable = function (o) {
      return o && isFunction(o.subscribe);
    };

    /**
     *  Subscribes an o to the observable sequence.
     *  @param {Mixed} [oOrOnNext] The object that is to receive notifications or an action to invoke for each element in the observable sequence.
     *  @param {Function} [onError] Action to invoke upon exceptional termination of the observable sequence.
     *  @param {Function} [onCompleted] Action to invoke upon graceful termination of the observable sequence.
     *  @returns {Diposable} A disposable handling the subscriptions and unsubscriptions.
     */
    observableProto.subscribe = observableProto.forEach = function (oOrOnNext, onError, onCompleted) {
      return this._subscribe(typeof oOrOnNext === 'object' ?
        oOrOnNext :
        observerCreate(oOrOnNext, onError, onCompleted));
    };

    /**
     * Subscribes to the next value in the sequence with an optional "this" argument.
     * @param {Function} onNext The function to invoke on each element in the observable sequence.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Disposable} A disposable handling the subscriptions and unsubscriptions.
     */
    observableProto.subscribeOnNext = function (onNext, thisArg) {
      return this._subscribe(observerCreate(typeof thisArg !== 'undefined' ? function(x) { onNext.call(thisArg, x); } : onNext));
    };

    /**
     * Subscribes to an exceptional condition in the sequence with an optional "this" argument.
     * @param {Function} onError The function to invoke upon exceptional termination of the observable sequence.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Disposable} A disposable handling the subscriptions and unsubscriptions.
     */
    observableProto.subscribeOnError = function (onError, thisArg) {
      return this._subscribe(observerCreate(null, typeof thisArg !== 'undefined' ? function(e) { onError.call(thisArg, e); } : onError));
    };

    /**
     * Subscribes to the next value in the sequence with an optional "this" argument.
     * @param {Function} onCompleted The function to invoke upon graceful termination of the observable sequence.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Disposable} A disposable handling the subscriptions and unsubscriptions.
     */
    observableProto.subscribeOnCompleted = function (onCompleted, thisArg) {
      return this._subscribe(observerCreate(null, null, typeof thisArg !== 'undefined' ? function() { onCompleted.call(thisArg); } : onCompleted));
    };

    return Observable;
  })();

  var ScheduledObserver = Rx.internals.ScheduledObserver = (function (__super__) {
    inherits(ScheduledObserver, __super__);

    function ScheduledObserver(scheduler, observer) {
      __super__.call(this);
      this.scheduler = scheduler;
      this.observer = observer;
      this.isAcquired = false;
      this.hasFaulted = false;
      this.queue = [];
      this.disposable = new SerialDisposable();
    }

    function enqueueNext(observer, x) { return function () { observer.onNext(x); }; }
    function enqueueError(observer, e) { return function () { observer.onError(e); }; }
    function enqueueCompleted(observer) { return function () { observer.onCompleted(); }; }

    ScheduledObserver.prototype.next = function (x) {
      this.queue.push(enqueueNext(this.observer, x));
    };

    ScheduledObserver.prototype.error = function (e) {
      this.queue.push(enqueueError(this.observer, e));
    };

    ScheduledObserver.prototype.completed = function () {
      this.queue.push(enqueueCompleted(this.observer));
    };


    function scheduleMethod(state, recurse) {
      var work;
      if (state.queue.length > 0) {
        work = state.queue.shift();
      } else {
        state.isAcquired = false;
        return;
      }
      var res = tryCatch(work)();
      if (res === errorObj) {
        state.queue = [];
        state.hasFaulted = true;
        return thrower(res.e);
      }
      recurse(state);
    }

    ScheduledObserver.prototype.ensureActive = function () {
      var isOwner = false;
      if (!this.hasFaulted && this.queue.length > 0) {
        isOwner = !this.isAcquired;
        this.isAcquired = true;
      }
      isOwner &&
        this.disposable.setDisposable(this.scheduler.scheduleRecursive(this, scheduleMethod));
    };

    ScheduledObserver.prototype.dispose = function () {
      __super__.prototype.dispose.call(this);
      this.disposable.dispose();
    };

    return ScheduledObserver;
  }(AbstractObserver));

  var ObservableBase = Rx.ObservableBase = (function (__super__) {
    inherits(ObservableBase, __super__);

    function fixSubscriber(subscriber) {
      return subscriber && isFunction(subscriber.dispose) ? subscriber :
        isFunction(subscriber) ? disposableCreate(subscriber) : disposableEmpty;
    }

    function setDisposable(s, state) {
      var ado = state[0], self = state[1];
      var sub = tryCatch(self.subscribeCore).call(self, ado);
      if (sub === errorObj && !ado.fail(errorObj.e)) { thrower(errorObj.e); }
      ado.setDisposable(fixSubscriber(sub));
    }

    function ObservableBase() {
      __super__.call(this);
    }

    ObservableBase.prototype._subscribe = function (o) {
      var ado = new AutoDetachObserver(o), state = [ado, this];

      if (currentThreadScheduler.scheduleRequired()) {
        currentThreadScheduler.schedule(state, setDisposable);
      } else {
        setDisposable(null, state);
      }
      return ado;
    };

    ObservableBase.prototype.subscribeCore = notImplemented;

    return ObservableBase;
  }(Observable));

var FlatMapObservable = Rx.FlatMapObservable = (function(__super__) {

    inherits(FlatMapObservable, __super__);

    function FlatMapObservable(source, selector, resultSelector, thisArg) {
      this.resultSelector = isFunction(resultSelector) ? resultSelector : null;
      this.selector = bindCallback(isFunction(selector) ? selector : function() { return selector; }, thisArg, 3);
      this.source = source;
      __super__.call(this);
    }

    FlatMapObservable.prototype.subscribeCore = function(o) {
      return this.source.subscribe(new InnerObserver(o, this.selector, this.resultSelector, this));
    };

    inherits(InnerObserver, AbstractObserver);
    function InnerObserver(observer, selector, resultSelector, source) {
      this.i = 0;
      this.selector = selector;
      this.resultSelector = resultSelector;
      this.source = source;
      this.o = observer;
      AbstractObserver.call(this);
    }

    InnerObserver.prototype._wrapResult = function(result, x, i) {
      return this.resultSelector ?
        result.map(function(y, i2) { return this.resultSelector(x, y, i, i2); }, this) :
        result;
    };

    InnerObserver.prototype.next = function(x) {
      var i = this.i++;
      var result = tryCatch(this.selector)(x, i, this.source);
      if (result === errorObj) { return this.o.onError(result.e); }

      isPromise(result) && (result = observableFromPromise(result));
      (isArrayLike(result) || isIterable(result)) && (result = Observable.from(result));
      this.o.onNext(this._wrapResult(result, x, i));
    };

    InnerObserver.prototype.error = function(e) { this.o.onError(e); };

    InnerObserver.prototype.completed = function() { this.o.onCompleted(); };

    return FlatMapObservable;

}(ObservableBase));

  var Enumerable = Rx.internals.Enumerable = function () { };

  function IsDisposedDisposable(state) {
    this._s = state;
    this.isDisposed = false;
  }

  IsDisposedDisposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this.isDisposed = true;
      this._s.isDisposed = true;
    }
  };

  var ConcatEnumerableObservable = (function(__super__) {
    inherits(ConcatEnumerableObservable, __super__);
    function ConcatEnumerableObservable(sources) {
      this.sources = sources;
      __super__.call(this);
    }

    function scheduleMethod(state, recurse) {
      if (state.isDisposed) { return; }
      var currentItem = tryCatch(state.e.next).call(state.e);
      if (currentItem === errorObj) { return state.o.onError(currentItem.e); }
      if (currentItem.done) { return state.o.onCompleted(); }

      // Check if promise
      var currentValue = currentItem.value;
      isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));

      var d = new SingleAssignmentDisposable();
      state.subscription.setDisposable(d);
      d.setDisposable(currentValue.subscribe(new InnerObserver(state, recurse)));
    }

    ConcatEnumerableObservable.prototype.subscribeCore = function (o) {
      var subscription = new SerialDisposable();
      var state = {
        isDisposed: false,
        o: o,
        subscription: subscription,
        e: this.sources[$iterator$]()
      };

      var cancelable = currentThreadScheduler.scheduleRecursive(state, scheduleMethod);
      return new NAryDisposable([subscription, cancelable, new IsDisposedDisposable(state)]);
    };

    function InnerObserver(state, recurse) {
      this._state = state;
      this._recurse = recurse;
      AbstractObserver.call(this);
    }

    inherits(InnerObserver, AbstractObserver);

    InnerObserver.prototype.next = function (x) { this._state.o.onNext(x); };
    InnerObserver.prototype.error = function (e) { this._state.o.onError(e); };
    InnerObserver.prototype.completed = function () { this._recurse(this._state); };

    return ConcatEnumerableObservable;
  }(ObservableBase));

  Enumerable.prototype.concat = function () {
    return new ConcatEnumerableObservable(this);
  };

  var CatchErrorObservable = (function(__super__) {
    function CatchErrorObservable(sources) {
      this.sources = sources;
      __super__.call(this);
    }

    inherits(CatchErrorObservable, __super__);

    function scheduleMethod(state, recurse) {
      if (state.isDisposed) { return; }
      var currentItem = tryCatch(state.e.next).call(state.e);
      if (currentItem === errorObj) { return state.o.onError(currentItem.e); }
      if (currentItem.done) { return state.lastError !== null ? state.o.onError(state.lastError) : state.o.onCompleted(); }

      var currentValue = currentItem.value;
      isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));

      var d = new SingleAssignmentDisposable();
      state.subscription.setDisposable(d);
      d.setDisposable(currentValue.subscribe(new InnerObserver(state, recurse)));
    }

    CatchErrorObservable.prototype.subscribeCore = function (o) {
      var subscription = new SerialDisposable();
      var state = {
        isDisposed: false,
        e: this.sources[$iterator$](),
        subscription: subscription,
        lastError: null,
        o: o
      };

      var cancelable = currentThreadScheduler.scheduleRecursive(state, scheduleMethod);
      return new NAryDisposable([subscription, cancelable, new IsDisposedDisposable(state)]);
    };

    function InnerObserver(state, recurse) {
      this._state = state;
      this._recurse = recurse;
      AbstractObserver.call(this);
    }

    inherits(InnerObserver, AbstractObserver);

    InnerObserver.prototype.next = function (x) { this._state.o.onNext(x); };
    InnerObserver.prototype.error = function (e) { this._state.lastError = e; this._recurse(this._state); };
    InnerObserver.prototype.completed = function () { this._state.o.onCompleted(); };

    return CatchErrorObservable;
  }(ObservableBase));

  Enumerable.prototype.catchError = function () {
    return new CatchErrorObservable(this);
  };

  var RepeatEnumerable = (function (__super__) {
    inherits(RepeatEnumerable, __super__);
    function RepeatEnumerable(v, c) {
      this.v = v;
      this.c = c == null ? -1 : c;
    }

    RepeatEnumerable.prototype[$iterator$] = function () {
      return new RepeatEnumerator(this);
    };

    function RepeatEnumerator(p) {
      this.v = p.v;
      this.l = p.c;
    }

    RepeatEnumerator.prototype.next = function () {
      if (this.l === 0) { return doneEnumerator; }
      if (this.l > 0) { this.l--; }
      return { done: false, value: this.v };
    };

    return RepeatEnumerable;
  }(Enumerable));

  var enumerableRepeat = Enumerable.repeat = function (value, repeatCount) {
    return new RepeatEnumerable(value, repeatCount);
  };

  var OfEnumerable = (function(__super__) {
    inherits(OfEnumerable, __super__);
    function OfEnumerable(s, fn, thisArg) {
      this.s = s;
      this.fn = fn ? bindCallback(fn, thisArg, 3) : null;
    }
    OfEnumerable.prototype[$iterator$] = function () {
      return new OfEnumerator(this);
    };

    function OfEnumerator(p) {
      this.i = -1;
      this.s = p.s;
      this.l = this.s.length;
      this.fn = p.fn;
    }

    OfEnumerator.prototype.next = function () {
     return ++this.i < this.l ?
       { done: false, value: !this.fn ? this.s[this.i] : this.fn(this.s[this.i], this.i, this.s) } :
       doneEnumerator;
    };

    return OfEnumerable;
  }(Enumerable));

  var enumerableOf = Enumerable.of = function (source, selector, thisArg) {
    return new OfEnumerable(source, selector, thisArg);
  };

  var ToArrayObservable = (function(__super__) {
    inherits(ToArrayObservable, __super__);
    function ToArrayObservable(source) {
      this.source = source;
      __super__.call(this);
    }

    ToArrayObservable.prototype.subscribeCore = function(o) {
      return this.source.subscribe(new InnerObserver(o));
    };

    inherits(InnerObserver, AbstractObserver);
    function InnerObserver(o) {
      this.o = o;
      this.a = [];
      AbstractObserver.call(this);
    }
    
    InnerObserver.prototype.next = function (x) { this.a.push(x); };
    InnerObserver.prototype.error = function (e) { this.o.onError(e);  };
    InnerObserver.prototype.completed = function () { this.o.onNext(this.a); this.o.onCompleted(); };

    return ToArrayObservable;
  }(ObservableBase));

  /**
  * Creates an array from an observable sequence.
  * @returns {Observable} An observable sequence containing a single element with a list containing all the elements of the source sequence.
  */
  observableProto.toArray = function () {
    return new ToArrayObservable(this);
  };

  /**
   *  Creates an observable sequence from a specified subscribe method implementation.
   * @example
   *  var res = Rx.Observable.create(function (observer) { return function () { } );
   *  var res = Rx.Observable.create(function (observer) { return Rx.Disposable.empty; } );
   *  var res = Rx.Observable.create(function (observer) { } );
   * @param {Function} subscribe Implementation of the resulting observable sequence's subscribe method, returning a function that will be wrapped in a Disposable.
   * @returns {Observable} The observable sequence with the specified implementation for the Subscribe method.
   */
  Observable.create = function (subscribe, parent) {
    return new AnonymousObservable(subscribe, parent);
  };

  var Defer = (function(__super__) {
    inherits(Defer, __super__);
    function Defer(factory) {
      this._f = factory;
      __super__.call(this);
    }

    Defer.prototype.subscribeCore = function (o) {
      var result = tryCatch(this._f)();
      if (result === errorObj) { return observableThrow(result.e).subscribe(o);}
      isPromise(result) && (result = observableFromPromise(result));
      return result.subscribe(o);
    };

    return Defer;
  }(ObservableBase));

  /**
   *  Returns an observable sequence that invokes the specified factory function whenever a new observer subscribes.
   *
   * @example
   *  var res = Rx.Observable.defer(function () { return Rx.Observable.fromArray([1,2,3]); });
   * @param {Function} observableFactory Observable factory function to invoke for each observer that subscribes to the resulting sequence or Promise.
   * @returns {Observable} An observable sequence whose observers trigger an invocation of the given observable factory function.
   */
  var observableDefer = Observable.defer = function (observableFactory) {
    return new Defer(observableFactory);
  };

  var EmptyObservable = (function(__super__) {
    inherits(EmptyObservable, __super__);
    function EmptyObservable(scheduler) {
      this.scheduler = scheduler;
      __super__.call(this);
    }

    EmptyObservable.prototype.subscribeCore = function (observer) {
      var sink = new EmptySink(observer, this.scheduler);
      return sink.run();
    };

    function EmptySink(observer, scheduler) {
      this.observer = observer;
      this.scheduler = scheduler;
    }

    function scheduleItem(s, state) {
      state.onCompleted();
      return disposableEmpty;
    }

    EmptySink.prototype.run = function () {
      var state = this.observer;
      return this.scheduler === immediateScheduler ?
        scheduleItem(null, state) :
        this.scheduler.schedule(state, scheduleItem);
    };

    return EmptyObservable;
  }(ObservableBase));

  var EMPTY_OBSERVABLE = new EmptyObservable(immediateScheduler);

  /**
   *  Returns an empty observable sequence, using the specified scheduler to send out the single OnCompleted message.
   *
   * @example
   *  var res = Rx.Observable.empty();
   *  var res = Rx.Observable.empty(Rx.Scheduler.timeout);
   * @param {Scheduler} [scheduler] Scheduler to send the termination call on.
   * @returns {Observable} An observable sequence with no elements.
   */
  var observableEmpty = Observable.empty = function (scheduler) {
    isScheduler(scheduler) || (scheduler = immediateScheduler);
    return scheduler === immediateScheduler ? EMPTY_OBSERVABLE : new EmptyObservable(scheduler);
  };

  var FromObservable = (function(__super__) {
    inherits(FromObservable, __super__);
    function FromObservable(iterable, fn, scheduler) {
      this._iterable = iterable;
      this._fn = fn;
      this._scheduler = scheduler;
      __super__.call(this);
    }

    function createScheduleMethod(o, it, fn) {
      return function loopRecursive(i, recurse) {
        var next = tryCatch(it.next).call(it);
        if (next === errorObj) { return o.onError(next.e); }
        if (next.done) { return o.onCompleted(); }

        var result = next.value;

        if (isFunction(fn)) {
          result = tryCatch(fn)(result, i);
          if (result === errorObj) { return o.onError(result.e); }
        }

        o.onNext(result);
        recurse(i + 1);
      };
    }

    FromObservable.prototype.subscribeCore = function (o) {
      var list = Object(this._iterable),
          it = getIterable(list);

      return this._scheduler.scheduleRecursive(0, createScheduleMethod(o, it, this._fn));
    };

    return FromObservable;
  }(ObservableBase));

  var maxSafeInteger = Math.pow(2, 53) - 1;

  function StringIterable(s) {
    this._s = s;
  }

  StringIterable.prototype[$iterator$] = function () {
    return new StringIterator(this._s);
  };

  function StringIterator(s) {
    this._s = s;
    this._l = s.length;
    this._i = 0;
  }

  StringIterator.prototype[$iterator$] = function () {
    return this;
  };

  StringIterator.prototype.next = function () {
    return this._i < this._l ? { done: false, value: this._s.charAt(this._i++) } : doneEnumerator;
  };

  function ArrayIterable(a) {
    this._a = a;
  }

  ArrayIterable.prototype[$iterator$] = function () {
    return new ArrayIterator(this._a);
  };

  function ArrayIterator(a) {
    this._a = a;
    this._l = toLength(a);
    this._i = 0;
  }

  ArrayIterator.prototype[$iterator$] = function () {
    return this;
  };

  ArrayIterator.prototype.next = function () {
    return this._i < this._l ? { done: false, value: this._a[this._i++] } : doneEnumerator;
  };

  function numberIsFinite(value) {
    return typeof value === 'number' && root.isFinite(value);
  }

  function isNan(n) {
    return n !== n;
  }

  function getIterable(o) {
    var i = o[$iterator$], it;
    if (!i && typeof o === 'string') {
      it = new StringIterable(o);
      return it[$iterator$]();
    }
    if (!i && o.length !== undefined) {
      it = new ArrayIterable(o);
      return it[$iterator$]();
    }
    if (!i) { throw new TypeError('Object is not iterable'); }
    return o[$iterator$]();
  }

  function sign(value) {
    var number = +value;
    if (number === 0) { return number; }
    if (isNaN(number)) { return number; }
    return number < 0 ? -1 : 1;
  }

  function toLength(o) {
    var len = +o.length;
    if (isNaN(len)) { return 0; }
    if (len === 0 || !numberIsFinite(len)) { return len; }
    len = sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) { return 0; }
    if (len > maxSafeInteger) { return maxSafeInteger; }
    return len;
  }

  /**
  * This method creates a new Observable sequence from an array-like or iterable object.
  * @param {Any} arrayLike An array-like or iterable object to convert to an Observable sequence.
  * @param {Function} [mapFn] Map function to call on every element of the array.
  * @param {Any} [thisArg] The context to use calling the mapFn if provided.
  * @param {Scheduler} [scheduler] Optional scheduler to use for scheduling.  If not provided, defaults to Scheduler.currentThread.
  */
  var observableFrom = Observable.from = function (iterable, mapFn, thisArg, scheduler) {
    if (iterable == null) {
      throw new Error('iterable cannot be null.')
    }
    if (mapFn && !isFunction(mapFn)) {
      throw new Error('mapFn when provided must be a function');
    }
    if (mapFn) {
      var mapper = bindCallback(mapFn, thisArg, 2);
    }
    isScheduler(scheduler) || (scheduler = currentThreadScheduler);
    return new FromObservable(iterable, mapper, scheduler);
  }

  var FromArrayObservable = (function(__super__) {
    inherits(FromArrayObservable, __super__);
    function FromArrayObservable(args, scheduler) {
      this._args = args;
      this._scheduler = scheduler;
      __super__.call(this);
    }

    function scheduleMethod(o, args) {
      var len = args.length;
      return function loopRecursive (i, recurse) {
        if (i < len) {
          o.onNext(args[i]);
          recurse(i + 1);
        } else {
          o.onCompleted();
        }
      };
    }

    FromArrayObservable.prototype.subscribeCore = function (o) {
      return this._scheduler.scheduleRecursive(0, scheduleMethod(o, this._args));
    };

    return FromArrayObservable;
  }(ObservableBase));

  /**
  *  Converts an array to an observable sequence, using an optional scheduler to enumerate the array.
  * @deprecated use Observable.from or Observable.of
  * @param {Scheduler} [scheduler] Scheduler to run the enumeration of the input sequence on.
  * @returns {Observable} The observable sequence whose elements are pulled from the given enumerable sequence.
  */
  var observableFromArray = Observable.fromArray = function (array, scheduler) {
    isScheduler(scheduler) || (scheduler = currentThreadScheduler);
    return new FromArrayObservable(array, scheduler)
  };

  var NeverObservable = (function(__super__) {
    inherits(NeverObservable, __super__);
    function NeverObservable() {
      __super__.call(this);
    }

    NeverObservable.prototype.subscribeCore = function (observer) {
      return disposableEmpty;
    };

    return NeverObservable;
  }(ObservableBase));

  var NEVER_OBSERVABLE = new NeverObservable();

  /**
   * Returns a non-terminating observable sequence, which can be used to denote an infinite duration (e.g. when using reactive joins).
   * @returns {Observable} An observable sequence whose observers will never get called.
   */
  var observableNever = Observable.never = function () {
    return NEVER_OBSERVABLE;
  };

  function observableOf (scheduler, array) {
    isScheduler(scheduler) || (scheduler = currentThreadScheduler);
    return new FromArrayObservable(array, scheduler);
  }

  /**
  *  This method creates a new Observable instance with a variable number of arguments, regardless of number or type of the arguments.
  * @returns {Observable} The observable sequence whose elements are pulled from the given arguments.
  */
  Observable.of = function () {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return new FromArrayObservable(args, currentThreadScheduler);
  };

  /**
  *  This method creates a new Observable instance with a variable number of arguments, regardless of number or type of the arguments.
  * @param {Scheduler} scheduler A scheduler to use for scheduling the arguments.
  * @returns {Observable} The observable sequence whose elements are pulled from the given arguments.
  */
  Observable.ofWithScheduler = function (scheduler) {
    var len = arguments.length, args = new Array(len - 1);
    for(var i = 1; i < len; i++) { args[i - 1] = arguments[i]; }
    return new FromArrayObservable(args, scheduler);
  };

  var PairsObservable = (function(__super__) {
    inherits(PairsObservable, __super__);
    function PairsObservable(o, scheduler) {
      this._o = o;
      this._keys = Object.keys(o);
      this._scheduler = scheduler;
      __super__.call(this);
    }

    function scheduleMethod(o, obj, keys) {
      return function loopRecursive(i, recurse) {
        if (i < keys.length) {
          var key = keys[i];
          o.onNext([key, obj[key]]);
          recurse(i + 1);
        } else {
          o.onCompleted();
        }
      };
    }

    PairsObservable.prototype.subscribeCore = function (o) {
      return this._scheduler.scheduleRecursive(0, scheduleMethod(o, this._o, this._keys));
    };

    return PairsObservable;
  }(ObservableBase));

  /**
   * Convert an object into an observable sequence of [key, value] pairs.
   * @param {Object} obj The object to inspect.
   * @param {Scheduler} [scheduler] Scheduler to run the enumeration of the input sequence on.
   * @returns {Observable} An observable sequence of [key, value] pairs from the object.
   */
  Observable.pairs = function (obj, scheduler) {
    scheduler || (scheduler = currentThreadScheduler);
    return new PairsObservable(obj, scheduler);
  };

    var RangeObservable = (function(__super__) {
    inherits(RangeObservable, __super__);
    function RangeObservable(start, count, scheduler) {
      this.start = start;
      this.rangeCount = count;
      this.scheduler = scheduler;
      __super__.call(this);
    }

    function loopRecursive(start, count, o) {
      return function loop (i, recurse) {
        if (i < count) {
          o.onNext(start + i);
          recurse(i + 1);
        } else {
          o.onCompleted();
        }
      };
    }

    RangeObservable.prototype.subscribeCore = function (o) {
      return this.scheduler.scheduleRecursive(
        0,
        loopRecursive(this.start, this.rangeCount, o)
      );
    };

    return RangeObservable;
  }(ObservableBase));

  /**
  *  Generates an observable sequence of integral numbers within a specified range, using the specified scheduler to send out observer messages.
  * @param {Number} start The value of the first integer in the sequence.
  * @param {Number} count The number of sequential integers to generate.
  * @param {Scheduler} [scheduler] Scheduler to run the generator loop on. If not specified, defaults to Scheduler.currentThread.
  * @returns {Observable} An observable sequence that contains a range of sequential integral numbers.
  */
  Observable.range = function (start, count, scheduler) {
    isScheduler(scheduler) || (scheduler = currentThreadScheduler);
    return new RangeObservable(start, count, scheduler);
  };

  var RepeatObservable = (function(__super__) {
    inherits(RepeatObservable, __super__);
    function RepeatObservable(value, repeatCount, scheduler) {
      this.value = value;
      this.repeatCount = repeatCount == null ? -1 : repeatCount;
      this.scheduler = scheduler;
      __super__.call(this);
    }

    RepeatObservable.prototype.subscribeCore = function (observer) {
      var sink = new RepeatSink(observer, this);
      return sink.run();
    };

    return RepeatObservable;
  }(ObservableBase));

  function RepeatSink(observer, parent) {
    this.observer = observer;
    this.parent = parent;
  }

  RepeatSink.prototype.run = function () {
    var observer = this.observer, value = this.parent.value;
    function loopRecursive(i, recurse) {
      if (i === -1 || i > 0) {
        observer.onNext(value);
        i > 0 && i--;
      }
      if (i === 0) { return observer.onCompleted(); }
      recurse(i);
    }

    return this.parent.scheduler.scheduleRecursive(this.parent.repeatCount, loopRecursive);
  };

  /**
   *  Generates an observable sequence that repeats the given element the specified number of times, using the specified scheduler to send out observer messages.
   * @param {Mixed} value Element to repeat.
   * @param {Number} repeatCount [Optiona] Number of times to repeat the element. If not specified, repeats indefinitely.
   * @param {Scheduler} scheduler Scheduler to run the producer loop on. If not specified, defaults to Scheduler.immediate.
   * @returns {Observable} An observable sequence that repeats the given element the specified number of times.
   */
  Observable.repeat = function (value, repeatCount, scheduler) {
    isScheduler(scheduler) || (scheduler = currentThreadScheduler);
    return new RepeatObservable(value, repeatCount, scheduler);
  };

  var JustObservable = (function(__super__) {
    inherits(JustObservable, __super__);
    function JustObservable(value, scheduler) {
      this._value = value;
      this._scheduler = scheduler;
      __super__.call(this);
    }

    JustObservable.prototype.subscribeCore = function (o) {
      var state = [this._value, o];
      return this._scheduler === immediateScheduler ?
        scheduleItem(null, state) :
        this._scheduler.schedule(state, scheduleItem);
    };

    function scheduleItem(s, state) {
      var value = state[0], observer = state[1];
      observer.onNext(value);
      observer.onCompleted();
      return disposableEmpty;
    }

    return JustObservable;
  }(ObservableBase));

  /**
   *  Returns an observable sequence that contains a single element, using the specified scheduler to send out observer messages.
   *  There is an alias called 'just' or browsers <IE9.
   * @param {Mixed} value Single element in the resulting observable sequence.
   * @param {Scheduler} scheduler Scheduler to send the single element on. If not specified, defaults to Scheduler.immediate.
   * @returns {Observable} An observable sequence containing the single specified element.
   */
  var observableReturn = Observable['return'] = Observable.just = function (value, scheduler) {
    isScheduler(scheduler) || (scheduler = immediateScheduler);
    return new JustObservable(value, scheduler);
  };

  var ThrowObservable = (function(__super__) {
    inherits(ThrowObservable, __super__);
    function ThrowObservable(error, scheduler) {
      this._error = error;
      this._scheduler = scheduler;
      __super__.call(this);
    }

    ThrowObservable.prototype.subscribeCore = function (o) {
      var state = [this._error, o];
      return this._scheduler === immediateScheduler ?
        scheduleItem(null, state) :
        this._scheduler.schedule(state, scheduleItem);
    };

    function scheduleItem(s, state) {
      var e = state[0], o = state[1];
      o.onError(e);
      return disposableEmpty;
    }

    return ThrowObservable;
  }(ObservableBase));

  /**
   *  Returns an observable sequence that terminates with an exception, using the specified scheduler to send out the single onError message.
   *  There is an alias to this method called 'throwError' for browsers <IE9.
   * @param {Mixed} error An object used for the sequence's termination.
   * @param {Scheduler} scheduler Scheduler to send the exceptional termination call on. If not specified, defaults to Scheduler.immediate.
   * @returns {Observable} The observable sequence that terminates exceptionally with the specified exception object.
   */
  var observableThrow = Observable['throw'] = function (error, scheduler) {
    isScheduler(scheduler) || (scheduler = immediateScheduler);
    return new ThrowObservable(error, scheduler);
  };

  var CatchObservable = (function (__super__) {
    inherits(CatchObservable, __super__);
    function CatchObservable(source, fn) {
      this.source = source;
      this._fn = fn;
      __super__.call(this);
    }

    CatchObservable.prototype.subscribeCore = function (o) {
      var d1 = new SingleAssignmentDisposable(), subscription = new SerialDisposable();
      subscription.setDisposable(d1);
      d1.setDisposable(this.source.subscribe(new CatchObserver(o, subscription, this._fn)));
      return subscription;
    };

    return CatchObservable;
  }(ObservableBase));

  var CatchObserver = (function(__super__) {
    inherits(CatchObserver, __super__);
    function CatchObserver(o, s, fn) {
      this._o = o;
      this._s = s;
      this._fn = fn;
      __super__.call(this);
    }

    CatchObserver.prototype.next = function (x) { this._o.onNext(x); };
    CatchObserver.prototype.completed = function () { return this._o.onCompleted(); };
    CatchObserver.prototype.error = function (e) {
      var result = tryCatch(this._fn)(e);
      if (result === errorObj) { return this._o.onError(result.e); }
      isPromise(result) && (result = observableFromPromise(result));

      var d = new SingleAssignmentDisposable();
      this._s.setDisposable(d);
      d.setDisposable(result.subscribe(this._o));
    };

    return CatchObserver;
  }(AbstractObserver));

  /**
   * Continues an observable sequence that is terminated by an exception with the next observable sequence.
   * @param {Mixed} handlerOrSecond Exception handler function that returns an observable sequence given the error that occurred in the first sequence, or a second observable sequence used to produce results when an error occurred in the first sequence.
   * @returns {Observable} An observable sequence containing the first sequence's elements, followed by the elements of the handler sequence in case an exception occurred.
   */
  observableProto['catch'] = function (handlerOrSecond) {
    return isFunction(handlerOrSecond) ? new CatchObservable(this, handlerOrSecond) : observableCatch([this, handlerOrSecond]);
  };

  /**
   * Continues an observable sequence that is terminated by an exception with the next observable sequence.
   * @param {Array | Arguments} args Arguments or an array to use as the next sequence if an error occurs.
   * @returns {Observable} An observable sequence containing elements from consecutive source sequences until a source sequence terminates successfully.
   */
  var observableCatch = Observable['catch'] = function () {
    var items;
    if (Array.isArray(arguments[0])) {
      items = arguments[0];
    } else {
      var len = arguments.length;
      items = new Array(len);
      for(var i = 0; i < len; i++) { items[i] = arguments[i]; }
    }
    return enumerableOf(items).catchError();
  };

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever any of the observable sequences or Promises produces an element.
   * This can be in the form of an argument list of observables or an array.
   *
   * @example
   * 1 - obs = observable.combineLatest(obs1, obs2, obs3, function (o1, o2, o3) { return o1 + o2 + o3; });
   * 2 - obs = observable.combineLatest([obs1, obs2, obs3], function (o1, o2, o3) { return o1 + o2 + o3; });
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */
  observableProto.combineLatest = function () {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    if (Array.isArray(args[0])) {
      args[0].unshift(this);
    } else {
      args.unshift(this);
    }
    return combineLatest.apply(this, args);
  };

  function falseFactory() { return false; }
  function argumentsToArray() {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return args;
  }

  var CombineLatestObservable = (function(__super__) {
    inherits(CombineLatestObservable, __super__);
    function CombineLatestObservable(params, cb) {
      this._params = params;
      this._cb = cb;
      __super__.call(this);
    }

    CombineLatestObservable.prototype.subscribeCore = function(observer) {
      var len = this._params.length,
          subscriptions = new Array(len);

      var state = {
        hasValue: arrayInitialize(len, falseFactory),
        hasValueAll: false,
        isDone: arrayInitialize(len, falseFactory),
        values: new Array(len)
      };

      for (var i = 0; i < len; i++) {
        var source = this._params[i], sad = new SingleAssignmentDisposable();
        subscriptions[i] = sad;
        isPromise(source) && (source = observableFromPromise(source));
        sad.setDisposable(source.subscribe(new CombineLatestObserver(observer, i, this._cb, state)));
      }

      return new NAryDisposable(subscriptions);
    };

    return CombineLatestObservable;
  }(ObservableBase));

  var CombineLatestObserver = (function (__super__) {
    inherits(CombineLatestObserver, __super__);
    function CombineLatestObserver(o, i, cb, state) {
      this._o = o;
      this._i = i;
      this._cb = cb;
      this._state = state;
      __super__.call(this);
    }

    function notTheSame(i) {
      return function (x, j) {
        return j !== i;
      };
    }

    CombineLatestObserver.prototype.next = function (x) {
      this._state.values[this._i] = x;
      this._state.hasValue[this._i] = true;
      if (this._state.hasValueAll || (this._state.hasValueAll = this._state.hasValue.every(identity))) {
        var res = tryCatch(this._cb).apply(null, this._state.values);
        if (res === errorObj) { return this._o.onError(res.e); }
        this._o.onNext(res);
      } else if (this._state.isDone.filter(notTheSame(this._i)).every(identity)) {
        this._o.onCompleted();
      }
    };

    CombineLatestObserver.prototype.error = function (e) {
      this._o.onError(e);
    };

    CombineLatestObserver.prototype.completed = function () {
      this._state.isDone[this._i] = true;
      this._state.isDone.every(identity) && this._o.onCompleted();
    };

    return CombineLatestObserver;
  }(AbstractObserver));

  /**
  * Merges the specified observable sequences into one observable sequence by using the selector function whenever any of the observable sequences or Promises produces an element.
  *
  * @example
  * 1 - obs = Rx.Observable.combineLatest(obs1, obs2, obs3, function (o1, o2, o3) { return o1 + o2 + o3; });
  * 2 - obs = Rx.Observable.combineLatest([obs1, obs2, obs3], function (o1, o2, o3) { return o1 + o2 + o3; });
  * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
  */
  var combineLatest = Observable.combineLatest = function () {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;
    Array.isArray(args[0]) && (args = args[0]);
    return new CombineLatestObservable(args, resultSelector);
  };

  /**
   * Concatenates all the observable sequences.  This takes in either an array or variable arguments to concatenate.
   * @returns {Observable} An observable sequence that contains the elements of each given sequence, in sequential order.
   */
  observableProto.concat = function () {
    for(var args = [], i = 0, len = arguments.length; i < len; i++) { args.push(arguments[i]); }
    args.unshift(this);
    return observableConcat.apply(null, args);
  };

  var ConcatObserver = (function(__super__) {
    inherits(ConcatObserver, __super__);
    function ConcatObserver(s, fn) {
      this._s = s;
      this._fn = fn;
      __super__.call(this);
    }

    ConcatObserver.prototype.next = function (x) { this._s.o.onNext(x); };
    ConcatObserver.prototype.error = function (e) { this._s.o.onError(e); };
    ConcatObserver.prototype.completed = function () { this._s.i++; this._fn(this._s); };

    return ConcatObserver;
  }(AbstractObserver));

  var ConcatObservable = (function(__super__) {
    inherits(ConcatObservable, __super__);
    function ConcatObservable(sources) {
      this._sources = sources;
      __super__.call(this);
    }

    function scheduleRecursive (state, recurse) {
      if (state.disposable.isDisposed) { return; }
      if (state.i === state.sources.length) { return state.o.onCompleted(); }

      // Check if promise
      var currentValue = state.sources[state.i];
      isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));

      var d = new SingleAssignmentDisposable();
      state.subscription.setDisposable(d);
      d.setDisposable(currentValue.subscribe(new ConcatObserver(state, recurse)));
    }

    ConcatObservable.prototype.subscribeCore = function(o) {
      var subscription = new SerialDisposable();
      var disposable = disposableCreate(noop);
      var state = {
        o: o,
        i: 0,
        subscription: subscription,
        disposable: disposable,
        sources: this._sources
      };

      var cancelable = immediateScheduler.scheduleRecursive(state, scheduleRecursive);
      return new NAryDisposable([subscription, disposable, cancelable]);
    };

    return ConcatObservable;
  }(ObservableBase));

  /**
   * Concatenates all the observable sequences.
   * @param {Array | Arguments} args Arguments or an array to concat to the observable sequence.
   * @returns {Observable} An observable sequence that contains the elements of each given sequence, in sequential order.
   */
  var observableConcat = Observable.concat = function () {
    var args;
    if (Array.isArray(arguments[0])) {
      args = arguments[0];
    } else {
      args = new Array(arguments.length);
      for(var i = 0, len = arguments.length; i < len; i++) { args[i] = arguments[i]; }
    }
    return new ConcatObservable(args);
  };

  /**
   * Concatenates an observable sequence of observable sequences.
   * @returns {Observable} An observable sequence that contains the elements of each observed inner sequence, in sequential order.
   */
  observableProto.concatAll = function () {
    return this.merge(1);
  };

  var MergeObservable = (function (__super__) {
    inherits(MergeObservable, __super__);

    function MergeObservable(source, maxConcurrent) {
      this.source = source;
      this.maxConcurrent = maxConcurrent;
      __super__.call(this);
    }

    MergeObservable.prototype.subscribeCore = function(observer) {
      var g = new CompositeDisposable();
      g.add(this.source.subscribe(new MergeObserver(observer, this.maxConcurrent, g)));
      return g;
    };

    return MergeObservable;

  }(ObservableBase));

  var MergeObserver = (function (__super__) {
    function MergeObserver(o, max, g) {
      this.o = o;
      this.max = max;
      this.g = g;
      this.done = false;
      this.q = [];
      this.activeCount = 0;
      __super__.call(this);
    }

    inherits(MergeObserver, __super__);

    MergeObserver.prototype.handleSubscribe = function (xs) {
      var sad = new SingleAssignmentDisposable();
      this.g.add(sad);
      isPromise(xs) && (xs = observableFromPromise(xs));
      sad.setDisposable(xs.subscribe(new InnerObserver(this, sad)));
    };

    MergeObserver.prototype.next = function (innerSource) {
      if(this.activeCount < this.max) {
        this.activeCount++;
        this.handleSubscribe(innerSource);
      } else {
        this.q.push(innerSource);
      }
    };
    MergeObserver.prototype.error = function (e) { this.o.onError(e); };
    MergeObserver.prototype.completed = function () { this.done = true; this.activeCount === 0 && this.o.onCompleted(); };

    function InnerObserver(parent, sad) {
      this.parent = parent;
      this.sad = sad;
      __super__.call(this);
    }

    inherits(InnerObserver, __super__);

    InnerObserver.prototype.next = function (x) { this.parent.o.onNext(x); };
    InnerObserver.prototype.error = function (e) { this.parent.o.onError(e); };
    InnerObserver.prototype.completed = function () {
      this.parent.g.remove(this.sad);
      if (this.parent.q.length > 0) {
        this.parent.handleSubscribe(this.parent.q.shift());
      } else {
        this.parent.activeCount--;
        this.parent.done && this.parent.activeCount === 0 && this.parent.o.onCompleted();
      }
    };

    return MergeObserver;
  }(AbstractObserver));

  /**
  * Merges an observable sequence of observable sequences into an observable sequence, limiting the number of concurrent subscriptions to inner sequences.
  * Or merges two observable sequences into a single observable sequence.
  * @param {Mixed} [maxConcurrentOrOther] Maximum number of inner observable sequences being subscribed to concurrently or the second observable sequence.
  * @returns {Observable} The observable sequence that merges the elements of the inner sequences.
  */
  observableProto.merge = function (maxConcurrentOrOther) {
    return typeof maxConcurrentOrOther !== 'number' ?
      observableMerge(this, maxConcurrentOrOther) :
      new MergeObservable(this, maxConcurrentOrOther);
  };

  /**
   * Merges all the observable sequences into a single observable sequence.
   * The scheduler is optional and if not specified, the immediate scheduler is used.
   * @returns {Observable} The observable sequence that merges the elements of the observable sequences.
   */
  var observableMerge = Observable.merge = function () {
    var scheduler, sources = [], i, len = arguments.length;
    if (!arguments[0]) {
      scheduler = immediateScheduler;
      for(i = 1; i < len; i++) { sources.push(arguments[i]); }
    } else if (isScheduler(arguments[0])) {
      scheduler = arguments[0];
      for(i = 1; i < len; i++) { sources.push(arguments[i]); }
    } else {
      scheduler = immediateScheduler;
      for(i = 0; i < len; i++) { sources.push(arguments[i]); }
    }
    if (Array.isArray(sources[0])) {
      sources = sources[0];
    }
    return observableOf(scheduler, sources).mergeAll();
  };

  var CompositeError = Rx.CompositeError = function(errors) {
    this.innerErrors = errors;
    this.message = 'This contains multiple errors. Check the innerErrors';
    Error.call(this);
  };
  CompositeError.prototype = Object.create(Error.prototype);
  CompositeError.prototype.name = 'CompositeError';

  var MergeDelayErrorObservable = (function(__super__) {
    inherits(MergeDelayErrorObservable, __super__);
    function MergeDelayErrorObservable(source) {
      this.source = source;
      __super__.call(this);
    }

    MergeDelayErrorObservable.prototype.subscribeCore = function (o) {
      var group = new CompositeDisposable(),
        m = new SingleAssignmentDisposable(),
        state = { isStopped: false, errors: [], o: o };

      group.add(m);
      m.setDisposable(this.source.subscribe(new MergeDelayErrorObserver(group, state)));

      return group;
    };

    return MergeDelayErrorObservable;
  }(ObservableBase));

  var MergeDelayErrorObserver = (function(__super__) {
    inherits(MergeDelayErrorObserver, __super__);
    function MergeDelayErrorObserver(group, state) {
      this._group = group;
      this._state = state;
      __super__.call(this);
    }

    function setCompletion(o, errors) {
      if (errors.length === 0) {
        o.onCompleted();
      } else if (errors.length === 1) {
        o.onError(errors[0]);
      } else {
        o.onError(new CompositeError(errors));
      }
    }

    MergeDelayErrorObserver.prototype.next = function (x) {
      var inner = new SingleAssignmentDisposable();
      this._group.add(inner);

      // Check for promises support
      isPromise(x) && (x = observableFromPromise(x));
      inner.setDisposable(x.subscribe(new InnerObserver(inner, this._group, this._state)));
    };

    MergeDelayErrorObserver.prototype.error = function (e) {
      this._state.errors.push(e);
      this._state.isStopped = true;
      this._group.length === 1 && setCompletion(this._state.o, this._state.errors);
    };

    MergeDelayErrorObserver.prototype.completed = function () {
      this._state.isStopped = true;
      this._group.length === 1 && setCompletion(this._state.o, this._state.errors);
    };

    inherits(InnerObserver, __super__);
    function InnerObserver(inner, group, state) {
      this._inner = inner;
      this._group = group;
      this._state = state;
      __super__.call(this);
    }

    InnerObserver.prototype.next = function (x) { this._state.o.onNext(x); };
    InnerObserver.prototype.error = function (e) {
      this._state.errors.push(e);
      this._group.remove(this._inner);
      this._state.isStopped && this._group.length === 1 && setCompletion(this._state.o, this._state.errors);
    };
    InnerObserver.prototype.completed = function () {
      this._group.remove(this._inner);
      this._state.isStopped && this._group.length === 1 && setCompletion(this._state.o, this._state.errors);
    };

    return MergeDelayErrorObserver;
  }(AbstractObserver));

  /**
  * Flattens an Observable that emits Observables into one Observable, in a way that allows an Observer to
  * receive all successfully emitted items from all of the source Observables without being interrupted by
  * an error notification from one of them.
  *
  * This behaves like Observable.prototype.mergeAll except that if any of the merged Observables notify of an
  * error via the Observer's onError, mergeDelayError will refrain from propagating that
  * error notification until all of the merged Observables have finished emitting items.
  * @param {Array | Arguments} args Arguments or an array to merge.
  * @returns {Observable} an Observable that emits all of the items emitted by the Observables emitted by the Observable
  */
  Observable.mergeDelayError = function() {
    var args;
    if (Array.isArray(arguments[0])) {
      args = arguments[0];
    } else {
      var len = arguments.length;
      args = new Array(len);
      for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    }
    var source = observableOf(null, args);
    return new MergeDelayErrorObservable(source);
  };

  var MergeAllObservable = (function (__super__) {
    inherits(MergeAllObservable, __super__);

    function MergeAllObservable(source) {
      this.source = source;
      __super__.call(this);
    }

    MergeAllObservable.prototype.subscribeCore = function (o) {
      var g = new CompositeDisposable(), m = new SingleAssignmentDisposable();
      g.add(m);
      m.setDisposable(this.source.subscribe(new MergeAllObserver(o, g)));
      return g;
    };

    return MergeAllObservable;
  }(ObservableBase));

  var MergeAllObserver = (function (__super__) {
    function MergeAllObserver(o, g) {
      this.o = o;
      this.g = g;
      this.done = false;
      __super__.call(this);
    }

    inherits(MergeAllObserver, __super__);

    MergeAllObserver.prototype.next = function(innerSource) {
      var sad = new SingleAssignmentDisposable();
      this.g.add(sad);
      isPromise(innerSource) && (innerSource = observableFromPromise(innerSource));
      sad.setDisposable(innerSource.subscribe(new InnerObserver(this, sad)));
    };

    MergeAllObserver.prototype.error = function (e) {
      this.o.onError(e);
    };

    MergeAllObserver.prototype.completed = function () {
      this.done = true;
      this.g.length === 1 && this.o.onCompleted();
    };

    function InnerObserver(parent, sad) {
      this.parent = parent;
      this.sad = sad;
      __super__.call(this);
    }

    inherits(InnerObserver, __super__);

    InnerObserver.prototype.next = function (x) {
      this.parent.o.onNext(x);
    };
    InnerObserver.prototype.error = function (e) {
      this.parent.o.onError(e);
    };
    InnerObserver.prototype.completed = function () {
      this.parent.g.remove(this.sad);
      this.parent.done && this.parent.g.length === 1 && this.parent.o.onCompleted();
    };

    return MergeAllObserver;
  }(AbstractObserver));

  /**
  * Merges an observable sequence of observable sequences into an observable sequence.
  * @returns {Observable} The observable sequence that merges the elements of the inner sequences.
  */
  observableProto.mergeAll = function () {
    return new MergeAllObservable(this);
  };

  var SkipUntilObservable = (function(__super__) {
    inherits(SkipUntilObservable, __super__);

    function SkipUntilObservable(source, other) {
      this._s = source;
      this._o = isPromise(other) ? observableFromPromise(other) : other;
      this._open = false;
      __super__.call(this);
    }

    SkipUntilObservable.prototype.subscribeCore = function(o) {
      var leftSubscription = new SingleAssignmentDisposable();
      leftSubscription.setDisposable(this._s.subscribe(new SkipUntilSourceObserver(o, this)));

      isPromise(this._o) && (this._o = observableFromPromise(this._o));

      var rightSubscription = new SingleAssignmentDisposable();
      rightSubscription.setDisposable(this._o.subscribe(new SkipUntilOtherObserver(o, this, rightSubscription)));

      return new BinaryDisposable(leftSubscription, rightSubscription);
    };

    return SkipUntilObservable;
  }(ObservableBase));

  var SkipUntilSourceObserver = (function(__super__) {
    inherits(SkipUntilSourceObserver, __super__);
    function SkipUntilSourceObserver(o, p) {
      this._o = o;
      this._p = p;
      __super__.call(this);
    }

    SkipUntilSourceObserver.prototype.next = function (x) {
      this._p._open && this._o.onNext(x);
    };

    SkipUntilSourceObserver.prototype.error = function (err) {
      this._o.onError(err);
    };

    SkipUntilSourceObserver.prototype.onCompleted = function () {
      this._p._open && this._o.onCompleted();
    };

    return SkipUntilSourceObserver;
  }(AbstractObserver));

  var SkipUntilOtherObserver = (function(__super__) {
    inherits(SkipUntilOtherObserver, __super__);
    function SkipUntilOtherObserver(o, p, r) {
      this._o = o;
      this._p = p;
      this._r = r;
      __super__.call(this);
    }

    SkipUntilOtherObserver.prototype.next = function () {
      this._p._open = true;
      this._r.dispose();
    };

    SkipUntilOtherObserver.prototype.error = function (err) {
      this._o.onError(err);
    };

    SkipUntilOtherObserver.prototype.onCompleted = function () {
      this._r.dispose();
    };

    return SkipUntilOtherObserver;
  }(AbstractObserver));

  /**
   * Returns the values from the source observable sequence only after the other observable sequence produces a value.
   * @param {Observable | Promise} other The observable sequence or Promise that triggers propagation of elements of the source sequence.
   * @returns {Observable} An observable sequence containing the elements of the source sequence starting from the point the other sequence triggered propagation.
   */
  observableProto.skipUntil = function (other) {
    return new SkipUntilObservable(this, other);
  };

  var SwitchObservable = (function(__super__) {
    inherits(SwitchObservable, __super__);
    function SwitchObservable(source) {
      this.source = source;
      __super__.call(this);
    }

    SwitchObservable.prototype.subscribeCore = function (o) {
      var inner = new SerialDisposable(), s = this.source.subscribe(new SwitchObserver(o, inner));
      return new BinaryDisposable(s, inner);
    };

    inherits(SwitchObserver, AbstractObserver);
    function SwitchObserver(o, inner) {
      this.o = o;
      this.inner = inner;
      this.stopped = false;
      this.latest = 0;
      this.hasLatest = false;
      AbstractObserver.call(this);
    }

    SwitchObserver.prototype.next = function (innerSource) {
      var d = new SingleAssignmentDisposable(), id = ++this.latest;
      this.hasLatest = true;
      this.inner.setDisposable(d);
      isPromise(innerSource) && (innerSource = observableFromPromise(innerSource));
      d.setDisposable(innerSource.subscribe(new InnerObserver(this, id)));
    };

    SwitchObserver.prototype.error = function (e) {
      this.o.onError(e);
    };

    SwitchObserver.prototype.completed = function () {
      this.stopped = true;
      !this.hasLatest && this.o.onCompleted();
    };

    inherits(InnerObserver, AbstractObserver);
    function InnerObserver(parent, id) {
      this.parent = parent;
      this.id = id;
      AbstractObserver.call(this);
    }
    InnerObserver.prototype.next = function (x) {
      this.parent.latest === this.id && this.parent.o.onNext(x);
    };

    InnerObserver.prototype.error = function (e) {
      this.parent.latest === this.id && this.parent.o.onError(e);
    };

    InnerObserver.prototype.completed = function () {
      if (this.parent.latest === this.id) {
        this.parent.hasLatest = false;
        this.parent.stopped && this.parent.o.onCompleted();
      }
    };

    return SwitchObservable;
  }(ObservableBase));

  /**
  * Transforms an observable sequence of observable sequences into an observable sequence producing values only from the most recent observable sequence.
  * @returns {Observable} The observable sequence that at any point in time produces the elements of the most recent inner observable sequence that has been received.
  */
  observableProto['switch'] = observableProto.switchLatest = function () {
    return new SwitchObservable(this);
  };

  var TakeUntilObservable = (function(__super__) {
    inherits(TakeUntilObservable, __super__);

    function TakeUntilObservable(source, other) {
      this.source = source;
      this.other = isPromise(other) ? observableFromPromise(other) : other;
      __super__.call(this);
    }

    TakeUntilObservable.prototype.subscribeCore = function(o) {
      return new BinaryDisposable(
        this.source.subscribe(o),
        this.other.subscribe(new TakeUntilObserver(o))
      );
    };

    return TakeUntilObservable;
  }(ObservableBase));

  var TakeUntilObserver = (function(__super__) {
    inherits(TakeUntilObserver, __super__);
    function TakeUntilObserver(o) {
      this._o = o;
      __super__.call(this);
    }

    TakeUntilObserver.prototype.next = function () {
      this._o.onCompleted();
    };

    TakeUntilObserver.prototype.error = function (err) {
      this._o.onError(err);
    };

    TakeUntilObserver.prototype.onCompleted = noop;

    return TakeUntilObserver;
  }(AbstractObserver));

  /**
   * Returns the values from the source observable sequence until the other observable sequence produces a value.
   * @param {Observable | Promise} other Observable sequence or Promise that terminates propagation of elements of the source sequence.
   * @returns {Observable} An observable sequence containing the elements of the source sequence up to the point the other sequence interrupted further propagation.
   */
  observableProto.takeUntil = function (other) {
    return new TakeUntilObservable(this, other);
  };

  function falseFactory() { return false; }
  function argumentsToArray() {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return args;
  }

  var WithLatestFromObservable = (function(__super__) {
    inherits(WithLatestFromObservable, __super__);
    function WithLatestFromObservable(source, sources, resultSelector) {
      this._s = source;
      this._ss = sources;
      this._cb = resultSelector;
      __super__.call(this);
    }

    WithLatestFromObservable.prototype.subscribeCore = function (o) {
      var len = this._ss.length;
      var state = {
        hasValue: arrayInitialize(len, falseFactory),
        hasValueAll: false,
        values: new Array(len)
      };

      var n = this._ss.length, subscriptions = new Array(n + 1);
      for (var i = 0; i < n; i++) {
        var other = this._ss[i], sad = new SingleAssignmentDisposable();
        isPromise(other) && (other = observableFromPromise(other));
        sad.setDisposable(other.subscribe(new WithLatestFromOtherObserver(o, i, state)));
        subscriptions[i] = sad;
      }

      var outerSad = new SingleAssignmentDisposable();
      outerSad.setDisposable(this._s.subscribe(new WithLatestFromSourceObserver(o, this._cb, state)));
      subscriptions[n] = outerSad;

      return new NAryDisposable(subscriptions);
    };

    return WithLatestFromObservable;
  }(ObservableBase));

  var WithLatestFromOtherObserver = (function (__super__) {
    inherits(WithLatestFromOtherObserver, __super__);
    function WithLatestFromOtherObserver(o, i, state) {
      this._o = o;
      this._i = i;
      this._state = state;
      __super__.call(this);
    }

    WithLatestFromOtherObserver.prototype.next = function (x) {
      this._state.values[this._i] = x;
      this._state.hasValue[this._i] = true;
      this._state.hasValueAll = this._state.hasValue.every(identity);
    };

    WithLatestFromOtherObserver.prototype.error = function (e) {
      this._o.onError(e);
    };

    WithLatestFromOtherObserver.prototype.completed = noop;

    return WithLatestFromOtherObserver;
  }(AbstractObserver));

  var WithLatestFromSourceObserver = (function (__super__) {
    inherits(WithLatestFromSourceObserver, __super__);
    function WithLatestFromSourceObserver(o, cb, state) {
      this._o = o;
      this._cb = cb;
      this._state = state;
      __super__.call(this);
    }

    WithLatestFromSourceObserver.prototype.next = function (x) {
      var allValues = [x].concat(this._state.values);
      if (!this._state.hasValueAll) { return; }
      var res = tryCatch(this._cb).apply(null, allValues);
      if (res === errorObj) { return this._o.onError(res.e); }
      this._o.onNext(res);
    };

    WithLatestFromSourceObserver.prototype.error = function (e) {
      this._o.onError(e);
    };

    WithLatestFromSourceObserver.prototype.completed = function () {
      this._o.onCompleted();
    };

    return WithLatestFromSourceObserver;
  }(AbstractObserver));

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function only when the (first) source observable sequence produces an element.
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */
  observableProto.withLatestFrom = function () {
    if (arguments.length === 0) { throw new Error('invalid arguments'); }

    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;
    Array.isArray(args[0]) && (args = args[0]);

    return new WithLatestFromObservable(this, args, resultSelector);
  };

  function falseFactory() { return false; }
  function emptyArrayFactory() { return []; }

  var ZipObservable = (function(__super__) {
    inherits(ZipObservable, __super__);
    function ZipObservable(sources, resultSelector) {
      this._s = sources;
      this._cb = resultSelector;
      __super__.call(this);
    }

    ZipObservable.prototype.subscribeCore = function(observer) {
      var n = this._s.length,
          subscriptions = new Array(n),
          done = arrayInitialize(n, falseFactory),
          q = arrayInitialize(n, emptyArrayFactory);

      for (var i = 0; i < n; i++) {
        var source = this._s[i], sad = new SingleAssignmentDisposable();
        subscriptions[i] = sad;
        isPromise(source) && (source = observableFromPromise(source));
        sad.setDisposable(source.subscribe(new ZipObserver(observer, i, this, q, done)));
      }

      return new NAryDisposable(subscriptions);
    };

    return ZipObservable;
  }(ObservableBase));

  var ZipObserver = (function (__super__) {
    inherits(ZipObserver, __super__);
    function ZipObserver(o, i, p, q, d) {
      this._o = o;
      this._i = i;
      this._p = p;
      this._q = q;
      this._d = d;
      __super__.call(this);
    }

    function notEmpty(x) { return x.length > 0; }
    function shiftEach(x) { return x.shift(); }
    function notTheSame(i) {
      return function (x, j) {
        return j !== i;
      };
    }

    ZipObserver.prototype.next = function (x) {
      this._q[this._i].push(x);
      if (this._q.every(notEmpty)) {
        var queuedValues = this._q.map(shiftEach);
        var res = tryCatch(this._p._cb).apply(null, queuedValues);
        if (res === errorObj) { return this._o.onError(res.e); }
        this._o.onNext(res);
      } else if (this._d.filter(notTheSame(this._i)).every(identity)) {
        this._o.onCompleted();
      }
    };

    ZipObserver.prototype.error = function (e) {
      this._o.onError(e);
    };

    ZipObserver.prototype.completed = function () {
      this._d[this._i] = true;
      this._d.every(identity) && this._o.onCompleted();
    };

    return ZipObserver;
  }(AbstractObserver));

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences or an array have produced an element at a corresponding index.
   * The last element in the arguments must be a function to invoke for each series of elements at corresponding indexes in the args.
   * @returns {Observable} An observable sequence containing the result of combining elements of the args using the specified result selector function.
   */
  observableProto.zip = function () {
    if (arguments.length === 0) { throw new Error('invalid arguments'); }

    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;
    Array.isArray(args[0]) && (args = args[0]);

    var parent = this;
    args.unshift(parent);

    return new ZipObservable(args, resultSelector);
  };

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences have produced an element at a corresponding index.
   * @param arguments Observable sources.
   * @param {Function} resultSelector Function to invoke for each series of elements at corresponding indexes in the sources.
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */
  Observable.zip = function () {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    if (Array.isArray(args[0])) {
      args = isFunction(args[1]) ? args[0].concat(args[1]) : args[0];
    }
    var first = args.shift();
    return first.zip.apply(first, args);
  };

function falseFactory() { return false; }
function emptyArrayFactory() { return []; }
function argumentsToArray() {
  var len = arguments.length, args = new Array(len);
  for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
  return args;
}

var ZipIterableObservable = (function(__super__) {
  inherits(ZipIterableObservable, __super__);
  function ZipIterableObservable(sources, cb) {
    this.sources = sources;
    this._cb = cb;
    __super__.call(this);
  }

  ZipIterableObservable.prototype.subscribeCore = function (o) {
    var sources = this.sources, len = sources.length, subscriptions = new Array(len);

    var state = {
      q: arrayInitialize(len, emptyArrayFactory),
      done: arrayInitialize(len, falseFactory),
      cb: this._cb,
      o: o
    };

    for (var i = 0; i < len; i++) {
      (function (i) {
        var source = sources[i], sad = new SingleAssignmentDisposable();
        (isArrayLike(source) || isIterable(source)) && (source = observableFrom(source));

        subscriptions[i] = sad;
        sad.setDisposable(source.subscribe(new ZipIterableObserver(state, i)));
      }(i));
    }

    return new NAryDisposable(subscriptions);
  };

  return ZipIterableObservable;
}(ObservableBase));

var ZipIterableObserver = (function (__super__) {
  inherits(ZipIterableObserver, __super__);
  function ZipIterableObserver(s, i) {
    this._s = s;
    this._i = i;
    __super__.call(this);
  }

  function notEmpty(x) { return x.length > 0; }
  function shiftEach(x) { return x.shift(); }
  function notTheSame(i) {
    return function (x, j) {
      return j !== i;
    };
  }

  ZipIterableObserver.prototype.next = function (x) {
    this._s.q[this._i].push(x);
    if (this._s.q.every(notEmpty)) {
      var queuedValues = this._s.q.map(shiftEach),
          res = tryCatch(this._s.cb).apply(null, queuedValues);
      if (res === errorObj) { return this._s.o.onError(res.e); }
      this._s.o.onNext(res);
    } else if (this._s.done.filter(notTheSame(this._i)).every(identity)) {
      this._s.o.onCompleted();
    }
  };

  ZipIterableObserver.prototype.error = function (e) { this._s.o.onError(e); };

  ZipIterableObserver.prototype.completed = function () {
    this._s.done[this._i] = true;
    this._s.done.every(identity) && this._s.o.onCompleted();
  };

  return ZipIterableObserver;
}(AbstractObserver));

/**
 * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences or an array have produced an element at a corresponding index.
 * The last element in the arguments must be a function to invoke for each series of elements at corresponding indexes in the args.
 * @returns {Observable} An observable sequence containing the result of combining elements of the args using the specified result selector function.
 */
observableProto.zipIterable = function () {
  if (arguments.length === 0) { throw new Error('invalid arguments'); }

  var len = arguments.length, args = new Array(len);
  for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
  var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;

  var parent = this;
  args.unshift(parent);
  return new ZipIterableObservable(args, resultSelector);
};

  function asObservable(source) {
    return function subscribe(o) { return source.subscribe(o); };
  }

  /**
   *  Hides the identity of an observable sequence.
   * @returns {Observable} An observable sequence that hides the identity of the source sequence.
   */
  observableProto.asObservable = function () {
    return new AnonymousObservable(asObservable(this), this);
  };

  var DematerializeObservable = (function (__super__) {
    inherits(DematerializeObservable, __super__);
    function DematerializeObservable(source) {
      this.source = source;
      __super__.call(this);
    }

    DematerializeObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new DematerializeObserver(o));
    };

    return DematerializeObservable;
  }(ObservableBase));

  var DematerializeObserver = (function (__super__) {
    inherits(DematerializeObserver, __super__);

    function DematerializeObserver(o) {
      this._o = o;
      __super__.call(this);
    }

    DematerializeObserver.prototype.next = function (x) { x.accept(this._o); };
    DematerializeObserver.prototype.error = function (e) { this._o.onError(e); };
    DematerializeObserver.prototype.completed = function () { this._o.onCompleted(); };

    return DematerializeObserver;
  }(AbstractObserver));

  /**
   * Dematerializes the explicit notification values of an observable sequence as implicit notifications.
   * @returns {Observable} An observable sequence exhibiting the behavior corresponding to the source sequence's notification values.
   */
  observableProto.dematerialize = function () {
    return new DematerializeObservable(this);
  };

  var DistinctUntilChangedObservable = (function(__super__) {
    inherits(DistinctUntilChangedObservable, __super__);
    function DistinctUntilChangedObservable(source, keyFn, comparer) {
      this.source = source;
      this.keyFn = keyFn;
      this.comparer = comparer;
      __super__.call(this);
    }

    DistinctUntilChangedObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new DistinctUntilChangedObserver(o, this.keyFn, this.comparer));
    };

    return DistinctUntilChangedObservable;
  }(ObservableBase));

  var DistinctUntilChangedObserver = (function(__super__) {
    inherits(DistinctUntilChangedObserver, __super__);
    function DistinctUntilChangedObserver(o, keyFn, comparer) {
      this.o = o;
      this.keyFn = keyFn;
      this.comparer = comparer;
      this.hasCurrentKey = false;
      this.currentKey = null;
      __super__.call(this);
    }

    DistinctUntilChangedObserver.prototype.next = function (x) {
      var key = x, comparerEquals;
      if (isFunction(this.keyFn)) {
        key = tryCatch(this.keyFn)(x);
        if (key === errorObj) { return this.o.onError(key.e); }
      }
      if (this.hasCurrentKey) {
        comparerEquals = tryCatch(this.comparer)(this.currentKey, key);
        if (comparerEquals === errorObj) { return this.o.onError(comparerEquals.e); }
      }
      if (!this.hasCurrentKey || !comparerEquals) {
        this.hasCurrentKey = true;
        this.currentKey = key;
        this.o.onNext(x);
      }
    };
    DistinctUntilChangedObserver.prototype.error = function(e) {
      this.o.onError(e);
    };
    DistinctUntilChangedObserver.prototype.completed = function () {
      this.o.onCompleted();
    };

    return DistinctUntilChangedObserver;
  }(AbstractObserver));

  /**
  *  Returns an observable sequence that contains only distinct contiguous elements according to the keyFn and the comparer.
  * @param {Function} [keyFn] A function to compute the comparison key for each element. If not provided, it projects the value.
  * @param {Function} [comparer] Equality comparer for computed key values. If not provided, defaults to an equality comparer function.
  * @returns {Observable} An observable sequence only containing the distinct contiguous elements, based on a computed key value, from the source sequence.
  */
  observableProto.distinctUntilChanged = function (keyFn, comparer) {
    comparer || (comparer = defaultComparer);
    return new DistinctUntilChangedObservable(this, keyFn, comparer);
  };

  var TapObservable = (function(__super__) {
    inherits(TapObservable,__super__);
    function TapObservable(source, observerOrOnNext, onError, onCompleted) {
      this.source = source;
      this._oN = observerOrOnNext;
      this._oE = onError;
      this._oC = onCompleted;
      __super__.call(this);
    }

    TapObservable.prototype.subscribeCore = function(o) {
      return this.source.subscribe(new InnerObserver(o, this));
    };

    inherits(InnerObserver, AbstractObserver);
    function InnerObserver(o, p) {
      this.o = o;
      this.t = !p._oN || isFunction(p._oN) ?
        observerCreate(p._oN || noop, p._oE || noop, p._oC || noop) :
        p._oN;
      this.isStopped = false;
      AbstractObserver.call(this);
    }
    InnerObserver.prototype.next = function(x) {
      var res = tryCatch(this.t.onNext).call(this.t, x);
      if (res === errorObj) { this.o.onError(res.e); }
      this.o.onNext(x);
    };
    InnerObserver.prototype.error = function(err) {
      var res = tryCatch(this.t.onError).call(this.t, err);
      if (res === errorObj) { return this.o.onError(res.e); }
      this.o.onError(err);
    };
    InnerObserver.prototype.completed = function() {
      var res = tryCatch(this.t.onCompleted).call(this.t);
      if (res === errorObj) { return this.o.onError(res.e); }
      this.o.onCompleted();
    };

    return TapObservable;
  }(ObservableBase));

  /**
  *  Invokes an action for each element in the observable sequence and invokes an action upon graceful or exceptional termination of the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function | Observer} observerOrOnNext Action to invoke for each element in the observable sequence or an o.
  * @param {Function} [onError]  Action to invoke upon exceptional termination of the observable sequence. Used if only the observerOrOnNext parameter is also a function.
  * @param {Function} [onCompleted]  Action to invoke upon graceful termination of the observable sequence. Used if only the observerOrOnNext parameter is also a function.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */
  observableProto['do'] = observableProto.tap = observableProto.doAction = function (observerOrOnNext, onError, onCompleted) {
    return new TapObservable(this, observerOrOnNext, onError, onCompleted);
  };

  /**
  *  Invokes an action for each element in the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function} onNext Action to invoke for each element in the observable sequence.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */
  observableProto.doOnNext = observableProto.tapOnNext = function (onNext, thisArg) {
    return this.tap(typeof thisArg !== 'undefined' ? function (x) { onNext.call(thisArg, x); } : onNext);
  };

  /**
  *  Invokes an action upon exceptional termination of the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function} onError Action to invoke upon exceptional termination of the observable sequence.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */
  observableProto.doOnError = observableProto.tapOnError = function (onError, thisArg) {
    return this.tap(noop, typeof thisArg !== 'undefined' ? function (e) { onError.call(thisArg, e); } : onError);
  };

  /**
  *  Invokes an action upon graceful termination of the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function} onCompleted Action to invoke upon graceful termination of the observable sequence.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */
  observableProto.doOnCompleted = observableProto.tapOnCompleted = function (onCompleted, thisArg) {
    return this.tap(noop, null, typeof thisArg !== 'undefined' ? function () { onCompleted.call(thisArg); } : onCompleted);
  };

  var FinallyObservable = (function (__super__) {
    inherits(FinallyObservable, __super__);
    function FinallyObservable(source, fn, thisArg) {
      this.source = source;
      this._fn = bindCallback(fn, thisArg, 0);
      __super__.call(this);
    }

    FinallyObservable.prototype.subscribeCore = function (o) {
      var d = tryCatch(this.source.subscribe).call(this.source, o);
      if (d === errorObj) {
        this._fn();
        thrower(d.e);
      }

      return new FinallyDisposable(d, this._fn);
    };

    function FinallyDisposable(s, fn) {
      this.isDisposed = false;
      this._s = s;
      this._fn = fn;
    }
    FinallyDisposable.prototype.dispose = function () {
      if (!this.isDisposed) {
        var res = tryCatch(this._s.dispose).call(this._s);
        this._fn();
        res === errorObj && thrower(res.e);
      }
    };

    return FinallyObservable;

  }(ObservableBase));

  /**
   *  Invokes a specified action after the source observable sequence terminates gracefully or exceptionally.
   * @param {Function} finallyAction Action to invoke after the source observable sequence terminates.
   * @returns {Observable} Source sequence with the action-invoking termination behavior applied.
   */
  observableProto['finally'] = function (action, thisArg) {
    return new FinallyObservable(this, action, thisArg);
  };

  var IgnoreElementsObservable = (function(__super__) {
    inherits(IgnoreElementsObservable, __super__);

    function IgnoreElementsObservable(source) {
      this.source = source;
      __super__.call(this);
    }

    IgnoreElementsObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new InnerObserver(o));
    };

    function InnerObserver(o) {
      this.o = o;
      this.isStopped = false;
    }
    InnerObserver.prototype.onNext = noop;
    InnerObserver.prototype.onError = function (err) {
      if(!this.isStopped) {
        this.isStopped = true;
        this.o.onError(err);
      }
    };
    InnerObserver.prototype.onCompleted = function () {
      if(!this.isStopped) {
        this.isStopped = true;
        this.o.onCompleted();
      }
    };
    InnerObserver.prototype.dispose = function() { this.isStopped = true; };
    InnerObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.observer.onError(e);
        return true;
      }

      return false;
    };

    return IgnoreElementsObservable;
  }(ObservableBase));

  /**
   *  Ignores all elements in an observable sequence leaving only the termination messages.
   * @returns {Observable} An empty observable sequence that signals termination, successful or exceptional, of the source sequence.
   */
  observableProto.ignoreElements = function () {
    return new IgnoreElementsObservable(this);
  };

  var MaterializeObservable = (function (__super__) {
    inherits(MaterializeObservable, __super__);
    function MaterializeObservable(source, fn) {
      this.source = source;
      __super__.call(this);
    }

    MaterializeObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new MaterializeObserver(o));
    };

    return MaterializeObservable;
  }(ObservableBase));

  var MaterializeObserver = (function (__super__) {
    inherits(MaterializeObserver, __super__);

    function MaterializeObserver(o) {
      this._o = o;
      __super__.call(this);
    }

    MaterializeObserver.prototype.next = function (x) { this._o.onNext(notificationCreateOnNext(x)) };
    MaterializeObserver.prototype.error = function (e) { this._o.onNext(notificationCreateOnError(e)); this._o.onCompleted(); };
    MaterializeObserver.prototype.completed = function () { this._o.onNext(notificationCreateOnCompleted()); this._o.onCompleted(); };

    return MaterializeObserver;
  }(AbstractObserver));

  /**
   *  Materializes the implicit notifications of an observable sequence as explicit notification values.
   * @returns {Observable} An observable sequence containing the materialized notification values from the source sequence.
   */
  observableProto.materialize = function () {
    return new MaterializeObservable(this);
  };

  /**
   *  Repeats the observable sequence a specified number of times. If the repeat count is not specified, the sequence repeats indefinitely.
   * @param {Number} [repeatCount]  Number of times to repeat the sequence. If not provided, repeats the sequence indefinitely.
   * @returns {Observable} The observable sequence producing the elements of the given sequence repeatedly.
   */
  observableProto.repeat = function (repeatCount) {
    return enumerableRepeat(this, repeatCount).concat();
  };

  /**
   *  Repeats the source observable sequence the specified number of times or until it successfully terminates. If the retry count is not specified, it retries indefinitely.
   *  Note if you encounter an error and want it to retry once, then you must use .retry(2);
   *
   * @example
   *  var res = retried = retry.repeat();
   *  var res = retried = retry.repeat(2);
   * @param {Number} [retryCount]  Number of times to retry the sequence. If not provided, retry the sequence indefinitely.
   * @returns {Observable} An observable sequence producing the elements of the given sequence repeatedly until it terminates successfully.
   */
  observableProto.retry = function (retryCount) {
    return enumerableRepeat(this, retryCount).catchError();
  };

  function repeat(value) {
    return {
      '@@iterator': function () {
        return {
          next: function () {
            return { done: false, value: value };
          }
        };
      }
    };
  }

  var RetryWhenObservable = (function(__super__) {
    function createDisposable(state) {
      return {
        isDisposed: false,
        dispose: function () {
          if (!this.isDisposed) {
            this.isDisposed = true;
            state.isDisposed = true;
          }
        }
      };
    }

    function RetryWhenObservable(source, notifier) {
      this.source = source;
      this._notifier = notifier;
      __super__.call(this);
    }

    inherits(RetryWhenObservable, __super__);

    RetryWhenObservable.prototype.subscribeCore = function (o) {
      var exceptions = new Subject(),
        notifier = new Subject(),
        handled = this._notifier(exceptions),
        notificationDisposable = handled.subscribe(notifier);

      var e = this.source['@@iterator']();

      var state = { isDisposed: false },
        lastError,
        subscription = new SerialDisposable();
      var cancelable = currentThreadScheduler.scheduleRecursive(null, function (_, recurse) {
        if (state.isDisposed) { return; }
        var currentItem = e.next();

        if (currentItem.done) {
          if (lastError) {
            o.onError(lastError);
          } else {
            o.onCompleted();
          }
          return;
        }

        // Check if promise
        var currentValue = currentItem.value;
        isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));

        var outer = new SingleAssignmentDisposable();
        var inner = new SingleAssignmentDisposable();
        subscription.setDisposable(new BinaryDisposable(inner, outer));
        outer.setDisposable(currentValue.subscribe(
          function(x) { o.onNext(x); },
          function (exn) {
            inner.setDisposable(notifier.subscribe(recurse, function(ex) {
              o.onError(ex);
            }, function() {
              o.onCompleted();
            }));

            exceptions.onNext(exn);
            outer.dispose();
          },
          function() { o.onCompleted(); }));
      });

      return new NAryDisposable([notificationDisposable, subscription, cancelable, createDisposable(state)]);
    };

    return RetryWhenObservable;
  }(ObservableBase));

  observableProto.retryWhen = function (notifier) {
    return new RetryWhenObservable(repeat(this), notifier);
  };

  function repeat(value) {
    return {
      '@@iterator': function () {
        return {
          next: function () {
            return { done: false, value: value };
          }
        };
      }
    };
  }

  var RepeatWhenObservable = (function(__super__) {
    function createDisposable(state) {
      return {
        isDisposed: false,
        dispose: function () {
          if (!this.isDisposed) {
            this.isDisposed = true;
            state.isDisposed = true;
          }
        }
      };
    }

    function RepeatWhenObservable(source, notifier) {
      this.source = source;
      this._notifier = notifier;
      __super__.call(this);
    }

    inherits(RepeatWhenObservable, __super__);

    RepeatWhenObservable.prototype.subscribeCore = function (o) {
      var completions = new Subject(),
        notifier = new Subject(),
        handled = this._notifier(completions),
        notificationDisposable = handled.subscribe(notifier);

      var e = this.source['@@iterator']();

      var state = { isDisposed: false },
        lastError,
        subscription = new SerialDisposable();
      var cancelable = currentThreadScheduler.scheduleRecursive(null, function (_, recurse) {
        if (state.isDisposed) { return; }
        var currentItem = e.next();

        if (currentItem.done) {
          if (lastError) {
            o.onError(lastError);
          } else {
            o.onCompleted();
          }
          return;
        }

        // Check if promise
        var currentValue = currentItem.value;
        isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));

        var outer = new SingleAssignmentDisposable();
        var inner = new SingleAssignmentDisposable();
        subscription.setDisposable(new BinaryDisposable(inner, outer));
        outer.setDisposable(currentValue.subscribe(
          function(x) { o.onNext(x); },
          function (exn) { o.onError(exn); },
          function() {
            inner.setDisposable(notifier.subscribe(recurse, function(ex) {
              o.onError(ex);
            }, function() {
              o.onCompleted();
            }));

            completions.onNext(null);
            outer.dispose();
          }));
      });

      return new NAryDisposable([notificationDisposable, subscription, cancelable, createDisposable(state)]);
    };

    return RepeatWhenObservable;
  }(ObservableBase));

  observableProto.repeatWhen = function (notifier) {
    return new RepeatWhenObservable(repeat(this), notifier);
  };

  var ScanObservable = (function(__super__) {
    inherits(ScanObservable, __super__);
    function ScanObservable(source, accumulator, hasSeed, seed) {
      this.source = source;
      this.accumulator = accumulator;
      this.hasSeed = hasSeed;
      this.seed = seed;
      __super__.call(this);
    }

    ScanObservable.prototype.subscribeCore = function(o) {
      return this.source.subscribe(new ScanObserver(o,this));
    };

    return ScanObservable;
  }(ObservableBase));

  var ScanObserver = (function (__super__) {
    inherits(ScanObserver, __super__);
    function ScanObserver(o, parent) {
      this._o = o;
      this._p = parent;
      this._fn = parent.accumulator;
      this._hs = parent.hasSeed;
      this._s = parent.seed;
      this._ha = false;
      this._a = null;
      this._hv = false;
      this._i = 0;
      __super__.call(this);
    }

    ScanObserver.prototype.next = function (x) {
      !this._hv && (this._hv = true);
      if (this._ha) {
        this._a = tryCatch(this._fn)(this._a, x, this._i, this._p);
      } else {
        this._a = this._hs ? tryCatch(this._fn)(this._s, x, this._i, this._p) : x;
        this._ha = true;
      }
      if (this._a === errorObj) { return this._o.onError(this._a.e); }
      this._o.onNext(this._a);
      this._i++;
    };

    ScanObserver.prototype.error = function (e) {
      this._o.onError(e);
    };

    ScanObserver.prototype.completed = function () {
      !this._hv && this._hs && this._o.onNext(this._s);
      this._o.onCompleted();
    };

    return ScanObserver;
  }(AbstractObserver));

  /**
  *  Applies an accumulator function over an observable sequence and returns each intermediate result. The optional seed value is used as the initial accumulator value.
  *  For aggregation behavior with no intermediate results, see Observable.aggregate.
  * @param {Mixed} [seed] The initial accumulator value.
  * @param {Function} accumulator An accumulator function to be invoked on each element.
  * @returns {Observable} An observable sequence containing the accumulated values.
  */
  observableProto.scan = function () {
    var hasSeed = false, seed, accumulator = arguments[0];
    if (arguments.length === 2) {
      hasSeed = true;
      seed = arguments[1];
    }
    return new ScanObservable(this, accumulator, hasSeed, seed);
  };

  var SkipLastObservable = (function (__super__) {
    inherits(SkipLastObservable, __super__);
    function SkipLastObservable(source, c) {
      this.source = source;
      this._c = c;
      __super__.call(this);
    }

    SkipLastObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new SkipLastObserver(o, this._c));
    };

    return SkipLastObservable;
  }(ObservableBase));

  var SkipLastObserver = (function (__super__) {
    inherits(SkipLastObserver, __super__);
    function SkipLastObserver(o, c) {
      this._o = o;
      this._c = c;
      this._q = [];
      __super__.call(this);
    }

    SkipLastObserver.prototype.next = function (x) {
      this._q.push(x);
      this._q.length > this._c && this._o.onNext(this._q.shift());
    };

    SkipLastObserver.prototype.error = function (e) {
      this._o.onError(e);
    };

    SkipLastObserver.prototype.completed = function () {
      this._o.onCompleted();
    };

    return SkipLastObserver;
  }(AbstractObserver));

  /**
   *  Bypasses a specified number of elements at the end of an observable sequence.
   * @description
   *  This operator accumulates a queue with a length enough to store the first `count` elements. As more elements are
   *  received, elements are taken from the front of the queue and produced on the result sequence. This causes elements to be delayed.
   * @param count Number of elements to bypass at the end of the source sequence.
   * @returns {Observable} An observable sequence containing the source sequence elements except for the bypassed ones at the end.
   */
  observableProto.skipLast = function (count) {
    if (count < 0) { throw new ArgumentOutOfRangeError(); }
    return new SkipLastObservable(this, count);
  };

  /**
   *  Prepends a sequence of values to an observable sequence with an optional scheduler and an argument list of values to prepend.
   *  @example
   *  var res = source.startWith(1, 2, 3);
   *  var res = source.startWith(Rx.Scheduler.timeout, 1, 2, 3);
   * @param {Arguments} args The specified values to prepend to the observable sequence
   * @returns {Observable} The source sequence prepended with the specified values.
   */
  observableProto.startWith = function () {
    var values, scheduler, start = 0;
    if (!!arguments.length && isScheduler(arguments[0])) {
      scheduler = arguments[0];
      start = 1;
    } else {
      scheduler = immediateScheduler;
    }
    for(var args = [], i = start, len = arguments.length; i < len; i++) { args.push(arguments[i]); }
    return enumerableOf([observableFromArray(args, scheduler), this]).concat();
  };

  var TakeLastObserver = (function (__super__) {
    inherits(TakeLastObserver, __super__);
    function TakeLastObserver(o, c) {
      this._o = o;
      this._c = c;
      this._q = [];
      __super__.call(this);
    }

    TakeLastObserver.prototype.next = function (x) {
      this._q.push(x);
      this._q.length > this._c && this._q.shift();
    };

    TakeLastObserver.prototype.error = function (e) {
      this._o.onError(e);
    };

    TakeLastObserver.prototype.completed = function () {
      while (this._q.length > 0) { this._o.onNext(this._q.shift()); }
      this._o.onCompleted();
    };

    return TakeLastObserver;
  }(AbstractObserver));

  /**
   *  Returns a specified number of contiguous elements from the end of an observable sequence.
   * @description
   *  This operator accumulates a buffer with a length enough to store elements count elements. Upon completion of
   *  the source sequence, this buffer is drained on the result sequence. This causes the elements to be delayed.
   * @param {Number} count Number of elements to take from the end of the source sequence.
   * @returns {Observable} An observable sequence containing the specified number of elements from the end of the source sequence.
   */
  observableProto.takeLast = function (count) {
    if (count < 0) { throw new ArgumentOutOfRangeError(); }
    var source = this;
    return new AnonymousObservable(function (o) {
      return source.subscribe(new TakeLastObserver(o, count));
    }, source);
  };

observableProto.flatMapConcat = observableProto.concatMap = function(selector, resultSelector, thisArg) {
    return new FlatMapObservable(this, selector, resultSelector, thisArg).merge(1);
};
  var MapObservable = (function (__super__) {
    inherits(MapObservable, __super__);

    function MapObservable(source, selector, thisArg) {
      this.source = source;
      this.selector = bindCallback(selector, thisArg, 3);
      __super__.call(this);
    }

    function innerMap(selector, self) {
      return function (x, i, o) { return selector.call(this, self.selector(x, i, o), i, o); };
    }

    MapObservable.prototype.internalMap = function (selector, thisArg) {
      return new MapObservable(this.source, innerMap(selector, this), thisArg);
    };

    MapObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new InnerObserver(o, this.selector, this));
    };

    inherits(InnerObserver, AbstractObserver);
    function InnerObserver(o, selector, source) {
      this.o = o;
      this.selector = selector;
      this.source = source;
      this.i = 0;
      AbstractObserver.call(this);
    }

    InnerObserver.prototype.next = function(x) {
      var result = tryCatch(this.selector)(x, this.i++, this.source);
      if (result === errorObj) { return this.o.onError(result.e); }
      this.o.onNext(result);
    };

    InnerObserver.prototype.error = function (e) {
      this.o.onError(e);
    };

    InnerObserver.prototype.completed = function () {
      this.o.onCompleted();
    };

    return MapObservable;

  }(ObservableBase));

  /**
  * Projects each element of an observable sequence into a new form by incorporating the element's index.
  * @param {Function} selector A transform function to apply to each source element; the second parameter of the function represents the index of the source element.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} An observable sequence whose elements are the result of invoking the transform function on each element of source.
  */
  observableProto.map = observableProto.select = function (selector, thisArg) {
    var selectorFn = typeof selector === 'function' ? selector : function () { return selector; };
    return this instanceof MapObservable ?
      this.internalMap(selectorFn, thisArg) :
      new MapObservable(this, selectorFn, thisArg);
  };

  function plucker(args, len) {
    return function mapper(x) {
      var currentProp = x;
      for (var i = 0; i < len; i++) {
        var p = currentProp[args[i]];
        if (typeof p !== 'undefined') {
          currentProp = p;
        } else {
          return undefined;
        }
      }
      return currentProp;
    };
  }

  /**
   * Retrieves the value of a specified nested property from all elements in
   * the Observable sequence.
   * @param {Arguments} arguments The nested properties to pluck.
   * @returns {Observable} Returns a new Observable sequence of property values.
   */
  observableProto.pluck = function () {
    var len = arguments.length, args = new Array(len);
    if (len === 0) { throw new Error('List of properties cannot be empty.'); }
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return this.map(plucker(args, len));
  };

observableProto.flatMap = observableProto.selectMany = function(selector, resultSelector, thisArg) {
    return new FlatMapObservable(this, selector, resultSelector, thisArg).mergeAll();
};

Rx.Observable.prototype.flatMapLatest = function(selector, resultSelector, thisArg) {
    return new FlatMapObservable(this, selector, resultSelector, thisArg).switchLatest();
};
  var SkipObservable = (function(__super__) {
    inherits(SkipObservable, __super__);
    function SkipObservable(source, count) {
      this.source = source;
      this._count = count;
      __super__.call(this);
    }

    SkipObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new SkipObserver(o, this._count));
    };

    function SkipObserver(o, c) {
      this._o = o;
      this._r = c;
      AbstractObserver.call(this);
    }

    inherits(SkipObserver, AbstractObserver);

    SkipObserver.prototype.next = function (x) {
      if (this._r <= 0) {
        this._o.onNext(x);
      } else {
        this._r--;
      }
    };
    SkipObserver.prototype.error = function(e) { this._o.onError(e); };
    SkipObserver.prototype.completed = function() { this._o.onCompleted(); };

    return SkipObservable;
  }(ObservableBase));

  /**
   * Bypasses a specified number of elements in an observable sequence and then returns the remaining elements.
   * @param {Number} count The number of elements to skip before returning the remaining elements.
   * @returns {Observable} An observable sequence that contains the elements that occur after the specified index in the input sequence.
   */
  observableProto.skip = function (count) {
    if (count < 0) { throw new ArgumentOutOfRangeError(); }
    return new SkipObservable(this, count);
  };

  var SkipWhileObservable = (function (__super__) {
    inherits(SkipWhileObservable, __super__);
    function SkipWhileObservable(source, fn) {
      this.source = source;
      this._fn = fn;
      __super__.call(this);
    }

    SkipWhileObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new SkipWhileObserver(o, this));
    };

    return SkipWhileObservable;
  }(ObservableBase));

  var SkipWhileObserver = (function (__super__) {
    inherits(SkipWhileObserver, __super__);

    function SkipWhileObserver(o, p) {
      this._o = o;
      this._p = p;
      this._i = 0;
      this._r = false;
      __super__.call(this);
    }

    SkipWhileObserver.prototype.next = function (x) {
      if (!this._r) {
        var res = tryCatch(this._p._fn)(x, this._i++, this._p);
        if (res === errorObj) { return this._o.onError(res.e); }
        this._r = !res;
      }
      this._r && this._o.onNext(x);
    };
    SkipWhileObserver.prototype.error = function (e) { this._o.onError(e); };
    SkipWhileObserver.prototype.completed = function () { this._o.onCompleted(); };

    return SkipWhileObserver;
  }(AbstractObserver));

  /**
   *  Bypasses elements in an observable sequence as long as a specified condition is true and then returns the remaining elements.
   *  The element's index is used in the logic of the predicate function.
   *
   *  var res = source.skipWhile(function (value) { return value < 10; });
   *  var res = source.skipWhile(function (value, index) { return value < 10 || index < 10; });
   * @param {Function} predicate A function to test each element for a condition; the second parameter of the function represents the index of the source element.
   * @param {Any} [thisArg] Object to use as this when executing callback.
   * @returns {Observable} An observable sequence that contains the elements from the input sequence starting at the first element in the linear series that does not pass the test specified by predicate.
   */
  observableProto.skipWhile = function (predicate, thisArg) {
    var fn = bindCallback(predicate, thisArg, 3);
    return new SkipWhileObservable(this, fn);
  };

  var TakeObservable = (function(__super__) {
    inherits(TakeObservable, __super__);
    function TakeObservable(source, count) {
      this.source = source;
      this._count = count;
      __super__.call(this);
    }

    TakeObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new TakeObserver(o, this._count));
    };

    function TakeObserver(o, c) {
      this._o = o;
      this._c = c;
      this._r = c;
      AbstractObserver.call(this);
    }

    inherits(TakeObserver, AbstractObserver);

    TakeObserver.prototype.next = function (x) {
      if (this._r-- > 0) {
        this._o.onNext(x);
        this._r <= 0 && this._o.onCompleted();
      }
    };

    TakeObserver.prototype.error = function (e) { this._o.onError(e); };
    TakeObserver.prototype.completed = function () { this._o.onCompleted(); };

    return TakeObservable;
  }(ObservableBase));

  /**
   *  Returns a specified number of contiguous elements from the start of an observable sequence, using the specified scheduler for the edge case of take(0).
   * @param {Number} count The number of elements to return.
   * @param {Scheduler} [scheduler] Scheduler used to produce an OnCompleted message in case <paramref name="count count</paramref> is set to 0.
   * @returns {Observable} An observable sequence that contains the specified number of elements from the start of the input sequence.
   */
  observableProto.take = function (count, scheduler) {
    if (count < 0) { throw new ArgumentOutOfRangeError(); }
    if (count === 0) { return observableEmpty(scheduler); }
    return new TakeObservable(this, count);
  };

  var TakeWhileObservable = (function (__super__) {
    inherits(TakeWhileObservable, __super__);
    function TakeWhileObservable(source, fn) {
      this.source = source;
      this._fn = fn;
      __super__.call(this);
    }

    TakeWhileObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new TakeWhileObserver(o, this));
    };

    return TakeWhileObservable;
  }(ObservableBase));

  var TakeWhileObserver = (function (__super__) {
    inherits(TakeWhileObserver, __super__);

    function TakeWhileObserver(o, p) {
      this._o = o;
      this._p = p;
      this._i = 0;
      this._r = true;
      __super__.call(this);
    }

    TakeWhileObserver.prototype.next = function (x) {
      if (this._r) {
        this._r = tryCatch(this._p._fn)(x, this._i++, this._p);
        if (this._r === errorObj) { return this._o.onError(this._r.e); }
      }
      if (this._r) {
        this._o.onNext(x);
      } else {
        this._o.onCompleted();
      }
    };
    TakeWhileObserver.prototype.error = function (e) { this._o.onError(e); };
    TakeWhileObserver.prototype.completed = function () { this._o.onCompleted(); };

    return TakeWhileObserver;
  }(AbstractObserver));

  /**
   *  Returns elements from an observable sequence as long as a specified condition is true.
   *  The element's index is used in the logic of the predicate function.
   * @param {Function} predicate A function to test each element for a condition; the second parameter of the function represents the index of the source element.
   * @param {Any} [thisArg] Object to use as this when executing callback.
   * @returns {Observable} An observable sequence that contains the elements from the input sequence that occur before the element at which the test no longer passes.
   */
  observableProto.takeWhile = function (predicate, thisArg) {
    var fn = bindCallback(predicate, thisArg, 3);
    return new TakeWhileObservable(this, fn);
  };

  var FilterObservable = (function (__super__) {
    inherits(FilterObservable, __super__);

    function FilterObservable(source, predicate, thisArg) {
      this.source = source;
      this.predicate = bindCallback(predicate, thisArg, 3);
      __super__.call(this);
    }

    FilterObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new InnerObserver(o, this.predicate, this));
    };

    function innerPredicate(predicate, self) {
      return function(x, i, o) { return self.predicate(x, i, o) && predicate.call(this, x, i, o); }
    }

    FilterObservable.prototype.internalFilter = function(predicate, thisArg) {
      return new FilterObservable(this.source, innerPredicate(predicate, this), thisArg);
    };

    inherits(InnerObserver, AbstractObserver);
    function InnerObserver(o, predicate, source) {
      this.o = o;
      this.predicate = predicate;
      this.source = source;
      this.i = 0;
      AbstractObserver.call(this);
    }

    InnerObserver.prototype.next = function(x) {
      var shouldYield = tryCatch(this.predicate)(x, this.i++, this.source);
      if (shouldYield === errorObj) {
        return this.o.onError(shouldYield.e);
      }
      shouldYield && this.o.onNext(x);
    };

    InnerObserver.prototype.error = function (e) {
      this.o.onError(e);
    };

    InnerObserver.prototype.completed = function () {
      this.o.onCompleted();
    };

    return FilterObservable;

  }(ObservableBase));

  /**
  *  Filters the elements of an observable sequence based on a predicate by incorporating the element's index.
  * @param {Function} predicate A function to test each source element for a condition; the second parameter of the function represents the index of the source element.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} An observable sequence that contains elements from the input sequence that satisfy the condition.
  */
  observableProto.filter = observableProto.where = function (predicate, thisArg) {
    return this instanceof FilterObservable ? this.internalFilter(predicate, thisArg) :
      new FilterObservable(this, predicate, thisArg);
  };

function createCbObservable(fn, ctx, selector, args) {
  var o = new AsyncSubject();

  args.push(createCbHandler(o, ctx, selector));
  fn.apply(ctx, args);

  return o.asObservable();
}

function createCbHandler(o, ctx, selector) {
  return function handler () {
    var len = arguments.length, results = new Array(len);
    for(var i = 0; i < len; i++) { results[i] = arguments[i]; }

    if (isFunction(selector)) {
      results = tryCatch(selector).apply(ctx, results);
      if (results === errorObj) { return o.onError(results.e); }
      o.onNext(results);
    } else {
      if (results.length <= 1) {
        o.onNext(results[0]);
      } else {
        o.onNext(results);
      }
    }

    o.onCompleted();
  };
}

/**
 * Converts a callback function to an observable sequence.
 *
 * @param {Function} fn Function with a callback as the last parameter to convert to an Observable sequence.
 * @param {Mixed} [ctx] The context for the func parameter to be executed.  If not specified, defaults to undefined.
 * @param {Function} [selector] A selector which takes the arguments from the callback to produce a single item to yield on next.
 * @returns {Function} A function, when executed with the required parameters minus the callback, produces an Observable sequence with a single value of the arguments to the callback as an array.
 */
Observable.fromCallback = function (fn, ctx, selector) {
  return function () {
    typeof ctx === 'undefined' && (ctx = this); 

    var len = arguments.length, args = new Array(len)
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return createCbObservable(fn, ctx, selector, args);
  };
};

function createNodeObservable(fn, ctx, selector, args) {
  var o = new AsyncSubject();

  args.push(createNodeHandler(o, ctx, selector));
  fn.apply(ctx, args);

  return o.asObservable();
}

function createNodeHandler(o, ctx, selector) {
  return function handler () {
    var err = arguments[0];
    if (err) { return o.onError(err); }

    var len = arguments.length, results = [];
    for(var i = 1; i < len; i++) { results[i - 1] = arguments[i]; }

    if (isFunction(selector)) {
      var results = tryCatch(selector).apply(ctx, results);
      if (results === errorObj) { return o.onError(results.e); }
      o.onNext(results);
    } else {
      if (results.length <= 1) {
        o.onNext(results[0]);
      } else {
        o.onNext(results);
      }
    }

    o.onCompleted();
  };
}

/**
 * Converts a Node.js callback style function to an observable sequence.  This must be in function (err, ...) format.
 * @param {Function} fn The function to call
 * @param {Mixed} [ctx] The context for the func parameter to be executed.  If not specified, defaults to undefined.
 * @param {Function} [selector] A selector which takes the arguments from the callback minus the error to produce a single item to yield on next.
 * @returns {Function} An async function which when applied, returns an observable sequence with the callback arguments as an array.
 */
Observable.fromNodeCallback = function (fn, ctx, selector) {
  return function () {
    typeof ctx === 'undefined' && (ctx = this); 
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return createNodeObservable(fn, ctx, selector, args);
  };
};

  function isNodeList(el) {
    if (root.StaticNodeList) {
      // IE8 Specific
      // instanceof is slower than Object#toString, but Object#toString will not work as intended in IE8
      return el instanceof root.StaticNodeList || el instanceof root.NodeList;
    } else {
      return Object.prototype.toString.call(el) === '[object NodeList]';
    }
  }

  function ListenDisposable(e, n, fn) {
    this._e = e;
    this._n = n;
    this._fn = fn;
    this._e.addEventListener(this._n, this._fn, false);
    this.isDisposed = false;
  }
  ListenDisposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this._e.removeEventListener(this._n, this._fn, false);
      this.isDisposed = true;
    }
  };

  function createEventListener (el, eventName, handler) {
    var disposables = new CompositeDisposable();

    // Asume NodeList or HTMLCollection
    var elemToString = Object.prototype.toString.call(el);
    if (isNodeList(el) || elemToString === '[object HTMLCollection]') {
      for (var i = 0, len = el.length; i < len; i++) {
        disposables.add(createEventListener(el.item(i), eventName, handler));
      }
    } else if (el) {
      disposables.add(new ListenDisposable(el, eventName, handler));
    }

    return disposables;
  }

  /**
   * Configuration option to determine whether to use native events only
   */
  Rx.config.useNativeEvents = false;

  var EventObservable = (function(__super__) {
    inherits(EventObservable, __super__);
    function EventObservable(el, name, fn) {
      this._el = el;
      this._n = name;
      this._fn = fn;
      __super__.call(this);
    }

    function createHandler(o, fn) {
      return function handler () {
        var results = arguments[0];
        if (isFunction(fn)) {
          results = tryCatch(fn).apply(null, arguments);
          if (results === errorObj) { return o.onError(results.e); }
        }
        o.onNext(results);
      };
    }

    EventObservable.prototype.subscribeCore = function (o) {
      return createEventListener(
        this._el,
        this._n,
        createHandler(o, this._fn));
    };

    return EventObservable;
  }(ObservableBase));

  /**
   * Creates an observable sequence by adding an event listener to the matching DOMElement or each item in the NodeList.
   * @param {Object} element The DOMElement or NodeList to attach a listener.
   * @param {String} eventName The event name to attach the observable sequence.
   * @param {Function} [selector] A selector which takes the arguments from the event handler to produce a single item to yield on next.
   * @returns {Observable} An observable sequence of events from the specified element and the specified event.
   */
  Observable.fromEvent = function (element, eventName, selector) {
    // Node.js specific
    if (element.addListener) {
      return fromEventPattern(
        function (h) { element.addListener(eventName, h); },
        function (h) { element.removeListener(eventName, h); },
        selector);
    }

    // Use only if non-native events are allowed
    if (!Rx.config.useNativeEvents) {
      // Handles jq, Angular.js, Zepto, Marionette, Ember.js
      if (typeof element.on === 'function' && typeof element.off === 'function') {
        return fromEventPattern(
          function (h) { element.on(eventName, h); },
          function (h) { element.off(eventName, h); },
          selector);
      }
    }

    return new EventObservable(element, eventName, selector).publish().refCount();
  };

  var EventPatternObservable = (function(__super__) {
    inherits(EventPatternObservable, __super__);
    function EventPatternObservable(add, del, fn) {
      this._add = add;
      this._del = del;
      this._fn = fn;
      __super__.call(this);
    }

    function createHandler(o, fn) {
      return function handler () {
        var results = arguments[0];
        if (isFunction(fn)) {
          results = tryCatch(fn).apply(null, arguments);
          if (results === errorObj) { return o.onError(results.e); }
        }
        o.onNext(results);
      };
    }

    EventPatternObservable.prototype.subscribeCore = function (o) {
      var fn = createHandler(o, this._fn);
      var returnValue = this._add(fn);
      return new EventPatternDisposable(this._del, fn, returnValue);
    };

    function EventPatternDisposable(del, fn, ret) {
      this._del = del;
      this._fn = fn;
      this._ret = ret;
      this.isDisposed = false;
    }

    EventPatternDisposable.prototype.dispose = function () {
      if(!this.isDisposed) {
        isFunction(this._del) && this._del(this._fn, this._ret);
        this.isDisposed = true;
      }
    };

    return EventPatternObservable;
  }(ObservableBase));

  /**
   * Creates an observable sequence from an event emitter via an addHandler/removeHandler pair.
   * @param {Function} addHandler The function to add a handler to the emitter.
   * @param {Function} [removeHandler] The optional function to remove a handler from an emitter.
   * @param {Function} [selector] A selector which takes the arguments from the event handler to produce a single item to yield on next.
   * @returns {Observable} An observable sequence which wraps an event from an event emitter
   */
  var fromEventPattern = Observable.fromEventPattern = function (addHandler, removeHandler, selector) {
    return new EventPatternObservable(addHandler, removeHandler, selector).publish().refCount();
  };

  var FromPromiseObservable = (function(__super__) {
    inherits(FromPromiseObservable, __super__);
    function FromPromiseObservable(p, s) {
      this._p = p;
      this._s = s;
      __super__.call(this);
    }

    function scheduleNext(s, state) {
      var o = state[0], data = state[1];
      o.onNext(data);
      o.onCompleted();
    }

    function scheduleError(s, state) {
      var o = state[0], err = state[1];
      o.onError(err);
    }

    FromPromiseObservable.prototype.subscribeCore = function(o) {
      var sad = new SingleAssignmentDisposable(), self = this;

      this._p
        .then(function (data) {
          sad.setDisposable(self._s.schedule([o, data], scheduleNext));
        }, function (err) {
          sad.setDisposable(self._s.schedule([o, err], scheduleError));
        });

      return sad;
    };

    return FromPromiseObservable;
  }(ObservableBase));

  /**
  * Converts a Promise to an Observable sequence
  * @param {Promise} An ES6 Compliant promise.
  * @returns {Observable} An Observable sequence which wraps the existing promise success and failure.
  */
  var observableFromPromise = Observable.fromPromise = function (promise, scheduler) {
    scheduler || (scheduler = defaultScheduler);
    return new FromPromiseObservable(promise, scheduler);
  };

  /*
   * Converts an existing observable sequence to an ES6 Compatible Promise
   * @example
   * var promise = Rx.Observable.return(42).toPromise(RSVP.Promise);
   *
   * // With config
   * Rx.config.Promise = RSVP.Promise;
   * var promise = Rx.Observable.return(42).toPromise();
   * @param {Function} [promiseCtor] The constructor of the promise. If not provided, it looks for it in Rx.config.Promise.
   * @returns {Promise} An ES6 compatible promise with the last value from the observable sequence.
   */
  observableProto.toPromise = function (promiseCtor) {
    promiseCtor || (promiseCtor = Rx.config.Promise);
    if (!promiseCtor) { throw new NotSupportedError('Promise type not provided nor in Rx.config.Promise'); }
    var source = this;
    return new promiseCtor(function (resolve, reject) {
      // No cancellation can be done
      var value;
      source.subscribe(function (v) {
        value = v;
      }, reject, function () {
        resolve(value);
      });
    });
  };

  /**
   * Invokes the asynchronous function, surfacing the result through an observable sequence.
   * @param {Function} functionAsync Asynchronous function which returns a Promise to run.
   * @returns {Observable} An observable sequence exposing the function's result value, or an exception.
   */
  Observable.startAsync = function (functionAsync) {
    var promise = tryCatch(functionAsync)();
    if (promise === errorObj) { return observableThrow(promise.e); }
    return observableFromPromise(promise);
  };

  var MulticastObservable = (function (__super__) {
    inherits(MulticastObservable, __super__);
    function MulticastObservable(source, fn1, fn2) {
      this.source = source;
      this._fn1 = fn1;
      this._fn2 = fn2;
      __super__.call(this);
    }

    MulticastObservable.prototype.subscribeCore = function (o) {
      var connectable = this.source.multicast(this._fn1());
      return new BinaryDisposable(this._fn2(connectable).subscribe(o), connectable.connect());
    };

    return MulticastObservable;
  }(ObservableBase));

  /**
   * Multicasts the source sequence notifications through an instantiated subject into all uses of the sequence within a selector function. Each
   * subscription to the resulting sequence causes a separate multicast invocation, exposing the sequence resulting from the selector function's
   * invocation. For specializations with fixed subject types, see Publish, PublishLast, and Replay.
   *
   * @example
   * 1 - res = source.multicast(observable);
   * 2 - res = source.multicast(function () { return new Subject(); }, function (x) { return x; });
   *
   * @param {Function|Subject} subjectOrSubjectSelector
   * Factory function to create an intermediate subject through which the source sequence's elements will be multicast to the selector function.
   * Or:
   * Subject to push source elements into.
   *
   * @param {Function} [selector] Optional selector function which can use the multicasted source sequence subject to the policies enforced by the created subject. Specified only if <paramref name="subjectOrSubjectSelector" is a factory function.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */
  observableProto.multicast = function (subjectOrSubjectSelector, selector) {
    return isFunction(subjectOrSubjectSelector) ?
      new MulticastObservable(this, subjectOrSubjectSelector, selector) :
      new ConnectableObservable(this, subjectOrSubjectSelector);
  };

  /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence.
   * This operator is a specialization of Multicast using a regular Subject.
   *
   * @example
   * var resres = source.publish();
   * var res = source.publish(function (x) { return x; });
   *
   * @param {Function} [selector] Selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */
  observableProto.publish = function (selector) {
    return selector && isFunction(selector) ?
      this.multicast(function () { return new Subject(); }, selector) :
      this.multicast(new Subject());
  };

  /**
   * Returns an observable sequence that shares a single subscription to the underlying sequence.
   * This operator is a specialization of publish which creates a subscription when the number of observers goes from zero to one, then shares that subscription with all subsequent observers until the number of observers returns to zero, at which point the subscription is disposed.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence.
   */
  observableProto.share = function () {
    return this.publish().refCount();
  };

  /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence containing only the last notification.
   * This operator is a specialization of Multicast using a AsyncSubject.
   *
   * @example
   * var res = source.publishLast();
   * var res = source.publishLast(function (x) { return x; });
   *
   * @param selector [Optional] Selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will only receive the last notification of the source.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */
  observableProto.publishLast = function (selector) {
    return selector && isFunction(selector) ?
      this.multicast(function () { return new AsyncSubject(); }, selector) :
      this.multicast(new AsyncSubject());
  };

  /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence and starts with initialValue.
   * This operator is a specialization of Multicast using a BehaviorSubject.
   *
   * @example
   * var res = source.publishValue(42);
   * var res = source.publishValue(function (x) { return x.select(function (y) { return y * y; }) }, 42);
   *
   * @param {Function} [selector] Optional selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will receive immediately receive the initial value, followed by all notifications of the source from the time of the subscription on.
   * @param {Mixed} initialValue Initial value received by observers upon subscription.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */
  observableProto.publishValue = function (initialValueOrSelector, initialValue) {
    return arguments.length === 2 ?
      this.multicast(function () {
        return new BehaviorSubject(initialValue);
      }, initialValueOrSelector) :
      this.multicast(new BehaviorSubject(initialValueOrSelector));
  };

  /**
   * Returns an observable sequence that shares a single subscription to the underlying sequence and starts with an initialValue.
   * This operator is a specialization of publishValue which creates a subscription when the number of observers goes from zero to one, then shares that subscription with all subsequent observers until the number of observers returns to zero, at which point the subscription is disposed.
   * @param {Mixed} initialValue Initial value received by observers upon subscription.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence.
   */
  observableProto.shareValue = function (initialValue) {
    return this.publishValue(initialValue).refCount();
  };

  /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence replaying notifications subject to a maximum time length for the replay buffer.
   * This operator is a specialization of Multicast using a ReplaySubject.
   *
   * @example
   * var res = source.replay(null, 3);
   * var res = source.replay(null, 3, 500);
   * var res = source.replay(null, 3, 500, scheduler);
   * var res = source.replay(function (x) { return x.take(6).repeat(); }, 3, 500, scheduler);
   *
   * @param selector [Optional] Selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will receive all the notifications of the source subject to the specified replay buffer trimming policy.
   * @param bufferSize [Optional] Maximum element count of the replay buffer.
   * @param windowSize [Optional] Maximum time length of the replay buffer.
   * @param scheduler [Optional] Scheduler where connected observers within the selector function will be invoked on.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */
  observableProto.replay = function (selector, bufferSize, windowSize, scheduler) {
    return selector && isFunction(selector) ?
      this.multicast(function () { return new ReplaySubject(bufferSize, windowSize, scheduler); }, selector) :
      this.multicast(new ReplaySubject(bufferSize, windowSize, scheduler));
  };

  /**
   * Returns an observable sequence that shares a single subscription to the underlying sequence replaying notifications subject to a maximum time length for the replay buffer.
   * This operator is a specialization of replay which creates a subscription when the number of observers goes from zero to one, then shares that subscription with all subsequent observers until the number of observers returns to zero, at which point the subscription is disposed.
   *
   * @example
   * var res = source.shareReplay(3);
   * var res = source.shareReplay(3, 500);
   * var res = source.shareReplay(3, 500, scheduler);
   *

   * @param bufferSize [Optional] Maximum element count of the replay buffer.
   * @param window [Optional] Maximum time length of the replay buffer.
   * @param scheduler [Optional] Scheduler where connected observers within the selector function will be invoked on.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence.
   */
  observableProto.shareReplay = function (bufferSize, windowSize, scheduler) {
    return this.replay(null, bufferSize, windowSize, scheduler).refCount();
  };

  var RefCountObservable = (function (__super__) {
    inherits(RefCountObservable, __super__);
    function RefCountObservable(source) {
      this.source = source;
      this._count = 0;
      this._connectableSubscription = null;
      __super__.call(this);
    }

    RefCountObservable.prototype.subscribeCore = function (o) {
      var subscription = this.source.subscribe(o);
      ++this._count === 1 && (this._connectableSubscription = this.source.connect());
      return new RefCountDisposable(this, subscription);
    };

    function RefCountDisposable(p, s) {
      this._p = p;
      this._s = s;
      this.isDisposed = false;
    }

    RefCountDisposable.prototype.dispose = function () {
      if (!this.isDisposed) {
        this.isDisposed = true;
        this._s.dispose();
        --this._p._count === 0 && this._p._connectableSubscription.dispose();
      }
    };

    return RefCountObservable;
  }(ObservableBase));

  var ConnectableObservable = Rx.ConnectableObservable = (function (__super__) {
    inherits(ConnectableObservable, __super__);
    function ConnectableObservable(source, subject) {
      this.source = source;
      this._connection = null;
      this._source = source.asObservable();
      this._subject = subject;
      __super__.call(this);
    }

    function ConnectDisposable(parent, subscription) {
      this._p = parent;
      this._s = subscription;
    }

    ConnectDisposable.prototype.dispose = function () {
      if (this._s) {
        this._s.dispose();
        this._s = null;
        this._p._connection = null;
      }
    };

    ConnectableObservable.prototype.connect = function () {
      if (!this._connection) {
        var subscription = this._source.subscribe(this._subject);
        this._connection = new ConnectDisposable(this, subscription);
      }
      return this._connection;
    };

    ConnectableObservable.prototype._subscribe = function (o) {
      return this._subject.subscribe(o);
    };

    ConnectableObservable.prototype.refCount = function () {
      return new RefCountObservable(this);
    };

    return ConnectableObservable;
  }(Observable));

  var TimerObservable = (function(__super__) {
    inherits(TimerObservable, __super__);
    function TimerObservable(dt, s) {
      this._dt = dt;
      this._s = s;
      __super__.call(this);
    }

    TimerObservable.prototype.subscribeCore = function (o) {
      return this._s.scheduleFuture(o, this._dt, scheduleMethod);
    };

    function scheduleMethod(s, o) {
      o.onNext(0);
      o.onCompleted();
    }

    return TimerObservable;
  }(ObservableBase));

  function _observableTimer(dueTime, scheduler) {
    return new TimerObservable(dueTime, scheduler);
  }

  function observableTimerDateAndPeriod(dueTime, period, scheduler) {
    return new AnonymousObservable(function (observer) {
      var d = dueTime, p = normalizeTime(period);
      return scheduler.scheduleRecursiveFuture(0, d, function (count, self) {
        if (p > 0) {
          var now = scheduler.now();
          d = new Date(d.getTime() + p);
          d.getTime() <= now && (d = new Date(now + p));
        }
        observer.onNext(count);
        self(count + 1, new Date(d));
      });
    });
  }

  function observableTimerTimeSpanAndPeriod(dueTime, period, scheduler) {
    return dueTime === period ?
      new AnonymousObservable(function (observer) {
        return scheduler.schedulePeriodic(0, period, function (count) {
          observer.onNext(count);
          return count + 1;
        });
      }) :
      observableDefer(function () {
        return observableTimerDateAndPeriod(new Date(scheduler.now() + dueTime), period, scheduler);
      });
  }

  /**
   *  Returns an observable sequence that produces a value after each period.
   *
   * @example
   *  1 - res = Rx.Observable.interval(1000);
   *  2 - res = Rx.Observable.interval(1000, Rx.Scheduler.timeout);
   *
   * @param {Number} period Period for producing the values in the resulting sequence (specified as an integer denoting milliseconds).
   * @param {Scheduler} [scheduler] Scheduler to run the timer on. If not specified, Rx.Scheduler.timeout is used.
   * @returns {Observable} An observable sequence that produces a value after each period.
   */
  var observableinterval = Observable.interval = function (period, scheduler) {
    return observableTimerTimeSpanAndPeriod(period, period, isScheduler(scheduler) ? scheduler : defaultScheduler);
  };

  /**
   *  Returns an observable sequence that produces a value after dueTime has elapsed and then after each period.
   * @param {Number} dueTime Absolute (specified as a Date object) or relative time (specified as an integer denoting milliseconds) at which to produce the first value.
   * @param {Mixed} [periodOrScheduler]  Period to produce subsequent values (specified as an integer denoting milliseconds), or the scheduler to run the timer on. If not specified, the resulting timer is not recurring.
   * @param {Scheduler} [scheduler]  Scheduler to run the timer on. If not specified, the timeout scheduler is used.
   * @returns {Observable} An observable sequence that produces a value after due time has elapsed and then each period.
   */
  var observableTimer = Observable.timer = function (dueTime, periodOrScheduler, scheduler) {
    var period;
    isScheduler(scheduler) || (scheduler = defaultScheduler);
    if (periodOrScheduler != null && typeof periodOrScheduler === 'number') {
      period = periodOrScheduler;
    } else if (isScheduler(periodOrScheduler)) {
      scheduler = periodOrScheduler;
    }
    if ((dueTime instanceof Date || typeof dueTime === 'number') && period === undefined) {
      return _observableTimer(dueTime, scheduler);
    }
    if (dueTime instanceof Date && period !== undefined) {
      return observableTimerDateAndPeriod(dueTime, periodOrScheduler, scheduler);
    }
    return observableTimerTimeSpanAndPeriod(dueTime, period, scheduler);
  };

  function observableDelayRelative(source, dueTime, scheduler) {
    return new AnonymousObservable(function (o) {
      var active = false,
        cancelable = new SerialDisposable(),
        exception = null,
        q = [],
        running = false,
        subscription;
      subscription = source.materialize().timestamp(scheduler).subscribe(function (notification) {
        var d, shouldRun;
        if (notification.value.kind === 'E') {
          q = [];
          q.push(notification);
          exception = notification.value.error;
          shouldRun = !running;
        } else {
          q.push({ value: notification.value, timestamp: notification.timestamp + dueTime });
          shouldRun = !active;
          active = true;
        }
        if (shouldRun) {
          if (exception !== null) {
            o.onError(exception);
          } else {
            d = new SingleAssignmentDisposable();
            cancelable.setDisposable(d);
            d.setDisposable(scheduler.scheduleRecursiveFuture(null, dueTime, function (_, self) {
              var e, recurseDueTime, result, shouldRecurse;
              if (exception !== null) {
                return;
              }
              running = true;
              do {
                result = null;
                if (q.length > 0 && q[0].timestamp - scheduler.now() <= 0) {
                  result = q.shift().value;
                }
                if (result !== null) {
                  result.accept(o);
                }
              } while (result !== null);
              shouldRecurse = false;
              recurseDueTime = 0;
              if (q.length > 0) {
                shouldRecurse = true;
                recurseDueTime = Math.max(0, q[0].timestamp - scheduler.now());
              } else {
                active = false;
              }
              e = exception;
              running = false;
              if (e !== null) {
                o.onError(e);
              } else if (shouldRecurse) {
                self(null, recurseDueTime);
              }
            }));
          }
        }
      });
      return new BinaryDisposable(subscription, cancelable);
    }, source);
  }

  function observableDelayAbsolute(source, dueTime, scheduler) {
    return observableDefer(function () {
      return observableDelayRelative(source, dueTime - scheduler.now(), scheduler);
    });
  }

  function delayWithSelector(source, subscriptionDelay, delayDurationSelector) {
    var subDelay, selector;
    if (isFunction(subscriptionDelay)) {
      selector = subscriptionDelay;
    } else {
      subDelay = subscriptionDelay;
      selector = delayDurationSelector;
    }
    return new AnonymousObservable(function (o) {
      var delays = new CompositeDisposable(), atEnd = false, subscription = new SerialDisposable();

      function start() {
        subscription.setDisposable(source.subscribe(
          function (x) {
            var delay = tryCatch(selector)(x);
            if (delay === errorObj) { return o.onError(delay.e); }
            var d = new SingleAssignmentDisposable();
            delays.add(d);
            d.setDisposable(delay.subscribe(
              function () {
                o.onNext(x);
                delays.remove(d);
                done();
              },
              function (e) { o.onError(e); },
              function () {
                o.onNext(x);
                delays.remove(d);
                done();
              }
            ));
          },
          function (e) { o.onError(e); },
          function () {
            atEnd = true;
            subscription.dispose();
            done();
          }
        ));
      }

      function done () {
        atEnd && delays.length === 0 && o.onCompleted();
      }

      if (!subDelay) {
        start();
      } else {
        subscription.setDisposable(subDelay.subscribe(start, function (e) { o.onError(e); }, start));
      }

      return new BinaryDisposable(subscription, delays);
    }, source);
  }

  /**
   *  Time shifts the observable sequence by dueTime.
   *  The relative time intervals between the values are preserved.
   *
   * @param {Number} dueTime Absolute (specified as a Date object) or relative time (specified as an integer denoting milliseconds) by which to shift the observable sequence.
   * @param {Scheduler} [scheduler] Scheduler to run the delay timers on. If not specified, the timeout scheduler is used.
   * @returns {Observable} Time-shifted sequence.
   */
  observableProto.delay = function () {
    var firstArg = arguments[0];
    if (typeof firstArg === 'number' || firstArg instanceof Date) {
      var dueTime = firstArg, scheduler = arguments[1];
      isScheduler(scheduler) || (scheduler = defaultScheduler);
      return dueTime instanceof Date ?
        observableDelayAbsolute(this, dueTime, scheduler) :
        observableDelayRelative(this, dueTime, scheduler);
    } else if (Observable.isObservable(firstArg) || isFunction(firstArg)) {
      return delayWithSelector(this, firstArg, arguments[1]);
    } else {
      throw new Error('Invalid arguments');
    }
  };

  var DebounceObservable = (function (__super__) {
    inherits(DebounceObservable, __super__);
    function DebounceObservable(source, dt, s) {
      isScheduler(s) || (s = defaultScheduler);
      this.source = source;
      this._dt = dt;
      this._s = s;
      __super__.call(this);
    }

    DebounceObservable.prototype.subscribeCore = function (o) {
      var cancelable = new SerialDisposable();
      return new BinaryDisposable(
        this.source.subscribe(new DebounceObserver(o, this._dt, this._s, cancelable)),
        cancelable);
    };

    return DebounceObservable;
  }(ObservableBase));

  var DebounceObserver = (function (__super__) {
    inherits(DebounceObserver, __super__);
    function DebounceObserver(observer, dueTime, scheduler, cancelable) {
      this._o = observer;
      this._d = dueTime;
      this._scheduler = scheduler;
      this._c = cancelable;
      this._v = null;
      this._hv = false;
      this._id = 0;
      __super__.call(this);
    }

    function scheduleFuture(s, state) {
      state.self._hv && state.self._id === state.currentId && state.self._o.onNext(state.x);
      state.self._hv = false;
    }

    DebounceObserver.prototype.next = function (x) {
      this._hv = true;
      this._v = x;
      var currentId = ++this._id, d = new SingleAssignmentDisposable();
      this._c.setDisposable(d);
      d.setDisposable(this._scheduler.scheduleFuture(this, this._d, function (_, self) {
        self._hv && self._id === currentId && self._o.onNext(x);
        self._hv = false;
      }));
    };

    DebounceObserver.prototype.error = function (e) {
      this._c.dispose();
      this._o.onError(e);
      this._hv = false;
      this._id++;
    };

    DebounceObserver.prototype.completed = function () {
      this._c.dispose();
      this._hv && this._o.onNext(this._v);
      this._o.onCompleted();
      this._hv = false;
      this._id++;
    };

    return DebounceObserver;
  }(AbstractObserver));

  function debounceWithSelector(source, durationSelector) {
    return new AnonymousObservable(function (o) {
      var value, hasValue = false, cancelable = new SerialDisposable(), id = 0;
      var subscription = source.subscribe(
        function (x) {
          var throttle = tryCatch(durationSelector)(x);
          if (throttle === errorObj) { return o.onError(throttle.e); }

          isPromise(throttle) && (throttle = observableFromPromise(throttle));

          hasValue = true;
          value = x;
          id++;
          var currentid = id, d = new SingleAssignmentDisposable();
          cancelable.setDisposable(d);
          d.setDisposable(throttle.subscribe(
            function () {
              hasValue && id === currentid && o.onNext(value);
              hasValue = false;
              d.dispose();
            },
            function (e) { o.onError(e); },
            function () {
              hasValue && id === currentid && o.onNext(value);
              hasValue = false;
              d.dispose();
            }
          ));
        },
        function (e) {
          cancelable.dispose();
          o.onError(e);
          hasValue = false;
          id++;
        },
        function () {
          cancelable.dispose();
          hasValue && o.onNext(value);
          o.onCompleted();
          hasValue = false;
          id++;
        }
      );
      return new BinaryDisposable(subscription, cancelable);
    }, source);
  }

  observableProto.debounce = function () {
    if (isFunction (arguments[0])) {
      return debounceWithSelector(this, arguments[0]);
    } else if (typeof arguments[0] === 'number') {
      return new DebounceObservable(this, arguments[0], arguments[1]);
    } else {
      throw new Error('Invalid arguments');
    }
  };

  var TimestampObservable = (function (__super__) {
    inherits(TimestampObservable, __super__);
    function TimestampObservable(source, s) {
      this.source = source;
      this._s = s;
      __super__.call(this);
    }

    TimestampObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new TimestampObserver(o, this._s));
    };

    return TimestampObservable;
  }(ObservableBase));

  var TimestampObserver = (function (__super__) {
    inherits(TimestampObserver, __super__);
    function TimestampObserver(o, s) {
      this._o = o;
      this._s = s;
      __super__.call(this);
    }

    TimestampObserver.prototype.next = function (x) {
      this._o.onNext({ value: x, timestamp: this._s.now() });
    };

    TimestampObserver.prototype.error = function (e) {
      this._o.onError(e);
    };

    TimestampObserver.prototype.completed = function () {
      this._o.onCompleted();
    };

    return TimestampObserver;
  }(AbstractObserver));

  /**
   *  Records the timestamp for each value in an observable sequence.
   *
   * @example
   *  1 - res = source.timestamp(); // produces { value: x, timestamp: ts }
   *  2 - res = source.timestamp(Rx.Scheduler.default);
   *
   * @param {Scheduler} [scheduler]  Scheduler used to compute timestamps. If not specified, the default scheduler is used.
   * @returns {Observable} An observable sequence with timestamp information on values.
   */
  observableProto.timestamp = function (scheduler) {
    isScheduler(scheduler) || (scheduler = defaultScheduler);
    return new TimestampObservable(this, scheduler);
  };

  var SampleObservable = (function(__super__) {
    inherits(SampleObservable, __super__);
    function SampleObservable(source, sampler) {
      this.source = source;
      this._sampler = sampler;
      __super__.call(this);
    }

    SampleObservable.prototype.subscribeCore = function (o) {
      var state = {
        o: o,
        atEnd: false,
        value: null,
        hasValue: false,
        sourceSubscription: new SingleAssignmentDisposable()
      };

      state.sourceSubscription.setDisposable(this.source.subscribe(new SampleSourceObserver(state)));
      return new BinaryDisposable(
        state.sourceSubscription,
        this._sampler.subscribe(new SamplerObserver(state))
      );
    };

    return SampleObservable;
  }(ObservableBase));

  var SamplerObserver = (function(__super__) {
    inherits(SamplerObserver, __super__);
    function SamplerObserver(s) {
      this._s = s;
      __super__.call(this);
    }

    SamplerObserver.prototype._handleMessage = function () {
      if (this._s.hasValue) {
        this._s.hasValue = false;
        this._s.o.onNext(this._s.value);
      }
      this._s.atEnd && this._s.o.onCompleted();
    };

    SamplerObserver.prototype.next = function () { this._handleMessage(); };
    SamplerObserver.prototype.error = function (e) { this._s.onError(e); };
    SamplerObserver.prototype.completed = function () { this._handleMessage(); };

    return SamplerObserver;
  }(AbstractObserver));

  var SampleSourceObserver = (function(__super__) {
    inherits(SampleSourceObserver, __super__);
    function SampleSourceObserver(s) {
      this._s = s;
      __super__.call(this);
    }

    SampleSourceObserver.prototype.next = function (x) {
      this._s.hasValue = true;
      this._s.value = x;
    };
    SampleSourceObserver.prototype.error = function (e) { this._s.o.onError(e); };
    SampleSourceObserver.prototype.completed = function () {
      this._s.atEnd = true;
      this._s.sourceSubscription.dispose();
    };

    return SampleSourceObserver;
  }(AbstractObserver));

  /**
   *  Samples the observable sequence at each interval.
   *
   * @example
   *  1 - res = source.sample(sampleObservable); // Sampler tick sequence
   *  2 - res = source.sample(5000); // 5 seconds
   *  2 - res = source.sample(5000, Rx.Scheduler.timeout); // 5 seconds
   *
   * @param {Mixed} intervalOrSampler Interval at which to sample (specified as an integer denoting milliseconds) or Sampler Observable.
   * @param {Scheduler} [scheduler]  Scheduler to run the sampling timer on. If not specified, the timeout scheduler is used.
   * @returns {Observable} Sampled observable sequence.
   */
  observableProto.sample = function (intervalOrSampler, scheduler) {
    isScheduler(scheduler) || (scheduler = defaultScheduler);
    return typeof intervalOrSampler === 'number' ?
      new SampleObservable(this, observableinterval(intervalOrSampler, scheduler)) :
      new SampleObservable(this, intervalOrSampler);
  };

  var TimeoutError = Rx.TimeoutError = function(message) {
    this.message = message || 'Timeout has occurred';
    this.name = 'TimeoutError';
    Error.call(this);
  };
  TimeoutError.prototype = Object.create(Error.prototype);

  function timeoutWithSelector(source, firstTimeout, timeoutDurationSelector, other) {
    if (isFunction(firstTimeout)) {
      other = timeoutDurationSelector;
      timeoutDurationSelector = firstTimeout;
      firstTimeout = observableNever();
    }
    Observable.isObservable(other) || (other = observableThrow(new TimeoutError()));
    return new AnonymousObservable(function (o) {
      var subscription = new SerialDisposable(),
        timer = new SerialDisposable(),
        original = new SingleAssignmentDisposable();

      subscription.setDisposable(original);

      var id = 0, switched = false;

      function setTimer(timeout) {
        var myId = id, d = new SingleAssignmentDisposable();

        function timerWins() {
          switched = (myId === id);
          return switched;
        }

        timer.setDisposable(d);
        d.setDisposable(timeout.subscribe(function () {
          timerWins() && subscription.setDisposable(other.subscribe(o));
          d.dispose();
        }, function (e) {
          timerWins() && o.onError(e);
        }, function () {
          timerWins() && subscription.setDisposable(other.subscribe(o));
        }));
      };

      setTimer(firstTimeout);

      function oWins() {
        var res = !switched;
        if (res) { id++; }
        return res;
      }

      original.setDisposable(source.subscribe(function (x) {
        if (oWins()) {
          o.onNext(x);
          var timeout = tryCatch(timeoutDurationSelector)(x);
          if (timeout === errorObj) { return o.onError(timeout.e); }
          setTimer(isPromise(timeout) ? observableFromPromise(timeout) : timeout);
        }
      }, function (e) {
        oWins() && o.onError(e);
      }, function () {
        oWins() && o.onCompleted();
      }));
      return new BinaryDisposable(subscription, timer);
    }, source);
  }

  function timeout(source, dueTime, other, scheduler) {
    if (isScheduler(other)) {
      scheduler = other;
      other = observableThrow(new TimeoutError());
    }
    if (other instanceof Error) { other = observableThrow(other); }
    isScheduler(scheduler) || (scheduler = defaultScheduler);
    Observable.isObservable(other) || (other = observableThrow(new TimeoutError()));
    return new AnonymousObservable(function (o) {
      var id = 0,
        original = new SingleAssignmentDisposable(),
        subscription = new SerialDisposable(),
        switched = false,
        timer = new SerialDisposable();

      subscription.setDisposable(original);

      function createTimer() {
        var myId = id;
        timer.setDisposable(scheduler.scheduleFuture(null, dueTime, function () {
          switched = id === myId;
          if (switched) {
            isPromise(other) && (other = observableFromPromise(other));
            subscription.setDisposable(other.subscribe(o));
          }
        }));
      }

      createTimer();

      original.setDisposable(source.subscribe(function (x) {
        if (!switched) {
          id++;
          o.onNext(x);
          createTimer();
        }
      }, function (e) {
        if (!switched) {
          id++;
          o.onError(e);
        }
      }, function () {
        if (!switched) {
          id++;
          o.onCompleted();
        }
      }));
      return new BinaryDisposable(subscription, timer);
    }, source);
  }

  observableProto.timeout = function () {
    var firstArg = arguments[0];
    if (firstArg instanceof Date || typeof firstArg === 'number') {
      return timeout(this, firstArg, arguments[1], arguments[2]);
    } else if (Observable.isObservable(firstArg) || isFunction(firstArg)) {
      return timeoutWithSelector(this, firstArg, arguments[1], arguments[2]);
    } else {
      throw new Error('Invalid arguments');
    }
  };

  /**
   * Returns an Observable that emits only the first item emitted by the source Observable during sequential time windows of a specified duration.
   * @param {Number} windowDuration time to wait before emitting another item after emitting the last item
   * @param {Scheduler} [scheduler] the Scheduler to use internally to manage the timers that handle timeout for each item. If not provided, defaults to Scheduler.timeout.
   * @returns {Observable} An Observable that performs the throttle operation.
   */
  observableProto.throttle = function (windowDuration, scheduler) {
    isScheduler(scheduler) || (scheduler = defaultScheduler);
    var duration = +windowDuration || 0;
    if (duration <= 0) { throw new RangeError('windowDuration cannot be less or equal zero.'); }
    var source = this;
    return new AnonymousObservable(function (o) {
      var lastOnNext = 0;
      return source.subscribe(
        function (x) {
          var now = scheduler.now();
          if (lastOnNext === 0 || now - lastOnNext >= duration) {
            lastOnNext = now;
            o.onNext(x);
          }
        },function (e) { o.onError(e); }, function () { o.onCompleted(); }
      );
    }, source);
  };

  var PausableObservable = (function (__super__) {
    inherits(PausableObservable, __super__);
    function PausableObservable(source, pauser) {
      this.source = source;
      this.controller = new Subject();

      if (pauser && pauser.subscribe) {
        this.pauser = this.controller.merge(pauser);
      } else {
        this.pauser = this.controller;
      }

      __super__.call(this);
    }

    PausableObservable.prototype._subscribe = function (o) {
      var conn = this.source.publish(),
        subscription = conn.subscribe(o),
        connection = disposableEmpty;

      var pausable = this.pauser.distinctUntilChanged().subscribe(function (b) {
        if (b) {
          connection = conn.connect();
        } else {
          connection.dispose();
          connection = disposableEmpty;
        }
      });

      return new NAryDisposable([subscription, connection, pausable]);
    };

    PausableObservable.prototype.pause = function () {
      this.controller.onNext(false);
    };

    PausableObservable.prototype.resume = function () {
      this.controller.onNext(true);
    };

    return PausableObservable;

  }(Observable));

  /**
   * Pauses the underlying observable sequence based upon the observable sequence which yields true/false.
   * @example
   * var pauser = new Rx.Subject();
   * var source = Rx.Observable.interval(100).pausable(pauser);
   * @param {Observable} pauser The observable sequence used to pause the underlying sequence.
   * @returns {Observable} The observable sequence which is paused based upon the pauser.
   */
  observableProto.pausable = function (pauser) {
    return new PausableObservable(this, pauser);
  };

  function combineLatestSource(source, subject, resultSelector) {
    return new AnonymousObservable(function (o) {
      var hasValue = [false, false],
        hasValueAll = false,
        isDone = false,
        values = new Array(2),
        err;

      function next(x, i) {
        values[i] = x;
        hasValue[i] = true;
        if (hasValueAll || (hasValueAll = hasValue.every(identity))) {
          if (err) { return o.onError(err); }
          var res = tryCatch(resultSelector).apply(null, values);
          if (res === errorObj) { return o.onError(res.e); }
          o.onNext(res);
        }
        isDone && values[1] && o.onCompleted();
      }

      return new BinaryDisposable(
        source.subscribe(
          function (x) {
            next(x, 0);
          },
          function (e) {
            if (values[1]) {
              o.onError(e);
            } else {
              err = e;
            }
          },
          function () {
            isDone = true;
            values[1] && o.onCompleted();
          }),
        subject.subscribe(
          function (x) {
            next(x, 1);
          },
          function (e) { o.onError(e); },
          function () {
            isDone = true;
            next(true, 1);
          })
        );
    }, source);
  }

  var PausableBufferedObservable = (function (__super__) {
    inherits(PausableBufferedObservable, __super__);
    function PausableBufferedObservable(source, pauser) {
      this.source = source;
      this.controller = new Subject();

      if (pauser && pauser.subscribe) {
        this.pauser = this.controller.merge(pauser);
      } else {
        this.pauser = this.controller;
      }

      __super__.call(this);
    }

    PausableBufferedObservable.prototype._subscribe = function (o) {
      var q = [], previousShouldFire;

      function drainQueue() { while (q.length > 0) { o.onNext(q.shift()); } }

      var subscription =
        combineLatestSource(
          this.source,
          this.pauser.startWith(false).distinctUntilChanged(),
          function (data, shouldFire) {
            return { data: data, shouldFire: shouldFire };
          })
          .subscribe(
            function (results) {
              if (previousShouldFire !== undefined && results.shouldFire !== previousShouldFire) {
                previousShouldFire = results.shouldFire;
                // change in shouldFire
                if (results.shouldFire) { drainQueue(); }
              } else {
                previousShouldFire = results.shouldFire;
                // new data
                if (results.shouldFire) {
                  o.onNext(results.data);
                } else {
                  q.push(results.data);
                }
              }
            },
            function (err) {
              drainQueue();
              o.onError(err);
            },
            function () {
              drainQueue();
              o.onCompleted();
            }
          );
      return subscription;      
    };

    PausableBufferedObservable.prototype.pause = function () {
      this.controller.onNext(false);
    };

    PausableBufferedObservable.prototype.resume = function () {
      this.controller.onNext(true);
    };

    return PausableBufferedObservable;

  }(Observable));

  /**
   * Pauses the underlying observable sequence based upon the observable sequence which yields true/false,
   * and yields the values that were buffered while paused.
   * @example
   * var pauser = new Rx.Subject();
   * var source = Rx.Observable.interval(100).pausableBuffered(pauser);
   * @param {Observable} pauser The observable sequence used to pause the underlying sequence.
   * @returns {Observable} The observable sequence which is paused based upon the pauser.
   */
  observableProto.pausableBuffered = function (pauser) {
    return new PausableBufferedObservable(this, pauser);
  };

  var ControlledObservable = (function (__super__) {
    inherits(ControlledObservable, __super__);
    function ControlledObservable (source, enableQueue, scheduler) {
      __super__.call(this);
      this.subject = new ControlledSubject(enableQueue, scheduler);
      this.source = source.multicast(this.subject).refCount();
    }

    ControlledObservable.prototype._subscribe = function (o) {
      return this.source.subscribe(o);
    };

    ControlledObservable.prototype.request = function (numberOfItems) {
      return this.subject.request(numberOfItems == null ? -1 : numberOfItems);
    };

    return ControlledObservable;

  }(Observable));

  var ControlledSubject = (function (__super__) {
    inherits(ControlledSubject, __super__);
    function ControlledSubject(enableQueue, scheduler) {
      enableQueue == null && (enableQueue = true);

      __super__.call(this);
      this.subject = new Subject();
      this.enableQueue = enableQueue;
      this.queue = enableQueue ? [] : null;
      this.requestedCount = 0;
      this.requestedDisposable = null;
      this.error = null;
      this.hasFailed = false;
      this.hasCompleted = false;
      this.scheduler = scheduler || currentThreadScheduler;
    }

    addProperties(ControlledSubject.prototype, Observer, {
      _subscribe: function (o) {
        return this.subject.subscribe(o);
      },
      onCompleted: function () {
        this.hasCompleted = true;
        if (!this.enableQueue || this.queue.length === 0) {
          this.subject.onCompleted();
          this.disposeCurrentRequest();
        } else {
          this.queue.push(Notification.createOnCompleted());
        }
      },
      onError: function (error) {
        this.hasFailed = true;
        this.error = error;
        if (!this.enableQueue || this.queue.length === 0) {
          this.subject.onError(error);
          this.disposeCurrentRequest();
        } else {
          this.queue.push(Notification.createOnError(error));
        }
      },
      onNext: function (value) {
        if (this.requestedCount <= 0) {
          this.enableQueue && this.queue.push(Notification.createOnNext(value));
        } else {
          (this.requestedCount-- === 0) && this.disposeCurrentRequest();
          this.subject.onNext(value);
        }
      },
      _processRequest: function (numberOfItems) {
        if (this.enableQueue) {
          while (this.queue.length > 0 && (numberOfItems > 0 || this.queue[0].kind !== 'N')) {
            var first = this.queue.shift();
            first.accept(this.subject);
            if (first.kind === 'N') {
              numberOfItems--;
            } else {
              this.disposeCurrentRequest();
              this.queue = [];
            }
          }
        }

        return numberOfItems;
      },
      request: function (number) {
        this.disposeCurrentRequest();
        var self = this;

        this.requestedDisposable = this.scheduler.schedule(number,
        function(s, i) {
          var remaining = self._processRequest(i);
          var stopped = self.hasCompleted || self.hasFailed;
          if (!stopped && remaining > 0) {
            self.requestedCount = remaining;

            return disposableCreate(function () {
              self.requestedCount = 0;
            });
              // Scheduled item is still in progress. Return a new
              // disposable to allow the request to be interrupted
              // via dispose.
          }
        });

        return this.requestedDisposable;
      },
      disposeCurrentRequest: function () {
        if (this.requestedDisposable) {
          this.requestedDisposable.dispose();
          this.requestedDisposable = null;
        }
      }
    });

    return ControlledSubject;
  }(Observable));

  /**
   * Attaches a controller to the observable sequence with the ability to queue.
   * @example
   * var source = Rx.Observable.interval(100).controlled();
   * source.request(3); // Reads 3 values
   * @param {bool} enableQueue truthy value to determine if values should be queued pending the next request
   * @param {Scheduler} scheduler determines how the requests will be scheduled
   * @returns {Observable} The observable sequence which only propagates values on request.
   */
  observableProto.controlled = function (enableQueue, scheduler) {

    if (enableQueue && isScheduler(enableQueue)) {
      scheduler = enableQueue;
      enableQueue = true;
    }

    if (enableQueue == null) {  enableQueue = true; }
    return new ControlledObservable(this, enableQueue, scheduler);
  };

  /**
   * Pipes the existing Observable sequence into a Node.js Stream.
   * @param {Stream} dest The destination Node.js stream.
   * @returns {Stream} The destination stream.
   */
  observableProto.pipe = function (dest) {
    var source = this.pausableBuffered();

    function onDrain() {
      source.resume();
    }

    dest.addListener('drain', onDrain);

    source.subscribe(
      function (x) {
        !dest.write(String(x)) && source.pause();
      },
      function (err) {
        dest.emit('error', err);
      },
      function () {
        // Hack check because STDIO is not closable
        !dest._isStdio && dest.end();
        dest.removeListener('drain', onDrain);
      });

    source.resume();

    return dest;
  };

  var TransduceObserver = (function (__super__) {
    inherits(TransduceObserver, __super__);
    function TransduceObserver(o, xform) {
      this._o = o;
      this._xform = xform;
      __super__.call(this);
    }

    TransduceObserver.prototype.next = function (x) {
      var res = tryCatch(this._xform['@@transducer/step']).call(this._xform, this._o, x);
      if (res === errorObj) { this._o.onError(res.e); }
    };

    TransduceObserver.prototype.error = function (e) { this._o.onError(e); };

    TransduceObserver.prototype.completed = function () {
      this._xform['@@transducer/result'](this._o);
    };

    return TransduceObserver;
  }(AbstractObserver));

  function transformForObserver(o) {
    return {
      '@@transducer/init': function() {
        return o;
      },
      '@@transducer/step': function(obs, input) {
        return obs.onNext(input);
      },
      '@@transducer/result': function(obs) {
        return obs.onCompleted();
      }
    };
  }

  /**
   * Executes a transducer to transform the observable sequence
   * @param {Transducer} transducer A transducer to execute
   * @returns {Observable} An Observable sequence containing the results from the transducer.
   */
  observableProto.transduce = function(transducer) {
    var source = this;
    return new AnonymousObservable(function(o) {
      var xform = transducer(transformForObserver(o));
      return source.subscribe(new TransduceObserver(o, xform));
    }, source);
  };

  var AnonymousObservable = Rx.AnonymousObservable = (function (__super__) {
    inherits(AnonymousObservable, __super__);

    // Fix subscriber to check for undefined or function returned to decorate as Disposable
    function fixSubscriber(subscriber) {
      return subscriber && isFunction(subscriber.dispose) ? subscriber :
        isFunction(subscriber) ? disposableCreate(subscriber) : disposableEmpty;
    }

    function setDisposable(s, state) {
      var ado = state[0], self = state[1];
      var sub = tryCatch(self.__subscribe).call(self, ado);
      if (sub === errorObj && !ado.fail(errorObj.e)) { thrower(errorObj.e); }
      ado.setDisposable(fixSubscriber(sub));
    }

    function AnonymousObservable(subscribe, parent) {
      this.source = parent;
      this.__subscribe = subscribe;
      __super__.call(this);
    }

    AnonymousObservable.prototype._subscribe = function (o) {
      var ado = new AutoDetachObserver(o), state = [ado, this];

      if (currentThreadScheduler.scheduleRequired()) {
        currentThreadScheduler.schedule(state, setDisposable);
      } else {
        setDisposable(null, state);
      }
      return ado;
    };

    return AnonymousObservable;

  }(Observable));

  var AutoDetachObserver = (function (__super__) {
    inherits(AutoDetachObserver, __super__);

    function AutoDetachObserver(observer) {
      __super__.call(this);
      this.observer = observer;
      this.m = new SingleAssignmentDisposable();
    }

    var AutoDetachObserverPrototype = AutoDetachObserver.prototype;

    AutoDetachObserverPrototype.next = function (value) {
      var result = tryCatch(this.observer.onNext).call(this.observer, value);
      if (result === errorObj) {
        this.dispose();
        thrower(result.e);
      }
    };

    AutoDetachObserverPrototype.error = function (err) {
      var result = tryCatch(this.observer.onError).call(this.observer, err);
      this.dispose();
      result === errorObj && thrower(result.e);
    };

    AutoDetachObserverPrototype.completed = function () {
      var result = tryCatch(this.observer.onCompleted).call(this.observer);
      this.dispose();
      result === errorObj && thrower(result.e);
    };

    AutoDetachObserverPrototype.setDisposable = function (value) { this.m.setDisposable(value); };
    AutoDetachObserverPrototype.getDisposable = function () { return this.m.getDisposable(); };

    AutoDetachObserverPrototype.dispose = function () {
      __super__.prototype.dispose.call(this);
      this.m.dispose();
    };

    return AutoDetachObserver;
  }(AbstractObserver));

  var InnerSubscription = function (s, o) {
    this._s = s;
    this._o = o;
  };

  InnerSubscription.prototype.dispose = function () {
    if (!this._s.isDisposed && this._o !== null) {
      var idx = this._s.observers.indexOf(this._o);
      this._s.observers.splice(idx, 1);
      this._o = null;
    }
  };

  /**
   *  Represents an object that is both an observable sequence as well as an observer.
   *  Each notification is broadcasted to all subscribed observers.
   */
  var Subject = Rx.Subject = (function (__super__) {
    inherits(Subject, __super__);
    function Subject() {
      __super__.call(this);
      this.isDisposed = false;
      this.isStopped = false;
      this.observers = [];
      this.hasError = false;
    }

    addProperties(Subject.prototype, Observer.prototype, {
      _subscribe: function (o) {
        checkDisposed(this);
        if (!this.isStopped) {
          this.observers.push(o);
          return new InnerSubscription(this, o);
        }
        if (this.hasError) {
          o.onError(this.error);
          return disposableEmpty;
        }
        o.onCompleted();
        return disposableEmpty;
      },
      /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */
      hasObservers: function () { checkDisposed(this); return this.observers.length > 0; },
      /**
       * Notifies all subscribed observers about the end of the sequence.
       */
      onCompleted: function () {
        checkDisposed(this);
        if (!this.isStopped) {
          this.isStopped = true;
          for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
            os[i].onCompleted();
          }

          this.observers.length = 0;
        }
      },
      /**
       * Notifies all subscribed observers about the exception.
       * @param {Mixed} error The exception to send to all observers.
       */
      onError: function (error) {
        checkDisposed(this);
        if (!this.isStopped) {
          this.isStopped = true;
          this.error = error;
          this.hasError = true;
          for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
            os[i].onError(error);
          }

          this.observers.length = 0;
        }
      },
      /**
       * Notifies all subscribed observers about the arrival of the specified element in the sequence.
       * @param {Mixed} value The value to send to all observers.
       */
      onNext: function (value) {
        checkDisposed(this);
        if (!this.isStopped) {
          for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
            os[i].onNext(value);
          }
        }
      },
      /**
       * Unsubscribe all observers and release resources.
       */
      dispose: function () {
        this.isDisposed = true;
        this.observers = null;
      }
    });

    /**
     * Creates a subject from the specified observer and observable.
     * @param {Observer} observer The observer used to send messages to the subject.
     * @param {Observable} observable The observable used to subscribe to messages sent from the subject.
     * @returns {Subject} Subject implemented using the given observer and observable.
     */
    Subject.create = function (observer, observable) {
      return new AnonymousSubject(observer, observable);
    };

    return Subject;
  }(Observable));

  /**
   *  Represents the result of an asynchronous operation.
   *  The last value before the OnCompleted notification, or the error received through OnError, is sent to all subscribed observers.
   */
  var AsyncSubject = Rx.AsyncSubject = (function (__super__) {
    inherits(AsyncSubject, __super__);

    /**
     * Creates a subject that can only receive one value and that value is cached for all future observations.
     * @constructor
     */
    function AsyncSubject() {
      __super__.call(this);
      this.isDisposed = false;
      this.isStopped = false;
      this.hasValue = false;
      this.observers = [];
      this.hasError = false;
    }

    addProperties(AsyncSubject.prototype, Observer.prototype, {
      _subscribe: function (o) {
        checkDisposed(this);

        if (!this.isStopped) {
          this.observers.push(o);
          return new InnerSubscription(this, o);
        }

        if (this.hasError) {
          o.onError(this.error);
        } else if (this.hasValue) {
          o.onNext(this.value);
          o.onCompleted();
        } else {
          o.onCompleted();
        }

        return disposableEmpty;
      },
      /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */
      hasObservers: function () { checkDisposed(this); return this.observers.length > 0; },
      /**
       * Notifies all subscribed observers about the end of the sequence, also causing the last received value to be sent out (if any).
       */
      onCompleted: function () {
        var i, len;
        checkDisposed(this);
        if (!this.isStopped) {
          this.isStopped = true;
          var os = cloneArray(this.observers), len = os.length;

          if (this.hasValue) {
            for (i = 0; i < len; i++) {
              var o = os[i];
              o.onNext(this.value);
              o.onCompleted();
            }
          } else {
            for (i = 0; i < len; i++) {
              os[i].onCompleted();
            }
          }

          this.observers.length = 0;
        }
      },
      /**
       * Notifies all subscribed observers about the error.
       * @param {Mixed} error The Error to send to all observers.
       */
      onError: function (error) {
        checkDisposed(this);
        if (!this.isStopped) {
          this.isStopped = true;
          this.hasError = true;
          this.error = error;

          for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
            os[i].onError(error);
          }

          this.observers.length = 0;
        }
      },
      /**
       * Sends a value to the subject. The last value received before successful termination will be sent to all subscribed and future observers.
       * @param {Mixed} value The value to store in the subject.
       */
      onNext: function (value) {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.value = value;
        this.hasValue = true;
      },
      /**
       * Unsubscribe all observers and release resources.
       */
      dispose: function () {
        this.isDisposed = true;
        this.observers = null;
        this.error = null;
        this.value = null;
      }
    });

    return AsyncSubject;
  }(Observable));

  var AnonymousSubject = Rx.AnonymousSubject = (function (__super__) {
    inherits(AnonymousSubject, __super__);
    function AnonymousSubject(observer, observable) {
      this.observer = observer;
      this.observable = observable;
      __super__.call(this);
    }

    addProperties(AnonymousSubject.prototype, Observer.prototype, {
      _subscribe: function (o) {
        return this.observable.subscribe(o);
      },
      onCompleted: function () {
        this.observer.onCompleted();
      },
      onError: function (error) {
        this.observer.onError(error);
      },
      onNext: function (value) {
        this.observer.onNext(value);
      }
    });

    return AnonymousSubject;
  }(Observable));

  /**
   *  Represents a value that changes over time.
   *  Observers can subscribe to the subject to receive the last (or initial) value and all subsequent notifications.
   */
  var BehaviorSubject = Rx.BehaviorSubject = (function (__super__) {
    inherits(BehaviorSubject, __super__);
    function BehaviorSubject(value) {
      __super__.call(this);
      this.value = value;
      this.observers = [];
      this.isDisposed = false;
      this.isStopped = false;
      this.hasError = false;
    }

    addProperties(BehaviorSubject.prototype, Observer.prototype, {
      _subscribe: function (o) {
        checkDisposed(this);
        if (!this.isStopped) {
          this.observers.push(o);
          o.onNext(this.value);
          return new InnerSubscription(this, o);
        }
        if (this.hasError) {
          o.onError(this.error);
        } else {
          o.onCompleted();
        }
        return disposableEmpty;
      },
      /**
       * Gets the current value or throws an exception.
       * Value is frozen after onCompleted is called.
       * After onError is called always throws the specified exception.
       * An exception is always thrown after dispose is called.
       * @returns {Mixed} The initial value passed to the constructor until onNext is called; after which, the last value passed to onNext.
       */
      getValue: function () {
        checkDisposed(this);
        if (this.hasError) { thrower(this.error); }
        return this.value;
      },
      /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */
      hasObservers: function () { checkDisposed(this); return this.observers.length > 0; },
      /**
       * Notifies all subscribed observers about the end of the sequence.
       */
      onCompleted: function () {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.isStopped = true;
        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          os[i].onCompleted();
        }

        this.observers.length = 0;
      },
      /**
       * Notifies all subscribed observers about the exception.
       * @param {Mixed} error The exception to send to all observers.
       */
      onError: function (error) {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.isStopped = true;
        this.hasError = true;
        this.error = error;

        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          os[i].onError(error);
        }

        this.observers.length = 0;
      },
      /**
       * Notifies all subscribed observers about the arrival of the specified element in the sequence.
       * @param {Mixed} value The value to send to all observers.
       */
      onNext: function (value) {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.value = value;
        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          os[i].onNext(value);
        }
      },
      /**
       * Unsubscribe all observers and release resources.
       */
      dispose: function () {
        this.isDisposed = true;
        this.observers = null;
        this.value = null;
        this.error = null;
      }
    });

    return BehaviorSubject;
  }(Observable));

  /**
   * Represents an object that is both an observable sequence as well as an observer.
   * Each notification is broadcasted to all subscribed and future observers, subject to buffer trimming policies.
   */
  var ReplaySubject = Rx.ReplaySubject = (function (__super__) {

    var maxSafeInteger = Math.pow(2, 53) - 1;

    function createRemovableDisposable(subject, observer) {
      return disposableCreate(function () {
        observer.dispose();
        !subject.isDisposed && subject.observers.splice(subject.observers.indexOf(observer), 1);
      });
    }

    inherits(ReplaySubject, __super__);

    /**
     *  Initializes a new instance of the ReplaySubject class with the specified buffer size, window size and scheduler.
     *  @param {Number} [bufferSize] Maximum element count of the replay buffer.
     *  @param {Number} [windowSize] Maximum time length of the replay buffer.
     *  @param {Scheduler} [scheduler] Scheduler the observers are invoked on.
     */
    function ReplaySubject(bufferSize, windowSize, scheduler) {
      this.bufferSize = bufferSize == null ? maxSafeInteger : bufferSize;
      this.windowSize = windowSize == null ? maxSafeInteger : windowSize;
      this.scheduler = scheduler || currentThreadScheduler;
      this.q = [];
      this.observers = [];
      this.isStopped = false;
      this.isDisposed = false;
      this.hasError = false;
      this.error = null;
      __super__.call(this);
    }

    addProperties(ReplaySubject.prototype, Observer.prototype, {
      _subscribe: function (o) {
        checkDisposed(this);
        var so = new ScheduledObserver(this.scheduler, o), subscription = createRemovableDisposable(this, so);

        this._trim(this.scheduler.now());
        this.observers.push(so);

        for (var i = 0, len = this.q.length; i < len; i++) {
          so.onNext(this.q[i].value);
        }

        if (this.hasError) {
          so.onError(this.error);
        } else if (this.isStopped) {
          so.onCompleted();
        }

        so.ensureActive();
        return subscription;
      },
      /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */
      hasObservers: function () { checkDisposed(this); return this.observers.length > 0; },
      _trim: function (now) {
        while (this.q.length > this.bufferSize) {
          this.q.shift();
        }
        while (this.q.length > 0 && (now - this.q[0].interval) > this.windowSize) {
          this.q.shift();
        }
      },
      /**
       * Notifies all subscribed observers about the arrival of the specified element in the sequence.
       * @param {Mixed} value The value to send to all observers.
       */
      onNext: function (value) {
        checkDisposed(this);
        if (this.isStopped) { return; }
        var now = this.scheduler.now();
        this.q.push({ interval: now, value: value });
        this._trim(now);

        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          var observer = os[i];
          observer.onNext(value);
          observer.ensureActive();
        }
      },
      /**
       * Notifies all subscribed observers about the exception.
       * @param {Mixed} error The exception to send to all observers.
       */
      onError: function (error) {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.isStopped = true;
        this.error = error;
        this.hasError = true;
        var now = this.scheduler.now();
        this._trim(now);
        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          var observer = os[i];
          observer.onError(error);
          observer.ensureActive();
        }
        this.observers.length = 0;
      },
      /**
       * Notifies all subscribed observers about the end of the sequence.
       */
      onCompleted: function () {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.isStopped = true;
        var now = this.scheduler.now();
        this._trim(now);
        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          var observer = os[i];
          observer.onCompleted();
          observer.ensureActive();
        }
        this.observers.length = 0;
      },
      /**
       * Unsubscribe all observers and release resources.
       */
      dispose: function () {
        this.isDisposed = true;
        this.observers = null;
      }
    });

    return ReplaySubject;
  }(Observable));

  /**
  * Used to pause and resume streams.
  */
  Rx.Pauser = (function (__super__) {
    inherits(Pauser, __super__);
    function Pauser() {
      __super__.call(this);
    }

    /**
     * Pauses the underlying sequence.
     */
    Pauser.prototype.pause = function () { this.onNext(false); };

    /**
    * Resumes the underlying sequence.
    */
    Pauser.prototype.resume = function () { this.onNext(true); };

    return Pauser;
  }(Subject));

  if (true) {
    root.Rx = Rx;

    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return Rx;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (freeExports && freeModule) {
    // in Node.js or RingoJS
    if (moduleExports) {
      (freeModule.exports = Rx).Rx = Rx;
    } else {
      freeExports.Rx = Rx;
    }
  } else {
    // in a browser or Rhino
    root.Rx = Rx;
  }

  // All code before this point will be filtered from stack traces.
  var rEndingLine = captureLine();

}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(134)(module), __webpack_require__(133), __webpack_require__(131)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(31);


/***/ })
/******/ ]);
});
//# sourceMappingURL=binary-live-api.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isEuCountry */
/* unused harmony export isUKCountry */
/* unused harmony export moveToDeriv */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClientsCountryByIP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es7_symbol_async_iterator_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es7_symbol_async_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es7_symbol_async_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_name_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_appId__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_utils_storageManager__ = __webpack_require__(39);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


















var euCountries = ['it', 'de', 'fr', 'lu', 'gr', 'es', 'sk', 'lt', 'nl', 'at', 'bg', 'si', 'cy', 'be', 'ro', 'hr', 'pt', 'pl', 'lv', 'ee', 'cz', 'fi', 'hu', 'dk', 'se', 'ie', 'gb', 'mt'];
var isEuCountry = function isEuCountry(country) {
  return euCountries.includes(country);
};
var isUKCountry = function isUKCountry(country) {
  return country === 'gb';
};
/* eslint-disable camelcase */

var moveToDeriv = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var clients_country, tokenList, landingCompanyName;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getClientsCountryByIP();

          case 2:
            clients_country = _context.sent;
            tokenList = Object(__WEBPACK_IMPORTED_MODULE_16__common_utils_storageManager__["d" /* getTokenList */])();
            landingCompanyName = tokenList.map(function (token) {
              return token.loginInfo.landing_company_name;
            });

            if (!tokenList.length) {
              if (isEuCountry(clients_country) || isUKCountry(clients_country)) {
                window.location.replace('https://binary.com/move-to-deriv');
              }
            }

            if (landingCompanyName.length === 1 && landingCompanyName.includes('virtual') && (isEuCountry(clients_country) || isUKCountry(clients_country) || isEuCountry(localStorage.getItem('residence')) || isUKCountry(localStorage.getItem('residence'))) || landingCompanyName.includes('maltainvest') || landingCompanyName.includes('malta') || landingCompanyName.includes('iom')) {
              window.location.replace('https://binary.com/move-to-deriv');
            }

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function moveToDeriv() {
    return _ref.apply(this, arguments);
  };
}();
var getClientsCountryByIP = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var api, _yield$api$send, website_status;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            api = Object(__WEBPACK_IMPORTED_MODULE_15__common_appId__["c" /* generateLiveApiInstance */])();
            _context2.next = 3;
            return api.send({
              website_status: 1
            });

          case 3:
            _yield$api$send = _context2.sent;
            website_status = _yield$api$send.website_status;
            return _context2.abrupt("return", website_status.clients_country);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getClientsCountryByIP() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hero_jsx__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SwitchSection_jsx__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Carousel_jsx__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WaitSection_jsx__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChooseSection_jsx__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Footer_jsx__ = __webpack_require__(298);






 // eslint-disable-next-line arrow-body-style

var BotLanding = function BotLanding() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Hero_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SwitchSection_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Carousel_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ChooseSection_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__WaitSection_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Footer_jsx__["a" /* default */], null));
};

/* harmony default export */ __webpack_exports__["a"] = (BotLanding);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appId__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storageManager__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_i18n__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gtm__ = __webpack_require__(84);

 // import { getLanguage } from '../common/lang';






var Elevio = function () {
  var elShellId = 'elevio-shell';
  var elShell;
  var elBtnLabel;
  var accountId = '5bbc2de0b7365';
  var elevioScript = "https://cdn.elev.io/sdk/bootloader/v4/elevio-bootloader.js?cid=".concat(accountId);

  var init = function init() {
    elShell = document.getElementById(elShellId);
    elBtnLabel = elShell.querySelector('span.text');
    elBtnLabel.innerText = Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('NEED HELP?');
    elShell.classList.remove('invisible');
    elShell.addEventListener('click', function () {
      return injectElevio(true);
    });
  };

  var injectElevio = function injectElevio() {
    var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    window._elev = {}; // eslint-disable-line no-underscore-dangle

    window._elev.account_id = accountId; // eslint-disable-line no-underscore-dangle

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = 1;
    script.src = elevioScript;
    script.id = 'loaded-elevio-script';
    document.body.appendChild(script);
    window._elev.q = []; // eslint-disable-line no-underscore-dangle

    window._elev.on = function (z, y) {
      // eslint-disable-line no-underscore-dangle
      window._elev.q.push([z, y]); // eslint-disable-line no-underscore-dangle

    };

    script.onload = function () {
      return loadElevio(isOpen);
    };
  };

  var loadElevio = function loadElevio() {
    var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!window._elev) return; // eslint-disable-line no-underscore-dangle
    // eslint-disable-next-line no-underscore-dangle

    window._elev.on('widget:opened', function () {
      if (localStorage.getItem('seenWhatsBinaryBot')) {
        window._elev.open(); // eslint-disable-line no-underscore-dangle

      } else {
        localStorage.setItem('seenWhatsBinaryBot', true);

        window._elev.openArticle(90); // eslint-disable-line no-underscore-dangle

      }
    }); // eslint-disable-next-line no-underscore-dangle


    window._elev.on('load', function (elev) {
      __WEBPACK_IMPORTED_MODULE_5__gtm__["a" /* default */].pushDataLayer({
        event: 'elevio_widget_load'
      });
      var availableLanguages = ['en', 'es', 'id', 'pt', 'ru'];
      var currentLanguage = Object(__WEBPACK_IMPORTED_MODULE_4__lang__["a" /* getLanguage */])();

      if (availableLanguages.includes(currentLanguage)) {
        elev.setLanguage(currentLanguage);
      } else {
        elev.setLanguage('en');
      }

      elev.setSettings({
        disablePushState: true,
        page_url: "".concat(document.location.protocol, "//").concat(document.location.hostname).concat(document.location.pathname)
      });
      setUserInfo(elev);
      setTranslations(elev);
      addEventListenerGTM();

      if (isOpen) {
        elev.open();
      }
    });
  };

  var addEventListenerGTM = function addEventListenerGTM() {
    window._elev.on('widget:opened', function () {
      // eslint-disable-line no-underscore-dangle
      __WEBPACK_IMPORTED_MODULE_5__gtm__["a" /* default */].pushDataLayer({
        event: 'elevio_widget_opened',
        is_elevio: true
      });
    });

    window._elev.on('page:view', function () {
      // eslint-disable-line no-underscore-dangle
      __WEBPACK_IMPORTED_MODULE_5__gtm__["a" /* default */].pushDataLayer({
        event: 'elevio_page_views',
        is_elevio: true
      });
    });
  };

  var setUserInfo = function setUserInfo(elev) {
    var tokenList = Object(__WEBPACK_IMPORTED_MODULE_2__utils_storageManager__["d" /* getTokenList */])();

    if (tokenList.length) {
      var api = Object(__WEBPACK_IMPORTED_MODULE_1__appId__["c" /* generateLiveApiInstance */])(); // Refactor when reducing WS connections

      var activeToken = tokenList[0];
      api.authorize(activeToken.token).then(function () {
        api.send({
          get_settings: 1
        }).then(function (response) {
          var isVirtual = activeToken.loginInfo.is_virtual;
          var userObject = {
            email: response.get_settings.email,
            first_name: isVirtual ? 'Virtual' : response.get_settings.first_name,
            last_name: isVirtual ? activeToken.loginInfo.loginid : response.get_settings.first_name,
            user_hash: response.get_settings.user_hash
          };
          elev.setUser(userObject);
          api.disconnect();
        });
      });
    }
  }; // Elevio has a window._elev.logoutUser() fn, but it doesn't work


  var logoutUser = function logoutUser() {
    sessionStorage.removeItem('_elevaddon-6app');
    sessionStorage.removeItem('_elevaddon-6create');
  };

  var setTranslations = function setTranslations(elev) {
    elev.setTranslations({
      modules: {
        support: {
          thankyou: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Thank you, we\'ll get back to you within 24 hours')
        }
      }
    });
  };

  return {
    init: init,
    logoutUser: logoutUser
  };
}();

/* unused harmony default export */ var _unused_webpack_default_export = (Elevio);

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(89)('native-function-to-string', Function.toString);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var isArray = __webpack_require__(124);
var SPECIES = __webpack_require__(13)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(59);
var gOPS = __webpack_require__(103);
var pIE = __webpack_require__(83);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(165),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(3),n=__webpack_require__(165),r=__webpack_require__(228);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(229);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 230 */,
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CookieStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setCookieLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_keys_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_filter_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es7_object_get_own_property_descriptors_js__);






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Cookies = __webpack_require__(232);

var CookieStorage = function CookieStorage(cookieName, cookieDomain) {
  this.initialized = false;
  this.cookieName = cookieName;
  this.domain = cookieDomain;
  this.path = '/';
  this.expires = new Date('Thu, 1 Jan 2037 12:00:00 GMT');
  this.value = {};
};
CookieStorage.prototype = {
  read: function read() {
    var cookieValue = Cookies.get(this.cookieName);

    try {
      this.value = cookieValue ? JSON.parse(cookieValue) : {};
    } catch (e) {
      this.value = {};
    }

    this.initialized = true;
  },
  write: function write(val, expireDate, isSecure, sameSite) {
    if (!this.initialized) this.read();
    this.value = val;
    if (expireDate) this.expires = expireDate;
    Cookies.set(this.cookieName, this.value, {
      expires: this.expires,
      path: this.path,
      domain: this.domain,
      secure: !!isSecure,
      sameSite: sameSite || 'strict'
    });
  },
  get: function get(key) {
    if (!this.initialized) this.read();
    return this.value[key];
  },
  set: function set(key, val, options) {
    if (!this.initialized) this.read();
    this.value[key] = val;
    Cookies.set(this.cookieName, this.value, _objectSpread({
      expires: new Date(this.expires),
      path: this.path,
      domain: this.domain
    }, options));
  },
  remove: function remove() {
    Cookies.remove(this.cookieName, {
      path: this.path,
      domain: this.domain
    });
  }
};
var setCookieLanguage = function setCookieLanguage(lang) {
  if (!Cookies.get('language') || lang) {
    var cookie = new CookieStorage('language');
    cookie.write(lang.toUpperCase(), undefined, true, 'none');
  }
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {(function() {
  var crypt = __webpack_require__(236),
      utf8 = __webpack_require__(168).utf8,
      bin = __webpack_require__(168).bin,

  // The core
  sha1 = function (message) {
    // Convert to byte array
    if (message.constructor == String)
      message = utf8.stringToBytes(message);
    else if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer == 'function' && Buffer.isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();

    // otherwise assume byte array

    var m  = crypt.bytesToWords(message),
        l  = message.length * 8,
        w  = [],
        H0 =  1732584193,
        H1 = -271733879,
        H2 = -1732584194,
        H3 =  271733878,
        H4 = -1009589776;

    // Padding
    m[l >> 5] |= 0x80 << (24 - l % 32);
    m[((l + 64 >>> 9) << 4) + 15] = l;

    for (var i = 0; i < m.length; i += 16) {
      var a = H0,
          b = H1,
          c = H2,
          d = H3,
          e = H4;

      for (var j = 0; j < 80; j++) {

        if (j < 16)
          w[j] = m[i + j];
        else {
          var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
          w[j] = (n << 1) | (n >>> 31);
        }

        var t = ((H0 << 5) | (H0 >>> 27)) + H4 + (w[j] >>> 0) + (
                j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249 :
                j < 40 ? (H1 ^ H2 ^ H3) + 1859775393 :
                j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588 :
                         (H1 ^ H2 ^ H3) - 899497514);

        H4 = H3;
        H3 = H2;
        H2 = (H1 << 30) | (H1 >>> 2);
        H1 = H0;
        H0 = t;
      }

      H0 += a;
      H1 += b;
      H2 += c;
      H3 += d;
      H4 += e;
    }

    return [H0, H1, H2, H3, H4];
  },

  // Public API
  api = function (message, options) {
    var digestbytes = crypt.wordsToBytes(sha1(message));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

  api._blocksize = 16;
  api._digestsize = 20;

  module.exports = api;
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96).Buffer))

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 235 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 236 */
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var htmlParser = __webpack_require__(238);
var React = __webpack_require__(3);
var convertAttr = __webpack_require__(265);
var styleParser = __webpack_require__(266);

function renderNode(node, key) {
  if (node.nodeName === '#text') {
    return node.value;
  }

  if (node.nodeName === '#comment') {
    return node.value;
  }

  var attr = node.attrs.reduce(function (result, attr) {
    var name = convertAttr(attr.name);
    result[name] = name === 'style' ? styleParser(attr.value) : attr.value;
    return result;
  }, {key: key});

  if (node.childNodes.length === 0) {
    return React.createElement(node.tagName, attr);
  }

  if (node.nodeName === 'script') {
    attr.dangerouslySetInnerHTML = {__html: node.childNodes[0].value};
    return React.createElement('script', attr);
  }

  var children = node.childNodes.map(renderNode);
  return React.createElement(node.tagName, attr, children);
}

function renderHTML(html) {
  var htmlAST = htmlParser.parseFragment(html);

  if (htmlAST.childNodes.length === 0) {
    return null;
  }

  var result = htmlAST.childNodes.map(renderNode);

  return result.length === 1 ? result[0] : result;
}

module.exports = renderHTML;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Parser = __webpack_require__(169),
    Serializer = __webpack_require__(173);


// Shorthands
exports.parse = function parse(html, options) {
    var parser = new Parser(options);

    return parser.parse(html);
};

exports.parseFragment = function parseFragment(fragmentContext, html, options) {
    if (typeof fragmentContext === 'string') {
        options = html;
        html = fragmentContext;
        fragmentContext = null;
    }

    var parser = new Parser(options);

    return parser.parseFragment(html, fragmentContext);
};

exports.serialize = function (node, options) {
    var serializer = new Serializer(node, options);

    return serializer.serialize();
};


// Tree adapters
exports.treeAdapters = {
    default: __webpack_require__(130),
    htmlparser2: __webpack_require__(247)
};


// Streaming
exports.ParserStream = __webpack_require__(174);
exports.PlainTextConversionStream = __webpack_require__(260);
exports.SerializerStream = __webpack_require__(261);
exports.SAXParser = __webpack_require__(262);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UNICODE = __webpack_require__(86);

//Aliases
var $ = UNICODE.CODE_POINTS;

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isSurrogatePair(cp1, cp2) {
    return cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF;
}

function getSurrogatePairCodePoint(cp1, cp2) {
    return (cp1 - 0xD800) * 0x400 + 0x2400 + cp2;
}


//Const
var DEFAULT_BUFFER_WATERLINE = 1 << 16;


//Preprocessor
//NOTE: HTML input preprocessing
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
var Preprocessor = module.exports = function () {
    this.html = null;

    this.pos = -1;
    this.lastGapPos = -1;
    this.lastCharPos = -1;

    this.gapStack = [];

    this.skipNextNewLine = false;

    this.lastChunkWritten = false;
    this.endOfChunkHit = false;
    this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
};

Preprocessor.prototype.dropParsedChunk = function () {
    if (this.pos > this.bufferWaterline) {
        this.lastCharPos -= this.pos;
        this.html = this.html.substring(this.pos);
        this.pos = 0;
        this.lastGapPos = -1;
        this.gapStack = [];
    }
};

Preprocessor.prototype._addGap = function () {
    this.gapStack.push(this.lastGapPos);
    this.lastGapPos = this.pos;
};

Preprocessor.prototype._processHighRangeCodePoint = function (cp) {
    //NOTE: try to peek a surrogate pair
    if (this.pos !== this.lastCharPos) {
        var nextCp = this.html.charCodeAt(this.pos + 1);

        if (isSurrogatePair(cp, nextCp)) {
            //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
            this.pos++;
            cp = getSurrogatePairCodePoint(cp, nextCp);

            //NOTE: add gap that should be avoided during retreat
            this._addGap();
        }
    }

    // NOTE: we've hit the end of chunk, stop processing at this point
    else if (!this.lastChunkWritten) {
        this.endOfChunkHit = true;
        return $.EOF;
    }

    return cp;
};

Preprocessor.prototype.write = function (chunk, isLastChunk) {
    if (this.html)
        this.html += chunk;

    else
        this.html = chunk;

    this.lastCharPos = this.html.length - 1;
    this.endOfChunkHit = false;
    this.lastChunkWritten = isLastChunk;
};

Preprocessor.prototype.insertHtmlAtCurrentPos = function (chunk) {
    this.html = this.html.substring(0, this.pos + 1) +
                chunk +
                this.html.substring(this.pos + 1, this.html.length);

    this.lastCharPos = this.html.length - 1;
    this.endOfChunkHit = false;
};


Preprocessor.prototype.advance = function () {
    this.pos++;

    if (this.pos > this.lastCharPos) {
        if (!this.lastChunkWritten)
            this.endOfChunkHit = true;

        return $.EOF;
    }

    var cp = this.html.charCodeAt(this.pos);

    //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
    //must be ignored.
    if (this.skipNextNewLine && cp === $.LINE_FEED) {
        this.skipNextNewLine = false;
        this._addGap();
        return this.advance();
    }

    //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
    if (cp === $.CARRIAGE_RETURN) {
        this.skipNextNewLine = true;
        return $.LINE_FEED;
    }

    this.skipNextNewLine = false;

    //OPTIMIZATION: first perform check if the code point in the allowed range that covers most common
    //HTML input (e.g. ASCII codes) to avoid performance-cost operations for high-range code points.
    return cp >= 0xD800 ? this._processHighRangeCodePoint(cp) : cp;
};

Preprocessor.prototype.retreat = function () {
    if (this.pos === this.lastGapPos) {
        this.lastGapPos = this.gapStack.pop();
        this.pos--;
    }

    this.pos--;
};



/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//NOTE: this file contains auto-generated array mapped radix tree that is used for the named entity references consumption
//(details: https://github.com/inikulin/parse5/tree/master/scripts/generate_named_entity_data/README.md)
module.exports = new Uint16Array([4,52,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,106,303,412,810,1432,1701,1796,1987,2114,2360,2420,2484,3170,3251,4140,4393,4575,4610,5106,5512,5728,6117,6274,6315,6345,6427,6516,7002,7910,8733,9323,9870,10170,10631,10893,11318,11386,11467,12773,13092,14474,14922,15448,15542,16419,17666,18166,18611,19004,19095,19298,19397,4,16,69,77,97,98,99,102,103,108,109,110,111,112,114,115,116,117,140,150,158,169,176,194,199,210,216,222,226,242,256,266,283,294,108,105,103,5,198,1,59,148,1,198,80,5,38,1,59,156,1,38,99,117,116,101,5,193,1,59,167,1,193,114,101,118,101,59,1,258,4,2,105,121,182,191,114,99,5,194,1,59,189,1,194,59,1,1040,114,59,3,55349,56580,114,97,118,101,5,192,1,59,208,1,192,112,104,97,59,1,913,97,99,114,59,1,256,100,59,1,10835,4,2,103,112,232,237,111,110,59,1,260,102,59,3,55349,56632,112,108,121,70,117,110,99,116,105,111,110,59,1,8289,105,110,103,5,197,1,59,264,1,197,4,2,99,115,272,277,114,59,3,55349,56476,105,103,110,59,1,8788,105,108,100,101,5,195,1,59,292,1,195,109,108,5,196,1,59,301,1,196,4,8,97,99,101,102,111,114,115,117,321,350,354,383,388,394,400,405,4,2,99,114,327,336,107,115,108,97,115,104,59,1,8726,4,2,118,119,342,345,59,1,10983,101,100,59,1,8966,121,59,1,1041,4,3,99,114,116,362,369,379,97,117,115,101,59,1,8757,110,111,117,108,108,105,115,59,1,8492,97,59,1,914,114,59,3,55349,56581,112,102,59,3,55349,56633,101,118,101,59,1,728,99,114,59,1,8492,109,112,101,113,59,1,8782,4,14,72,79,97,99,100,101,102,104,105,108,111,114,115,117,442,447,456,504,542,547,569,573,577,616,678,784,790,796,99,121,59,1,1063,80,89,5,169,1,59,454,1,169,4,3,99,112,121,464,470,497,117,116,101,59,1,262,4,2,59,105,476,478,1,8914,116,97,108,68,105,102,102,101,114,101,110,116,105,97,108,68,59,1,8517,108,101,121,115,59,1,8493,4,4,97,101,105,111,514,520,530,535,114,111,110,59,1,268,100,105,108,5,199,1,59,528,1,199,114,99,59,1,264,110,105,110,116,59,1,8752,111,116,59,1,266,4,2,100,110,553,560,105,108,108,97,59,1,184,116,101,114,68,111,116,59,1,183,114,59,1,8493,105,59,1,935,114,99,108,101,4,4,68,77,80,84,591,596,603,609,111,116,59,1,8857,105,110,117,115,59,1,8854,108,117,115,59,1,8853,105,109,101,115,59,1,8855,111,4,2,99,115,623,646,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8754,101,67,117,114,108,121,4,2,68,81,658,671,111,117,98,108,101,81,117,111,116,101,59,1,8221,117,111,116,101,59,1,8217,4,4,108,110,112,117,688,701,736,753,111,110,4,2,59,101,696,698,1,8759,59,1,10868,4,3,103,105,116,709,717,722,114,117,101,110,116,59,1,8801,110,116,59,1,8751,111,117,114,73,110,116,101,103,114,97,108,59,1,8750,4,2,102,114,742,745,59,1,8450,111,100,117,99,116,59,1,8720,110,116,101,114,67,108,111,99,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8755,111,115,115,59,1,10799,99,114,59,3,55349,56478,112,4,2,59,67,803,805,1,8915,97,112,59,1,8781,4,11,68,74,83,90,97,99,101,102,105,111,115,834,850,855,860,865,888,903,916,921,1011,1415,4,2,59,111,840,842,1,8517,116,114,97,104,100,59,1,10513,99,121,59,1,1026,99,121,59,1,1029,99,121,59,1,1039,4,3,103,114,115,873,879,883,103,101,114,59,1,8225,114,59,1,8609,104,118,59,1,10980,4,2,97,121,894,900,114,111,110,59,1,270,59,1,1044,108,4,2,59,116,910,912,1,8711,97,59,1,916,114,59,3,55349,56583,4,2,97,102,927,998,4,2,99,109,933,992,114,105,116,105,99,97,108,4,4,65,68,71,84,950,957,978,985,99,117,116,101,59,1,180,111,4,2,116,117,964,967,59,1,729,98,108,101,65,99,117,116,101,59,1,733,114,97,118,101,59,1,96,105,108,100,101,59,1,732,111,110,100,59,1,8900,102,101,114,101,110,116,105,97,108,68,59,1,8518,4,4,112,116,117,119,1021,1026,1048,1249,102,59,3,55349,56635,4,3,59,68,69,1034,1036,1041,1,168,111,116,59,1,8412,113,117,97,108,59,1,8784,98,108,101,4,6,67,68,76,82,85,86,1065,1082,1101,1189,1211,1236,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8751,111,4,2,116,119,1089,1092,59,1,168,110,65,114,114,111,119,59,1,8659,4,2,101,111,1107,1141,102,116,4,3,65,82,84,1117,1124,1136,114,114,111,119,59,1,8656,105,103,104,116,65,114,114,111,119,59,1,8660,101,101,59,1,10980,110,103,4,2,76,82,1149,1177,101,102,116,4,2,65,82,1158,1165,114,114,111,119,59,1,10232,105,103,104,116,65,114,114,111,119,59,1,10234,105,103,104,116,65,114,114,111,119,59,1,10233,105,103,104,116,4,2,65,84,1199,1206,114,114,111,119,59,1,8658,101,101,59,1,8872,112,4,2,65,68,1218,1225,114,114,111,119,59,1,8657,111,119,110,65,114,114,111,119,59,1,8661,101,114,116,105,99,97,108,66,97,114,59,1,8741,110,4,6,65,66,76,82,84,97,1264,1292,1299,1352,1391,1408,114,114,111,119,4,3,59,66,85,1276,1278,1283,1,8595,97,114,59,1,10515,112,65,114,114,111,119,59,1,8693,114,101,118,101,59,1,785,101,102,116,4,3,82,84,86,1310,1323,1334,105,103,104,116,86,101,99,116,111,114,59,1,10576,101,101,86,101,99,116,111,114,59,1,10590,101,99,116,111,114,4,2,59,66,1345,1347,1,8637,97,114,59,1,10582,105,103,104,116,4,2,84,86,1362,1373,101,101,86,101,99,116,111,114,59,1,10591,101,99,116,111,114,4,2,59,66,1384,1386,1,8641,97,114,59,1,10583,101,101,4,2,59,65,1399,1401,1,8868,114,114,111,119,59,1,8615,114,114,111,119,59,1,8659,4,2,99,116,1421,1426,114,59,3,55349,56479,114,111,107,59,1,272,4,16,78,84,97,99,100,102,103,108,109,111,112,113,115,116,117,120,1466,1470,1478,1489,1515,1520,1525,1536,1544,1593,1609,1617,1650,1664,1668,1677,71,59,1,330,72,5,208,1,59,1476,1,208,99,117,116,101,5,201,1,59,1487,1,201,4,3,97,105,121,1497,1503,1512,114,111,110,59,1,282,114,99,5,202,1,59,1510,1,202,59,1,1069,111,116,59,1,278,114,59,3,55349,56584,114,97,118,101,5,200,1,59,1534,1,200,101,109,101,110,116,59,1,8712,4,2,97,112,1550,1555,99,114,59,1,274,116,121,4,2,83,86,1563,1576,109,97,108,108,83,113,117,97,114,101,59,1,9723,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9643,4,2,103,112,1599,1604,111,110,59,1,280,102,59,3,55349,56636,115,105,108,111,110,59,1,917,117,4,2,97,105,1624,1640,108,4,2,59,84,1631,1633,1,10869,105,108,100,101,59,1,8770,108,105,98,114,105,117,109,59,1,8652,4,2,99,105,1656,1660,114,59,1,8496,109,59,1,10867,97,59,1,919,109,108,5,203,1,59,1675,1,203,4,2,105,112,1683,1689,115,116,115,59,1,8707,111,110,101,110,116,105,97,108,69,59,1,8519,4,5,99,102,105,111,115,1713,1717,1722,1762,1791,121,59,1,1060,114,59,3,55349,56585,108,108,101,100,4,2,83,86,1732,1745,109,97,108,108,83,113,117,97,114,101,59,1,9724,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9642,4,3,112,114,117,1770,1775,1781,102,59,3,55349,56637,65,108,108,59,1,8704,114,105,101,114,116,114,102,59,1,8497,99,114,59,1,8497,4,12,74,84,97,98,99,100,102,103,111,114,115,116,1822,1827,1834,1848,1855,1877,1882,1887,1890,1896,1978,1984,99,121,59,1,1027,5,62,1,59,1832,1,62,109,109,97,4,2,59,100,1843,1845,1,915,59,1,988,114,101,118,101,59,1,286,4,3,101,105,121,1863,1869,1874,100,105,108,59,1,290,114,99,59,1,284,59,1,1043,111,116,59,1,288,114,59,3,55349,56586,59,1,8921,112,102,59,3,55349,56638,101,97,116,101,114,4,6,69,70,71,76,83,84,1915,1933,1944,1953,1959,1971,113,117,97,108,4,2,59,76,1925,1927,1,8805,101,115,115,59,1,8923,117,108,108,69,113,117,97,108,59,1,8807,114,101,97,116,101,114,59,1,10914,101,115,115,59,1,8823,108,97,110,116,69,113,117,97,108,59,1,10878,105,108,100,101,59,1,8819,99,114,59,3,55349,56482,59,1,8811,4,8,65,97,99,102,105,111,115,117,2005,2012,2026,2032,2036,2049,2073,2089,82,68,99,121,59,1,1066,4,2,99,116,2018,2023,101,107,59,1,711,59,1,94,105,114,99,59,1,292,114,59,1,8460,108,98,101,114,116,83,112,97,99,101,59,1,8459,4,2,112,114,2055,2059,102,59,1,8461,105,122,111,110,116,97,108,76,105,110,101,59,1,9472,4,2,99,116,2079,2083,114,59,1,8459,114,111,107,59,1,294,109,112,4,2,68,69,2097,2107,111,119,110,72,117,109,112,59,1,8782,113,117,97,108,59,1,8783,4,14,69,74,79,97,99,100,102,103,109,110,111,115,116,117,2144,2149,2155,2160,2171,2189,2194,2198,2209,2245,2307,2329,2334,2341,99,121,59,1,1045,108,105,103,59,1,306,99,121,59,1,1025,99,117,116,101,5,205,1,59,2169,1,205,4,2,105,121,2177,2186,114,99,5,206,1,59,2184,1,206,59,1,1048,111,116,59,1,304,114,59,1,8465,114,97,118,101,5,204,1,59,2207,1,204,4,3,59,97,112,2217,2219,2238,1,8465,4,2,99,103,2225,2229,114,59,1,298,105,110,97,114,121,73,59,1,8520,108,105,101,115,59,1,8658,4,2,116,118,2251,2281,4,2,59,101,2257,2259,1,8748,4,2,103,114,2265,2271,114,97,108,59,1,8747,115,101,99,116,105,111,110,59,1,8898,105,115,105,98,108,101,4,2,67,84,2293,2300,111,109,109,97,59,1,8291,105,109,101,115,59,1,8290,4,3,103,112,116,2315,2320,2325,111,110,59,1,302,102,59,3,55349,56640,97,59,1,921,99,114,59,1,8464,105,108,100,101,59,1,296,4,2,107,109,2347,2352,99,121,59,1,1030,108,5,207,1,59,2358,1,207,4,5,99,102,111,115,117,2372,2386,2391,2397,2414,4,2,105,121,2378,2383,114,99,59,1,308,59,1,1049,114,59,3,55349,56589,112,102,59,3,55349,56641,4,2,99,101,2403,2408,114,59,3,55349,56485,114,99,121,59,1,1032,107,99,121,59,1,1028,4,7,72,74,97,99,102,111,115,2436,2441,2446,2452,2467,2472,2478,99,121,59,1,1061,99,121,59,1,1036,112,112,97,59,1,922,4,2,101,121,2458,2464,100,105,108,59,1,310,59,1,1050,114,59,3,55349,56590,112,102,59,3,55349,56642,99,114,59,3,55349,56486,4,11,74,84,97,99,101,102,108,109,111,115,116,2508,2513,2520,2562,2585,2981,2986,3004,3011,3146,3167,99,121,59,1,1033,5,60,1,59,2518,1,60,4,5,99,109,110,112,114,2532,2538,2544,2548,2558,117,116,101,59,1,313,98,100,97,59,1,923,103,59,1,10218,108,97,99,101,116,114,102,59,1,8466,114,59,1,8606,4,3,97,101,121,2570,2576,2582,114,111,110,59,1,317,100,105,108,59,1,315,59,1,1051,4,2,102,115,2591,2907,116,4,10,65,67,68,70,82,84,85,86,97,114,2614,2663,2672,2728,2735,2760,2820,2870,2888,2895,4,2,110,114,2620,2633,103,108,101,66,114,97,99,107,101,116,59,1,10216,114,111,119,4,3,59,66,82,2644,2646,2651,1,8592,97,114,59,1,8676,105,103,104,116,65,114,114,111,119,59,1,8646,101,105,108,105,110,103,59,1,8968,111,4,2,117,119,2679,2692,98,108,101,66,114,97,99,107,101,116,59,1,10214,110,4,2,84,86,2699,2710,101,101,86,101,99,116,111,114,59,1,10593,101,99,116,111,114,4,2,59,66,2721,2723,1,8643,97,114,59,1,10585,108,111,111,114,59,1,8970,105,103,104,116,4,2,65,86,2745,2752,114,114,111,119,59,1,8596,101,99,116,111,114,59,1,10574,4,2,101,114,2766,2792,101,4,3,59,65,86,2775,2777,2784,1,8867,114,114,111,119,59,1,8612,101,99,116,111,114,59,1,10586,105,97,110,103,108,101,4,3,59,66,69,2806,2808,2813,1,8882,97,114,59,1,10703,113,117,97,108,59,1,8884,112,4,3,68,84,86,2829,2841,2852,111,119,110,86,101,99,116,111,114,59,1,10577,101,101,86,101,99,116,111,114,59,1,10592,101,99,116,111,114,4,2,59,66,2863,2865,1,8639,97,114,59,1,10584,101,99,116,111,114,4,2,59,66,2881,2883,1,8636,97,114,59,1,10578,114,114,111,119,59,1,8656,105,103,104,116,97,114,114,111,119,59,1,8660,115,4,6,69,70,71,76,83,84,2922,2936,2947,2956,2962,2974,113,117,97,108,71,114,101,97,116,101,114,59,1,8922,117,108,108,69,113,117,97,108,59,1,8806,114,101,97,116,101,114,59,1,8822,101,115,115,59,1,10913,108,97,110,116,69,113,117,97,108,59,1,10877,105,108,100,101,59,1,8818,114,59,3,55349,56591,4,2,59,101,2992,2994,1,8920,102,116,97,114,114,111,119,59,1,8666,105,100,111,116,59,1,319,4,3,110,112,119,3019,3110,3115,103,4,4,76,82,108,114,3030,3058,3070,3098,101,102,116,4,2,65,82,3039,3046,114,114,111,119,59,1,10229,105,103,104,116,65,114,114,111,119,59,1,10231,105,103,104,116,65,114,114,111,119,59,1,10230,101,102,116,4,2,97,114,3079,3086,114,114,111,119,59,1,10232,105,103,104,116,97,114,114,111,119,59,1,10234,105,103,104,116,97,114,114,111,119,59,1,10233,102,59,3,55349,56643,101,114,4,2,76,82,3123,3134,101,102,116,65,114,114,111,119,59,1,8601,105,103,104,116,65,114,114,111,119,59,1,8600,4,3,99,104,116,3154,3158,3161,114,59,1,8466,59,1,8624,114,111,107,59,1,321,59,1,8810,4,8,97,99,101,102,105,111,115,117,3188,3192,3196,3222,3227,3237,3243,3248,112,59,1,10501,121,59,1,1052,4,2,100,108,3202,3213,105,117,109,83,112,97,99,101,59,1,8287,108,105,110,116,114,102,59,1,8499,114,59,3,55349,56592,110,117,115,80,108,117,115,59,1,8723,112,102,59,3,55349,56644,99,114,59,1,8499,59,1,924,4,9,74,97,99,101,102,111,115,116,117,3271,3276,3283,3306,3422,3427,4120,4126,4137,99,121,59,1,1034,99,117,116,101,59,1,323,4,3,97,101,121,3291,3297,3303,114,111,110,59,1,327,100,105,108,59,1,325,59,1,1053,4,3,103,115,119,3314,3380,3415,97,116,105,118,101,4,3,77,84,86,3327,3340,3365,101,100,105,117,109,83,112,97,99,101,59,1,8203,104,105,4,2,99,110,3348,3357,107,83,112,97,99,101,59,1,8203,83,112,97,99,101,59,1,8203,101,114,121,84,104,105,110,83,112,97,99,101,59,1,8203,116,101,100,4,2,71,76,3389,3405,114,101,97,116,101,114,71,114,101,97,116,101,114,59,1,8811,101,115,115,76,101,115,115,59,1,8810,76,105,110,101,59,1,10,114,59,3,55349,56593,4,4,66,110,112,116,3437,3444,3460,3464,114,101,97,107,59,1,8288,66,114,101,97,107,105,110,103,83,112,97,99,101,59,1,160,102,59,1,8469,4,13,59,67,68,69,71,72,76,78,80,82,83,84,86,3492,3494,3517,3536,3578,3657,3685,3784,3823,3860,3915,4066,4107,1,10988,4,2,111,117,3500,3510,110,103,114,117,101,110,116,59,1,8802,112,67,97,112,59,1,8813,111,117,98,108,101,86,101,114,116,105,99,97,108,66,97,114,59,1,8742,4,3,108,113,120,3544,3552,3571,101,109,101,110,116,59,1,8713,117,97,108,4,2,59,84,3561,3563,1,8800,105,108,100,101,59,3,8770,824,105,115,116,115,59,1,8708,114,101,97,116,101,114,4,7,59,69,70,71,76,83,84,3600,3602,3609,3621,3631,3637,3650,1,8815,113,117,97,108,59,1,8817,117,108,108,69,113,117,97,108,59,3,8807,824,114,101,97,116,101,114,59,3,8811,824,101,115,115,59,1,8825,108,97,110,116,69,113,117,97,108,59,3,10878,824,105,108,100,101,59,1,8821,117,109,112,4,2,68,69,3666,3677,111,119,110,72,117,109,112,59,3,8782,824,113,117,97,108,59,3,8783,824,101,4,2,102,115,3692,3724,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3709,3711,3717,1,8938,97,114,59,3,10703,824,113,117,97,108,59,1,8940,115,4,6,59,69,71,76,83,84,3739,3741,3748,3757,3764,3777,1,8814,113,117,97,108,59,1,8816,114,101,97,116,101,114,59,1,8824,101,115,115,59,3,8810,824,108,97,110,116,69,113,117,97,108,59,3,10877,824,105,108,100,101,59,1,8820,101,115,116,101,100,4,2,71,76,3795,3812,114,101,97,116,101,114,71,114,101,97,116,101,114,59,3,10914,824,101,115,115,76,101,115,115,59,3,10913,824,114,101,99,101,100,101,115,4,3,59,69,83,3838,3840,3848,1,8832,113,117,97,108,59,3,10927,824,108,97,110,116,69,113,117,97,108,59,1,8928,4,2,101,105,3866,3881,118,101,114,115,101,69,108,101,109,101,110,116,59,1,8716,103,104,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3900,3902,3908,1,8939,97,114,59,3,10704,824,113,117,97,108,59,1,8941,4,2,113,117,3921,3973,117,97,114,101,83,117,4,2,98,112,3933,3952,115,101,116,4,2,59,69,3942,3945,3,8847,824,113,117,97,108,59,1,8930,101,114,115,101,116,4,2,59,69,3963,3966,3,8848,824,113,117,97,108,59,1,8931,4,3,98,99,112,3981,4000,4045,115,101,116,4,2,59,69,3990,3993,3,8834,8402,113,117,97,108,59,1,8840,99,101,101,100,115,4,4,59,69,83,84,4015,4017,4025,4037,1,8833,113,117,97,108,59,3,10928,824,108,97,110,116,69,113,117,97,108,59,1,8929,105,108,100,101,59,3,8831,824,101,114,115,101,116,4,2,59,69,4056,4059,3,8835,8402,113,117,97,108,59,1,8841,105,108,100,101,4,4,59,69,70,84,4080,4082,4089,4100,1,8769,113,117,97,108,59,1,8772,117,108,108,69,113,117,97,108,59,1,8775,105,108,100,101,59,1,8777,101,114,116,105,99,97,108,66,97,114,59,1,8740,99,114,59,3,55349,56489,105,108,100,101,5,209,1,59,4135,1,209,59,1,925,4,14,69,97,99,100,102,103,109,111,112,114,115,116,117,118,4170,4176,4187,4205,4212,4217,4228,4253,4259,4292,4295,4316,4337,4346,108,105,103,59,1,338,99,117,116,101,5,211,1,59,4185,1,211,4,2,105,121,4193,4202,114,99,5,212,1,59,4200,1,212,59,1,1054,98,108,97,99,59,1,336,114,59,3,55349,56594,114,97,118,101,5,210,1,59,4226,1,210,4,3,97,101,105,4236,4241,4246,99,114,59,1,332,103,97,59,1,937,99,114,111,110,59,1,927,112,102,59,3,55349,56646,101,110,67,117,114,108,121,4,2,68,81,4272,4285,111,117,98,108,101,81,117,111,116,101,59,1,8220,117,111,116,101,59,1,8216,59,1,10836,4,2,99,108,4301,4306,114,59,3,55349,56490,97,115,104,5,216,1,59,4314,1,216,105,4,2,108,109,4323,4332,100,101,5,213,1,59,4330,1,213,101,115,59,1,10807,109,108,5,214,1,59,4344,1,214,101,114,4,2,66,80,4354,4380,4,2,97,114,4360,4364,114,59,1,8254,97,99,4,2,101,107,4372,4375,59,1,9182,101,116,59,1,9140,97,114,101,110,116,104,101,115,105,115,59,1,9180,4,9,97,99,102,104,105,108,111,114,115,4413,4422,4426,4431,4435,4438,4448,4471,4561,114,116,105,97,108,68,59,1,8706,121,59,1,1055,114,59,3,55349,56595,105,59,1,934,59,1,928,117,115,77,105,110,117,115,59,1,177,4,2,105,112,4454,4467,110,99,97,114,101,112,108,97,110,101,59,1,8460,102,59,1,8473,4,4,59,101,105,111,4481,4483,4526,4531,1,10939,99,101,100,101,115,4,4,59,69,83,84,4498,4500,4507,4519,1,8826,113,117,97,108,59,1,10927,108,97,110,116,69,113,117,97,108,59,1,8828,105,108,100,101,59,1,8830,109,101,59,1,8243,4,2,100,112,4537,4543,117,99,116,59,1,8719,111,114,116,105,111,110,4,2,59,97,4555,4557,1,8759,108,59,1,8733,4,2,99,105,4567,4572,114,59,3,55349,56491,59,1,936,4,4,85,102,111,115,4585,4594,4599,4604,79,84,5,34,1,59,4592,1,34,114,59,3,55349,56596,112,102,59,1,8474,99,114,59,3,55349,56492,4,12,66,69,97,99,101,102,104,105,111,114,115,117,4636,4642,4650,4681,4704,4763,4767,4771,5047,5069,5081,5094,97,114,114,59,1,10512,71,5,174,1,59,4648,1,174,4,3,99,110,114,4658,4664,4668,117,116,101,59,1,340,103,59,1,10219,114,4,2,59,116,4675,4677,1,8608,108,59,1,10518,4,3,97,101,121,4689,4695,4701,114,111,110,59,1,344,100,105,108,59,1,342,59,1,1056,4,2,59,118,4710,4712,1,8476,101,114,115,101,4,2,69,85,4722,4748,4,2,108,113,4728,4736,101,109,101,110,116,59,1,8715,117,105,108,105,98,114,105,117,109,59,1,8651,112,69,113,117,105,108,105,98,114,105,117,109,59,1,10607,114,59,1,8476,111,59,1,929,103,104,116,4,8,65,67,68,70,84,85,86,97,4792,4840,4849,4905,4912,4972,5022,5040,4,2,110,114,4798,4811,103,108,101,66,114,97,99,107,101,116,59,1,10217,114,111,119,4,3,59,66,76,4822,4824,4829,1,8594,97,114,59,1,8677,101,102,116,65,114,114,111,119,59,1,8644,101,105,108,105,110,103,59,1,8969,111,4,2,117,119,4856,4869,98,108,101,66,114,97,99,107,101,116,59,1,10215,110,4,2,84,86,4876,4887,101,101,86,101,99,116,111,114,59,1,10589,101,99,116,111,114,4,2,59,66,4898,4900,1,8642,97,114,59,1,10581,108,111,111,114,59,1,8971,4,2,101,114,4918,4944,101,4,3,59,65,86,4927,4929,4936,1,8866,114,114,111,119,59,1,8614,101,99,116,111,114,59,1,10587,105,97,110,103,108,101,4,3,59,66,69,4958,4960,4965,1,8883,97,114,59,1,10704,113,117,97,108,59,1,8885,112,4,3,68,84,86,4981,4993,5004,111,119,110,86,101,99,116,111,114,59,1,10575,101,101,86,101,99,116,111,114,59,1,10588,101,99,116,111,114,4,2,59,66,5015,5017,1,8638,97,114,59,1,10580,101,99,116,111,114,4,2,59,66,5033,5035,1,8640,97,114,59,1,10579,114,114,111,119,59,1,8658,4,2,112,117,5053,5057,102,59,1,8477,110,100,73,109,112,108,105,101,115,59,1,10608,105,103,104,116,97,114,114,111,119,59,1,8667,4,2,99,104,5087,5091,114,59,1,8475,59,1,8625,108,101,68,101,108,97,121,101,100,59,1,10740,4,13,72,79,97,99,102,104,105,109,111,113,115,116,117,5134,5150,5157,5164,5198,5203,5259,5265,5277,5283,5374,5380,5385,4,2,67,99,5140,5146,72,99,121,59,1,1065,121,59,1,1064,70,84,99,121,59,1,1068,99,117,116,101,59,1,346,4,5,59,97,101,105,121,5176,5178,5184,5190,5195,1,10940,114,111,110,59,1,352,100,105,108,59,1,350,114,99,59,1,348,59,1,1057,114,59,3,55349,56598,111,114,116,4,4,68,76,82,85,5216,5227,5238,5250,111,119,110,65,114,114,111,119,59,1,8595,101,102,116,65,114,114,111,119,59,1,8592,105,103,104,116,65,114,114,111,119,59,1,8594,112,65,114,114,111,119,59,1,8593,103,109,97,59,1,931,97,108,108,67,105,114,99,108,101,59,1,8728,112,102,59,3,55349,56650,4,2,114,117,5289,5293,116,59,1,8730,97,114,101,4,4,59,73,83,85,5306,5308,5322,5367,1,9633,110,116,101,114,115,101,99,116,105,111,110,59,1,8851,117,4,2,98,112,5329,5347,115,101,116,4,2,59,69,5338,5340,1,8847,113,117,97,108,59,1,8849,101,114,115,101,116,4,2,59,69,5358,5360,1,8848,113,117,97,108,59,1,8850,110,105,111,110,59,1,8852,99,114,59,3,55349,56494,97,114,59,1,8902,4,4,98,99,109,112,5395,5420,5475,5478,4,2,59,115,5401,5403,1,8912,101,116,4,2,59,69,5411,5413,1,8912,113,117,97,108,59,1,8838,4,2,99,104,5426,5468,101,101,100,115,4,4,59,69,83,84,5440,5442,5449,5461,1,8827,113,117,97,108,59,1,10928,108,97,110,116,69,113,117,97,108,59,1,8829,105,108,100,101,59,1,8831,84,104,97,116,59,1,8715,59,1,8721,4,3,59,101,115,5486,5488,5507,1,8913,114,115,101,116,4,2,59,69,5498,5500,1,8835,113,117,97,108,59,1,8839,101,116,59,1,8913,4,11,72,82,83,97,99,102,104,105,111,114,115,5536,5546,5552,5567,5579,5602,5607,5655,5695,5701,5711,79,82,78,5,222,1,59,5544,1,222,65,68,69,59,1,8482,4,2,72,99,5558,5563,99,121,59,1,1035,121,59,1,1062,4,2,98,117,5573,5576,59,1,9,59,1,932,4,3,97,101,121,5587,5593,5599,114,111,110,59,1,356,100,105,108,59,1,354,59,1,1058,114,59,3,55349,56599,4,2,101,105,5613,5631,4,2,114,116,5619,5627,101,102,111,114,101,59,1,8756,97,59,1,920,4,2,99,110,5637,5647,107,83,112,97,99,101,59,3,8287,8202,83,112,97,99,101,59,1,8201,108,100,101,4,4,59,69,70,84,5668,5670,5677,5688,1,8764,113,117,97,108,59,1,8771,117,108,108,69,113,117,97,108,59,1,8773,105,108,100,101,59,1,8776,112,102,59,3,55349,56651,105,112,108,101,68,111,116,59,1,8411,4,2,99,116,5717,5722,114,59,3,55349,56495,114,111,107,59,1,358,4,14,97,98,99,100,102,103,109,110,111,112,114,115,116,117,5758,5789,5805,5823,5830,5835,5846,5852,5921,5937,6089,6095,6101,6108,4,2,99,114,5764,5774,117,116,101,5,218,1,59,5772,1,218,114,4,2,59,111,5781,5783,1,8607,99,105,114,59,1,10569,114,4,2,99,101,5796,5800,121,59,1,1038,118,101,59,1,364,4,2,105,121,5811,5820,114,99,5,219,1,59,5818,1,219,59,1,1059,98,108,97,99,59,1,368,114,59,3,55349,56600,114,97,118,101,5,217,1,59,5844,1,217,97,99,114,59,1,362,4,2,100,105,5858,5905,101,114,4,2,66,80,5866,5892,4,2,97,114,5872,5876,114,59,1,95,97,99,4,2,101,107,5884,5887,59,1,9183,101,116,59,1,9141,97,114,101,110,116,104,101,115,105,115,59,1,9181,111,110,4,2,59,80,5913,5915,1,8899,108,117,115,59,1,8846,4,2,103,112,5927,5932,111,110,59,1,370,102,59,3,55349,56652,4,8,65,68,69,84,97,100,112,115,5955,5985,5996,6009,6026,6033,6044,6075,114,114,111,119,4,3,59,66,68,5967,5969,5974,1,8593,97,114,59,1,10514,111,119,110,65,114,114,111,119,59,1,8645,111,119,110,65,114,114,111,119,59,1,8597,113,117,105,108,105,98,114,105,117,109,59,1,10606,101,101,4,2,59,65,6017,6019,1,8869,114,114,111,119,59,1,8613,114,114,111,119,59,1,8657,111,119,110,97,114,114,111,119,59,1,8661,101,114,4,2,76,82,6052,6063,101,102,116,65,114,114,111,119,59,1,8598,105,103,104,116,65,114,114,111,119,59,1,8599,105,4,2,59,108,6082,6084,1,978,111,110,59,1,933,105,110,103,59,1,366,99,114,59,3,55349,56496,105,108,100,101,59,1,360,109,108,5,220,1,59,6115,1,220,4,9,68,98,99,100,101,102,111,115,118,6137,6143,6148,6152,6166,6250,6255,6261,6267,97,115,104,59,1,8875,97,114,59,1,10987,121,59,1,1042,97,115,104,4,2,59,108,6161,6163,1,8873,59,1,10982,4,2,101,114,6172,6175,59,1,8897,4,3,98,116,121,6183,6188,6238,97,114,59,1,8214,4,2,59,105,6194,6196,1,8214,99,97,108,4,4,66,76,83,84,6209,6214,6220,6231,97,114,59,1,8739,105,110,101,59,1,124,101,112,97,114,97,116,111,114,59,1,10072,105,108,100,101,59,1,8768,84,104,105,110,83,112,97,99,101,59,1,8202,114,59,3,55349,56601,112,102,59,3,55349,56653,99,114,59,3,55349,56497,100,97,115,104,59,1,8874,4,5,99,101,102,111,115,6286,6292,6298,6303,6309,105,114,99,59,1,372,100,103,101,59,1,8896,114,59,3,55349,56602,112,102,59,3,55349,56654,99,114,59,3,55349,56498,4,4,102,105,111,115,6325,6330,6333,6339,114,59,3,55349,56603,59,1,926,112,102,59,3,55349,56655,99,114,59,3,55349,56499,4,9,65,73,85,97,99,102,111,115,117,6365,6370,6375,6380,6391,6405,6410,6416,6422,99,121,59,1,1071,99,121,59,1,1031,99,121,59,1,1070,99,117,116,101,5,221,1,59,6389,1,221,4,2,105,121,6397,6402,114,99,59,1,374,59,1,1067,114,59,3,55349,56604,112,102,59,3,55349,56656,99,114,59,3,55349,56500,109,108,59,1,376,4,8,72,97,99,100,101,102,111,115,6445,6450,6457,6472,6477,6501,6505,6510,99,121,59,1,1046,99,117,116,101,59,1,377,4,2,97,121,6463,6469,114,111,110,59,1,381,59,1,1047,111,116,59,1,379,4,2,114,116,6483,6497,111,87,105,100,116,104,83,112,97,99,101,59,1,8203,97,59,1,918,114,59,1,8488,112,102,59,1,8484,99,114,59,3,55349,56501,4,16,97,98,99,101,102,103,108,109,110,111,112,114,115,116,117,119,6550,6561,6568,6612,6622,6634,6645,6672,6699,6854,6870,6923,6933,6963,6974,6983,99,117,116,101,5,225,1,59,6559,1,225,114,101,118,101,59,1,259,4,6,59,69,100,105,117,121,6582,6584,6588,6591,6600,6609,1,8766,59,3,8766,819,59,1,8767,114,99,5,226,1,59,6598,1,226,116,101,5,180,1,59,6607,1,180,59,1,1072,108,105,103,5,230,1,59,6620,1,230,4,2,59,114,6628,6630,1,8289,59,3,55349,56606,114,97,118,101,5,224,1,59,6643,1,224,4,2,101,112,6651,6667,4,2,102,112,6657,6663,115,121,109,59,1,8501,104,59,1,8501,104,97,59,1,945,4,2,97,112,6678,6692,4,2,99,108,6684,6688,114,59,1,257,103,59,1,10815,5,38,1,59,6697,1,38,4,2,100,103,6705,6737,4,5,59,97,100,115,118,6717,6719,6724,6727,6734,1,8743,110,100,59,1,10837,59,1,10844,108,111,112,101,59,1,10840,59,1,10842,4,7,59,101,108,109,114,115,122,6753,6755,6758,6762,6814,6835,6848,1,8736,59,1,10660,101,59,1,8736,115,100,4,2,59,97,6770,6772,1,8737,4,8,97,98,99,100,101,102,103,104,6790,6793,6796,6799,6802,6805,6808,6811,59,1,10664,59,1,10665,59,1,10666,59,1,10667,59,1,10668,59,1,10669,59,1,10670,59,1,10671,116,4,2,59,118,6821,6823,1,8735,98,4,2,59,100,6830,6832,1,8894,59,1,10653,4,2,112,116,6841,6845,104,59,1,8738,59,1,197,97,114,114,59,1,9084,4,2,103,112,6860,6865,111,110,59,1,261,102,59,3,55349,56658,4,7,59,69,97,101,105,111,112,6886,6888,6891,6897,6900,6904,6908,1,8776,59,1,10864,99,105,114,59,1,10863,59,1,8778,100,59,1,8779,115,59,1,39,114,111,120,4,2,59,101,6917,6919,1,8776,113,59,1,8778,105,110,103,5,229,1,59,6931,1,229,4,3,99,116,121,6941,6946,6949,114,59,3,55349,56502,59,1,42,109,112,4,2,59,101,6957,6959,1,8776,113,59,1,8781,105,108,100,101,5,227,1,59,6972,1,227,109,108,5,228,1,59,6981,1,228,4,2,99,105,6989,6997,111,110,105,110,116,59,1,8755,110,116,59,1,10769,4,16,78,97,98,99,100,101,102,105,107,108,110,111,112,114,115,117,7036,7041,7119,7135,7149,7155,7219,7224,7347,7354,7463,7489,7786,7793,7814,7866,111,116,59,1,10989,4,2,99,114,7047,7094,107,4,4,99,101,112,115,7058,7064,7073,7080,111,110,103,59,1,8780,112,115,105,108,111,110,59,1,1014,114,105,109,101,59,1,8245,105,109,4,2,59,101,7088,7090,1,8765,113,59,1,8909,4,2,118,119,7100,7105,101,101,59,1,8893,101,100,4,2,59,103,7113,7115,1,8965,101,59,1,8965,114,107,4,2,59,116,7127,7129,1,9141,98,114,107,59,1,9142,4,2,111,121,7141,7146,110,103,59,1,8780,59,1,1073,113,117,111,59,1,8222,4,5,99,109,112,114,116,7167,7181,7188,7193,7199,97,117,115,4,2,59,101,7176,7178,1,8757,59,1,8757,112,116,121,118,59,1,10672,115,105,59,1,1014,110,111,117,59,1,8492,4,3,97,104,119,7207,7210,7213,59,1,946,59,1,8502,101,101,110,59,1,8812,114,59,3,55349,56607,103,4,7,99,111,115,116,117,118,119,7241,7262,7288,7305,7328,7335,7340,4,3,97,105,117,7249,7253,7258,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,4,3,100,112,116,7270,7275,7281,111,116,59,1,10752,108,117,115,59,1,10753,105,109,101,115,59,1,10754,4,2,113,116,7294,7300,99,117,112,59,1,10758,97,114,59,1,9733,114,105,97,110,103,108,101,4,2,100,117,7318,7324,111,119,110,59,1,9661,112,59,1,9651,112,108,117,115,59,1,10756,101,101,59,1,8897,101,100,103,101,59,1,8896,97,114,111,119,59,1,10509,4,3,97,107,111,7362,7436,7458,4,2,99,110,7368,7432,107,4,3,108,115,116,7377,7386,7394,111,122,101,110,103,101,59,1,10731,113,117,97,114,101,59,1,9642,114,105,97,110,103,108,101,4,4,59,100,108,114,7411,7413,7419,7425,1,9652,111,119,110,59,1,9662,101,102,116,59,1,9666,105,103,104,116,59,1,9656,107,59,1,9251,4,2,49,51,7442,7454,4,2,50,52,7448,7451,59,1,9618,59,1,9617,52,59,1,9619,99,107,59,1,9608,4,2,101,111,7469,7485,4,2,59,113,7475,7478,3,61,8421,117,105,118,59,3,8801,8421,116,59,1,8976,4,4,112,116,119,120,7499,7504,7517,7523,102,59,3,55349,56659,4,2,59,116,7510,7512,1,8869,111,109,59,1,8869,116,105,101,59,1,8904,4,12,68,72,85,86,98,100,104,109,112,116,117,118,7549,7571,7597,7619,7655,7660,7682,7708,7715,7721,7728,7750,4,4,76,82,108,114,7559,7562,7565,7568,59,1,9559,59,1,9556,59,1,9558,59,1,9555,4,5,59,68,85,100,117,7583,7585,7588,7591,7594,1,9552,59,1,9574,59,1,9577,59,1,9572,59,1,9575,4,4,76,82,108,114,7607,7610,7613,7616,59,1,9565,59,1,9562,59,1,9564,59,1,9561,4,7,59,72,76,82,104,108,114,7635,7637,7640,7643,7646,7649,7652,1,9553,59,1,9580,59,1,9571,59,1,9568,59,1,9579,59,1,9570,59,1,9567,111,120,59,1,10697,4,4,76,82,108,114,7670,7673,7676,7679,59,1,9557,59,1,9554,59,1,9488,59,1,9484,4,5,59,68,85,100,117,7694,7696,7699,7702,7705,1,9472,59,1,9573,59,1,9576,59,1,9516,59,1,9524,105,110,117,115,59,1,8863,108,117,115,59,1,8862,105,109,101,115,59,1,8864,4,4,76,82,108,114,7738,7741,7744,7747,59,1,9563,59,1,9560,59,1,9496,59,1,9492,4,7,59,72,76,82,104,108,114,7766,7768,7771,7774,7777,7780,7783,1,9474,59,1,9578,59,1,9569,59,1,9566,59,1,9532,59,1,9508,59,1,9500,114,105,109,101,59,1,8245,4,2,101,118,7799,7804,118,101,59,1,728,98,97,114,5,166,1,59,7812,1,166,4,4,99,101,105,111,7824,7829,7834,7846,114,59,3,55349,56503,109,105,59,1,8271,109,4,2,59,101,7841,7843,1,8765,59,1,8909,108,4,3,59,98,104,7855,7857,7860,1,92,59,1,10693,115,117,98,59,1,10184,4,2,108,109,7872,7885,108,4,2,59,101,7879,7881,1,8226,116,59,1,8226,112,4,3,59,69,101,7894,7896,7899,1,8782,59,1,10926,4,2,59,113,7905,7907,1,8783,59,1,8783,4,15,97,99,100,101,102,104,105,108,111,114,115,116,117,119,121,7942,8021,8075,8080,8121,8126,8157,8279,8295,8430,8446,8485,8491,8707,8726,4,3,99,112,114,7950,7956,8007,117,116,101,59,1,263,4,6,59,97,98,99,100,115,7970,7972,7977,7984,7998,8003,1,8745,110,100,59,1,10820,114,99,117,112,59,1,10825,4,2,97,117,7990,7994,112,59,1,10827,112,59,1,10823,111,116,59,1,10816,59,3,8745,65024,4,2,101,111,8013,8017,116,59,1,8257,110,59,1,711,4,4,97,101,105,117,8031,8046,8056,8061,4,2,112,114,8037,8041,115,59,1,10829,111,110,59,1,269,100,105,108,5,231,1,59,8054,1,231,114,99,59,1,265,112,115,4,2,59,115,8069,8071,1,10828,109,59,1,10832,111,116,59,1,267,4,3,100,109,110,8088,8097,8104,105,108,5,184,1,59,8095,1,184,112,116,121,118,59,1,10674,116,5,162,2,59,101,8112,8114,1,162,114,100,111,116,59,1,183,114,59,3,55349,56608,4,3,99,101,105,8134,8138,8154,121,59,1,1095,99,107,4,2,59,109,8146,8148,1,10003,97,114,107,59,1,10003,59,1,967,114,4,7,59,69,99,101,102,109,115,8174,8176,8179,8258,8261,8268,8273,1,9675,59,1,10691,4,3,59,101,108,8187,8189,8193,1,710,113,59,1,8791,101,4,2,97,100,8200,8223,114,114,111,119,4,2,108,114,8210,8216,101,102,116,59,1,8634,105,103,104,116,59,1,8635,4,5,82,83,97,99,100,8235,8238,8241,8246,8252,59,1,174,59,1,9416,115,116,59,1,8859,105,114,99,59,1,8858,97,115,104,59,1,8861,59,1,8791,110,105,110,116,59,1,10768,105,100,59,1,10991,99,105,114,59,1,10690,117,98,115,4,2,59,117,8288,8290,1,9827,105,116,59,1,9827,4,4,108,109,110,112,8305,8326,8376,8400,111,110,4,2,59,101,8313,8315,1,58,4,2,59,113,8321,8323,1,8788,59,1,8788,4,2,109,112,8332,8344,97,4,2,59,116,8339,8341,1,44,59,1,64,4,3,59,102,108,8352,8354,8358,1,8705,110,59,1,8728,101,4,2,109,120,8365,8371,101,110,116,59,1,8705,101,115,59,1,8450,4,2,103,105,8382,8395,4,2,59,100,8388,8390,1,8773,111,116,59,1,10861,110,116,59,1,8750,4,3,102,114,121,8408,8412,8417,59,3,55349,56660,111,100,59,1,8720,5,169,2,59,115,8424,8426,1,169,114,59,1,8471,4,2,97,111,8436,8441,114,114,59,1,8629,115,115,59,1,10007,4,2,99,117,8452,8457,114,59,3,55349,56504,4,2,98,112,8463,8474,4,2,59,101,8469,8471,1,10959,59,1,10961,4,2,59,101,8480,8482,1,10960,59,1,10962,100,111,116,59,1,8943,4,7,100,101,108,112,114,118,119,8507,8522,8536,8550,8600,8697,8702,97,114,114,4,2,108,114,8516,8519,59,1,10552,59,1,10549,4,2,112,115,8528,8532,114,59,1,8926,99,59,1,8927,97,114,114,4,2,59,112,8545,8547,1,8630,59,1,10557,4,6,59,98,99,100,111,115,8564,8566,8573,8587,8592,8596,1,8746,114,99,97,112,59,1,10824,4,2,97,117,8579,8583,112,59,1,10822,112,59,1,10826,111,116,59,1,8845,114,59,1,10821,59,3,8746,65024,4,4,97,108,114,118,8610,8623,8663,8672,114,114,4,2,59,109,8618,8620,1,8631,59,1,10556,121,4,3,101,118,119,8632,8651,8656,113,4,2,112,115,8639,8645,114,101,99,59,1,8926,117,99,99,59,1,8927,101,101,59,1,8910,101,100,103,101,59,1,8911,101,110,5,164,1,59,8670,1,164,101,97,114,114,111,119,4,2,108,114,8684,8690,101,102,116,59,1,8630,105,103,104,116,59,1,8631,101,101,59,1,8910,101,100,59,1,8911,4,2,99,105,8713,8721,111,110,105,110,116,59,1,8754,110,116,59,1,8753,108,99,116,121,59,1,9005,4,19,65,72,97,98,99,100,101,102,104,105,106,108,111,114,115,116,117,119,122,8773,8778,8783,8821,8839,8854,8887,8914,8930,8944,9036,9041,9058,9197,9227,9258,9281,9297,9305,114,114,59,1,8659,97,114,59,1,10597,4,4,103,108,114,115,8793,8799,8805,8809,103,101,114,59,1,8224,101,116,104,59,1,8504,114,59,1,8595,104,4,2,59,118,8816,8818,1,8208,59,1,8867,4,2,107,108,8827,8834,97,114,111,119,59,1,10511,97,99,59,1,733,4,2,97,121,8845,8851,114,111,110,59,1,271,59,1,1076,4,3,59,97,111,8862,8864,8880,1,8518,4,2,103,114,8870,8876,103,101,114,59,1,8225,114,59,1,8650,116,115,101,113,59,1,10871,4,3,103,108,109,8895,8902,8907,5,176,1,59,8900,1,176,116,97,59,1,948,112,116,121,118,59,1,10673,4,2,105,114,8920,8926,115,104,116,59,1,10623,59,3,55349,56609,97,114,4,2,108,114,8938,8941,59,1,8643,59,1,8642,4,5,97,101,103,115,118,8956,8986,8989,8996,9001,109,4,3,59,111,115,8965,8967,8983,1,8900,110,100,4,2,59,115,8975,8977,1,8900,117,105,116,59,1,9830,59,1,9830,59,1,168,97,109,109,97,59,1,989,105,110,59,1,8946,4,3,59,105,111,9009,9011,9031,1,247,100,101,5,247,2,59,111,9020,9022,1,247,110,116,105,109,101,115,59,1,8903,110,120,59,1,8903,99,121,59,1,1106,99,4,2,111,114,9048,9053,114,110,59,1,8990,111,112,59,1,8973,4,5,108,112,116,117,119,9070,9076,9081,9130,9144,108,97,114,59,1,36,102,59,3,55349,56661,4,5,59,101,109,112,115,9093,9095,9109,9116,9122,1,729,113,4,2,59,100,9102,9104,1,8784,111,116,59,1,8785,105,110,117,115,59,1,8760,108,117,115,59,1,8724,113,117,97,114,101,59,1,8865,98,108,101,98,97,114,119,101,100,103,101,59,1,8966,110,4,3,97,100,104,9153,9160,9172,114,114,111,119,59,1,8595,111,119,110,97,114,114,111,119,115,59,1,8650,97,114,112,111,111,110,4,2,108,114,9184,9190,101,102,116,59,1,8643,105,103,104,116,59,1,8642,4,2,98,99,9203,9211,107,97,114,111,119,59,1,10512,4,2,111,114,9217,9222,114,110,59,1,8991,111,112,59,1,8972,4,3,99,111,116,9235,9248,9252,4,2,114,121,9241,9245,59,3,55349,56505,59,1,1109,108,59,1,10742,114,111,107,59,1,273,4,2,100,114,9264,9269,111,116,59,1,8945,105,4,2,59,102,9276,9278,1,9663,59,1,9662,4,2,97,104,9287,9292,114,114,59,1,8693,97,114,59,1,10607,97,110,103,108,101,59,1,10662,4,2,99,105,9311,9315,121,59,1,1119,103,114,97,114,114,59,1,10239,4,18,68,97,99,100,101,102,103,108,109,110,111,112,113,114,115,116,117,120,9361,9376,9398,9439,9444,9447,9462,9495,9531,9585,9598,9614,9659,9755,9771,9792,9808,9826,4,2,68,111,9367,9372,111,116,59,1,10871,116,59,1,8785,4,2,99,115,9382,9392,117,116,101,5,233,1,59,9390,1,233,116,101,114,59,1,10862,4,4,97,105,111,121,9408,9414,9430,9436,114,111,110,59,1,283,114,4,2,59,99,9421,9423,1,8790,5,234,1,59,9428,1,234,108,111,110,59,1,8789,59,1,1101,111,116,59,1,279,59,1,8519,4,2,68,114,9453,9458,111,116,59,1,8786,59,3,55349,56610,4,3,59,114,115,9470,9472,9482,1,10906,97,118,101,5,232,1,59,9480,1,232,4,2,59,100,9488,9490,1,10902,111,116,59,1,10904,4,4,59,105,108,115,9505,9507,9515,9518,1,10905,110,116,101,114,115,59,1,9191,59,1,8467,4,2,59,100,9524,9526,1,10901,111,116,59,1,10903,4,3,97,112,115,9539,9544,9564,99,114,59,1,275,116,121,4,3,59,115,118,9554,9556,9561,1,8709,101,116,59,1,8709,59,1,8709,112,4,2,49,59,9571,9583,4,2,51,52,9577,9580,59,1,8196,59,1,8197,1,8195,4,2,103,115,9591,9594,59,1,331,112,59,1,8194,4,2,103,112,9604,9609,111,110,59,1,281,102,59,3,55349,56662,4,3,97,108,115,9622,9635,9640,114,4,2,59,115,9629,9631,1,8917,108,59,1,10723,117,115,59,1,10865,105,4,3,59,108,118,9649,9651,9656,1,949,111,110,59,1,949,59,1,1013,4,4,99,115,117,118,9669,9686,9716,9747,4,2,105,111,9675,9680,114,99,59,1,8790,108,111,110,59,1,8789,4,2,105,108,9692,9696,109,59,1,8770,97,110,116,4,2,103,108,9705,9710,116,114,59,1,10902,101,115,115,59,1,10901,4,3,97,101,105,9724,9729,9734,108,115,59,1,61,115,116,59,1,8799,118,4,2,59,68,9741,9743,1,8801,68,59,1,10872,112,97,114,115,108,59,1,10725,4,2,68,97,9761,9766,111,116,59,1,8787,114,114,59,1,10609,4,3,99,100,105,9779,9783,9788,114,59,1,8495,111,116,59,1,8784,109,59,1,8770,4,2,97,104,9798,9801,59,1,951,5,240,1,59,9806,1,240,4,2,109,114,9814,9822,108,5,235,1,59,9820,1,235,111,59,1,8364,4,3,99,105,112,9834,9838,9843,108,59,1,33,115,116,59,1,8707,4,2,101,111,9849,9859,99,116,97,116,105,111,110,59,1,8496,110,101,110,116,105,97,108,101,59,1,8519,4,12,97,99,101,102,105,106,108,110,111,112,114,115,9896,9910,9914,9921,9954,9960,9967,9989,9994,10027,10036,10164,108,108,105,110,103,100,111,116,115,101,113,59,1,8786,121,59,1,1092,109,97,108,101,59,1,9792,4,3,105,108,114,9929,9935,9950,108,105,103,59,1,64259,4,2,105,108,9941,9945,103,59,1,64256,105,103,59,1,64260,59,3,55349,56611,108,105,103,59,1,64257,108,105,103,59,3,102,106,4,3,97,108,116,9975,9979,9984,116,59,1,9837,105,103,59,1,64258,110,115,59,1,9649,111,102,59,1,402,4,2,112,114,10000,10005,102,59,3,55349,56663,4,2,97,107,10011,10016,108,108,59,1,8704,4,2,59,118,10022,10024,1,8916,59,1,10969,97,114,116,105,110,116,59,1,10765,4,2,97,111,10042,10159,4,2,99,115,10048,10155,4,6,49,50,51,52,53,55,10062,10102,10114,10135,10139,10151,4,6,50,51,52,53,54,56,10076,10083,10086,10093,10096,10099,5,189,1,59,10081,1,189,59,1,8531,5,188,1,59,10091,1,188,59,1,8533,59,1,8537,59,1,8539,4,2,51,53,10108,10111,59,1,8532,59,1,8534,4,3,52,53,56,10122,10129,10132,5,190,1,59,10127,1,190,59,1,8535,59,1,8540,53,59,1,8536,4,2,54,56,10145,10148,59,1,8538,59,1,8541,56,59,1,8542,108,59,1,8260,119,110,59,1,8994,99,114,59,3,55349,56507,4,17,69,97,98,99,100,101,102,103,105,106,108,110,111,114,115,116,118,10206,10217,10247,10254,10268,10273,10358,10363,10374,10380,10385,10406,10458,10464,10470,10497,10610,4,2,59,108,10212,10214,1,8807,59,1,10892,4,3,99,109,112,10225,10231,10244,117,116,101,59,1,501,109,97,4,2,59,100,10239,10241,1,947,59,1,989,59,1,10886,114,101,118,101,59,1,287,4,2,105,121,10260,10265,114,99,59,1,285,59,1,1075,111,116,59,1,289,4,4,59,108,113,115,10283,10285,10288,10308,1,8805,59,1,8923,4,3,59,113,115,10296,10298,10301,1,8805,59,1,8807,108,97,110,116,59,1,10878,4,4,59,99,100,108,10318,10320,10324,10345,1,10878,99,59,1,10921,111,116,4,2,59,111,10332,10334,1,10880,4,2,59,108,10340,10342,1,10882,59,1,10884,4,2,59,101,10351,10354,3,8923,65024,115,59,1,10900,114,59,3,55349,56612,4,2,59,103,10369,10371,1,8811,59,1,8921,109,101,108,59,1,8503,99,121,59,1,1107,4,4,59,69,97,106,10395,10397,10400,10403,1,8823,59,1,10898,59,1,10917,59,1,10916,4,4,69,97,101,115,10416,10419,10434,10453,59,1,8809,112,4,2,59,112,10426,10428,1,10890,114,111,120,59,1,10890,4,2,59,113,10440,10442,1,10888,4,2,59,113,10448,10450,1,10888,59,1,8809,105,109,59,1,8935,112,102,59,3,55349,56664,97,118,101,59,1,96,4,2,99,105,10476,10480,114,59,1,8458,109,4,3,59,101,108,10489,10491,10494,1,8819,59,1,10894,59,1,10896,5,62,6,59,99,100,108,113,114,10512,10514,10527,10532,10538,10545,1,62,4,2,99,105,10520,10523,59,1,10919,114,59,1,10874,111,116,59,1,8919,80,97,114,59,1,10645,117,101,115,116,59,1,10876,4,5,97,100,101,108,115,10557,10574,10579,10599,10605,4,2,112,114,10563,10570,112,114,111,120,59,1,10886,114,59,1,10616,111,116,59,1,8919,113,4,2,108,113,10586,10592,101,115,115,59,1,8923,108,101,115,115,59,1,10892,101,115,115,59,1,8823,105,109,59,1,8819,4,2,101,110,10616,10626,114,116,110,101,113,113,59,3,8809,65024,69,59,3,8809,65024,4,10,65,97,98,99,101,102,107,111,115,121,10653,10658,10713,10718,10724,10760,10765,10786,10850,10875,114,114,59,1,8660,4,4,105,108,109,114,10668,10674,10678,10684,114,115,112,59,1,8202,102,59,1,189,105,108,116,59,1,8459,4,2,100,114,10690,10695,99,121,59,1,1098,4,3,59,99,119,10703,10705,10710,1,8596,105,114,59,1,10568,59,1,8621,97,114,59,1,8463,105,114,99,59,1,293,4,3,97,108,114,10732,10748,10754,114,116,115,4,2,59,117,10741,10743,1,9829,105,116,59,1,9829,108,105,112,59,1,8230,99,111,110,59,1,8889,114,59,3,55349,56613,115,4,2,101,119,10772,10779,97,114,111,119,59,1,10533,97,114,111,119,59,1,10534,4,5,97,109,111,112,114,10798,10803,10809,10839,10844,114,114,59,1,8703,116,104,116,59,1,8763,107,4,2,108,114,10816,10827,101,102,116,97,114,114,111,119,59,1,8617,105,103,104,116,97,114,114,111,119,59,1,8618,102,59,3,55349,56665,98,97,114,59,1,8213,4,3,99,108,116,10858,10863,10869,114,59,3,55349,56509,97,115,104,59,1,8463,114,111,107,59,1,295,4,2,98,112,10881,10887,117,108,108,59,1,8259,104,101,110,59,1,8208,4,15,97,99,101,102,103,105,106,109,110,111,112,113,115,116,117,10925,10936,10958,10977,10990,11001,11039,11045,11101,11192,11220,11226,11237,11285,11299,99,117,116,101,5,237,1,59,10934,1,237,4,3,59,105,121,10944,10946,10955,1,8291,114,99,5,238,1,59,10953,1,238,59,1,1080,4,2,99,120,10964,10968,121,59,1,1077,99,108,5,161,1,59,10975,1,161,4,2,102,114,10983,10986,59,1,8660,59,3,55349,56614,114,97,118,101,5,236,1,59,10999,1,236,4,4,59,105,110,111,11011,11013,11028,11034,1,8520,4,2,105,110,11019,11024,110,116,59,1,10764,116,59,1,8749,102,105,110,59,1,10716,116,97,59,1,8489,108,105,103,59,1,307,4,3,97,111,112,11053,11092,11096,4,3,99,103,116,11061,11065,11088,114,59,1,299,4,3,101,108,112,11073,11076,11082,59,1,8465,105,110,101,59,1,8464,97,114,116,59,1,8465,104,59,1,305,102,59,1,8887,101,100,59,1,437,4,5,59,99,102,111,116,11113,11115,11121,11136,11142,1,8712,97,114,101,59,1,8453,105,110,4,2,59,116,11129,11131,1,8734,105,101,59,1,10717,100,111,116,59,1,305,4,5,59,99,101,108,112,11154,11156,11161,11179,11186,1,8747,97,108,59,1,8890,4,2,103,114,11167,11173,101,114,115,59,1,8484,99,97,108,59,1,8890,97,114,104,107,59,1,10775,114,111,100,59,1,10812,4,4,99,103,112,116,11202,11206,11211,11216,121,59,1,1105,111,110,59,1,303,102,59,3,55349,56666,97,59,1,953,114,111,100,59,1,10812,117,101,115,116,5,191,1,59,11235,1,191,4,2,99,105,11243,11248,114,59,3,55349,56510,110,4,5,59,69,100,115,118,11261,11263,11266,11271,11282,1,8712,59,1,8953,111,116,59,1,8949,4,2,59,118,11277,11279,1,8948,59,1,8947,59,1,8712,4,2,59,105,11291,11293,1,8290,108,100,101,59,1,297,4,2,107,109,11305,11310,99,121,59,1,1110,108,5,239,1,59,11316,1,239,4,6,99,102,109,111,115,117,11332,11346,11351,11357,11363,11380,4,2,105,121,11338,11343,114,99,59,1,309,59,1,1081,114,59,3,55349,56615,97,116,104,59,1,567,112,102,59,3,55349,56667,4,2,99,101,11369,11374,114,59,3,55349,56511,114,99,121,59,1,1112,107,99,121,59,1,1108,4,8,97,99,102,103,104,106,111,115,11404,11418,11433,11438,11445,11450,11455,11461,112,112,97,4,2,59,118,11413,11415,1,954,59,1,1008,4,2,101,121,11424,11430,100,105,108,59,1,311,59,1,1082,114,59,3,55349,56616,114,101,101,110,59,1,312,99,121,59,1,1093,99,121,59,1,1116,112,102,59,3,55349,56668,99,114,59,3,55349,56512,4,23,65,66,69,72,97,98,99,100,101,102,103,104,106,108,109,110,111,112,114,115,116,117,118,11515,11538,11544,11555,11560,11721,11780,11818,11868,12136,12160,12171,12203,12208,12246,12275,12327,12509,12523,12569,12641,12732,12752,4,3,97,114,116,11523,11528,11532,114,114,59,1,8666,114,59,1,8656,97,105,108,59,1,10523,97,114,114,59,1,10510,4,2,59,103,11550,11552,1,8806,59,1,10891,97,114,59,1,10594,4,9,99,101,103,109,110,112,113,114,116,11580,11586,11594,11600,11606,11624,11627,11636,11694,117,116,101,59,1,314,109,112,116,121,118,59,1,10676,114,97,110,59,1,8466,98,100,97,59,1,955,103,4,3,59,100,108,11615,11617,11620,1,10216,59,1,10641,101,59,1,10216,59,1,10885,117,111,5,171,1,59,11634,1,171,114,4,8,59,98,102,104,108,112,115,116,11655,11657,11669,11673,11677,11681,11685,11690,1,8592,4,2,59,102,11663,11665,1,8676,115,59,1,10527,115,59,1,10525,107,59,1,8617,112,59,1,8619,108,59,1,10553,105,109,59,1,10611,108,59,1,8610,4,3,59,97,101,11702,11704,11709,1,10923,105,108,59,1,10521,4,2,59,115,11715,11717,1,10925,59,3,10925,65024,4,3,97,98,114,11729,11734,11739,114,114,59,1,10508,114,107,59,1,10098,4,2,97,107,11745,11758,99,4,2,101,107,11752,11755,59,1,123,59,1,91,4,2,101,115,11764,11767,59,1,10635,108,4,2,100,117,11774,11777,59,1,10639,59,1,10637,4,4,97,101,117,121,11790,11796,11811,11815,114,111,110,59,1,318,4,2,100,105,11802,11807,105,108,59,1,316,108,59,1,8968,98,59,1,123,59,1,1083,4,4,99,113,114,115,11828,11832,11845,11864,97,59,1,10550,117,111,4,2,59,114,11840,11842,1,8220,59,1,8222,4,2,100,117,11851,11857,104,97,114,59,1,10599,115,104,97,114,59,1,10571,104,59,1,8626,4,5,59,102,103,113,115,11880,11882,12008,12011,12031,1,8804,116,4,5,97,104,108,114,116,11895,11913,11935,11947,11996,114,114,111,119,4,2,59,116,11905,11907,1,8592,97,105,108,59,1,8610,97,114,112,111,111,110,4,2,100,117,11925,11931,111,119,110,59,1,8637,112,59,1,8636,101,102,116,97,114,114,111,119,115,59,1,8647,105,103,104,116,4,3,97,104,115,11959,11974,11984,114,114,111,119,4,2,59,115,11969,11971,1,8596,59,1,8646,97,114,112,111,111,110,115,59,1,8651,113,117,105,103,97,114,114,111,119,59,1,8621,104,114,101,101,116,105,109,101,115,59,1,8907,59,1,8922,4,3,59,113,115,12019,12021,12024,1,8804,59,1,8806,108,97,110,116,59,1,10877,4,5,59,99,100,103,115,12043,12045,12049,12070,12083,1,10877,99,59,1,10920,111,116,4,2,59,111,12057,12059,1,10879,4,2,59,114,12065,12067,1,10881,59,1,10883,4,2,59,101,12076,12079,3,8922,65024,115,59,1,10899,4,5,97,100,101,103,115,12095,12103,12108,12126,12131,112,112,114,111,120,59,1,10885,111,116,59,1,8918,113,4,2,103,113,12115,12120,116,114,59,1,8922,103,116,114,59,1,10891,116,114,59,1,8822,105,109,59,1,8818,4,3,105,108,114,12144,12150,12156,115,104,116,59,1,10620,111,111,114,59,1,8970,59,3,55349,56617,4,2,59,69,12166,12168,1,8822,59,1,10897,4,2,97,98,12177,12198,114,4,2,100,117,12184,12187,59,1,8637,4,2,59,108,12193,12195,1,8636,59,1,10602,108,107,59,1,9604,99,121,59,1,1113,4,5,59,97,99,104,116,12220,12222,12227,12235,12241,1,8810,114,114,59,1,8647,111,114,110,101,114,59,1,8990,97,114,100,59,1,10603,114,105,59,1,9722,4,2,105,111,12252,12258,100,111,116,59,1,320,117,115,116,4,2,59,97,12267,12269,1,9136,99,104,101,59,1,9136,4,4,69,97,101,115,12285,12288,12303,12322,59,1,8808,112,4,2,59,112,12295,12297,1,10889,114,111,120,59,1,10889,4,2,59,113,12309,12311,1,10887,4,2,59,113,12317,12319,1,10887,59,1,8808,105,109,59,1,8934,4,8,97,98,110,111,112,116,119,122,12345,12359,12364,12421,12446,12467,12474,12490,4,2,110,114,12351,12355,103,59,1,10220,114,59,1,8701,114,107,59,1,10214,103,4,3,108,109,114,12373,12401,12409,101,102,116,4,2,97,114,12382,12389,114,114,111,119,59,1,10229,105,103,104,116,97,114,114,111,119,59,1,10231,97,112,115,116,111,59,1,10236,105,103,104,116,97,114,114,111,119,59,1,10230,112,97,114,114,111,119,4,2,108,114,12433,12439,101,102,116,59,1,8619,105,103,104,116,59,1,8620,4,3,97,102,108,12454,12458,12462,114,59,1,10629,59,3,55349,56669,117,115,59,1,10797,105,109,101,115,59,1,10804,4,2,97,98,12480,12485,115,116,59,1,8727,97,114,59,1,95,4,3,59,101,102,12498,12500,12506,1,9674,110,103,101,59,1,9674,59,1,10731,97,114,4,2,59,108,12517,12519,1,40,116,59,1,10643,4,5,97,99,104,109,116,12535,12540,12548,12561,12564,114,114,59,1,8646,111,114,110,101,114,59,1,8991,97,114,4,2,59,100,12556,12558,1,8651,59,1,10605,59,1,8206,114,105,59,1,8895,4,6,97,99,104,105,113,116,12583,12589,12594,12597,12614,12635,113,117,111,59,1,8249,114,59,3,55349,56513,59,1,8624,109,4,3,59,101,103,12606,12608,12611,1,8818,59,1,10893,59,1,10895,4,2,98,117,12620,12623,59,1,91,111,4,2,59,114,12630,12632,1,8216,59,1,8218,114,111,107,59,1,322,5,60,8,59,99,100,104,105,108,113,114,12660,12662,12675,12680,12686,12692,12698,12705,1,60,4,2,99,105,12668,12671,59,1,10918,114,59,1,10873,111,116,59,1,8918,114,101,101,59,1,8907,109,101,115,59,1,8905,97,114,114,59,1,10614,117,101,115,116,59,1,10875,4,2,80,105,12711,12716,97,114,59,1,10646,4,3,59,101,102,12724,12726,12729,1,9667,59,1,8884,59,1,9666,114,4,2,100,117,12739,12746,115,104,97,114,59,1,10570,104,97,114,59,1,10598,4,2,101,110,12758,12768,114,116,110,101,113,113,59,3,8808,65024,69,59,3,8808,65024,4,14,68,97,99,100,101,102,104,105,108,110,111,112,115,117,12803,12809,12893,12908,12914,12928,12933,12937,13011,13025,13032,13049,13052,13069,68,111,116,59,1,8762,4,4,99,108,112,114,12819,12827,12849,12887,114,5,175,1,59,12825,1,175,4,2,101,116,12833,12836,59,1,9794,4,2,59,101,12842,12844,1,10016,115,101,59,1,10016,4,2,59,115,12855,12857,1,8614,116,111,4,4,59,100,108,117,12869,12871,12877,12883,1,8614,111,119,110,59,1,8615,101,102,116,59,1,8612,112,59,1,8613,107,101,114,59,1,9646,4,2,111,121,12899,12905,109,109,97,59,1,10793,59,1,1084,97,115,104,59,1,8212,97,115,117,114,101,100,97,110,103,108,101,59,1,8737,114,59,3,55349,56618,111,59,1,8487,4,3,99,100,110,12945,12954,12985,114,111,5,181,1,59,12952,1,181,4,4,59,97,99,100,12964,12966,12971,12976,1,8739,115,116,59,1,42,105,114,59,1,10992,111,116,5,183,1,59,12983,1,183,117,115,4,3,59,98,100,12995,12997,13000,1,8722,59,1,8863,4,2,59,117,13006,13008,1,8760,59,1,10794,4,2,99,100,13017,13021,112,59,1,10971,114,59,1,8230,112,108,117,115,59,1,8723,4,2,100,112,13038,13044,101,108,115,59,1,8871,102,59,3,55349,56670,59,1,8723,4,2,99,116,13058,13063,114,59,3,55349,56514,112,111,115,59,1,8766,4,3,59,108,109,13077,13079,13087,1,956,116,105,109,97,112,59,1,8888,97,112,59,1,8888,4,24,71,76,82,86,97,98,99,100,101,102,103,104,105,106,108,109,111,112,114,115,116,117,118,119,13142,13165,13217,13229,13247,13330,13359,13414,13420,13508,13513,13579,13602,13626,13631,13762,13767,13855,13936,13995,14214,14285,14312,14432,4,2,103,116,13148,13152,59,3,8921,824,4,2,59,118,13158,13161,3,8811,8402,59,3,8811,824,4,3,101,108,116,13173,13200,13204,102,116,4,2,97,114,13181,13188,114,114,111,119,59,1,8653,105,103,104,116,97,114,114,111,119,59,1,8654,59,3,8920,824,4,2,59,118,13210,13213,3,8810,8402,59,3,8810,824,105,103,104,116,97,114,114,111,119,59,1,8655,4,2,68,100,13235,13241,97,115,104,59,1,8879,97,115,104,59,1,8878,4,5,98,99,110,112,116,13259,13264,13270,13275,13308,108,97,59,1,8711,117,116,101,59,1,324,103,59,3,8736,8402,4,5,59,69,105,111,112,13287,13289,13293,13298,13302,1,8777,59,3,10864,824,100,59,3,8779,824,115,59,1,329,114,111,120,59,1,8777,117,114,4,2,59,97,13316,13318,1,9838,108,4,2,59,115,13325,13327,1,9838,59,1,8469,4,2,115,117,13336,13344,112,5,160,1,59,13342,1,160,109,112,4,2,59,101,13352,13355,3,8782,824,59,3,8783,824,4,5,97,101,111,117,121,13371,13385,13391,13407,13411,4,2,112,114,13377,13380,59,1,10819,111,110,59,1,328,100,105,108,59,1,326,110,103,4,2,59,100,13399,13401,1,8775,111,116,59,3,10861,824,112,59,1,10818,59,1,1085,97,115,104,59,1,8211,4,7,59,65,97,100,113,115,120,13436,13438,13443,13466,13472,13478,13494,1,8800,114,114,59,1,8663,114,4,2,104,114,13450,13454,107,59,1,10532,4,2,59,111,13460,13462,1,8599,119,59,1,8599,111,116,59,3,8784,824,117,105,118,59,1,8802,4,2,101,105,13484,13489,97,114,59,1,10536,109,59,3,8770,824,105,115,116,4,2,59,115,13503,13505,1,8708,59,1,8708,114,59,3,55349,56619,4,4,69,101,115,116,13523,13527,13563,13568,59,3,8807,824,4,3,59,113,115,13535,13537,13559,1,8817,4,3,59,113,115,13545,13547,13551,1,8817,59,3,8807,824,108,97,110,116,59,3,10878,824,59,3,10878,824,105,109,59,1,8821,4,2,59,114,13574,13576,1,8815,59,1,8815,4,3,65,97,112,13587,13592,13597,114,114,59,1,8654,114,114,59,1,8622,97,114,59,1,10994,4,3,59,115,118,13610,13612,13623,1,8715,4,2,59,100,13618,13620,1,8956,59,1,8954,59,1,8715,99,121,59,1,1114,4,7,65,69,97,100,101,115,116,13647,13652,13656,13661,13665,13737,13742,114,114,59,1,8653,59,3,8806,824,114,114,59,1,8602,114,59,1,8229,4,4,59,102,113,115,13675,13677,13703,13725,1,8816,116,4,2,97,114,13684,13691,114,114,111,119,59,1,8602,105,103,104,116,97,114,114,111,119,59,1,8622,4,3,59,113,115,13711,13713,13717,1,8816,59,3,8806,824,108,97,110,116,59,3,10877,824,4,2,59,115,13731,13734,3,10877,824,59,1,8814,105,109,59,1,8820,4,2,59,114,13748,13750,1,8814,105,4,2,59,101,13757,13759,1,8938,59,1,8940,105,100,59,1,8740,4,2,112,116,13773,13778,102,59,3,55349,56671,5,172,3,59,105,110,13787,13789,13829,1,172,110,4,4,59,69,100,118,13800,13802,13806,13812,1,8713,59,3,8953,824,111,116,59,3,8949,824,4,3,97,98,99,13820,13823,13826,59,1,8713,59,1,8951,59,1,8950,105,4,2,59,118,13836,13838,1,8716,4,3,97,98,99,13846,13849,13852,59,1,8716,59,1,8958,59,1,8957,4,3,97,111,114,13863,13892,13899,114,4,4,59,97,115,116,13874,13876,13883,13888,1,8742,108,108,101,108,59,1,8742,108,59,3,11005,8421,59,3,8706,824,108,105,110,116,59,1,10772,4,3,59,99,101,13907,13909,13914,1,8832,117,101,59,1,8928,4,2,59,99,13920,13923,3,10927,824,4,2,59,101,13929,13931,1,8832,113,59,3,10927,824,4,4,65,97,105,116,13946,13951,13971,13982,114,114,59,1,8655,114,114,4,3,59,99,119,13961,13963,13967,1,8603,59,3,10547,824,59,3,8605,824,103,104,116,97,114,114,111,119,59,1,8603,114,105,4,2,59,101,13990,13992,1,8939,59,1,8941,4,7,99,104,105,109,112,113,117,14011,14036,14060,14080,14085,14090,14106,4,4,59,99,101,114,14021,14023,14028,14032,1,8833,117,101,59,1,8929,59,3,10928,824,59,3,55349,56515,111,114,116,4,2,109,112,14045,14050,105,100,59,1,8740,97,114,97,108,108,101,108,59,1,8742,109,4,2,59,101,14067,14069,1,8769,4,2,59,113,14075,14077,1,8772,59,1,8772,105,100,59,1,8740,97,114,59,1,8742,115,117,4,2,98,112,14098,14102,101,59,1,8930,101,59,1,8931,4,3,98,99,112,14114,14157,14171,4,4,59,69,101,115,14124,14126,14130,14133,1,8836,59,3,10949,824,59,1,8840,101,116,4,2,59,101,14141,14144,3,8834,8402,113,4,2,59,113,14151,14153,1,8840,59,3,10949,824,99,4,2,59,101,14164,14166,1,8833,113,59,3,10928,824,4,4,59,69,101,115,14181,14183,14187,14190,1,8837,59,3,10950,824,59,1,8841,101,116,4,2,59,101,14198,14201,3,8835,8402,113,4,2,59,113,14208,14210,1,8841,59,3,10950,824,4,4,103,105,108,114,14224,14228,14238,14242,108,59,1,8825,108,100,101,5,241,1,59,14236,1,241,103,59,1,8824,105,97,110,103,108,101,4,2,108,114,14254,14269,101,102,116,4,2,59,101,14263,14265,1,8938,113,59,1,8940,105,103,104,116,4,2,59,101,14279,14281,1,8939,113,59,1,8941,4,2,59,109,14291,14293,1,957,4,3,59,101,115,14301,14303,14308,1,35,114,111,59,1,8470,112,59,1,8199,4,9,68,72,97,100,103,105,108,114,115,14332,14338,14344,14349,14355,14369,14376,14408,14426,97,115,104,59,1,8877,97,114,114,59,1,10500,112,59,3,8781,8402,97,115,104,59,1,8876,4,2,101,116,14361,14365,59,3,8805,8402,59,3,62,8402,110,102,105,110,59,1,10718,4,3,65,101,116,14384,14389,14393,114,114,59,1,10498,59,3,8804,8402,4,2,59,114,14399,14402,3,60,8402,105,101,59,3,8884,8402,4,2,65,116,14414,14419,114,114,59,1,10499,114,105,101,59,3,8885,8402,105,109,59,3,8764,8402,4,3,65,97,110,14440,14445,14468,114,114,59,1,8662,114,4,2,104,114,14452,14456,107,59,1,10531,4,2,59,111,14462,14464,1,8598,119,59,1,8598,101,97,114,59,1,10535,4,18,83,97,99,100,101,102,103,104,105,108,109,111,112,114,115,116,117,118,14512,14515,14535,14560,14597,14603,14618,14643,14657,14662,14701,14741,14747,14769,14851,14877,14907,14916,59,1,9416,4,2,99,115,14521,14531,117,116,101,5,243,1,59,14529,1,243,116,59,1,8859,4,2,105,121,14541,14557,114,4,2,59,99,14548,14550,1,8858,5,244,1,59,14555,1,244,59,1,1086,4,5,97,98,105,111,115,14572,14577,14583,14587,14591,115,104,59,1,8861,108,97,99,59,1,337,118,59,1,10808,116,59,1,8857,111,108,100,59,1,10684,108,105,103,59,1,339,4,2,99,114,14609,14614,105,114,59,1,10687,59,3,55349,56620,4,3,111,114,116,14626,14630,14640,110,59,1,731,97,118,101,5,242,1,59,14638,1,242,59,1,10689,4,2,98,109,14649,14654,97,114,59,1,10677,59,1,937,110,116,59,1,8750,4,4,97,99,105,116,14672,14677,14693,14698,114,114,59,1,8634,4,2,105,114,14683,14687,114,59,1,10686,111,115,115,59,1,10683,110,101,59,1,8254,59,1,10688,4,3,97,101,105,14709,14714,14719,99,114,59,1,333,103,97,59,1,969,4,3,99,100,110,14727,14733,14736,114,111,110,59,1,959,59,1,10678,117,115,59,1,8854,112,102,59,3,55349,56672,4,3,97,101,108,14755,14759,14764,114,59,1,10679,114,112,59,1,10681,117,115,59,1,8853,4,7,59,97,100,105,111,115,118,14785,14787,14792,14831,14837,14841,14848,1,8744,114,114,59,1,8635,4,4,59,101,102,109,14802,14804,14817,14824,1,10845,114,4,2,59,111,14811,14813,1,8500,102,59,1,8500,5,170,1,59,14822,1,170,5,186,1,59,14829,1,186,103,111,102,59,1,8886,114,59,1,10838,108,111,112,101,59,1,10839,59,1,10843,4,3,99,108,111,14859,14863,14873,114,59,1,8500,97,115,104,5,248,1,59,14871,1,248,108,59,1,8856,105,4,2,108,109,14884,14893,100,101,5,245,1,59,14891,1,245,101,115,4,2,59,97,14901,14903,1,8855,115,59,1,10806,109,108,5,246,1,59,14914,1,246,98,97,114,59,1,9021,4,12,97,99,101,102,104,105,108,109,111,114,115,117,14948,14992,14996,15033,15038,15068,15090,15189,15192,15222,15427,15441,114,4,4,59,97,115,116,14959,14961,14976,14989,1,8741,5,182,2,59,108,14968,14970,1,182,108,101,108,59,1,8741,4,2,105,108,14982,14986,109,59,1,10995,59,1,11005,59,1,8706,121,59,1,1087,114,4,5,99,105,109,112,116,15009,15014,15019,15024,15027,110,116,59,1,37,111,100,59,1,46,105,108,59,1,8240,59,1,8869,101,110,107,59,1,8241,114,59,3,55349,56621,4,3,105,109,111,15046,15057,15063,4,2,59,118,15052,15054,1,966,59,1,981,109,97,116,59,1,8499,110,101,59,1,9742,4,3,59,116,118,15076,15078,15087,1,960,99,104,102,111,114,107,59,1,8916,59,1,982,4,2,97,117,15096,15119,110,4,2,99,107,15103,15115,107,4,2,59,104,15110,15112,1,8463,59,1,8462,118,59,1,8463,115,4,9,59,97,98,99,100,101,109,115,116,15140,15142,15148,15151,15156,15168,15171,15179,15184,1,43,99,105,114,59,1,10787,59,1,8862,105,114,59,1,10786,4,2,111,117,15162,15165,59,1,8724,59,1,10789,59,1,10866,110,5,177,1,59,15177,1,177,105,109,59,1,10790,119,111,59,1,10791,59,1,177,4,3,105,112,117,15200,15208,15213,110,116,105,110,116,59,1,10773,102,59,3,55349,56673,110,100,5,163,1,59,15220,1,163,4,10,59,69,97,99,101,105,110,111,115,117,15244,15246,15249,15253,15258,15334,15347,15367,15416,15421,1,8826,59,1,10931,112,59,1,10935,117,101,59,1,8828,4,2,59,99,15264,15266,1,10927,4,6,59,97,99,101,110,115,15280,15282,15290,15299,15303,15329,1,8826,112,112,114,111,120,59,1,10935,117,114,108,121,101,113,59,1,8828,113,59,1,10927,4,3,97,101,115,15311,15319,15324,112,112,114,111,120,59,1,10937,113,113,59,1,10933,105,109,59,1,8936,105,109,59,1,8830,109,101,4,2,59,115,15342,15344,1,8242,59,1,8473,4,3,69,97,115,15355,15358,15362,59,1,10933,112,59,1,10937,105,109,59,1,8936,4,3,100,102,112,15375,15378,15404,59,1,8719,4,3,97,108,115,15386,15392,15398,108,97,114,59,1,9006,105,110,101,59,1,8978,117,114,102,59,1,8979,4,2,59,116,15410,15412,1,8733,111,59,1,8733,105,109,59,1,8830,114,101,108,59,1,8880,4,2,99,105,15433,15438,114,59,3,55349,56517,59,1,968,110,99,115,112,59,1,8200,4,6,102,105,111,112,115,117,15462,15467,15472,15478,15485,15491,114,59,3,55349,56622,110,116,59,1,10764,112,102,59,3,55349,56674,114,105,109,101,59,1,8279,99,114,59,3,55349,56518,4,3,97,101,111,15499,15520,15534,116,4,2,101,105,15506,15515,114,110,105,111,110,115,59,1,8461,110,116,59,1,10774,115,116,4,2,59,101,15528,15530,1,63,113,59,1,8799,116,5,34,1,59,15540,1,34,4,21,65,66,72,97,98,99,100,101,102,104,105,108,109,110,111,112,114,115,116,117,120,15586,15609,15615,15620,15796,15855,15893,15931,15977,16001,16039,16183,16204,16222,16228,16285,16312,16318,16363,16408,16416,4,3,97,114,116,15594,15599,15603,114,114,59,1,8667,114,59,1,8658,97,105,108,59,1,10524,97,114,114,59,1,10511,97,114,59,1,10596,4,7,99,100,101,110,113,114,116,15636,15651,15656,15664,15687,15696,15770,4,2,101,117,15642,15646,59,3,8765,817,116,101,59,1,341,105,99,59,1,8730,109,112,116,121,118,59,1,10675,103,4,4,59,100,101,108,15675,15677,15680,15683,1,10217,59,1,10642,59,1,10661,101,59,1,10217,117,111,5,187,1,59,15694,1,187,114,4,11,59,97,98,99,102,104,108,112,115,116,119,15721,15723,15727,15739,15742,15746,15750,15754,15758,15763,15767,1,8594,112,59,1,10613,4,2,59,102,15733,15735,1,8677,115,59,1,10528,59,1,10547,115,59,1,10526,107,59,1,8618,112,59,1,8620,108,59,1,10565,105,109,59,1,10612,108,59,1,8611,59,1,8605,4,2,97,105,15776,15781,105,108,59,1,10522,111,4,2,59,110,15788,15790,1,8758,97,108,115,59,1,8474,4,3,97,98,114,15804,15809,15814,114,114,59,1,10509,114,107,59,1,10099,4,2,97,107,15820,15833,99,4,2,101,107,15827,15830,59,1,125,59,1,93,4,2,101,115,15839,15842,59,1,10636,108,4,2,100,117,15849,15852,59,1,10638,59,1,10640,4,4,97,101,117,121,15865,15871,15886,15890,114,111,110,59,1,345,4,2,100,105,15877,15882,105,108,59,1,343,108,59,1,8969,98,59,1,125,59,1,1088,4,4,99,108,113,115,15903,15907,15914,15927,97,59,1,10551,100,104,97,114,59,1,10601,117,111,4,2,59,114,15922,15924,1,8221,59,1,8221,104,59,1,8627,4,3,97,99,103,15939,15966,15970,108,4,4,59,105,112,115,15950,15952,15957,15963,1,8476,110,101,59,1,8475,97,114,116,59,1,8476,59,1,8477,116,59,1,9645,5,174,1,59,15975,1,174,4,3,105,108,114,15985,15991,15997,115,104,116,59,1,10621,111,111,114,59,1,8971,59,3,55349,56623,4,2,97,111,16007,16028,114,4,2,100,117,16014,16017,59,1,8641,4,2,59,108,16023,16025,1,8640,59,1,10604,4,2,59,118,16034,16036,1,961,59,1,1009,4,3,103,110,115,16047,16167,16171,104,116,4,6,97,104,108,114,115,116,16063,16081,16103,16130,16143,16155,114,114,111,119,4,2,59,116,16073,16075,1,8594,97,105,108,59,1,8611,97,114,112,111,111,110,4,2,100,117,16093,16099,111,119,110,59,1,8641,112,59,1,8640,101,102,116,4,2,97,104,16112,16120,114,114,111,119,115,59,1,8644,97,114,112,111,111,110,115,59,1,8652,105,103,104,116,97,114,114,111,119,115,59,1,8649,113,117,105,103,97,114,114,111,119,59,1,8605,104,114,101,101,116,105,109,101,115,59,1,8908,103,59,1,730,105,110,103,100,111,116,115,101,113,59,1,8787,4,3,97,104,109,16191,16196,16201,114,114,59,1,8644,97,114,59,1,8652,59,1,8207,111,117,115,116,4,2,59,97,16214,16216,1,9137,99,104,101,59,1,9137,109,105,100,59,1,10990,4,4,97,98,112,116,16238,16252,16257,16278,4,2,110,114,16244,16248,103,59,1,10221,114,59,1,8702,114,107,59,1,10215,4,3,97,102,108,16265,16269,16273,114,59,1,10630,59,3,55349,56675,117,115,59,1,10798,105,109,101,115,59,1,10805,4,2,97,112,16291,16304,114,4,2,59,103,16298,16300,1,41,116,59,1,10644,111,108,105,110,116,59,1,10770,97,114,114,59,1,8649,4,4,97,99,104,113,16328,16334,16339,16342,113,117,111,59,1,8250,114,59,3,55349,56519,59,1,8625,4,2,98,117,16348,16351,59,1,93,111,4,2,59,114,16358,16360,1,8217,59,1,8217,4,3,104,105,114,16371,16377,16383,114,101,101,59,1,8908,109,101,115,59,1,8906,105,4,4,59,101,102,108,16394,16396,16399,16402,1,9657,59,1,8885,59,1,9656,116,114,105,59,1,10702,108,117,104,97,114,59,1,10600,59,1,8478,4,19,97,98,99,100,101,102,104,105,108,109,111,112,113,114,115,116,117,119,122,16459,16466,16472,16572,16590,16672,16687,16746,16844,16850,16924,16963,16988,17115,17121,17154,17206,17614,17656,99,117,116,101,59,1,347,113,117,111,59,1,8218,4,10,59,69,97,99,101,105,110,112,115,121,16494,16496,16499,16513,16518,16531,16536,16556,16564,16569,1,8827,59,1,10932,4,2,112,114,16505,16508,59,1,10936,111,110,59,1,353,117,101,59,1,8829,4,2,59,100,16524,16526,1,10928,105,108,59,1,351,114,99,59,1,349,4,3,69,97,115,16544,16547,16551,59,1,10934,112,59,1,10938,105,109,59,1,8937,111,108,105,110,116,59,1,10771,105,109,59,1,8831,59,1,1089,111,116,4,3,59,98,101,16582,16584,16587,1,8901,59,1,8865,59,1,10854,4,7,65,97,99,109,115,116,120,16606,16611,16634,16642,16646,16652,16668,114,114,59,1,8664,114,4,2,104,114,16618,16622,107,59,1,10533,4,2,59,111,16628,16630,1,8600,119,59,1,8600,116,5,167,1,59,16640,1,167,105,59,1,59,119,97,114,59,1,10537,109,4,2,105,110,16659,16665,110,117,115,59,1,8726,59,1,8726,116,59,1,10038,114,4,2,59,111,16679,16682,3,55349,56624,119,110,59,1,8994,4,4,97,99,111,121,16697,16702,16716,16739,114,112,59,1,9839,4,2,104,121,16708,16713,99,121,59,1,1097,59,1,1096,114,116,4,2,109,112,16724,16729,105,100,59,1,8739,97,114,97,108,108,101,108,59,1,8741,5,173,1,59,16744,1,173,4,2,103,109,16752,16770,109,97,4,3,59,102,118,16762,16764,16767,1,963,59,1,962,59,1,962,4,8,59,100,101,103,108,110,112,114,16788,16790,16795,16806,16817,16828,16832,16838,1,8764,111,116,59,1,10858,4,2,59,113,16801,16803,1,8771,59,1,8771,4,2,59,69,16812,16814,1,10910,59,1,10912,4,2,59,69,16823,16825,1,10909,59,1,10911,101,59,1,8774,108,117,115,59,1,10788,97,114,114,59,1,10610,97,114,114,59,1,8592,4,4,97,101,105,116,16860,16883,16891,16904,4,2,108,115,16866,16878,108,115,101,116,109,105,110,117,115,59,1,8726,104,112,59,1,10803,112,97,114,115,108,59,1,10724,4,2,100,108,16897,16900,59,1,8739,101,59,1,8995,4,2,59,101,16910,16912,1,10922,4,2,59,115,16918,16920,1,10924,59,3,10924,65024,4,3,102,108,112,16932,16938,16958,116,99,121,59,1,1100,4,2,59,98,16944,16946,1,47,4,2,59,97,16952,16954,1,10692,114,59,1,9023,102,59,3,55349,56676,97,4,2,100,114,16970,16985,101,115,4,2,59,117,16978,16980,1,9824,105,116,59,1,9824,59,1,8741,4,3,99,115,117,16996,17028,17089,4,2,97,117,17002,17015,112,4,2,59,115,17009,17011,1,8851,59,3,8851,65024,112,4,2,59,115,17022,17024,1,8852,59,3,8852,65024,117,4,2,98,112,17035,17062,4,3,59,101,115,17043,17045,17048,1,8847,59,1,8849,101,116,4,2,59,101,17056,17058,1,8847,113,59,1,8849,4,3,59,101,115,17070,17072,17075,1,8848,59,1,8850,101,116,4,2,59,101,17083,17085,1,8848,113,59,1,8850,4,3,59,97,102,17097,17099,17112,1,9633,114,4,2,101,102,17106,17109,59,1,9633,59,1,9642,59,1,9642,97,114,114,59,1,8594,4,4,99,101,109,116,17131,17136,17142,17148,114,59,3,55349,56520,116,109,110,59,1,8726,105,108,101,59,1,8995,97,114,102,59,1,8902,4,2,97,114,17160,17172,114,4,2,59,102,17167,17169,1,9734,59,1,9733,4,2,97,110,17178,17202,105,103,104,116,4,2,101,112,17188,17197,112,115,105,108,111,110,59,1,1013,104,105,59,1,981,115,59,1,175,4,5,98,99,109,110,112,17218,17351,17420,17423,17427,4,9,59,69,100,101,109,110,112,114,115,17238,17240,17243,17248,17261,17267,17279,17285,17291,1,8834,59,1,10949,111,116,59,1,10941,4,2,59,100,17254,17256,1,8838,111,116,59,1,10947,117,108,116,59,1,10945,4,2,69,101,17273,17276,59,1,10955,59,1,8842,108,117,115,59,1,10943,97,114,114,59,1,10617,4,3,101,105,117,17299,17335,17339,116,4,3,59,101,110,17308,17310,17322,1,8834,113,4,2,59,113,17317,17319,1,8838,59,1,10949,101,113,4,2,59,113,17330,17332,1,8842,59,1,10955,109,59,1,10951,4,2,98,112,17345,17348,59,1,10965,59,1,10963,99,4,6,59,97,99,101,110,115,17366,17368,17376,17385,17389,17415,1,8827,112,112,114,111,120,59,1,10936,117,114,108,121,101,113,59,1,8829,113,59,1,10928,4,3,97,101,115,17397,17405,17410,112,112,114,111,120,59,1,10938,113,113,59,1,10934,105,109,59,1,8937,105,109,59,1,8831,59,1,8721,103,59,1,9834,4,13,49,50,51,59,69,100,101,104,108,109,110,112,115,17455,17462,17469,17476,17478,17481,17496,17509,17524,17530,17536,17548,17554,5,185,1,59,17460,1,185,5,178,1,59,17467,1,178,5,179,1,59,17474,1,179,1,8835,59,1,10950,4,2,111,115,17487,17491,116,59,1,10942,117,98,59,1,10968,4,2,59,100,17502,17504,1,8839,111,116,59,1,10948,115,4,2,111,117,17516,17520,108,59,1,10185,98,59,1,10967,97,114,114,59,1,10619,117,108,116,59,1,10946,4,2,69,101,17542,17545,59,1,10956,59,1,8843,108,117,115,59,1,10944,4,3,101,105,117,17562,17598,17602,116,4,3,59,101,110,17571,17573,17585,1,8835,113,4,2,59,113,17580,17582,1,8839,59,1,10950,101,113,4,2,59,113,17593,17595,1,8843,59,1,10956,109,59,1,10952,4,2,98,112,17608,17611,59,1,10964,59,1,10966,4,3,65,97,110,17622,17627,17650,114,114,59,1,8665,114,4,2,104,114,17634,17638,107,59,1,10534,4,2,59,111,17644,17646,1,8601,119,59,1,8601,119,97,114,59,1,10538,108,105,103,5,223,1,59,17664,1,223,4,13,97,98,99,100,101,102,104,105,111,112,114,115,119,17694,17709,17714,17737,17742,17749,17754,17860,17905,17957,17964,18090,18122,4,2,114,117,17700,17706,103,101,116,59,1,8982,59,1,964,114,107,59,1,9140,4,3,97,101,121,17722,17728,17734,114,111,110,59,1,357,100,105,108,59,1,355,59,1,1090,111,116,59,1,8411,108,114,101,99,59,1,8981,114,59,3,55349,56625,4,4,101,105,107,111,17764,17805,17836,17851,4,2,114,116,17770,17786,101,4,2,52,102,17777,17780,59,1,8756,111,114,101,59,1,8756,97,4,3,59,115,118,17795,17797,17802,1,952,121,109,59,1,977,59,1,977,4,2,99,110,17811,17831,107,4,2,97,115,17818,17826,112,112,114,111,120,59,1,8776,105,109,59,1,8764,115,112,59,1,8201,4,2,97,115,17842,17846,112,59,1,8776,105,109,59,1,8764,114,110,5,254,1,59,17858,1,254,4,3,108,109,110,17868,17873,17901,100,101,59,1,732,101,115,5,215,3,59,98,100,17884,17886,17898,1,215,4,2,59,97,17892,17894,1,8864,114,59,1,10801,59,1,10800,116,59,1,8749,4,3,101,112,115,17913,17917,17953,97,59,1,10536,4,4,59,98,99,102,17927,17929,17934,17939,1,8868,111,116,59,1,9014,105,114,59,1,10993,4,2,59,111,17945,17948,3,55349,56677,114,107,59,1,10970,97,59,1,10537,114,105,109,101,59,1,8244,4,3,97,105,112,17972,17977,18082,100,101,59,1,8482,4,7,97,100,101,109,112,115,116,17993,18051,18056,18059,18066,18072,18076,110,103,108,101,4,5,59,100,108,113,114,18009,18011,18017,18032,18035,1,9653,111,119,110,59,1,9663,101,102,116,4,2,59,101,18026,18028,1,9667,113,59,1,8884,59,1,8796,105,103,104,116,4,2,59,101,18045,18047,1,9657,113,59,1,8885,111,116,59,1,9708,59,1,8796,105,110,117,115,59,1,10810,108,117,115,59,1,10809,98,59,1,10701,105,109,101,59,1,10811,101,122,105,117,109,59,1,9186,4,3,99,104,116,18098,18111,18116,4,2,114,121,18104,18108,59,3,55349,56521,59,1,1094,99,121,59,1,1115,114,111,107,59,1,359,4,2,105,111,18128,18133,120,116,59,1,8812,104,101,97,100,4,2,108,114,18143,18154,101,102,116,97,114,114,111,119,59,1,8606,105,103,104,116,97,114,114,111,119,59,1,8608,4,18,65,72,97,98,99,100,102,103,104,108,109,111,112,114,115,116,117,119,18204,18209,18214,18234,18250,18268,18292,18308,18319,18343,18379,18397,18413,18504,18547,18553,18584,18603,114,114,59,1,8657,97,114,59,1,10595,4,2,99,114,18220,18230,117,116,101,5,250,1,59,18228,1,250,114,59,1,8593,114,4,2,99,101,18241,18245,121,59,1,1118,118,101,59,1,365,4,2,105,121,18256,18265,114,99,5,251,1,59,18263,1,251,59,1,1091,4,3,97,98,104,18276,18281,18287,114,114,59,1,8645,108,97,99,59,1,369,97,114,59,1,10606,4,2,105,114,18298,18304,115,104,116,59,1,10622,59,3,55349,56626,114,97,118,101,5,249,1,59,18317,1,249,4,2,97,98,18325,18338,114,4,2,108,114,18332,18335,59,1,8639,59,1,8638,108,107,59,1,9600,4,2,99,116,18349,18374,4,2,111,114,18355,18369,114,110,4,2,59,101,18363,18365,1,8988,114,59,1,8988,111,112,59,1,8975,114,105,59,1,9720,4,2,97,108,18385,18390,99,114,59,1,363,5,168,1,59,18395,1,168,4,2,103,112,18403,18408,111,110,59,1,371,102,59,3,55349,56678,4,6,97,100,104,108,115,117,18427,18434,18445,18470,18475,18494,114,114,111,119,59,1,8593,111,119,110,97,114,114,111,119,59,1,8597,97,114,112,111,111,110,4,2,108,114,18457,18463,101,102,116,59,1,8639,105,103,104,116,59,1,8638,117,115,59,1,8846,105,4,3,59,104,108,18484,18486,18489,1,965,59,1,978,111,110,59,1,965,112,97,114,114,111,119,115,59,1,8648,4,3,99,105,116,18512,18537,18542,4,2,111,114,18518,18532,114,110,4,2,59,101,18526,18528,1,8989,114,59,1,8989,111,112,59,1,8974,110,103,59,1,367,114,105,59,1,9721,99,114,59,3,55349,56522,4,3,100,105,114,18561,18566,18572,111,116,59,1,8944,108,100,101,59,1,361,105,4,2,59,102,18579,18581,1,9653,59,1,9652,4,2,97,109,18590,18595,114,114,59,1,8648,108,5,252,1,59,18601,1,252,97,110,103,108,101,59,1,10663,4,15,65,66,68,97,99,100,101,102,108,110,111,112,114,115,122,18643,18648,18661,18667,18847,18851,18857,18904,18909,18915,18931,18937,18943,18949,18996,114,114,59,1,8661,97,114,4,2,59,118,18656,18658,1,10984,59,1,10985,97,115,104,59,1,8872,4,2,110,114,18673,18679,103,114,116,59,1,10652,4,7,101,107,110,112,114,115,116,18695,18704,18711,18720,18742,18754,18810,112,115,105,108,111,110,59,1,1013,97,112,112,97,59,1,1008,111,116,104,105,110,103,59,1,8709,4,3,104,105,114,18728,18732,18735,105,59,1,981,59,1,982,111,112,116,111,59,1,8733,4,2,59,104,18748,18750,1,8597,111,59,1,1009,4,2,105,117,18760,18766,103,109,97,59,1,962,4,2,98,112,18772,18791,115,101,116,110,101,113,4,2,59,113,18784,18787,3,8842,65024,59,3,10955,65024,115,101,116,110,101,113,4,2,59,113,18803,18806,3,8843,65024,59,3,10956,65024,4,2,104,114,18816,18822,101,116,97,59,1,977,105,97,110,103,108,101,4,2,108,114,18834,18840,101,102,116,59,1,8882,105,103,104,116,59,1,8883,121,59,1,1074,97,115,104,59,1,8866,4,3,101,108,114,18865,18884,18890,4,3,59,98,101,18873,18875,18880,1,8744,97,114,59,1,8891,113,59,1,8794,108,105,112,59,1,8942,4,2,98,116,18896,18901,97,114,59,1,124,59,1,124,114,59,3,55349,56627,116,114,105,59,1,8882,115,117,4,2,98,112,18923,18927,59,3,8834,8402,59,3,8835,8402,112,102,59,3,55349,56679,114,111,112,59,1,8733,116,114,105,59,1,8883,4,2,99,117,18955,18960,114,59,3,55349,56523,4,2,98,112,18966,18981,110,4,2,69,101,18973,18977,59,3,10955,65024,59,3,8842,65024,110,4,2,69,101,18988,18992,59,3,10956,65024,59,3,8843,65024,105,103,122,97,103,59,1,10650,4,7,99,101,102,111,112,114,115,19020,19026,19061,19066,19072,19075,19089,105,114,99,59,1,373,4,2,100,105,19032,19055,4,2,98,103,19038,19043,97,114,59,1,10847,101,4,2,59,113,19050,19052,1,8743,59,1,8793,101,114,112,59,1,8472,114,59,3,55349,56628,112,102,59,3,55349,56680,59,1,8472,4,2,59,101,19081,19083,1,8768,97,116,104,59,1,8768,99,114,59,3,55349,56524,4,14,99,100,102,104,105,108,109,110,111,114,115,117,118,119,19125,19146,19152,19157,19173,19176,19192,19197,19202,19236,19252,19269,19286,19291,4,3,97,105,117,19133,19137,19142,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,116,114,105,59,1,9661,114,59,3,55349,56629,4,2,65,97,19163,19168,114,114,59,1,10234,114,114,59,1,10231,59,1,958,4,2,65,97,19182,19187,114,114,59,1,10232,114,114,59,1,10229,97,112,59,1,10236,105,115,59,1,8955,4,3,100,112,116,19210,19215,19230,111,116,59,1,10752,4,2,102,108,19221,19225,59,3,55349,56681,117,115,59,1,10753,105,109,101,59,1,10754,4,2,65,97,19242,19247,114,114,59,1,10233,114,114,59,1,10230,4,2,99,113,19258,19263,114,59,3,55349,56525,99,117,112,59,1,10758,4,2,112,116,19275,19281,108,117,115,59,1,10756,114,105,59,1,9651,101,101,59,1,8897,101,100,103,101,59,1,8896,4,8,97,99,101,102,105,111,115,117,19316,19335,19349,19357,19362,19367,19373,19379,99,4,2,117,121,19323,19332,116,101,5,253,1,59,19330,1,253,59,1,1103,4,2,105,121,19341,19346,114,99,59,1,375,59,1,1099,110,5,165,1,59,19355,1,165,114,59,3,55349,56630,99,121,59,1,1111,112,102,59,3,55349,56682,99,114,59,3,55349,56526,4,2,99,109,19385,19389,121,59,1,1102,108,5,255,1,59,19395,1,255,4,10,97,99,100,101,102,104,105,111,115,119,19419,19426,19441,19446,19462,19467,19472,19480,19486,19492,99,117,116,101,59,1,378,4,2,97,121,19432,19438,114,111,110,59,1,382,59,1,1079,111,116,59,1,380,4,2,101,116,19452,19458,116,114,102,59,1,8488,97,59,1,950,114,59,3,55349,56631,99,121,59,1,1078,103,114,97,114,114,59,1,8669,112,102,59,3,55349,56683,99,114,59,3,55349,56527,4,2,106,110,19498,19501,59,1,8205,106,59,1,8204]);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HTML = __webpack_require__(43);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;

//Element utils

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function isImpliedEndTagRequired(tn) {
    switch (tn.length) {
        case 1:
            return tn === $.P;

        case 2:
            return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI;

        case 3:
            return tn === $.RTC;

        case 6:
            return tn === $.OPTION;

        case 8:
            return tn === $.OPTGROUP || tn === $.MENUITEM;
    }

    return false;
}

function isScopingElement(tn, ns) {
    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH)
                return ns === NS.HTML;

            else if (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS)
                return ns === NS.MATHML;

            break;

        case 4:
            if (tn === $.HTML)
                return ns === NS.HTML;

            else if (tn === $.DESC)
                return ns === NS.SVG;

            break;

        case 5:
            if (tn === $.TABLE)
                return ns === NS.HTML;

            else if (tn === $.MTEXT)
                return ns === NS.MATHML;

            else if (tn === $.TITLE)
                return ns === NS.SVG;

            break;

        case 6:
            return (tn === $.APPLET || tn === $.OBJECT) && ns === NS.HTML;

        case 7:
            return (tn === $.CAPTION || tn === $.MARQUEE) && ns === NS.HTML;

        case 8:
            return tn === $.TEMPLATE && ns === NS.HTML;

        case 13:
            return tn === $.FOREIGN_OBJECT && ns === NS.SVG;

        case 14:
            return tn === $.ANNOTATION_XML && ns === NS.MATHML;
    }

    return false;
}

//Stack of open elements
var OpenElementStack = module.exports = function (document, treeAdapter) {
    this.stackTop = -1;
    this.items = [];
    this.current = document;
    this.currentTagName = null;
    this.currentTmplContent = null;
    this.tmplCount = 0;
    this.treeAdapter = treeAdapter;
};

//Index of element
OpenElementStack.prototype._indexOf = function (element) {
    var idx = -1;

    for (var i = this.stackTop; i >= 0; i--) {
        if (this.items[i] === element) {
            idx = i;
            break;
        }
    }
    return idx;
};

//Update current element
OpenElementStack.prototype._isInTemplate = function () {
    return this.currentTagName === $.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
};

OpenElementStack.prototype._updateCurrentElement = function () {
    this.current = this.items[this.stackTop];
    this.currentTagName = this.current && this.treeAdapter.getTagName(this.current);

    this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
};

//Mutations
OpenElementStack.prototype.push = function (element) {
    this.items[++this.stackTop] = element;
    this._updateCurrentElement();

    if (this._isInTemplate())
        this.tmplCount++;

};

OpenElementStack.prototype.pop = function () {
    this.stackTop--;

    if (this.tmplCount > 0 && this._isInTemplate())
        this.tmplCount--;

    this._updateCurrentElement();
};

OpenElementStack.prototype.replace = function (oldElement, newElement) {
    var idx = this._indexOf(oldElement);

    this.items[idx] = newElement;

    if (idx === this.stackTop)
        this._updateCurrentElement();
};

OpenElementStack.prototype.insertAfter = function (referenceElement, newElement) {
    var insertionIdx = this._indexOf(referenceElement) + 1;

    this.items.splice(insertionIdx, 0, newElement);

    if (insertionIdx === ++this.stackTop)
        this._updateCurrentElement();
};

OpenElementStack.prototype.popUntilTagNamePopped = function (tagName) {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === tagName && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popUntilElementPopped = function (element) {
    while (this.stackTop > -1) {
        var poppedElement = this.current;

        this.pop();

        if (poppedElement === element)
            break;
    }
};

OpenElementStack.prototype.popUntilNumberedHeaderPopped = function () {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6 && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popUntilTableCellPopped = function () {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === $.TD || tn === $.TH && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popAllUpToHtmlElement = function () {
    //NOTE: here we assume that root <html> element is always first in the open element stack, so
    //we perform this fast stack clean up.
    this.stackTop = 0;
    this._updateCurrentElement();
};

OpenElementStack.prototype.clearBackToTableContext = function () {
    while (this.currentTagName !== $.TABLE &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.clearBackToTableBodyContext = function () {
    while (this.currentTagName !== $.TBODY &&
           this.currentTagName !== $.TFOOT &&
           this.currentTagName !== $.THEAD &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.clearBackToTableRowContext = function () {
    while (this.currentTagName !== $.TR &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.remove = function (element) {
    for (var i = this.stackTop; i >= 0; i--) {
        if (this.items[i] === element) {
            this.items.splice(i, 1);
            this.stackTop--;
            this._updateCurrentElement();
            break;
        }
    }
};

//Search
OpenElementStack.prototype.tryPeekProperlyNestedBodyElement = function () {
    //Properly nested <body> element (should be second element in stack).
    var element = this.items[1];

    return element && this.treeAdapter.getTagName(element) === $.BODY ? element : null;
};

OpenElementStack.prototype.contains = function (element) {
    return this._indexOf(element) > -1;
};

OpenElementStack.prototype.getCommonAncestor = function (element) {
    var elementIdx = this._indexOf(element);

    return --elementIdx >= 0 ? this.items[elementIdx] : null;
};

OpenElementStack.prototype.isRootHtmlElementCurrent = function () {
    return this.stackTop === 0 && this.currentTagName === $.HTML;
};

//Element in scope
OpenElementStack.prototype.hasInScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if (isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasNumberedHeaderInScope = function () {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if ((tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) && ns === NS.HTML)
            return true;

        if (isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInListItemScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if ((tn === $.UL || tn === $.OL) && ns === NS.HTML || isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInButtonScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if (tn === $.BUTTON && ns === NS.HTML || isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInTableScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === tagName)
            return true;

        if (tn === $.TABLE || tn === $.TEMPLATE || tn === $.HTML)
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasTableBodyContextInTableScope = function () {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === $.TBODY || tn === $.THEAD || tn === $.TFOOT)
            return true;

        if (tn === $.TABLE || tn === $.HTML)
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInSelectScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === tagName)
            return true;

        if (tn !== $.OPTION && tn !== $.OPTGROUP)
            return false;
    }

    return true;
};

//Implied end tags
OpenElementStack.prototype.generateImpliedEndTags = function () {
    while (isImpliedEndTagRequired(this.currentTagName))
        this.pop();
};

OpenElementStack.prototype.generateImpliedEndTagsWithExclusion = function (exclusionTagName) {
    while (isImpliedEndTagRequired(this.currentTagName) && this.currentTagName !== exclusionTagName)
        this.pop();
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Const
var NOAH_ARK_CAPACITY = 3;

//List of formatting elements
var FormattingElementList = module.exports = function (treeAdapter) {
    this.length = 0;
    this.entries = [];
    this.treeAdapter = treeAdapter;
    this.bookmark = null;
};

//Entry types
FormattingElementList.MARKER_ENTRY = 'MARKER_ENTRY';
FormattingElementList.ELEMENT_ENTRY = 'ELEMENT_ENTRY';

//Noah Ark's condition
//OPTIMIZATION: at first we try to find possible candidates for exclusion using
//lightweight heuristics without thorough attributes check.
FormattingElementList.prototype._getNoahArkConditionCandidates = function (newElement) {
    var candidates = [];

    if (this.length >= NOAH_ARK_CAPACITY) {
        var neAttrsLength = this.treeAdapter.getAttrList(newElement).length,
            neTagName = this.treeAdapter.getTagName(newElement),
            neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);

        for (var i = this.length - 1; i >= 0; i--) {
            var entry = this.entries[i];

            if (entry.type === FormattingElementList.MARKER_ENTRY)
                break;

            var element = entry.element,
                elementAttrs = this.treeAdapter.getAttrList(element),
                isCandidate = this.treeAdapter.getTagName(element) === neTagName &&
                              this.treeAdapter.getNamespaceURI(element) === neNamespaceURI &&
                              elementAttrs.length === neAttrsLength;

            if (isCandidate)
                candidates.push({idx: i, attrs: elementAttrs});
        }
    }

    return candidates.length < NOAH_ARK_CAPACITY ? [] : candidates;
};

FormattingElementList.prototype._ensureNoahArkCondition = function (newElement) {
    var candidates = this._getNoahArkConditionCandidates(newElement),
        cLength = candidates.length;

    if (cLength) {
        var neAttrs = this.treeAdapter.getAttrList(newElement),
            neAttrsLength = neAttrs.length,
            neAttrsMap = Object.create(null);

        //NOTE: build attrs map for the new element so we can perform fast lookups
        for (var i = 0; i < neAttrsLength; i++) {
            var neAttr = neAttrs[i];

            neAttrsMap[neAttr.name] = neAttr.value;
        }

        for (i = 0; i < neAttrsLength; i++) {
            for (var j = 0; j < cLength; j++) {
                var cAttr = candidates[j].attrs[i];

                if (neAttrsMap[cAttr.name] !== cAttr.value) {
                    candidates.splice(j, 1);
                    cLength--;
                }

                if (candidates.length < NOAH_ARK_CAPACITY)
                    return;
            }
        }

        //NOTE: remove bottommost candidates until Noah's Ark condition will not be met
        for (i = cLength - 1; i >= NOAH_ARK_CAPACITY - 1; i--) {
            this.entries.splice(candidates[i].idx, 1);
            this.length--;
        }
    }
};

//Mutations
FormattingElementList.prototype.insertMarker = function () {
    this.entries.push({type: FormattingElementList.MARKER_ENTRY});
    this.length++;
};

FormattingElementList.prototype.pushElement = function (element, token) {
    this._ensureNoahArkCondition(element);

    this.entries.push({
        type: FormattingElementList.ELEMENT_ENTRY,
        element: element,
        token: token
    });

    this.length++;
};

FormattingElementList.prototype.insertElementAfterBookmark = function (element, token) {
    var bookmarkIdx = this.length - 1;

    for (; bookmarkIdx >= 0; bookmarkIdx--) {
        if (this.entries[bookmarkIdx] === this.bookmark)
            break;
    }

    this.entries.splice(bookmarkIdx + 1, 0, {
        type: FormattingElementList.ELEMENT_ENTRY,
        element: element,
        token: token
    });

    this.length++;
};

FormattingElementList.prototype.removeEntry = function (entry) {
    for (var i = this.length - 1; i >= 0; i--) {
        if (this.entries[i] === entry) {
            this.entries.splice(i, 1);
            this.length--;
            break;
        }
    }
};

FormattingElementList.prototype.clearToLastMarker = function () {
    while (this.length) {
        var entry = this.entries.pop();

        this.length--;

        if (entry.type === FormattingElementList.MARKER_ENTRY)
            break;
    }
};

//Search
FormattingElementList.prototype.getElementEntryInScopeWithTagName = function (tagName) {
    for (var i = this.length - 1; i >= 0; i--) {
        var entry = this.entries[i];

        if (entry.type === FormattingElementList.MARKER_ENTRY)
            return null;

        if (this.treeAdapter.getTagName(entry.element) === tagName)
            return entry;
    }

    return null;
};

FormattingElementList.prototype.getElementEntry = function (element) {
    for (var i = this.length - 1; i >= 0; i--) {
        var entry = this.entries[i];

        if (entry.type === FormattingElementList.ELEMENT_ENTRY && entry.element === element)
            return entry;
    }

    return null;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(104),
    Tokenizer = __webpack_require__(73),
    LocationInfoTokenizerMixin = __webpack_require__(170),
    PositionTrackingPreprocessorMixin = __webpack_require__(171),
    LocationInfoOpenElementStackMixin = __webpack_require__(246),
    HTML = __webpack_require__(43),
    inherits = __webpack_require__(50).inherits;


//Aliases
var $ = HTML.TAG_NAMES;

var LocationInfoParserMixin = module.exports = function (parser) {
    Mixin.call(this, parser);

    this.parser = parser;
    this.posTracker = null;
    this.lastStartTagToken = null;
    this.lastFosterParentingLocation = null;
    this.currentToken = null;
};

inherits(LocationInfoParserMixin, Mixin);


LocationInfoParserMixin.prototype._setStartLocation = function (element) {
    if (this.lastStartTagToken) {
        element.__location = Object.create(this.lastStartTagToken.location);
        element.__location.startTag = this.lastStartTagToken.location;
    }
    else
        element.__location = null;
};

LocationInfoParserMixin.prototype._setEndLocation = function (element, closingToken) {
    var loc = element.__location;

    if (loc) {
        if (closingToken.location) {
            var ctLoc = closingToken.location,
                tn = this.parser.treeAdapter.getTagName(element);

            // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
            // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
            var isClosingEndTag = closingToken.type === Tokenizer.END_TAG_TOKEN && tn === closingToken.tagName;

            if (isClosingEndTag) {
                loc.endTag = Object.create(ctLoc);
                loc.endOffset = ctLoc.endOffset;
            }

            else
                loc.endOffset = ctLoc.startOffset;
        }

        else if (closingToken.type === Tokenizer.EOF_TOKEN)
            loc.endOffset = this.posTracker.offset;
    }
};

LocationInfoParserMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        _bootstrap: function (document, fragmentContext) {
            orig._bootstrap.call(this, document, fragmentContext);

            mxn.lastStartTagToken = null;
            mxn.lastFosterParentingLocation = null;
            mxn.currentToken = null;
            mxn.posTracker = new PositionTrackingPreprocessorMixin(this.tokenizer.preprocessor);

            new LocationInfoTokenizerMixin(this.tokenizer);

            new LocationInfoOpenElementStackMixin(this.openElements, {
                onItemPop: function (element) {
                    mxn._setEndLocation(element, mxn.currentToken);
                }
            });
        },

        _runParsingLoop: function (scriptHandler) {
            orig._runParsingLoop.call(this, scriptHandler);

            // NOTE: generate location info for elements
            // that remains on open element stack
            for (var i = this.openElements.stackTop; i >= 0; i--)
                mxn._setEndLocation(this.openElements.items[i], mxn.currentToken);
        },


        //Token processing
        _processTokenInForeignContent: function (token) {
            mxn.currentToken = token;
            orig._processTokenInForeignContent.call(this, token);
        },

        _processToken: function (token) {
            mxn.currentToken = token;
            orig._processToken.call(this, token);

            //NOTE: <body> and <html> are never popped from the stack, so we need to updated
            //their end location explicitly.
            var requireExplicitUpdate = token.type === Tokenizer.END_TAG_TOKEN &&
                                        (token.tagName === $.HTML ||
                                         token.tagName === $.BODY && this.openElements.hasInScope($.BODY));

            if (requireExplicitUpdate) {
                for (var i = this.openElements.stackTop; i >= 0; i--) {
                    var element = this.openElements.items[i];

                    if (this.treeAdapter.getTagName(element) === token.tagName) {
                        mxn._setEndLocation(element, token);
                        break;
                    }
                }
            }
        },


        //Doctype
        _setDocumentType: function (token) {
            orig._setDocumentType.call(this, token);

            var documentChildren = this.treeAdapter.getChildNodes(this.document),
                cnLength = documentChildren.length;

            for (var i = 0; i < cnLength; i++) {
                var node = documentChildren[i];

                if (this.treeAdapter.isDocumentTypeNode(node)) {
                    node.__location = token.location;
                    break;
                }
            }
        },


        //Elements
        _attachElementToTree: function (element) {
            //NOTE: _attachElementToTree is called from _appendElement, _insertElement and _insertTemplate methods.
            //So we will use token location stored in this methods for the element.
            mxn._setStartLocation(element);
            mxn.lastStartTagToken = null;
            orig._attachElementToTree.call(this, element);
        },

        _appendElement: function (token, namespaceURI) {
            mxn.lastStartTagToken = token;
            orig._appendElement.call(this, token, namespaceURI);
        },

        _insertElement: function (token, namespaceURI) {
            mxn.lastStartTagToken = token;
            orig._insertElement.call(this, token, namespaceURI);
        },

        _insertTemplate: function (token) {
            mxn.lastStartTagToken = token;
            orig._insertTemplate.call(this, token);

            var tmplContent = this.treeAdapter.getTemplateContent(this.openElements.current);

            tmplContent.__location = null;
        },

        _insertFakeRootElement: function () {
            orig._insertFakeRootElement.call(this);
            this.openElements.current.__location = null;
        },

        //Comments
        _appendCommentNode: function (token, parent) {
            orig._appendCommentNode.call(this, token, parent);

            var children = this.treeAdapter.getChildNodes(parent),
                commentNode = children[children.length - 1];

            commentNode.__location = token.location;
        },

        //Text
        _findFosterParentingLocation: function () {
            //NOTE: store last foster parenting location, so we will be able to find inserted text
            //in case of foster parenting
            mxn.lastFosterParentingLocation = orig._findFosterParentingLocation.call(this);

            return mxn.lastFosterParentingLocation;
        },

        _insertCharacters: function (token) {
            orig._insertCharacters.call(this, token);

            var hasFosterParent = this._shouldFosterParentOnInsertion(),
                parent = hasFosterParent && mxn.lastFosterParentingLocation.parent ||
                         this.openElements.currentTmplContent ||
                         this.openElements.current,
                siblings = this.treeAdapter.getChildNodes(parent),
                textNodeIdx = hasFosterParent && mxn.lastFosterParentingLocation.beforeElement ?
                siblings.indexOf(mxn.lastFosterParentingLocation.beforeElement) - 1 :
                siblings.length - 1,
                textNode = siblings[textNodeIdx];

            //NOTE: if we have location assigned by another token, then just update end position
            if (textNode.__location)
                textNode.__location.endOffset = token.location.endOffset;

            else
                textNode.__location = token.location;
        }
    };
};



/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(104),
    inherits = __webpack_require__(50).inherits;

var LocationInfoOpenElementStackMixin = module.exports = function (stack, options) {
    Mixin.call(this, stack);

    this.onItemPop = options.onItemPop;
};

inherits(LocationInfoOpenElementStackMixin, Mixin);

LocationInfoOpenElementStackMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        pop: function () {
            mxn.onItemPop(this.current);
            orig.pop.call(this);
        },

        popAllUpToHtmlElement: function () {
            for (var i = this.stackTop; i > 0; i--)
                mxn.onItemPop(this.items[i]);

            orig.popAllUpToHtmlElement.call(this);
        },

        remove: function (element) {
            mxn.onItemPop(this.current);
            orig.remove.call(this, element);
        }
    };
};



/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var doctype = __webpack_require__(132),
    DOCUMENT_MODE = __webpack_require__(43).DOCUMENT_MODE;


//Conversion tables for DOM Level1 structure emulation
var nodeTypes = {
    element: 1,
    text: 3,
    cdata: 4,
    comment: 8
};

var nodePropertyShorthands = {
    tagName: 'name',
    childNodes: 'children',
    parentNode: 'parent',
    previousSibling: 'prev',
    nextSibling: 'next',
    nodeValue: 'data'
};

//Node
var Node = function (props) {
    for (var key in props) {
        if (props.hasOwnProperty(key))
            this[key] = props[key];
    }
};

Node.prototype = {
    get firstChild() {
        var children = this.children;

        return children && children[0] || null;
    },

    get lastChild() {
        var children = this.children;

        return children && children[children.length - 1] || null;
    },

    get nodeType() {
        return nodeTypes[this.type] || nodeTypes.element;
    }
};

Object.keys(nodePropertyShorthands).forEach(function (key) {
    var shorthand = nodePropertyShorthands[key];

    Object.defineProperty(Node.prototype, key, {
        get: function () {
            return this[shorthand] || null;
        },
        set: function (val) {
            this[shorthand] = val;
            return val;
        }
    });
});


//Node construction
exports.createDocument = function () {
    return new Node({
        type: 'root',
        name: 'root',
        parent: null,
        prev: null,
        next: null,
        children: [],
        'x-mode': DOCUMENT_MODE.NO_QUIRKS
    });
};

exports.createDocumentFragment = function () {
    return new Node({
        type: 'root',
        name: 'root',
        parent: null,
        prev: null,
        next: null,
        children: []
    });
};

exports.createElement = function (tagName, namespaceURI, attrs) {
    var attribs = Object.create(null),
        attribsNamespace = Object.create(null),
        attribsPrefix = Object.create(null);

    for (var i = 0; i < attrs.length; i++) {
        var attrName = attrs[i].name;

        attribs[attrName] = attrs[i].value;
        attribsNamespace[attrName] = attrs[i].namespace;
        attribsPrefix[attrName] = attrs[i].prefix;
    }

    return new Node({
        type: tagName === 'script' || tagName === 'style' ? tagName : 'tag',
        name: tagName,
        namespace: namespaceURI,
        attribs: attribs,
        'x-attribsNamespace': attribsNamespace,
        'x-attribsPrefix': attribsPrefix,
        children: [],
        parent: null,
        prev: null,
        next: null
    });
};

exports.createCommentNode = function (data) {
    return new Node({
        type: 'comment',
        data: data,
        parent: null,
        prev: null,
        next: null
    });
};

var createTextNode = function (value) {
    return new Node({
        type: 'text',
        data: value,
        parent: null,
        prev: null,
        next: null
    });
};


//Tree mutation
var appendChild = exports.appendChild = function (parentNode, newNode) {
    var prev = parentNode.children[parentNode.children.length - 1];

    if (prev) {
        prev.next = newNode;
        newNode.prev = prev;
    }

    parentNode.children.push(newNode);
    newNode.parent = parentNode;
};

var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
    var insertionIdx = parentNode.children.indexOf(referenceNode),
        prev = referenceNode.prev;

    if (prev) {
        prev.next = newNode;
        newNode.prev = prev;
    }

    referenceNode.prev = newNode;
    newNode.next = referenceNode;

    parentNode.children.splice(insertionIdx, 0, newNode);
    newNode.parent = parentNode;
};

exports.setTemplateContent = function (templateElement, contentElement) {
    appendChild(templateElement, contentElement);
};

exports.getTemplateContent = function (templateElement) {
    return templateElement.children[0];
};

exports.setDocumentType = function (document, name, publicId, systemId) {
    var data = doctype.serializeContent(name, publicId, systemId),
        doctypeNode = null;

    for (var i = 0; i < document.children.length; i++) {
        if (document.children[i].type === 'directive' && document.children[i].name === '!doctype') {
            doctypeNode = document.children[i];
            break;
        }
    }

    if (doctypeNode) {
        doctypeNode.data = data;
        doctypeNode['x-name'] = name;
        doctypeNode['x-publicId'] = publicId;
        doctypeNode['x-systemId'] = systemId;
    }

    else {
        appendChild(document, new Node({
            type: 'directive',
            name: '!doctype',
            data: data,
            'x-name': name,
            'x-publicId': publicId,
            'x-systemId': systemId
        }));
    }

};

exports.setDocumentMode = function (document, mode) {
    document['x-mode'] = mode;
};

exports.getDocumentMode = function (document) {
    return document['x-mode'];
};

exports.detachNode = function (node) {
    if (node.parent) {
        var idx = node.parent.children.indexOf(node),
            prev = node.prev,
            next = node.next;

        node.prev = null;
        node.next = null;

        if (prev)
            prev.next = next;

        if (next)
            next.prev = prev;

        node.parent.children.splice(idx, 1);
        node.parent = null;
    }
};

exports.insertText = function (parentNode, text) {
    var lastChild = parentNode.children[parentNode.children.length - 1];

    if (lastChild && lastChild.type === 'text')
        lastChild.data += text;
    else
        appendChild(parentNode, createTextNode(text));
};

exports.insertTextBefore = function (parentNode, text, referenceNode) {
    var prevNode = parentNode.children[parentNode.children.indexOf(referenceNode) - 1];

    if (prevNode && prevNode.type === 'text')
        prevNode.data += text;
    else
        insertBefore(parentNode, createTextNode(text), referenceNode);
};

exports.adoptAttributes = function (recipient, attrs) {
    for (var i = 0; i < attrs.length; i++) {
        var attrName = attrs[i].name;

        if (typeof recipient.attribs[attrName] === 'undefined') {
            recipient.attribs[attrName] = attrs[i].value;
            recipient['x-attribsNamespace'][attrName] = attrs[i].namespace;
            recipient['x-attribsPrefix'][attrName] = attrs[i].prefix;
        }
    }
};


//Tree traversing
exports.getFirstChild = function (node) {
    return node.children[0];
};

exports.getChildNodes = function (node) {
    return node.children;
};

exports.getParentNode = function (node) {
    return node.parent;
};

exports.getAttrList = function (element) {
    var attrList = [];

    for (var name in element.attribs) {
        attrList.push({
            name: name,
            value: element.attribs[name],
            namespace: element['x-attribsNamespace'][name],
            prefix: element['x-attribsPrefix'][name]
        });
    }

    return attrList;
};


//Node data
exports.getTagName = function (element) {
    return element.name;
};

exports.getNamespaceURI = function (element) {
    return element.namespace;
};

exports.getTextNodeContent = function (textNode) {
    return textNode.data;
};

exports.getCommentNodeContent = function (commentNode) {
    return commentNode.data;
};

exports.getDocumentTypeNodeName = function (doctypeNode) {
    return doctypeNode['x-name'];
};

exports.getDocumentTypeNodePublicId = function (doctypeNode) {
    return doctypeNode['x-publicId'];
};

exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
    return doctypeNode['x-systemId'];
};


//Node types
exports.isTextNode = function (node) {
    return node.type === 'text';
};

exports.isCommentNode = function (node) {
    return node.type === 'comment';
};

exports.isDocumentTypeNode = function (node) {
    return node.type === 'directive' && node.name === '!doctype';
};

exports.isElementNode = function (node) {
    return !!node.attribs;
};


/***/ }),
/* 248 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(135).Buffer;
var util = __webpack_require__(250);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(252);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(78)))

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(96)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(179);

/*<replacement>*/
var util = Object.create(__webpack_require__(87));
util.inherits = __webpack_require__(74);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(136);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(62);


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(134).Transform


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(134).PassThrough


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ParserStream = __webpack_require__(174),
    inherits = __webpack_require__(50).inherits,
    $ = __webpack_require__(43).TAG_NAMES;

var PlainTextConversionStream = module.exports = function (options) {
    ParserStream.call(this, options);

    // NOTE: see https://html.spec.whatwg.org/#read-text
    this.parser._insertFakeElement($.HTML);
    this.parser._insertFakeElement($.HEAD);
    this.parser.openElements.pop();
    this.parser._insertFakeElement($.BODY);
    this.parser._insertFakeElement($.PRE);
    this.parser.treeAdapter.insertText(this.parser.openElements.current, '\n');
    this.parser.switchToPlaintextParsing();
};

inherits(PlainTextConversionStream, ParserStream);


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ReadableStream = __webpack_require__(105).Readable,
    inherits = __webpack_require__(50).inherits,
    Serializer = __webpack_require__(173);

var SerializerStream = module.exports = function (node, options) {
    ReadableStream.call(this);

    this.serializer = new Serializer(node, options);

    Object.defineProperty(this.serializer, 'html', {
        //NOTE: To make `+=` concat operator work properly we define
        //getter which always returns empty string
        get: function () {
            return '';
        },
        set: this.push.bind(this)
    });
};

inherits(SerializerStream, ReadableStream);

//Readable stream implementation
SerializerStream.prototype._read = function () {
    this.serializer.serialize();
    this.push(null);
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TransformStream = __webpack_require__(105).Transform,
    DevNullStream = __webpack_require__(263),
    inherits = __webpack_require__(50).inherits,
    Tokenizer = __webpack_require__(73),
    LocationInfoTokenizerMixin = __webpack_require__(170),
    ParserFeedbackSimulator = __webpack_require__(264),
    mergeOptions = __webpack_require__(131);

var DEFAULT_OPTIONS = {
    locationInfo: false
};

var SAXParser = module.exports = function (options) {
    TransformStream.call(this);

    this.options = mergeOptions(DEFAULT_OPTIONS, options);

    this.tokenizer = new Tokenizer(options);

    if (this.options.locationInfo)
        new LocationInfoTokenizerMixin(this.tokenizer);

    this.parserFeedbackSimulator = new ParserFeedbackSimulator(this.tokenizer);

    this.pendingText = null;
    this.currentTokenLocation = void 0;

    this.lastChunkWritten = false;
    this.stopped = false;

    // NOTE: always pipe stream to the /dev/null stream to avoid
    // `highWaterMark` hit even if we don't have consumers.
    // (see: https://github.com/inikulin/parse5/issues/97#issuecomment-171940774)
    this.pipe(new DevNullStream());
};

inherits(SAXParser, TransformStream);

//TransformStream implementation
SAXParser.prototype._transform = function (chunk, encoding, callback) {
    if (!this.stopped) {
        this.tokenizer.write(chunk.toString('utf8'), this.lastChunkWritten);
        this._runParsingLoop();
    }

    this.push(chunk);

    callback();
};

SAXParser.prototype._flush = function (callback) {
    callback();
};

SAXParser.prototype.end = function (chunk, encoding, callback) {
    this.lastChunkWritten = true;
    TransformStream.prototype.end.call(this, chunk, encoding, callback);
};

SAXParser.prototype.stop = function () {
    this.stopped = true;
};

//Internals
SAXParser.prototype._runParsingLoop = function () {
    do {
        var token = this.parserFeedbackSimulator.getNextToken();

        if (token.type === Tokenizer.HIBERNATION_TOKEN)
            break;

        if (token.type === Tokenizer.CHARACTER_TOKEN ||
            token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN ||
            token.type === Tokenizer.NULL_CHARACTER_TOKEN) {

            if (this.options.locationInfo) {
                if (this.pendingText === null)
                    this.currentTokenLocation = token.location;

                else
                    this.currentTokenLocation.endOffset = token.location.endOffset;
            }

            this.pendingText = (this.pendingText || '') + token.chars;
        }

        else {
            this._emitPendingText();
            this._handleToken(token);
        }
    } while (!this.stopped && token.type !== Tokenizer.EOF_TOKEN);
};

SAXParser.prototype._handleToken = function (token) {
    if (this.options.locationInfo)
        this.currentTokenLocation = token.location;

    if (token.type === Tokenizer.START_TAG_TOKEN)
        this.emit('startTag', token.tagName, token.attrs, token.selfClosing, this.currentTokenLocation);

    else if (token.type === Tokenizer.END_TAG_TOKEN)
        this.emit('endTag', token.tagName, this.currentTokenLocation);

    else if (token.type === Tokenizer.COMMENT_TOKEN)
        this.emit('comment', token.data, this.currentTokenLocation);

    else if (token.type === Tokenizer.DOCTYPE_TOKEN)
        this.emit('doctype', token.name, token.publicId, token.systemId, this.currentTokenLocation);
};

SAXParser.prototype._emitPendingText = function () {
    if (this.pendingText !== null) {
        this.emit('text', this.pendingText, this.currentTokenLocation);
        this.pendingText = null;
    }
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WritableStream = __webpack_require__(105).Writable,
    util = __webpack_require__(50);

var DevNullStream = module.exports = function () {
    WritableStream.call(this);
};

util.inherits(DevNullStream, WritableStream);

DevNullStream.prototype._write = function (chunk, encoding, cb) {
    cb();
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__(73),
    foreignContent = __webpack_require__(172),
    UNICODE = __webpack_require__(86),
    HTML = __webpack_require__(43);


//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;


//ParserFeedbackSimulator
//Simulates adjustment of the Tokenizer which performed by standard parser during tree construction.
var ParserFeedbackSimulator = module.exports = function (tokenizer) {
    this.tokenizer = tokenizer;

    this.namespaceStack = [];
    this.namespaceStackTop = -1;
    this._enterNamespace(NS.HTML);
};

ParserFeedbackSimulator.prototype.getNextToken = function () {
    var token = this.tokenizer.getNextToken();

    if (token.type === Tokenizer.START_TAG_TOKEN)
        this._handleStartTagToken(token);

    else if (token.type === Tokenizer.END_TAG_TOKEN)
        this._handleEndTagToken(token);

    else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN && this.inForeignContent) {
        token.type = Tokenizer.CHARACTER_TOKEN;
        token.chars = UNICODE.REPLACEMENT_CHARACTER;
    }

    else if (this.skipNextNewLine) {
        if (token.type !== Tokenizer.HIBERNATION_TOKEN)
            this.skipNextNewLine = false;

        if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
            if (token.chars.length === 1)
                return this.getNextToken();

            token.chars = token.chars.substr(1);
        }
    }

    return token;
};

//Namespace stack mutations
ParserFeedbackSimulator.prototype._enterNamespace = function (namespace) {
    this.namespaceStackTop++;
    this.namespaceStack.push(namespace);

    this.inForeignContent = namespace !== NS.HTML;
    this.currentNamespace = namespace;
    this.tokenizer.allowCDATA = this.inForeignContent;
};

ParserFeedbackSimulator.prototype._leaveCurrentNamespace = function () {
    this.namespaceStackTop--;
    this.namespaceStack.pop();

    this.currentNamespace = this.namespaceStack[this.namespaceStackTop];
    this.inForeignContent = this.currentNamespace !== NS.HTML;
    this.tokenizer.allowCDATA = this.inForeignContent;
};

//Token handlers
ParserFeedbackSimulator.prototype._ensureTokenizerMode = function (tn) {
    if (tn === $.TEXTAREA || tn === $.TITLE)
        this.tokenizer.state = Tokenizer.MODE.RCDATA;

    else if (tn === $.PLAINTEXT)
        this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;

    else if (tn === $.SCRIPT)
        this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;

    else if (tn === $.STYLE || tn === $.IFRAME || tn === $.XMP ||
             tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT)
        this.tokenizer.state = Tokenizer.MODE.RAWTEXT;
};

ParserFeedbackSimulator.prototype._handleStartTagToken = function (token) {
    var tn = token.tagName;

    if (tn === $.SVG)
        this._enterNamespace(NS.SVG);

    else if (tn === $.MATH)
        this._enterNamespace(NS.MATHML);

    if (this.inForeignContent) {
        if (foreignContent.causesExit(token)) {
            this._leaveCurrentNamespace();
            return;
        }

        var currentNs = this.currentNamespace;

        if (currentNs === NS.MATHML)
            foreignContent.adjustTokenMathMLAttrs(token);

        else if (currentNs === NS.SVG) {
            foreignContent.adjustTokenSVGTagName(token);
            foreignContent.adjustTokenSVGAttrs(token);
        }

        foreignContent.adjustTokenXMLAttrs(token);

        tn = token.tagName;

        if (!token.selfClosing && foreignContent.isIntegrationPoint(tn, currentNs, token.attrs))
            this._enterNamespace(NS.HTML);
    }

    else {
        if (tn === $.PRE || tn === $.TEXTAREA || tn === $.LISTING)
            this.skipNextNewLine = true;

        else if (tn === $.IMAGE)
            token.tagName = $.IMG;

        this._ensureTokenizerMode(tn);
    }
};

ParserFeedbackSimulator.prototype._handleEndTagToken = function (token) {
    var tn = token.tagName;

    if (!this.inForeignContent) {
        var previousNs = this.namespaceStack[this.namespaceStackTop - 1];

        if (previousNs === NS.SVG && foreignContent.SVG_TAG_NAMES_ADJUSTMENT_MAP[tn])
            tn = foreignContent.SVG_TAG_NAMES_ADJUSTMENT_MAP[tn];

        //NOTE: check for exit from integration point
        if (foreignContent.isIntegrationPoint(tn, previousNs, token.attrs))
            this._leaveCurrentNamespace();
    }

    else if (tn === $.SVG && this.currentNamespace === NS.SVG ||
             tn === $.MATH && this.currentNamespace === NS.MATHML)
        this._leaveCurrentNamespace();

    // NOTE: adjust end tag name as well for consistency
    if (this.currentNamespace === NS.SVG)
        foreignContent.adjustTokenSVGTagName(token);
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Copied from https://facebook.github.io/react/docs/dom-elements.html
var map = {
  // Specials
  for: 'htmlFor',
  class: 'className',

  // HTML attributes
  accept: 'accept',
  acceptcharset: 'acceptCharset',
  accesskey: 'accessKey',
  action: 'action',
  allowfullscreen: 'allowFullScreen',
  allowtransparency: 'allowTransparency',
  alt: 'alt',
  async: 'async',
  autocomplete: 'autoComplete',
  autofocus: 'autoFocus',
  autoplay: 'autoPlay',
  capture: 'capture',
  cellpadding: 'cellPadding',
  cellspacing: 'cellSpacing',
  challenge: 'challenge',
  charset: 'charSet',
  checked: 'checked',
  cite: 'cite',
  classid: 'classID',
  classname: 'className',
  colspan: 'colSpan',
  cols: 'cols',
  content: 'content',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  controls: 'controls',
  coords: 'coords',
  crossorigin: 'crossOrigin',
  data: 'data',
  datetime: 'dateTime',
  default: 'default',
  defer: 'defer',
  dir: 'dir',
  disabled: 'disabled',
  download: 'download',
  draggable: 'draggable',
  enctype: 'encType',
  form: 'form',
  formaction: 'formAction',
  formenctype: 'formEncType',
  formmethod: 'formMethod',
  formnovalidate: 'formNoValidate',
  formtarget: 'formTarget',
  frameborder: 'frameBorder',
  headers: 'headers',
  height: 'height',
  hidden: 'hidden',
  high: 'high',
  href: 'href',
  hreflang: 'hrefLang',
  htmlfor: 'htmlFor',
  httpequiv: 'httpEquiv',
  icon: 'icon',
  id: 'id',
  inputmode: 'inputMode',
  integrity: 'integrity',
  is: 'is',
  keyparams: 'keyParams',
  keytype: 'keyType',
  kind: 'kind',
  label: 'label',
  lang: 'lang',
  list: 'list',
  loop: 'loop',
  low: 'low',
  manifest: 'manifest',
  marginheight: 'marginHeight',
  marginwidth: 'marginWidth',
  max: 'max',
  maxlength: 'maxLength',
  media: 'media',
  mediagroup: 'mediaGroup',
  method: 'method',
  min: 'min',
  minlength: 'minLength',
  multiple: 'multiple',
  muted: 'muted',
  name: 'name',
  novalidate: 'noValidate',
  nonce: 'nonce',
  open: 'open',
  optimum: 'optimum',
  pattern: 'pattern',
  placeholder: 'placeholder',
  poster: 'poster',
  preload: 'preload',
  profile: 'profile',
  radiogroup: 'radioGroup',
  readonly: 'readOnly',
  rel: 'rel',
  required: 'required',
  reversed: 'reversed',
  role: 'role',
  rowspan: 'rowSpan',
  rows: 'rows',
  sandbox: 'sandbox',
  scope: 'scope',
  scoped: 'scoped',
  scrolling: 'scrolling',
  seamless: 'seamless',
  selected: 'selected',
  shape: 'shape',
  size: 'size',
  sizes: 'sizes',
  span: 'span',
  spellcheck: 'spellCheck',
  src: 'src',
  srcdoc: 'srcDoc',
  srclang: 'srcLang',
  srcset: 'srcSet',
  start: 'start',
  step: 'step',
  style: 'style',
  summary: 'summary',
  tabindex: 'tabIndex',
  target: 'target',
  title: 'title',
  type: 'type',
  usemap: 'useMap',
  value: 'value',
  width: 'width',
  wmode: 'wmode',
  wrap: 'wrap',

  // SVG attributes
  accentheight: 'accentHeight',
  accumulate: 'accumulate',
  additive: 'additive',
  alignmentbaseline: 'alignmentBaseline',
  allowreorder: 'allowReorder',
  alphabetic: 'alphabetic',
  amplitude: 'amplitude',
  arabicform: 'arabicForm',
  ascent: 'ascent',
  attributename: 'attributeName',
  attributetype: 'attributeType',
  autoreverse: 'autoReverse',
  azimuth: 'azimuth',
  basefrequency: 'baseFrequency',
  baseprofile: 'baseProfile',
  baselineshift: 'baselineShift',
  bbox: 'bbox',
  begin: 'begin',
  bias: 'bias',
  by: 'by',
  calcmode: 'calcMode',
  capheight: 'capHeight',
  clip: 'clip',
  clippath: 'clipPath',
  clippathunits: 'clipPathUnits',
  cliprule: 'clipRule',
  colorinterpolation: 'colorInterpolation',
  colorinterpolationfilters: 'colorInterpolationFilters',
  colorprofile: 'colorProfile',
  colorrendering: 'colorRendering',
  contentscripttype: 'contentScriptType',
  contentstyletype: 'contentStyleType',
  cursor: 'cursor',
  cx: 'cx',
  cy: 'cy',
  d: 'd',
  decelerate: 'decelerate',
  descent: 'descent',
  diffuseconstant: 'diffuseConstant',
  direction: 'direction',
  display: 'display',
  divisor: 'divisor',
  dominantbaseline: 'dominantBaseline',
  dur: 'dur',
  dx: 'dx',
  dy: 'dy',
  edgemode: 'edgeMode',
  elevation: 'elevation',
  enablebackground: 'enableBackground',
  end: 'end',
  exponent: 'exponent',
  externalresourcesrequired: 'externalResourcesRequired',
  fill: 'fill',
  fillopacity: 'fillOpacity',
  fillrule: 'fillRule',
  filter: 'filter',
  filterres: 'filterRes',
  filterunits: 'filterUnits',
  floodcolor: 'floodColor',
  floodopacity: 'floodOpacity',
  focusable: 'focusable',
  fontfamily: 'fontFamily',
  fontsize: 'fontSize',
  fontsizeadjust: 'fontSizeAdjust',
  fontstretch: 'fontStretch',
  fontstyle: 'fontStyle',
  fontvariant: 'fontVariant',
  fontweight: 'fontWeight',
  format: 'format',
  from: 'from',
  fx: 'fx',
  fy: 'fy',
  g1: 'g1',
  g2: 'g2',
  glyphname: 'glyphName',
  glyphorientationhorizontal: 'glyphOrientationHorizontal',
  glyphorientationvertical: 'glyphOrientationVertical',
  glyphref: 'glyphRef',
  gradienttransform: 'gradientTransform',
  gradientunits: 'gradientUnits',
  hanging: 'hanging',
  horizadvx: 'horizAdvX',
  horizoriginx: 'horizOriginX',
  ideographic: 'ideographic',
  imagerendering: 'imageRendering',
  in: 'in',
  in2: 'in2',
  intercept: 'intercept',
  k: 'k',
  k1: 'k1',
  k2: 'k2',
  k3: 'k3',
  k4: 'k4',
  kernelmatrix: 'kernelMatrix',
  kernelunitlength: 'kernelUnitLength',
  kerning: 'kerning',
  keypoints: 'keyPoints',
  keysplines: 'keySplines',
  keytimes: 'keyTimes',
  lengthadjust: 'lengthAdjust',
  letterspacing: 'letterSpacing',
  lightingcolor: 'lightingColor',
  limitingconeangle: 'limitingConeAngle',
  local: 'local',
  markerend: 'markerEnd',
  markerheight: 'markerHeight',
  markermid: 'markerMid',
  markerstart: 'markerStart',
  markerunits: 'markerUnits',
  markerwidth: 'markerWidth',
  mask: 'mask',
  maskcontentunits: 'maskContentUnits',
  maskunits: 'maskUnits',
  mathematical: 'mathematical',
  mode: 'mode',
  numoctaves: 'numOctaves',
  offset: 'offset',
  opacity: 'opacity',
  operator: 'operator',
  order: 'order',
  orient: 'orient',
  orientation: 'orientation',
  origin: 'origin',
  overflow: 'overflow',
  overlineposition: 'overlinePosition',
  overlinethickness: 'overlineThickness',
  paintorder: 'paintOrder',
  panose1: 'panose1',
  pathlength: 'pathLength',
  patterncontentunits: 'patternContentUnits',
  patterntransform: 'patternTransform',
  patternunits: 'patternUnits',
  pointerevents: 'pointerEvents',
  points: 'points',
  pointsatx: 'pointsAtX',
  pointsaty: 'pointsAtY',
  pointsatz: 'pointsAtZ',
  preservealpha: 'preserveAlpha',
  preserveaspectratio: 'preserveAspectRatio',
  primitiveunits: 'primitiveUnits',
  r: 'r',
  radius: 'radius',
  refx: 'refX',
  refy: 'refY',
  renderingintent: 'renderingIntent',
  repeatcount: 'repeatCount',
  repeatdur: 'repeatDur',
  requiredextensions: 'requiredExtensions',
  requiredfeatures: 'requiredFeatures',
  restart: 'restart',
  result: 'result',
  rotate: 'rotate',
  rx: 'rx',
  ry: 'ry',
  scale: 'scale',
  seed: 'seed',
  shaperendering: 'shapeRendering',
  slope: 'slope',
  spacing: 'spacing',
  specularconstant: 'specularConstant',
  specularexponent: 'specularExponent',
  speed: 'speed',
  spreadmethod: 'spreadMethod',
  startoffset: 'startOffset',
  stddeviation: 'stdDeviation',
  stemh: 'stemh',
  stemv: 'stemv',
  stitchtiles: 'stitchTiles',
  stopcolor: 'stopColor',
  stopopacity: 'stopOpacity',
  strikethroughposition: 'strikethroughPosition',
  strikethroughthickness: 'strikethroughThickness',
  string: 'string',
  stroke: 'stroke',
  strokedasharray: 'strokeDasharray',
  strokedashoffset: 'strokeDashoffset',
  strokelinecap: 'strokeLinecap',
  strokelinejoin: 'strokeLinejoin',
  strokemiterlimit: 'strokeMiterlimit',
  strokeopacity: 'strokeOpacity',
  strokewidth: 'strokeWidth',
  surfacescale: 'surfaceScale',
  systemlanguage: 'systemLanguage',
  tablevalues: 'tableValues',
  targetx: 'targetX',
  targety: 'targetY',
  textanchor: 'textAnchor',
  textdecoration: 'textDecoration',
  textlength: 'textLength',
  textrendering: 'textRendering',
  to: 'to',
  transform: 'transform',
  u1: 'u1',
  u2: 'u2',
  underlineposition: 'underlinePosition',
  underlinethickness: 'underlineThickness',
  unicode: 'unicode',
  unicodebidi: 'unicodeBidi',
  unicoderange: 'unicodeRange',
  unitsperem: 'unitsPerEm',
  valphabetic: 'vAlphabetic',
  vhanging: 'vHanging',
  videographic: 'vIdeographic',
  vmathematical: 'vMathematical',
  values: 'values',
  vectoreffect: 'vectorEffect',
  version: 'version',
  vertadvy: 'vertAdvY',
  vertoriginx: 'vertOriginX',
  vertoriginy: 'vertOriginY',
  viewbox: 'viewBox',
  viewtarget: 'viewTarget',
  visibility: 'visibility',
  widths: 'widths',
  wordspacing: 'wordSpacing',
  writingmode: 'writingMode',
  x: 'x',
  x1: 'x1',
  x2: 'x2',
  xchannelselector: 'xChannelSelector',
  xheight: 'xHeight',
  xlinkactuate: 'xlinkActuate',
  xlinkarcrole: 'xlinkArcrole',
  xlinkhref: 'xlinkHref',
  xlinkrole: 'xlinkRole',
  xlinkshow: 'xlinkShow',
  xlinktitle: 'xlinkTitle',
  xlinktype: 'xlinkType',
  xmlns: 'xmlns',
  xmlnsxlink: 'xmlnsXlink',
  xmlbase: 'xmlBase',
  xmllang: 'xmlLang',
  xmlspace: 'xmlSpace',
  y: 'y',
  y1: 'y1',
  y2: 'y2',
  ychannelselector: 'yChannelSelector',
  z: 'z',
  zoomandpan: 'zoomAndPan',

  // Events
  onabort: 'onAbort',
  onanimationend: 'onAnimationEnd',
  onanimationiteration: 'onAnimationIteration',
  onanimationstart: 'onAnimationStart',
  onblur: 'onBlur',
  oncanplay: 'onCanPlay',
  oncanplaythrough: 'onCanPlayThrough',
  onchange: 'onChange',
  onclick: 'onClick',
  oncompositionend: 'onCompositionEnd',
  oncompositionstart: 'onCompositionStart',
  oncompositionupdate: 'onCompositionUpdate',
  oncontextmenu: 'onContextMenu',
  oncopy: 'onCopy',
  oncut: 'onCut',
  ondoubleclick: 'onDoubleClick',
  ondrag: 'onDrag',
  ondragend: 'onDragEnd',
  ondragenter: 'onDragEnter',
  ondragexit: 'onDragExit',
  ondragleave: 'onDragLeave',
  ondragover: 'onDragOver',
  ondragstart: 'onDragStart',
  ondrop: 'onDrop',
  ondurationchange: 'onDurationChange',
  onemptied: 'onEmptied',
  onencrypted: 'onEncrypted',
  onended: 'onEnded',
  onerror: 'onError',
  onfocus: 'onFocus',
  oninput: 'onInput',
  onkeydown: 'onKeyDown',
  onkeypress: 'onKeyPress',
  onkeyup: 'onKeyUp',
  onload: 'onLoad',
  onloadeddata: 'onLoadedData',
  onloadedmetadata: 'onLoadedMetadata',
  onloadstart: 'onLoadStart',
  onmousedown: 'onMouseDown',
  onmouseenter: 'onMouseEnter',
  onmouseleave: 'onMouseLeave',
  onmousemove: 'onMouseMove',
  onmouseout: 'onMouseOut',
  onmouseover: 'onMouseOver',
  onmouseup: 'onMouseUp',
  onpaste: 'onPaste',
  onpause: 'onPause',
  onplay: 'onPlay',
  onplaying: 'onPlaying',
  onprogress: 'onProgress',
  onratechange: 'onRateChange',
  onscroll: 'onScroll',
  onseeked: 'onSeeked',
  onseeking: 'onSeeking',
  onselect: 'onSelect',
  onstalled: 'onStalled',
  onsubmit: 'onSubmit',
  onsuspend: 'onSuspend',
  ontimeupdate: 'onTimeUpdate',
  ontouchcancel: 'onTouchCancel',
  ontouchend: 'onTouchEnd',
  ontouchmove: 'onTouchMove',
  ontouchstart: 'onTouchStart',
  ontransitionend: 'onTransitionEnd',
  onvolumechange: 'onVolumeChange',
  onwaiting: 'onWaiting',
  onwheel: 'onWheel'
};

var extraCharRegex = /[-:]/g;

var convert = function (attr) {
  if (/^(data-|aria-)/.test(attr)) {
    return attr;
  }
  var key = attr.replace(extraCharRegex, '').toLowerCase();
  return map[key] || attr;
};

module.exports = convert;
module.exports.convert = convert;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

function hyphenToCamelcase(str) {
  var result = '';
  var upper = false;

  for (var i = 0; i < str.length; i++) {
    var c = str[i];

    if (c === '-') {
      upper = true;
      continue;
    }

    if (upper) {
      c = c.toUpperCase();
      upper = false;
    }

    result += c;
  }

  return result;
}

function convertKey(key) {
  var res = hyphenToCamelcase(key);

  if (key.indexOf('-ms-') === 0) {
    res = res[0].toLowerCase() + res.slice(1);
  }

  return res;
}

module.exports = function (styleStr) {
  return styleStr
    .split(';')
    .reduce(function (res, token) {
      if (token.slice(0, 7) === 'base64,') {
        res[res.length - 1] += ';' + token;
      } else {
        res.push(token);
      }
      return res;
    }, [])
    .reduce(function (obj, str) {
      var tokens = str.split(':');
      var key = tokens[0].trim();
      if (key) {
        var value = tokens.slice(1).join(':').trim();
        obj[convertKey(key)] = value;
      }
      return obj;
    }, {});
};


/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"邏輯","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"數學","c3328c39b0e29f78e9ff45db674248b1d245887d":"文本","4d064726954a17487f94e931f5b157b733ec22ed":"高階","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"清單","19de69cb601f53a4ea7af22a65c71ae63251365c":"變數","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"功能","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"迴路","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"Binary","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"交易的定義","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"購入前","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"購入時","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"購入後","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"跳動點分析","8cf71374fa095a64b5295b672daef8507ec7be6a":"指標","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"工具","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"時間","8d8fd6765e184419cad8b88d1a60c895d79578c2":"蠟燭線","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"雜項","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"記錄","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"摘要","9feddbabd7e7309e96c590069057158e96baa8f6":"實況簡報","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"二元期權交易就像任何其他活動一樣，過於沉迷可能會上癮。為了避免發生此種風險，我們定期提供交易和財務的實況簡報。","4152043e8c670075d2c919677e835edb0d923cab":"請指定首選的實況調查間隔時間，以分鐘計","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"請輸入10和60之間的數字。","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"繼續交易","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"聲明","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"登出","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"聯繫我們","f7c400ed695f898b8ee9d21664aa17b5bb693828":"登入","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"將區塊重置成初始狀態","f98595d541778d86f75ef22b3328a031d20aa16b":"載入新區塊(xml檔)","4a1e616226c329a94da7768bc0435a3284478010":"保存現有的區塊（xml 檔）","6b3465ace62f33f0687b4669ac26d95895e9ca52":"將Binary Bot 連接到 Google Drive，以便保存及重新使用區塊","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"復原變更(Ctrl+Z)","937f5055f05be359ddf619744e8af4d643549e80":"復原變更(Ctrl+Shift+Z)","8406d1cce44230835932060649e999ca3283b413":"放大(Ctrl + +)","1109673172af2c173c492622ff8a72c8f29f0e70":"縮小(Ctrl + -)","44c22002c65d2871331263a23c3e09c0a1bfd847":"重設直行","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"顯示/隱藏彈出摘要","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"運行bot","ba50a42d8d3228c37a817865fce49fbca692c2ad":"停止自動交易","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"顯示記錄","91017ef9b165cd0e7475a770f318ea5e705e1321":"顯示圖表","c89e3dd1cafcadcc0312e476ab58b2332209da23":"顯示交易檢視","b02c858e72be118a65c9393930351012b647cb9e":"切換標題","250be77f7605669a0b3d968b9ed381a3d9787ed1":"打開已儲存的 XML 檔並擷取其區塊","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"Binary Bot","608061fb5aab975013fa70c5c814a1d8ba30c152":"交易效率比您想象的更高","e4ce8dc3e416e69262ba642dc57d3975d6616980":"想要讓您傾向的二元期權交易策略自動化？","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"Binary Bot 是尖端的程式設計工具，可建立交易應用程式，只需使用簡單的","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"不論是非常簡單的公式，或是極度複雜的算法，請發揮想像力，設計出無限量的二元期權交易bot，即使睡眠時也可自動為您進行交易。","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"立刻建立Bot","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"需要幫忙？","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"需要幫助?","d635b53e59c9aad8c5d78458826beffb029b27bf":"謝謝，會在24小時內回覆","a69a8fc21499d0fd85e87bab467699827547a5bc":"請輸入有效的服務器 URL","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"未選擇標的市場","50050f06645ad2743165b429a8f7deebd285fd63":"未選擇合約類型","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"請登入","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"持續時間必須是正整數","4df6e872792d72aea8a2f6b831d00b554464da23":"金額必須是正數","001e68df3a4b32a4d57148d9d407f44eee3b7436":"無效的蠟型線","04f14ea7c92e0b2b5ae005c696245063ec641d66":"無效的蠟線清單","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"重試間隔時間為","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"以下數額已達最大限制","094628ce13fc0e78f07b697d1cc9421bb2edd666":"以下請求已失敗","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"否","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"是的","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"聲明","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"賣價","50e72909992bdc37c7c07769d1b7efac5e52874c":"賠付額","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"利潤","c980b910204c7babdffe8ff3f7e755f30133383c":"合約類型","a726c6955157f1b8b92f9932652434a7150f80f8":"入市現價","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"入市值","3905be81561384dc8c43d6127c57ed1e0eb03b74":"入市值字串","7674920c033ca14277c577e19c037a6754d4fa80":"退市現價","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"退市值","06ecea26625359f7dcf5ff5c47af6174ff815257":"退市值字串","779455ee3bde8494d9629b353e17b19e92357ba8":"障礙","37a5301a88da334dc5afc5b63979daa0f3f45e68":"結果","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"贏得","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"損失","563339f82447b4e758ad76d5a0b63b5698594fba":"上升","5c1ae82c29543ac887703776bf3da2c7dcce683d":"下跌","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"沒有變化","ecb252044b5ea0f679ee78ec1a12904739e2904d":"字串","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"數字","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"綠色","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"藍色","96de5543d183d7de52ac5fa21c46fc811f673f89":"黃色","78988010b890ce6f4d2136481f392787ec6d6106":"紅色","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"無提示","cf84a98d6cf7f156862a08ba8236467b6f471004":"公告","eee2facd669d1434848c24da5527b3e87d9a12d5":"賺取的錢","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"完成工作","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"錯誤","a3b1583d377f37ac20de7e089edfa0920a078e57":"嚴重錯誤","66c8b6848eee629c4ac551bf2b5fa591571654be":"上漲同價","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"下跌同價","062787aa328047e189774b3703d983b83938f6e9":"高於","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"低於","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"觸及","7d7932bcc2e262ae98cf09dc5445130fb3881769":"未觸及","a16814a48ec58c2e24ba224a80921a5c02361abe":"範圍之內收盤","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"範圍之外收盤","534ec5da4e82ec419abc170e1a8448f55a01664f":"保持在範圍之內","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"超出範圍之外","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"亞洲上漲","c098658ce3d3a258e4d155949a60072966b36db7":"亞洲下跌","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"相符","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"差異","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"偶數","dc28f5f3c65ec611f0f30022650d24382d27448e":"奇數","18a63f5512afb5573e5b44deba78d629f0635317":"大於","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"小於","2155c8b38181dd2552e84a94049aacd33ef9c607":"高跳動點","1408cfd2b064b923f024fbe590e27db8282941a5":"低跳動點","b86eb15dc4f13e4c2972de158d3038d9f657242f":"重設買權","669a1f3d9a8f601a84da536cfdad1de4092b1926":"重設賣權","844d1a5c99a0a668383340cc095d040eef998c79":"只會持續上漲","87293a146cd481a2b30cf74282ec061dc4cf0735":"只會持續下跌","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"開盤","b1a5954a483f8f8b0207385095f74aeb409b3f80":"高","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"低","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"收盤","1173872a4fb205b713702f0eec5cf2c732c828fd":"開盤時間","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"預設值","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"1分鐘","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"2分鐘","24e46784cbce32443db5a2638b1a7d3201543e9b":"3分鐘","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"5分鐘","a6f151883b736f0470d33492e61c72a7d059d065":"10分鐘","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"15分鐘","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"30分鐘","f030c3d667652646b86732ad7bc67e226c49cd3a":"1小時","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"2小時","7b47150d431db70d783724007f07ab894eb8ac2e":"4小時","191800b7e9a48680792c0dd77cb6cac00c4514c6":"8小時","2d8a6f7c34468578640b333b8650131de06ac770":"1天","cd1495cb4c60266a6abad9024022ae079bf7e416":"(1) 定義交易合約","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"(2) 觀看和購入合約","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"交易選項","160f06d4799c85021a810f68c5b517eea37a2737":"購入","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"上漲/下跌","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"上漲/下跌平價","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"亞洲期權","2260ce49306460c8a2ef501939f29ad6ddd4e934":"位數","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"觸及/未觸及","f7de1f66f0979667da275b7e8996e805395025a1":"範圍之內/範圍之外收盤","a431deecd4c2258097adae418d496fe9a8179fee":"範圍內/範圍外","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"高/低跳動點","12a3f461cdebbc8f335190413ee6c57442743bba":"重設買/賣權","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"只會持續上漲/只會持續下跌","91a64e3f83c91acf336c631fba295f297f94c399":"n 秒後運行","024696596f26a4db232fd9e966eadfeb27c0bd1a":"每 n 秒運行","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"上部","85c274929bc0e28eafd3734f2c25046c3b95b36b":"中部","346e3ee198e98146993894d3de8ecab1a86c3e80":"下部","f16459104f92ab6b38aa265adb4ecbfc3768e303":"長條圖","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"指數平滑異同移動平均線","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"訊號","19eabc961735d78f12fc7be906ffcb033853cf85":"時間戳記","68f4145fee7dde76afceb910165924ad14cf0d00":"消息","e99811bd3b1ad17e74614060ecb180602be35ad6":"已被登出！","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"須新增區塊到工作區","1fde9f1ebca07dcbc704130bd18645bce7718b55":"須啓用區塊","d466687f90ba548434d65186d11a80c4204f9ad6":"必須向內新增:","629777b7d4d610ace6dee24442730f27d7d0853e":"不支持的文件︰","0b93c14956403c2e5c9e79f5c836babc56912006":"Binary Bot不會進行任何新的交易。已經確認（但未過期）的所有交易將由我們的系統完成。任何未儲存的變更都將丟失。","c1458ff86fd60d9544d7cd8a67437df2b766f482":"注: 有關已確認交易記錄的詳細資訊，請參閱 Binary.com 聲明頁面。","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"任何未儲存的變更都將丟失。","410bf23a3f080def9c7a976a16305bcde7943ed1":"是否確定？","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"對不起，您的所在國不可用 Binary Bot","901624741023fcfc805ce43c94b8012e3b1d1c99":"想在 MT5 交易差價合約？將可以存取外匯、股票、股票指數、大宗商品、加密貨幣和綜合指數。","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"策略","910ec7aa40b04ec6ba51162f4de7850569326cb6":"載入 Google API 腳本時出錯。","8f51f350debde84e067e1a0405fb6304922a7d4b":"Google 雲端硬碟初始化時出錯.","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"載入 Google 雲端硬碟庫時出錯","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"請授予權限，以檢視和管理 Google 雲端硬碟檔案","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"無法識別的檔案格式","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"從 Google 雲端硬碟檢索資料時出錯","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"選擇Binary Bot 策略","2db43c69a4b96454914f0b8272bc869984529e6e":"從 Google 雲端硬碟列出檔案時出錯","0dcea5f584938e0fff00084b83156ab31d641ab3":"從 Google 雲端硬碟檢索檔案時出錯","18da95988117ff029393f3f5c881d70ef47f7385":"處理請求時出錯","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"選擇資料夾","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"無法傳送Telegram通知","3f370309b6280eb100f898426d8605c1f45d558d":"無效的時間戳","af6a4e2a5582be89ac930e946eaed86e01cac58b":"無效的日期/時間","49d51398b574e7312d99b18d2b93d2ede416f053":"無法傳送 webhook","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"建議還沒有準備好","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"選定的建議並不存在","6ea4a034747d020b1d8ce4848def95d537555dd6":"已買入","89f89c02cf47e091e726a4e07b88af0966806897":"ID","1200c1af2f7bba4e29a34112865662748c9d41df":"此合約不提供轉售。","62d6180e55905f7b996d442c53631981a4ef8b5b":"已售出","ed4978867de1da05b336b724a3fb96222a29ebec":"指標必須是正整數","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"利潤總額","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"損失金額","46fc6f27a835486d63d9e927c6687e4508cb3087":"最大達成交易的數目","9202ddae4cea16513e53bbc965d88ed975e59512":"最大損失金額","5f52b397b7e5f538681f0f5717a88aa626349c7a":"未調用Bot.init","66c7734789e19cbeef3a5ac185ea732139aed213":"圖表","3b662fb2e8bafce29aa98321b18874bb44905488":"Google雲端硬碟集成","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"請到自我禁止工具頁面設定每天虧損限額，以允許交易。","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"最大連續交易數需是1到100之間","93039e609d94a24f3572b794a31b21525a09af2b":"未設定","a85b8cc112a8597df1612d60a74faa818c25d1b3":"須設定符合商業規則的交易限額。請注意自動交易機器人僅將在以下條件之一或二者都符合時才會停止交易。","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"每日損失限額:","95052a29f213e9698b593418fe396ecc21032f9b":"此閾值限制當天在所有 Binary.com 平台的潛在虧損。一旦總虧損達到或超過此金額，機器人將停止交易。請在{$0}自我禁止工具頁面{$1}設定一個值。","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"最大連續交易數","730657200c17321d926e1bd08dbf65bd96855a8a":"這是允許機器人為此次運行執行的最大交易數。","952f375412e89ff213a8aca383d18e5691354347":"開始","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"交易限制","095ba68888b5ace5f4515f5acab76dfa1073544e":"我的電腦","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"載入","248e224f533752db28a1aab3519a58569ad96140":"載入區塊","c7097e97dcc446ca889d3ca6be733a65e2728afe":"已成功上傳到 Google 雲端硬碟","a6b977714595aa01678fca98e86553aaeac05c92":"將區塊單獨儲存在集合中。加載時，它將被新增到現有的工作區（主區塊將被替換）。","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"另存為集合件","611ebbfb080284312904de925ef0f75f4cb56ad2":"保存區塊和設定，以便在其他策略中重複使用","efc007a393f66cdb14d57d385822a3d9e36ef873":"儲存","a638caa8ab2b7ff7980a571334217339e6d1d634":"區塊儲存為","39fca63515c105918f03e4908ec12df675b07f92":"交易檢視","e643975ea5296d9de4486458f31ab0a5a2b228bf":"這將清除摘要面板中的所有交易，所有計數器將重設為零。","85dfa32c97d8618d1bea083609e2c8a29845abe5":"帳戶","d847919a30d31c0be624087f3370492b3fdf80c6":"運行次數","5cd6978d63540c8a490ef76f43219de6362f958e":"總投注金額","17410d7b62b8b1de981cfebada24632987edf186":"總賠付額","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"總損益","90eef613042c5a51f542421065b68b886d473807":"餘額","db1c784524e1b54011a95823026161f7c8517fe0":"引用","4db3e9e4aecd187db9339a10d2629fef46724dc4":"交易類型","1bb4086b66659d8580f9be4beef69931aeea3cad":"入市現價","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"退市現價","ba7be969e7c1bb5f22489e843478e3d721aaa843":"買入價","772fbced18230220d2d9be1456be16fc1b271d25":"利潤/虧損","bae7d5be70820ed56467bd9a63744e23b47bd711":"狀況","96f608c16cef16caa06bf38901fb5f618a35a70b":"待決","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"已結算","82a82f798dd773717ec37d15fd4405510291734e":"自動交易已停止。","6a88e58aa1798626f94cf17f1a91618b405bb289":"Bot 將開始...","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"自動交易正在運行中","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"Bot 將停止...","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"Bot 已停止。","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"試圖購入","4684ee1026d9b4c872d016c3c4588a0c479a451c":"購入金額","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"購買成功","f02760cd2eac28169f0a990c950c3dfe8427f772":"合約已終止","c7363d8a0748d4a7e2cc968335dc9716f290359d":"停止 bot 將阻止進一步交易。任何正在進行的交易將由系統完成。請注意，如果在下單交易期間停止 bot，某些已完成的交易可能不會在表單中顯示。可以參考 Binary.com 聲明頁面瞭解所有已完成交易記錄的詳細資訊。","fadc0ef93d1ff13370524ce8481ddc4a71195934":"重設直行","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"下載","e4458464df6cbb8da1134875ba51519c5d244d9f":"區塊必須位於區塊筒、主要區塊或函數內","e9c45563358e813f157ba81b33143542165ba84e":"警告","31cb6f44d030abeabcc7046555dea851602a87a5":"您的國家不能使用此策略。","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"確定","9970168c192807246fad6138344e5a96449afbdd":"XML 文件為空。請檢查或修改文件。","a594b427eaf0f108d3e9cc20d70e15da811c760c":"不受支援的策略","04a5090686ac7b54822e00a9ff08c38a107601e7":"抱歉，此策略無法在 Binary Bot 使用。僅可在 DBot 使用。","77dfd2135f4db726c47299bb55be26f7f4525a46":"取消","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"帶我去 DBot","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"嘗試打開的文件在以下區塊中包含不受支持的元素：{$0} 請檢查文件並重試。","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"無法載入區塊檔。","af145748c9cf765a3b059eec20cb1dbb899297d8":"區塊載入成功","11ee9c5d534cc8d22651092222b532917594161a":"最小持續時間是","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"跳動點數必須介於 5 和 10 之間","ace1342bc3720b77ce510b93074041e7386d209e":"到期時間不能和開始時間相同","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"預測必須是一個數位","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"必須向內新增","33aa6ff282ee509d37c6f758274c9156b419ff73":"嘗試匯入的策略無效。","da162a909c2981ed318d23cd9a6be1d66e0a8400":"無法識別的檔案格式。","5e719fa76e1b6cb396376c82ebdd04bec7253229":"遠端區塊載入必須是集合物件。","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"無法載入區塊檔。","df84a88f38b03b5b342362d72370b0d66afdae35":"目標必須是 xml 檔","cd680fd936e9559ef1d95efac7a71680e2b13a89":"此 url 已經載入","34c59389053701a04127f74d32315e0206e076f8":"試圖載入url時出錯","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"請確保「存取-控制-允許-起源」 存在於來自伺服器的回應","988df856c066143616bd33d5904bbcdc22ff129e":"Binary.com 將移至 Deriv","2fccaab15d71b00c19da7053135471d510b513db":"在 Deriv 交易","3ead0b14c72503187691a7a6d7121987299bd401":"這不是官方版本的Binary Bot，使用時需自擔風險。","27401c9c8e476d659c8382e05c6d70a4a82be468":"官方版本","bc981983e7f547dc62e19a1e383acfe00782a6d5":"下一頁","b52b36b7269fbfc58ec24bb724691951a3decbe8":"返回","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"完成","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"快速瀏覽","a48e81d4a8da67637b46725824177a959fe99b21":"準備好學習如何使用 Binary Bot 了嗎？","6f3e6ebf249947cec4f64117253a8fe43335ae79":"不，謝謝","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"不要再問我。","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"工作區","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"拖放區塊檔案或製作自己的策略。","d171baee235d4c93f63755a876782dc5be4c3e47":"區塊工具箱","056f19272d96f902c38207cf163ea8dbff7fbd32":"從這裡新增更多區塊到機器人程式。","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"帳戶","f5c47fd3b3553b10441a06054078cea745177dea":"啟用機器人程式前請先登入。每次測試策略時請使用虛擬帳戶。","fd825ae94aa79500a878dd4590a4b360e7162663":"Bot 控制項","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"控制區塊。將游標放在每個按鈕上即可獲得更多資訊。","f5169c84497de3aea74f7da9e7e177d1427e736b":"享受其中樂趣！","4f1b3d682c2a00b393c33637da402463bc11d5ff":"想要報告問題或尋求幫助嗎？","0049f8894e41937ebb9111cd3def6749049fb50f":"請按一下此處","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"在 Deriv 哪裡可以找到 Binary Bot","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"在 Deriv 首頁點選頁面頂部的交易，然後選擇 Binary Bot。","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"試用 Deriv 的 Binary Bot","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"是您所熟悉和喜愛的 Binary Bot","169dd3b2025485a48b8f9f3f6ef89f5586714140":"一切都是您喜歡的方式。","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"讓機器人順暢地移過來","b763f8cbfa6396f195781032619a99bba04bc939":"Binary.com 的策略可以在 Deriv 使用。只需加載 XML 文件即可開始交易。","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"7 個交易平台——舊的最愛和新的一起","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"您會發現 Binary Bot 和 SmartTrader 以及 DBot 和 DTrader 等新平台。無論交易風格如何，我們都能提供相應的平台。","0ce7480da93c1c9839818d0720b77931d1637574":"通過法定匝道存入加密貨幣","6e6a4c6839d2e859758a517865b095c1b8298dd6":"通過 Changelly、Banxa 和 XanPool 等兌換服務輕鬆進行加密貨幣存款。","c1b51f196c97b4781a354457579e9699b09de087":"3 種交易類型","4708f7e87263464b130b987e4b9aed981c4f455d":"差價合約、數字期權和乘數交易是新的、令人興奮的交易類型，可以在有限的風險下提高潛在利潤。","b7fceac7d5f885d735aeda6e4654487467d33fa3":"點對點存款和取款","79a206119137878eb6be7c60f7ed34135194bdf0":"通過 Deriv P2P 與其他交易者兌換當地貨幣，以便從帳戶存取款。","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"6 種市場類型","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"通過廣泛的市場如外匯、股票、加密貨幣、綜合指數等擴展投資組合。","14b2a808fdec3702e5a6b9152e13288c87a4768a":"在 Deriv 學院學習","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"享受免費文章和視訊，幫助了解線上交易的技巧。","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"按一下選取","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"不可用","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"跳動點","5fb1db527825d2996e37c655e5dec49d4da80c09":"秒","092f99ea11a34a8490e7a767a83a42fc45634f82":"分鐘","9e25a34e635a123f8958bbe26e7c4843278597fb":"小時","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"日","db6708630fc646eb98298d9acd701e0a1ac051c2":"將區塊和策略保存到 Google 雲端硬碟","85538d002a336c5addef8d189d80976cf7758f8c":"登入ID是","b65463cb6a42a17de514acc4659f7fd331e0876a":"連接","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"中斷連線","cd5f85b6f187605f82386eacd680f93820af8d11":"結果是","1e38ce3d180cefae485a6986ca7c67841e30376f":"如果結果與選擇匹配，請回答「是」","5c89497fc3c128e2ff865ce8df15356054f2c028":"(4) 獲得交易結果並再次交易","14ea81918758c994cbe3178e695e56afc1ef2b45":"獲得以前的交易資訊和結果，然後再次交易（在交易完成上運行）","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"合約詳細資訊︰","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"從合同詳細資訊清單中讀取所選的選項","b3b543c80063a116ced4965d8537b7b62d14c0b7":"再次交易","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"再次運行交易區塊","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"賣價","343fda69c73b78b84967055aae97f790c422adfd":"選定建議的賣價","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"觀看跳動點流向和購入所需的合約（在跳動點更新上運行）","9bb396940adb9705fe57eba6ea8b578e6aafa792":"賠付額","87da93a46d143f6019979b3548414d9d7adabb35":"選定建議的賠付額","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"購入選定的合約。","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"可賣出","03bad10717e183b24829baf483dc715e1a44bf7b":"如果市場上可賣出，請回答「是」","2c71ed279a402e93312dbda173ab18f244d6bf46":"(3) 查看和賣出所購入的合約","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"查看購入的合約資訊，如果可以的話，在市場上賣出（在合約更新上運行）","579607dc4f989ce2b94b558431666a0ab07ac1f3":"在市場上賣出","e20afd5cf3811a42071c9a312abb2afdad4c590b":"在市場上賣出。","4712cbff8e92822fc960ef9c0197293a19675eae":"銷售利潤/虧損","df817b48c7a076561b4f8bedc52d65d2e351ab52":"退回在市場上賣出的利潤。","b44e884c355e447d0da0e6ba45caaff18c84373b":"布林通道","d6a2a207343bd83aacdc80b579ff4419713a256e":"輸入清單","170a28a9db6d27d7212fc6dc249434a57517e7bc":"期間","b833989d69900a4be9e32d1bab65c8f8233f099e":"標準偏差上漲乘法器","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"標準偏差下跌乘法器","974da601086448d0060aeed90e53ddd5acd17b91":"從有期限的清單計算布林通道 (BB)","d5b65cac1f1cf9421ac978eebe532de99040cca6":"布林通道陣列","58de49791c64aba14e36e5887244a5ef088286cd":"從有期限的清單計算布林通道 (BB)","4bd99f76f1104229744455d93df0ff76b9eeed58":"指數移動平均線","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"從有期限的清單中計算指數移動平均線 (EMA)","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"指數移動平均線陣列","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"從有期限的數值清單中計算指數移動平均線 (EMA)","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"指數平滑異同移動平均線陣列","b18e572ea14edd48587145f1ef50718adbf256c6":"快速指數移動平均週期","974023bddd6249d0f6404872cfcae205b2599ea2":"慢速指數移動平均週期","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"信號EMA週期","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"從清單計算指數平滑異同移動平均線 (MACD) 清單","95ec92885c855ba9cf734c17a43f081901e4d2cc":"相對強度指標","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"從有期限清單獲得的相對強度指標 (RSI)","4034de66995b876b2ba9bfd0274025e39168e05d":"相對強度指標陣列","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"使用有期限的數值清單計算相對強度指標 (RSI)","a9842c95766da40bf4ea6ee263cb5a5985847763":"簡單移動平均線","347775a293c14362d492f019e677c965be1d6e7d":"從有期限的清單中計算簡單移動平均線 (SMA)","4cc7b9e53d082896ad884eb01be16320af65f282":"簡單移動平均線陣列","2c75179a57af3c36581008b65e86ed81c4a4cbea":"從有期限的數值清單中計算簡單移動平均線 (SMA)","39f024cf49724fe7ffdea7773c72ed06eec998e1":"有間隔","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"方向是","ad47561efb1dcbd7246d9b64487f615647fda036":"「真」，如方向與選擇匹配","05bef508aadd62bf3967dcf67d769da296f19989":"跳動點方向","21bfc78607d3a64de767a6677d1db42156d5039d":"返回購前區塊收到的跳動點方向。如果跳動點比以前多，它的數值可能「上漲」，如比以前少則「下跌」及如果跳動點與前相同則為空（「」）","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"方向區塊已過時，請改為使用檢查方向區塊","cdb31fc857f01a59f664413498293c714285f46d":"蠟燭圖線清單中","20fd5f86f08796f145d69dedc209a27e459b2f51":"從結束端獲得 #","a96606af8c33ac3428b45abc4782dbf93f458d29":"得到第 n 個最近蠟燭圖線","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"最後數字清單","248428facb97408414180d4de74e4db35360fbc4":"返回最後點數值清單","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"最後數位","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"返回最新跳動點的最後數位","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"蠟燭圖線清單","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"返回蠟燭圖線清單","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"做個清單","a4220593d385a720886f7af1ed3c478fd0c6339c":"蠟燭清單數值","cd8cdf3d47e921c8a72addae9269e66041d417c5":"返回選定蠟燭圖線數值清單","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"蠟燭清單讀取 ","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"從結束端獲得 #","aba43a580daa7f306956ec69b83e6e37e7233126":"讀取最近第 n 個蠟燭圖線的選定蠟燭線值","e04b522218a181cf0223042dd18ae08dcc22d8d3":"最後跳動點","6ee445fc253a55c9ed54c009c3f020ac65200d80":"返回購前區塊收到的跳動點數值","ed44b69176217a1251c04f0c13d23ac789ea60b2":"最新跳動點字串","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"返回購前區塊收到的跳動點數值 (字串)","4b2340a890e88d1886757c3f7172e273a1edc31f":"每個跳動點都呼叫這個區塊","b54d7b4590559dad64f02d09aacbf6d9863e2624":"不論是否有交易，可以使用此區塊分析跳動點","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"跳動點清單","17649cac8739adcae95e641f794880272ad33bd1":"返回跳動點數值清單","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"跳動點字串清單","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"返回跳動點數值清單 (字串)","c67ded6b64019212eb2bc69afd761f5b3f626040":"給數字新增符號，以製作障礙抵消。","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"市場","74751e67c3e1010c343095eaf543e7cb21ced2ef":"交易類型","1f4698382842477e211eb46de81fa506f01a8c34":"兩個","c1baf816aac5a5cd849768773fc248cd249dc296":"合約類型:","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"預設蠟燭間隔︰","9693aeaaf68e3929b59b79306feaa0a847d01192":"持續時間︰","78d7103a319e808455d397513279d99f3b3f3768":"投注資金","10c02649e226d430bd75a5b6315a41c0db9992a2":"障礙","837276742aa90209dde3b4eef07d8e7ab26731ef":"預測","258b49925b41751c6bd790a0848246566ba61440":"重新開啓買/賣出錯","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"此功能禁用，以便改善性能","b410994b67e37d9516eb9b866c85a8c639f79e68":"重新開啟最近交易出錯","2260c5a971c2602834ef8feeb5fa522f900b469f":"bot 忽略不成功的交易","0745acf92abd7b60598f161717884cc45dab8694":"開機時運行","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"定義交易選項","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"定義交易合約和開始交易，在這裡新增初始化。（在開始上運行）","4d22b565e4253e92a908f216184779679bb1a044":"高障礙","b70c38c6db3127422e05315c30bdf76c7c36c480":"低障礙","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"絕對","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"餘額:","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"得到剩餘數字或字串","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"忽略內部區塊","d072c2ceeb5c1217722d14c74de7aeab945b4215":"把區塊放在這裡，以防止被移除","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"鍵: %1 數值: %2","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"返回鍵值對的字串表示形式","b06acc4158c824231f727a13e1c9811f43d5be42":"從此處載入區塊","661db37251a1ed1afe357ee13895f37a623d7cbf":"從此 url 載入區塊","6c03ee54ad3a51fc92a1d69943e99667847705b6":"通知","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"帶聲音","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"建立通知","6e0fc122f936f808bc2e3af661121b65712ae855":"通知Telegram %1 存取權杖: %2 聊天 ID: %3 訊息: %4","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"給Telegram發送訊息","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"利潤總計","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"返回總利潤","532e65f6e266db0bb442d1f426d44d7d32962340":"總利潤字串","78e84591ff76f992953a8e19b57c7eab7546d638":"返回總利潤 (字串)","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"運行次數","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"返回起始至今的運行次數","7d500ebe352ccfa932b253e21938813a06fcff8e":"Webhook URL: %1","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"給 URL 傳送 POST 請求","a35646754dbe7a9211ba8b81338a5d64580eb276":"空裝載","69b0648eddd207cd45a9e1ba973dae287b535576":"裝載:","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"蠟燭圖線是黑色的？","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"檢查看蠟燭圖線是否黑色，如果給定的蠟燭圖線關閉少於開放，返回「真」。","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"做個清單","5925d08228e246f07b790b88ad70c1b73a97d2bc":"蠟燭清單數值","852b438f91ad9eb2cdd84419a675a216d543c687":"讀取","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"蠟燭數值","d79d854dcd0829e2177a47beab6a55569e781ab1":"讀取 （從蠟燭圖線清單讀取） 蠟燭圖線的一個欄位","5606b4460ac96063b8a8e5647008f3ec97252fc5":"Epoch以來的秒數","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"返回epoch時間（epoch以來的秒數）","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"運行每個","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"秒數","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"運行每隔 n 秒鐘內的區塊","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"每秒運行的區塊已被否決。如果有可用的案例，請與我們聯繫。","7b9c76088576a64f32d67ec335162b9f73eaa026":"過後運行","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"n 秒後內部運行區塊","e9fb732dde76a6977bcaa2818b0f56125b183648":"至日期/時間","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"將自大紀元以來的秒數轉換為代表日期和時間的字串。範例：1546347825 將轉換為 2019-01-01 21:03:45。","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"至時間戳記","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"將代表日期/時間字串的字串轉換為自大紀元以來的秒數。例如：2019年1月1日21:03:45 GMT+0800 將轉換為1546347825。時間和時區偏移是可選項。","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"用 Binary.com 電子郵件和密碼開始使用 Deriv。","64f72129852fb7bdff0725c71324a012630f53bf":"歐盟國家的金融產品交易由Binary Investments (Europe) Ltd提供，地址為W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta，由馬爾他金融服務機構監管為3級投資服務提供商 ({$0}執照號碼為IS/70156{$1})。","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"歐盟以外地區，金融產品由Binary (SVG) Ltd, Hinds Building, Kingstown, St. Vincent and the Grenadines 提供服務。Binary (V) Ltd, Govant Building, Port Vila, PO Box 1276, Vanuatu提供服務，受瓦努阿圖金融服務委員會監管（{$0}查看執照{$1}），或由Binary (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands 提供服務，受英屬維爾京群島金融服務委員會監管（{$2}執照編號SIBA/L/18/1114{$3}）以及由Binary (FX) Ltd., Lot No. F16, First Floor, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia提供服務，受納閩金融服務管理局監管，並開展貨幣經紀業務（{$4}執照編號MB/18/0024{$5}）。","10dd345bc3319e2151794428b2c709dc5fc381a7":"某些國家如美國、加拿大、香港、日本或18歲以下人士無法使用本網站的服務。","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"風險警告","ad0fc99c05681528248b73007dba16fd760a81c6":"通過本網站提供的產品包括二元期權、差價合約 (CFD) 以及其他復雜衍生產品。二元期權交易不是每個人都適合。差價合約交易有很高的風險，因為槓桿作用可能對您有利，但也可能會對您不利。因此，本網站提供的產品可能不適合所有投資者，因為所有投入資金都有虧損的風險。您不應該將您無法承擔虧損的資金投入交易，也不可使用借來的錢交易。對所提供的複雜產品開始交易前，請務必了解所涉及的風險，並了解{$0}負責任交易{$1}。","1fda2716eb92e0195ff59b110af23d86b43fd909":"歐盟國家的金融產品交易由Binary Investments (Europe) Ltd提供，地址為W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta，由馬爾他金融服務機構授予執照及監管為3級投資服務提供商 (執照號碼為IS/70156)。","be7786af641b859c03ec152461d791480cf676ed":"英國和曼島的波動率指數交易由Binary (IOM) Ltd. 提供，地址為：First Floor, Millennium House, Victoria Road, Douglas, IM2 4RW, Isle of Man, British Isles；(1) 由不列顛群島曼島博彩監管委員會授予執照和監管，目前線上博彩執照於2017 年8 月31 日頒發；及(2) 由英國博彩委員會授予執照和監管(執照 {$0}編號: 39172{$1})。","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"歐盟其它國家的波動率指數交易由Binary (Europe) Ltd提供，地址為 W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta。由(1) 馬爾他的馬爾他博彩局授予執照並受其監管（執照號MGA/B2C/102/2000, 發照日期為2018年8月01日）。英國客戶由(2) 英國博彩委員會授予執照和監管(執照{$0}編號: 39495{$1})， 及愛爾蘭客戶由(3) 愛爾蘭的稅務局授予執照和監管(遠程博彩公司執照號: 1010285，發照日期為2017年7月1日)。查閱完整的{$2}監管資訊{$1}。","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"Binary.com 是多次獲獎的線上交易提供商，幫助客戶通過二元期權和差價合約在金融市場進行交易。基於波動率指數的二元期權和差價合約交易被歸類為博彩活動。請記住博彩活動可能會上癮，並提醒自己要承擔責任。查閱{$0}負責任交易{$1}]的詳細資訊。一些產品在所有國家都不可用。本網站不向一些國家如美國、加拿大、香港、或18歲以下的使用者提供服務。","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"二元期權交易並不適合所有人。因此，請確保您完全明白有關的風險。虧損可能會超越起始資金存款，而您並不擁有或占有任何標的資產。","496a99878841de69368c33af9e88eb37c0da5712":"差價合約是複雜的工具，並且由於槓桿作用，資金迅速虧損的風險很高。進行差價合約交易時有78.6-% 的零售投資者帳戶蒙受虧損。 您必須考慮自己是否了解差價合約的運作方式，以及是否能夠承擔資金虧損的高風險。","a726d863bbdceba7b06a1083026a53db76de47b7":"乘數期權交易","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"即使虧損也不會超過下注金額的情況下擴大潛在利潤。","febe8aef26fb3017be5bf43d66f7972731c20833":"點對點支付","a8c1114d1c88db12afa05b331188ceb77afad6e3":"崩盤/興旺指數","d29324705a18a81ffc0376f3f37639a68827f3e6":"預測令人興奮的峰值和跌幅並可能從中獲利。僅在 dTrader 使用乘數時可用。","ba2098a209e375402a0cf222cec87cce26440767":"僅 Deriv 可提供","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"光明的前程。","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"在 Deriv 找到這些附加功能和更多內容：","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"來看看","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"SmartTrader","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"經典期權交易平台","64dfd7424a05133b74cfb93fcbe385ede6539855":"經典自動交易平台","824d76b124e6289f372e2ff6bcba91e8939343bd":"瞭解更多資訊","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"Deriv MT5","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"全球馳名的差價合約交易平台","54617a018fc6dffb3a70627b97f0db5c52a4081d":"DTrader","dbcd68f389d64fc531a650652c87b7d83fc82d94":"旗艦期權和乘數交易平台","dd69c213333a751a0ab3bc9ce6368588bf971b61":"DBot","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"新一代自動交易平台","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"Deriv GO","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"使用行動交易平台隨時隨地交易","f63714db18c58c6b4a7a7bad09178faaeca05104":"Deriv X","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"可自訂的差價合約交易平台","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"Binary.com 您喜愛的一切以及更多新功能","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"7 個平台供選擇","029582bad299ab8f44c57b961210e56569efd536":"您會發現 SmartTrader、Binary Bot 以及 DTrader 和 Deriv X 等新平台。無論交易風格如何，我們都能提供相應的平台。","9a07439b57e510e8e33b372aad2c360dbc39e79c":"差價合約、數字期權和乘數交易是令人興奮的嶄新交易類型，可以在有限的風險下提高潛在利潤。","3d0be0e8eb736257254698ba821c45389e385f1e":"通過法定匝道存入加密貨幣","c4303d30e60f01fa922400e52df4e96d71b35d6e":"100+ 種工具","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"隨心所欲交易 — 外匯、大宗商品、股票、股票指數和綜合指數。 ","f30ce7459f29851b219b504216581bf3d3446de0":"需要時提供支援","6df6091514ee13992a3ac28445af1d9a1afbcb67":"取得全天候客戶支援並存取幫助中心。","92c8b7b779e7cf179b89484285fd766274b3bf1f":"立刻探索 Deriv","a87a92c5ce4925186a081cf4478639fcc31b12ed":"歐盟國家的金融產品交易由 Deriv 投資 (歐洲) 有限公司提供，地址為 W Business Centre, Level 3, Triq Dun Karm, Birkirkara BKR 9033, Malta，在馬爾他取得執照。 ","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"(執照編號 IS/70156)","720280451c98ceeb796f3c7fa118813fc8da694d":"並由位於Triq l-Imdina, Zone 1, Central Business District, Birkirkara CBD 1010, Malta 的馬爾他金融服務機構監管。由金融行為監管局授權並被視為許可變更。受金融行為監管局監管。消費者保護的性質和程度可能與英國公司不同。金融服務合同制度的詳細資訊，包括允許歐洲經濟區的公司在有限期內在英國經營，以開展履行現有合同所必需的活動，可在金融行為監管局的網站上找到。","0f1dda628bebb4748de6df05fa3bff4989c1b476":"在歐盟以外，金融產品交易由以下公司提供：Deriv (FX) 有限公司，地址為 F16, Level 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia，由納閩金融服務管理局發予執照 ","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"(執照編號 MB/18/0024);","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"Deriv (BVI) 有限公司，地址為 Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands，由英屬維爾京群島金融服務委員會授予執照 ","a56aa088dfea506d5dbe18f385c29418f771a639":"(執照編號 SIBA/L/18/1114);","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":" Deriv (V) 有限公司，地址為 1276, Kumul Highway, Port Vila, Vanuatu，由萬那杜金融服務委員會授予執照並受其監管；以及 Deriv (SVG) 有限責任公司，地址為 Hinds Buildings, Kingstown, St. Vincent and the Grenadines。","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"Deriv 有限公司 - 13 Castle Street, St. Helier, JE2 3BT, Jersey - 為以上子公司的控股公司。","74e8fa69aad80f93303a7723e5a304f3d43560b6":"某些國家，包括美國、加拿大和香港或18歲以下人士無法使用本網站的服務。","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"差價合約 (CFD) 被視為複雜衍生品，可能不適合散戶投資。差價合約交易是複雜的工具，因為槓桿作用會有很高的迅速虧損金錢的風險。您應該考慮自己是否了解差價合約的運作原理，以及是否有能力承受金錢虧損的高風險。此處提到的產品可能會受到貨幣匯率變化的影響。如果您對這些產品進行投資，則可能會損失部分或全部資金，並且投資價值可能會波動。不應該將您無法承擔虧損的資金投入交易，也不可使用借來的錢交易。","5bb3f3499158dbe30af5c725694b321dfe821433":"進行複雜的金融產品交易前，請務必了解所涉及的風險並了解 ","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"安全和負責任交易.","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"我們搬家了！","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"我們以前的名稱是","991753597fde70aab5791de6d50ee8cc49a0bdcc":" Binary.com","efa99ab039a285c6264580bea691a4ffefcbeee7":" 已經有二十年了，現在已到了開啟激動人心的新篇章的時候。","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"向新家打個招呼，","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":" Deriv.","52b8454dc755419beeff2f90cd0fc91def428244":"你好 Deriv！","27ad1d8334221366694c7acdd70fb380857d1e6e":"以後再說","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"帶我去 Deriv","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"切換到 Deriv 是如此簡單","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"只需使用 Binary.com 憑據登入即可。無需註冊。","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"立即嘗試","63fbf7977349e32e4a124ffa047549b720806d73":"隨身攜帶 Deriv","03d42257a2263b2841b9e0ae4b94de117228a33a":"獲取 Deriv GO 行動應用程式，隨時隨地交易。再也不會錯過千載難逢的機會。","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"掃描二維碼下載Deriv GO","6b7499b1513a3cec3da3ff07cdad9b358954021e":"不要等待","b23efda40ddeb801beeebf915669d806744014af":"讓交易永遠趕上潮流。現在就來 Deriv 吧。","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"體驗 Deriv 交易","34075438f939258908cc21d28bf59ab5126dc2d6":"現在就來 Deriv，為交易提供未來保障。","e669443b63757b5ad8571e52393caf2a0a812be3":"您會喜愛 Deriv 的 6 大理由","2c141583afaaa12438b16ee67355c6e3eaf77763":"Binary Bot 有了新家","4e0e045da59b385138ced3203cdb81c3b4cdd135":"Binary.com 已經成立 20 多年，是時候開啟激動人心的新章節了。您最喜歡的機器人構建器 Binary Bot 現在已搬來我們的新家 Deriv。快來看看吧。","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"帶我去 Deriv 的 Binary Bot","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"在我們的新家 Deriv 使用 Binary Bot","1071c645f523394b408a6d285e95331bc583f14c":"5 分鐘後，將向您展示在 Deriv 使用 Binary Bot 交易的好處。如果您忽略此消息，我們將在 3 週後再次提醒您。","be43a8989c5745ec7386ca7c69442165f55dee8e":"立刻把好處告訴我","074603c9aef93515ed33d179e982c67ea7abdb45":"在 Deriv 使用 Binary Bot 交易"}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"逻辑","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"数学","c3328c39b0e29f78e9ff45db674248b1d245887d":"文本","4d064726954a17487f94e931f5b157b733ec22ed":"高级","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"列表","19de69cb601f53a4ea7af22a65c71ae63251365c":"变量","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"功能","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"回路","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"Binary","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"交易的定义","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"购入前","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"购入时","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"购入后","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"跳动点分析","8cf71374fa095a64b5295b672daef8507ec7be6a":"指标","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"工具","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"时间","8d8fd6765e184419cad8b88d1a60c895d79578c2":"蜡烛线","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"杂项","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"日志","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"摘要","9feddbabd7e7309e96c590069057158e96baa8f6":"实况简报","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"二元期权交易和其他类似活动一样，过于沉迷可能会上瘾。为了避免这种风险，我们会定期提供交易和财务的实况简报。","4152043e8c670075d2c919677e835edb0d923cab":"请指定优选实况调查间隔时间分钟数","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"请输入10和60之间的数字。","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"继续交易","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"声明","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"注销","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"联系我们","f7c400ed695f898b8ee9d21664aa17b5bb693828":"登录","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"将程序块重置成初始状态","f98595d541778d86f75ef22b3328a031d20aa16b":"载入新程序块 (xml 文件)","4a1e616226c329a94da7768bc0435a3284478010":"保存现有的程序块（xml 文件）","6b3465ace62f33f0687b4669ac26d95895e9ca52":"将Binary Bot连接到 Google Drive，以便保存及重新使用程序块","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"撤消变更 (Ctrl+Z)","937f5055f05be359ddf619744e8af4d643549e80":"撤消变更 (Ctrl+Shift+Z)","8406d1cce44230835932060649e999ca3283b413":"放大(Ctrl + +)","1109673172af2c173c492622ff8a72c8f29f0e70":"缩小(Ctrl + -)","44c22002c65d2871331263a23c3e09c0a1bfd847":"重设直行","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"显示/隐藏弹出摘要","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"运行bot","ba50a42d8d3228c37a817865fce49fbca692c2ad":"停止自动交易","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"显示日志","91017ef9b165cd0e7475a770f318ea5e705e1321":"显示图表","c89e3dd1cafcadcc0312e476ab58b2332209da23":"显示交易查看","b02c858e72be118a65c9393930351012b647cb9e":"切换标题","250be77f7605669a0b3d968b9ed381a3d9787ed1":"打开已保存的XML文件并取回其程序块","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"Binary Bot","608061fb5aab975013fa70c5c814a1d8ba30c152":"交易效率比您想象的更高","e4ce8dc3e416e69262ba642dc57d3975d6616980":"想要让您倾向的二元期权交易策略自动化？","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"Binary Bot 是尖端的程序设计工具，可构建交易应用程序，只需使用简单的","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"不论是简单的公式还是复杂的算法，请尽情发挥想象力，设计出无限量的二元期权交易bot，即使睡觉时也可自动为您进行交易。","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"立刻建立Bot","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"需要帮忙？","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"需要帮助？","d635b53e59c9aad8c5d78458826beffb029b27bf":"谢谢，我们会在24小时内回复","a69a8fc21499d0fd85e87bab467699827547a5bc":"请输入有效的伺服器 URL","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"未选择标的市场","50050f06645ad2743165b429a8f7deebd285fd63":"未选择合约类型","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"请登录","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"持续时间必须是正整数","4df6e872792d72aea8a2f6b831d00b554464da23":"金额必须是正数","001e68df3a4b32a4d57148d9d407f44eee3b7436":"无效的烛形线","04f14ea7c92e0b2b5ae005c696245063ec641d66":"无效的烛线列表","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"重试间隔时间为","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"以下数额已达最大限制","094628ce13fc0e78f07b697d1cc9421bb2edd666":"以下请求已失败","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"否","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"是的","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"声明","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"卖价","50e72909992bdc37c7c07769d1b7efac5e52874c":"赔付额","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"利润","c980b910204c7babdffe8ff3f7e755f30133383c":"合约类型","a726c6955157f1b8b92f9932652434a7150f80f8":"入市现价","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"入市值","3905be81561384dc8c43d6127c57ed1e0eb03b74":"入市值字符串","7674920c033ca14277c577e19c037a6754d4fa80":"退市现价","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"退市值","06ecea26625359f7dcf5ff5c47af6174ff815257":"退市值字符串","779455ee3bde8494d9629b353e17b19e92357ba8":"障碍","37a5301a88da334dc5afc5b63979daa0f3f45e68":"结果","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"赢得","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"损失","563339f82447b4e758ad76d5a0b63b5698594fba":"上升","5c1ae82c29543ac887703776bf3da2c7dcce683d":"下跌","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"没有变化","ecb252044b5ea0f679ee78ec1a12904739e2904d":"字符串","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"数字","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"绿色","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"蓝色","96de5543d183d7de52ac5fa21c46fc811f673f89":"黄色","78988010b890ce6f4d2136481f392787ec6d6106":"红色","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"无提示","cf84a98d6cf7f156862a08ba8236467b6f471004":"公告","eee2facd669d1434848c24da5527b3e87d9a12d5":"赚取的钱","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"完成工作","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"错误","a3b1583d377f37ac20de7e089edfa0920a078e57":"严重错误","66c8b6848eee629c4ac551bf2b5fa591571654be":"上升同价","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"下跌同价","062787aa328047e189774b3703d983b83938f6e9":"高于","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"低于","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"触及","7d7932bcc2e262ae98cf09dc5445130fb3881769":"未触及","a16814a48ec58c2e24ba224a80921a5c02361abe":"范围之内收盘","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"范围之外收盘","534ec5da4e82ec419abc170e1a8448f55a01664f":"保持在范围之内","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"超出范围之外","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"亚洲上涨","c098658ce3d3a258e4d155949a60072966b36db7":"亚洲下跌","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"相符","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"差异","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"偶数","dc28f5f3c65ec611f0f30022650d24382d27448e":"奇数","18a63f5512afb5573e5b44deba78d629f0635317":"大于","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"小于","2155c8b38181dd2552e84a94049aacd33ef9c607":"高跳动点","1408cfd2b064b923f024fbe590e27db8282941a5":"低跳动点","b86eb15dc4f13e4c2972de158d3038d9f657242f":"重设买权","669a1f3d9a8f601a84da536cfdad1de4092b1926":"重设卖权","844d1a5c99a0a668383340cc095d040eef998c79":"只会持续上涨","87293a146cd481a2b30cf74282ec061dc4cf0735":"只会持续下跌","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"开盘","b1a5954a483f8f8b0207385095f74aeb409b3f80":"高","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"低","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"收盘","1173872a4fb205b713702f0eec5cf2c732c828fd":"开盘时间","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"默认","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"1分钟","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"2分钟","24e46784cbce32443db5a2638b1a7d3201543e9b":"3分钟","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"5分钟","a6f151883b736f0470d33492e61c72a7d059d065":"10分钟","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"15分钟","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"30分钟","f030c3d667652646b86732ad7bc67e226c49cd3a":"1小时","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"2小时","7b47150d431db70d783724007f07ab894eb8ac2e":"4小时","191800b7e9a48680792c0dd77cb6cac00c4514c6":"8小时","2d8a6f7c34468578640b333b8650131de06ac770":"1天","cd1495cb4c60266a6abad9024022ae079bf7e416":"(1) 定义交易合约","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"(2) 查看并购入合约","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"交易选项","160f06d4799c85021a810f68c5b517eea37a2737":"购入","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"上涨/下跌","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"上涨/下跌平价","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"亚洲期权","2260ce49306460c8a2ef501939f29ad6ddd4e934":"位数","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"触及/未触及","f7de1f66f0979667da275b7e8996e805395025a1":"范围之内/范围之外收盘","a431deecd4c2258097adae418d496fe9a8179fee":"范围内/范围外","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"高/低跳动点","12a3f461cdebbc8f335190413ee6c57442743bba":"重设买/卖权","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"只会持续上涨/只会持续下跌","91a64e3f83c91acf336c631fba295f297f94c399":"n 秒后运行","024696596f26a4db232fd9e966eadfeb27c0bd1a":"每n秒运行","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"上部","85c274929bc0e28eafd3734f2c25046c3b95b36b":"中部","346e3ee198e98146993894d3de8ecab1a86c3e80":"下部","f16459104f92ab6b38aa265adb4ecbfc3768e303":"直方图","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"指数平滑移动平均线","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"信号","19eabc961735d78f12fc7be906ffcb033853cf85":"时间戳","68f4145fee7dde76afceb910165924ad14cf0d00":"消息","e99811bd3b1ad17e74614060ecb180602be35ad6":"您已被注销！","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"须添加程序块到工作区","1fde9f1ebca07dcbc704130bd18645bce7718b55":"须启用程序块","d466687f90ba548434d65186d11a80c4204f9ad6":"必须添加进去:","629777b7d4d610ace6dee24442730f27d7d0853e":"不支持的文件︰","0b93c14956403c2e5c9e79f5c836babc56912006":"Binary Bot不会进行任何新的交易。已经确认（但未过期）的所有交易将由我们的系统完成。 任何未保存的更改都将丢失。","c1458ff86fd60d9544d7cd8a67437df2b766f482":"注: 有关已确认交易记录的详细信息, 请参阅 Binary.com 声明页面。","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"任何未保存的更改都将丢失。","410bf23a3f080def9c7a976a16305bcde7943ed1":"是否确定？","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"对不起，您的所在国不可用 Binary Bot","901624741023fcfc805ce43c94b8012e3b1d1c99":"想在 MT5 交易差价合约？您将可以访问外汇、股票、股票指数、大宗商品、加密货币和综合指数。","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"策略","910ec7aa40b04ec6ba51162f4de7850569326cb6":"加载 Google API 脚本时出错。","8f51f350debde84e067e1a0405fb6304922a7d4b":"Google 云端硬盘初始化时出错.","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"加载 Google 云端硬盘库时出错","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"请授予权限，以查看和管理Google云端硬盘文件","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"无法识别的文件格式","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"从 Google 云端硬盘检索数据时出错","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"选择Binary Bot策略","2db43c69a4b96454914f0b8272bc869984529e6e":"从 Google 云端硬盘列出文件时出错","0dcea5f584938e0fff00084b83156ab31d641ab3":"从 Google 云端硬盘检索文件时出错","18da95988117ff029393f3f5c881d70ef47f7385":"处理请求时出错","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"选择文件夹","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"Telegram通知无法发送","3f370309b6280eb100f898426d8605c1f45d558d":"无效的时间戳","af6a4e2a5582be89ac930e946eaed86e01cac58b":"无效的日期/时间","49d51398b574e7312d99b18d2b93d2ede416f053":"无法发送 webhook","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"建议还没有准备好","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"选定的建议并不存在","6ea4a034747d020b1d8ce4848def95d537555dd6":"已买入","89f89c02cf47e091e726a4e07b88af0966806897":"ID","1200c1af2f7bba4e29a34112865662748c9d41df":"此合约不提供转售。","62d6180e55905f7b996d442c53631981a4ef8b5b":"已售出","ed4978867de1da05b336b724a3fb96222a29ebec":"指标必须是正整数","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"利润总额","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"损失金额","46fc6f27a835486d63d9e927c6687e4508cb3087":"最大达成交易的数目","9202ddae4cea16513e53bbc965d88ed975e59512":"最大损失金额","5f52b397b7e5f538681f0f5717a88aa626349c7a":"未调用Bot.init","66c7734789e19cbeef3a5ac185ea732139aed213":"图表","3b662fb2e8bafce29aa98321b18874bb44905488":"Google云端硬盘集成","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"请到自我禁止设施页面设置每日亏损限额以允许交易。","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"最大连续交易数须是1到100之间","93039e609d94a24f3572b794a31b21525a09af2b":"未设置","a85b8cc112a8597df1612d60a74faa818c25d1b3":"须设置符合商业规则的交易限额。请注意自动交易机器人仅将在以下条件之一或二者都符合时才会停止交易。","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"每日损失限额:","95052a29f213e9698b593418fe396ecc21032f9b":"此阈值限制当天在所有 Binary.com 平台的潜在亏损。 一旦总亏损达到或超过此金额，机器人将停止交易。请在{$0}自我禁止设施页面{$1}设置一个值。","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"最大连续交易数","730657200c17321d926e1bd08dbf65bd96855a8a":"这是允许机器人为此次运行执行的最大交易数。","952f375412e89ff213a8aca383d18e5691354347":"开始","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"交易限制","095ba68888b5ace5f4515f5acab76dfa1073544e":"我的电脑","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"加载","248e224f533752db28a1aab3519a58569ad96140":"加载数据块","c7097e97dcc446ca889d3ca6be733a65e2728afe":"已成功上传到 Google 云端硬盘","a6b977714595aa01678fca98e86553aaeac05c92":"将区块单独保存在集合中。加载时，它将被添加到现有的工作区（主区块将被替换）。","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"另存为集合件","611ebbfb080284312904de925ef0f75f4cb56ad2":"保存数据块和设置, 以便在其他策略中重复使用","efc007a393f66cdb14d57d385822a3d9e36ef873":"保存","a638caa8ab2b7ff7980a571334217339e6d1d634":"保存程序块为","39fca63515c105918f03e4908ec12df675b07f92":"交易查看","e643975ea5296d9de4486458f31ab0a5a2b228bf":"这将清除摘要面板中的所有交易，所有计数器将重置为零。","85dfa32c97d8618d1bea083609e2c8a29845abe5":"账户","d847919a30d31c0be624087f3370492b3fdf80c6":"运行次数","5cd6978d63540c8a490ef76f43219de6362f958e":"总投注金额","17410d7b62b8b1de981cfebada24632987edf186":"总赔付额","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"总损益","90eef613042c5a51f542421065b68b886d473807":"余额","db1c784524e1b54011a95823026161f7c8517fe0":"引用","4db3e9e4aecd187db9339a10d2629fef46724dc4":"交易类型","1bb4086b66659d8580f9be4beef69931aeea3cad":"入市现价","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"退市现价","ba7be969e7c1bb5f22489e843478e3d721aaa843":"买入价","772fbced18230220d2d9be1456be16fc1b271d25":"利润/亏损","bae7d5be70820ed56467bd9a63744e23b47bd711":"状况","96f608c16cef16caa06bf38901fb5f618a35a70b":"待定","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"已结算","82a82f798dd773717ec37d15fd4405510291734e":"自动交易已停止。","6a88e58aa1798626f94cf17f1a91618b405bb289":"Bot 将开始...","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"自动交易正在运行中","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"Bot 将停止...","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"Bot 已停止。","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"试图买入","4684ee1026d9b4c872d016c3c4588a0c479a451c":"买入金额","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"购买成功","f02760cd2eac28169f0a990c950c3dfe8427f772":"合约已终止","c7363d8a0748d4a7e2cc968335dc9716f290359d":"停止 bot 将阻止进一步交易。任何正在进行的交易将由系统完成。请注意，如果在下单交易期间停止 bot，某些已完成的交易可能不会在列表中显示。可以参考 Binary.com 声明页面了解所有已完成交易记录的详细信息。","fadc0ef93d1ff13370524ce8481ddc4a71195934":"重设直行","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"下载","e4458464df6cbb8da1134875ba51519c5d244d9f":"程序块必须位于程序块定位器、主要程序块或函数内","e9c45563358e813f157ba81b33143542165ba84e":"警告","31cb6f44d030abeabcc7046555dea851602a87a5":"您的国家不能使用此策略。","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"确定","9970168c192807246fad6138344e5a96449afbdd":"XML 文件为空。请检查或修改文件。","a594b427eaf0f108d3e9cc20d70e15da811c760c":"不受支持的策略","04a5090686ac7b54822e00a9ff08c38a107601e7":"抱歉，此策略无法在 Binary Bot 使用。仅可在 DBot 使用。","77dfd2135f4db726c47299bb55be26f7f4525a46":"取消","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"带我去 DBot","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"尝试打开的文件在以下程序块中包含不受支持的元素：{$0} 请检查文件并重试。","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"无法加载程序块文件","af145748c9cf765a3b059eec20cb1dbb899297d8":"程序块加载成功","11ee9c5d534cc8d22651092222b532917594161a":"最小持续时间是","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"跳动点数必须在5到10之间","ace1342bc3720b77ce510b93074041e7386d209e":"到期时间不能等于开始时间","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"预测必须是单位数字","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"必须添加进去","33aa6ff282ee509d37c6f758274c9156b419ff73":"尝试导入的策略无效。","da162a909c2981ed318d23cd9a6be1d66e0a8400":"无法识别的文件格式。","5e719fa76e1b6cb396376c82ebdd04bec7253229":"远程程序块加载必须是集合件。","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"无法加载程序块文件。","df84a88f38b03b5b342362d72370b0d66afdae35":"目标必须是 xml 文件","cd680fd936e9559ef1d95efac7a71680e2b13a89":"此 url 已经加载","34c59389053701a04127f74d32315e0206e076f8":"尝试加载 url 时发生错误","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"请确保 '访问-控制-允许-起源' 存在于来自服务器的响应","988df856c066143616bd33d5904bbcdc22ff129e":"Binary.com 将移至 Deriv","2fccaab15d71b00c19da7053135471d510b513db":"在 Deriv 交易","3ead0b14c72503187691a7a6d7121987299bd401":"这不是官方版本的Binary Bot，如使用，需自己承担风险。","27401c9c8e476d659c8382e05c6d70a4a82be468":"官方版本","bc981983e7f547dc62e19a1e383acfe00782a6d5":"下一页","b52b36b7269fbfc58ec24bb724691951a3decbe8":"返回","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"完成","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"快速浏览","a48e81d4a8da67637b46725824177a959fe99b21":"准备好学习如何使用Binary Bot 了吗？","6f3e6ebf249947cec4f64117253a8fe43335ae79":"不，谢谢","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"不要再问我。","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"工作区","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"拖放程序块文件或制作自己的策略。","d171baee235d4c93f63755a876782dc5be4c3e47":"程序块工具箱","056f19272d96f902c38207cf163ea8dbff7fbd32":"从这里添加更多程序块到机器人程序。","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"账户","f5c47fd3b3553b10441a06054078cea745177dea":"启用机器人程序前请先登录。每次测试策略时请使用虚拟账户。","fd825ae94aa79500a878dd4590a4b360e7162663":"Bot 控件","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"控制程序块。将光标放在每个按钮上即可获取更多信息。","f5169c84497de3aea74f7da9e7e177d1427e736b":"享受其中乐趣！","4f1b3d682c2a00b393c33637da402463bc11d5ff":"想要报告问题或寻求帮助吗？","0049f8894e41937ebb9111cd3def6749049fb50f":"请单击此处","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"在 Deriv 哪里可以找到 Binary Bot","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"在 Deriv 主页点击页面顶部的交易，然后选择 Binary Bot。","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"试用 Deriv 的 Binary Bot","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"是您所熟悉和喜爱的 Binary Bot","169dd3b2025485a48b8f9f3f6ef89f5586714140":"一切都是您喜欢的方式。","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"让机器人顺场地移过来","b763f8cbfa6396f195781032619a99bba04bc939":"Binary.com 的策略可以在 Deriv 使用。只需加载 XML 文件即可开始交易。","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"7 个交易平台——旧的最爱和新的一起","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"您会发现 Binary Bot 和 SmartTrader 以及 DBot 和 DTrader 等新平台。无论交易风格如何，我们都能提供相应的平台。","0ce7480da93c1c9839818d0720b77931d1637574":"通过法定匝道存入加密货币","6e6a4c6839d2e859758a517865b095c1b8298dd6":"通过 Changelly、Banxa 和 XanPool 等兑换服务轻松进行加密货币存款。","c1b51f196c97b4781a354457579e9699b09de087":"3 种交易类型","4708f7e87263464b130b987e4b9aed981c4f455d":"差价合约、数字期权和乘数交易是新的、令人兴奋的交易类型，可以在有限的风险下提高潜在利润。","b7fceac7d5f885d735aeda6e4654487467d33fa3":"点对点存款和取款","79a206119137878eb6be7c60f7ed34135194bdf0":"通过 Deriv P2P 与其他交易者兑换当地货币，以便从账户存取款。","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"6 种市场类型","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"通过广泛的市场如外汇、股票、加密货币、综合指数等扩展投资组合。","14b2a808fdec3702e5a6b9152e13288c87a4768a":"在 Deriv 学院学习","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"享受免费文章和视频，帮助了解在线交易的技巧。","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"单击选择","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"不可用","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"跳动点","5fb1db527825d2996e37c655e5dec49d4da80c09":"秒","092f99ea11a34a8490e7a767a83a42fc45634f82":"分钟","9e25a34e635a123f8958bbe26e7c4843278597fb":"小时","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"日","db6708630fc646eb98298d9acd701e0a1ac051c2":"将程序块和策略保存到 Google 云端硬盘","85538d002a336c5addef8d189d80976cf7758f8c":"登录ID是","b65463cb6a42a17de514acc4659f7fd331e0876a":"连接","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"断开","cd5f85b6f187605f82386eacd680f93820af8d11":"结果是","1e38ce3d180cefae485a6986ca7c67841e30376f":"如果结果与选择匹配，请回答“是”","5c89497fc3c128e2ff865ce8df15356054f2c028":"(4) 获得交易结果，并再次交易","14ea81918758c994cbe3178e695e56afc1ef2b45":"获得以前的交易信息和结果，然后再次交易 （在交易完成上运行）","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"合约细节:","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"从合同详细信息列表中读取所选的选项","b3b543c80063a116ced4965d8537b7b62d14c0b7":"再次交易","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"再次运行交易程序块","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"卖价","343fda69c73b78b84967055aae97f790c422adfd":"选定建议的卖价","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"查看看跳动点流向和购入所需合约（在跳动点更新上运行）","9bb396940adb9705fe57eba6ea8b578e6aafa792":"赔付额","87da93a46d143f6019979b3548414d9d7adabb35":"选定建议的赔付额","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"购入选定的合约。","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"可卖出","03bad10717e183b24829baf483dc715e1a44bf7b":"如果市场上可卖出，请回答“是”","2c71ed279a402e93312dbda173ab18f244d6bf46":"(3) 查看和卖出已购入合约","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"查看已购入合约的信息，如可用，则在市场上卖出（合约更新上运行）","579607dc4f989ce2b94b558431666a0ab07ac1f3":"在市场卖出","e20afd5cf3811a42071c9a312abb2afdad4c590b":"在市场卖出。","4712cbff8e92822fc960ef9c0197293a19675eae":"销售利润/亏损","df817b48c7a076561b4f8bedc52d65d2e351ab52":"返回在市场上卖出的利润。","b44e884c355e447d0da0e6ba45caaff18c84373b":"布林线","d6a2a207343bd83aacdc80b579ff4419713a256e":"输入列表","170a28a9db6d27d7212fc6dc249434a57517e7bc":"期间","b833989d69900a4be9e32d1bab65c8f8233f099e":"标准偏差上涨乘法器","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"标准偏差下跌乘法器","974da601086448d0060aeed90e53ddd5acd17b91":"使用有期限列表计算布林线 (BB)","d5b65cac1f1cf9421ac978eebe532de99040cca6":"布林线数组","58de49791c64aba14e36e5887244a5ef088286cd":"使用有期限列表计算布林线 (BB) 列表","4bd99f76f1104229744455d93df0ff76b9eeed58":"指数移动平均线","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"使用有期限列表计算指数移动平均线 (EMA)","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"指数移动平均线数组","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"使用有期限数值列表计算指数移动平均线 (EMA) 列表","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"指数平滑移动平均线数组","b18e572ea14edd48587145f1ef50718adbf256c6":"快速指数平均数指标周期","974023bddd6249d0f6404872cfcae205b2599ea2":"慢速指数平均数指标周期","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"信号EMA周期","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"从列表计算指数平滑移动平均线 (MACD) 列表","95ec92885c855ba9cf734c17a43f081901e4d2cc":"相对强度指标","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"从有期限列表获得的相对强度指标 (RSI)","4034de66995b876b2ba9bfd0274025e39168e05d":"相对强度指标数组","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"使用有期限数值列表计算相对强度指标 (RSI)","a9842c95766da40bf4ea6ee263cb5a5985847763":"简单移动平均线","347775a293c14362d492f019e677c965be1d6e7d":"使用有期限列表计算简单移动平均线 (SMA)","4cc7b9e53d082896ad884eb01be16320af65f282":"简单移动平均线数组","2c75179a57af3c36581008b65e86ed81c4a4cbea":"使用有期限数值列表计算简单移动平均线 (SMA) 列表","39f024cf49724fe7ffdea7773c72ed06eec998e1":"有间隔","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"方向是","ad47561efb1dcbd7246d9b64487f615647fda036":"如方向与选择匹配，请回答“是”","05bef508aadd62bf3967dcf67d769da296f19989":"跳动点方向","21bfc78607d3a64de767a6677d1db42156d5039d":"返回购前程序块收到的跳动点方向。如果跳动点比以前多，它的数值可能“上涨” ；如果比以前少，则为“下跌”；如果跳动点与前相同，则为空（“”）","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"方向程序块已过时，请改为使用检查方向程序块","cdb31fc857f01a59f664413498293c714285f46d":"在蜡烛图线列表中","20fd5f86f08796f145d69dedc209a27e459b2f51":"从最终端获得 #","a96606af8c33ac3428b45abc4782dbf93f458d29":"获得第 n 个最近蜡烛图线","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"最后数字列表","248428facb97408414180d4de74e4db35360fbc4":"返回最后数字值列表","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"最后的数字","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"返回最新跳动点的最后数字","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"蜡烛图线列表","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"返回蜡烛图线列表","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"列个单子","a4220593d385a720886f7af1ed3c478fd0c6339c":"蜡烛列表数值","cd8cdf3d47e921c8a72addae9269e66041d417c5":"返回选定的蜡烛图线值列表","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"蜡烛列表读取 ","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"从最终端获得 #","aba43a580daa7f306956ec69b83e6e37e7233126":"读取最近第 n 个蜡烛图线的选定蜡烛线值","e04b522218a181cf0223042dd18ae08dcc22d8d3":"最后的跳动点","6ee445fc253a55c9ed54c009c3f020ac65200d80":"返回购前程序块收到的跳动点值","ed44b69176217a1251c04f0c13d23ac789ea60b2":"最新跳动点字符串","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"返回购前程序块收到的跳动点值（字符串）","4b2340a890e88d1886757c3f7172e273a1edc31f":"每个跳动点都呼叫这个程序块","b54d7b4590559dad64f02d09aacbf6d9863e2624":"无论是否有交易，都可以使用此程序块分析跳动点","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"跳动点列表","17649cac8739adcae95e641f794880272ad33bd1":"返回跳动点值的列表","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"跳动点字符串列表","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"返回跳动点值的列表（字符串)","c67ded6b64019212eb2bc69afd761f5b3f626040":"给数字添加符号，以制作障碍抵消。","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"市场","74751e67c3e1010c343095eaf543e7cb21ced2ef":"交易类型","1f4698382842477e211eb46de81fa506f01a8c34":"两个","c1baf816aac5a5cd849768773fc248cd249dc296":"合约类型：","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"默认蜡烛间隔︰","9693aeaaf68e3929b59b79306feaa0a847d01192":"持续时间︰","78d7103a319e808455d397513279d99f3b3f3768":"投注资金","10c02649e226d430bd75a5b6315a41c0db9992a2":"障碍","837276742aa90209dde3b4eef07d8e7ab26731ef":"预测","258b49925b41751c6bd790a0848246566ba61440":"重新启动买/卖出错","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"此功能禁用，以便改善性能","b410994b67e37d9516eb9b866c85a8c639f79e68":"重新启动最近交易出错","2260c5a971c2602834ef8feeb5fa522f900b469f":"bot 忽略不成功的交易","0745acf92abd7b60598f161717884cc45dab8694":"开机时运行","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"定义交易选项","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"定义交易合约和开始交易，在这里添加初始化。（在开始上运行）","4d22b565e4253e92a908f216184779679bb1a044":"高障碍","b70c38c6db3127422e05315c30bdf76c7c36c480":"低障碍","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"绝对","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"余额：","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"获取余额数字或字符串","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"忽略内部程序块","d072c2ceeb5c1217722d14c74de7aeab945b4215":"把程序块放在这里，以防止被移除","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"键：%1 数值: %2","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"返回键值对的字符串表示形式","b06acc4158c824231f727a13e1c9811f43d5be42":"加载程序块自","661db37251a1ed1afe357ee13895f37a623d7cbf":"从 url 加载程序块","6c03ee54ad3a51fc92a1d69943e99667847705b6":"通知","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"带声音","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"创建通知","6e0fc122f936f808bc2e3af661121b65712ae855":"通知Telegram %1 访问令牌: %2 聊天 ID: %3 消息: %4","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"給Telegram發送消息","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"总利润","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"返回总利润","532e65f6e266db0bb442d1f426d44d7d32962340":"总利润字符串","78e84591ff76f992953a8e19b57c7eab7546d638":"返回总利润（字符串）","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"运行次数","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"返回自开始以来的运行数量","7d500ebe352ccfa932b253e21938813a06fcff8e":"Webhook URL: %1","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"给 URL 发送 POST 请求","a35646754dbe7a9211ba8b81338a5d64580eb276":"空负载","69b0648eddd207cd45a9e1ba973dae287b535576":"负载：","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"黑色的蜡烛图线？","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"查看给定的蜡烛图线是否为黑色，如果给定的蜡烛图线关闭少于开放，返回 “是”。","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"列个单子","5925d08228e246f07b790b88ad70c1b73a97d2bc":"蜡烛列表数值","852b438f91ad9eb2cdd84419a675a216d543c687":"读取","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"蜡烛数值","d79d854dcd0829e2177a47beab6a55569e781ab1":"读取（从蜡烛图线列表读取）蜡烛图线的字段","5606b4460ac96063b8a8e5647008f3ec97252fc5":"自Epoch以来的秒数","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"返回epoch时间（自epoch以来的秒数）","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"运行每个","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"秒","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"在每 n 秒内运行程序块","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"每秒运行程序块已被否决。如有可用的案例，请与我们联系。","7b9c76088576a64f32d67ec335162b9f73eaa026":"以下时间过后运行","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"在 n 秒后运行内部程序块","e9fb732dde76a6977bcaa2818b0f56125b183648":"至日期/时间","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"将自大纪元以来的秒数转换为代表日期和时间的字符串。示例：1546347825 将转换为 2019-01-01 21:03:45。","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"至时间戳","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"将代表日期/时间字符串的字符串转换为自大纪元以来的秒数。例如：2019年1月1日21:03:45 GMT+0800 将转换为1546347825。时间和时区偏移是可选项。","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"用 Binary.com 电子邮件和密码开始使用 Deriv。","64f72129852fb7bdff0725c71324a012630f53bf":"欧盟国家的金融产品交易由Binary Investments (Europe) Ltd提供，地址为 W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta。由马耳他金融服务机构监管为3级投资服务提供商 ({$0}牌照号码为 IS/70156{$1})。","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"欧盟以外地区，金融产品由Binary (SVG) Ltd, Hinds Building, Kingstown, St. Vincent and the Grenadines提供服务; Binary (V) Ltd, Govant Building, Port Vila, PO Box 1276, Vanuatu提供服务，受瓦努阿图金融服务委员会监管（{$0}查看许可证{$1}）; Binary (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands 提供服务，受英属维尔京群岛金融服务委员会监管（{$2}许可证编号SIBA/L/18/1114{$3}）; Binary (FX) Ltd., Lot No. F16, First Floor, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia提供服务，受纳闽金融服务管理局监管，并开展货币经纪业务（{$4}许可证编号MB/18/0024{$5}）。","10dd345bc3319e2151794428b2c709dc5fc381a7":"某些国家如美国、加拿大、香港、日本或18岁以下人士无法使用本网站的服务。","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"风险警告","ad0fc99c05681528248b73007dba16fd760a81c6":"通过本网站提供的产品包括二元期权、差价合约 (CFD) 以及其他复杂衍生品。二元期权交易不是每个人都适合。差价合约交易有很高的风险，因为杠杆作用可能对您有利，但也可能会对您不利。因此, 本网站提供的产品可能不适合所有投资者，因为所有投入资金都有亏损的风险。不应该将您无法承担亏损的资金投入交易，也不可使用借来的钱交易。对所提供的复杂产品开始交易前，请务必了解所涉及的风险，并了解{$0}负责任交易{$1}。","1fda2716eb92e0195ff59b110af23d86b43fd909":"欧盟国家的金融产品交易由Binary Investments (Europe) Ltd提供，地址为 W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta。由马耳他金融服务机构授予牌照及监管为3级投资服务提供商(牌照号码为 IS/70156)。","be7786af641b859c03ec152461d791480cf676ed":"英国和马恩岛的波动率指数交易由Binary (IOM) Ltd. 提供，地址为：First Floor, Millennium House, Victoria Road, Douglas, IM2 4RW, Isle of Man, British Isles；由(1) 不列颠群岛马恩岛博彩监管委员会授予牌照和监管（当前在线牌照于2017 年8 月31 日颁发）及(2) 英国博彩委员会授予牌照和监管 (牌照 {$0}编号: 39172{$1})。","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"欧盟其它国家的波动率指数交易由Binary (Europe) Ltd提供，地址为 W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta。由(1) 马耳他的马耳他博彩局授予牌照并受其监管（牌照号MGA/B2C/102/2000, 发照日期为2018年8月01日）。英国客户由(2) 英国博彩委员会授予牌照和监管 (牌照 {$0}编号: 39495{$1})， 及爱尔兰客户由(3) 爱尔兰的税务局授予牌照和监管 (远程博彩公司牌照号: 1010285，发照日期为2017年7月1日)。查阅完整的{$2}监管信息{$1}。","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"Binary.com 是多次获奖的在线交易提供商，帮助客户通过二元期权和差价合约在金融市场进行交易。 基于波动率指数的二元期权和差价合约交易被归类为博彩活动。请记住博彩活动可能会上瘾，并提醒自己要承担责任。查阅{$0}负责任交易{$1}的详细信息。一些产品在所有国家都不可用。本网站不向一些国家如美国、加拿大、香港、或18岁以下的用户提供服务。","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"二元期权交易并不适合所有人。因此，请确保完全明白有关的风险。亏损可能会超越起始资金存款，而并不拥有或占有任何标的资产。","496a99878841de69368c33af9e88eb37c0da5712":"差价合约是复杂的工具，并且由于杠杆作用，资金迅速亏损的风险很高。进行差价合约交易时有78.6-% 的零售投资者账户蒙受亏损。必须考虑自己是否了解差价合约的运作方式，以及是否能够承担资金亏损的高风险。","a726d863bbdceba7b06a1083026a53db76de47b7":"乘数期权交易","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"即使亏损也不会超过下注金额的情况下扩大潜在收益。","febe8aef26fb3017be5bf43d66f7972731c20833":"点对点支付","a8c1114d1c88db12afa05b331188ceb77afad6e3":"崩盘/兴旺指数","d29324705a18a81ffc0376f3f37639a68827f3e6":"预测令人兴奋的峰值和跌势并可能从中获益。仅在 dTrader 使用乘数时可用。","ba2098a209e375402a0cf222cec87cce26440767":"仅 Deriv 可提供","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"光明的前程。","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"在 Deriv 找到这些额外功能及更多内容：","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"看看吧","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"SmartTrader","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"传统期权交易平台","64dfd7424a05133b74cfb93fcbe385ede6539855":"传统自动交易平台","824d76b124e6289f372e2ff6bcba91e8939343bd":"了解更多","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"Deriv MT5","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"全球驰名的差价合约交易平台","54617a018fc6dffb3a70627b97f0db5c52a4081d":"DTrader","dbcd68f389d64fc531a650652c87b7d83fc82d94":"旗舰期权和乘数交易平台","dd69c213333a751a0ab3bc9ce6368588bf971b61":"DBot","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"新一代自动交易平台","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"Deriv GO","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"使用移动交易平台随时随地交易","f63714db18c58c6b4a7a7bad09178faaeca05104":"Deriv X","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"可定制的差价合约交易平台","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"Binary.com 您喜愛的一切以及更多新功能","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"7个平台供选择","029582bad299ab8f44c57b961210e56569efd536":"您会发现 SmartTrader、Binary Bot 以及 DTrader 和 Deriv X 等新平台。无论交易风格如何，我们都能提供相应的平台。","9a07439b57e510e8e33b372aad2c360dbc39e79c":"差价合约、数字期权和乘数交易是令人兴奋的崭新交易类型，可以在有限的风险下提高潜在利润。","3d0be0e8eb736257254698ba821c45389e385f1e":"通过法定匝道存入加密货币","c4303d30e60f01fa922400e52df4e96d71b35d6e":"100+ 种工具","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"随心所欲交易—外汇、大宗商品、股票、股票指数和综合指数。 ","f30ce7459f29851b219b504216581bf3d3446de0":"需要时提供支持","6df6091514ee13992a3ac28445af1d9a1afbcb67":"获得全天候客户支持并访问帮助中心。","92c8b7b779e7cf179b89484285fd766274b3bf1f":"立刻探索 Deriv","a87a92c5ce4925186a081cf4478639fcc31b12ed":"欧盟国家的金融产品交易由Deriv 投资 (欧洲) 有限公司提供，地址为 W Business Centre, Level 3, Triq Dun Karm, Birkirkara BKR 9033, Malta，在马耳他取得许可证。 ","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"(许可证编号 IS/70156)","720280451c98ceeb796f3c7fa118813fc8da694d":"并由位于Triq l-Imdina, Zone 1, Central Business District, Birkirkara CBD 1010, Malta 的马耳他金融服务机构根据投资服务法令监管 。由金融行为监管局授权并被视为许可变更。受金融行为监管局监管。消费者保护的性质和程度可能与英国公司不同。金融服务合同制度的详细信息，包括允许欧洲经济区的公司在有限期内在英国经营，以开展履行现有合同所必需的活动，可在金融行为监管局的网站上找到。","0f1dda628bebb4748de6df05fa3bff4989c1b476":"在欧盟以外，金融产品交易由以下公司提供：Deriv (FX) 有限公司，地址为 F16, Level 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia，由纳闽金融服务管理局授予许可证 ","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"(许可证编号MB/18/0024);","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"Deriv (BVI) 有限公司，地址为 Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands，已由英属维尔京群岛的金融服务委员会授予许可证 ","a56aa088dfea506d5dbe18f385c29418f771a639":"(许可证编号 SIBA/L/18/1114);","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":" Deriv (V) 有限公司，地址为 1276, Kumul Highway, Port Vila, Vanuatu，由瓦努阿图金融服务委员会授予许可证并受其监管；以及 Deriv (SVG) 有限责任公司，地址为 Hinds Buildings, Kingstown, St. Vincent and the Grenadines。","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"Deriv 有限公司 - 13 Castle Street, St. Helier, JE2 3BT, Jersey - 为以上子公司的控股公司。","74e8fa69aad80f93303a7723e5a304f3d43560b6":"某些国家，包括美国、加拿大和香港或18岁以下人士无法使用本网站的服务。","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"差价合约 (CFD) 被视为复杂衍生品，可能不适合散户投资。差价合约交易是复杂的工具，因为杠杆作用会有很高的迅速亏损金钱的风险。应该考虑自己是否了解差价合约的运作原理，以及是否有能力承受金钱亏损的高风险。此处提到的产品可能会受到货币汇率变化的影响。如果对这些产品进行投资，则可能会损失部分或全部资金，并且投资价值可能会波动。不应该将您无法承担亏损的资金投入交易，也不可使用借来的钱交易。","5bb3f3499158dbe30af5c725694b321dfe821433":"进行复杂的金融产品交易前，请务必了解所涉及的风险并了解 ","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"安全和负责任交易.","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"我们搬家了！","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"我们以前的名称是","991753597fde70aab5791de6d50ee8cc49a0bdcc":" Binary.com","efa99ab039a285c6264580bea691a4ffefcbeee7":" 已经有二十年了，现在已到了开启激动人心的新篇章的时候。","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"向新家打个招呼，","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":" Deriv.","52b8454dc755419beeff2f90cd0fc91def428244":"你好 Deriv！","27ad1d8334221366694c7acdd70fb380857d1e6e":"以后再说","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"带我去 Deriv","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"切换到 Deriv 是如此简单","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"只需使用 Binary.com 凭据登录即可。无需注册。","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"立即体验","63fbf7977349e32e4a124ffa047549b720806d73":"随身携带 Deriv","03d42257a2263b2841b9e0ae4b94de117228a33a":"获取 Deriv GO 移动应用程序，随时随地交易。再也不会错过千载难逢的机会。","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"扫描二维码下载Deriv GO","6b7499b1513a3cec3da3ff07cdad9b358954021e":"不要等待","b23efda40ddeb801beeebf915669d806744014af":"让交易永远赶上潮流。现在就来 Deriv 吧。","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"体验 Deriv 交易","34075438f939258908cc21d28bf59ab5126dc2d6":"快来 Deriv，为交易提供未来保障。","e669443b63757b5ad8571e52393caf2a0a812be3":"您会喜爱 Deriv 的 6 大原因","2c141583afaaa12438b16ee67355c6e3eaf77763":"Binary Bot 有了新家","4e0e045da59b385138ced3203cdb81c3b4cdd135":"Binary.com 已经成立 20 多年，是时候开启激动人心的新篇章了。您最喜欢的机器人构建器 Binary Bot 现在已搬来我们的新家 Deriv。快来看看吧。","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"带我去 Deriv 的 Binary Bot","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"在我们的新家 Deriv 使用 Binary Bot","1071c645f523394b408a6d285e95331bc583f14c":"5 分钟后，将展示在 Deriv 使用 Binary Bot 交易的好处。如果忽略此消息，将在 3 周后再次提醒您。","be43a8989c5745ec7386ca7c69442165f55dee8e":"立刻把好处告诉我","074603c9aef93515ed33d179e982c67ea7abdb45":"在 Deriv 使用 Binary Bot 交易"}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"Logica","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"Matematica","c3328c39b0e29f78e9ff45db674248b1d245887d":"Testo","4d064726954a17487f94e931f5b157b733ec22ed":"Avanzato","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"Elenco","19de69cb601f53a4ea7af22a65c71ae63251365c":"Variabile","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"Funzioni","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"Loop","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"Binario","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"Definizione di trade","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"Prima dell'acquisto","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"Durante l'acquisto","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"Dopo l'acquisto","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"Analisi dei tick","8cf71374fa095a64b5295b672daef8507ec7be6a":"Indicatori","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"Strumenti","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"Orario","8d8fd6765e184419cad8b88d1a60c895d79578c2":"Candela","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"Misc.","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"Registro","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"Riepilogo","9feddbabd7e7309e96c590069057158e96baa8f6":"Controllo della situazione","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"Il trading in opzioni può diventare una vera e propria dipendenza, così come qualsiasi altra attività spinta al limite. Per evitare il pericolo di tale dipendenza, ti forniamo un controllo della situazione in grado di offrirti regolarmente la sintesi dei tuoi trade e dei tuoi account.","4152043e8c670075d2c919677e835edb0d923cab":"Indica l'intervallo di tempo preferito, espresso in minuti, per il controllo della situazione","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"Inserire un numero compreso tra 10 e 60.","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"Continua il trading","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"Estratto","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"Esci","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"Contattaci","f7c400ed695f898b8ee9d21664aa17b5bb693828":"Accedi","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"Reimpostare i blocchi al loro stato iniziale","f98595d541778d86f75ef22b3328a031d20aa16b":"Carica nuovi blocchi (file xml)","4a1e616226c329a94da7768bc0435a3284478010":"Salva i blocchi esistenti (file xml)","6b3465ace62f33f0687b4669ac26d95895e9ca52":"Collega Binary Bot a Google Drive per salvare e riutilizzare con facilità i tuoi blocchi","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"Annulla le modifiche (Ctrl+Z)","937f5055f05be359ddf619744e8af4d643549e80":"Ripristina le modifiche (Ctrl+Shift+Z)","8406d1cce44230835932060649e999ca3283b413":"Ingrandisci (Ctrl + +)","1109673172af2c173c492622ff8a72c8f29f0e70":"Riduci (Ctrl + -)","44c22002c65d2871331263a23c3e09c0a1bfd847":"Disponi in verticale","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"Mostra/nascondi pop-up riassuntivo","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"Riproduci il bot","ba50a42d8d3228c37a817865fce49fbca692c2ad":"Ferma il bot","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"Mostra registro","91017ef9b165cd0e7475a770f318ea5e705e1321":"Mostra grafico","c89e3dd1cafcadcc0312e476ab58b2332209da23":"Mostra Vista trading","b02c858e72be118a65c9393930351012b647cb9e":"Mostra/nascondi intestazione","250be77f7605669a0b3d968b9ed381a3d9787ed1":"Apri un file XML già salvato e recuperane i blocchi","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"Binary Bot","608061fb5aab975013fa70c5c814a1d8ba30c152":"Negozia nel modo in assoluto più efficiente","e4ce8dc3e416e69262ba642dc57d3975d6616980":"Sei interessato ad automatizzare le tue strategie preferite per il trading in opzioni binarie?","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"Binary Bot è il nostro strumento di programmazione all'avanguardia che ti consente di creare app di trading con un semplice","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"Sogna un qualsiasi numero di robot per il trading binario, da formule incredibilmente semplici ad algoritmi estremamente complessi. A questo punto lascia fare trading per te, anche mentre dormi.","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"Inizia a costruire un bot ora","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"Hai bisogno di ulteriore assistenza?","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"SERVE AIUTO?","d635b53e59c9aad8c5d78458826beffb029b27bf":"Grazie, ti invieremo una risposta entro 24 ore","a69a8fc21499d0fd85e87bab467699827547a5bc":"Inserisci un URL del server valido","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"Il mercato sottostante non è stato selezionato","50050f06645ad2743165b429a8f7deebd285fd63":"Non è stato selezionato il tipo di contratto","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"Effettua il login","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"La durata deve essere un numero intero positivo","4df6e872792d72aea8a2f6b831d00b554464da23":"L'importo deve essere un numero positivo","001e68df3a4b32a4d57148d9d407f44eee3b7436":"La candela in questione non è valida","04f14ea7c92e0b2b5ae005c696245063ec641d66":"L'elenco di candele selezionato non è valido","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"nuovo tentativo tra","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"Tasso massimo raggiunto per","094628ce13fc0e78f07b697d1cc9421bb2edd666":"Richiesta fallita per","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"No","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"Sì","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"estratto","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"chiedi prezzo","50e72909992bdc37c7c07769d1b7efac5e52874c":"payout","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"profitto","c980b910204c7babdffe8ff3f7e755f30133383c":"tipo di contratto","a726c6955157f1b8b92f9932652434a7150f80f8":"spot d'ingresso","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"valore iniziale","3905be81561384dc8c43d6127c57ed1e0eb03b74":"stringa del valore di entrata","7674920c033ca14277c577e19c037a6754d4fa80":"spot d'uscita","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"valore finale","06ecea26625359f7dcf5ff5c47af6174ff815257":"stringa del valore di uscita","779455ee3bde8494d9629b353e17b19e92357ba8":"barriera","37a5301a88da334dc5afc5b63979daa0f3f45e68":"risultato","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"Vincita","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"Perdita","563339f82447b4e758ad76d5a0b63b5698594fba":"Aumento","5c1ae82c29543ac887703776bf3da2c7dcce683d":"Diminuzione","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"Nessuna variazione","ecb252044b5ea0f679ee78ec1a12904739e2904d":"stringa","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"numero","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"verde","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"blu","96de5543d183d7de52ac5fa21c46fc811f673f89":"giallo","78988010b890ce6f4d2136481f392787ec6d6106":"rosso","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"Silenzioso","cf84a98d6cf7f156862a08ba8236467b6f471004":"Annuncio","eee2facd669d1434848c24da5527b3e87d9a12d5":"Soldi guadagnati","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"Lavoro svolto","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"Errore","a3b1583d377f37ac20de7e089edfa0920a078e57":"Errore grave","66c8b6848eee629c4ac551bf2b5fa591571654be":"Aumento pari a","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"Calo pari a","062787aa328047e189774b3703d983b83938f6e9":"Superiore","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"Inferiore","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"Touch","7d7932bcc2e262ae98cf09dc5445130fb3881769":"No Touch","a16814a48ec58c2e24ba224a80921a5c02361abe":"Finisce tra","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"Termina fuori","534ec5da4e82ec419abc170e1a8448f55a01664f":"Stays In","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"Goes Out","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"Asian Up","c098658ce3d3a258e4d155949a60072966b36db7":"Asian Down","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"La cifra combacia","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"La cifra differisce","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"Pari","dc28f5f3c65ec611f0f30022650d24382d27448e":"Dispari","18a63f5512afb5573e5b44deba78d629f0635317":"Sopra","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"Sotto","2155c8b38181dd2552e84a94049aacd33ef9c607":"Tick alto","1408cfd2b064b923f024fbe590e27db8282941a5":"Tick basso","b86eb15dc4f13e4c2972de158d3038d9f657242f":"Reset Call","669a1f3d9a8f601a84da536cfdad1de4092b1926":"Reset Put","844d1a5c99a0a668383340cc095d040eef998c79":"Solo ascendente","87293a146cd481a2b30cf74282ec061dc4cf0735":"Solo discendente","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"Apri","b1a5954a483f8f8b0207385095f74aeb409b3f80":"High","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"Low","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"Chiudi","1173872a4fb205b713702f0eec5cf2c732c828fd":"Orario d'apertura","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"Default","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"1 minuto","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"2 minuti","24e46784cbce32443db5a2638b1a7d3201543e9b":"3 minuti","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"5 minuti","a6f151883b736f0470d33492e61c72a7d059d065":"10 minuti","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"15 minuti","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"30 minuti","f030c3d667652646b86732ad7bc67e226c49cd3a":"1 ora","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"2 ore","7b47150d431db70d783724007f07ab894eb8ac2e":"4 ore","191800b7e9a48680792c0dd77cb6cac00c4514c6":"8 ore","2d8a6f7c34468578640b333b8650131de06ac770":"1 giorno","cd1495cb4c60266a6abad9024022ae079bf7e416":"(1) Definisci il contratto del tuo trade","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"(2) Osserva e acquista il tuo contratto","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"Opzioni di trade","160f06d4799c85021a810f68c5b517eea37a2737":"Acquista","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"Up/Down","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"Alto/basso coincidono","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"Asiatiche","2260ce49306460c8a2ef501939f29ad6ddd4e934":"Cifre","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"Touch/No Touch","f7de1f66f0979667da275b7e8996e805395025a1":"Ends In/Out","a431deecd4c2258097adae418d496fe9a8179fee":"Stays In/Goes Out","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"Tick alti/bassi","12a3f461cdebbc8f335190413ee6c57442743bba":"Reset Call/Reset Put","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"Solo ascendenti/Solo discendenti","91a64e3f83c91acf336c631fba295f297f94c399":"Usa dopo n secondi","024696596f26a4db232fd9e966eadfeb27c0bd1a":"Usa ogni n secondi","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"superiore","85c274929bc0e28eafd3734f2c25046c3b95b36b":"intermedio","346e3ee198e98146993894d3de8ecab1a86c3e80":"inferiore","f16459104f92ab6b38aa265adb4ecbfc3768e303":"Istogramma","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"MACD","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"Segnale","19eabc961735d78f12fc7be906ffcb033853cf85":"Timestamp","68f4145fee7dde76afceb910165924ad14cf0d00":"Messaggio","e99811bd3b1ad17e74614060ecb180602be35ad6":"Sei uscito!","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"aggiungere blocco all'area di lavoro","1fde9f1ebca07dcbc704130bd18645bce7718b55":"consenti blocco","d466687f90ba548434d65186d11a80c4204f9ad6":"deve essere aggiunto all'interno:","629777b7d4d610ace6dee24442730f27d7d0853e":"Il file non è supportato:","0b93c14956403c2e5c9e79f5c836babc56912006":"Binary Bot non piazzerà nessuna nuova operazione. Qualsiasi trade già piazzato (ma non scaduto) sarà completato dal nostro sistema. Tutte le modifiche non salvate saranno perse.","c1458ff86fd60d9544d7cd8a67437df2b766f482":"Nota: si prega di consultare la pagina dell'estratto conto di Binary.com per i dettagli di tutte le transazioni confermate.","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"Le modifiche non salvate andranno perse.","410bf23a3f080def9c7a976a16305bcde7943ed1":"Sei sicuro?","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"Purtroppo, Binary Bot non è disponibile nel tuo Paese","901624741023fcfc805ce43c94b8012e3b1d1c99":"Vuoi fare trading con CFD su MT5? Avrai accesso a Forex, azioni, indici azionari, materie prime, criptovalute e sintetici.","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"Strategie","910ec7aa40b04ec6ba51162f4de7850569326cb6":"Si è verificato un errore nel caricamento dello script API di Google.","8f51f350debde84e067e1a0405fb6304922a7d4b":"Si è verificato un errore nell'inizializzazione di Google Drive.","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"Si è verificato un errore nel caricamento delle librerie di Google Drive","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"Concedi autorizzazione a visualizzare e gestire i file di Google Drive","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"Formato file non riconosciuto","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"Si è verificato un errore nel recupero dei dati da Google Drive","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"Selezionare una strategia di Binary Bot","2db43c69a4b96454914f0b8272bc869984529e6e":"Si è verificato un errore nella creazione dell'elenco di file da Google Drive","0dcea5f584938e0fff00084b83156ab31d641ab3":"Si è verificato un errore nel recupero dei file da Google Drive","18da95988117ff029393f3f5c881d70ef47f7385":"Si è verificato un errore nell'elaborazione della tua richiesta","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"Seleziona una cartella","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"Impossibile inviare la notifica su Telegram","3f370309b6280eb100f898426d8605c1f45d558d":"Marca temporale non valida","af6a4e2a5582be89ac930e946eaed86e01cac58b":"Data/ora non validi","49d51398b574e7312d99b18d2b93d2ede416f053":"Impossibile inviare webhook","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"Le proposte non sono pronte","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"La proposta selezionata non esiste","6ea4a034747d020b1d8ce4848def95d537555dd6":"Comprato","89f89c02cf47e091e726a4e07b88af0966806897":"ID","1200c1af2f7bba4e29a34112865662748c9d41df":"La rivendita non è disponibile per questo contratto.","62d6180e55905f7b996d442c53631981a4ef8b5b":"Venduto per","ed4978867de1da05b336b724a3fb96222a29ebec":"L'indice deve essere un numero intero positivo","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"Volume del profitto","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"Volume della perdita","46fc6f27a835486d63d9e927c6687e4508cb3087":"Numero massimo di trade raggiunto","9202ddae4cea16513e53bbc965d88ed975e59512":"Importo massimo della perdita raggiunto","5f52b397b7e5f538681f0f5717a88aa626349c7a":"Bot.init non viene richiamato","66c7734789e19cbeef3a5ac185ea732139aed213":"Grafico","3b662fb2e8bafce29aa98321b18874bb44905488":"Integrazione di Google Drive","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"Imposta il tuo limite di perdita giornaliera nella pagina dei servizi di autoesclusione per consentire il trading.","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"Il numero massimo di trade consecutivi deve essere compreso tra 1 e 100","93039e609d94a24f3572b794a31b21525a09af2b":"Non impostato","a85b8cc112a8597df1612d60a74faa818c25d1b3":"Ti chiediamo di impostare le limitazioni di trading in conformità con i regolamenti aziendali. Tieni presente che il tuo bot interromperà il trading solo se una o entrambe le condizioni di seguito saranno soddisfatte.","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"Limite giornaliero sulle perdite:","95052a29f213e9698b593418fe396ecc21032f9b":"Questa è la soglia che limita le perdite potenziali giornaliere in tutte le piattaforme Binary.com. Una volta che la vostra perdita totale raggiunge o supera questo importo, il bot interromperà il trading. Imposta un valore nella pagina {$0}Servizi di autoesclusione{$1}.","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"Numero massimo di trade consecutivi","730657200c17321d926e1bd08dbf65bd96855a8a":"Questo è il numero massimo di compravendite che permetti al tuo bot di eseguire per questa corsa.","952f375412e89ff213a8aca383d18e5691354347":"Inizio","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"Limiti del trading","095ba68888b5ace5f4515f5acab76dfa1073544e":"Il mio computer","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"Carica","248e224f533752db28a1aab3519a58569ad96140":"Carica blocchi","c7097e97dcc446ca889d3ca6be733a65e2728afe":"Il caricamento su Google Drive è stato effettuato","a6b977714595aa01678fca98e86553aaeac05c92":"Salva i tuoi blocchi individualmente in una collezione. Saranno aggiunti al tuo spazio di lavoro esistente (i blocchi principali saranno sostituiti) quando saranno caricati.","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"Salva come raccolta","611ebbfb080284312904de925ef0f75f4cb56ad2":"Salva blocchi e impostazioni per utilizzarli in altre strategie","efc007a393f66cdb14d57d385822a3d9e36ef873":"Salva","a638caa8ab2b7ff7980a571334217339e6d1d634":"Salva blocchi","39fca63515c105918f03e4908ec12df675b07f92":"Trading View","e643975ea5296d9de4486458f31ab0a5a2b228bf":"Questa operazione cancellerà tutte le transazioni nel pannello di riepilogo e tutti i contatori saranno azzerati.","85dfa32c97d8618d1bea083609e2c8a29845abe5":"Account","d847919a30d31c0be624087f3370492b3fdf80c6":"N. di utilizzi","5cd6978d63540c8a490ef76f43219de6362f958e":"Puntata totale","17410d7b62b8b1de981cfebada24632987edf186":"Payout totale","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"Profitto/Perdita totale","90eef613042c5a51f542421065b68b886d473807":"Saldo","db1c784524e1b54011a95823026161f7c8517fe0":"Riferimento","4db3e9e4aecd187db9339a10d2629fef46724dc4":"Tipologia di trade","1bb4086b66659d8580f9be4beef69931aeea3cad":"Prezzo d'ingresso","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"Prezzo di uscita","ba7be969e7c1bb5f22489e843478e3d721aaa843":"Prezzo d'acquisto","772fbced18230220d2d9be1456be16fc1b271d25":"Profitto/Perdita","bae7d5be70820ed56467bd9a63744e23b47bd711":"Stato","96f608c16cef16caa06bf38901fb5f618a35a70b":"In sospeso","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"Concluso","82a82f798dd773717ec37d15fd4405510291734e":"Il bot non è in esecuzione.","6a88e58aa1798626f94cf17f1a91618b405bb289":"Il bot si sta avviando...","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"Il bot è in esecuzione...","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"Il bot si sta interrompendo...","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"Il bot si è interrotto.","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"Tentativo di acquisto in corso","4684ee1026d9b4c872d016c3c4588a0c479a451c":"Acquista corrispettivo","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"Acquisto effettuato","f02760cd2eac28169f0a990c950c3dfe8427f772":"Contratto chiuso","c7363d8a0748d4a7e2cc968335dc9716f290359d":"Fermare il bot impedirà ulteriori compravendite. Tutti i trade in corso saranno completati dal nostro sistema. Tieni presente che alcune transazioni completate potrebbero non essere visualizzate nella tabella se il bot viene interrotto durante l'esecuzione di trade. Consulta la pagina informativa di Binary.com per i dettagli di tutte le transazioni completate.","fadc0ef93d1ff13370524ce8481ddc4a71195934":"Disponi in verticale","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"Scarica","e4458464df6cbb8da1134875ba51519c5d244d9f":"I blocchi devono rimanere all'interno dei contenitori di blocchi, blocchi principali o funzioni","e9c45563358e813f157ba81b33143542165ba84e":"Attenzione","31cb6f44d030abeabcc7046555dea851602a87a5":"Questa strategia non è disponibile nel tuo Paese.","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"OK","9970168c192807246fad6138344e5a96449afbdd":"Il file XML è vuoto. Controlla o modifica il file.","a594b427eaf0f108d3e9cc20d70e15da811c760c":"Strategia non supportata","04a5090686ac7b54822e00a9ff08c38a107601e7":"Siamo spiacenti, questa strategia non può essere usata con Binary Bot, ma soltanto con DBot.","77dfd2135f4db726c47299bb55be26f7f4525a46":"Annulla","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"Vai su DBot","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"Il file che si sta cercando di aprire contiene elementi non supportati su questo blocco: {$0} Controlla il file e riprova.","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"Impossibile caricare il file di blocco","af145748c9cf765a3b059eec20cb1dbb899297d8":"I blocchi sono stati caricati con successo","11ee9c5d534cc8d22651092222b532917594161a":"La durata minima è","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"Il numero di tick deve essere compreso tra 5 e 10","ace1342bc3720b77ce510b93074041e7386d209e":"L'orario di scadenza non può essere uguale all'orario di inizio","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"La previsione deve essere una cifra","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"deve essere aggiunto all'interno","33aa6ff282ee509d37c6f758274c9156b419ff73":"La strategia selezionata non è valida.","da162a909c2981ed318d23cd9a6be1d66e0a8400":"Formato di file non riconosciuto.","5e719fa76e1b6cb396376c82ebdd04bec7253229":"Per caricare blocchi da remoto devono essere una raccolta.","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"Impossibile caricare il file di blocco.","df84a88f38b03b5b342362d72370b0d66afdae35":"La destinazione deve essere un file xml","cd680fd936e9559ef1d95efac7a71680e2b13a89":"Questo url è già stato caricato","34c59389053701a04127f74d32315e0206e076f8":"Si è verificato un errore durante il tentativo di caricare l'url","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"Assicurati che 'Access-Control-Allow-Origin' esista nella risposta del server","988df856c066143616bd33d5904bbcdc22ff129e":"Binary.com si sposta su Deriv","2fccaab15d71b00c19da7053135471d510b513db":"Fai trading su Deriv","3ead0b14c72503187691a7a6d7121987299bd401":"Non si tratta di una versione ufficiale di Binary Bot, utilizzare a proprio rischio.","27401c9c8e476d659c8382e05c6d70a4a82be468":"Versione ufficiale","bc981983e7f547dc62e19a1e383acfe00782a6d5":"Avanti","b52b36b7269fbfc58ec24bb724691951a3decbe8":"Indietro","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"Fatto","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"Fai un tour veloce","a48e81d4a8da67637b46725824177a959fe99b21":"Sei pronto per imparare a utilizzare Binary Bot?","6f3e6ebf249947cec4f64117253a8fe43335ae79":"No, grazie","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"Non chiedermelo più.","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"Area di lavoro","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"Trascina i file dei blocchi oppure metti a punto le tue strategie personali.","d171baee235d4c93f63755a876782dc5be4c3e47":"Scatola dei blocchi","056f19272d96f902c38207cf163ea8dbff7fbd32":"Aggiungi più blocchi al tuo robot da qui.","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"Account","f5c47fd3b3553b10441a06054078cea745177dea":"Prima di avviare il tuo robot, effettua il login. Testa sempre le tue strategie con l'account virtuale.","fd825ae94aa79500a878dd4590a4b360e7162663":"Comandi del robot","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"Controlla i tuoi blocchi. Per ulteriori informazioni, mantieni il cursore su ogni pulsante.","f5169c84497de3aea74f7da9e7e177d1427e736b":"Buon divertimento!","4f1b3d682c2a00b393c33637da402463bc11d5ff":"Desideri segnalare un problema o chiedere aiuto?","0049f8894e41937ebb9111cd3def6749049fb50f":"Clicca qui","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"Dove trovare Binary Bot su Deriv","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"Sulla homepage di Deriv, clicca su Realizza un Trade nella parte superiore della pagina, e scegli Binary Bot.","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"Prova Binary Bot su Deriv","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"È lo stesso Binary Bot che conosci e ami","169dd3b2025485a48b8f9f3f6ef89f5586714140":"È tutto come prima, proprio come ti piace.","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"Trasferisci i tuoi bot senza problemi","b763f8cbfa6396f195781032619a99bba04bc939":"Le tue strategie in Binary.com possono essere usate su Deriv. Semplicemente carica il tuo file XML e comincia a fare trading.","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"7 piattaforme di trading (le classiche favorite e anche delle nuove)","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"Troverai Binary Bot e SmartTrader insieme alle nuove piattaforme come DBot e DTrader. Qualunque sia il tuo stile di trading, abbiamo la piattaforma per te.","0ce7480da93c1c9839818d0720b77931d1637574":"Depositi in criptovalute tramite fiat on-ramp","6e6a4c6839d2e859758a517865b095c1b8298dd6":"Deposita criptovalute in modo semplice tramite servizi di scambio come Changelly, Banxa e XanPool.","c1b51f196c97b4781a354457579e9699b09de087":"3 tipi di trade","4708f7e87263464b130b987e4b9aed981c4f455d":"Fai trading su CFD, opzioni digitali e moltiplicatori, un nuovo ed emozionante tipo di trade che aumenta i tuoi potenziali profitti con rischi limitati.","b7fceac7d5f885d735aeda6e4654487467d33fa3":"Depositi e prelievi peer-to-peer","79a206119137878eb6be7c60f7ed34135194bdf0":"Scambia la tua valuta locale con altri trader per far entrare e uscire fondi dal tuo conto con Deriv P2P.","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"6 tipi di mercato","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"Espandi il tuo portfolio con un'ampia gamma di mercati come Forex, azioni, criptovalute, indici sintentici, e altro ancora.","14b2a808fdec3702e5a6b9152e13288c87a4768a":"Impara con l'Accademia Deriv","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"Approfitta degli articoli e dei video gratuiti che ti aiuteranno ad imparare i trucchi del trading online.","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"Clicca per selezionare","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"Non disponibile","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"Tick","5fb1db527825d2996e37c655e5dec49d4da80c09":"Secondi","092f99ea11a34a8490e7a767a83a42fc45634f82":"Minuti","9e25a34e635a123f8958bbe26e7c4843278597fb":"Ore","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"Giorni","db6708630fc646eb98298d9acd701e0a1ac051c2":"Salva blocchi e strategie su Google Drive","85538d002a336c5addef8d189d80976cf7758f8c":"Hai effettuato il login come","b65463cb6a42a17de514acc4659f7fd331e0876a":"Connetti","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"Disconnetti","cd5f85b6f187605f82386eacd680f93820af8d11":"Il risultato è","1e38ce3d180cefae485a6986ca7c67841e30376f":"Vero se il risulta corrisponde alla selezione","5c89497fc3c128e2ff865ce8df15356054f2c028":"(4) Ottieni il risultato del tuo trade e negozia di nuovo","14ea81918758c994cbe3178e695e56afc1ef2b45":"Ricevi le informazioni e i risultati dei trade precedenti, poi fai di nuovo trading (Funziona con trade completi)","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"Dettagli del contratto:","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"Leggi un'opzione selezionata dall'elenco dei dettagli dei contratti","b3b543c80063a116ced4965d8537b7b62d14c0b7":"Negozia di nuovo","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"Esegui nuovamente il blocco dei trade","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"Chiedi prezzo","343fda69c73b78b84967055aae97f790c422adfd":"Chiedi il prezzo per la proposta selezionata","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"Osserva il flusso di tick e acquista il contratto desiderato (Funziona sull'aggiornamento dei tick)","9bb396940adb9705fe57eba6ea8b578e6aafa792":"Payout","87da93a46d143f6019979b3548414d9d7adabb35":"Payout per la proposta selezionata","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"Acquista il contratto selezionato.","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"La vendita è disponibile","03bad10717e183b24829baf483dc715e1a44bf7b":"Vero se è disponibile la vendita al prezzo di mercato","2c71ed279a402e93312dbda173ab18f244d6bf46":"(3) Osserva e vendi il contratto acquistato","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"Osserva le informazioni del contratto acquistato e vendi sul mercato se disponibile (Funziona sull'aggiornamento del contratto)","579607dc4f989ce2b94b558431666a0ab07ac1f3":"Vendi sul mercato","e20afd5cf3811a42071c9a312abb2afdad4c590b":"Vendi sul mercato.","4712cbff8e92822fc960ef9c0197293a19675eae":"Profitto/perdita della vendita","df817b48c7a076561b4f8bedc52d65d2e351ab52":"Restituisce il profitto di vendere sul mercato.","b44e884c355e447d0da0e6ba45caaff18c84373b":"Bande di Bollinger","d6a2a207343bd83aacdc80b579ff4419713a256e":"Elenco di input","170a28a9db6d27d7212fc6dc249434a57517e7bc":"Periodo","b833989d69900a4be9e32d1bab65c8f8233f099e":"Std. Dev. Up Multiplier","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"Std. Dev. Down Multiplier","974da601086448d0060aeed90e53ddd5acd17b91":"Calcola le Bande di Bollinger (BB) da un elenco con un periodo","d5b65cac1f1cf9421ac978eebe532de99040cca6":"Serie di Bande di Bollinger","58de49791c64aba14e36e5887244a5ef088286cd":"Calcola un elenco di Bande di Bollinger (BB) da un elenco con un periodo","4bd99f76f1104229744455d93df0ff76b9eeed58":"Media mobile esponenziale","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"Calcola la Media mobile esponenziale (EMA) da un elenco con un periodo","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"Serie di medie mobili esponenziali","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"Calcola l'elenco della Media mobile esponenziale (EMA) da un elenco di valori con un periodo","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"MACD Array","b18e572ea14edd48587145f1ef50718adbf256c6":"Periodo EMA veloce","974023bddd6249d0f6404872cfcae205b2599ea2":"Periodo EMA lento","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"Periodo EMA del segnale","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"Calcola l'elenco della Moving Average Convergence Divergence (MACD) da un elenco","95ec92885c855ba9cf734c17a43f081901e4d2cc":"Indice di forza relativa","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"Indice di forza relativa (RSI) da un elenco con un periodo","4034de66995b876b2ba9bfd0274025e39168e05d":"Serie di Indici di forza relativa","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"Calcola l'elenco dell'Indice di forza relativa (RSI) da un elenco di valori con un periodo","a9842c95766da40bf4ea6ee263cb5a5985847763":"Media mobile semplice","347775a293c14362d492f019e677c965be1d6e7d":"Calcola la Media mobile semplice (SMA) da un elenco con un periodo","4cc7b9e53d082896ad884eb01be16320af65f282":"Serie di Medie mobili semplici","2c75179a57af3c36581008b65e86ed81c4a4cbea":"Calcola la Media mobile semplice (SMA) da un elenco di valori con un periodo","39f024cf49724fe7ffdea7773c72ed06eec998e1":"con intervallo","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"La direzione è","ad47561efb1dcbd7246d9b64487f615647fda036":"Vero se la direzione corrisponde alla selezione","05bef508aadd62bf3967dcf67d769da296f19989":"Direzione del tick","21bfc78607d3a64de767a6677d1db42156d5039d":"Restituisce la direzione del tick ricevuta da un blocco prima dell'acquisto, il suo valore potrebbe essere 'crescente' se il tick è superiore al precedente, 'decrescente' se inferiore e vuoto ('') se il tick è uguale al tick precedente","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"Il blocco della direzione è obsoleto, si prega di usare invece il blocco di verifica della direzione","cdb31fc857f01a59f664413498293c714285f46d":"nell'elenco delle candele","20fd5f86f08796f145d69dedc209a27e459b2f51":"ottieni # dalla fine","a96606af8c33ac3428b45abc4782dbf93f458d29":"Ottenere l'ennesima candela più recente","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"Elenco delle ultime cifre","248428facb97408414180d4de74e4db35360fbc4":"Ritorna all'elenco dei valori delle ultime cifre","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"Ultima cifra","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"Ritorna all'ultima cifra dell'ultimo tick","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"Elenco delle candele","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"Ritorna all'elenco delle candele","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"Crea un elenco di","a4220593d385a720886f7af1ed3c478fd0c6339c":"valori nell'elenco delle candele","cd8cdf3d47e921c8a72addae9269e66041d417c5":"Ritorna all'elenco dei valori delle candele selezionate","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"Nell'elenco delle candele si legge ","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"dalla fine","aba43a580daa7f306956ec69b83e6e37e7233126":"Leggere il valore delle candele selezionate nell'ennesima candela recente","e04b522218a181cf0223042dd18ae08dcc22d8d3":"Ultimo tick","6ee445fc253a55c9ed54c009c3f020ac65200d80":"Ritorna il valore del tick ricevuto da un blocco prima dell'acquisto","ed44b69176217a1251c04f0c13d23ac789ea60b2":"Stringa dell'ultimo tick","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"Ritorna il valore del tick ricevuto da un blocco d'acquisto precedente (stringa)","4b2340a890e88d1886757c3f7172e273a1edc31f":"Questo blocco si verifica su ogni tick","b54d7b4590559dad64f02d09aacbf6d9863e2624":"Puoi utilizzare questo blocco per analizzare i tick a prescindere dai tuoi trade","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"Elenco dei tick","17649cac8739adcae95e641f794880272ad33bd1":"Ritorna all'elenco dei valori dei tick","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"Lista stringhe di tick","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"Restituisce un elenco di valori di tick (stringa)","c67ded6b64019212eb2bc69afd761f5b3f626040":"Aggiungi un segnale al numero per creare uno spostamento della barriera.","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"Mercato","74751e67c3e1010c343095eaf543e7cb21ced2ef":"Tipologia di trade","1f4698382842477e211eb46de81fa506f01a8c34":"Entrambi","c1baf816aac5a5cd849768773fc248cd249dc296":"Tipo di contratto:","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"Intervallo predefinito delle candele:","9693aeaaf68e3929b59b79306feaa0a847d01192":"Durata:","78d7103a319e808455d397513279d99f3b3f3768":"Puntata","10c02649e226d430bd75a5b6315a41c0db9992a2":"Barriera","837276742aa90209dde3b4eef07d8e7ab26731ef":"Previsione","258b49925b41751c6bd790a0848246566ba61440":"Riavvia acquisto/vendita in caso di errore","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"disattiva per una performance migliore","b410994b67e37d9516eb9b866c85a8c639f79e68":"Riavvia l'ultimo trade in caso di errore","2260c5a971c2602834ef8feeb5fa522f900b469f":"il robot ignora il trade non riuscito","0745acf92abd7b60598f161717884cc45dab8694":"Esegui una volta all'inizio","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"Definisci le opzioni dei trade","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"Definisci il contratto del tuo trade e inizia il trade, aggiungi qui le inizializzazioni. (Esegue all'avvio)","4d22b565e4253e92a908f216184779679bb1a044":"Barriera superiore","b70c38c6db3127422e05315c30bdf76c7c36c480":"Barriera inferiore","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"Assoluta","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"Saldo:","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"Ottieni il numero del saldo o della stringa","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"I blocchi all'interno vengono ignorati","d072c2ceeb5c1217722d14c74de7aeab945b4215":"Colloca qui i tuoi blocchi per evitare che vengano rimossi","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"Chiave: %1 Valore: %2","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"Restituisce una stringa rappresentativa di una coppia di valori chiave","b06acc4158c824231f727a13e1c9811f43d5be42":"Carica il blocco da","661db37251a1ed1afe357ee13895f37a623d7cbf":"Carica i blocchi dall'url","6c03ee54ad3a51fc92a1d69943e99667847705b6":"Notifica","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"con audio","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"Crea la notifica","6e0fc122f936f808bc2e3af661121b65712ae855":"Notifica Telegram %1 Token accesso: %2 ID chat: %3 Messaggio: %4","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"Invia un messaggio a Telegram","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"Profitto totale","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"Ritorna al profitto totale","532e65f6e266db0bb442d1f426d44d7d32962340":"Stringa dei profitti totali","78e84591ff76f992953a8e19b57c7eab7546d638":"Restituisce il profitto totale (stringa)","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"N. di utilizzi","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"Ritorna al numero di esecuzioni fin dall'inizio","7d500ebe352ccfa932b253e21938813a06fcff8e":"URL Webhook: %1","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"Invia una richiesta di POST a un URL","a35646754dbe7a9211ba8b81338a5d64580eb276":"Unità dati vuota","69b0648eddd207cd45a9e1ba973dae287b535576":"Unità dati:","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"la candela è nera?","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"Controlla se la candela data è nera, restituisce vero se la chiusura è inferiore all'apertura nella candela data.","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"Crea un elenco di","5925d08228e246f07b790b88ad70c1b73a97d2bc":"valori della lista di candele","852b438f91ad9eb2cdd84419a675a216d543c687":"Leggi","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"valore nella candela","d79d854dcd0829e2177a47beab6a55569e781ab1":"Leggi un campo in una candela (leggi dall'elenco delle candele)","5606b4460ac96063b8a8e5647008f3ec97252fc5":"Secondi dall'epoca","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"Ritorna all'orario epoch (secondi dopo epoch)","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"Usa ogni","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"Secondo(i)","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"Usa i blocchi all'interno ogni n secondi","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"Il blocco dopo ogni secondo è stato disapprovato. Se hai un valido caso per utilizzarlo, contattaci.","7b9c76088576a64f32d67ec335162b9f73eaa026":"Usa dopo","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"Usa i blocchi all'interno dopo n secondi","e9fb732dde76a6977bcaa2818b0f56125b183648":"Fino a data/ora","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"Converte un numero di secondi dall'Epoca in una stringa che rappresenta data e ora. Esempio: 1546347825 sarà convertito in 2019-01-01 21:03:45.","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"Fino a marca temporale","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"Converte una stringa data/tempo in una stringa in secondi rispetto all'epoca. Ad esempio: 01-01-02019 21:03:45 GMT+0800 verrebbe convertito in 1546347825. Gli offset di tempo e fuso orario sono opzionali.","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"Inizia a usare Deriv con l'e-mail e la password di Binary.com.","64f72129852fb7bdff0725c71324a012630f53bf":"Nell'UE, i prodotti finanziari sono offerti da Binary Investments (Europe) Ltd., W Business Centre, terzo piano, Triq Dun Karm, Birkirkara, BKR 9033, Malta, regolamentata come appartenente alla Categoria 3 dei fornitori di servizi di investimento dalla Malta Financial Services Authority ({$0}licenza n. IS/70156{$1}).","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"Al di fuori dell'UE, i prodotti finanziari sono offerti da Binary (SVG) Ltd, Hinds Building, Kingstown, San Vincenzo e Grenadine; Binary (V) Ltd, Govant Building, Port Vila, PO Box 1276, Vanuatu, regolamentata dalla Vanuatu Financial Services Commission ({$0}vedi licenza{$1}); Binary (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, Isole Vergini britanniche, regolamentata dalla British Virgin Islands Financial Services Commission ({$2}licenza n. SIBA/L/18/1114{$3}); e Binary (FX) Ltd., lotto n. F16, primo piano, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malesia, regolamentata dalla Labuan Financial Services Authority per svolgere attività di intermediazione nel mercato finanziario({$4}licenza n. MB/18/0024{$5}).","10dd345bc3319e2151794428b2c709dc5fc381a7":"I servizi di questo sito web non sono disponibili in alcuni paesi quali USA, Canada, Hong Kong e Giappone, così come agli individui di età inferiore ai 18 anni.","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"Avviso di rischio","ad0fc99c05681528248b73007dba16fd760a81c6":"I prodotti offerti tramite il presente sito web includono opzioni binarie, contratti per differenza (CFD) e altri complessi strumenti derivati. Il trading di opzioni binarie non è adatto a tutti. Il trading di CFD implica un elevato livello di rischio, poiché la leva finanziaria può agire sia a vantaggio che a svantaggio del cliente. Di conseguenza, i prodotti finanziari offerti su questo sito web potrebbero non essere idonei per tutti gli investitori a causa del rischio di perdita dell'intero capitale investito. È raccomandabile che i clienti non investano denaro che non possono permettersi di perdere e non effettuino trade con denaro prestato. Prima di fare trading con gli strumenti complessi offerti, suggeriamo di accertarsi di comprendere i rischi presenti e approfondire il tema del {$0}trading responsabile{$1}.","1fda2716eb92e0195ff59b110af23d86b43fd909":"Nell'UE, i prodotti finanziari sono offerti da Binary Investments (Europe) Ltd., W Business Centre, terzo piano, Triq Dun Karm, Birkirkara, BKR 9033, Malta, autorizzata e regolamentata come appartenente alla Categoria 3 dei fornitori di servizi di investimento dalla Malta Financial Services Authority (licenza n. IS/70156).","be7786af641b859c03ec152461d791480cf676ed":"Nell'Isola di Man e nel Regno Unito, gli indici di volatilità sono offerti da Binary (IOM) Ltd., primo piano, Millennium House, Victoria Road, Douglas, IM2 4RW, Isola di Man, Isole Britanniche; autorizzata e regolamentata rispettivamente dalla (1) Gambling Supervision Commission dell'Isola di Man (licenza attuale emessa il 31 agosto 2017) e dalla (2) Gambling Commission del Regno Unito ({$0}licenza n. 39172{$1}).","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"Nel resto dell'UE, gli indici di volatilità sono offerti da Binary (Europe) Ltd., W Business Centre, terzo piano, Triq Dun Karm, Birkirkara, BKR 9033, Malta, autorizzata e regolamentata dalla (1) Malta Gaming Authority di Malta (licenza n. MGA/B2C/102/2000 rilasciata l'1 agosto 2018); per i clienti nel Regno Unito dalla (2) UK Gambling Commission ({$0}licenza n. 39495{$1}) e per i clienti irlandesi dalla (3) Revenue Commissioners di Irlanda (licenza del Remote Bookmaker n. 1010285 emessa l'1 luglio 2017). Consulta le {$2}informazioni complete sulla regolamentazione{$1}.","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"Binary.com è un pluripremiato fornitore di servizi online che aiuta i clienti ad effettuare trading nei mercati finanziari attraverso opzioni binarie e CFD. Il trading di opzioni binarie e CFD sugli indici di volatilità è classificato come attività di gioco d'azzardo. È importante essere consapevoli che il gioco d'azzardo può creare dipendenza – ti invitiamo a giocare in modo responsabile. Scopri di più sul {$0}trading responsabile{$1}. Alcuni prodotti non sono disponibili in tutti i Paesi. I servizi offerti su questo sito web non sono disponibili in alcuni paesi, quali USA, Canada, Hong Kong, o per le persone di età inferiore ai 18 anni.","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"Il trading di opzioni binarie può non essere adatto a tutti, pertanto occorre assicurarsi di aver compreso appieno i rischi connessi. Le perdite possono superare il deposito iniziale, e il Cliente non è effettivamente in possesso degli asset sottostanti, né ha degli interessi su di essi.","496a99878841de69368c33af9e88eb37c0da5712":"I CFD sono strumenti complessi che implicano un rischio elevato di perdite rapide di denaro a causa della leva finanziaria. Il 78.6% degli investitori al dettaglio subisce perdite effettuando trading su CFD. Ti invitiamo a valutare se sei effettivamente in grado di comprendere il funzionamento dei CFD e nelle condizioni di correre l'elevato rischio di perdere del denaro.","a726d863bbdceba7b06a1083026a53db76de47b7":"Fai trading con i moltiplicatori","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"Ampifica il profitto potenziale senza rischiare più della tua puntata.","febe8aef26fb3017be5bf43d66f7972731c20833":"Pagamenti peer-to-peer","a8c1114d1c88db12afa05b331188ceb77afad6e3":"Indici Crash/Boom","d29324705a18a81ffc0376f3f37639a68827f3e6":"Prevedi e guadagna potenzialmente da picchi e cali entusiasmanti. Disponibile solo con moltiplicatori su dTrader.","ba2098a209e375402a0cf222cec87cce26440767":"In esclusiva su Deriv","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"C'è un futuro brillante davanti.","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"Scopri queste funzioni extra e molto altro su Deriv:","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"Dai un'occhiata","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"SmartTrader","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"La nostra piattaforma classica per il trading di opzioni","64dfd7424a05133b74cfb93fcbe385ede6539855":"La nostra piattaforma classica per il trading automatizzato","824d76b124e6289f372e2ff6bcba91e8939343bd":"Scopri di più","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"Deriv MT5","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"La piattaforma di trading di CFD famosa in tutto il mondo","54617a018fc6dffb3a70627b97f0db5c52a4081d":"DTrader","dbcd68f389d64fc531a650652c87b7d83fc82d94":"La nostra principale piattaforma di trading con opzioni e moltiplicatori","dd69c213333a751a0ab3bc9ce6368588bf971b61":"DBot","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"La nostra piattaforma di trading automatizzato di nuova generazione","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"Deriv GO","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"Fai trading ovunque tu sia con la nostra piattaforma di trading mobile","f63714db18c58c6b4a7a7bad09178faaeca05104":"Deriv X","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"La nostra piattaforma di trading CFD personalizzabile","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"Tutto ciò che ami di Binary.com e molto altro","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"7 piattaforme tra cui scegliere","029582bad299ab8f44c57b961210e56569efd536":"Troverai SmartTrader e Binary Bot insieme a nuove piattaforme come DTrader e Deriv X. Qualunque sia il tuo stile di trading, abbiamo la piattaforma per te.","9a07439b57e510e8e33b372aad2c360dbc39e79c":"Fai trading su CFD, opzioni digitali e moltiplicatori, un nuovo ed emozionante tipo di trade che aumenta i tuoi potenziali profitti con rischi limitati.","3d0be0e8eb736257254698ba821c45389e385f1e":"Depositi in criptovalute tramite fiat on-ramp","c4303d30e60f01fa922400e52df4e96d71b35d6e":"Oltre 100 strumenti","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"Fai trading in base alle tue preferenze: su Forex, materie prime, indici azionari e indici sintetici. ","f30ce7459f29851b219b504216581bf3d3446de0":"Assistenza quando ne hai bisogno","6df6091514ee13992a3ac28445af1d9a1afbcb67":"Ottieni assistenza clienti 24 ore su 24 e accedi al Centro assistenza.","92c8b7b779e7cf179b89484285fd766274b3bf1f":"Esplora Deriv ora","a87a92c5ce4925186a081cf4478639fcc31b12ed":"Nell'UE, i prodotti finanziari vengono offerti da Deriv Investments (Europe) Limited, W Business Centre, terzo piano, Triq Dun Karm, Birkirkara, BKR 9033; con licenza concessa a Malta ","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"(licenza n. IS/70156)","720280451c98ceeb796f3c7fa118813fc8da694d":"ed è regolamentata dalla Malta Financial Services Authority, Triq l-Imdina, zona 1, Central Business District, Birkirkara CBD 1010, Malta in base all'Investments Services Act. Autorizzata dalla Financial Conduct Authority e con variazzione ritenuta del permesso. Soggetto a regolazione dalla Financial Conduct Authority. La natura e l'estensione delle protezioni per il consumatore possono essere diverse da quelle intese per le società basate nel Regno Unito. I dettagli del Financial Services Contracts Regime, che permette alle società basate nel SEE di operare nel Regno Unito per un periodo limitato per svolgere attività che sono necessarie per l'esecuzione di contratti preesistenti, e che sono disponibili sul sito web della Financial Conduct Authority.","0f1dda628bebb4748de6df05fa3bff4989c1b476":"Fuori dall'UE, i prodotti finanziari vengono offerti dalle seguenti società: Deriv (FX) Ltd, F16, primo piano, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malesia; autorizzata dalla Labuan Financial Services Authority ","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"(licenza n. MB/18/0024);","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"Deriv (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, Isole Vergini britanniche, autorizzata dalla British Virgin Islands Financial Services Commission ","a56aa088dfea506d5dbe18f385c29418f771a639":"(licenza n. SIBA/L/18/1114);","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":" Deriv (V) Ltd, 1276, Kumul Highway, Port Vila, Vanuatu, è autorizzata e regolamentata dalla Vanuatu Financial Services Commission; e Deriv (SVG) LLC, Hinds Buildings, Kingstown, Saint Vincent e Grenadine.","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"Deriv Limited — 13 Castle Street, St. Helier, JE2 3BT, Jersey — è la società capogruppo delle sussidiarie riportate sopra.","74e8fa69aad80f93303a7723e5a304f3d43560b6":"I servizi di questo sito web non sono disponibili in alcuni Paesi quali, USA, Canada e Hong Kong, così come per gli individui di età inferiore ai 18 anni.","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"I CFD vengono classificati come strumenti derivati complessi e potrebbero non essere adatti per i clienti al dettaglio. Proprio per la loro complessità, i CFD comportano un rischio elevato di perdere denaro rapidamente a causa della leva finanziaria. Prima di utilizzarli, è bene valutare se si comprende il loro funzionamento e se ci si può permettere di perdere il denaro investito. I prodotti elencati qui potrebbero essere influenzati dai tassi di cambio tra valute; investendo in tali prodotti, potresti perdere totalmente o parzialmente il denaro investito e il valore dell'investimento stesso potrebbe variare. Per questo motivo, bisogna evitare di investire somme di denaro che non ci si può permettere di perdere ed evitare di fare trading con denaro preso in prestito.","5bb3f3499158dbe30af5c725694b321dfe821433":"Prima di fare trading con prodotti finanziari complessi, assicurati di comprendere i possibili rischi connessi: scopri di più su ","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"Trading sicuro e responsabile.","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"Ci spostiamo!","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"Siamo stati","991753597fde70aab5791de6d50ee8cc49a0bdcc":" Binary.com","efa99ab039a285c6264580bea691a4ffefcbeee7":" per 2 decenni ed è ora di un nuovo entusiasmante capitolo.","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"Saluta la nostra nuova casa,","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":" Deriv.","52b8454dc755419beeff2f90cd0fc91def428244":"Ciao Deriv!","27ad1d8334221366694c7acdd70fb380857d1e6e":"Forse più tardi","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"Vai su Deriv","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"Il passaggio a Deriv è davvero semplice","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"Basta accedere con le tue credenziali Binary.com. Non serve registrarsi.","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"Provalo ora","63fbf7977349e32e4a124ffa047549b720806d73":"Porta Deriv con te","03d42257a2263b2841b9e0ae4b94de117228a33a":"Scarica l'app mobile Deriv GO e fai trading ovunque ti trovi. Non perdere mai più occasioni d'oro.","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"Scansiona il codice QR per scaricare Deriv GO","6b7499b1513a3cec3da3ff07cdad9b358954021e":"Non aspettare","b23efda40ddeb801beeebf915669d806744014af":"Assicura il tuo trading del futuro. Passa a Deriv ora.","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"Entra nell'esperienza Deriv","34075438f939258908cc21d28bf59ab5126dc2d6":"Vieni da Deriv e prepara subito il tuo trading a prova di futuro.","e669443b63757b5ad8571e52393caf2a0a812be3":"6 motivi per cui t'innamorerai di Deriv","2c141583afaaa12438b16ee67355c6e3eaf77763":"Binary Bot ha una nuova casa","4e0e045da59b385138ced3203cdb81c3b4cdd135":"Siamo stati Binary.com per 2 decenni e adesso è ora di iniziare un eccitante nuovo capitolo. Il tuo costruttore di Bot preferito, Binary Bot, è adesso su Deriv, la sua nuova casa. Vieni a dare un'occhiata.","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"Vai a Binary Bot su Deriv","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"Utilizza Binary Bot su Deriv, la sua nuova casa","1071c645f523394b408a6d285e95331bc583f14c":"Tra 5 minuti, ti mostreremo i vantaggi del trading con Binary Bot su Deriv. Se ignorerai il messaggio, ti invieremo un promemoria tra 3 settimane.","be43a8989c5745ec7386ca7c69442165f55dee8e":"Mostrami subito i vantaggi","074603c9aef93515ed33d179e982c67ea7abdb45":"Fai trading con Binary Bot su Deriv"}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"Lý luận","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"Toán học","c3328c39b0e29f78e9ff45db674248b1d245887d":"Văn bản","4d064726954a17487f94e931f5b157b733ec22ed":"Nâng cao","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"Danh sách","19de69cb601f53a4ea7af22a65c71ae63251365c":"Biến số","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"Chức năng","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"Vòng lặp","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"Nhị phân","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"Khái niệm thương mại","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"Trước khi mua","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"Trong khi mua","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"Sau khi mua","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"Phân tích đánh dấu","8cf71374fa095a64b5295b672daef8507ec7be6a":"Chỉ số","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"Công cụ","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"Thời gian","8d8fd6765e184419cad8b88d1a60c895d79578c2":"Nến","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"Các loại khác","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"Lịch sử","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"Tổng quát","9feddbabd7e7309e96c590069057158e96baa8f6":"Kiểm lại thực tế","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"Giao dịch các tùy chọn có thể trở thành một cơn nghiện thực sự, như bất kỳ hoạt động nào khác bị đẩy đến giới hạn của nó. Để tránh rủi ro của một cơn nghiện nhu vậy, chúng tôi cung cấp một phương thức kiểm duyệt thực tế cung cấp cho bạn một bản tổng quát những giao dịch và tài khoản của bạn một cách thường xuyên.","4152043e8c670075d2c919677e835edb0d923cab":"Xin vui lòng ghi rõ khoảng thời gian kiểm duyệt thực tế phù hợp với bạn trong vài phút","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"Vui lòng nhập một con số trong khoảng từ 10 đến 60.","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"Tiếp tục giao dịch","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"Lời tuyên bố","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"Đăng xuất","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"Liên hệ với chúng tôi","f7c400ed695f898b8ee9d21664aa17b5bb693828":"Đăng nhập","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"Phục hồi giao dịch về trạng thái ban đầu","f98595d541778d86f75ef22b3328a031d20aa16b":"Tải các giao dịch mới (tệp xml)","4a1e616226c329a94da7768bc0435a3284478010":"Lưu lại những giao dịch hiện có (tệp xml)","6b3465ace62f33f0687b4669ac26d95895e9ca52":"Liên kết Binary Bot với Google Drive của bạn để dễ dàng lưu và tái sử dụng các khối giao dịch của bạn","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"Hủy thay đổi (Ctrl+Z)","937f5055f05be359ddf619744e8af4d643549e80":"Phục hồi các thay đổi (Ctrl+Shift+Z)","8406d1cce44230835932060649e999ca3283b413":"Phóng to (Ctrl + +)","1109673172af2c173c492622ff8a72c8f29f0e70":"Thu nhỏ (Ctrl + -)","44c22002c65d2871331263a23c3e09c0a1bfd847":"Sắp xếp lại theo chiều dọc","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"Hiện/Ẩn các thông báo tổng hợp","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"Chạy bot","ba50a42d8d3228c37a817865fce49fbca692c2ad":"Dừng bot","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"Hiện lịch sử","91017ef9b165cd0e7475a770f318ea5e705e1321":"Hiển thị biểu đồ","c89e3dd1cafcadcc0312e476ab58b2332209da23":"Xem giao dịch","b02c858e72be118a65c9393930351012b647cb9e":"Hiện tiêu đề","250be77f7605669a0b3d968b9ed381a3d9787ed1":"Mở tệp XML đã được lưu và lấy về các khối giao dịch của nó","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"Binary Bot","608061fb5aab975013fa70c5c814a1d8ba30c152":"Giao Dịch Hiệu Quả Ngoài Sức Tưởng Tượng","e4ce8dc3e416e69262ba642dc57d3975d6616980":"Quan tâm đến tự động hóa những chiến lược ưa thích của bạn cho việc giao dịch những tùy chọn?","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"Binary Bot là công cụ lập trình tiên tiến của chúng tôi mà giúp bạn xây dựng những ứng dụng giao dịch với 1 một chức năng kéo-và-thả đơn giản","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"Mơ đến con số bất kì thuộc những con bot giao dịch những tùy chọn nhị phân, từ những công thức vô cùng đơn giản cho đến những thuật toán quy mô phức tạp. Sau đó để chúng giao dịch cho bạn, ngay cả khi bạn đang ngủ.","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"Bắt đầu dựng một Bot bây giờ","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"Cần hỗ trợ thêm?","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"CẦN TRỢ GIÚP?","d635b53e59c9aad8c5d78458826beffb029b27bf":"Cảm ơn bạn, chúng tôi sẽ liên hệ lại với bạn trong vòng 24 giờ","a69a8fc21499d0fd85e87bab467699827547a5bc":"Vui lòng nhập một URL server hợp lệ","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"Thị trường được gạch chân chưa được chọn","50050f06645ad2743165b429a8f7deebd285fd63":"Loại hợp đồng không được lựa chọn","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"Xin vui lòng đăng nhập","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"Thời lượng phải là một số nguyên dương","4df6e872792d72aea8a2f6b831d00b554464da23":"Số tiền phải là một số dương","001e68df3a4b32a4d57148d9d407f44eee3b7436":"Nến đã chọn không hợp lệ","04f14ea7c92e0b2b5ae005c696245063ec641d66":"Danh sách nến đã chọn không hợp lệ","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"thử lại trong","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"Tỉ lệ tối đa chạm tới","094628ce13fc0e78f07b697d1cc9421bb2edd666":"Yêu cầu không thực hiện được","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"Không","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"Có","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"tuyên bố","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"hỏi giá","50e72909992bdc37c7c07769d1b7efac5e52874c":"thanh toán","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"lợi nhuận","c980b910204c7babdffe8ff3f7e755f30133383c":"loại hợp đồng","a726c6955157f1b8b92f9932652434a7150f80f8":"điểm gia nhập","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"giá trị nhập cảnh","3905be81561384dc8c43d6127c57ed1e0eb03b74":"chuỗi giá trị vào","7674920c033ca14277c577e19c037a6754d4fa80":"điểm ra","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"giá trị xuất cảnh","06ecea26625359f7dcf5ff5c47af6174ff815257":"chuỗi giá trị ra","779455ee3bde8494d9629b353e17b19e92357ba8":"rào cản","37a5301a88da334dc5afc5b63979daa0f3f45e68":"kết quả","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"Thắng","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"Thua","563339f82447b4e758ad76d5a0b63b5698594fba":"Tăng lên","5c1ae82c29543ac887703776bf3da2c7dcce683d":"Sự giảm","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"Không có thay đổi","ecb252044b5ea0f679ee78ec1a12904739e2904d":"chuỗi","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"con số","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"xanh lục","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"xanh dương","96de5543d183d7de52ac5fa21c46fc811f673f89":"vàng","78988010b890ce6f4d2136481f392787ec6d6106":"đỏ","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"Yên lặng","cf84a98d6cf7f156862a08ba8236467b6f471004":"Thông báo","eee2facd669d1434848c24da5527b3e87d9a12d5":"Tiền kiếm được","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"Công việc hoàn thành","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"Lỗi","a3b1583d377f37ac20de7e089edfa0920a078e57":"Lỗi nghiêm trọng","66c8b6848eee629c4ac551bf2b5fa591571654be":"Tăng tương đương","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"Giảm tương đương","062787aa328047e189774b3703d983b83938f6e9":"Cao hơn","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"Thấp hơn","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"Liên lạc","7d7932bcc2e262ae98cf09dc5445130fb3881769":"Không liên lạc","a16814a48ec58c2e24ba224a80921a5c02361abe":"Kết thúc vào","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"Đầu ra","534ec5da4e82ec419abc170e1a8448f55a01664f":"Ở lại","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"Ra ngoài","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"Châu á tăng","c098658ce3d3a258e4d155949a60072966b36db7":"Châu Á giảm","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"Những chỉ số khớp","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"Những điểm khác nhau","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"Chẵn","dc28f5f3c65ec611f0f30022650d24382d27448e":"Lẻ","18a63f5512afb5573e5b44deba78d629f0635317":"Lớn hơn","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"Thấp hơn","2155c8b38181dd2552e84a94049aacd33ef9c607":"Tick cao","1408cfd2b064b923f024fbe590e27db8282941a5":"Tick thấp","b86eb15dc4f13e4c2972de158d3038d9f657242f":"Đặt lại Gọi Biên","669a1f3d9a8f601a84da536cfdad1de4092b1926":"Đặt lại Đặt Biên","844d1a5c99a0a668383340cc095d040eef998c79":"Chỉ Tăng","87293a146cd481a2b30cf74282ec061dc4cf0735":"Chỉ Giảm","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"Mở","b1a5954a483f8f8b0207385095f74aeb409b3f80":"Cao","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"Thấp","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"Đóng","1173872a4fb205b713702f0eec5cf2c732c828fd":"Thời gian mở","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"Mặc định","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"1 phút","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"2 phút","24e46784cbce32443db5a2638b1a7d3201543e9b":"3 phút","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"5 phút","a6f151883b736f0470d33492e61c72a7d059d065":"10 phút","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"15 phút","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"30 phút","f030c3d667652646b86732ad7bc67e226c49cd3a":"1 giờ","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"2 giờ","7b47150d431db70d783724007f07ab894eb8ac2e":"4 giờ","191800b7e9a48680792c0dd77cb6cac00c4514c6":"8 giờ","2d8a6f7c34468578640b333b8650131de06ac770":"1 ngày","cd1495cb4c60266a6abad9024022ae079bf7e416":"(1) xác định hợp đồng giao dịch của bạn","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"(2) xem và mua các hợp đồng của bạn","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"Các tùy chọn giao dịch","160f06d4799c85021a810f68c5b517eea37a2737":"Mua","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"Lên/Xuống","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"Lên/xuống tương đương","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"Châu Á","2260ce49306460c8a2ef501939f29ad6ddd4e934":"Chữ số","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"Chạm tới/Không chạm tới","f7de1f66f0979667da275b7e8996e805395025a1":"Kết thúc ở trong/ngoài","a431deecd4c2258097adae418d496fe9a8179fee":"Ở trong/Ra ngoài","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"Tick Cao/Thấp","12a3f461cdebbc8f335190413ee6c57442743bba":"Đặt lại Call/Put","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"Chỉ Tăng/Giảm","91a64e3f83c91acf336c631fba295f297f94c399":"Chạy sau n giây","024696596f26a4db232fd9e966eadfeb27c0bd1a":"Chạy mỗi n giây","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"phía trên","85c274929bc0e28eafd3734f2c25046c3b95b36b":"ở giữa","346e3ee198e98146993894d3de8ecab1a86c3e80":"ở dưới","f16459104f92ab6b38aa265adb4ecbfc3768e303":"Biểu đồ","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"Macd","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"Tín hiệu","19eabc961735d78f12fc7be906ffcb033853cf85":"Dấu thời gian","68f4145fee7dde76afceb910165924ad14cf0d00":"Tin nhắn","e99811bd3b1ad17e74614060ecb180602be35ad6":"Bạn đã bị đăng xuất!","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"khối nên được thêm vào không gian làm việc","1fde9f1ebca07dcbc704130bd18645bce7718b55":"khối nên được kích hoạt","d466687f90ba548434d65186d11a80c4204f9ad6":"phải được thêm ở bên trong:","629777b7d4d610ace6dee24442730f27d7d0853e":"Tệp không được hỗ trợ:","0b93c14956403c2e5c9e79f5c836babc56912006":"Binary Bot sẽ không thực hiện thêm các giao dịch mới. Bất cứ giao dịch nào được đưa ra (mà vẫn còn hiệu lực) sẽ được hoàn tất bới hệ thống của chúng tôi. Bất cứ thay đổi nào chưa được lưu sẽ bị xóa.","c1458ff86fd60d9544d7cd8a67437df2b766f482":"Lưu ý: Vui lòng truy cập trang thông báo của Binary.com để biết thêm chi tiết về các giao dịch đã được xác nhận.","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"Bất kỳ thay đổi nào chưa được lưu sẽ bị xóa.","410bf23a3f080def9c7a976a16305bcde7943ed1":"Bạn có chắc không?","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"Rất tiếc, Binary Bot không khả dụng ở quốc gia của bạn","901624741023fcfc805ce43c94b8012e3b1d1c99":"Muốn giao dịch CFDs trên MT5? Bạn sẽ được quyền giao dịch ngoại hối, cổ phiếu, chỉ số chứng khoán, hàng hóa, tiền điện tử, và các chỉ số tổng hợp.","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"Các chiến lược","910ec7aa40b04ec6ba51162f4de7850569326cb6":"Đã có lỗi xảy ra khi tải Google API script.","8f51f350debde84e067e1a0405fb6304922a7d4b":"Đã xảy ra lỗi khi khởi chạy Google Drive.","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"Đã có lỗi xảy ra khi tải thư viện Google Drive","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"Vui lòng cấp phép để có thể xem và quản lý các tệp của bạn trên Google Drive","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"Tệp không thể được nhận dạng","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"Đã có lỗi khi lấy dữ liệu từ Google Drive","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"Chọn một chiến lược Bot Binary","2db43c69a4b96454914f0b8272bc869984529e6e":"Đã có lỗi khi liệt kê tệp từ Google Drive","0dcea5f584938e0fff00084b83156ab31d641ab3":"Đã có lỗi khi lấy tệp từ Google Drive","18da95988117ff029393f3f5c881d70ef47f7385":"Đã có lỗi khi xử lý yêu cầu của bạn","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"Chọn một thư mục","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"Không thể gửi thông báo điện tử","3f370309b6280eb100f898426d8605c1f45d558d":"Mốc thời gian không hợp lệ","af6a4e2a5582be89ac930e946eaed86e01cac58b":"Ngày/giờ không hợp lệ","49d51398b574e7312d99b18d2b93d2ede416f053":"Không thể gửi webhook","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"Các đề nghị chưa sẵn sàng","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"Đề nghị đã chọn không tồn tại","6ea4a034747d020b1d8ce4848def95d537555dd6":"Đã được mua","89f89c02cf47e091e726a4e07b88af0966806897":"ID","1200c1af2f7bba4e29a34112865662748c9d41df":"Hợp đồng chưa được đề nghị bán lại.","62d6180e55905f7b996d442c53631981a4ef8b5b":"Đã bán cho","ed4978867de1da05b336b724a3fb96222a29ebec":"Chỉ số phải là một số nguyên dương","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"Số lợi nhuận","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"Số lỗ","46fc6f27a835486d63d9e927c6687e4508cb3087":"Số giao dịch tối đa đã đạt tới","9202ddae4cea16513e53bbc965d88ed975e59512":"Số lỗ tối đa đã đạt tới","5f52b397b7e5f538681f0f5717a88aa626349c7a":"Bot.init không được gọi","66c7734789e19cbeef3a5ac185ea732139aed213":"Biểu đồ","3b662fb2e8bafce29aa98321b18874bb44905488":"Tích hợp Google Drive","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"Vui lòng đặt giới hạn thua lỗ hàng ngày của bạn trong trang Công cụ tự loại trừ để cho phép giao dịch.","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"Tối đa các giao dịch liên tiếp nên trong khoảng từ 1 đến 100","93039e609d94a24f3572b794a31b21525a09af2b":"Chưa thiết lập","a85b8cc112a8597df1612d60a74faa818c25d1b3":"Chúng tôi yêu cầu bạn đặt các giới hạn thương mại tuân theo các quy định kinh doanh. Xin lưu ý rằng bot của bạn sẽ chỉ ngừng giao dịch nếu có bất kỳ hoặc cả hai điều kiện dưới đây được đáp ứng.","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"Giới hạn mức thua lỗ hàng ngày:","95052a29f213e9698b593418fe396ecc21032f9b":"Đây là ngưỡng giới hạn khoản lỗ tiềm năng của bạn trong ngày trên tất cả các nền tảng Binary.com. Khi tổng số tiền thua lỗ của bạn đạt đến hoặc vượt quá số tiền này, bot của bạn sẽ ngừng giao dịch. Vui lòng đặt một giá trị trong {$0}trang Công cụ tự loại trừ{$1}.","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"Tối đa các giao dịch liên tiếp","730657200c17321d926e1bd08dbf65bd96855a8a":"Đây là số lượng giao dịch tối đa mà bạn cho phép bot của mình thực hiện trong lần chạy này.","952f375412e89ff213a8aca383d18e5691354347":"Bắt đầu","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"Những rào cản về giao dịch","095ba68888b5ace5f4515f5acab76dfa1073544e":"Máy tính của tôi","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"Tải","248e224f533752db28a1aab3519a58569ad96140":"Tải các giao dịch","c7097e97dcc446ca889d3ca6be733a65e2728afe":"Tải lên Google Drive thành công","a6b977714595aa01678fca98e86553aaeac05c92":"Lưu các khối của bạn riêng lẻ trong một bộ sưu tập. Chúng sẽ được thêm vào không gian làm việc hiện tại của bạn (các khối chính sẽ được thay thế) khi được tải.","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"Lưu làm bộ sưu tập","611ebbfb080284312904de925ef0f75f4cb56ad2":"Lưu các khối và cài đặt của bạn để sử dụng cho các chiến lược khác","efc007a393f66cdb14d57d385822a3d9e36ef873":"Lưu","a638caa8ab2b7ff7980a571334217339e6d1d634":"Lưu lại giao dịch","39fca63515c105918f03e4908ec12df675b07f92":"Xem giao dịch","e643975ea5296d9de4486458f31ab0a5a2b228bf":"Thao tác này sẽ xóa tất cả các giao dịch trong bảng tóm tắt và tất cả các quầy sẽ được đặt lại về 0.","85dfa32c97d8618d1bea083609e2c8a29845abe5":"Tài khoản","d847919a30d31c0be624087f3370492b3fdf80c6":"Số lần chạy","5cd6978d63540c8a490ef76f43219de6362f958e":"Tổng cổ phần","17410d7b62b8b1de981cfebada24632987edf186":"Tổng thanh toán","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"Tổng lợi nhuận/lỗ","90eef613042c5a51f542421065b68b886d473807":"Số dư","db1c784524e1b54011a95823026161f7c8517fe0":"Tương quan","4db3e9e4aecd187db9339a10d2629fef46724dc4":"Loại giao dịch","1bb4086b66659d8580f9be4beef69931aeea3cad":"Điểm gia nhập","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"Điểm thoát","ba7be969e7c1bb5f22489e843478e3d721aaa843":"Giá mua","772fbced18230220d2d9be1456be16fc1b271d25":"Lãi/Lỗ","bae7d5be70820ed56467bd9a63744e23b47bd711":"Trạng thái","96f608c16cef16caa06bf38901fb5f618a35a70b":"Đang chờ xử lý","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"Đã cài đặt","82a82f798dd773717ec37d15fd4405510291734e":"Bot đang không hoạt động.","6a88e58aa1798626f94cf17f1a91618b405bb289":"Bot đang khởi động...","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"Bot đang hoạt động...","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"Bot đang dừng lại...","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"Bot đã dừng lại.","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"Đang mua","4684ee1026d9b4c872d016c3c4588a0c479a451c":"Số lượng mua","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"Mua thành công","f02760cd2eac28169f0a990c950c3dfe8427f772":"Hợp đồng đã được đóng","c7363d8a0748d4a7e2cc968335dc9716f290359d":"Dừng bot sẽ ngăn giao dịch tiếp theo. Bất kỳ giao dịch đang diễn ra sẽ được hoàn thành bởi hệ thống của chúng tôi. Xin lưu ý rằng một số giao dịch đã hoàn thành có thể không được hiển thị trong bảng nếu bot bị dừng trong khi đặt giao dịch. Bạn có thể tham khảo trang sao kê Binary.com để biết chi tiết về tất cả các giao dịch đã hoàn thành.","fadc0ef93d1ff13370524ce8481ddc4a71195934":"Sắp xếp lại theo chiều dọc","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"Tải xuống","e4458464df6cbb8da1134875ba51519c5d244d9f":"Các khối phải ở trong giữ khối, các khối chính hoặc các chức năng","e9c45563358e813f157ba81b33143542165ba84e":"Cảnh báo","31cb6f44d030abeabcc7046555dea851602a87a5":"Chiến lược này không khả dụng ở quốc gia của bạn.","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"Ok","9970168c192807246fad6138344e5a96449afbdd":"Tệp XML đang trống. Vui lòng kiểm tra hoặc sửa lại tệp.","a594b427eaf0f108d3e9cc20d70e15da811c760c":"Chiến lược không được hỗ trợ","04a5090686ac7b54822e00a9ff08c38a107601e7":"Rất tiếc, chiến lược này không thể được sử dụng cho Binary Bot. Bạn chỉ có thể sử dụng chiến lược đó trên DBot.","77dfd2135f4db726c47299bb55be26f7f4525a46":"Hủy bỏ","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"Đưa tôi đến DBot","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"Tệp bạn muốn mở chứa các phần tử không được hỗ trợ trong khối sau: {$0} Vui lòng kiểm tra lại tệp của bạn và thử lại.","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"Không thể nạp tệp giao dịch","af145748c9cf765a3b059eec20cb1dbb899297d8":"Các khối đã được nạp thành công","11ee9c5d534cc8d22651092222b532917594161a":"Thời lượng tối thiểu là","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"Số lượng giao động phải ở trong khoảng 5 đến 10","ace1342bc3720b77ce510b93074041e7386d209e":"Thời gian hết hạn không thể bằng thời gian bắt đầu","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"Dự đoán phải là một chữ số","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"phải được thêm ở bên trong","33aa6ff282ee509d37c6f758274c9156b419ff73":"Chiến lược bạn nhập không hợp lệ.","da162a909c2981ed318d23cd9a6be1d66e0a8400":"Định dạng tệp không nhận dạng được.","5e719fa76e1b6cb396376c82ebdd04bec7253229":"Khối từ xa để tải phải là một bộ sưu tập.","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"Không thể nạp tệp khối.","df84a88f38b03b5b342362d72370b0d66afdae35":"Mục tiêu phải là một tập tin xml","cd680fd936e9559ef1d95efac7a71680e2b13a89":"Url này đã được nạp xong","34c59389053701a04127f74d32315e0206e076f8":"Lỗi đã xảy ra trong khi tải url","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"Đảm bảo rằng 'Truy cập-Điều khiển-Cho phép-Nguồn gốc' tồn tại trong các phản hồi từ máy chủ","988df856c066143616bd33d5904bbcdc22ff129e":"Binary.com đang chuyển sang Deriv","2fccaab15d71b00c19da7053135471d510b513db":"Giao dịch trên Deriv","3ead0b14c72503187691a7a6d7121987299bd401":"Đây không phải là một phiên bản chính thức của Binary Bot, sử dụng tại rủi ro của riêng bạn.","27401c9c8e476d659c8382e05c6d70a4a82be468":"Phiên bản chính thức","bc981983e7f547dc62e19a1e383acfe00782a6d5":"Tiếp theo","b52b36b7269fbfc58ec24bb724691951a3decbe8":"Trở lại","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"Hoàn tất","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"Làm một chuyến tham quan nhanh chóng","a48e81d4a8da67637b46725824177a959fe99b21":"Đã sẵn sàng để học cách sử dụng Binary Bot?","6f3e6ebf249947cec4f64117253a8fe43335ae79":"Không, cám ơn","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"Không hỏi lại tôi lần nữa.","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"Không gian làm việc","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"Kéo và thả các tệp hoặc thực hiện các chiến lược của riêng bạn.","d171baee235d4c93f63755a876782dc5be4c3e47":"Công cụ cho các giao dịch","056f19272d96f902c38207cf163ea8dbff7fbd32":"Thêm các giao dịch từ đây tới bot của bạn.","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"Các tài khoản","f5c47fd3b3553b10441a06054078cea745177dea":"Đăng nhập trước khi khởi động bot của bạn. Luôn luôn kiểm tra chiến lược của bạn với tài khoản ảo.","fd825ae94aa79500a878dd4590a4b360e7162663":"Điều khiển bot","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"Kiểm soát các giao dịch. Giữ con trỏ chuột trên mỗi nút để biết thêm thông tin.","f5169c84497de3aea74f7da9e7e177d1427e736b":"Tận hưởng!","4f1b3d682c2a00b393c33637da402463bc11d5ff":"Muốn báo cáo sự cố hay yêu cầu giúp đỡ?","0049f8894e41937ebb9111cd3def6749049fb50f":"Bấm vào đây","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"Truy cập vào Binary Bot ở đâu trên Deriv","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"Trên trang chủ của Deriv, nhấn vào Giao dịch ở đầu trang và chọn Binary Bot.","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"Dùng thử Binary Bot trên Deriv","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"Vẫn là Binary Bot mà bạn hay sử dụng","169dd3b2025485a48b8f9f3f6ef89f5586714140":"Mọi thứ đều chính xác theo cách bạn muốn.","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"Dịch chuyển bot của bạn một cách liền mạch","b763f8cbfa6396f195781032619a99bba04bc939":"Các chiến lược của bạn trên Binary.com cũng có thể được sử dụng trên Deriv. Chỉ cần tải các tệp XML của bạn và bắt đầu giao dịch.","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"7 nền tảng giao dịch — gồm các nền tảng cũ được yêu thích cùng nhiều nên tảng mới","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"Bạn sẽ tìm thấy Binary Bot và SmartTrader cùng với các nền tảng mới như DBot và DTrader. Dù phong cách giao dịch của bạn là gì, chúng tôi vẫn sẽ có nền tảng dành riêng cho bạn.","0ce7480da93c1c9839818d0720b77931d1637574":"Gửi tiền điện tử thông qua đường nối tiền phấp định","6e6a4c6839d2e859758a517865b095c1b8298dd6":"Dễ dàng gửi tiền điện tử thông qua các dịch vụ trao đổi như Changelly, Banxa và XanPool.","c1b51f196c97b4781a354457579e9699b09de087":"3 kiểu giao dịch","4708f7e87263464b130b987e4b9aed981c4f455d":"Giao dịch CFDs, quyền chọn điện tử, và cấp số nhân, một loại hình giao dịch hoàn toàn mới giúp tăng lợi nhuận tiềm năng và hạn chế rủi ro.","b7fceac7d5f885d735aeda6e4654487467d33fa3":"Hình thức gửi và rút tiền ngang hàng","79a206119137878eb6be7c60f7ed34135194bdf0":"Trao đổi nội tệ của bạn với các nhà giao dịch khác để nhận tiền vào và ra khỏi tài khoản qua Deriv P2P.","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"6 loại thị trường","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"Mở rộng danh mục đầu tư của bạn với nhiều loại thị trường như ngoại hối, cổ phiếu, tiền điện tử, tổng hợp, và còn nhiều hơn nữa.","14b2a808fdec3702e5a6b9152e13288c87a4768a":"Trau dồi kỹ năng với Deriv Academy","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"Tham khảo các bài báo và video miễn phí để giúp bạn tìm hiểu các nguyên tắc giao dịch trực tuyến.","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"Bấm để chọn","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"Không tồn tại","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"Những điểm thay đổi giá","5fb1db527825d2996e37c655e5dec49d4da80c09":"Giây","092f99ea11a34a8490e7a767a83a42fc45634f82":"Phút","9e25a34e635a123f8958bbe26e7c4843278597fb":"Giờ","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"Ngày","db6708630fc646eb98298d9acd701e0a1ac051c2":"Lưu các giao dịch và chiến lược của bạn lên Google Drive","85538d002a336c5addef8d189d80976cf7758f8c":"Bạn đăng nhập với tên","b65463cb6a42a17de514acc4659f7fd331e0876a":"Kết nối","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"Ngắt kết nối","cd5f85b6f187605f82386eacd680f93820af8d11":"Kết quả là","1e38ce3d180cefae485a6986ca7c67841e30376f":"Đúng nếu kết quả khớp với lựa chọn","5c89497fc3c128e2ff865ce8df15356054f2c028":"(4) Nhận kết quả giao dịch của bạn và giao dịch lần nữa","14ea81918758c994cbe3178e695e56afc1ef2b45":"Nhận được thông tin giao dịch trước đó và kết quả, sau đó giao dịch lần nữa (Chạy trên điểm kết thúc thương mại)","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"Chi tiết hợp đồng:","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"Đọc một tùy chọn đã được chọn từ danh sách chi tiết hợp đồng","b3b543c80063a116ced4965d8537b7b62d14c0b7":"Giao dịch lần nữa","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"Chạy lại khối giao dịch","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"Hỏi giá","343fda69c73b78b84967055aae97f790c422adfd":"Hỏi giá cho đề nghị đã chọn","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"Xem các dòng dấu tích và mua hợp đồng mong muốn (chạy trên cập nhật tích)","9bb396940adb9705fe57eba6ea8b578e6aafa792":"Thanh toán","87da93a46d143f6019979b3548414d9d7adabb35":"Thanh toán cho đề nghị đã chọn","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"Mua một hợp đồng đã chọn.","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"Lựa chọn bán hiện khả dụng","03bad10717e183b24829baf483dc715e1a44bf7b":"Đúng nếu lựa chọn tại thị trường đang khả dụng","2c71ed279a402e93312dbda173ab18f244d6bf46":"(3) Xem và bán hợp đồng đã mua của bạn","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"Xem thông tin hợp đồng đã mua và bán tại thị trường nếu có sẵn (chạy trên cập nhật hợp đồng)","579607dc4f989ce2b94b558431666a0ab07ac1f3":"Bán tại thị trường","e20afd5cf3811a42071c9a312abb2afdad4c590b":"Bán tại thị trường.","4712cbff8e92822fc960ef9c0197293a19675eae":"Bán lợi nhuận/tổn thất","df817b48c7a076561b4f8bedc52d65d2e351ab52":"Trả lại lợi nhuận cho bán tại thị trường.","b44e884c355e447d0da0e6ba45caaff18c84373b":"Bollinger Bands","d6a2a207343bd83aacdc80b579ff4419713a256e":"Danh sách nhập","170a28a9db6d27d7212fc6dc249434a57517e7bc":"Khoảng thời gian","b833989d69900a4be9e32d1bab65c8f8233f099e":"Hệ số Std. Dev. Up","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"Hệ số Std. Dev. Down","974da601086448d0060aeed90e53ddd5acd17b91":"Tính toán Bollinger Bands (BB) từ một danh sách với một khoảng thời gian","d5b65cac1f1cf9421ac978eebe532de99040cca6":"Mảng Bollinger Bands","58de49791c64aba14e36e5887244a5ef088286cd":"Tính toán danh sách Bollinger Bands (BB) với một khoảng thời gian","4bd99f76f1104229744455d93df0ff76b9eeed58":"Trung bình động mũ","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"Tính toán hàm mũ trung bình động (EMA) từ một danh sách với một khoảng thời gian","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"Mảng mũ trung bình động","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"Tính toán danh sách hàm mũ trung bình động (EMA) từ một danh sách các hía trị với một khoảng thời gian","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"Mảng MACD","b18e572ea14edd48587145f1ef50718adbf256c6":"Giai đoạn EMA nhanh","974023bddd6249d0f6404872cfcae205b2599ea2":"Giai đoạn EMA chậm","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"Chu kỳ tín hiệu EMA","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"Tính toán danh sách Phân kì hội tụ trung bình động (MACD) từ một danh sách","95ec92885c855ba9cf734c17a43f081901e4d2cc":"Chỉ số tiềm lực tương đương","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"Chỉ số tiềm lực tương đương (RSI) từ một danh sách cùng với một giai đoạn","4034de66995b876b2ba9bfd0274025e39168e05d":"Mảng chỉ số tiềm lực tương đối","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"Tính toán danh sách chỉ số tiềm lực tương đối (RSI) từ một danh sách giá trị với một giai đoạn","a9842c95766da40bf4ea6ee263cb5a5985847763":"Trung bình động đơn giản","347775a293c14362d492f019e677c965be1d6e7d":"Tính toán trung bình động đơn giản (SMA) từ một danh sách với một chu kì","4cc7b9e53d082896ad884eb01be16320af65f282":"Mảng Trung bình động đơn giản","2c75179a57af3c36581008b65e86ed81c4a4cbea":"Tính toán danh sách trung bình động đơn giản (SMA) từ một danh sách các giá trị với một chu kì","39f024cf49724fe7ffdea7773c72ed06eec998e1":"với khoảng thời gian","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"Hướng là","ad47561efb1dcbd7246d9b64487f615647fda036":"Đúng nếu hướng trùng với lựa chọn","05bef508aadd62bf3967dcf67d769da296f19989":"Hướng giao động","21bfc78607d3a64de767a6677d1db42156d5039d":"Trả về hướng đánh dấu nhận được bởi một khối trước khi mua, giá trị của nó có thể là 'tăng' nếu đánh dấu nhiều hơn trước đó, 'giảm' nếu ít hơn trước đó và trống ('') nếu đánh dấu bằng với đánh dấu trước đó","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"Hướng của khối bị từ chối, vui lòng sử dụng khối kiểm tra định hướng","cdb31fc857f01a59f664413498293c714285f46d":"trong danh sách nến","20fd5f86f08796f145d69dedc209a27e459b2f51":"có được # từ điểm kết thúc","a96606af8c33ac3428b45abc4782dbf93f458d29":"Có được ngọn nến gân đây của nth","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"Danh sách chữ số cuối","248428facb97408414180d4de74e4db35360fbc4":"Hoàn lại danh sách các giá trị của các chữ số cuối","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"Số cuối","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"Hoàn lại con số cuối của giao động cuối cùng","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"Danh sách nến","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"Hoàn lại danh sách nến","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"Làm một danh sách của","a4220593d385a720886f7af1ed3c478fd0c6339c":"các giá trị trong danh sách các nến","cd8cdf3d47e921c8a72addae9269e66041d417c5":"Hoàn lại danh sách những giá trị nến đã được chọn","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"Trong danh sách các nến cho thấy ","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"# từ điểm kết thúc","aba43a580daa7f306956ec69b83e6e37e7233126":"Đọc giá trị nến đã chọn trong nến n thứ gần đây","e04b522218a181cf0223042dd18ae08dcc22d8d3":"Giao động cuối","6ee445fc253a55c9ed54c009c3f020ac65200d80":"Hoàn lại giá trị giao động nhận được bởi một giao dịch đã mua trước đó","ed44b69176217a1251c04f0c13d23ac789ea60b2":"Chuỗi tick cuối cùng","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"Hoàn lại giá trị tick nhận được bởi một một khối Mua Trước (Chuỗi)","4b2340a890e88d1886757c3f7172e273a1edc31f":"Giao dịch này xuất hiện trên từng giao động","b54d7b4590559dad64f02d09aacbf6d9863e2624":"Bạn có thể sủ dụng giao dịch này để phân tích những giao động, dù bất kể các giao dịch của bạn","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"Danh sách các giao động","17649cac8739adcae95e641f794880272ad33bd1":"Hoàn lại danh sách các giá trị của giao động","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"Danh sách Chuỗi Tick","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"Trả về danh sách các giá trị tick (Chuỗi)","c67ded6b64019212eb2bc69afd761f5b3f626040":"Thêm ký hiệu cho một số để làm một hàng rào bù đắp.","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"Thị trường","74751e67c3e1010c343095eaf543e7cb21ced2ef":"Loại giao dịch","1f4698382842477e211eb46de81fa506f01a8c34":"Cả hai","c1baf816aac5a5cd849768773fc248cd249dc296":"Loại hợp đồng:","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"Khoảng thời gian nến mặc định:","9693aeaaf68e3929b59b79306feaa0a847d01192":"Thời lượng:","78d7103a319e808455d397513279d99f3b3f3768":"Cổ phần","10c02649e226d430bd75a5b6315a41c0db9992a2":"Rào cản","837276742aa90209dde3b4eef07d8e7ab26731ef":"Dự đoán","258b49925b41751c6bd790a0848246566ba61440":"Khởi động lại mua/bán trên lỗi","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"vô hiệu hóa để hiệu suất tốt hơn","b410994b67e37d9516eb9b866c85a8c639f79e68":"Khởi động lại giao dịch cuối nếu có lỗi","2260c5a971c2602834ef8feeb5fa522f900b469f":"bot bỏ qua giao dịch không thành công","0745acf92abd7b60598f161717884cc45dab8694":"Chạy một lần tại điểm bắt đầu","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"Lựa chọn tùy chọn giao dịch","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"Xác định các hợp đồng giao dịch của bạn và bắt đầu giao dịch, thêm khởi tạo ở đây. (Run on start)","4d22b565e4253e92a908f216184779679bb1a044":"Rào cản cao","b70c38c6db3127422e05315c30bdf76c7c36c480":"Rào cản Thấp","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"Tuyệt đối","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"Số dư:","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"Có được số dư hoặc chuỗi","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"Các khối giao dịch bên trong được bỏ qua","d072c2ceeb5c1217722d14c74de7aeab945b4215":"Đặt các khối giao dịch của bạn ở đây để ngăn chặn chúng khỏi bị gỡ bỏ","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"Khóa: %1 Giá trị: %2","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"Trả về một chuỗi đại diện cho một cặp khóa giá trị","b06acc4158c824231f727a13e1c9811f43d5be42":"Tải khối từ","661db37251a1ed1afe357ee13895f37a623d7cbf":"Nạp các khối từ url","6c03ee54ad3a51fc92a1d69943e99667847705b6":"Thông báo cho","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"với âm thanh","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"Tạo thông báo","6e0fc122f936f808bc2e3af661121b65712ae855":"Thông báo điện tín %1 Token truy cập: %2 ID Chat: %3 Tin nhắn: %4","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"Gửi một tin nhắn đến điện tín","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"Tổng lợi nhuận","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"Hoàn về tổng lợi nhuận","532e65f6e266db0bb442d1f426d44d7d32962340":"Chuỗi Tổng Lợi nhuận","78e84591ff76f992953a8e19b57c7eab7546d638":"Trả về tổng lợi nhuận (Chuỗi)","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"Số lần chạy","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"Hoàn về số lần tổng xu hướng dài kể từ lúc bắt đầu","7d500ebe352ccfa932b253e21938813a06fcff8e":"URL Webhook: %1","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"Gửi một yêu cầu POST đến một URL","a35646754dbe7a9211ba8b81338a5d64580eb276":"Khối tải trống","69b0648eddd207cd45a9e1ba973dae287b535576":"Khối tải:","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"nến là màu đen?","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"Kiểm tra nếu ngọn nến là màu đen, hoàn về đúng nếu đóng ít hơn mở ở ngọn nến được đưa ra.","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"Làm một danh sách của","5925d08228e246f07b790b88ad70c1b73a97d2bc":"các giá trị từ danh sách các nến","852b438f91ad9eb2cdd84419a675a216d543c687":"Đọc","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"giá trị trong nến","d79d854dcd0829e2177a47beab6a55569e781ab1":"Đọc một mục trong một ngọn nến (đọc từ danh sách nến)","5606b4460ac96063b8a8e5647008f3ec97252fc5":"Thứ hai kể từ Epoch","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"Trở lại thời gian thời kì (thứ hai kể từ thời kì)","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"Chạy mỗi","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"Giây","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"Chạy các khối bên trong mỗi n giây","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"Chạy mỗi khối thứ hai đã bị từ chối. Vui lòng liên hệ chúng tôi nếu bạn có một trường hợp sử dụng hợp lệ.","7b9c76088576a64f32d67ec335162b9f73eaa026":"Chạy theo","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"Chạy theo các khối bên trong sau n giây","e9fb732dde76a6977bcaa2818b0f56125b183648":"Tới ngày/giờ","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"Chuyển đổi một số giây kể từ Epoch thành một chuỗi biểu thị ngày và giờ. Ví dụ: 1546347825 sẽ được chuyển đổi thành 2019-01-01 21:03:45.","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"Tới mốc thời gian","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"Chuyển đổi một chuỗi đại diện cho ngày/giờ thành giây kể từ Epoch. Ví dụ: 2019-01-01 21:03:45 GMT + 0800 sẽ được chuyển đổi thành 1546347825. Thời gian và múi giờ được tùy chọn.","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"Bắt đầu sử dụng Deriv với email và mật khẩu Binary.com của bạn.","64f72129852fb7bdff0725c71324a012630f53bf":"Tại EU, các dịch vụ tài chính được cung cấp bởi Công Ty TNHH đầu tư Binary (Châu Âu), W Business Centre, Tầng 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, được cấp phép là một nhà cung cấp dịch vụ đầu tư loại 3 bởi Cơ Quan Dịch Vụ Tài Chính Malta ({$0}giấy phép số IS/70156{$1}).","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"Ngoài EU, các sản phẩm tài chính được cung cấp bởi Binary (SVG) Ltd, Tòa Hinds, Kingstown, St.Vincent và Grenadines, Binary (V) Ltd, Tòa nhà Govant, Port Vila, PO Box 1276, Vanuatu, được quy định bởi Ủy ban Dịch vụ Tài chính Vanuatu ({$0}xem giấy phép{$1}), Binary (BVI) Ltd, Tầng 2, Kingston Chambers, PO Box 173, Road Town, Tortola, Quần đảo British Virgin, được quy định bởi Ủy ban Dịch vụ Tài chính Quần đảo British Virgin ({$2}giấy phép số. SIBA/L/18/1114{$3}) và Binary (FX) Ltd., Lô số F16, Tầng 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia, do Cơ quan dịch vụ tài chính Labuan quy định để thực hiện công việc kinh doanh tiền tệ ({$4}giấy phép số. MB/18/0024{$5}).","10dd345bc3319e2151794428b2c709dc5fc381a7":"Dịch vụ của trang web này không có sẵn ở một số quốc gia như Mỹ, Canada, Hồng Kông, Nhật bản, hoặc cho những người dưới 18 tuổi.","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"Cảnh Báo Rủi Ro","ad0fc99c05681528248b73007dba16fd760a81c6":"Các sản phẩm tài chính được cung cấp thông qua trang web này bao gồm các tùy chọn nhị phân, hợp đồng cho sự khác biệt (\"CFDs\") và các sản phẩm tài chính phái sinh phức tạp khác. Các tùy chọn nhị phân giao dịch có thể không phù hợp với mọi người. Giao dịch CFD mang mức độ rủi ro cao vì đòn bẩy có thể mang lải cả lợi thế và bất lợi cho bạn. Do đó, các sản phẩm được cung cấp trên trang web này có thể không phù hợp với tất cả các nhà đầu tư vì rủi ro mất tất cả vốn đầu tư của họ. Bạn không bao giờ nên đầu tư tiền mà bạn không thể mất, và không bao giờ giao dịch bằng tiền vay. Trước khi giao dịch trong các sản phẩm tài chính phức tạp được cung cấp, vui lòng đảm bảo bạn đã hiểu các rủi ro có liên quan và tìm hiểu về {$0}Giao Dịch Có Trách Nhiệm{$1}.","1fda2716eb92e0195ff59b110af23d86b43fd909":"Tại EU, các sản phẩm tài chính được cung cấp bởi Công Ty TNHH đầu tư Binary (Châu Âu), W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, được cấp phép và quy định như là một nhà cung cấp dịch vụ đầu tư loại 3 bởi Cơ Quan Dịch Vụ Tài Chính Malta (giấy phép số IS/70156).","be7786af641b859c03ec152461d791480cf676ed":"Ở Isle of Man và UK, các Chỉ Số Biến Động được cung cấp bởi Binary (IOM) Ltd., tầng 1, Millennium House, đường Victoria, Douglas, IM2 4RW, Isle of Man, British Isles; được quản lý và cấp phép bởi (1) Ủy ban giám sát cờ bạc ở Isle of Man (giấy phép hiện hành được cấp ngày 31 tháng 8 năm 2017) cũng như (2) Ủy ban cờ bạc ở Vương quốc Anh (giấy phép {$0}số: 39172{$1}).","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"Đối với các khu vực còn lại trong EU, các Chỉ Số Biến Động được cung cấp bởi Binary (Europe) Ltd., W Business Centre, Tầng 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta; được quản lý và cấp phép bởi(1) Ủy ban Quản Lý Cá Cược Malta (giấy phép số. MGA/B2C/102/2000 được ban hành vào ngày 01 tháng 8 năm 2018), đối với các khách hàng ở Anh, (2) Ủy ban cờ bạc Vương quốc Anh (giấy phép {$0}số: 39495{$1}), và khách hàng Ai-len, (3) Ủy viên Doanh thu ở Ireland (Giấy phép của Người lập sổ từ xa số 1010285 cấp ngày 1 tháng 7 năm 2017). Xem hết các {$2}Thông tin pháp lý{$1}.","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"Binary.com là một trang cung cấp dịch vụ kinh doanh trực tuyến hỗ trợ khách hàng của mình giao dịch trên các thị trường tài chính thông qua Binary Options và CFDs. Giao dịch Binary Options và CFDs theo Chỉ Số Biến Động được phân loại như là một hoạt động cờ bạc. Hãy nhớ rằng cờ bạc có thể gây nghiện-hãy có trách nhiệm khi chơi. Tìm hiểu thêm về {$0}Giao Dịch Có Trách Nhiệm{$1}. Một số sản phẩm sẽ không có sẵn ở tất cả mọi nước. Dịch vụ của trang web không hoạt động ở một số quốc gia như Mỹ, Canada, Hồng Kông, hoặc những người dưới 18 tuổi.","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"Giao dịch binary options có thể không phù hợp với mọi người, vì vậy hãy đảm bảo rằng bạn hiểu đầy đủ các rủi ro liên quan. Khoản lỗ của bạn có thể vượt quá khoản tiền gửi ban đầu của bạn và bạn không sở hữu hoặc có bất kỳ lợi ích nào trong tài sản cơ sở.","496a99878841de69368c33af9e88eb37c0da5712":"CFDs là công cụ phức tạp và đi kèm với rủi ro cao do áp dụng đòn bẩy tài chính. Khoảng 78.6% các tài khoản đầu tư lẻ đều mất tiền khi giao dịch CFDs. bạn nên cân nhắc kỹ lưỡng liệu mình đã đủ am hiểu về CFDs và sãn sàng chấp nhận rủi ro thua lỗ cao.","a726d863bbdceba7b06a1083026a53db76de47b7":"Giao dịch multipliers","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"Tăng lợi nhuận tiềm năng của bạn mà không phải chịu rủi ro mất nhiều hơn số tiền bạn mua.","febe8aef26fb3017be5bf43d66f7972731c20833":"Thanh toán Peer-to-peer","a8c1114d1c88db12afa05b331188ceb77afad6e3":"Chỉ số Crash/Boom","d29324705a18a81ffc0376f3f37639a68827f3e6":"Dự đoán và đạt lợi nhuận cao từ đỉnh và đáy. Chỉ khả dụng với mulpliers tại Dtrader.","ba2098a209e375402a0cf222cec87cce26440767":"Độc quyền trên Deriv","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"Một tương lai tươi sáng trước mắt.","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"Tìm các tính năng tiền thưởng và nhiều hơn nữa \btại \bDeriv:","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"Thử ngay hôm nay","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"SmartTrader","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"Nền tảng giao dịch tùy chọn cổ điển của chúng tôi","64dfd7424a05133b74cfb93fcbe385ede6539855":"Nền tảng giao dịch tự động cổ điển của chúng tôi","824d76b124e6289f372e2ff6bcba91e8939343bd":"Tìm hiểu thêm","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"Deriv MT5","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"Nền tảng giao dịch CFD nổi tiếng thế giới","54617a018fc6dffb3a70627b97f0db5c52a4081d":"DTrader","dbcd68f389d64fc531a650652c87b7d83fc82d94":"Các tùy chọn hàng đầu và nền tảng giao dịch số nhân của chúng tôi","dd69c213333a751a0ab3bc9ce6368588bf971b61":"DBot","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"Nền tảng giao dịch tự động thế hệ tiếp theo của chúng tôi","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"Deriv GO","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"Giao dịch mọi lúc mọi nơi với ứng dụng di động của chúng tôi","f63714db18c58c6b4a7a7bad09178faaeca05104":"Deriv X","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"Nền tảng giao dịch CFD có thể tùy chỉnh của chúng tôi","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"Mọi thứ bạn yêu thích về Binary.com và hơn thế nữa","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"7 nền tảng để lựa chọn","029582bad299ab8f44c57b961210e56569efd536":"Bạn sẽ tìm thấy SmartTrader và Binary Bot cùng với các nền tảng mới như DTrader và Deriv X. Bất kể phong cách giao dịch nào của bạn, chúng tôi đều có nền tảng dành riêng cho bạn.","9a07439b57e510e8e33b372aad2c360dbc39e79c":"Giao dịch CFDs, quyền chọn nhị phân, và cấp số nhân, một loại hình giao dịch hoàn toàn mới giúp tăng lợi nhuận tiềm năng và hạn chế rủi ro.","3d0be0e8eb736257254698ba821c45389e385f1e":"Nạp tiền điện tử thông qua fiat on-ramp","c4303d30e60f01fa922400e52df4e96d71b35d6e":"Hơn 100 loại thị trường","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"Giao dịch những gì bạn thích - ngoại hối, hàng hóa, chứng khoán và các chỉ số tổng hợp. ","f30ce7459f29851b219b504216581bf3d3446de0":"Hỗ trợ khi bạn cần","6df6091514ee13992a3ac28445af1d9a1afbcb67":"Nhận được sự hỗ trợ khách hàng mọi lúc và Trung tâm Trợ giúp.","92c8b7b779e7cf179b89484285fd766274b3bf1f":"Khám phá Deriv ngay","a87a92c5ce4925186a081cf4478639fcc31b12ed":"Tại EU, các sản phẩm tài chính được cung cấp bởi Deriv Investments (Europe) Limited, W Business Center, Tầng 3, Triq Dun Karm, Birkirkara BKR 9033, Malta, được cấp phép tại Malta ","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"(giấy phép số. IS/70156)","720280451c98ceeb796f3c7fa118813fc8da694d":"và được quy định bởi Cơ quan Dịch vụ Tài chính Malta, Triq l-Imdina, Khu 1, Khu Thương mại Trung tâm, Birkirkara CBD 1010, Malta, theo Đạo luật Dịch vụ Đầu tư. Được ủy quyền bởi Cơ quan quản lý tài chính và với sự cho phép khác nhau. Theo quy định của Cơ quan Quản lý Tài chính. Bản chất và mức độ của các biện pháp bảo vệ người tiêu dùng có thể khác với các biện pháp đối với các công ty có trụ sở tại Vương quốc Anh. Thông tin chi tiết về Chế độ hợp đồng dịch vụ tài chính, cho phép các công ty có trụ sở tại EEA hoạt động ở Vương quốc Anh trong một khoảng thời gian giới hạn để thực hiện các hoạt động cần thiết cho việc thực hiện các hợp đồng đã có từ trước, có sẵn trên trang web của Cơ quan quản lý hành vi tài chính.","0f1dda628bebb4748de6df05fa3bff4989c1b476":"Bên ngoài EU, các sản phẩm tài chính được cung cấp bởi các công ty sau: Deriv (FX) Ltd, F16, Level 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia, được cấp phép bởi Cơ quan dịch vụ tài chính Labuan ","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"(giấy phép số. MB/18/0024);","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"Deriv (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, Quần đảo Virgin thuộc Anh, được cấp phép bởi Ủy ban Dịch vụ Tài chính Quần đảo Virgin thuộc Anh ","a56aa088dfea506d5dbe18f385c29418f771a639":"(giấy phép số. SIBA/L/18/1114);","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":" Deriv (V) Ltd, 1276, Kumul Highway, Port Vila, Vanuatu, được cấp phép và quản lý bởi Ủy ban Dịch vụ Tài chính Vanuatu; và Deriv (SVG) LLC, Hinds Buildings, Kingstown, St. Vincent và Grenadines.","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"Deriv Limited — 13 Castle Street, St. Helier, JE2 3BT, Jersey — là công ty mẹ của các công ty con trên.","74e8fa69aad80f93303a7723e5a304f3d43560b6":"Các dịch vụ của trang web này không khả dụng ở một số quốc gia nhất định, bao gồm Hoa Kỳ, Canada và Hồng Kông, hoặc cho những người dưới 18 tuổi.","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"CFD được coi là các sản phẩm phái sinh phức tạp và có thể không phù hợp cho các khách bán lẻ. CFD là công cụ phức tạp và có nguy cơ mất tiền nhanh chóng do đòn bẩy. Bạn nên xem xét liệu bạn có hiểu cách hoạt động của CFD và liệu bạn có đủ khả năng chấp nhận rủi ro mất tiền cao hay không. Các sản phẩm được đề cập ở đây có thể bị ảnh hưởng bởi sự thay đổi của tỷ giá hối đoái. Nếu bạn đầu tư vào các sản phẩm này, bạn có thể mất một phần hoặc toàn bộ khoản đầu tư của mình và giá trị khoản đầu tư của bạn có thể dao động. Bạn không bao giờ nên đầu tư số tiền mà bạn không thể để mất và không bao giờ giao dịch bằng tiền đi vay.","5bb3f3499158dbe30af5c725694b321dfe821433":"Trước khi giao dịch các sản phẩm tài chính phức tạp được cung cấp, hãy đảm bảo bạn hiểu rõ các rủi ro liên quan và tìm hiểu về ","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"Bảo mật và giao dịch có trách nhiệm.","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"Chúng tôi đang giao chuyển!","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"Chúng tôi đã","991753597fde70aab5791de6d50ee8cc49a0bdcc":" Binary.com","efa99ab039a285c6264580bea691a4ffefcbeee7":" đã 2 thập kỷ trôi qua và bây giờ là thời gian cho một chương mới thú vị hơn.","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"Chào mừng đến với ngôi nhà mới của chúng tôi,","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":" Deriv.","52b8454dc755419beeff2f90cd0fc91def428244":"Xin chào Deriv!","27ad1d8334221366694c7acdd70fb380857d1e6e":"Để sau","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"Đưa tôi đến Deriv","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"Việc chuyển sang Deriv rất dễ dàng","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"Chỉ cần đăng nhập bằng thông tin đăng nhập Binary.com của bạn. Không cần đăng ký.","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"Thử ngay bây giờ","63fbf7977349e32e4a124ffa047549b720806d73":"Mang Deriv đi với bạn","03d42257a2263b2841b9e0ae4b94de117228a33a":"Tải ứng dụng di động Deriv GO và giao mọi lúc. Không bao giờ lỡ mất cơ hội.","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"Quét mã QR này để tải Deriv GO","6b7499b1513a3cec3da3ff07cdad9b358954021e":"Đừng chần chừ","b23efda40ddeb801beeebf915669d806744014af":"Chứng minh giao dịch của bạn trong tương lai. Đến với Deriv ngay.","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"Trải nghiệm giao dịch với Deriv","34075438f939258908cc21d28bf59ab5126dc2d6":"Hãy đến với Deriv và bảo toàn giao dịch của bạn ngay bây giờ.","e669443b63757b5ad8571e52393caf2a0a812be3":"6 lý do bạn nên chọn Deriv","2c141583afaaa12438b16ee67355c6e3eaf77763":"Binary Bot đã có thêm một ngôi nhà mới","4e0e045da59b385138ced3203cdb81c3b4cdd135":"Chúng tôi đã hoạt động trên Binary.com trong 2 thập kỷ và đã đến lúc mở ra một chương mới. Trình tạo bot yêu thích của bạn, Binary Bot, hiện đã có mặt trên Deriv, ngôi nhà mới của chúng tôi. Hãy qua xem và dùng thử.","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"Đưa tôi đến Binary Bot trên Deriv","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"Sử dụng Binary Bot trên Deriv, ngôi nhà mới của chúng tôi","1071c645f523394b408a6d285e95331bc583f14c":"Trong 5 phút nữa, chúng tôi sẽ cho bạn thấy những lợi ích của việc giao dịch Binary Bot trên Deriv. Nếu bạn bỏ qua thông báo này, chúng tôi sẽ nhắc bạn một lần nữa sau 3 tuần.","be43a8989c5745ec7386ca7c69442165f55dee8e":"Cho tôi thấy những lợi ích ngay bây giờ","074603c9aef93515ed33d179e982c67ea7abdb45":"Giao dịch Binary Bot trên Deriv"}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"Logika","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"Matematyka","c3328c39b0e29f78e9ff45db674248b1d245887d":"Tekst","4d064726954a17487f94e931f5b157b733ec22ed":"Zaawansowane","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"Lista","19de69cb601f53a4ea7af22a65c71ae63251365c":"Zmienne","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"Funkcje","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"Pętla","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"Binary","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"Definicja zakładu","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"Przed zakupem","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"Podczas zakupu","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"Po zakupie","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"Analiza najmniejszych zmian ceny","8cf71374fa095a64b5295b672daef8507ec7be6a":"Wskaźniki","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"Narzędzia","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"Czas","8d8fd6765e184419cad8b88d1a60c895d79578c2":"Świeca","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"Różne","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"Dziennik","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"Podsumowanie","9feddbabd7e7309e96c590069057158e96baa8f6":"Bieżąca kontrola konta","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"Handel opcjami może stać się poważnym uzależnieniem, tak jak wszystkie inne czynności, którym poświęcamy zbyt wiele czasu. Aby zapobiec niebezpieczeństwu takiego uzależnienia, umożliwiamy sprawdzanie rzeczywistej sytuacji na bieżąco, co zapewnia Ci regularne zestawienie Twoich zakładów i kont.","4152043e8c670075d2c919677e835edb0d923cab":"Proszę określić w minutach preferowany odstęp czasu pomiędzy kontrolami konta","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"Proszę wpisać liczbę z przedziału od 10 do 60.","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"Kontynuuj handlowanie","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"Oświadczenie","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"Wyloguj","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"Skontaktuj się z nami","f7c400ed695f898b8ee9d21664aa17b5bb693828":"Zaloguj","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"Resetuj bloki do ich stanu początkowego","f98595d541778d86f75ef22b3328a031d20aa16b":"Załaduj nowe bloki (plik xml)","4a1e616226c329a94da7768bc0435a3284478010":"Zapisz istniejące bloki (plik xml)","6b3465ace62f33f0687b4669ac26d95895e9ca52":"Połącz Binary Bot ze swoim Dyskiem Google, aby w prosty sposób zapisywać bloki i używać ich ponownie","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"Cofnij zmiany (Ctrl+Z)","937f5055f05be359ddf619744e8af4d643549e80":"Ponów zmiany (Ctrl+Shift+Z)","8406d1cce44230835932060649e999ca3283b413":"Powiększ (Ctrl + +)","1109673172af2c173c492622ff8a72c8f29f0e70":"Pomniejsz (Ctrl + -)","44c22002c65d2871331263a23c3e09c0a1bfd847":"Przestaw pionowo","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"Pokaż/ukryj okienko z podsumowaniem","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"Uruchom bot","ba50a42d8d3228c37a817865fce49fbca692c2ad":"Zatrzymaj bot","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"Pokaż dziennik","91017ef9b165cd0e7475a770f318ea5e705e1321":"Pokaż wykres","c89e3dd1cafcadcc0312e476ab58b2332209da23":"Pokaż widok handlowy","b02c858e72be118a65c9393930351012b647cb9e":"Przełącz nagłówek","250be77f7605669a0b3d968b9ed381a3d9787ed1":"Otwórz zapisany plik XML i pobierz jego bloki","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"Bot Binary","608061fb5aab975013fa70c5c814a1d8ba30c152":"Jeszcze wygodniejsze handlowanie","e4ce8dc3e416e69262ba642dc57d3975d6616980":"Czy interesuje Cię zautomatyzowanie swoich ulubionych strategii handlu opcjami binarnymi?","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"Binary Bot to nasze wiodące narzędzie do programowania, które pozwala budować aplikacje do inwestowania za pomocą prostego","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"Wymyśl dowolną liczbę botów do handlu opcjami binarnymi – od najprostszych formuł po niezwykle skomplikowane algorytmy – i pozwól, by handlowały za Ciebie, nawet gdy śpisz.","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"Rozpocznij tworzenie bota już teraz","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"Potrzebujesz pomocy?","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"POTRZEBUJESZ POMOCY?","d635b53e59c9aad8c5d78458826beffb029b27bf":"Dziękujemy, skontaktujemy się w ciągu 24 godzin","a69a8fc21499d0fd85e87bab467699827547a5bc":"Proszę podać poprawne URL serwera","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"Nie wybrano rynku bazowego","50050f06645ad2743165b429a8f7deebd285fd63":"Nie wybrano rodzaju kontraktu","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"Proszę się zalogować","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"Czas trwania musi być dodatnią liczbą całkowitą","4df6e872792d72aea8a2f6b831d00b554464da23":"Kwota musi być liczbą dodatnią","001e68df3a4b32a4d57148d9d407f44eee3b7436":"Ta świeca nie jest prawidłowa","04f14ea7c92e0b2b5ae005c696245063ec641d66":"Ta lista świec nie jest prawidłowa","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"ponowna próba za","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"Limit stawki został osiągnięty dla","094628ce13fc0e78f07b697d1cc9421bb2edd666":"Żądanie nie powiodło się dla","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"Nie","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"Tak","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"stan konta","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"cena ofertowa","50e72909992bdc37c7c07769d1b7efac5e52874c":"wypłata","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"zysk","c980b910204c7babdffe8ff3f7e755f30133383c":"typ kontraktu","a726c6955157f1b8b92f9932652434a7150f80f8":"pozycja wejściowa","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"wartość wejściowa","3905be81561384dc8c43d6127c57ed1e0eb03b74":"ciąg wejściowych wartości","7674920c033ca14277c577e19c037a6754d4fa80":"pozycja wyjściowa","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"wartość wyjściowa","06ecea26625359f7dcf5ff5c47af6174ff815257":"ciąg wyjściowych wartości","779455ee3bde8494d9629b353e17b19e92357ba8":"limit","37a5301a88da334dc5afc5b63979daa0f3f45e68":"wynik","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"Wygrana","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"Przegrana","563339f82447b4e758ad76d5a0b63b5698594fba":"Wzrost","5c1ae82c29543ac887703776bf3da2c7dcce683d":"Spadek","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"Bez zmian","ecb252044b5ea0f679ee78ec1a12904739e2904d":"ciąg","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"liczba","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"zielony","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"niebieski","96de5543d183d7de52ac5fa21c46fc811f673f89":"żółty","78988010b890ce6f4d2136481f392787ec6d6106":"czerwony","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"Wyciszony","cf84a98d6cf7f156862a08ba8236467b6f471004":"Zawiadomienie","eee2facd669d1434848c24da5527b3e87d9a12d5":"Zarobiono pieniądze","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"Zrealizowano zakład","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"Błąd","a3b1583d377f37ac20de7e089edfa0920a078e57":"Poważny błąd","66c8b6848eee629c4ac551bf2b5fa591571654be":"Wzrost Równa się","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"Spadek Równa się","062787aa328047e189774b3703d983b83938f6e9":"Wyższe","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"Niższe","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"Osiągnie","7d7932bcc2e262ae98cf09dc5445130fb3881769":"Nie osiągnie","a16814a48ec58c2e24ba224a80921a5c02361abe":"Zakończy się w","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"Zakończy się poza","534ec5da4e82ec419abc170e1a8448f55a01664f":"Pozostanie na danym poziomie","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"Przekroczy","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"Azjatycki – Wzrost","c098658ce3d3a258e4d155949a60072966b36db7":"Azjatycki – Spadek","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"Zgadza się","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"Różni się","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"Parzysta","dc28f5f3c65ec611f0f30022650d24382d27448e":"Nieparzysta","18a63f5512afb5573e5b44deba78d629f0635317":"Powyżej","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"Poniżej","2155c8b38181dd2552e84a94049aacd33ef9c607":"Duża zmiana ceny","1408cfd2b064b923f024fbe590e27db8282941a5":"Mała zmiana ceny","b86eb15dc4f13e4c2972de158d3038d9f657242f":"Reset Call","669a1f3d9a8f601a84da536cfdad1de4092b1926":"Reset Put","844d1a5c99a0a668383340cc095d040eef998c79":"Tylko wzrosty","87293a146cd481a2b30cf74282ec061dc4cf0735":"Tylko spadki","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"Otwórz","b1a5954a483f8f8b0207385095f74aeb409b3f80":"Wysoki","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"Niski","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"Zamknij","1173872a4fb205b713702f0eec5cf2c732c828fd":"Godziny otwarcia","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"Domyślny","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"1 minuta","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"2 minuty","24e46784cbce32443db5a2638b1a7d3201543e9b":"3 minuty","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"5 minut","a6f151883b736f0470d33492e61c72a7d059d065":"10 minut","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"15 minut","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"30 minut","f030c3d667652646b86732ad7bc67e226c49cd3a":"1 godzina","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"2 godziny","7b47150d431db70d783724007f07ab894eb8ac2e":"4 godziny","191800b7e9a48680792c0dd77cb6cac00c4514c6":"8 godzin","2d8a6f7c34468578640b333b8650131de06ac770":"1 dzień","cd1495cb4c60266a6abad9024022ae079bf7e416":"(1) Zdefiniuj swój kontrakt","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"(2) Obserwuj i dokonaj zakupu swojego kontraktu","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"Opcje zakładu","160f06d4799c85021a810f68c5b517eea37a2737":"Zakup","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"Góra/dół","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"Góra/dół Równa się","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"Azjatyckie","2260ce49306460c8a2ef501939f29ad6ddd4e934":"Cyfry","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"Osiągnie/nie osiągnie","f7de1f66f0979667da275b7e8996e805395025a1":"Zakończy się w/poza","a431deecd4c2258097adae418d496fe9a8179fee":"Pozostanie w/poza","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"Duże/małe zmiany ceny","12a3f461cdebbc8f335190413ee6c57442743bba":"Reset Call/Reset Put","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"Tylko wzrosty/ Tylko spadki","91a64e3f83c91acf336c631fba295f297f94c399":"Uruchom po n sek.","024696596f26a4db232fd9e966eadfeb27c0bd1a":"Uruchamiaj co n sek.","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"wyższy","85c274929bc0e28eafd3734f2c25046c3b95b36b":"średni","346e3ee198e98146993894d3de8ecab1a86c3e80":"niższy","f16459104f92ab6b38aa265adb4ecbfc3768e303":"Histogram","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"MACD","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"Sygnał","19eabc961735d78f12fc7be906ffcb033853cf85":"Znacznik czasu","68f4145fee7dde76afceb910165924ad14cf0d00":"Wiadomość","e99811bd3b1ad17e74614060ecb180602be35ad6":"Wylogowano!","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"należy dodać blok do obszaru roboczego","1fde9f1ebca07dcbc704130bd18645bce7718b55":"należy uruchomić blok","d466687f90ba548434d65186d11a80c4204f9ad6":"musi zostać dodany wewnątrz:","629777b7d4d610ace6dee24442730f27d7d0853e":"Nieobsługiwany plik:","0b93c14956403c2e5c9e79f5c836babc56912006":"Binary Bot nie będzie zawierać żadnych nowych zakładów. Wszelkie zakłady, które zostały już zawarte (ale nie wygasły) zostaną zakończone przez nasz system. Wszelkie niezapisane zmiany zostaną utracone.","c1458ff86fd60d9544d7cd8a67437df2b766f482":"Uwaga: Odwiedź sekcję Stan konta na stronie Binary.com, aby uzyskać szczegóły na temat wszystkich potwierdzonych transakcji.","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"Wszelkie niezapisane zmiany zostaną utracone.","410bf23a3f080def9c7a976a16305bcde7943ed1":"Czy na pewno?","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"Niestety Binary Bot jest niedostępny w Twoim kraju","901624741023fcfc805ce43c94b8012e3b1d1c99":"Chcesz inwestować w kontrakty na różnice kursowe na MT5? Będziesz mieć dostęp do rynku forex, wskaźników syntetycznych, towarów, kryptowalut i syntetyków.","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"Strategie","910ec7aa40b04ec6ba51162f4de7850569326cb6":"Podczas ładowania skryptu Google API wystąpił błąd.","8f51f350debde84e067e1a0405fb6304922a7d4b":"Wystąpił błąd podczas inicjalizacji usługi Google Drive.","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"Podczas ładowania bibliotek Dysku Google wystąpił błąd","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"Udziel pozwolenia na podgląd Twoich plików na Google Drive i zarządzanie nimi","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"Nieznany format pliku","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"Podczas pobierania danych z Dysku Google wystąpił błąd","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"Wybierz strategię Binary Bot","2db43c69a4b96454914f0b8272bc869984529e6e":"Podczas wyświetlania plików z Dysku Google wystąpił błąd","0dcea5f584938e0fff00084b83156ab31d641ab3":"Podczas pobierania plików z Dysku Google wystąpił błąd","18da95988117ff029393f3f5c881d70ef47f7385":"Podczas przetwarzania Twojego żądania wystąpił błąd","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"Wybierz folder","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"Nie udało się wysłać powiadomienia Telegram","3f370309b6280eb100f898426d8605c1f45d558d":"Nieprawidłowy znacznik czasu","af6a4e2a5582be89ac930e946eaed86e01cac58b":"Nieprawidłowa data/czas","49d51398b574e7312d99b18d2b93d2ede416f053":"Nie udało się wysłać webhook","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"Propozycje nie są gotowe","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"Wybrana propozycja nie istnieje","6ea4a034747d020b1d8ce4848def95d537555dd6":"Kupiono","89f89c02cf47e091e726a4e07b88af0966806897":"Identyfikator","1200c1af2f7bba4e29a34112865662748c9d41df":"Nie można odsprzedać tego kontraktu.","62d6180e55905f7b996d442c53631981a4ef8b5b":"Sprzedano za","ed4978867de1da05b336b724a3fb96222a29ebec":"Indeks musi być dodatnią liczbą całkowitą","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"Kwota zysku","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"Kwota straty","46fc6f27a835486d63d9e927c6687e4508cb3087":"Zawarto już maksymalną liczbę zakładów","9202ddae4cea16513e53bbc965d88ed975e59512":"Została osiągnięta maksymalna kwota straty","5f52b397b7e5f538681f0f5717a88aa626349c7a":"Nie wywołano Bot.init","66c7734789e19cbeef3a5ac185ea732139aed213":"Wykres","3b662fb2e8bafce29aa98321b18874bb44905488":"Integracja z Dyskiem Google","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"Proszę ustawić swój dzienny limit straty na stronie Udogodnienia samowykluczenia, aby umożliwić handel.","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"Maksymalna liczba zakładów następujących po sobie powinna wynosić od 1 do 100","93039e609d94a24f3572b794a31b21525a09af2b":"Nie ustawiono","a85b8cc112a8597df1612d60a74faa818c25d1b3":"Wymagamy, abyś ustawił ograniczenia handlu zgodnie z przepisami biznesowymi. Pamiętaj, że Twój bot przestanie handlować tylko wtedy, gdy spełniony zostanie jeden lub oba z poniższych warunków.","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"Dzienny limit strat:","95052a29f213e9698b593418fe396ecc21032f9b":"Jest to próg, który ogranicza Twoje potencjalne straty na dzień we wszystkich platformach Binary.com. Gdy całkowita strata osiągnie lub przekroczy tę kwotę, Twój bot przestanie handlować. Proszę ustawić wartość na stronie {$0}Funkcji Samodzielnego Wykluczenia{$1}.","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"Maksymalna liczba zakładów następujących po sobie","730657200c17321d926e1bd08dbf65bd96855a8a":"Jest to maksymalna liczba transakcji, którą pozwala się wykonać botowi dla tego przebiegu.","952f375412e89ff213a8aca383d18e5691354347":"Start","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"Ograniczenia dot. zakładów","095ba68888b5ace5f4515f5acab76dfa1073544e":"Mój komputer","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"Załaduj","248e224f533752db28a1aab3519a58569ad96140":"Załaduj bloki","c7097e97dcc446ca889d3ca6be733a65e2728afe":"Pomyślnie przesłano na Dysk Google","a6b977714595aa01678fca98e86553aaeac05c92":"Zapisz swoje bloki pojedynczo w kolekcji. Zostaną one dodane do istniejącego obszaru roboczego (główne bloki zostaną zastąpione) podczas ładowania.","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"Zapisz jako kolekcję","611ebbfb080284312904de925ef0f75f4cb56ad2":"Zapisz swoje bloki i ustawienia do ponownego użycia w innych strategiach","efc007a393f66cdb14d57d385822a3d9e36ef873":"Zapisz","a638caa8ab2b7ff7980a571334217339e6d1d634":"Zapisz bloki","39fca63515c105918f03e4908ec12df675b07f92":"Widok handlowy","e643975ea5296d9de4486458f31ab0a5a2b228bf":"Spowoduje to wyczyszczenie wszystkich transakcji w panelu podsumowującym, a wszystkie liczniki zostaną wyzerowane.","85dfa32c97d8618d1bea083609e2c8a29845abe5":"Konto","d847919a30d31c0be624087f3370492b3fdf80c6":"Liczba uruchomień","5cd6978d63540c8a490ef76f43219de6362f958e":"Całkowita stawka","17410d7b62b8b1de981cfebada24632987edf186":"Całkowita wypłata","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"Całkowity zysk/ całkowita strata","90eef613042c5a51f542421065b68b886d473807":"Saldo","db1c784524e1b54011a95823026161f7c8517fe0":"Odwołanie","4db3e9e4aecd187db9339a10d2629fef46724dc4":"Rodzaj zakładu","1bb4086b66659d8580f9be4beef69931aeea3cad":"Pozycja wejściowa","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"Pozycja wyjściowa","ba7be969e7c1bb5f22489e843478e3d721aaa843":"Cena zakupu","772fbced18230220d2d9be1456be16fc1b271d25":"Zysk/strata","bae7d5be70820ed56467bd9a63744e23b47bd711":"Status","96f608c16cef16caa06bf38901fb5f618a35a70b":"Oczekujące","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"Gotowe","82a82f798dd773717ec37d15fd4405510291734e":"Bot nie jest uruchomiony.","6a88e58aa1798626f94cf17f1a91618b405bb289":"Zatrzymywanie bota...","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"Bot jest uruchomiony...","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"Zatrzymywanie bota...","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"Bot został zatrzymany.","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"Próba dokonania zakupu","4684ee1026d9b4c872d016c3c4588a0c479a451c":"Kwota zakupu","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"Dokonano zakupu","f02760cd2eac28169f0a990c950c3dfe8427f772":"Kontrakt został zamknięty","c7363d8a0748d4a7e2cc968335dc9716f290359d":"Zatrzymanie bota uniemożliwi realizację kolejnych zakładów. Wszelkie trwające zakłady zostaną zakończone w naszym systemie. Pamiętaj, że niektóre zakończone transakcje mogą nie być wyświetlane w tabeli, jeśli bot zostanie zatrzymany podczas zawierania zakładu. Szczegóły na temat wszystkich zakończonych zakładów można uzyskać w sekcji Stan konta na stronie Binary.com.","fadc0ef93d1ff13370524ce8481ddc4a71195934":"Przestaw pionowo","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"Pobierz","e4458464df6cbb8da1134875ba51519c5d244d9f":"Bloki muszą znajdować się między symbolami bloków, głównymi blokami lub funkcjami","e9c45563358e813f157ba81b33143542165ba84e":"Ostrzeżenie","31cb6f44d030abeabcc7046555dea851602a87a5":"Ta strategia jest niedostępna w Twoim kraju.","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"OK","9970168c192807246fad6138344e5a96449afbdd":"Plik XML jest pusty. Sprawdź lub zmodyfikuj plik.","a594b427eaf0f108d3e9cc20d70e15da811c760c":"Nieobsługiwana strategia","04a5090686ac7b54822e00a9ff08c38a107601e7":"Przepraszamy, tej strategii nie można użyć w Binary Bot. Możesz jej użyć tylko w DBot.","77dfd2135f4db726c47299bb55be26f7f4525a46":"Anuluj","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"Przejdź do DBot","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"Plik, który próbujesz otworzyć zawiera nieobsługiwane elementy w tym bloku: {$0} Sprawdź swój plik lub spróbuj ponownie.","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"Nie można załadować pliku bloku","af145748c9cf765a3b059eec20cb1dbb899297d8":"Załadowano bloki","11ee9c5d534cc8d22651092222b532917594161a":"Minimalny czas trwania to","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"Liczba zmian ceny musi mieścić się w przedziale od 5 do 10","ace1342bc3720b77ce510b93074041e7386d209e":"Czas wygaśnięcia nie może być taki sam jak czas rozpoczęcia","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"Przewidywanie musi mieć wartość jednej cyfry","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"musi zostać dodany wewnątrz","33aa6ff282ee509d37c6f758274c9156b419ff73":"Strategia, którą próbujesz importować jest nieprawidłowa.","da162a909c2981ed318d23cd9a6be1d66e0a8400":"Nieznany format pliku.","5e719fa76e1b6cb396376c82ebdd04bec7253229":"Zdalne bloki do załadowania muszę być zbiorem.","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"Nie można załadować pliku bloku.","df84a88f38b03b5b342362d72370b0d66afdae35":"Plik docelowy musi być plikiem xml","cd680fd936e9559ef1d95efac7a71680e2b13a89":"Ten adres URL jest już załadowany","34c59389053701a04127f74d32315e0206e076f8":"Podczas próby załadowania adresu URL wystąpił błąd","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"Upewnij się, że odpowiedź z serwera zawiera: „Access-Control-Allow-Origin”","988df856c066143616bd33d5904bbcdc22ff129e":"Binary.com zmienia lokalizację na Deriv","2fccaab15d71b00c19da7053135471d510b513db":"Inwestuj na Deriv","3ead0b14c72503187691a7a6d7121987299bd401":"To nie jest oficjalna wersja Binary Bot, używasz jej na własne ryzyko.","27401c9c8e476d659c8382e05c6d70a4a82be468":"Oficjalna wersja","bc981983e7f547dc62e19a1e383acfe00782a6d5":"Dalej","b52b36b7269fbfc58ec24bb724691951a3decbe8":"Wstecz","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"Gotowe","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"Zobacz krótki przewodnik","a48e81d4a8da67637b46725824177a959fe99b21":"Chcesz nauczyć się, jak korzystać z Binary Bot?","6f3e6ebf249947cec4f64117253a8fe43335ae79":"Nie, dziękuję","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"Nie pytaj ponownie.","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"Obszar roboczy","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"Przeciągnij i opuść pliki bloku lub stwórz swoje własne strategie.","d171baee235d4c93f63755a876782dc5be4c3e47":"Zestaw narzędzi do tworzenia bloków","056f19272d96f902c38207cf163ea8dbff7fbd32":"Dodaj stąd więcej bloków do swojego bota.","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"Konta","f5c47fd3b3553b10441a06054078cea745177dea":"Zaloguj się przed uruchomieniem bota. Zawsze testuj strategie, korzystając z konta wirtualnego.","fd825ae94aa79500a878dd4590a4b360e7162663":"Kontrola bota","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"Kontroluj swoje bloki. Zatrzymaj kursor na poszczególnych przyciskach, aby uzyskać więcej informacji.","f5169c84497de3aea74f7da9e7e177d1427e736b":"Powodzenia!","4f1b3d682c2a00b393c33637da402463bc11d5ff":"Chcesz zgłosić problem lub poprosić o pomoc?","0049f8894e41937ebb9111cd3def6749049fb50f":"Kliknij tutaj","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"Gdzie znaleźć Binary Bot na Deriv","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"Na stronie głównej Deriv naciśnij przycisk Handluj znajdujący się na górze strony, poczym wybierz Binary Bot.","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"Wypróbuj Binary Bot na Deriv","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"To ten sam znany i lubiany Bot Binary","169dd3b2025485a48b8f9f3f6ef89f5586714140":"Wszystko jest tak, jak lubisz.","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"Przenieś swoje boty bezproblemowo","b763f8cbfa6396f195781032619a99bba04bc939":"Twoje strategie z Binary.com mogą zostać użyte na Deriv. Wystarczy załadować pliki XML i zacząć inwestować.","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"7 platform inwestycyjnych — stare ulubione i zupełnie nowe","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"Znajdziesz Binary Bot i SmartTrader na nowej platformie jako DBot i DTrader. Niezależnie od tego, jaki jest Twój styl inwestowania, mamy dla Ciebie odpowiednią platformę.","0ce7480da93c1c9839818d0720b77931d1637574":"Wpłaty kryptowalut przez on-ramp dla waluty fiducjarnej","6e6a4c6839d2e859758a517865b095c1b8298dd6":"Wpłacaj kryptowalutę bezproblemowo przez serwisy wymiany, takie jak Changelly, Banxa czy XanPool.","c1b51f196c97b4781a354457579e9699b09de087":"3 typy zakładów","4708f7e87263464b130b987e4b9aed981c4f455d":"Inwestoj w kontrakty CFD, opcje cyfrowe i mnożniki, nowy rodzaj zakładów pozwalający zwiększyć potencjalne zyski przy ograniczonym ryzyku.","b7fceac7d5f885d735aeda6e4654487467d33fa3":"Wpłaty i wypłaty między użytkownikami","79a206119137878eb6be7c60f7ed34135194bdf0":"Wymieniaj swoją lokalną walutę z innymi inwestorami, aby wpłacać i wypłacać środki ze swojego konta przez Deriv P2P.","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"6 rodzajów rynków","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"Rozszerz swoje portfolio o różne nowe rynki, takie jak forex, aktywa, kryptowaluty, czy syntetyki.","14b2a808fdec3702e5a6b9152e13288c87a4768a":"Ucz się na Deriv Academy","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"Korzystaj z dodatkowych artykułów i nagrań, które pomogą Ci zrozumieć zasady inwestowania online.","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"Kliknij, aby wybrać","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"Niedostępne","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"Najmniejsze zmiany ceny","5fb1db527825d2996e37c655e5dec49d4da80c09":"Sekundy","092f99ea11a34a8490e7a767a83a42fc45634f82":"Minuty","9e25a34e635a123f8958bbe26e7c4843278597fb":"Godziny","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"Dni","db6708630fc646eb98298d9acd701e0a1ac051c2":"Zapisz swoje bloki i strategie na Dysku Google","85538d002a336c5addef8d189d80976cf7758f8c":"Jesteś zalogowany jako","b65463cb6a42a17de514acc4659f7fd331e0876a":"Połącz","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"Rozłącz","cd5f85b6f187605f82386eacd680f93820af8d11":"Wynik","1e38ce3d180cefae485a6986ca7c67841e30376f":"Prawda, jeśli wynik jest zgodny z wyborem","5c89497fc3c128e2ff865ce8df15356054f2c028":"(4) Uzyskaj wynik swojego zakładu i handluj ponownie","14ea81918758c994cbe3178e695e56afc1ef2b45":"Uzyskaj informacje o poprzednim zakładzie i jego wynik, po czym handluj ponownie (Uruchamia się w momencie zakończenia zakładu)","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"Szczegóły kontraktu:","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"Wczytuje wybraną opcję z listy szczegółów kontraktu","b3b543c80063a116ced4965d8537b7b62d14c0b7":"Handluj ponownie","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"Uruchamia ponownie blok handlowy","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"Cena ofertowa","343fda69c73b78b84967055aae97f790c422adfd":"Cena ofertowa dla wybranej propozycji","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"Obserwuj strumień zmian cen i dokonaj zakupu wybranego kontraktu (Uruchamia się przy aktualizacji najmniejszych zmian cen)","9bb396940adb9705fe57eba6ea8b578e6aafa792":"Wypłata","87da93a46d143f6019979b3548414d9d7adabb35":"Wypłata dla wybranej propozycji","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"Kupuje wybrany kontrakt.","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"Dostępna jest opcja sprzedaży","03bad10717e183b24829baf483dc715e1a44bf7b":"Prawda, jeśli opcja sprzedaży na rynku jest dostępna","2c71ed279a402e93312dbda173ab18f244d6bf46":"(3) Obserwuj i sprzedaj swój zakupiony kontrakt","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"Zobacz informacje o zakupionym kontrakcie i sprzedaj go na rynku, jeśli taka opcja jest dostępna (Uruchamia się w momencie aktualizacji kontraktu)","579607dc4f989ce2b94b558431666a0ab07ac1f3":"Sprzedaj na rynku","e20afd5cf3811a42071c9a312abb2afdad4c590b":"Sprzedaj na rynku.","4712cbff8e92822fc960ef9c0197293a19675eae":"Zysk/strata ze sprzedaży","df817b48c7a076561b4f8bedc52d65d2e351ab52":"Zwraca zysk w przypadku bloku Sprzedaj na rynku.","b44e884c355e447d0da0e6ba45caaff18c84373b":"Wstęgi Bollingera","d6a2a207343bd83aacdc80b579ff4419713a256e":"Lista wejściowa","170a28a9db6d27d7212fc6dc249434a57517e7bc":"Okres","b833989d69900a4be9e32d1bab65c8f8233f099e":"Mnożnik odch. stand. w górę","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"Mnożnik odch. stand. w dół","974da601086448d0060aeed90e53ddd5acd17b91":"Oblicza wstęgę Bollingera (BB) z listy z okresem","d5b65cac1f1cf9421ac978eebe532de99040cca6":"Szereg wstęgi Bollingera","58de49791c64aba14e36e5887244a5ef088286cd":"Oblicza listę wstęg Bollingera (BB) z listy z poprawnym okresem","4bd99f76f1104229744455d93df0ff76b9eeed58":"Wykładnicza średnia krocząca","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"Oblicza wykładniczą średnią kroczącą (EMA) z listy z okresem","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"Szereg wykładniczej średniej kroczącej","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"Oblicza wykładniczą średnią kroczącą (EMA) z listy wartości z okresem","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"Szereg MACD","b18e572ea14edd48587145f1ef50718adbf256c6":"Okres szybkiej EMA","974023bddd6249d0f6404872cfcae205b2599ea2":"Okres wolnej EMA","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"Sygnał okresu średniej kroczącej","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"Oblicza listę wskaźnika MACD z listy","95ec92885c855ba9cf734c17a43f081901e4d2cc":"Wskaźnik względnej siły","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"Wskaźnik względnej siły (RSI) z listy z okresem","4034de66995b876b2ba9bfd0274025e39168e05d":"Szereg wskaźnika względnej siły","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"Oblicza listę wskaźnika RSI (wskaźnik względnej siły) z listy wartości z okresem","a9842c95766da40bf4ea6ee263cb5a5985847763":"Prosta średnia krocząca","347775a293c14362d492f019e677c965be1d6e7d":"Oblicza prostą średnią kroczącą (EMA) z listy z okresem","4cc7b9e53d082896ad884eb01be16320af65f282":"Szereg prostej średniej wykładniczej","2c75179a57af3c36581008b65e86ed81c4a4cbea":"Oblicza prostą średnią kroczącą (SMA) z listy wartości z okresem","39f024cf49724fe7ffdea7773c72ed06eec998e1":"z interwałem","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"Kierunek","ad47561efb1dcbd7246d9b64487f615647fda036":"Prawda, jeśli kierunek jest zgodny z wyborem","05bef508aadd62bf3967dcf67d769da296f19989":"Kierunek zmiany ceny","21bfc78607d3a64de767a6677d1db42156d5039d":"Zwraca kierunek zmiany ceny otrzymany przez blok Przed zakupem, wartość może być „w górę”, jeśli najmniejsza zmiana ceny jest większa niż wcześniej lub „w dół”, jeśli jest mniejsza niż wcześniej, bądź pusta (''), jeśli najmniejsza zmiana ceny jest równa poprzedniej najmniejszej zmianie ceny","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"Blok kierunku nie jest już w użyciu, użyj bloku sprawdzania kierunku","cdb31fc857f01a59f664413498293c714285f46d":"na liście świec","20fd5f86f08796f145d69dedc209a27e459b2f51":"uzyskaj # od końca","a96606af8c33ac3428b45abc4782dbf93f458d29":"Pokaż ostatnią świecę: nth","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"Lista ostatnich cyfr","248428facb97408414180d4de74e4db35360fbc4":"Zwraca listę wartości ostatnich cyfr","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"Ostatnia cyfra","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"Zwraca ostatnią cyfrę ostatniej najmniejszej zmiany ceny","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"Lista świec","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"Zwraca listę świec","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"Stwórz listę","a4220593d385a720886f7af1ed3c478fd0c6339c":"wartości na liście świec","cd8cdf3d47e921c8a72addae9269e66041d417c5":"Zwraca listę wybranych wartości świecy","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"Na liście świec odczytaj:","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"# od końca","aba43a580daa7f306956ec69b83e6e37e7233126":"Zapoznaj się z wybranymi wartościami ostatniej świecy: nth","e04b522218a181cf0223042dd18ae08dcc22d8d3":"Ostatnia najmniejsza zmiana ceny","6ee445fc253a55c9ed54c009c3f020ac65200d80":"Zwraca wartość najmniejszej zmiany ceny otrzymaną przez blok Przed zakupem","ed44b69176217a1251c04f0c13d23ac789ea60b2":"Ciąg ostatniego ticku","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"Zwraca wartość najmniejszej zmiany ceny otrzymaną przez blok Przed zakupem (Ciąg)","4b2340a890e88d1886757c3f7172e273a1edc31f":"Blok jest wywoływany przy każdej najmniejszej zmianie ceny","b54d7b4590559dad64f02d09aacbf6d9863e2624":"Możesz korzystać z tego bloku w celu analizowania najmniejszych zmian ceny bez względu na twoje zakłady","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"Lista zmian ceny","17649cac8739adcae95e641f794880272ad33bd1":"Zwraca listę wartości najmniejszej zmiany ceny","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"Lista ciągu ticków","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"Zwraca listę wartości najmniejszej zmiany ceny (Ciąg)","c67ded6b64019212eb2bc69afd761f5b3f626040":"Dodaj znak do liczby, aby utworzyć wyrównanie limitu.","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"Rynek","74751e67c3e1010c343095eaf543e7cb21ced2ef":"Rodzaj zakładu","1f4698382842477e211eb46de81fa506f01a8c34":"Oba","c1baf816aac5a5cd849768773fc248cd249dc296":"Rodzaj kontraktu:","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"Domyślny interwał świecy:","9693aeaaf68e3929b59b79306feaa0a847d01192":"Czas trwania:","78d7103a319e808455d397513279d99f3b3f3768":"Stawka","10c02649e226d430bd75a5b6315a41c0db9992a2":"Limit","837276742aa90209dde3b4eef07d8e7ab26731ef":"Przewidywanie","258b49925b41751c6bd790a0848246566ba61440":"Restartuj polecenie kup/sprzedaj z błędem","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"wyłącz, aby zapewnić lepsze działanie","b410994b67e37d9516eb9b866c85a8c639f79e68":"Restartuj ostatni zakład z błędem","2260c5a971c2602834ef8feeb5fa522f900b469f":"bot ignoruje zakład z błędem","0745acf92abd7b60598f161717884cc45dab8694":"Uruchom raz przy starcie","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"Zdefiniuj opcje zakładu","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"Określ swój kontrakt i rozpocznij zakład, dodaj dane inicjowania tutaj. (Uruchamia się przy starcie)","4d22b565e4253e92a908f216184779679bb1a044":"Górny limit","b70c38c6db3127422e05315c30bdf76c7c36c480":"Dolny limit","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"Nieograniczony","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"Saldo:","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"Uzyskaj numer salda lub ciąg","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"Bloki wewnętrzne są ignorowane","d072c2ceeb5c1217722d14c74de7aeab945b4215":"Umieść tu swoje bloki, aby mieć pewność, że nie zostaną usunięte","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"Klucz: %1 Wartość: %2","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"Zwraca parę głównych wartości w postaci ciągu","b06acc4158c824231f727a13e1c9811f43d5be42":"Załaduj bloki z","661db37251a1ed1afe357ee13895f37a623d7cbf":"Załaduj bloki z adresu URL","6c03ee54ad3a51fc92a1d69943e99667847705b6":"Powiadom","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"z dźwiękiem","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"Tworzy powiadomienia","6e0fc122f936f808bc2e3af661121b65712ae855":"Powiadom Telegram %1 Token dostępu: %2 ID czatu: %3 Wiadomość: %4","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"Wysyła wiadomość do Telegram","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"Całkowity zysk","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"Zwraca całkowity zysk","532e65f6e266db0bb442d1f426d44d7d32962340":"Ciąg całkowitego zysku","78e84591ff76f992953a8e19b57c7eab7546d638":"Zwraca całkowity zysk (Ciąg)","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"Liczba uruchomień","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"Zwraca liczbę uruchomień od początku funkcjonowania","7d500ebe352ccfa932b253e21938813a06fcff8e":"URL Webhook: %1","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"Wysyła żądanie PUBLIKUJ do URL","a35646754dbe7a9211ba8b81338a5d64580eb276":"Pusty ładunek","69b0648eddd207cd45a9e1ba973dae287b535576":"Ładunek:","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"czy świeca jest czarna?","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"Sprawdza, czy dana świeca jest czarna; zwraca wartość prawda, jeśli wartość zamknij jest mniejsza niż wartość otwórz w przypadku danej świecy.","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"Wykonaj listę","5925d08228e246f07b790b88ad70c1b73a97d2bc":"wartości z listy świec","852b438f91ad9eb2cdd84419a675a216d543c687":"Przeczytaj","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"wartość w świecy","d79d854dcd0829e2177a47beab6a55569e781ab1":"Przeczytaj pole w świecy (przeczytaj z listy świecy)","5606b4460ac96063b8a8e5647008f3ec97252fc5":"Sekundy od epoki","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"Zwraca czas epoki (sekundy od epoki)","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"Uruchom co","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"Sek.","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"Uruchamiaj bloki wewnątrz co n sek.","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"Blok uruchamiania co n sekund został zaniechany. Skontaktuj się z nami, jeśli posiadasz prawidłowy przypadek użycia.","7b9c76088576a64f32d67ec335162b9f73eaa026":"Uruchom po","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"Uruchom bloki wewnątrz po n sek.","e9fb732dde76a6977bcaa2818b0f56125b183648":"Do daty/godziny","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"Konwertuje liczbę sekund od Epoch na łańcuch reprezentujący datę i czas. Przykład: 1546347825 zostanie przekonwertowane na 2019-01-01 21:03:45.","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"Na znacznik czasu","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"Zamienia ciąg reprezentujący datę/czas na sekundy od epoki. Na przykład: 2019-01-01 21:03:45 GMT+0800 zostanie zamieniony na 1546347825. Godzina i strefa czasowa są opcjonalne.","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"Korzystaj z Deriv, posługując się adresem e-mail i hasłem Binary.com.","64f72129852fb7bdff0725c71324a012630f53bf":"W UE produkty finansowe są oferowane przez Binary Investments (Europe) Ltd, W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, objętą regulacjami Urzędu ds. Usług Finansowych na Malcie: Malta Financial Services Authority jako firma świadcząca usługi inwestycyjne kategorii 3 ({$0}cencja o nr IS/70156{$1}).","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"Poza terytorium UE produkty finansowe są oferowane przez spółkę Binary (SVG) Ltd, Hinds Building, Kingstown, St. Vincent and the Grenadines; Binary (V) Ltd, Govant Building, Port Vila, PO Box 1276, Vanuatu, za której regulacje odpowiada Komisja ds. usług finansowych Vanuatu (Vanuatu Financial Services Commission) – ({$0}zobacz licencję{$1}) Binary (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, Brytyjskie Wyspy Dziewicze, za której regulacje odpowiada Komisja Brytyjskich Wysp Dziewiczych ds. Usług Finansowych (British Virgin Islands Financial Services Commission) – ({$2}licencja o numerze SIBA/L/18/1114{$3}), oraz Binary (FX) Ltd., Lot No. F16, First Floor, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malezja, za regulacje w zakresie prowadzenia usług brokerskich odpowiada Urząd ds. Usług Finansowych na Labuanie (Labuan Financial Services Authority) – {$4}licencja o numerze MB/18/0024{$5}).","10dd345bc3319e2151794428b2c709dc5fc381a7":"Ta witryna internetowa nie jest dostępna dla osób poniżej 18 roku życia oraz w niektórych krajach, takich jak: Stany Zjednoczone, Kanada, Hongkong, Japonia.","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"Ostrzeżenie o ryzyku","ad0fc99c05681528248b73007dba16fd760a81c6":"Produkty oferowane za pośrednictwem tej witryny internetowej obejmują opcje binarne, kontrakty na różnice kursowe (kontrakty CFDs) i inne złożone instrumenty pochodne. Handlowanie opcjami binarnymi nie jest odpowiednie dla każdego. Handel kontraktami na różnice kursowe (CFDs) wiąże się z wysokim ryzykiem, gdyż dźwignia finansowa może przynieść zarówno korzyści, jak i straty. W związku z tym, produkty oferowane na tej witrynie internetowej mogą być nieodpowiednie dla niektórych inwestorów i wiążą się z ryzykiem utraty całego zainwestowanego kapitału. Nigdy nie inwestuj środków finansowych, na stratę których nie możesz sobie pozwolić, ani pożyczonych środków. Przed rozpoczęciem handlowania oferowanymi przez nas złożonymi produktami upewnij się, że rozumiesz ryzyko z nimi związane i zapoznaj się z zasadami {$0}odpowiedzialnego handlowania{$1}.","1fda2716eb92e0195ff59b110af23d86b43fd909":"W UE produkty finansowe są oferowane przez Binary Investments (Europe) Ltd, W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta. Objęta licencją i regulacjami Urzędu ds. Usług Finansowych na Malcie: Malta Financial Services Authority jako firma świadcząca usługi inwestycyjne kategorii 3 (licencja o nr IS/70156).","be7786af641b859c03ec152461d791480cf676ed":"Na Wyspie Man i w Wielkiej Brytanii wskaźniki zmienności są oferowane przez Binary (IOM) Ltd., First Floor, Millennium House, Victoria Road, Douglas, IM2 4RW, Wyspa Man, Wyspy Brytyjskie; za wydawanie licencji i regulację odpowiada odpowiednio (1) Komisja Nadzoru Gier Hazardowych Wyspy Man, na Wyspach Brytyjskich (Gambling Supervision Commission) – aktualna licencja została wydana dnia 31 sierpnia 2017 r., (2) Komisja ds. Gier Hazardowych w Zjednoczonym Królestwie (UK Gambling Commission) – licencja o {$0}numerze referencyjnym: 39172{$1}).","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"W pozostałej części UE wskaźniki zmienności są oferowane przez Binary (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta - za licencję i regulację odpowiada (1) Urząd ds. Gier Hazardowych: Malta Gaming Authority na Malcie (licencja o numerze MGA/B2C/102/2000 wydana 1 sierpnia 2018 r.), w przypadku klientów ze Zjednoczonego Królestwa (2) Komisja ds. Gier Hazardowych w Zjednoczonym Królestwie: UK Gambling Commission (licencja o {$0}numerze referencyjnym: 39495{$1}), w przypadku klientów z Irlandii (3) Irlandzkie Władze Podatkowe i Celne: Revenue Commissioners (Zdalna licencja bukmacherska o numerze: 1010285 wydana 1 lipca 2017 r.). Zobacz pełną treść {$2}Informacji o przepisach prawnych{$1}.","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"Binary.com to zdobywająca nagrody platforma do handlu online, która ułatwia swoim klientom handel na rynkach finansowych, oferując opcje binarne i kontrakty na różnice kursowe. Handel opcjami binarnymi i kontraktami na różnice kursowe wskaźników zmienności jest uznawany za grę hazardową. Należy pamiętać, że gra hazardowa może uzależniać – prosimy o rozsądną grę. Dowiedz się więcej na temat {$0}Odpowiedzialnego Handlowania{$1}. Niektóre produkty są niedostępne w niektórych krajach. Usługi oferowane za pośrednictwem tej strony internetowej nie są dostępne w niektórych krajach, np. w Stanach Zjednoczonych, Kanadzie, Hongkongu, oraz dla osób poniżej 18 roku życia.","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"Handlowanie opcjami binarnymi może nie być odpowiednie dla wszystkich, więc upewnij się, że w pełni rozumiesz powiązane z nim ryzyko. Twoje straty mogą przekroczyć Twoją początkową wpłatę, a aktywa bazowe nie są Twoją własnością i nie posiadasz praw w stosunku do nich.","496a99878841de69368c33af9e88eb37c0da5712":"Kontrakty na różnice kursowe (CFDs) są złożonymi instrumentami i wiążą się z dużym ryzykiem szybkiej utraty pieniędzy z powodu dźwigni finansowej. 78.6% inwestorów detalicznych traci pieniądze podczas handlowania kontraktami na różnice kursowe. Zastanów się, czy rozumiesz, jak działają kontrakty CFD i czy możesz sobie pozwolić na wysokie ryzyko utraty pieniędzy.","a726d863bbdceba7b06a1083026a53db76de47b7":"Mnożniki handlowe","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"Zwiększ swoje potencjalne zystki bez ryzykowania więcej niż Twoja stawka.","febe8aef26fb3017be5bf43d66f7972731c20833":"Płatności między użytkownikami","a8c1114d1c88db12afa05b331188ceb77afad6e3":"Wskaźniki Crash/Boom","d29324705a18a81ffc0376f3f37639a68827f3e6":"Pprognozuj i osiągaj potencjalne zyski w przypadku wzrostów lub spadków cen. Opcja dostępna tylko z mnożnikami na DTrader.","ba2098a209e375402a0cf222cec87cce26440767":"Wyłącznie na Deriv","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"Przed nami świetlana przyszłość.","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"Znajdź te funkcje bonusowe i wiele więcej na Deriv:","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"Wypróbuj","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"SmartTrader","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"Nasza klasyczna platforma do inwestowania w opcje","64dfd7424a05133b74cfb93fcbe385ede6539855":"Nasza klasyczna zautomatyzowana platforma do inwestowania","824d76b124e6289f372e2ff6bcba91e8939343bd":"Dowiedz się więcej","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"Deriv MT5","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"Światowej sławy platforma do inwestowania w kontrakty na rożnice kursowe","54617a018fc6dffb3a70627b97f0db5c52a4081d":"DTrader","dbcd68f389d64fc531a650652c87b7d83fc82d94":"Nasze flagowa platforma do inwestowania w opcje i mnożniki","dd69c213333a751a0ab3bc9ce6368588bf971b61":"DBot","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"Nasza zautomatyzowana platforma inwestycyjna nowej generacji","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"Deriv GO","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"Handluj w podróży dzięki naszej mobilnej platformie inwestycyjnej","f63714db18c58c6b4a7a7bad09178faaeca05104":"Deriv X","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"Nasza platforma do inwestowania w kontrakty na różnice kursowe z możliwością personalizacji","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"Wszystko, co lubisz w Binary.com i jeszcze więcej","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"7 platform do wyboru","029582bad299ab8f44c57b961210e56569efd536":"Zarówno SmartTrader i Binary Bot, jak i nowe platformy, takie jak jako DTrader i Deriv X. Niezależnie od tego, jaki jest Twój styl inwestowania, mamy dla Ciebie odpowiednią platformę.","9a07439b57e510e8e33b372aad2c360dbc39e79c":"Inwestoj w kontrakty CFD, opcje cyfrowe i mnożniki, nowy rodzaj zakładów pozwalający zwiększyć potencjalne zyski przy ograniczonym ryzyku.","3d0be0e8eb736257254698ba821c45389e385f1e":"Wpłaty kryptowalut przez on-ramp dla waluty fiducjarnej","c4303d30e60f01fa922400e52df4e96d71b35d6e":"Ponad 100 instrumentów","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"Inwestuj w swoje ulubione produkty: waluty, towary, akcje, wskaźniki giełdowe i syntetyczne. ","f30ce7459f29851b219b504216581bf3d3446de0":"Wsparcie, zawsze gdy go potrzebujesz","6df6091514ee13992a3ac28445af1d9a1afbcb67":"Uzyskaj całodobową obsługę klienta i dostęp do centrum pomocy.","92c8b7b779e7cf179b89484285fd766274b3bf1f":"Poznaj Deriv już teraz","a87a92c5ce4925186a081cf4478639fcc31b12ed":"W UE produkty finansowe są oferowane przez Deriv Investments (Europe) Limited z siedzibą pod adresem: W Business Centre, Level 3, Triq Dun Karm, Birkirkara BKR 933, na Malcie, która podlega licencji wydanej na Malcie ","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"(licencja nr IS/70156)","720280451c98ceeb796f3c7fa118813fc8da694d":"i regulacjom Urzędu ds. Usług Finansowych na Malcie: Malta Financial Services Authority, Triq l-Imdina, Zone 1, Central Business District, Birkirkara CBD 1010, Malta, na mocy ustawy o usługach inwestycyjnych. Podlega autoryzacji i regulacjom instytucji Financial Conduct Authority oraz posiada różnorodne pozwolenia. Rodzaj i zakres ochrony konsumentów może się różnić od ochrony w przypadku firm zlokalizowanych w Wielkiej Brytanii. Na stronie internetowej instytucji można znaleź szczegóły na temat dokumentu Financial Services Contracts Regime, który umożliwia firmom zlokalizowanym w Europejskim Obszarze Gospodarczym na prowadzenie działalności w Wielkiej Brytanii przez ograniczony czas, aby kontynuować działania niezbędne w celu realizacji wcześniej istniejących umów.","0f1dda628bebb4748de6df05fa3bff4989c1b476":"Poza Unią Europejską produkty finansowe są oferowane przez następujące firmy: Deriv (FX) Ltd, F16, Level 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malezja z licencją wydaną przez Labuan Financial Services Authority ","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"(licencja nr MB/18/0024);","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"Deriv (BVI) Ltd - Kingston Chambers, P.O. Box 173, Road Town, Tortola, Brytyjskie Wyspy Dziewicze - jest objęta licencją British Virgin Islands Financial Services Commission ","a56aa088dfea506d5dbe18f385c29418f771a639":"(licencja nr SIBA/L/18/1114);","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":" Deriv (V) Ltd, 1276, Kumul Highway, Port Vila, Vanuatu, podleającą pod licencję i regulację komisji Vanuatu Financial Services Commission; oraz Deriv (SVG) LLC, Hinds Buildings, Kingstown, Saint Vincent i Grenadyny.","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"Deriv Limited — 13 Castle Street, St. Helier, JE2 3BT, Jersey — jest spółką holdingową dla powyższych spółek zależnych.","74e8fa69aad80f93303a7723e5a304f3d43560b6":"Usługi oferowane na tej witrynie internetowej nie są dostępne dla osób poniżej 18 roku życia oraz w niektórych krajach, w tym: Stanach Zjednoczonych, Kanadzie i Hongkongu.","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"Kontrakty na różnice kursowe (CFD) uważa się za złożone instrumenty pochodne, w związku z czym mogą nie być odpowiednie dla klientów indywidualnych. Kontrakty CFD to skomplikowane instrumenty finansowe związane z wysokim ryzykiem utraty pieniędzy z powodu zastosowania dźwigni finansowej. Należy się zastanowić, czy rozumiesz istotę kontraktów CFD i czy możesz sobie pozwolić na wysokie ryzyko utraty swoich pieniędzy. Wspomniane tu produkty mogą podlegać zmianom kursów walutowych. Jeśli zainwestujesz w te produkty, możesz stracić część lub całość zainwestowanej kwoty, a wartość inwestycji może się zmieniać. Nigdy nie inwestuj środków finansowych, na stratę których nie możesz sobie pozwolić, ani pożyczonych środków.","5bb3f3499158dbe30af5c725694b321dfe821433":"Zanim zainwestujesz w oferowane przez nas skomplikowane produkty finansowe upewnij się, że rozumiesz związane z nimi ryzyko i dowiedz się więcej na temat ","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"Bezpieczne i odpowiedzialne inwestowanie.","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"Przenosimy się!","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"Byliśmy obecni pod marką","991753597fde70aab5791de6d50ee8cc49a0bdcc":" Binary.com","efa99ab039a285c6264580bea691a4ffefcbeee7":" przez 2 dekacy i już czas na nowy ekscytujący rozdział.","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"Poznaj nasz nowy dom","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":" Deriv.","52b8454dc755419beeff2f90cd0fc91def428244":"Witaj Deriv!","27ad1d8334221366694c7acdd70fb380857d1e6e":"Może później","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"Przejdź do Deriv","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"Przejście na Deriv jest bardzo proste","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"Wystarczy zalogować się przy użyciu poświadczeń Binary.com. Rejestracja nie jest wymagana.","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"Wypróbuj teraz","63fbf7977349e32e4a124ffa047549b720806d73":"Zabierz Deriv ze sobą","03d42257a2263b2841b9e0ae4b94de117228a33a":"Pobierz aplikację mobilną Deriv GO i inwestuj w drodze. Nigdy więcej nie przegapisz złotych okazji.","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"Zeskanuj ten kod QR, aby pobrać Deriv GO","6b7499b1513a3cec3da3ff07cdad9b358954021e":"Nie czekaj","b23efda40ddeb801beeebf915669d806744014af":"Zabezpiecz swoje inwestycje na przyszłosć. Przejdź na Deriv już dziś.","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"Zapoznaj się z Deriv","34075438f939258908cc21d28bf59ab5126dc2d6":"Przyjdź do Deriv i zabezpieczyć swoje inwestycje na przyszłość.","e669443b63757b5ad8571e52393caf2a0a812be3":"6 powodów, dlaczego spodoba Ci się Deriv","2c141583afaaa12438b16ee67355c6e3eaf77763":"Binary Bot ma teraz nowy dom","4e0e045da59b385138ced3203cdb81c3b4cdd135":"Od dwóch dekad oferowaliśmy usługi jako Binary.com, a teraz nadszedł czas na ekscytujący nowy rozdział. Binary Bot, Twoje ulubione narzędzie do Tworzenia botów, jest teraz dostępne na Deriv, naszym nowym portalu. Odwiedź nas i zobacz.","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"Przejdź do Binary Bot na Deriv","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"Skorzystaj z Binary Bot na Deriv, naszym nowym portalu","1071c645f523394b408a6d285e95331bc583f14c":"W ciągu 5 minut pokażemy Ci zalety korzystania z Binary Bot na Deriv. Jeśli zignorujesz tę wiadomość, wyślemy ponowne przypomnienie za 3 tygodnie.","be43a8989c5745ec7386ca7c69442165f55dee8e":"Pokaż mi korzyści teraz","074603c9aef93515ed33d179e982c67ea7abdb45":"Korzystaj z Binary Bot na Deriv"}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"Логика","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"Математика","c3328c39b0e29f78e9ff45db674248b1d245887d":"Текст","4d064726954a17487f94e931f5b157b733ec22ed":"Расширенные","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"Список","19de69cb601f53a4ea7af22a65c71ae63251365c":"Переменная","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"Функции","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"Цикл","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"Binary","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"Определение контракта","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"До покупки","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"Во время покупки","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"После покупки","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"Анализ тиков","8cf71374fa095a64b5295b672daef8507ec7be6a":"Индикаторы","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"Инструменты","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"Время","8d8fd6765e184419cad8b88d1a60c895d79578c2":"Свечи","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"Разное","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"Журнал","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"Детали","9feddbabd7e7309e96c590069057158e96baa8f6":"Проверка реальности","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"Торговля опционами может перерасти в зависимость, как и любая другая деятельность, доведенная до крайности. Чтобы избежать опасности возникновения подобной зависимости, мы проводим проверку реальности и предоставляем регулярный отчёт о ваших сделках и счетах.","4152043e8c670075d2c919677e835edb0d923cab":"Пожалуйста, укажите желаемый интервал для проверки реальности (в минутах)","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"Пожалуйста, введите число от 10 до 60.","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"Продолжить торговлю","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"История счёта","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"Выход","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"Свяжитесь с нами","f7c400ed695f898b8ee9d21664aa17b5bb693828":"Вход","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"Вернуть исходное состояние блоков","f98595d541778d86f75ef22b3328a031d20aa16b":"Загрузить новые блоки (xml файл)","4a1e616226c329a94da7768bc0435a3284478010":"Сохранить существующие блоки (xml файл)","6b3465ace62f33f0687b4669ac26d95895e9ca52":"Подключите Binary Bot к Google Drive, чтобы легче сохранять и повторно использовать блоки","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"Отменить изменения (Ctrl+Z)","937f5055f05be359ddf619744e8af4d643549e80":"Вернуть изменения (Ctrl+Shift+Z)","8406d1cce44230835932060649e999ca3283b413":"Увеличить (Ctrl + +)","1109673172af2c173c492622ff8a72c8f29f0e70":"Уменьшить (Ctrl + -)","44c22002c65d2871331263a23c3e09c0a1bfd847":"Упорядочить по вертикали","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"Показать/скрыть окно деталей","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"Запустить робота","ba50a42d8d3228c37a817865fce49fbca692c2ad":"Остановить бота","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"Показать журнал","91017ef9b165cd0e7475a770f318ea5e705e1321":"Показать график","c89e3dd1cafcadcc0312e476ab58b2332209da23":"Показать TradingView","b02c858e72be118a65c9393930351012b647cb9e":"Изменить заголовок","250be77f7605669a0b3d968b9ed381a3d9787ed1":"Открыть сохранённый XML файл и извлечь блоки","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"Binary Bot","608061fb5aab975013fa70c5c814a1d8ba30c152":"Торгуйте ещё лучше и эффективнее","e4ce8dc3e416e69262ba642dc57d3975d6616980":"Хотите автоматизировать свои любимые стратегии для торговли бинарными опционами?","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"Binary Bot — наш передовой инструмент программирования, который позволяет создавать торговых ботов с помощью простого","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"Создавайте любое количество роботов для торговли бинарными опционами, закладывая в них простые формулы или сложнейшие алгоритмы. Позвольте роботам торговать за вас, даже когда вы спите.","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"Начните создавать робота","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"Нужна помощь?","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"НУЖНА ПОМОЩЬ?","d635b53e59c9aad8c5d78458826beffb029b27bf":"Спасибо! Мы свяжемся с вами в течение 24 часов","a69a8fc21499d0fd85e87bab467699827547a5bc":"Пожалуйста, введите действительный URL сервера","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"Не выбран актив","50050f06645ad2743165b429a8f7deebd285fd63":"Не указан тип контракта","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"Пожалуйста, войдите","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"Длительность должна быть положительным целым числом","4df6e872792d72aea8a2f6b831d00b554464da23":"Сумма должна быть целым числом","001e68df3a4b32a4d57148d9d407f44eee3b7436":"Данная свеча недействительна","04f14ea7c92e0b2b5ae005c696245063ec641d66":"Заданный список свечей недействителен","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"повторная попытка через","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"Достигнут предел ставки для","094628ce13fc0e78f07b697d1cc9421bb2edd666":"Не удалось выполнить запрос для","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"Нет","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"Да","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"история счёта","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"цена аск","50e72909992bdc37c7c07769d1b7efac5e52874c":"выплата","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"прибыль","c980b910204c7babdffe8ff3f7e755f30133383c":"тип контракта","a726c6955157f1b8b92f9932652434a7150f80f8":"входная котировка","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"значение на входе","3905be81561384dc8c43d6127c57ed1e0eb03b74":"входное значение строка","7674920c033ca14277c577e19c037a6754d4fa80":"выходная котировка","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"значение на выходе","06ecea26625359f7dcf5ff5c47af6174ff815257":"выходное значение строка","779455ee3bde8494d9629b353e17b19e92357ba8":"барьер","37a5301a88da334dc5afc5b63979daa0f3f45e68":"результат","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"Прибыль","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"Убыток","563339f82447b4e758ad76d5a0b63b5698594fba":"Повышение","5c1ae82c29543ac887703776bf3da2c7dcce683d":"Падение","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"Без изменений","ecb252044b5ea0f679ee78ec1a12904739e2904d":"строка","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"номер","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"зелёный","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"синий","96de5543d183d7de52ac5fa21c46fc811f673f89":"жёлтый","78988010b890ce6f4d2136481f392787ec6d6106":"красный","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"Беззвучный","cf84a98d6cf7f156862a08ba8236467b6f471004":"Оповещение","eee2facd669d1434848c24da5527b3e87d9a12d5":"Получение прибыли","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"Задание выполнено","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"Ошибка","a3b1583d377f37ac20de7e089edfa0920a078e57":"Серьёзная ошибка","66c8b6848eee629c4ac551bf2b5fa591571654be":"Повышение равно","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"Падение равно","062787aa328047e189774b3703d983b83938f6e9":"Выше","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"Ниже","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"Касание","7d7932bcc2e262ae98cf09dc5445130fb3881769":"Нет касания","a16814a48ec58c2e24ba224a80921a5c02361abe":"Заканчивается внутри","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"Заканчивается вне","534ec5da4e82ec419abc170e1a8448f55a01664f":"Останется внутри","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"Выйдет за пределы","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"Азиатские вверх","c098658ce3d3a258e4d155949a60072966b36db7":"Азиатские вниз","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"Совпадёт","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"Отличается","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"Чётное","dc28f5f3c65ec611f0f30022650d24382d27448e":"Нечётное","18a63f5512afb5573e5b44deba78d629f0635317":"Над","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"Под","2155c8b38181dd2552e84a94049aacd33ef9c607":"Высокий тик","1408cfd2b064b923f024fbe590e27db8282941a5":"Низкий тик","b86eb15dc4f13e4c2972de158d3038d9f657242f":"Reset Колл","669a1f3d9a8f601a84da536cfdad1de4092b1926":"Reset Пут","844d1a5c99a0a668383340cc095d040eef998c79":"Только вверх","87293a146cd481a2b30cf74282ec061dc4cf0735":"Только вниз","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"Открытие","b1a5954a483f8f8b0207385095f74aeb409b3f80":"Верхн.","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"Нижн.","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"Закрытие","1173872a4fb205b713702f0eec5cf2c732c828fd":"Время открытия","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"По умолчанию","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"1 минута","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"2 минуты","24e46784cbce32443db5a2638b1a7d3201543e9b":"3 минуты","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"5 минут","a6f151883b736f0470d33492e61c72a7d059d065":"10 минут","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"15 минут","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"30 минут","f030c3d667652646b86732ad7bc67e226c49cd3a":"1 час","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"2 часа","7b47150d431db70d783724007f07ab894eb8ac2e":"4 часа","191800b7e9a48680792c0dd77cb6cac00c4514c6":"8 часов","2d8a6f7c34468578640b333b8650131de06ac770":"1 день","cd1495cb4c60266a6abad9024022ae079bf7e416":"(1) Выберите нужный контракт","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"(2) Просм. и купите контракт","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"Параметры контракта","160f06d4799c85021a810f68c5b517eea37a2737":"Покупка","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"Вверх/Вниз","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"Вверх/Вниз равно","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"Азиатские","2260ce49306460c8a2ef501939f29ad6ddd4e934":"Цифровые","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"Касание/Нет касания","f7de1f66f0979667da275b7e8996e805395025a1":"Закончится внутри/вне","a431deecd4c2258097adae418d496fe9a8179fee":"Останется внутри/вне","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"Наибольш./наименьш. тик","12a3f461cdebbc8f335190413ee6c57442743bba":"Reset колл/Reset пут","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"Только вверх/вниз","91a64e3f83c91acf336c631fba295f297f94c399":"Запустить после n секунд","024696596f26a4db232fd9e966eadfeb27c0bd1a":"Запускать через каждые n секунд","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"верхн.","85c274929bc0e28eafd3734f2c25046c3b95b36b":"средн.","346e3ee198e98146993894d3de8ecab1a86c3e80":"нижн.","f16459104f92ab6b38aa265adb4ecbfc3768e303":"Гистограмма","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"MACD","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"Сигнал","19eabc961735d78f12fc7be906ffcb033853cf85":"Временная метка","68f4145fee7dde76afceb910165924ad14cf0d00":"Сообщение","e99811bd3b1ad17e74614060ecb180602be35ad6":"Вы успешно вышли!","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"блок нужно добавить на рабочую область","1fde9f1ebca07dcbc704130bd18645bce7718b55":"блок должен быть включен","d466687f90ba548434d65186d11a80c4204f9ad6":"должно быть добавлено внутри:","629777b7d4d610ace6dee24442730f27d7d0853e":"Файл не поддерживается:","0b93c14956403c2e5c9e79f5c836babc56912006":"Binary Bot не будет размещать новые контракты. Все размещённые (и не истёкшие) контракты будут закрыты нашей системой. Все несохранённые изменения будут потеряны.","c1458ff86fd60d9544d7cd8a67437df2b766f482":"Примечание: подробную информацию обо всех подтвержденных транзакциях см. на странице выписки Binary.com.","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"Все несохранённые изменения будут утеряны.","410bf23a3f080def9c7a976a16305bcde7943ed1":"Вы уверены?","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"К сожалению, Binary Bot недоступен в вашей стране","901624741023fcfc805ce43c94b8012e3b1d1c99":"Хотите торговать CFD на MT5? У вас будет доступ к forex, акциям, фондовым индексам, сырьевым товарам, криптовалютам и синтетическим активам.","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"Стратегии","910ec7aa40b04ec6ba51162f4de7850569326cb6":"Возникла ошибка при загрузке скрипта Google API.","8f51f350debde84e067e1a0405fb6304922a7d4b":"Произошла ошибка при инициализации Google диска.","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"Возникла ошибка при загрузке библиотек Google Drive","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"Предоставьте разрешение на просмотр и управление файлами на Google Диске","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"Неизвестный формат файла","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"Возникла ошибка при извлечении данных из Google Drive","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"Выберите стратегию Binary Bot","2db43c69a4b96454914f0b8272bc869984529e6e":"Возникла ошибка при регистрации файлов из Google Drive","0dcea5f584938e0fff00084b83156ab31d641ab3":"Возникла ошибка при извлечении файлов из Google Drive","18da95988117ff029393f3f5c881d70ef47f7385":"При обработке вашего запроса возникла ошибка","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"Выберите папку","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"Произошла ошибка при отправке сообщения через Telegram","3f370309b6280eb100f898426d8605c1f45d558d":"Неверная временная метка","af6a4e2a5582be89ac930e946eaed86e01cac58b":"Неправильная дата/время","49d51398b574e7312d99b18d2b93d2ede416f053":"Не удалось отправить webhook","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"Предложения не готовы","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"Выбранное предложение не существует","6ea4a034747d020b1d8ce4848def95d537555dd6":"Куплено","89f89c02cf47e091e726a4e07b88af0966806897":"ID","1200c1af2f7bba4e29a34112865662748c9d41df":"Перепродажа этого контракта невозможна.","62d6180e55905f7b996d442c53631981a4ef8b5b":"Продано по","ed4978867de1da05b336b724a3fb96222a29ebec":"Индекс должен быть положительным целым числом","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"Сумма прибыли","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"Сумма убытка","46fc6f27a835486d63d9e927c6687e4508cb3087":"Вы достигли максимального количества сделок","9202ddae4cea16513e53bbc965d88ed975e59512":"Вы достигли максимальной суммы убытка","5f52b397b7e5f538681f0f5717a88aa626349c7a":"Bot.init не вызывается","66c7734789e19cbeef3a5ac185ea732139aed213":"График","3b662fb2e8bafce29aa98321b18874bb44905488":"Интеграция Google Drive","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"Установите дневной лимит убытков на странице самоисключения, чтобы активировать трейдинг.","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"Максимальное число последовательных контрактов должно составлять от 1 до 100","93039e609d94a24f3572b794a31b21525a09af2b":"Не задано","a85b8cc112a8597df1612d60a74faa818c25d1b3":"Условия наших регуляторов требуют от вас установить торговые ограничения. Обратите внимание, что ваш бот прекратит торговлю, только если будет выполнено одно или оба из приведенных ниже условий.","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"Дневной лимит на убытки:","95052a29f213e9698b593418fe396ecc21032f9b":"Это порог ваших потенциальных убытков за день на всех платформах Binary.com. Как только ваш общий убыток достигнет или превысит эту сумму, бот перестанет торговать. Установить лимит можно на {$0}странице самоисключения{$1}.","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"Максимальное число последовательных контрактов","730657200c17321d926e1bd08dbf65bd96855a8a":"Это максимальное количество контрактов, которое вы разрешаете вашему боту провести за этот запуск.","952f375412e89ff213a8aca383d18e5691354347":"Начать","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"Торговые ограничения","095ba68888b5ace5f4515f5acab76dfa1073544e":"Мой компьютер","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"Загрузить","248e224f533752db28a1aab3519a58569ad96140":"Загрузить блоки","c7097e97dcc446ca889d3ca6be733a65e2728afe":"Успешно загружено на Google Drive","a6b977714595aa01678fca98e86553aaeac05c92":"Сохраняйте блоки по отдельности в коллекцию. Они будут добавлены в вашу существующую рабочую область (основные блоки будут заменены) при загрузке.","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"Сохранить как коллекцию","611ebbfb080284312904de925ef0f75f4cb56ad2":"Сохраните блоки и настройки для повторного использования в других стратегиях","efc007a393f66cdb14d57d385822a3d9e36ef873":"Сохранить","a638caa8ab2b7ff7980a571334217339e6d1d634":"Сохранить блоки","39fca63515c105918f03e4908ec12df675b07f92":"TradingView","e643975ea5296d9de4486458f31ab0a5a2b228bf":"Это очистит все транзакции на панели сводки, и все счетчики будут сброшены на ноль.","85dfa32c97d8618d1bea083609e2c8a29845abe5":"Счёт","d847919a30d31c0be624087f3370492b3fdf80c6":"Кол-во выполнений","5cd6978d63540c8a490ef76f43219de6362f958e":"Общая ставка","17410d7b62b8b1de981cfebada24632987edf186":"Общая выплата","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"Общая прибыль/убыток","90eef613042c5a51f542421065b68b886d473807":"Баланс","db1c784524e1b54011a95823026161f7c8517fe0":"Ссылка","4db3e9e4aecd187db9339a10d2629fef46724dc4":"Тип контракта","1bb4086b66659d8580f9be4beef69931aeea3cad":"Входная котировка","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"Выходная котировка","ba7be969e7c1bb5f22489e843478e3d721aaa843":"Цена покупки","772fbced18230220d2d9be1456be16fc1b271d25":"Прибыль/убыток","bae7d5be70820ed56467bd9a63744e23b47bd711":"Статус","96f608c16cef16caa06bf38901fb5f618a35a70b":"В процессе","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"Завершен","82a82f798dd773717ec37d15fd4405510291734e":"Бот не запущен.","6a88e58aa1798626f94cf17f1a91618b405bb289":"Запуск бота...","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"Бот включен...","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"Бот выключается...","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"Бот остановлен.","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"Попытка купить","4684ee1026d9b4c872d016c3c4588a0c479a451c":"Сумма покупки","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"Покупка прошла успешно","f02760cd2eac28169f0a990c950c3dfe8427f772":"Контракт закрыт","c7363d8a0748d4a7e2cc968335dc9716f290359d":"Прекращение работы робота приведёт к приостановлению торговли. Все текущие контракты будут автоматически закрыты системой. Пожалуйста, примите во внимание, что ряд завершенных контрактов не будет отображен в таблице статистики, если робот будет остановлен на момент заключения этих контрактов. Для получения более подробной информации о всех завершенных контрактах ознакомьтесь с историей счёта Binary.com.","fadc0ef93d1ff13370524ce8481ddc4a71195934":"Упорядочить по вертикали","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"Загрузить","e4458464df6cbb8da1134875ba51519c5d244d9f":"Блоки должны быть внутри контейнера для блоков, основных блоков или функций","e9c45563358e813f157ba81b33143542165ba84e":"Предупреждение","31cb6f44d030abeabcc7046555dea851602a87a5":"Эта стратегия недоступна в вашей стране.","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"OK","9970168c192807246fad6138344e5a96449afbdd":"XML-файл пуст. Проверьте или измените файл.","a594b427eaf0f108d3e9cc20d70e15da811c760c":"Неподдерживаемая стратегия","04a5090686ac7b54822e00a9ff08c38a107601e7":"К сожалению, эту стратегию нельзя использовать на Binary Bot. Вы можете использовать ее только на DBot.","77dfd2135f4db726c47299bb55be26f7f4525a46":"Отмена","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"Перейти на DBot","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"Файл, который вы пытаетесь открыть, содержит неподдерживаемые элементы в следующем блоке: {$0}. Проверьте файл и повторите попытку.","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"Не удалось загрузить файл блока","af145748c9cf765a3b059eec20cb1dbb899297d8":"Блоки загружены успешно","11ee9c5d534cc8d22651092222b532917594161a":"Минимальная длительность","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"Число тиков должно быть от 5 до 10","ace1342bc3720b77ce510b93074041e7386d209e":"Время окончания не может совпадать со временем начала","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"Прогноз должен быть одной цифрой","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"должно быть добавлено внутри","33aa6ff282ee509d37c6f758274c9156b419ff73":"Вы попытались внедрить неразрешенную стратегию.","da162a909c2981ed318d23cd9a6be1d66e0a8400":"Нераспознанный формат файла.","5e719fa76e1b6cb396376c82ebdd04bec7253229":"Удалённые блоки для загрузки должны относиться к коллекции.","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"Не удалось загрузить файл блока.","df84a88f38b03b5b342362d72370b0d66afdae35":"Целью должен быть файл xml","cd680fd936e9559ef1d95efac7a71680e2b13a89":"Этот url уже загружен","34c59389053701a04127f74d32315e0206e076f8":"Возникла ошибка при загрузке url","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"Убедитесь, что в ответе сервера есть 'Доступ-Контроль-Разрешить-Источник' ('Access-Control-Allow-Origin')","988df856c066143616bd33d5904bbcdc22ff129e":"Binary.com переезжает на Deriv","2fccaab15d71b00c19da7053135471d510b513db":"Перейти на Deriv","3ead0b14c72503187691a7a6d7121987299bd401":"Данная версия не является официальной версией Binary Bot. Вы используете её на свой страх и риск.","27401c9c8e476d659c8382e05c6d70a4a82be468":"Официальная версия","bc981983e7f547dc62e19a1e383acfe00782a6d5":"Далее","b52b36b7269fbfc58ec24bb724691951a3decbe8":"Назад","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"Готово","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"Быстрый обзор","a48e81d4a8da67637b46725824177a959fe99b21":"Хотите узнать, как пользоваться Binary Bot?","6f3e6ebf249947cec4f64117253a8fe43335ae79":"Нет, спасибо","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"Не спрашивайте меня снова.","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"Рабочая область","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"Используйте готовые группы блоков или создавайте свои собственные стратегии.","d171baee235d4c93f63755a876782dc5be4c3e47":"Инструменты для блоков","056f19272d96f902c38207cf163ea8dbff7fbd32":"Добавьте больше блоков для вашего робота.","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"Счета","f5c47fd3b3553b10441a06054078cea745177dea":"Войдите в систему перед тем, как запустить робота. Всегда тестируйте свои стратегии на демо-счете.","fd825ae94aa79500a878dd4590a4b360e7162663":"Управление роботом","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"Управляйте своими блоками. Направьте курсор на каждую кнопку для получения дополнительной информации.","f5169c84497de3aea74f7da9e7e177d1427e736b":"Удачи!","4f1b3d682c2a00b393c33637da402463bc11d5ff":"Хотите обратиться за помощью или сообщить об ошибке?","0049f8894e41937ebb9111cd3def6749049fb50f":"Нажмите здесь","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"Как найти Binary Bot на Deriv","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"На главной странице Deriv нажмите «Трейдинг» в верхней части страницы и выберите Binary Bot.","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"Попробуйте Binary Bot на Deriv","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"Тот же самый Binary Bot, которого вы знаете и любите","169dd3b2025485a48b8f9f3f6ef89f5586714140":"Оставили все так, как вам нравится.","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"Простое перемещение ботов","b763f8cbfa6396f195781032619a99bba04bc939":"Ваши стратегии с Binary.com можно использовать и на Deriv. Просто загрузите файлы XML и начните торговать.","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"7 торговых платформ","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"Проверенные временем Binary Bot и SmartTrader и новые платформы, такие как DBot и DTrader. Каким бы ни был ваш стиль торговли, у нас есть платформа для вас.","0ce7480da93c1c9839818d0720b77931d1637574":"Криптовалютные депозиты через fiat on-ramp","6e6a4c6839d2e859758a517865b095c1b8298dd6":"Простые пополнения счета в криптовалюте с такими обменниками, как Changelly, Banxa и XanPool.","c1b51f196c97b4781a354457579e9699b09de087":"3 типа контрактов","4708f7e87263464b130b987e4b9aed981c4f455d":"Торгуйте CFD, цифровыми опционами и мультипликаторами — новым видом контрактов, который увеличивает потенциальную прибыль при ограниченном риске.","b7fceac7d5f885d735aeda6e4654487467d33fa3":"Одноранговые пополнения счета и вывод средств","79a206119137878eb6be7c60f7ed34135194bdf0":"Обменивайте местную валюту с другими трейдерами на Deriv P2P, чтобы вносить и выводить средства со своего счета.","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"6 типов рынков","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"Диверсифицируйте портфель с широким спектром рынков, таких как forex, акции, криптовалюты, синтетика и многое другое.","14b2a808fdec3702e5a6b9152e13288c87a4768a":"Учитесь с академией Deriv","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"Полезные бесплатные статьи и видео помогут изучить основы онлайн-трейдинга.","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"Нажмите, чтобы выбрать","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"Недоступно","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"Тики","5fb1db527825d2996e37c655e5dec49d4da80c09":"Секунды","092f99ea11a34a8490e7a767a83a42fc45634f82":"Минуты","9e25a34e635a123f8958bbe26e7c4843278597fb":"Часы","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"Дни","db6708630fc646eb98298d9acd701e0a1ac051c2":"Сохраните блоки и стратегии на Google Drive","85538d002a336c5addef8d189d80976cf7758f8c":"Вы вошли как","b65463cb6a42a17de514acc4659f7fd331e0876a":"Подключить","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"Отключить","cd5f85b6f187605f82386eacd680f93820af8d11":"Результат","1e38ce3d180cefae485a6986ca7c67841e30376f":"Значение верно, если результат соответствует выбору","5c89497fc3c128e2ff865ce8df15356054f2c028":"(4) Узнайте результат и торгуйте снова","14ea81918758c994cbe3178e695e56afc1ef2b45":"Получите информацию о предыдущем контракте, узнайте результат и торгуйте снова. (Запускается после завершения сделки)","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"Подробности контракта:","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"Считывает выбранный параметр из списка Подробностей контракта","b3b543c80063a116ced4965d8537b7b62d14c0b7":"Торговать снова","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"Повторно запускает блок торговли","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"Цена аск","343fda69c73b78b84967055aae97f790c422adfd":"Цена аск для выбранного предложения","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"Проследите за потоком тиков и купите нужный контракт. (Запускается при обновлении тиков)","9bb396940adb9705fe57eba6ea8b578e6aafa792":"Выплата","87da93a46d143f6019979b3548414d9d7adabb35":"Выплата для выбранного предложения","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"Покупает выбранный контракт.","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"Продажа доступна","03bad10717e183b24829baf483dc715e1a44bf7b":"Значение верно, если доступна продажа по рыночной цене","2c71ed279a402e93312dbda173ab18f244d6bf46":"(3) Следите и продайте контракт","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"Следите за результатом купленного контракта и, по возможности, продайте его по рыночной цене. (Запускается при обновлении контракта)","579607dc4f989ce2b94b558431666a0ab07ac1f3":"Продать по рыночной цене","e20afd5cf3811a42071c9a312abb2afdad4c590b":"Продать по рыночной цене.","4712cbff8e92822fc960ef9c0197293a19675eae":"Продать прибыль/убыток","df817b48c7a076561b4f8bedc52d65d2e351ab52":"Возвращает прибыль для продажи по рыночной цене.","b44e884c355e447d0da0e6ba45caaff18c84373b":"Полосы Боллинджера","d6a2a207343bd83aacdc80b579ff4419713a256e":"Список ввода","170a28a9db6d27d7212fc6dc249434a57517e7bc":"Период","b833989d69900a4be9e32d1bab65c8f8233f099e":"Станд. коэффициент Dev. Вверх","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"Станд. коэффициент Dev. Вниз","974da601086448d0060aeed90e53ddd5acd17b91":"Рассчитывает список полос Боллинджера (ПБ) из списка с периодом","d5b65cac1f1cf9421ac978eebe532de99040cca6":"Список полос Боллинджера","58de49791c64aba14e36e5887244a5ef088286cd":"Рассчитывает список Полос Боллинджера (ПБ) из списка с периодом","4bd99f76f1104229744455d93df0ff76b9eeed58":"Экспоненциальная СС","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"Рассчитывает экспоненциальную скользящую среднюю (ЭСС) из списка с периодом","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"Массив экспоненциальных СС","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"Рассчитывает список экспоненциальных скользящих средних (ЭСС) из списка значений с периодом","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"Линейка MACD","b18e572ea14edd48587145f1ef50718adbf256c6":"Период быстрой ЭСС","974023bddd6249d0f6404872cfcae205b2599ea2":"Период медленной ЭСС","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"Период сигнальной ЭСС","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"Вычисляет список схождения-расхождения скользящих средних (MACD) из списка","95ec92885c855ba9cf734c17a43f081901e4d2cc":"Индекс относительной силы","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"Индекс относительной силы (RSI) из списка с периодом","4034de66995b876b2ba9bfd0274025e39168e05d":"Группа индексов относительной силы","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"Рассчитывает список индексов относительной силы (RSI) из списка значений с периодом","a9842c95766da40bf4ea6ee263cb5a5985847763":"Простая скользящая средняя","347775a293c14362d492f019e677c965be1d6e7d":"Рассчитывает простую скользящую среднюю (ПСС) из списка с периодом","4cc7b9e53d082896ad884eb01be16320af65f282":"Массив простых СС","2c75179a57af3c36581008b65e86ed81c4a4cbea":"Вычисляет список простых скользящих средних (ПСС) из списка значений с периодом","39f024cf49724fe7ffdea7773c72ed06eec998e1":"с интервалом","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"Направление","ad47561efb1dcbd7246d9b64487f615647fda036":"Значение верно, если направление соответствует выбранному","05bef508aadd62bf3967dcf67d769da296f19989":"Направление тика","21bfc78607d3a64de767a6677d1db42156d5039d":"Возвращает направление тика, полученное в блоке До покупки. Его значение может быть 'выше', если тик выше предыдущего, или 'ниже', если тик ниже предыдущего, а также пустым (''), если тик равен предыдущему","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"Блок направления устарел, используйте вместо него блок проверки направления","cdb31fc857f01a59f664413498293c714285f46d":"в списке свечей","20fd5f86f08796f145d69dedc209a27e459b2f51":"получить # с конца","a96606af8c33ac3428b45abc4782dbf93f458d29":"Получить последнюю n-ю свечу","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"Список последних тиков","248428facb97408414180d4de74e4db35360fbc4":"Возвращает список последних тиков","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"Последняя десятичная","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"Возвращает последнюю десятичную последнего тика","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"Список свечей","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"Возвращает список свечей","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"Составить список из","a4220593d385a720886f7af1ed3c478fd0c6339c":"значений в списке свечей","cd8cdf3d47e921c8a72addae9269e66041d417c5":"Возвращает список выбранных значений свеч","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"В списке свечей читайте ","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"# с конца","aba43a580daa7f306956ec69b83e6e37e7233126":"Прочитать значение выбранной свечи в последней n-й свече","e04b522218a181cf0223042dd18ae08dcc22d8d3":"Последний тик","6ee445fc253a55c9ed54c009c3f020ac65200d80":"Возвращает значение тика, полученное блоком До покупки","ed44b69176217a1251c04f0c13d23ac789ea60b2":"Последний тик Строка","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"Возвращает значение тика, полученное блоком 'до покупки' (строкой)","4b2340a890e88d1886757c3f7172e273a1edc31f":"Этот блок вызывается при каждом тике","b54d7b4590559dad64f02d09aacbf6d9863e2624":"Вы можете использовать этот блок для анализа тиков, независимо от ваших контрактов","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"Список тиков","17649cac8739adcae95e641f794880272ad33bd1":"Возвращает список значений тиков","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"Строка тиков Список","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"Возвращает список значений тиков (строкой)","c67ded6b64019212eb2bc69afd761f5b3f626040":"Добавить символ к числу, чтобы установить оффсет барьера.","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"Рынок","74751e67c3e1010c343095eaf543e7cb21ced2ef":"Тип контракта","1f4698382842477e211eb46de81fa506f01a8c34":"Оба","c1baf816aac5a5cd849768773fc248cd249dc296":"Тип контракта:","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"Интервал по умолчанию:","9693aeaaf68e3929b59b79306feaa0a847d01192":"Длительность:","78d7103a319e808455d397513279d99f3b3f3768":"Ставка","10c02649e226d430bd75a5b6315a41c0db9992a2":"Барьер","837276742aa90209dde3b4eef07d8e7ab26731ef":"Прогноз","258b49925b41751c6bd790a0848246566ba61440":"Перезапустить покупку/продажу в случ. ошибки","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"отключить для улучшения работы","b410994b67e37d9516eb9b866c85a8c639f79e68":"Перезапустить последн. контракт в случ. ошибки","2260c5a971c2602834ef8feeb5fa522f900b469f":"робот проигнорирует неудачн. контракт","0745acf92abd7b60598f161717884cc45dab8694":"Запустить один раз в начале","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"Задайте параметры контракта","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"Выберите нужный контракт и начните торговлю; добавьте инициализацию. (Запускается в начале контракта)","4d22b565e4253e92a908f216184779679bb1a044":"Верхний барьер","b70c38c6db3127422e05315c30bdf76c7c36c480":"Нижний барьер","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"Абсолютный","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"Баланс:","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"Получить баланс или строку","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"Внутренние блоки игнорируются","d072c2ceeb5c1217722d14c74de7aeab945b4215":"Поместите свои блоки здесь, чтобы не удалять их","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"Ключ: %1 Значение: %2","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"Возвращает строковое отображение пары ключ-значение","b06acc4158c824231f727a13e1c9811f43d5be42":"Загрузить блок из","661db37251a1ed1afe357ee13895f37a623d7cbf":"Загрузить блоки через url","6c03ee54ad3a51fc92a1d69943e99667847705b6":"Уведомить","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"со звуком","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"Создаёт уведомление","6e0fc122f936f808bc2e3af661121b65712ae855":"Уведомить в Telegram %1 Код доступа: %2 Чат: %3 Сообщение: %4","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"Отправить сообщение через Telegram","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"Общая прибыль","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"Возвращает общую прибыль","532e65f6e266db0bb442d1f426d44d7d32962340":"Общая прибыль Строка","78e84591ff76f992953a8e19b57c7eab7546d638":"Возвращает общую прибыль (строкой)","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"Кол-во выполнений","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"Возвращает количество выполнений с самого начала","7d500ebe352ccfa932b253e21938813a06fcff8e":"Webhook URL: %1","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"Отправляет POST запрос на URL","a35646754dbe7a9211ba8b81338a5d64580eb276":"Полезная нагрузка пуста","69b0648eddd207cd45a9e1ba973dae287b535576":"Полезная нагрузка:","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"свеча чёрная?","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"Определяет, является ли данная свеча чёрной; возвращает значение Верно, если цена данной свечи при закрытии меньше цены при открытии.","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"Составить список","5925d08228e246f07b790b88ad70c1b73a97d2bc":"значений в списке свечей","852b438f91ad9eb2cdd84419a675a216d543c687":"Прочитать","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"значение свечи","d79d854dcd0829e2177a47beab6a55569e781ab1":"Прочитать поле на свечах (прочитать в Списке свечей)","5606b4460ac96063b8a8e5647008f3ec97252fc5":"Секунд с начала отсчёта","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"Возвращает время начала отсчёта (секунды с начала отсчёта)","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"Выполнять каждые","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"Секунд(ы)","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"Выполнять внутренние блоки каждые n секунд(ы)","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"Блок 'Запускать каждую секунду' устарел. Свяжитесь с нами, если у вас есть допустимый вариант использования.","7b9c76088576a64f32d67ec335162b9f73eaa026":"Выполнить после","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"Выполнить внутренние блоки после n секунд","e9fb732dde76a6977bcaa2818b0f56125b183648":"В дату/время","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"Преобразует количество секунд с начала эпохи Unix в строку даты/времени. Пример: 1546347825 будет преобразовано в 2019-01-01 21:03:45.","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"Во временную метку","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"Преобразует строку, представляющую строку даты/времени, в секунды с начала эпохи Unix. Пример: 2019-01-01 21:03:45 GMT +0800 будет преобразовано в 1546347825. Время и часовой пояс не являются обязательными.","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"Начните использовать Deriv с вашим адресом электронной почты и паролем Binary.com.","64f72129852fb7bdff0725c71324a012630f53bf":"Компания Binary Investments (Europe) Ltd, расположенная по адресу W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, лицензирована и регулируется Мальтийским управлением финансовых услуг в качестве поставщика инвестиционных услуг 3-й категории ({$0}лицензия номер IS/70156{$1}).","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"За пределами ЕС финансовые продукты предоставляются компанией Binary (SVG) Ltd, Hinds Building, Kingstown, St. Vincent and the Grenadines; компанией Binary (V) Ltd, Govant Building, Port Vila, PO Box 1276, Vanuatu, деятельность которой регулируется Комиссией по предоставлению финансовых услуг Вануату ({$0}см. лицензию{$1}); компанией Binary (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands, деятельность которой регулируется Комиссией по предоставлению финансовых услуг на Британских Виргинских островах ({$2}лицензия номер SIBA/L/18/1114{$3}); а также Binary (FX) Ltd., Lot No. F16, First Floor, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia, регулируемой Управлением финансовых услуг Лабуана для ведения брокерской деятельности ({$4}лицензия номер MB/18/0024{$5}).","10dd345bc3319e2151794428b2c709dc5fc381a7":"Услуги данного веб-сайта недоступны в ряде стран, включая США, Канаду, Гонконг, Японию, а также для лиц моложе 18 лет.","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"Предупреждение о риске","ad0fc99c05681528248b73007dba16fd760a81c6":"Продукты, предоставленные на данном сайте, включают бинарные опционы, контракты на разницу (или \"CFD\"), а также другие комплексные производные продукты. Торговля бинарными опционами подходит далеко не для всех. Торговля CFD предполагает высокий уровень риска, так как кредитное плечо может сыграть не только в вашу пользу, но и против вас. В результате продукты, предложенные на данном сайте, могут подходить не каждому инвестору, ввиду риска потери всего инвестированного капитала. Настоятельно рекомендуем не инвестировать средства, которые вы не можете позволить себе потерять, а также не торговать на деньги, взятые в долг. Перед началом работы с предложенными нами комплексными продуктами, пожалуйста, оцените все сопряженные риски и ознакомьтесь с рекомендациями по {$0}ответственной торговле{$1}.","1fda2716eb92e0195ff59b110af23d86b43fd909":"Компания Binary Investments (Europe) Ltd, расположенная по адресу W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, лицензирована и регулируется Мальтийским управлением финансовых услуг в качестве поставщика инвестиционных услуг 3-й категории (лицензия номер IS/70156).","be7786af641b859c03ec152461d791480cf676ed":"Индексы волатильности на острове Мэн и в Великобритании предоставлены компанией Binary (IOM) Ltd., расположенной по адресу First Floor, Millennium House, Victoria Road, Douglas, IM2 4RW, Isle of Man, British Isles. Компания лицензирована и регулируется (1) Комиссией по надзору за азартными играми на Острове Мэн (текущая лицензия выдана 31 августа 2017 г.), а также (2) Комиссией по азартным играм Великобритании (номер лицензии: {$0}39172{$1}).","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"В остальной части ЕС Индексы волатильности предоставлены компанией Binary (Europe) Ltd., расположенной по адресу W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta. Компания лицензирована и регулируется (1) Управлением по азартным играм Мальты (лицензия номер MGA/B2C/102/2000 выдана 1 августа 2018 г.), для клиентов из Великобритании - (2) Управлением по азартным играм Великобритании ({$0}номер лицензии: 39495{$1}), для клиентов из Ирландии - (3) Налоговой службой Ирландии (лицензия удалённого букмекера номер 1010285, выданная 1 июля 2017 г). Ознакомьтесь с полной {$2}Информацией о регулировании{$1}.","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"Binary.com – это отмеченный наградами провайдер онлайн-трейдинга, который позволяет своим клиентам торговать на финансовых рынках с помощью бинарных опционов и CFD. Торговля бинарными опционами и CFD на Индексах волатильности относится к категории азартных игр. Пожалуйста, помните, что азартные игры могут перерасти в зависимость и играйте ответственно. Узнайте больше об {$0}ответственной торговле{$1}. Ряд продуктов доступен не во всех странах мира. Услуги данного сайта недоступны для лиц моложе 18 лет, а также в следующих странах: США, Канада, Гонконг.","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"Торговля бинарными опционами подходит далеко не всем, поэтому просим убедиться, что вы полностью осознаёте все возможные риски. Ваш убыток может превысить сумму первоначального пополнения счёта, и вы не получаете никаких процентов с активов, на которых заключаете контракты.","496a99878841de69368c33af9e88eb37c0da5712":"CFD являются сложными инструментами и сопряжены с высоким риском быстрой потери средств из-за применения кредитного плеча. 78,6% счетов частных инвесторов теряют деньги при торговле CFD. Пожалуйста, убедитесь, что вы хорошо понимаете принципы работы CFD и осознаете все сопряженные риски.","a726d863bbdceba7b06a1083026a53db76de47b7":"Мультипликаторы","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"Увеличьте потенциальную прибыль, не рискуя больше, чем ставка.","febe8aef26fb3017be5bf43d66f7972731c20833":"Одноранговые платежи","a8c1114d1c88db12afa05b331188ceb77afad6e3":"Индексы Crash/Boom","d29324705a18a81ffc0376f3f37639a68827f3e6":"Прогнозируйте и зарабатывайте на резких скачках и падениях. Доступно только с мультипликаторами на DTrader.","ba2098a209e375402a0cf222cec87cce26440767":"Только на Deriv","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"Новые возможности.","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"Эти и другие бонусные функции уже ждут вас на Deriv:","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"Перейти","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"SmartTrader","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"Наша классическая платформа для опционов","64dfd7424a05133b74cfb93fcbe385ede6539855":"Наша классическая платформа автоматизированного трейдинга","824d76b124e6289f372e2ff6bcba91e8939343bd":"Узнать больше","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"Deriv MT5","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"Всемирно известная торговая платформа CFD","54617a018fc6dffb3a70627b97f0db5c52a4081d":"DTrader","dbcd68f389d64fc531a650652c87b7d83fc82d94":"Наша флагманская платформа для торговли опционами и мультипликаторами","dd69c213333a751a0ab3bc9ce6368588bf971b61":"DBot","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"Платформа автоматизированного трейдинга нового поколения","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"Deriv GO","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"Наше мобильное приложение","f63714db18c58c6b4a7a7bad09178faaeca05104":"Deriv X","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"Наша гибкая платформа для CFD","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"Все, за что вы любите Binary.com... и даже больше","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"7 платформ на выбор","029582bad299ab8f44c57b961210e56569efd536":"Уже знакомые SmartTrader и Binary Bot, а также новые платформы, такие как DTrader и Deriv X. Каким бы ни был ваш торговый стиль, у нас найдется платформа для вас.","9a07439b57e510e8e33b372aad2c360dbc39e79c":"Торгуйте CFD, цифровыми опционами и мультипликаторами — новым типом контрактов, который увеличивает потенциальную прибыль при ограниченном риске.","3d0be0e8eb736257254698ba821c45389e385f1e":"Криптовалютные депозиты через fiat on-ramp","c4303d30e60f01fa922400e52df4e96d71b35d6e":"100+ инструментов","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"Торгуйте, чем вам нравится — forex, сырьевыми товарами, акциями, фондовыми и синтетическими индексами. ","f30ce7459f29851b219b504216581bf3d3446de0":"Помощь всегда рядом","6df6091514ee13992a3ac28445af1d9a1afbcb67":"Круглосуточный доступ к чату и Центру поддержки.","92c8b7b779e7cf179b89484285fd766274b3bf1f":"Перейти на Deriv","a87a92c5ce4925186a081cf4478639fcc31b12ed":"В ЕС финансовые продукты предоставляет компания Deriv Investments (Europe) Limited, расположенная по адресу W Business Centre, Level 3, Triq Dun Karm, Birkirkara BKR 9033, Malta. Компания лицензирована ","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"(номер лицензии IS/70156)","720280451c98ceeb796f3c7fa118813fc8da694d":"и регулируется Мальтийским управлением финансовых услуг, Triq l-Imdina, Zone 1, Central Business District, Birkirkara CBD 1010, Malta, в рамках закона об инвестиционных услугах. Компания уполномочена Управлением по финансовому надзору с предполагаемым изменением разрешения (VoP). Регулируется Управлением по финансовому надзору. Характер и степень защиты прав потребителей могут отличаться от тех, которые действуют для фирм, базирующихся в Великобритании. Подробная информация о режиме контрактов на финансовые услуги, который позволяет фирмам из ЕЭЗ работать в Великобритании в течение ограниченного периода времени для осуществления деятельности, необходимой для выполнения ранее заключенных контрактов, доступна на сайте Управления по финансовому надзору.","0f1dda628bebb4748de6df05fa3bff4989c1b476":"За пределами ЕС финансовые продукты предлагают следующие компании: Deriv (FX) Ltd, расположенная по адресу F16, Level 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia, лицензированная Управлением финансовых услуг Лабуана ","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"(номер лицензии MB/18/0024);","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"Deriv (BVI) Ltd, расположенная по адресу Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands, лицензированная Комиссией по финансовым услугам Британских Виргинских островов ","a56aa088dfea506d5dbe18f385c29418f771a639":"(номер лицензии SIBA/L/18/1114);","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":" Deriv (V) Ltd, расположенная по адресу 1276, Kumul Highway, Port Vila, Vanuatu, лицензированная Комиссией по финансовым услугам Вануату; и Deriv (SVG) LLC, расположенная по адресу Hinds Buildings, Kingstown, St. Vincent and the Grenadines.","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"Deriv Limited — 13 Castle Street, St. Helier, JE2 3BT, Jersey — является холдинговой компанией для вышеуказанных дочерних компаний.","74e8fa69aad80f93303a7723e5a304f3d43560b6":"Услуги данного сайта недоступны в ряде стран, включая США, Канаду, Гонконг, а также для лиц моложе 18 лет.","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"Контракты на разницу (CFD) считаются сложными производными финансовыми инструментами и могут не подходить для розничных клиентов. CFD сопряжены с высоким риском быстрой потери средств из-за эффекта кредитного плеча. Вам следует подумать, понимаете ли вы, как работают CFD, и можете ли вы позволить себе рискнуть потерять свои деньги. На упомянутые здесь продукты могут влиять изменения курсов обмена валют. Если вы инвестируете в эти продукты, вы можете потерять часть или все свои вложения, ввиду колебания их стоимости. Вы никогда не должны инвестировать средства, которые не можете позволить себе потерять, а также деньги, взятые в долг.","5bb3f3499158dbe30af5c725694b321dfe821433":"Прежде чем начать торговлю на предлагаемых комплексных финансовых продуктах, убедитесь, что понимаете сопряженные риски и знаете изложенные здесь принципы: ","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"Безопасная и ответственная торговля.","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"Мы переезжаем!","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"Мы были","991753597fde70aab5791de6d50ee8cc49a0bdcc":" Binary.com","efa99ab039a285c6264580bea691a4ffefcbeee7":" на протяжении двух десятилетий, но настало время для новой главы в нашей истории.","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"У нас теперь новый дом –","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":" Deriv.","52b8454dc755419beeff2f90cd0fc91def428244":"Открыть Deriv","27ad1d8334221366694c7acdd70fb380857d1e6e":"Позже","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"Перейти на Deriv","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"Перейти на Deriv легко","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"Регистрация не требуется. Просто войдите в систему со своими учетными данными Binary.com.","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"Попробуйте сейчас","63fbf7977349e32e4a124ffa047549b720806d73":"Возьмите Deriv с собой","03d42257a2263b2841b9e0ae4b94de117228a33a":"Установите мобильное приложение Deriv GO и никогда больше не упускайте удачные возможности для трейдинга.","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"Отсканируйте QR-код, чтобы скачать Deriv GO","6b7499b1513a3cec3da3ff07cdad9b358954021e":"Не нужно ждать","b23efda40ddeb801beeebf915669d806744014af":"Будущее трейдинга уже здесь. Переходите на Deriv сейчас.","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"Начать пользоваться Deriv","34075438f939258908cc21d28bf59ab5126dc2d6":"Попробуйте трейдинг будущего на Deriv прямо сейчас.","e669443b63757b5ad8571e52393caf2a0a812be3":"6 причин любить Deriv","2c141583afaaa12438b16ee67355c6e3eaf77763":"Binary Bot переехал","4e0e045da59b385138ced3203cdb81c3b4cdd135":"Мы работали как Binary.com 2 десятилетия, и пришло время для новой главы в нашей истории. Ваш любимый конструктор ботов, Binary Bot, теперь можно найти на Deriv. Приходите взглянуть.","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"Перейти на Binary Bot на Deriv","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"Работайте с Binary Bot на Deriv","1071c645f523394b408a6d285e95331bc583f14c":"Через 5 минут мы покажем вам преимущества торговли с Binary Bot на Deriv. Если вы проигнорируете это сообщение, мы напомним вам через 3 недели.","be43a8989c5745ec7386ca7c69442165f55dee8e":"Покажите сейчас","074603c9aef93515ed33d179e982c67ea7abdb45":"К Binary Bot на Deriv"}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"Lógica","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"Matemática","c3328c39b0e29f78e9ff45db674248b1d245887d":"Texto","4d064726954a17487f94e931f5b157b733ec22ed":"Avançado","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"Lista","19de69cb601f53a4ea7af22a65c71ae63251365c":"Variável","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"Funções","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"Loop","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"Binary","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"Definição de negociação","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"Antes da aquisição","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"Durante a aquisição","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"Depois da aquisição","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"Análise de tique-taques","8cf71374fa095a64b5295b672daef8507ec7be6a":"Indicadores","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"Ferramentas","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"Tempo","8d8fd6765e184419cad8b88d1a60c895d79578c2":"Vela","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"Diversos","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"Registro","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"Resumo","9feddbabd7e7309e96c590069057158e96baa8f6":"Verificação da realidade","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"A negociação de opções pode se tornar um verdadeiro vício, tal como qualquer outra atividade levada até ao limite. Para evitar os perigos de tal vício, fornecemos uma verificação de realidade que lhe proporciona um resumo de todas as suas negociações e conta regularmente.","4152043e8c670075d2c919677e835edb0d923cab":"Especifique o seu intervalo preferido, em minutos, para a verificação da realidade","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"Insira um número entre 10 e 60.","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"Continue a negociar","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"Extrato","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"Sair","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"Contate-nos","f7c400ed695f898b8ee9d21664aa17b5bb693828":"Conectar-se","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"Redefinir os blocos para o seu estado inicial","f98595d541778d86f75ef22b3328a031d20aa16b":"Carregar novos blocos (arquivo xml)","4a1e616226c329a94da7768bc0435a3284478010":"Salvar os blocos existentes (arquivo xml)","6b3465ace62f33f0687b4669ac26d95895e9ca52":"Conecte Binary Bot à sua conta do Google Drive para poder salvar e reutilizar os seus blocos com facilidade","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"Desfazer as alterações (Ctrl+Z)","937f5055f05be359ddf619744e8af4d643549e80":"Refazer as alterações (Ctrl+Shift+Z)","8406d1cce44230835932060649e999ca3283b413":"Ampliar (Ctrl + +)","1109673172af2c173c492622ff8a72c8f29f0e70":"Reduzir (Ctrl + -)","44c22002c65d2871331263a23c3e09c0a1bfd847":"Reorganizar verticalmente","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"Mostrar/Ocultar o pop-up do resumo","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"Reproduzir o bot","ba50a42d8d3228c37a817865fce49fbca692c2ad":"Parar o robô","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"Mostrar registro","91017ef9b165cd0e7475a770f318ea5e705e1321":"Mostrar gráfico","c89e3dd1cafcadcc0312e476ab58b2332209da23":"Mostrar vista de negociação","b02c858e72be118a65c9393930351012b647cb9e":"Ativar/Desativar cabeçalho","250be77f7605669a0b3d968b9ed381a3d9787ed1":"Abrir um arquivo XML já salvo e recuperar os seus blocos","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"Binary Bot","608061fb5aab975013fa70c5c814a1d8ba30c152":"Negocie de forma mais eficiente do que você alguma vez imaginou ser possível","e4ce8dc3e416e69262ba642dc57d3975d6616980":"Está interessado em automatizar as suas estratégias preferidas para a negociação de opções binárias?","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"O Binary bot é a nossa ferramenta de programação de ponta que lhe permite criar aplicativos de negociação com uma função simples","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"Invente qualquer número de robôs de negociação Binary, desde fórmulas simples a algoritmos complexos. Depois deixe-os negociar por você, mesmo enquanto dorme.","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"Comece a desenvolver um novo robô já","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"Precisa de mais assistência?","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"PRECISA DE AJUDA?","d635b53e59c9aad8c5d78458826beffb029b27bf":"Obrigado, responderemos dentro de 24 horas","a69a8fc21499d0fd85e87bab467699827547a5bc":"Digite uma URL de servidor válido","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"Mercado subjacente não está selecionado","50050f06645ad2743165b429a8f7deebd285fd63":"Tipo de contrato não está selecionado","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"Conecte-se","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"A duração deve ser um número inteiro positivo","4df6e872792d72aea8a2f6b831d00b554464da23":"Valor deve ser um número positivo","001e68df3a4b32a4d57148d9d407f44eee3b7436":"A vela atual não é válida","04f14ea7c92e0b2b5ae005c696245063ec641d66":"A lista de velas atual não é válida","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"tentar novamente em","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"Limite de taxa alcançado para","094628ce13fc0e78f07b697d1cc9421bb2edd666":"Solicitação falhou para","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"Não","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"Sim","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"extrato","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"preço de venda","50e72909992bdc37c7c07769d1b7efac5e52874c":"prêmio","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"lucro","c980b910204c7babdffe8ff3f7e755f30133383c":"tipo de contrato","a726c6955157f1b8b92f9932652434a7150f80f8":"preço de entrada","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"valor de entrada","3905be81561384dc8c43d6127c57ed1e0eb03b74":"string valor de entrada","7674920c033ca14277c577e19c037a6754d4fa80":"preço de saída","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"valor de saída","06ecea26625359f7dcf5ff5c47af6174ff815257":"string valor de saída","779455ee3bde8494d9629b353e17b19e92357ba8":"barreira","37a5301a88da334dc5afc5b63979daa0f3f45e68":"resultado","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"Ganho","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"Perda","563339f82447b4e758ad76d5a0b63b5698594fba":"Sobe","5c1ae82c29543ac887703776bf3da2c7dcce683d":"Desce","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"Sem alteração","ecb252044b5ea0f679ee78ec1a12904739e2904d":"string","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"número","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"verde","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"azul","96de5543d183d7de52ac5fa21c46fc811f673f89":"amarelo","78988010b890ce6f4d2136481f392787ec6d6106":"vermelho","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"Silencioso","cf84a98d6cf7f156862a08ba8236467b6f471004":"Anúncio","eee2facd669d1434848c24da5527b3e87d9a12d5":"Ganhou dinheiro","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"Trabalho feito","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"Erro","a3b1583d377f37ac20de7e089edfa0920a078e57":"Erro grave","66c8b6848eee629c4ac551bf2b5fa591571654be":"Sobe-Equivalentes","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"Desce-Equivalentes","062787aa328047e189774b3703d983b83938f6e9":"Acima","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"Abaixo","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"Toca","7d7932bcc2e262ae98cf09dc5445130fb3881769":"Não toca","a16814a48ec58c2e24ba224a80921a5c02361abe":"Termina dentro","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"Termina fora","534ec5da4e82ec419abc170e1a8448f55a01664f":"Fica dentro","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"Sai fora","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"Asiático acima","c098658ce3d3a258e4d155949a60072966b36db7":"Asiático abaixo","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"Combina","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"Difere","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"Par","dc28f5f3c65ec611f0f30022650d24382d27448e":"Ímpar","18a63f5512afb5573e5b44deba78d629f0635317":"Superior","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"Inferior","2155c8b38181dd2552e84a94049aacd33ef9c607":"Tick alto","1408cfd2b064b923f024fbe590e27db8282941a5":"Tick baixo","b86eb15dc4f13e4c2972de158d3038d9f657242f":"Redefinição - Compra","669a1f3d9a8f601a84da536cfdad1de4092b1926":"Redefinição - Venda","844d1a5c99a0a668383340cc095d040eef998c79":"Sempre acima","87293a146cd481a2b30cf74282ec061dc4cf0735":"Sempre abaixo","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"Abertura","b1a5954a483f8f8b0207385095f74aeb409b3f80":"Alta","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"Baixa","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"Fechamento","1173872a4fb205b713702f0eec5cf2c732c828fd":"Hora de abertura","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"Padrão","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"1 minuto","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"2 minutos","24e46784cbce32443db5a2638b1a7d3201543e9b":"3 minutos","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"5 minutos","a6f151883b736f0470d33492e61c72a7d059d065":"10 minutos","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"15 minutos","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"30 minutos","f030c3d667652646b86732ad7bc67e226c49cd3a":"1 hora","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"2 horas","7b47150d431db70d783724007f07ab894eb8ac2e":"4 horas","191800b7e9a48680792c0dd77cb6cac00c4514c6":"8 horas","2d8a6f7c34468578640b333b8650131de06ac770":"1 dia","cd1495cb4c60266a6abad9024022ae079bf7e416":"(1) Defina o contrato da sua negociação","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"(2) Acompanhe e compre o seu contrato","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"Opções de negociação","160f06d4799c85021a810f68c5b517eea37a2737":"Comprar","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"Acima/Abaixo","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"Igualdades Acima/Abaixo","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"Asiáticos","2260ce49306460c8a2ef501939f29ad6ddd4e934":"Dígitos","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"Toca/Não toca","f7de1f66f0979667da275b7e8996e805395025a1":"Termina Dentro/Fora","a431deecd4c2258097adae418d496fe9a8179fee":"Fica dentro/Sai fora","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"Ticks Altos/Baixos","12a3f461cdebbc8f335190413ee6c57442743bba":"Redefinição — Compra/Venda","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"Sempre acima/Sempre abaixo","91a64e3f83c91acf336c631fba295f297f94c399":"Executar-se após n segundos","024696596f26a4db232fd9e966eadfeb27c0bd1a":"Executar-se a cada n segundos","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"superior","85c274929bc0e28eafd3734f2c25046c3b95b36b":"do meio","346e3ee198e98146993894d3de8ecab1a86c3e80":"inferior","f16459104f92ab6b38aa265adb4ecbfc3768e303":"Histograma","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"MACD","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"Sinal","19eabc961735d78f12fc7be906ffcb033853cf85":"Carimbo de data/hora","68f4145fee7dde76afceb910165924ad14cf0d00":"Mensagem","e99811bd3b1ad17e74614060ecb180602be35ad6":"Desconectou você!","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"bloco deve ser adicionado ao espaço de trabalho","1fde9f1ebca07dcbc704130bd18645bce7718b55":"o bloco deve ser habilitado","d466687f90ba548434d65186d11a80c4204f9ad6":"deve ser adicionado dentro de:","629777b7d4d610ace6dee24442730f27d7d0853e":"Arquivo não é suportado:","0b93c14956403c2e5c9e79f5c836babc56912006":"O Binary Bot não executará novas negociações. Quaisquer negociações já executadas (mas não expiradas) serão concluídas pelo nosso sistema.","c1458ff86fd60d9544d7cd8a67437df2b766f482":"Nota: Consulte a página \"Extrato\" para obter detalhes sobre todas as transações confirmadas.","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"Quaisquer alterações não salvas serão perdidas.","410bf23a3f080def9c7a976a16305bcde7943ed1":"Tem certeza?","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"Infelizmente, Binary Bot não está disponível em seu país","901624741023fcfc805ce43c94b8012e3b1d1c99":"Deseja negociar CFDs na MT5? Você terá acesso a forex, ações, índices de ações, commodities, criptomoedas e sintéticos.","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"Estratégias","910ec7aa40b04ec6ba51162f4de7850569326cb6":"Houve um erro ao carregar o script API do Google.","8f51f350debde84e067e1a0405fb6304922a7d4b":"Houve um erro na inicialização do Google Drive.","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"Houve um erro ao carregar as bibliotecas do Google Drive","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"Conceda permissão para visualizar e gerenciar seus arquivos do Google Drive","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"Formato de arquivo não reconhecido","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"Houve um erro ao recuperar dados de Google Drive","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"Selecione uma estratégia do Binary Bot","2db43c69a4b96454914f0b8272bc869984529e6e":"Houve um erro ao listar arquivos de Google Drive","0dcea5f584938e0fff00084b83156ab31d641ab3":"Houve um erro ao recuperar arquivos de Google Drive","18da95988117ff029393f3f5c881d70ef47f7385":"Houve um erro ao processar o seu pedido","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"Selecione uma pasta","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"Não foi possível enviar esta notificação do Telegram","3f370309b6280eb100f898426d8605c1f45d558d":"Registro de data e hora inválido","af6a4e2a5582be89ac930e946eaed86e01cac58b":"Data/hora inválida","49d51398b574e7312d99b18d2b93d2ede416f053":"Não foi possível enviar o webhook","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"As propostas não estão prontas","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"A proposta selecionada não existe","6ea4a034747d020b1d8ce4848def95d537555dd6":"Comprado","89f89c02cf47e091e726a4e07b88af0966806897":"ID","1200c1af2f7bba4e29a34112865662748c9d41df":"Não permitimos a revenda deste contrato.","62d6180e55905f7b996d442c53631981a4ef8b5b":"Vendido por","ed4978867de1da05b336b724a3fb96222a29ebec":"Índice deve ser um número inteiro positivo","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"Valor do lucro","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"Valor da perda","46fc6f27a835486d63d9e927c6687e4508cb3087":"Número máximo de negociações atingido","9202ddae4cea16513e53bbc965d88ed975e59512":"Valor máximo de perdas atingido","5f52b397b7e5f538681f0f5717a88aa626349c7a":"Bot.init não foi chamado","66c7734789e19cbeef3a5ac185ea732139aed213":"Gráfico","3b662fb2e8bafce29aa98321b18874bb44905488":"Integração com Google Drive","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"Por favor, defina o seu limite de perdas diárias na página das Instalações de Auto-Exclusão para permitir a negociação.","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"Máximo de negociações consecutivas deve ser entre 1 e 100","93039e609d94a24f3572b794a31b21525a09af2b":"Não definido","a85b8cc112a8597df1612d60a74faa818c25d1b3":"Exigimos-lhe que estabeleça limitações comerciais em conformidade com os regulamentos comerciais. Note que o seu bot só cessará a sua actividade comercial se alguma ou ambas as condições abaixo forem cumpridas.","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"Limite diário de perdas:","95052a29f213e9698b593418fe396ecc21032f9b":"Este é o limiar que limita as suas perdas potenciais para o dia em todas as plataformas Binary.com. Uma vez que a sua perda total atinja ou exceda este montante, o seu bot deixará de negociar. Por favor, defina um valor na página {$0}Facilidades de auto-exclusão{$1}.","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"Máximo de negociações consecutivas","730657200c17321d926e1bd08dbf65bd96855a8a":"Este é o número máximo de negócios que permite que o seu bot execute para esta execução.","952f375412e89ff213a8aca383d18e5691354347":"Iniciar","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"Limitações de negociação","095ba68888b5ace5f4515f5acab76dfa1073544e":"Meu computador","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"Carregar","248e224f533752db28a1aab3519a58569ad96140":"Carregar blocos","c7097e97dcc446ca889d3ca6be733a65e2728afe":"Carregado com sucesso para o Google Drive","a6b977714595aa01678fca98e86553aaeac05c92":"Guarde os seus blocos individualmente numa colecção. Eles serão adicionados ao seu espaço de trabalho existente (os blocos principais serão substituídos) quando carregados.","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"Salvar como coleção","611ebbfb080284312904de925ef0f75f4cb56ad2":"Salvar os seus blocos e as suas configurações para reutiliação em outras estratégias","efc007a393f66cdb14d57d385822a3d9e36ef873":"Salvar","a638caa8ab2b7ff7980a571334217339e6d1d634":"Salvar blocos","39fca63515c105918f03e4908ec12df675b07f92":"Trading View","e643975ea5296d9de4486458f31ab0a5a2b228bf":"Isto irá limpar todas as transacções no painel de resumo, e todos os balcões serão zerados.","85dfa32c97d8618d1bea083609e2c8a29845abe5":"Conta","d847919a30d31c0be624087f3370492b3fdf80c6":"Nº de execuções","5cd6978d63540c8a490ef76f43219de6362f958e":"Aposta total","17410d7b62b8b1de981cfebada24632987edf186":"Prêmio total","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"Lucro/Perda total","90eef613042c5a51f542421065b68b886d473807":"Saldo","db1c784524e1b54011a95823026161f7c8517fe0":"Referência","4db3e9e4aecd187db9339a10d2629fef46724dc4":"Tipo de negociação","1bb4086b66659d8580f9be4beef69931aeea3cad":"Preço de entrada","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"Preço de saída","ba7be969e7c1bb5f22489e843478e3d721aaa843":"Preço de compra","772fbced18230220d2d9be1456be16fc1b271d25":"Lucro/Perda","bae7d5be70820ed56467bd9a63744e23b47bd711":"Status","96f608c16cef16caa06bf38901fb5f618a35a70b":"Pendente","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"Liquidado","82a82f798dd773717ec37d15fd4405510291734e":"O robô não está em execução.","6a88e58aa1798626f94cf17f1a91618b405bb289":"O bot está iniciando...","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"O robô está em execução...","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"O robô vai parar...","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"O robô parou.","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"Tentando comprar","4684ee1026d9b4c872d016c3c4588a0c479a451c":"Valor de compra","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"Compra bem-sucedida","f02760cd2eac28169f0a990c950c3dfe8427f772":"Contrato fechado","c7363d8a0748d4a7e2cc968335dc9716f290359d":"A paragem do bot impedirá novas trocas. Quaisquer negócios em curso serão completados pelo nosso sistema. Tenha em atenção que algumas transacções concluídas podem não ser exibidas na tabela se o bot for parado durante a colocação de transacções. Pode consultar a página de declaração do Binary.com para obter detalhes de todas as transacções concluídas.","fadc0ef93d1ff13370524ce8481ddc4a71195934":"Reorganizar verticalmente","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"Baixar","e4458464df6cbb8da1134875ba51519c5d244d9f":"Blocos devem estar dentro de contentores de blocos, blocos principais ou funções","e9c45563358e813f157ba81b33143542165ba84e":"Aviso","31cb6f44d030abeabcc7046555dea851602a87a5":"Esta estratégia não está disponível no seu país.","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"OK","9970168c192807246fad6138344e5a96449afbdd":"O arquivo XML está vazio. Por favor, verifique ou modifique o arquivo.","a594b427eaf0f108d3e9cc20d70e15da811c760c":"Estratégia não suportada","04a5090686ac7b54822e00a9ff08c38a107601e7":"Desculpe, esta estratégia não pode ser usada com o Binary Bot. Você pode usá-lo apenas com o DBot.","77dfd2135f4db726c47299bb55be26f7f4525a46":"Cancelar","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"Abrir o DBot","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"O arquivo que você está tentando abrir contém elementos não suportados no seguinte bloco: {$0} Por favor, verifique seu arquivo e tente novamente.","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"Não foi possível carregar o arquivo de bloco","af145748c9cf765a3b059eec20cb1dbb899297d8":"Os blocos foram carregados com sucesso","11ee9c5d534cc8d22651092222b532917594161a":"A duração mínima é","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"O número de tique-taques deve ser entre 5 e 10","ace1342bc3720b77ce510b93074041e7386d209e":"A hora de expiração não pode ser igual à hora de início","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"A previsão deve ser de um dígito","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"deve ser adicionado dentro","33aa6ff282ee509d37c6f758274c9156b419ff73":"A estratégia que você tentou importar é inválida.","da162a909c2981ed318d23cd9a6be1d66e0a8400":"Formato de arquivo não reconhecido.","5e719fa76e1b6cb396376c82ebdd04bec7253229":"Blocos remotos a serem carregados devem ser uma coleção.","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"Não foi possível carregar o arquivo de bloco.","df84a88f38b03b5b342362d72370b0d66afdae35":"O destino deve ser um arquivo xml","cd680fd936e9559ef1d95efac7a71680e2b13a89":"Este URL já foi carregado","34c59389053701a04127f74d32315e0206e076f8":"Ocorreu um erro ao tentar carregar o url","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"Certifique-se de que 'Access-Control-Allow-Origin' existe na resposta do servidor","988df856c066143616bd33d5904bbcdc22ff129e":"Binary.com está se mudando para Deriv","2fccaab15d71b00c19da7053135471d510b513db":"Negocie na Deriv","3ead0b14c72503187691a7a6d7121987299bd401":"Isto não é uma versão oficial do Binary Bot. Use por sua conta e risco.","27401c9c8e476d659c8382e05c6d70a4a82be468":"Versão oficial","bc981983e7f547dc62e19a1e383acfe00782a6d5":"Próximo","b52b36b7269fbfc58ec24bb724691951a3decbe8":"Voltar","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"Concluído","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"Faça uma rápida visita","a48e81d4a8da67637b46725824177a959fe99b21":"Pronto para aprender como usar o Binary Bot?","6f3e6ebf249947cec4f64117253a8fe43335ae79":"Não obrigado","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"Não me pergunte novamente.","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"Espaço de trabalho","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"Arraste e solte arquivos de bloco ou crie suas próprias estratégias.","d171baee235d4c93f63755a876782dc5be4c3e47":"Caixa de ferramentas de blocos","056f19272d96f902c38207cf163ea8dbff7fbd32":"Adicione mais blocos daqui ao seu bot.","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"Contas","f5c47fd3b3553b10441a06054078cea745177dea":"Conecte-se antes de iniciar o seu bot. Teste sempre as suas estratégias com a conta virtual.","fd825ae94aa79500a878dd4590a4b360e7162663":"Controles do bot","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"Controle os seus blocos. Mantenha o cursor sobre cada botão para ver mais informações.","f5169c84497de3aea74f7da9e7e177d1427e736b":"Divirta-se!","4f1b3d682c2a00b393c33637da402463bc11d5ff":"Deseja relatar um problema ou pedir ajuda?","0049f8894e41937ebb9111cd3def6749049fb50f":"Clique aqui","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"Onde encontrar o Binary Bot em Deriv","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"Na página inicial da Deriv, clique em Negocie no topo da página e escolha Binary Bot.","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"Experimente Binary Bot na Deriv","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"É o mesmo Binary Bot que você conhece e ama","169dd3b2025485a48b8f9f3f6ef89f5586714140":"Tudo está exatamente do jeito que você gosta.","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"Traga seus bots sem problemas","b763f8cbfa6396f195781032619a99bba04bc939":"Suas estratégias da Binary.com podem ser usadas na Deriv. Basta carregar seus arquivos XML e começar a negociar.","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"7 plataformas de negociação - antigas e novas também","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"Você encontrará Binary Bot e SmartTrader ao lado de novas plataformas como DBot e DTrader. Qualquer que seja seu estilo de negociação, nós temos a plataforma para você.","0ce7480da93c1c9839818d0720b77931d1637574":"Depósitos de criptomoedas via fiat on-ramp","6e6a4c6839d2e859758a517865b095c1b8298dd6":"Faça depósitos de criptomoedas facilmente através de serviços de troca como Changelly, Banxa e XanPool.","c1b51f196c97b4781a354457579e9699b09de087":"3 tipos de negociações","4708f7e87263464b130b987e4b9aed981c4f455d":"Negocie CFDs, opções digitais e multiplicadores, um novo e excitante tipo de negociação que impulsiona seus potenciais de lucros com risco limitado.","b7fceac7d5f885d735aeda6e4654487467d33fa3":"Depósitos e saques entre traders","79a206119137878eb6be7c60f7ed34135194bdf0":"Troque sua moeda local com outros colegas negociantes para obter fundos ou retirar de sua conta com o Deriv P2P.","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"6 tipos de mercados","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"Expanda seu portfólio com uma ampla gama de mercados como forex, ações, criptomoedas, sintéticos e muito mais.","14b2a808fdec3702e5a6b9152e13288c87a4768a":"Aprenda com a Deriv Academy","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"Aproveite os artigos e vídeos de cortesia para ajudá-lo a aprender o básico da negociação on-line.","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"Clique para selecionar","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"Não disponível","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"Tique-taques","5fb1db527825d2996e37c655e5dec49d4da80c09":"Segundos","092f99ea11a34a8490e7a767a83a42fc45634f82":"Minutos","9e25a34e635a123f8958bbe26e7c4843278597fb":"Horas","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"Dias","db6708630fc646eb98298d9acd701e0a1ac051c2":"Salvar os seus blocos e as suas estratégias no Google Drive","85538d002a336c5addef8d189d80976cf7758f8c":"Você está conectado como","b65463cb6a42a17de514acc4659f7fd331e0876a":"Conectar-se","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"Desconectar-se","cd5f85b6f187605f82386eacd680f93820af8d11":"O resultado é","1e38ce3d180cefae485a6986ca7c67841e30376f":"Verdadeiro se o resultado corresponder à seleção","5c89497fc3c128e2ff865ce8df15356054f2c028":"(4) Receba o resultado da sua negociação e negocie novamente","14ea81918758c994cbe3178e695e56afc1ef2b45":"Receba as informações e o resultado da última negociação e depois negocie novamente (Executa-se no final da negociação)","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"Dado do contrato:","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"Lê uma opção selecionada da lista de dados do contrato","b3b543c80063a116ced4965d8537b7b62d14c0b7":"Negocie novamente","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"Executa o bloco de negociação novamente","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"Preço de venda","343fda69c73b78b84967055aae97f790c422adfd":"Preço de venda da proposta selecionada","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"Acompanhe o fluxo de tique-taques e compre o contrato desejado (Executa-se na atualização dos tique-taques)","9bb396940adb9705fe57eba6ea8b578e6aafa792":"Prêmio","87da93a46d143f6019979b3548414d9d7adabb35":"Prêmio da proposta selecionada","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"Compra um contrato selecionado.","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"Venda disponível","03bad10717e183b24829baf483dc715e1a44bf7b":"Verdadeiro se venda no mercado estiver disponível","2c71ed279a402e93312dbda173ab18f244d6bf46":"(3) Acompanhe e venda o seu contrato adquirido","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"Acompanhe as informações do contrato adquirido e venda no mercado caso disponível (Executa-se na atualização do contrato)","579607dc4f989ce2b94b558431666a0ab07ac1f3":"Vender no mercado","e20afd5cf3811a42071c9a312abb2afdad4c590b":"Vender no mercado.","4712cbff8e92822fc960ef9c0197293a19675eae":"Vender lucro/perda","df817b48c7a076561b4f8bedc52d65d2e351ab52":"Retorna o lucro de vender no mercado.","b44e884c355e447d0da0e6ba45caaff18c84373b":"Bandas de Bollinger","d6a2a207343bd83aacdc80b579ff4419713a256e":"Lista de entradas","170a28a9db6d27d7212fc6dc249434a57517e7bc":"Período","b833989d69900a4be9e32d1bab65c8f8233f099e":"Multiplicador de desvio padrão para cima","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"Multiplicador de desvio padrão para baixo","974da601086448d0060aeed90e53ddd5acd17b91":"Calcula Bandas de Bollinger (BB) a partir de uma lista com um período","d5b65cac1f1cf9421ac978eebe532de99040cca6":"Série de Bandas de Bollinger","58de49791c64aba14e36e5887244a5ef088286cd":"Calcula Bandas de Bollinger (BB) a partir de uma lista com um período","4bd99f76f1104229744455d93df0ff76b9eeed58":"Média Móvel Exponencial","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"Calcula uma Média Móvel Exponencial (EMA - Exponential Moving Average) a partir de uma lista com um período","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"Série de média móvel exponencial","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"Calcula uma lista de Médias Móveis Exponenciais (EMA - Exponential Moving Average) a partir de uma lista de valores com um período","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"Série MACD","b18e572ea14edd48587145f1ef50718adbf256c6":"Período de rápida MME","974023bddd6249d0f6404872cfcae205b2599ea2":"Período de lenta MME","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"Período de sinalização de MME","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"Calcula a lista de Convergência e Divergência de Médias Móveis (MACD - Moving Average Convergence / Divergence) a partir de uma lista","95ec92885c855ba9cf734c17a43f081901e4d2cc":"Índice de Força Relativa","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"Índice de Força Relativa (RSI) de uma lista com um período","4034de66995b876b2ba9bfd0274025e39168e05d":"Série do Índice de Força Relativa","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"Calcula a lista do Índice de Força Relativa (RSI) de uma lista de valores com um período","a9842c95766da40bf4ea6ee263cb5a5985847763":"Média Móvel Simples","347775a293c14362d492f019e677c965be1d6e7d":"Calcula uma Média Móvel Simples (SMA - Simple Moving Average) a partir de uma lista com um período","4cc7b9e53d082896ad884eb01be16320af65f282":"Série de Médias Móveis Simples","2c75179a57af3c36581008b65e86ed81c4a4cbea":"Calcula uma lista de Médias Móveis Simples (SMA - Simple Moving Average) a partir de uma lista de valores dentro de um período de tempo","39f024cf49724fe7ffdea7773c72ed06eec998e1":"com intervalo","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"Direção é","ad47561efb1dcbd7246d9b64487f615647fda036":"Verdadeiro se a direção combina com a seleção","05bef508aadd62bf3967dcf67d769da296f19989":"Direção dos tique-taques","21bfc78607d3a64de767a6677d1db42156d5039d":"Devolve a direção dos tique-taques recebida por um bloco de pré-compra, o seu valor pode ser \"acima\" se o seu valor for superior ao anterior, \"abaixo\" se for inferior ao anterior e vazio (\") se o tique-taque for igual ao anterior","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"Bloco de direção foi preterido, por favor, use a verificação de bloco de direção em vez","cdb31fc857f01a59f664413498293c714285f46d":"na lista de velas","20fd5f86f08796f145d69dedc209a27e459b2f51":"obter n.º do fim","a96606af8c33ac3428b45abc4782dbf93f458d29":"Obter a n-ésima vela mais recente","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"Lista de últimos dígitos","248428facb97408414180d4de74e4db35360fbc4":"Retorna a lista de valores de últimos dígitos","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"Último dígito","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"Devolve o último dígito do tique-taque mais recente","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"Lista de velas","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"Devolve a lista de velas","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"Fazer lista de","a4220593d385a720886f7af1ed3c478fd0c6339c":"valores na lista de velas","cd8cdf3d47e921c8a72addae9269e66041d417c5":"Devolve uma lista de valores das velas selecionadas","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"Ler na lista de velas ","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"N.º do fim","aba43a580daa7f306956ec69b83e6e37e7233126":"Ler o valor da vela selecionada na enésima vela mais recente","e04b522218a181cf0223042dd18ae08dcc22d8d3":"Último tique-taque","6ee445fc253a55c9ed54c009c3f020ac65200d80":"Devolve o valor do tique-taque recebido por um bloco de pré-compra","ed44b69176217a1251c04f0c13d23ac789ea60b2":"String Último Tique-Taque","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"Retorna o valor do tique-taque recebido por um bloco antes da compra (String)","4b2340a890e88d1886757c3f7172e273a1edc31f":"Este bloco é chamado em todos os tique-taques","b54d7b4590559dad64f02d09aacbf6d9863e2624":"É possível usar este bloco para analisar os tique-taques, independentemente das suas negociações","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"Lista de tique-taques","17649cac8739adcae95e641f794880272ad33bd1":"Devolve a lista de valores de tique-taques","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"Lista String Tique-Taques","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"Retorna a lista de valores de tique-taques (String)","c67ded6b64019212eb2bc69afd761f5b3f626040":"Adicionar sinal a um número para criar uma deslocação de barreira.","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"Mercado","74751e67c3e1010c343095eaf543e7cb21ced2ef":"Tipo de negociação","1f4698382842477e211eb46de81fa506f01a8c34":"Ambos","c1baf816aac5a5cd849768773fc248cd249dc296":"Tipo de contrato:","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"Intervalo padrão de velas:","9693aeaaf68e3929b59b79306feaa0a847d01192":"Duração:","78d7103a319e808455d397513279d99f3b3f3768":"Aposta","10c02649e226d430bd75a5b6315a41c0db9992a2":"Barreira","837276742aa90209dde3b4eef07d8e7ab26731ef":"Previsão","258b49925b41751c6bd790a0848246566ba61440":"Reiniciar compra/venda no caso de erro","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"desativar para melhor desempenho","b410994b67e37d9516eb9b866c85a8c639f79e68":"Reiniciar última negociação em caso de erro","2260c5a971c2602834ef8feeb5fa522f900b469f":"robô ignora a negociação mal-sucedida","0745acf92abd7b60598f161717884cc45dab8694":"Executar uma vez ao iniciar","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"Definir opções de negociação","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"Defina o contrato da sua negociação e inicie a negociação. Adicione inicializações aqui. (Executa-se ao iniciar)","4d22b565e4253e92a908f216184779679bb1a044":"Barreira alta","b70c38c6db3127422e05315c30bdf76c7c36c480":"Barreira baixa","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"Absoluto","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"Saldo:","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"Obter número do saldo ou o string","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"Os blocos no interior são ignorados","d072c2ceeb5c1217722d14c74de7aeab945b4215":"Coloque os seus blocos aqui dentro para prevenir que sejam removidos","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"Chave: %1 Valor: %2","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"Retorna uma representação de string de um par de valores-chave","b06acc4158c824231f727a13e1c9811f43d5be42":"Carregar blocos de","661db37251a1ed1afe357ee13895f37a623d7cbf":"Carregar blocos da Url","6c03ee54ad3a51fc92a1d69943e99667847705b6":"Notificar","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"com som","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"Cria notificação","6e0fc122f936f808bc2e3af661121b65712ae855":"Notificar Telegram %1 Token de acesso: %2 ID de chat: %3 Mensagem: %4","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"Enviar mensagem ao Telegram","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"Lucro total","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"Devolve o lucro total","532e65f6e266db0bb442d1f426d44d7d32962340":"String Lucro Total","78e84591ff76f992953a8e19b57c7eab7546d638":"Retorna o lucro total (String)","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"N.º de execuções","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"Devolve o número de execuções desde o início","7d500ebe352ccfa932b253e21938813a06fcff8e":"Webhook URL: %1","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"Envia uma solicitação POST para uma URL","a35646754dbe7a9211ba8b81338a5d64580eb276":"Carga útil vazia","69b0648eddd207cd45a9e1ba973dae287b535576":"Carga útil:","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"a vela é preta?","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"Verifique se a determinada vela é preta, devolverá a resposta \"verdadeiro\" se o fecho for inferior à abertura na determinada vela.","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"Faze lista de","5925d08228e246f07b790b88ad70c1b73a97d2bc":"valores da lista de velas","852b438f91ad9eb2cdd84419a675a216d543c687":"Ler","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"valor na vela","d79d854dcd0829e2177a47beab6a55569e781ab1":"Leia um campo numa vela (ler da lista de velas)","5606b4460ac96063b8a8e5647008f3ec97252fc5":"Segundos desde o epoch","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"Devolve o horário epoch (segundos desde o epoch)","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"Executar a cada","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"Segundo(s)","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"Executar os blocos no interior a cada n segundos","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"Bloco executar a cada segunda foi preterido. Contate-nos caso tenha um válido caso para uso.","7b9c76088576a64f32d67ec335162b9f73eaa026":"Executar depois de","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"Executar os blocos no interior após n segundos","e9fb732dde76a6977bcaa2818b0f56125b183648":"Até a Data/Hora","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"Converte um número de segundos desde a época numa cadeia que representa a data e a hora. Exemplo: 1546347825 será convertido para 2019-01-01 21:03:45.","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"Para Timestamp","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"Converte uma sequência que representa uma sequência de data/hora em segundos desde a Epoch. Exemplo: 2019-01-01 21:03:45 GMT +0800 será convertido em 1546347825. Horário e fuso horário é opcional.","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"Comece a usar Deriv com seu e-mail e senha Binary.com.","64f72129852fb7bdff0725c71324a012630f53bf":"Dentro da UE, os produtos financeiros são oferecidos pela Binary Investments (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, regulamentada como um provedor de serviços de investimento de categoria 3 pela Malta Financial Services Authority (Licença{$0} nº IS/70156{$1}).","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"Fora da UE, os produtos financeiros são oferecidos pela Binary (SVG) Ltd, Hinds Building, Kingstown, São Vicente e Granadinas; Binary (V) Ltd, Govant Building, Port Vila, PO Box 1276, Vanuatu, regulamentado pela Vanuatu Financial Services Commission ({$0}ver licença{$1}); Binary (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, Ilhas Virgens Britânicas, regulamentada pela Comissão de Serviços Financeiros das Ilhas Virgens Britânicas (licença{$2} nº SIBA/L/18/1114{$3}); e Binary (FX) Ltd., Lote No. F16, Primeiro Andar, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malásia, regulamentada pela Labuan Financial Services Authority para conduzir um negócio de corretagem de dinheiro (licença{$4} no. MB/18/0024{$5}).","10dd345bc3319e2151794428b2c709dc5fc381a7":"Os serviços deste site não são disponibilizados em determinados países, como os EUA, Canadá, Hong Kong, Japão, nem a quaisquer pessoas com idade inferior a 18 anos.","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"Aviso de Risco","ad0fc99c05681528248b73007dba16fd760a81c6":"Os produtos disponibilizados através deste site incluem opções binárias, contratos por diferenças (\"CFDs\") e outros derivados complexos. A negociação de opções binárias pode não ser adequada para todos. A negociação de CFDs implica um elevado grau de risco, uma vez que a alavancagem pode trabalhar tanto para a sua vantagem como para a sua desvantagem. Como resultado, os produtos disponibilizados neste site podem não ser adequados para todo o tipo de investidor, devido ao risco de se perder todo o capital investido. Nunca se deve investir dinheiro que precisa e nunca se deve negociar com dinheiro emprestado. Antes de negociar os complexos produtos disponibilizados, certifique-se de que compreenda os riscos envolvidos e aprenda mais sobre a {$0}negociação responsável{$1}.","1fda2716eb92e0195ff59b110af23d86b43fd909":"Na União Europeia, os produtos financeiros são disponibilizados pela Binary Investments (Europe) Ltd, W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, licenciada e regulamentada como um fornecedor de Serviços de Investimento de Categoria 3 pela Autoridade de Serviços Financeiros (licença n. º IS/70156).","be7786af641b859c03ec152461d791480cf676ed":"Na Ilha de Man e no Reino Unido, os índices Volatility são disponibilizados pela Binary (IOM) Ltd., First Floor, Millennium House, Victoria Road, Douglas, IM2 4RW, Ilha de Man, Ilhas Britânicas, licenciada e regulamentada, respectivamente, pela (1) Comissão de Supervisão de Jogos de Azar na Ilha de Man (licença atual emitida a 31 de agosto de 2017) e pela (2) Comissão de Jogos de Azar no Reino Unido (licença com {$0}referência n.º: 39172{$1}).","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"No resto da UE, os índices Volatility são disponibilizados pela Binary (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta; licenciada e regulamentada (1) Autoridade de Jogos de Malta (licença n. º MGA/B2C/102/2000 emitida a 01 de agosto de 2018), para clientes do Reino Unido pela (2) Comissão de Jogos de Azar do Reino Unido (licença com {$0}referência n. º: 39495{$1}) e para clientes irlandeses pelo (3) Departamento de Impostos da Irlanda (licença de casa de apostas remota n. º: 1010285 emitida a 1 de julho de 2017). Ver {$2}informações regulamentares{$1} completas.","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"A Binary.com é um premiado provedor de negociações online que ajuda os seus clientes a negociar em mercados financeiros através de opções binárias e CFDs. A negociação de opções binárias e CFDs em índices Volatility classifica-se como uma atividade de jogo. Não se esqueça que os jogos podem ser viciantes – jogue responsavelmente. Aprenda mais sobre a {$0}Negociação Responsável{$1}. Alguns produtos não estão disponíveis em todos os países. Os serviços deste site não são disponibilizados em determinados países como os EUA, Canadá, Hong Kong ou a pessoas com idade inferior a 18 anos.","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"A negociação de opções binárias pode não ser adequada para todos. Portanto, certifique-se de que compreenda totalmente os riscos envolvidos. As suas perdas podem exceder o seu depósito inicial e você não deterá nem possuirá interesses no ativo subjacente.","496a99878841de69368c33af9e88eb37c0da5712":"CFDs são instrumentos complexos e implicam um elevado risco de perda rápida de dinheiro devido à alavancagem. 78.6% das contas de investidores particulares perdem dinheiro quando negociam CFDs. Você deve pensar bem sobre se compreende como funcionam os CFDs e se pode arriscar de perder todo o seu dinheiro.","a726d863bbdceba7b06a1083026a53db76de47b7":"Negocie multiplicadores","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"Amplie seu lucro potencial sem arriscar mais do que seu valor de entrada.","febe8aef26fb3017be5bf43d66f7972731c20833":"Pagamentos peer-to-peer","a8c1114d1c88db12afa05b331188ceb77afad6e3":"Índices crash/boom","d29324705a18a81ffc0376f3f37639a68827f3e6":"Preveja e potencialmente ganhe com picos e quedas emocionantes. Disponível apenas com multiplicadores na DTrader.","ba2098a209e375402a0cf222cec87cce26440767":"Exclusivamente na Deriv","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"Há um futuro brilhante pela frente.","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"Encontre esses recursos extras e muito mais na Deriv:","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"Confira","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"SmartTrader","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"Nossa plataforma clássica de negociação de opções","64dfd7424a05133b74cfb93fcbe385ede6539855":"Nossa plataforma clássica de negociação automatizada","824d76b124e6289f372e2ff6bcba91e8939343bd":"Saiba mais","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"Deriv MT5","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"A mundialmente famosa plataforma de negociação de CFD","54617a018fc6dffb3a70627b97f0db5c52a4081d":"DTrader","dbcd68f389d64fc531a650652c87b7d83fc82d94":"Nossa principal plataforma de negociação de opções e multiplicadores","dd69c213333a751a0ab3bc9ce6368588bf971b61":"DBot","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"Nossa plataforma de negociação automatizada de próxima geração","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"Deriv GO","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"Opere de qualquer lugar com nossa plataforma de negociação móvel","f63714db18c58c6b4a7a7bad09178faaeca05104":"Deriv X","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"Nossa plataforma de negociação de CFD personalizável","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"Tudo o que você adora na Binary.com e muito mais","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"7 plataformas à sua escolha","029582bad299ab8f44c57b961210e56569efd536":"Você encontrará SmartTrader e Binary Bot ao lado de novas plataformas como DTrader e Deriv X. Seja qual for o seu estilo de negociação, nós temos a plataforma para você.","9a07439b57e510e8e33b372aad2c360dbc39e79c":"Negocie CFDs, opções digitais e multiplicadores, um novo tipo de negociação empolgante que aumenta seus lucros potenciais com risco limitado.","3d0be0e8eb736257254698ba821c45389e385f1e":"Depósitos de criptomoedas via fiat on-ramp","c4303d30e60f01fa922400e52df4e96d71b35d6e":"Mais de 100 instrumentos","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"Negocie o que você quiser - forex, commodities, ações, índices de ações e índices sintéticos. ","f30ce7459f29851b219b504216581bf3d3446de0":"Suporte quando você precisa","6df6091514ee13992a3ac28445af1d9a1afbcb67":"Obtenha suporte ao cliente 24 horas por dia e acesso à Central de Ajuda.","92c8b7b779e7cf179b89484285fd766274b3bf1f":"Explore Deriv agora","a87a92c5ce4925186a081cf4478639fcc31b12ed":"Na UE, produtos financeiros são oferecidos pela Deriv Investments (Europe) Limited, W Business Centre, Level 3, Triq Dun Karm, Birkirkara BKR 9033, Malta, licenciada em Malta ","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"(licença n. IS/70156)","720280451c98ceeb796f3c7fa118813fc8da694d":"e regulamentada pela Autoridade de Serviços Financeiros de Malta, Triq l-Imdina, Zona 1, Distrito Comercial Central, Birkirkara CBD 1010, Malta, sob a Lei de Serviços de Investimentos. Autorizada pela Autoridade de Conduta Financeira e com a permissão considerada variável. Sujeito à regulamentação da Autoridade de Conduta Financeira. A natureza e extensão das proteções ao consumidor podem ser diferentes daquelas para empresas sediadas no Reino Unido. Detalhes do Regime de Contratos de Serviços Financeiros, que permite que empresas sediadas na EEA operem no Reino Unido por um período limitado para realizar atividades necessárias para a execução de contratos pré-existentes, estão disponíveis no website da Autoridade de Conduta Financeira.","0f1dda628bebb4748de6df05fa3bff4989c1b476":"Fora da UE, os produtos financeiros são oferecidos pelas seguintes empresas: Deriv (FX) Ltd, F16, Level 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malásia, licenciada pela Labuan Financial Services Authority ","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"(licença n. MB/18/0024);","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"Deriv (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, Ilhas Virgens Britânicas, licenciada pela Comissão de Serviços Financeiros das Ilhas Virgens Britânicas ","a56aa088dfea506d5dbe18f385c29418f771a639":"(licença n.SIBA/L/18/1114);","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":" Deriv (V) Ltd, 1276, Kumul Highway, Port Vila, Vanuatu, licenciada e regulamentada pela Vanuatu Financial Services Commission; e Deriv (SVG) LLC, Hinds Buildings, Kingstown, St.","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"Deriv Limited - 13 Castle Street, St. Helier, JE2 3BT, Jersey - é a empresa holding das subsidiárias acima.","74e8fa69aad80f93303a7723e5a304f3d43560b6":"Os serviços deste website não estão disponíveis em certos países, incluindo os EUA, Canadá e Hong Kong, ou para pessoas abaixo de 18 anos.","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"Os CFDs são considerados derivativos complexos e podem não ser adequados para clientes de varejo. Os CFDs são instrumentos complexos e vêm com um alto risco de perder dinheiro rapidamente devido à alavancagem. Você deve considerar se compreende como funcionam os CFDs e se pode arcar com o alto risco de perder seu dinheiro. Os produtos aqui mencionados podem ser afetados por mudanças nas taxas de câmbio de moedas. Se você investir nesses produtos, poderá perder parte ou a totalidade de seu investimento, e o valor de seu investimento poderá flutuar. Você nunca deve investir dinheiro que não pode perder e nunca deve negociar com dinheiro emprestado.","5bb3f3499158dbe30af5c725694b321dfe821433":"Antes de negociar os complexos produtos financeiros oferecidos, certifique-se de compreender os riscos envolvidos e aprender sobre ","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"Negociação segura e responsável.","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"Estamos nos mudando!","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"Nós fomos","991753597fde70aab5791de6d50ee8cc49a0bdcc":" Binary.com","efa99ab039a285c6264580bea691a4ffefcbeee7":" por 2 décadas e é hora de um novo capítulo empolgante.","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"Diga oi para nossa nova casa,","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":" Deriv.","52b8454dc755419beeff2f90cd0fc91def428244":"Olá Deriv!","27ad1d8334221366694c7acdd70fb380857d1e6e":"Talvez mais tarde","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"Leve-me para Deriv","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"É tão fácil mudar para Deriv","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"Basta fazer o login usando suas credenciais Binary.com. Não é necessário cadastrar-se.","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"Experimente","63fbf7977349e32e4a124ffa047549b720806d73":"Leve a Deriv com você","03d42257a2263b2841b9e0ae4b94de117228a33a":"Obtenha o aplicativo móvel Deriv GO e negocie de qualquer lugar. Nunca mais perca oportunidades valiosas.","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"Digitalize este código QR para baixar o Deriv GO","6b7499b1513a3cec3da3ff07cdad9b358954021e":"Não espere mais","b23efda40ddeb801beeebf915669d806744014af":"Tecnologia para suas negociações. Venha para Deriv agora.","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"Entre na experiência Deriv","34075438f939258908cc21d28bf59ab5126dc2d6":"Venha para Deriv agora e garanta tecnologia para suas negociações.","e669443b63757b5ad8571e52393caf2a0a812be3":"6 razões pelas quais você vai adorar Deriv","2c141583afaaa12438b16ee67355c6e3eaf77763":"Binary Bot tem um novo lar","4e0e045da59b385138ced3203cdb81c3b4cdd135":"Fomos Binary.com por 2 décadas e está na hora de um novo capítulo excitante. Seu construtor de bot favorito, Binary Bot, está agora na Deriv, nossa nova casa. Venha dar uma olhada.","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"Leve-me ao Binary Bot na Deriv","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"Use o Binary Bot na Deriv, nossa nova casa","1071c645f523394b408a6d285e95331bc583f14c":"Em 5 minutos, mostraremos a você os benefícios de negociar com o Binary Bot na Deriv. Se você ignorar esta mensagem, nós o lembraremos novamente em 3 semanas.","be43a8989c5745ec7386ca7c69442165f55dee8e":"Mostre-me os benefícios agora","074603c9aef93515ed33d179e982c67ea7abdb45":"Negocie com o Binary Bot na Deriv"}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"Lógica","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"Matemáticas","c3328c39b0e29f78e9ff45db674248b1d245887d":"Texto","4d064726954a17487f94e931f5b157b733ec22ed":"Avanzado","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"Lista","19de69cb601f53a4ea7af22a65c71ae63251365c":"Variable","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"Funciones","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"Loop","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"Binary","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"Definición de la operación","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"Antes de la compra","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"Durante la compra","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"Después de la compra","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"Análisis de los ticks","8cf71374fa095a64b5295b672daef8507ec7be6a":"Indicadores","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"Herramientas","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"Tiempo","8d8fd6765e184419cad8b88d1a60c895d79578c2":"Vela","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"Misc.","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"Log","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"Resumen","9feddbabd7e7309e96c590069057158e96baa8f6":"Verificación de realidad","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"El comercio con opciones binarias puede convertirse en una adicción real, al igual que cualquier otra actividad llevada al extremo. Para evitar el peligro de una adicción así, le ofrecemos una verificación de realidad que le da un resumen de sus transacciones y cuentas de forma regular.","4152043e8c670075d2c919677e835edb0d923cab":"Por favor indique su intervalo de verificación de realidad preferido en minutos","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"Por favor, introduzca un número entre 10 y 60.","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"Seguir operando","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"Extracto","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"Cerrar sesión","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"Contáctenos","f7c400ed695f898b8ee9d21664aa17b5bb693828":"Iniciar sesión","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"Restablecer los bloques a su estado inicial","f98595d541778d86f75ef22b3328a031d20aa16b":"Cargar nuevos bloques (archivo xml)","4a1e616226c329a94da7768bc0435a3284478010":"Guardar los bloques existentes (archivo xml)","6b3465ace62f33f0687b4669ac26d95895e9ca52":"Conectar Binary Bot a su Google Drive para guardar y reutilizar sus bloques fácilmente","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"Deshacer los cambios (Ctrl + Z)","937f5055f05be359ddf619744e8af4d643549e80":"Rehacer los cambios (Ctrl + Shift + Z)","8406d1cce44230835932060649e999ca3283b413":"Zoom In (Ctrl + +)","1109673172af2c173c492622ff8a72c8f29f0e70":"Zoom Out (Ctrl + -)","44c22002c65d2871331263a23c3e09c0a1bfd847":"Reorganizar verticalmente","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"Mostrar / ocultar el resumen emergente","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"Ejecutar el bot","ba50a42d8d3228c37a817865fce49fbca692c2ad":"Detener el bot","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"Mostrar log","91017ef9b165cd0e7475a770f318ea5e705e1321":"Mostrar gráfico","c89e3dd1cafcadcc0312e476ab58b2332209da23":"Mostrar Trading View","b02c858e72be118a65c9393930351012b647cb9e":"Ocultar encabezado","250be77f7605669a0b3d968b9ed381a3d9787ed1":"Abra un archivo XML ya guardado y recupere sus bloques","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"Binary Bot","608061fb5aab975013fa70c5c814a1d8ba30c152":"Opere más eficientemente de lo que jamás pensó posible","e4ce8dc3e416e69262ba642dc57d3975d6616980":"¿Interesado en automatizar sus estrategias preferidas para operar opciones binarias?","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"Binary Bot es nuestra herramienta de programación de vanguardia que le permite crear aplicaciones de operaciones con un simple","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"Cree un sinfín de bots de operaciones de opciones binarias, desde fórmulas increíblemente sencillas hasta algoritmos altamente complejos. Luego deje que operen por usted, incluso mientras duerme.","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"Comience a construir un bot ahora","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"¿Necesita más ayuda?","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"¿NECESITA AYUDA?","d635b53e59c9aad8c5d78458826beffb029b27bf":"Gracias, le responderemos en 24 horas","a69a8fc21499d0fd85e87bab467699827547a5bc":"Por favor ingrese una URL de servidor válida","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"No ha seleccionado el mercado subyacente","50050f06645ad2743165b429a8f7deebd285fd63":"No ha seleccionado el tipo de contrato","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"Por favor, inicie sesión","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"La duración debe ser un número entero positivo","4df6e872792d72aea8a2f6b831d00b554464da23":"El importe debe ser un número positivo","001e68df3a4b32a4d57148d9d407f44eee3b7436":"La vela actual no es válida","04f14ea7c92e0b2b5ae005c696245063ec641d66":"La lista actual de velas no es válida","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"reintentar en","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"Límite de tasa alcanzado para","094628ce13fc0e78f07b697d1cc9421bb2edd666":"Error en la solicitud para","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"No","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"Sí","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"extracto","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"precio de venta","50e72909992bdc37c7c07769d1b7efac5e52874c":"pago","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"ganancia","c980b910204c7babdffe8ff3f7e755f30133383c":"tipo de contrato","a726c6955157f1b8b92f9932652434a7150f80f8":"punto de entrada","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"valor de entrada","3905be81561384dc8c43d6127c57ed1e0eb03b74":"cadena de valor de entrada","7674920c033ca14277c577e19c037a6754d4fa80":"punto de salida","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"valor de salida","06ecea26625359f7dcf5ff5c47af6174ff815257":"cadena de valor de salida","779455ee3bde8494d9629b353e17b19e92357ba8":"barrera","37a5301a88da334dc5afc5b63979daa0f3f45e68":"resultado","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"Ganar","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"Pérdida","563339f82447b4e758ad76d5a0b63b5698594fba":"Alza","5c1ae82c29543ac887703776bf3da2c7dcce683d":"Baja","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"Sin cambios","ecb252044b5ea0f679ee78ec1a12904739e2904d":"cadena","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"número","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"verde","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"azul","96de5543d183d7de52ac5fa21c46fc811f673f89":"amarillo","78988010b890ce6f4d2136481f392787ec6d6106":"rojo","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"Silencioso","cf84a98d6cf7f156862a08ba8236467b6f471004":"Anuncio","eee2facd669d1434848c24da5527b3e87d9a12d5":"Dinero ganado","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"Operación finalizada","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"Error","a3b1583d377f37ac20de7e089edfa0920a078e57":"Error grave","66c8b6848eee629c4ac551bf2b5fa591571654be":"Rise Equals","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"Fall Equals","062787aa328047e189774b3703d983b83938f6e9":"Más alto","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"Inferior","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"Tocar","7d7932bcc2e262ae98cf09dc5445130fb3881769":"No tocar","a16814a48ec58c2e24ba224a80921a5c02361abe":"Finaliza Dentro","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"Finaliza Fuera","534ec5da4e82ec419abc170e1a8448f55a01664f":"Permanece Dentro","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"Sale","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"Asiáticas arriba","c098658ce3d3a258e4d155949a60072966b36db7":"Asiáticas abajo","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"Iguales","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"Diferentes","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"Par","dc28f5f3c65ec611f0f30022650d24382d27448e":"Impar","18a63f5512afb5573e5b44deba78d629f0635317":"Encima","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"Debajo","2155c8b38181dd2552e84a94049aacd33ef9c607":"Tick alto","1408cfd2b064b923f024fbe590e27db8282941a5":"Tick bajo","b86eb15dc4f13e4c2972de158d3038d9f657242f":"Reset Call","669a1f3d9a8f601a84da536cfdad1de4092b1926":"Reset Put","844d1a5c99a0a668383340cc095d040eef998c79":"Solo Arriba","87293a146cd481a2b30cf74282ec061dc4cf0735":"Solo Abajo","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"Abierto","b1a5954a483f8f8b0207385095f74aeb409b3f80":"Alto","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"Bajo","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"Cerrar","1173872a4fb205b713702f0eec5cf2c732c828fd":"Hora de apertura","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"Predeterminado","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"1 minuto","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"2 minutos","24e46784cbce32443db5a2638b1a7d3201543e9b":"3 minutos","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"5 minutos","a6f151883b736f0470d33492e61c72a7d059d065":"10 minutos","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"15 minutos","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"30 minutos","f030c3d667652646b86732ad7bc67e226c49cd3a":"1 hora","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"2 horas","7b47150d431db70d783724007f07ab894eb8ac2e":"4 horas","191800b7e9a48680792c0dd77cb6cac00c4514c6":"8 horas","2d8a6f7c34468578640b333b8650131de06ac770":"1 día","cd1495cb4c60266a6abad9024022ae079bf7e416":"(1) Defina su contrato de operación","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"(2) Vea y compre su contrato","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"Opciones de operación","160f06d4799c85021a810f68c5b517eea37a2737":"Compra","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"Arriba/Abajo","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"Arriba/Abajo Iguales","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"Asiáticos","2260ce49306460c8a2ef501939f29ad6ddd4e934":"Dígitos","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"Tocar/No Tocar","f7de1f66f0979667da275b7e8996e805395025a1":"Finaliza Dentro/Fuera","a431deecd4c2258097adae418d496fe9a8179fee":"Permanece Dentro/Sale","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"Ticks Altos/Bajos","12a3f461cdebbc8f335190413ee6c57442743bba":"Reset Call/Reset Put","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"Solo Arriba/Solo Abajo","91a64e3f83c91acf336c631fba295f297f94c399":"Ejecutar luego de n segundos","024696596f26a4db232fd9e966eadfeb27c0bd1a":"Ejecutar cada n segundos","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"superior","85c274929bc0e28eafd3734f2c25046c3b95b36b":"intermedio","346e3ee198e98146993894d3de8ecab1a86c3e80":"inferior","f16459104f92ab6b38aa265adb4ecbfc3768e303":"Histograma","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"MACD","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"Señal","19eabc961735d78f12fc7be906ffcb033853cf85":"Marca de tiempo","68f4145fee7dde76afceb910165924ad14cf0d00":"Mensaje","e99811bd3b1ad17e74614060ecb180602be35ad6":"¡Se ha desconectado!","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"el bloque debe agregarse al espacio de trabajo","1fde9f1ebca07dcbc704130bd18645bce7718b55":"el bloque debe estar habilitado","d466687f90ba548434d65186d11a80c4204f9ad6":"debe agregarse dentro de:","629777b7d4d610ace6dee24442730f27d7d0853e":"Archivo no compatible:","0b93c14956403c2e5c9e79f5c836babc56912006":"El Binary Bot no colocará ninguna operación nueva. Cualquier operación ya colocada (pero que no haya expirado) será completada por nuestro sistema. Cualquier cambio no guardado se perderá.","c1458ff86fd60d9544d7cd8a67437df2b766f482":"Nota: Consulte la página de extractos de Binary.com para ver los detalles de todas las transacciones confirmadas.","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"Los cambios no guardados se perderán.","410bf23a3f080def9c7a976a16305bcde7943ed1":"¿Está seguro?","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"Lamentablemente, Binary Bot no está disponible en su país","901624741023fcfc805ce43c94b8012e3b1d1c99":"¿Quiere operar con CFD en MT5? Tendrá acceso a forex, acciones, índices bursátiles, materias primas, criptomonedas y sintéticos.","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"Estrategias","910ec7aa40b04ec6ba51162f4de7850569326cb6":"Se ha producido un error al cargar el script API de Google.","8f51f350debde84e067e1a0405fb6304922a7d4b":"Se ha producido un error al iniciar Google Drive.","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"Se ha producido un error al cargar la biblioteca de Google Drive","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"Otorgue permiso para ver y administrar sus archivos de Google Drive","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"Formato de archivo no reconocido","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"Se ha producido un error al recuperar los datos de Google Drive","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"Seleccione una estrategia de Binary Bot","2db43c69a4b96454914f0b8272bc869984529e6e":"Se ha producido un error al enumerar archivos de Google Drive","0dcea5f584938e0fff00084b83156ab31d641ab3":"Se ha producido un error al recuperar archivos de Google Drive","18da95988117ff029393f3f5c881d70ef47f7385":"Se ha producido un error al procesar su solicitud","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"Seleccione una carpeta","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"La notificación de Telegram no se pudo enviar","3f370309b6280eb100f898426d8605c1f45d558d":"Marca de tiempo inválida","af6a4e2a5582be89ac930e946eaed86e01cac58b":"Fecha / hora inválida","49d51398b574e7312d99b18d2b93d2ede416f053":"No se pudo enviar el webhook","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"Las propuestas no están listas","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"La propuesta seleccionada no existe","6ea4a034747d020b1d8ce4848def95d537555dd6":"Comprado","89f89c02cf47e091e726a4e07b88af0966806897":"ID","1200c1af2f7bba4e29a34112865662748c9d41df":"No se ofrece reventa de este contrato.","62d6180e55905f7b996d442c53631981a4ef8b5b":"Vendido por","ed4978867de1da05b336b724a3fb96222a29ebec":"El índice debe ser un número entero positivo","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"Volumen de ganancias","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"Volumen de pérdidas","46fc6f27a835486d63d9e927c6687e4508cb3087":"Número máximo de transacciones alcanzado","9202ddae4cea16513e53bbc965d88ed975e59512":"Importe máximo de pérdidas alcanzado","5f52b397b7e5f538681f0f5717a88aa626349c7a":"Bot.init no fue llamado","66c7734789e19cbeef3a5ac185ea732139aed213":"Gráfico","3b662fb2e8bafce29aa98321b18874bb44905488":"Integración de Google Drive","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"Por favor, establezca su límite de pérdidas diarias en la página de Mecanismos de Autoexclusión para permitir la operación.","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"El máximo de operaciones consecutivas debe estar entre 1 y 100","93039e609d94a24f3572b794a31b21525a09af2b":"No está ajustado","a85b8cc112a8597df1612d60a74faa818c25d1b3":"Le solicitamos que establezca limitaciones de operación de acuerdo con las regulaciones comerciales. Tenga en cuenta que su bot solo dejará de operar si se cumple alguna de las condiciones siguientes o ambas.","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"Límite diario de pérdidas:","95052a29f213e9698b593418fe396ecc21032f9b":"Este es el umbral que limita sus pérdidas potenciales de un día en todas las plataformas de Binary.com. Una vez que su pérdida total alcance o supere esta cantidad, su bot dejará de operar. Por favor, establezca un valor en la {$0}página de Mecanismos de Autoexclusión{$1}.","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"Máximo de operaciones consecutivas","730657200c17321d926e1bd08dbf65bd96855a8a":"Este es el número máximo de operaciones que permite que su bot ejecute para esta sesión.","952f375412e89ff213a8aca383d18e5691354347":"Comenzar","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"Limitaciones de operación","095ba68888b5ace5f4515f5acab76dfa1073544e":"Mi dispositivo","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"Cargar","248e224f533752db28a1aab3519a58569ad96140":"Bloques de carga","c7097e97dcc446ca889d3ca6be733a65e2728afe":"Subido con éxito a Google Drive","a6b977714595aa01678fca98e86553aaeac05c92":"Guarde sus bloques individualmente en una colección. Se añadirán a su espacio de trabajo actual (los bloques principales serán sustituidos) cuando se carguen.","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"Guardar como colección","611ebbfb080284312904de925ef0f75f4cb56ad2":"Guarde sus bloques y configuraciones para reutilizarlos en otras estrategias","efc007a393f66cdb14d57d385822a3d9e36ef873":"Guardar","a638caa8ab2b7ff7980a571334217339e6d1d634":"Guardar bloques","39fca63515c105918f03e4908ec12df675b07f92":"Trading View","e643975ea5296d9de4486458f31ab0a5a2b228bf":"Esto borrará todas las transacciones en el panel de resumen, y todos los contadores volverán a cero.","85dfa32c97d8618d1bea083609e2c8a29845abe5":"Cuenta","d847919a30d31c0be624087f3370492b3fdf80c6":"Nº de ejecuciones","5cd6978d63540c8a490ef76f43219de6362f958e":"Inversión total","17410d7b62b8b1de981cfebada24632987edf186":"Pago total","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"Ganancia/Pérdida total","90eef613042c5a51f542421065b68b886d473807":"Saldo","db1c784524e1b54011a95823026161f7c8517fe0":"Referencia","4db3e9e4aecd187db9339a10d2629fef46724dc4":"Tipo de contrato","1bb4086b66659d8580f9be4beef69931aeea3cad":"Punto de entrada","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"Punto de salida","ba7be969e7c1bb5f22489e843478e3d721aaa843":"Precio de compra","772fbced18230220d2d9be1456be16fc1b271d25":"Ganancias/Pérdidas","bae7d5be70820ed56467bd9a63744e23b47bd711":"Estado","96f608c16cef16caa06bf38901fb5f618a35a70b":"Pendiente","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"Resuelto","82a82f798dd773717ec37d15fd4405510291734e":"El bot no está funcionando.","6a88e58aa1798626f94cf17f1a91618b405bb289":"El bot está arrancando...","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"El bot está funcionando...","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"El bot se está deteniendo...","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"El bot se ha detenido.","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"Intentando comprar","4684ee1026d9b4c872d016c3c4588a0c479a451c":"Comprar cantidad","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"Compra exitosa","f02760cd2eac28169f0a990c950c3dfe8427f772":"Contrato cerrado","c7363d8a0748d4a7e2cc968335dc9716f290359d":"Si se detiene el bot, se evitarán más operaciones. Cualquier operación en curso será completada por nuestro sistema. Por favor, tenga en cuenta que algunas transacciones completadas pueden no mostrarse en la tabla si el bot se detiene mientras coloca las operaciones. Puede consultar la página del estado de cuenta de Binary.com para ver los detalles de todas las transacciones completadas.","fadc0ef93d1ff13370524ce8481ddc4a71195934":"Reordenar verticalmente","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"Descargar","e4458464df6cbb8da1134875ba51519c5d244d9f":"Los bloques deben estar dentro de los contenedores de bloques, bloques principales o funciones","e9c45563358e813f157ba81b33143542165ba84e":"Advertencia","31cb6f44d030abeabcc7046555dea851602a87a5":"Esta estrategia no está disponible en su país.","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"OK","9970168c192807246fad6138344e5a96449afbdd":"El archivo XML está vacío. Por favor, compruebe o modifique el archivo.","a594b427eaf0f108d3e9cc20d70e15da811c760c":"Estrategia no compatible","04a5090686ac7b54822e00a9ff08c38a107601e7":"Lo sentimos, esta estrategia no se puede usar con Binary Bot. Solo puede usarla con DBot.","77dfd2135f4db726c47299bb55be26f7f4525a46":"Cancelar","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"Ir a DBot","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"El archivo que está intentado abrir contiene elementos no soportados en el siguiente bloque: {$0} Por favor, compruebe el archivo e inténtelo de nuevo.","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"No se puede cargar el archivo de bloque","af145748c9cf765a3b059eec20cb1dbb899297d8":"Los bloques fueron cargados con éxito","11ee9c5d534cc8d22651092222b532917594161a":"La duración mínima es","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"El número de ticks debe estar entre 5 y 10","ace1342bc3720b77ce510b93074041e7386d209e":"La hora de caducidad no puede ser igual a la hora de inicio","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"La predicción debe ser un dígito","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"debe agregarse dentro de","33aa6ff282ee509d37c6f758274c9156b419ff73":"La estrategia que intentó importar no es válida.","da162a909c2981ed318d23cd9a6be1d66e0a8400":"Formato de archivo no reconocido.","5e719fa76e1b6cb396376c82ebdd04bec7253229":"Los bloques remotos a cargar deben ser una colección.","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"No se puede cargar el archivo de bloque.","df84a88f38b03b5b342362d72370b0d66afdae35":"El destino debe ser un archivo xml","cd680fd936e9559ef1d95efac7a71680e2b13a89":"Esta URL ya está cargada","34c59389053701a04127f74d32315e0206e076f8":"Se ha producido un error al intentar cargar la URL","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"Asegúrese de que \"Access-Control-Allow-Origin\" existe en la respuesta del servidor","988df856c066143616bd33d5904bbcdc22ff129e":"Binary.com se está transladando a Deriv","2fccaab15d71b00c19da7053135471d510b513db":"Opere en Deriv","3ead0b14c72503187691a7a6d7121987299bd401":"Esta no es una versión oficial de Binary Bot. Úsela bajo su propio riesgo.","27401c9c8e476d659c8382e05c6d70a4a82be468":"Versión oficial","bc981983e7f547dc62e19a1e383acfe00782a6d5":"Siguiente","b52b36b7269fbfc58ec24bb724691951a3decbe8":"Atrás","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"Finalizado","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"Hacer una visita rápida","a48e81d4a8da67637b46725824177a959fe99b21":"¿Listo para aprender a usar Binary Bot?","6f3e6ebf249947cec4f64117253a8fe43335ae79":"No, gracias","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"No preguntar de nuevo.","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"Espacio de trabajo","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"Arrastre y suelte archivos de bloques o cree sus propias estrategias.","d171baee235d4c93f63755a876782dc5be4c3e47":"Caja de herramientas de bloques","056f19272d96f902c38207cf163ea8dbff7fbd32":"Añada más bloques desde aquí a su bot.","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"Cuentas","f5c47fd3b3553b10441a06054078cea745177dea":"Inicie sesión antes de ejecutar el bot. Siempre pruebe sus estrategias en la cuenta virtual.","fd825ae94aa79500a878dd4590a4b360e7162663":"Controles del bot","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"Controle sus bloques. Mantenga el cursor sobre cada botón para obtener más información.","f5169c84497de3aea74f7da9e7e177d1427e736b":"¡Disfrute!","4f1b3d682c2a00b393c33637da402463bc11d5ff":"¿Quiere reportar un problema o pedir ayuda?","0049f8894e41937ebb9111cd3def6749049fb50f":"Haga clic aquí","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"Dónde encontrar Binary Bot en Deriv","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"En la página de inicio de Deriv, apriete en Operar en la parte superior de la página y elija Binary Bot.","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"Pruebe Binary Bot en Deriv","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"Es el mismo Binary Bot que ya conoce y ama","169dd3b2025485a48b8f9f3f6ef89f5586714140":"Todo es exactamente como le gusta.","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"Traiga sus bots sin complicaciones","b763f8cbfa6396f195781032619a99bba04bc939":"Sus estrategias de Binary.com se pueden usar en Deriv. Tan solo suba sus archivos XML y empiece a operar.","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"7 plataformas de operación (las clásicas favoritas y algunas nuevas, también)","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"Encontrará Binary Bot y SmartTrader junto a nuevas plataformas como DBot y DTrader. Sea cual sea su estilo de operación, tenemos la plataforma para usted.","0ce7480da93c1c9839818d0720b77931d1637574":"Las criptomonedas se depositan a través del fiat on-ramp","6e6a4c6839d2e859758a517865b095c1b8298dd6":"Realice depósitos cripto de manera sencilla mediante servicios de intercambio como Changelly, Banxa y XanPool.","c1b51f196c97b4781a354457579e9699b09de087":"3 tipos de operaciones","4708f7e87263464b130b987e4b9aed981c4f455d":"Opere con CFD, opciones digitales y multipicadores, un nuevo y emocionante tipo de operación que incrementa sus beneficios potenciales con riesgo limitado.","b7fceac7d5f885d735aeda6e4654487467d33fa3":"Depósitos y retiros entre pares","79a206119137878eb6be7c60f7ed34135194bdf0":"Intercambie su moneda local con otros traders para ingresar y sacar fondos de su cuenta con Deriv P2P.","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"6 tipos de mercado","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"Expanda su cartera de inversión con una amplia gama de mercados como el forex, las acciones, las criptomonedas, los sintéticos, entre otros.","14b2a808fdec3702e5a6b9152e13288c87a4768a":"Aprenda con Deriv Academy","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"Disfrute de artículos y vídeos gratuitos que le ayudarán a descubrir los secretos de las operaciones en línea.","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"Haga clic para seleccionar","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"No disponible","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"Intervalos","5fb1db527825d2996e37c655e5dec49d4da80c09":"Segundos","092f99ea11a34a8490e7a767a83a42fc45634f82":"Minutos","9e25a34e635a123f8958bbe26e7c4843278597fb":"Horas","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"Días","db6708630fc646eb98298d9acd701e0a1ac051c2":"Guarde sus bloques y estrategias en Google Drive","85538d002a336c5addef8d189d80976cf7758f8c":"Ha iniciado sesión como","b65463cb6a42a17de514acc4659f7fd331e0876a":"Conectar","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"Desconectar","cd5f85b6f187605f82386eacd680f93820af8d11":"El resultado es","1e38ce3d180cefae485a6986ca7c67841e30376f":"Verdadero si el resultado corresponde a la selección","5c89497fc3c128e2ff865ce8df15356054f2c028":"(4) Reciba el resultado de su operación y opere nuevamente","14ea81918758c994cbe3178e695e56afc1ef2b45":"Obtenga la información y el resultado de la operación anterior, luego opere nuevamente (se ejecuta al finalizar la operación)","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"Detalles del contrato:","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"Lee una opción seleccionada de la lista de detalles del contrato","b3b543c80063a116ced4965d8537b7b62d14c0b7":"Opere nuevamente","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"Ejecute el bloque de operación nuevamente","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"Precio de venta","343fda69c73b78b84967055aae97f790c422adfd":"Precio de venta de la propuesta seleccionada","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"Observe el flujo de ticks y compre el contrato deseado (se ejecuta conforme a la actualización de los ticks)","9bb396940adb9705fe57eba6ea8b578e6aafa792":"Pago","87da93a46d143f6019979b3548414d9d7adabb35":"Pago de la propuesta seleccionada","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"Compra un contrato elegido.","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"Venta disponible","03bad10717e183b24829baf483dc715e1a44bf7b":"Verdadero si venta a precio de mercado está disponible","2c71ed279a402e93312dbda173ab18f244d6bf46":"(3) Observe y venda su contrato adquirido","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"Vea la información de los contratos comprados y venda en el mercado si hay disponibilidad (Se ejecuta cuando se actualiza el contrato)","579607dc4f989ce2b94b558431666a0ab07ac1f3":"Vender a precio de mercado","e20afd5cf3811a42071c9a312abb2afdad4c590b":"Vender a precio de mercado.","4712cbff8e92822fc960ef9c0197293a19675eae":"Vender ganancias/pérdidas","df817b48c7a076561b4f8bedc52d65d2e351ab52":"Devuelva las ganancias de vender a precio de mercado.","b44e884c355e447d0da0e6ba45caaff18c84373b":"Bandas de Bollinger","d6a2a207343bd83aacdc80b579ff4419713a256e":"Lista de entradas","170a28a9db6d27d7212fc6dc249434a57517e7bc":"Período","b833989d69900a4be9e32d1bab65c8f8233f099e":"Multiplicador media desv. arriba","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"Multiplicador media desv. abajo","974da601086448d0060aeed90e53ddd5acd17b91":"Calcula las Bandas de Bollinger (BB) a partir de una lista con un período","d5b65cac1f1cf9421ac978eebe532de99040cca6":"Matriz de Bandas de Bollinger","58de49791c64aba14e36e5887244a5ef088286cd":"Calcula la lista de Bandas de Bollinger (BB) a partir de una lista con un período","4bd99f76f1104229744455d93df0ff76b9eeed58":"Media móvil exponencial","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"Calcule la Media Móvil Exponencial (EMA) a partir de una lista con un período","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"Matriz de Medias Móviles Exponenciales","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"Calcule la lista de Media Móvil Exponencial (EMA) a partir de una lista de valores con un período","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"Matriz MACD","b18e572ea14edd48587145f1ef50718adbf256c6":"Período de EMA rápida","974023bddd6249d0f6404872cfcae205b2599ea2":"Período de EMA lenta","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"Periodo de señal EMA","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"Calcule la lista de Media Móvil Convergencia/Divergencia (MACD) de una lista","95ec92885c855ba9cf734c17a43f081901e4d2cc":"Índice de Fuerza Relativa","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"Índice de Fuerza Relativa (RSI) a partir de una lista con un período","4034de66995b876b2ba9bfd0274025e39168e05d":"Matriz de índice de fuerza relativa","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"Calcule la lista del Índice de Fuerza Relativa (RSI) a partir de una lista de valores con un periodo","a9842c95766da40bf4ea6ee263cb5a5985847763":"Media Móvil Simple","347775a293c14362d492f019e677c965be1d6e7d":"Calcule la Media Móvil Simple (SMA) a partir de una lista con un período","4cc7b9e53d082896ad884eb01be16320af65f282":"Matriz de medias móviles simples","2c75179a57af3c36581008b65e86ed81c4a4cbea":"Calcule la lista de Media Móvil Simple (SMA) a partir de una lista de valores con un período","39f024cf49724fe7ffdea7773c72ed06eec998e1":"con intervalo","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"La dirección es","ad47561efb1dcbd7246d9b64487f615647fda036":"Verdadero si la dirección corresponde a la selección","05bef508aadd62bf3967dcf67d769da296f19989":"Dirección del tick","21bfc78607d3a64de767a6677d1db42156d5039d":"Devuelve la dirección del tick recibido por un bloque de compra anterior, su valor puede ser 'arriba' si el tick es mayor que el anterior, 'abajo' si es menor que el anterior y vacío ('') si el tick es igual al anterior","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"El bloque de dirección está obsoleto, utilice en su lugar el bloque de verificación de dirección","cdb31fc857f01a59f664413498293c714285f46d":"en lista de velas","20fd5f86f08796f145d69dedc209a27e459b2f51":"obtenga # desde final","a96606af8c33ac3428b45abc4782dbf93f458d29":"Obtener la enésima vela más reciente","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"Lista del último dígito","248428facb97408414180d4de74e4db35360fbc4":"Devuelve la lista de valores del último dígito","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"Último dígito","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"Devuelve el último dígito del último tick","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"Lista de velas","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"Devuelve la lista de velas","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"Haga una lista de","a4220593d385a720886f7af1ed3c478fd0c6339c":"valores en la lista de velas","cd8cdf3d47e921c8a72addae9269e66041d417c5":"Devuelve una lista de los valores de la velas seleccionadas","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"Leer en la lista de velas ","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"# desde final","aba43a580daa7f306956ec69b83e6e37e7233126":"Lea el valor de la vela seleccionada en la enésima vela más reciente","e04b522218a181cf0223042dd18ae08dcc22d8d3":"Último tick","6ee445fc253a55c9ed54c009c3f020ac65200d80":"Devuelve el valor del tick recibido por un bloque antes de la compra","ed44b69176217a1251c04f0c13d23ac789ea60b2":"Cadena del último tick","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"Devuelve el valor de tick recibido por un bloque antes de la compra (Cadena)","4b2340a890e88d1886757c3f7172e273a1edc31f":"Este bloque se activa con cada tick","b54d7b4590559dad64f02d09aacbf6d9863e2624":"Puede utilizar este bloque para analizar los ticks, independientemente de sus operaciones","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"Lista de ticks","17649cac8739adcae95e641f794880272ad33bd1":"Devuelve la lista de valores de ticks","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"Lista de cadenas de ticks","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"Devuelve la lista de valores de tick (Cadena)","c67ded6b64019212eb2bc69afd761f5b3f626040":"Añade un signo a un número para hacer un Desplazamiento de Barrera.","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"Mercado","74751e67c3e1010c343095eaf543e7cb21ced2ef":"Tipo de operación","1f4698382842477e211eb46de81fa506f01a8c34":"Ambos","c1baf816aac5a5cd849768773fc248cd249dc296":"Tipo de contrato:","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"Intervalo de vela predeterminado:","9693aeaaf68e3929b59b79306feaa0a847d01192":"Duración:","78d7103a319e808455d397513279d99f3b3f3768":"Inversión","10c02649e226d430bd75a5b6315a41c0db9992a2":"Barrera","837276742aa90209dde3b4eef07d8e7ab26731ef":"Predicción","258b49925b41751c6bd790a0848246566ba61440":"Reiniciar compra/venta en caso de error","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"desactivar para un mejor rendimiento","b410994b67e37d9516eb9b866c85a8c639f79e68":"Reiniciar última operación en caso de error","2260c5a971c2602834ef8feeb5fa522f900b469f":"bot ignora la operación fallida","0745acf92abd7b60598f161717884cc45dab8694":"Ejecutar una vez al iniciar","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"Definir Opciones de Operación","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"Defina su contrato operativo y comience la operación, añada las inicializaciones aquí. (Se ejecuta al inicio)","4d22b565e4253e92a908f216184779679bb1a044":"Barrera alta","b70c38c6db3127422e05315c30bdf76c7c36c480":"Barrera baja","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"Absoluto","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"Saldo:","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"Obtener número de saldo o cadena","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"Los bloques en el interior son ignorados","d072c2ceeb5c1217722d14c74de7aeab945b4215":"Coloque sus bloques aquí para evitar que sean eliminados","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"Clave: %1 Valor: %2","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"Devuelve una representación de cadena de un par de valores clave","b06acc4158c824231f727a13e1c9811f43d5be42":"Cargar bloque desde","661db37251a1ed1afe357ee13895f37a623d7cbf":"Cargar bloques desde la url","6c03ee54ad3a51fc92a1d69943e99667847705b6":"Notificar","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"con sonido","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"Crea la notificación","6e0fc122f936f808bc2e3af661121b65712ae855":"Notificar a Telegram %1 Token de acceso: %2 ID de chat: %3 Mensaje: %4","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"Envía un mensaje a Telegram","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"Ganancia total","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"Devuelve la ganancia total","532e65f6e266db0bb442d1f426d44d7d32962340":"Cadena de ganancia total","78e84591ff76f992953a8e19b57c7eab7546d638":"Devuelve la ganancia total (Cadena)","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"Nº de ejecuciones","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"Devuelve el número de ejecuciones desde el principio","7d500ebe352ccfa932b253e21938813a06fcff8e":"Webhook URL: %1","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"Envía una solicitud POST a una URL","a35646754dbe7a9211ba8b81338a5d64580eb276":"Carga vacía","69b0648eddd207cd45a9e1ba973dae287b535576":"Carga:","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"¿la vela es negra?","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"Comprueba si la vela dada es negra, devuelve verdadero si el cierre es menor que la apertura en la vela dada.","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"Haga una lista de","5925d08228e246f07b790b88ad70c1b73a97d2bc":"valores a partir de una lista de velas","852b438f91ad9eb2cdd84419a675a216d543c687":"Leer","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"valor en la vela","d79d854dcd0829e2177a47beab6a55569e781ab1":"Lea un campo en la vela (leer desde la lista de velas)","5606b4460ac96063b8a8e5647008f3ec97252fc5":"Segundos desde el Epoch","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"Devuelve el tiempo epoch (segundos desde el epoch)","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"Ejecutar cada","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"Segundo(s)","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"Ejecuta los bloques en el interior cada n segundos","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"Bloque ejecutar a cada segundo ha quedado obsoleto. Por favor, contáctenos si posee un caso de uso válido.","7b9c76088576a64f32d67ec335162b9f73eaa026":"Ejecutar después de","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"Ejecuta los bloques en el interior después de n segundos","e9fb732dde76a6977bcaa2818b0f56125b183648":"Hasta la fecha / hora","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"Convierte un número de segundos desde Epoch en una cadena que representa la fecha y la hora. Ejemplo: 1546347825 se convertirá en 2019-01-01 21:03:45.","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"A la marca horaria","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"Convierte una cadena que representa una cadena de fecha / hora en segundos desde Epoch. Ejemplo: 2019-01-01 21:03:45 GMT + 0800 se convertirá a 1546347825. La hora y el desplazamiento de zona horaria son opcionales.","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"Comience a utilizar Deriv con su correo electrónico y contraseña de Binary.com.","64f72129852fb7bdff0725c71324a012630f53bf":"En la UE, los productos financieros son ofrecidos por Binary Investments (Europe) Ltd., W Business Centre, Nivel 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, regulada como proveedor de Servicios de Inversión de Categoría 3 por la Autoridad de Servicios Financieros de Malta ({$0}licencia nº IS/70156{$1}).","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"Fuera de la UE, los productos financieros son ofrecidos por Binary (SVG) Ltd, Edificio Hinds, Kingstown, San Vicente y las Granadinas; Binary (V) Ltd, Edificio Govant, Port Vila, PO Box 1276, Vanuatu, regulada por la Comisión de Servicios Financieros de Vanuatu ({$0}ver licencia{$1}); Binary (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, Islas Vírgenes Británicas, regulada por la Comisión de Servicios Financieros de las Islas Vírgenes Británicas ({$2}licencia núm. SIBA/L/18/1114{$3}); y Binary (FX) Ltd, Lote Núm. F16, Primer Piso, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malasia, regulada por la Autoridad de Servicios Financieros de Labuan para realización de un negocio de corretaje de cambios ({$4}licencia núm. MB/18/0024{$5}).","10dd345bc3319e2151794428b2c709dc5fc381a7":"Los servicios de este sitio web no están disponibles en ciertos países como los Estados Unidos, Canadá, Hong Kong, Japón, ni tampoco para personas menores de 18 años.","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"Advertencia de riesgo","ad0fc99c05681528248b73007dba16fd760a81c6":"Los productos ofrecidos a través de este sitio web incluyen opciones binarias, contratos por diferencias (\"CFD\", por sus siglas en inglés) y otros derivados complejos. Las operaciones con opciones binarias pueden no ser adecuadas para todos. Las operaciones con CFD conllevan un alto nivel de riesgo ya que el apalancamiento puede funcionar tanto a vuestro favor como en contra. Como resultado, los productos ofrecidos en este sitio web pueden no ser adecuados para todos los inversionistas debido al riesgo de perder todo el capital invertido. Nunca debe invertir dinero que no pueda permitirse perder, y nunca debe operar con dinero prestado. Antes de operar con los productos complejos que se ofrecen, asegúrese de comprender los riesgos implicados y de obtener información acerca de {$0}Operaciones Responsables{$1}.","1fda2716eb92e0195ff59b110af23d86b43fd909":"En la UE, los productos financieros son ofrecidos por Binary Investments (Europe) Ltd., W Business Centre, Nivel 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, autorizada y regulada como Proveedor de Servicios de Inversión de Categoría 3 por la Autoridad de Servicios Financieros de Malta (licencia nº IS/70156).","be7786af641b859c03ec152461d791480cf676ed":"En la Isla de Man y el Reino Unido, los índices de volatilidad se ofrecen a través de Binary (IOM) Ltd., Primer Piso, Millennium House, Victoria Road, Douglas, IM2 4RW, Isla de Man, Islas Británica, licenciado y regulado respectivamente por (1) la Comisión Supervisora de Apuestas de la Isla de Man (licencia actual otorgada el 31 de agosto de 2017) y por (2) la Comisión de Apuestas del Reino Unido (número de {$0}referencia de licencia: 39172{$1}).","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"En el resto de la UE, los índices de volatilidad son ofrecidos por Binary (Europe) Ltd., W Business Centre, Nivel 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta; con licencia y regulada por (1) la Autoridad de Juegos de Azar de Malta (licencia nº MGA/B2C/102/2000 emitida el 1 de agosto de 2018), para los clientes del Reino Unido por (2) la Comisión de Apuestas del Reino Unido (número de {$0}referencia de licencia: 39495{$1}), y para los clientes irlandeses por (3) los Comisionados de Hacienda en Irlanda (Licencia de Corredor de Apuestas de Forma Remota nº 1010285 emitida el 1 de julio de 2017). Ver la {$2}Información Normativa{$1} completa.","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"Binary.com es un galardonado proveedor de operaciones en línea que ayuda a sus clientes a operar en los mercados financieros mediante opciones binarias y CFD. Operar con opciones binarias y CFD sobre Índices de Volatilidad está clasificado como una actividad de juego de azar. Recuerde que el juego puede ser adictivo - por favor, juegue de manera responsable. Más información sobre {$0}Operación Responsable{$1}. Algunos productos no están disponibles en todos los países. Los servicios de este sitio web no están disponibles en determinados países, como EE.UU., Canadá, Hong Kong, o para personas menores de 18 años.","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"Operar con opciones binarias puede no ser adecuado para todas las personas, por lo que le rogamos que se asegure de comprender plenamente los riesgos que conlleva. Sus pérdidas pueden superar su depósito inicial y usted no es dueño ni tiene ningún interés en el activo subyacente.","496a99878841de69368c33af9e88eb37c0da5712":"Los CFD son instrumentos complejos y conllevan un alto riesgo de perder dinero rápidamente debido al apalancamiento. El 78,6% de las cuentas de inversores minoristas pierden dinero al operar con CFD. Debe considerar si entiende cómo funcionan los CFD y si puede permitirse el alto riesgo de perder su dinero.","a726d863bbdceba7b06a1083026a53db76de47b7":"Opere con multiplicadores","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"Amplíe su ganancia potencial sin arriesgar más que su inversión.","febe8aef26fb3017be5bf43d66f7972731c20833":"Pagos entre pares","a8c1114d1c88db12afa05b331188ceb77afad6e3":"Índices Crash/Boom","d29324705a18a81ffc0376f3f37639a68827f3e6":"Prediga y obtenga beneficios potenciales de emocionantes picos y caídas. Solo disponible con multiplicadores en DTrader.","ba2098a209e375402a0cf222cec87cce26440767":"Exclusivamente en Deriv","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"Hay un futuro brillante por delante.","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"Encuentre estas funciones adicionales y más en Deriv:","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"Compruébelo","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"SmartTrader","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"Nuestra plataforma clásica de operaciones con opciones","64dfd7424a05133b74cfb93fcbe385ede6539855":"Nuestra plataforma clásica de operaciones automatizadas","824d76b124e6289f372e2ff6bcba91e8939343bd":"Más información","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"Deriv MT5","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"La famosa plataforma de operaciones con CFD","54617a018fc6dffb3a70627b97f0db5c52a4081d":"DTrader","dbcd68f389d64fc531a650652c87b7d83fc82d94":"Nuestra plataforma insignia de operaciones con opciones y multiplicadores","dd69c213333a751a0ab3bc9ce6368588bf971b61":"DBot","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"Nuestra plataforma de operaciones automatizadas de nueva generación","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"Deriv GO","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"Opere desde cualquier lugar con nuestra plataforma de operaciones para móviles","f63714db18c58c6b4a7a7bad09178faaeca05104":"Deriv X","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"Nuestra plataforma personalizable de operaciones con CFD","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"Todo lo que más le gusta de Binary.com y más","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"7 plataformas para elegir","029582bad299ab8f44c57b961210e56569efd536":"Encontrará SmartTrader y Binary Bot junto a nuevas plataformas como DTrader y Deriv X. Sea cual sea su estilo de trading, tenemos la plataforma para usted.","9a07439b57e510e8e33b372aad2c360dbc39e79c":"Opere con CFD, opciones digitales y multiplicadores, un nuevo y emocionante tipo de operación que incrementa sus ganancias potenciales con riesgo limitado.","3d0be0e8eb736257254698ba821c45389e385f1e":"Depósitos de criptomonedas mediante rampa de acceso fiat","c4303d30e60f01fa922400e52df4e96d71b35d6e":"Más de 100 instrumentos","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"Opere con lo que prefiera: forex, materias primas, acciones, índices bursátiles e índices sintéticos. ","f30ce7459f29851b219b504216581bf3d3446de0":"Asistencia cuando la necesite","6df6091514ee13992a3ac28445af1d9a1afbcb67":"Obtenga asistencia al cliente las 24 horas del día y acceda al Centro de Ayuda.","92c8b7b779e7cf179b89484285fd766274b3bf1f":"Explore Deriv ahora","a87a92c5ce4925186a081cf4478639fcc31b12ed":"En la UE, los productos financieros se ofrecen a través de Deriv Investments (Europe) Limited, W Business Centre, Nivel 3, Triq Dun Karm, Birkirkara BKR 9033, Malta, con licencia en Malta ","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"(licencia Nº IS/70156)","720280451c98ceeb796f3c7fa118813fc8da694d":"y regulada por la Autoridad de Servicios Financieros de Malta, Triq l-Imdina, Zona 1, Central Business District, Birkirkara CBD 1010, Malta, en virtud de la Ley de Servicios de Inversión. Autorizada por la Autoridad de Conducta Financiera y con modificación estimada del permiso. Sujeta a la regulación de la Autoridad de Conducta Financiera. La naturaleza y el alcance de la protección al consumidor pueden diferir de los especificados para empresas con base en Reino Unido. Los detalles del Régimen de Contratos de Servicios Financieros, que permite a empresas basadas en el EEE operar en el Reino Unido durante un periodo de tiempo limitado para llevar a cabo las actividades necesarias para la ejecución de contratos preexistentes, están disponibles en la página web de la Autoridad de Conducta Financiera.","0f1dda628bebb4748de6df05fa3bff4989c1b476":"Fuera de la UE, los productos financieros se ofrecen a través de las siguientes empresas: Deriv (FX) Ltd, F16, Nivel 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malasia, con licencia otorgada por la Autoridad de Servicios Financieros de Labuan ","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"(licencia Nº MB/18/0024);","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"Deriv (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, Islas Vírgenes Británicas, está regulada por la Comisión de Servicios Financieros de las Islas Vírgenes Británicas ","a56aa088dfea506d5dbe18f385c29418f771a639":"(núm. de licencia SIBA/L/18/1114);","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":" Deriv (V) Ltd, 1276, Kumul Highway, Port Vila, Vanuatu, está licenciada y regulada por la Comisión de Servicios Financieros de Vanuatu; y Deriv (SVG) LLC, Hinds Buildings, Kingstown, San Vicente y las Granadinas.","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"Deriv Limited - Calle Castle 13, St. Helier, JE2 3BT, Jersey - es la compañía holding de las filiales mencionadas.","74e8fa69aad80f93303a7723e5a304f3d43560b6":"Los servicios de este sitio web no están disponibles en ciertos países incluyendo Estados Unidos, Canadá y Hong Kong, ni para personas menores de 18 años.","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"Los CFD se consideran derivados complejos y pueden no ser adecuados para clientes minoristas. Los CFD son instrumentos complejos y conllevan un alto riesgo de perder dinero rápidamente debido al apalancamiento. Debe considerar si comprende cómo funcionan los CFD y si puede permitirse asumir el alto riesgo de perder su dinero. Los productos mencionados aquí pueden verse afectados por cambios en los tipos de cambio. Si invierte en estos productos, puede perder parte o la totalidad de su inversión y el valor de su inversión puede fluctuar. Nunca debe invertir dinero que no pueda permitirse perder y nunca debe operar con dinero prestado.","5bb3f3499158dbe30af5c725694b321dfe821433":"Antes de operar con los productos financieros complejos que se ofrecen, asegúrese de comprender los riesgos involucrados y aprender sobre ","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"Trading seguro y responsable.","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"¡Nos mudamos!","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"Hemos sido","991753597fde70aab5791de6d50ee8cc49a0bdcc":" Binary.com","efa99ab039a285c6264580bea691a4ffefcbeee7":" durante 2 décadas y ya es hora de un nuevo y emocionante capítulo.","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"Dé la bienvenida a nuestro nuevo hogar,","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":" Deriv.","52b8454dc755419beeff2f90cd0fc91def428244":"¡Hola, Deriv!","27ad1d8334221366694c7acdd70fb380857d1e6e":"Quizá más tarde","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"Llévame a Deriv","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"Es tan sencillo cambiarse a Deriv","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"Simplemente inicie sesión con sus credenciales de Binary.com. No hace falta registrarse.","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"Pruébelo ahora","63fbf7977349e32e4a124ffa047549b720806d73":"Lleve Deriv con usted","03d42257a2263b2841b9e0ae4b94de117228a33a":"Obtenga la aplicación móvil Deriv GO y opere en cualquier lugar. Nunca más pierda oportunidades de oro.","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"Escanee este código QR para descargar Deriv GO","6b7499b1513a3cec3da3ff07cdad9b358954021e":"No espere más","b23efda40ddeb801beeebf915669d806744014af":"Asegure sus operaciones de cara al futuro. Véngase a Deriv ahora.","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"Entre en la experiencia Deriv","34075438f939258908cc21d28bf59ab5126dc2d6":"Venga a Deriv y prepare sus operaciones para el futuro ahora.","e669443b63757b5ad8571e52393caf2a0a812be3":"6 razones por las que le encantará Deriv","2c141583afaaa12438b16ee67355c6e3eaf77763":"Binary Bot tiene un nuevo hogar","4e0e045da59b385138ced3203cdb81c3b4cdd135":"Hemos sido Binary.com durante 2 décadas y es hora de iniciar un nuevo y emocionante capítulo. Su constructor de bots favorito, Binary Bot, está ahora en Deriv, nuestro nuevo hogar. Venga a echar un vistazo.","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"Llévame a Binary Bot en Deriv","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"Utilice Binary Bot en Deriv, nuestro nuevo hogar","1071c645f523394b408a6d285e95331bc583f14c":"En 5 minutos, le mostraremos los beneficios de operar con Binary Bot en Deriv. Si ignora este mensaje, se lo recordaremos de nuevo en 3 semanas.","be43a8989c5745ec7386ca7c69442165f55dee8e":"Muéstrame los beneficios ahora","074603c9aef93515ed33d179e982c67ea7abdb45":"Opere Binary Bot en Deriv"}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"Logique","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"Mathématique","c3328c39b0e29f78e9ff45db674248b1d245887d":"Texte","4d064726954a17487f94e931f5b157b733ec22ed":"Options avancées","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"Liste","19de69cb601f53a4ea7af22a65c71ae63251365c":"Variable","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"Fonctions","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"Boucle","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"Binaire","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"Définition de l'option","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"Avant l'achat","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"Pendant l'achat","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"Après l'achat","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"Analyse des ticks","8cf71374fa095a64b5295b672daef8507ec7be6a":"Indicateurs","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"Outils","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"Périodicité","8d8fd6765e184419cad8b88d1a60c895d79578c2":"Chandeliers","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"Divers","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"Log","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"Synthèse","9feddbabd7e7309e96c590069057158e96baa8f6":"Relevé d'activité","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"Le trading d'options binaires peut devenir une véritable addiction, au même titre que toute autre activité pratiquée de façon trop intensive. Pour éviter le danger d'une telle addiction, nous mettons en œuvre suivi réaliste de votre situation en vous fournissant régulièrement un relevé de vos opérations et de vos comptes.","4152043e8c670075d2c919677e835edb0d923cab":"Veuillez indiquer la périodicité souhaitée en minutes pour les relevés d'activité","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"Veuillez saisir un chiffre entre 10 et 60.","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"Poursuivre les opérations de trading","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"Relevé","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"Déconnexion","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"Contactez-nous","f7c400ed695f898b8ee9d21664aa17b5bb693828":"Connexion","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"Réinitialiser les blocs à leur état initial","f98595d541778d86f75ef22b3328a031d20aa16b":"Charger de nouveaux blocs (fichier xml)","4a1e616226c329a94da7768bc0435a3284478010":"Sauvegarder les blocs existants (fichier xml)","6b3465ace62f33f0687b4669ac26d95895e9ca52":"Connectez Binary Bot à votre Google Drive pour sauvegarder et réutiliser facilement vos blocs","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"Annuler les modifications (Ctrl+Z)","937f5055f05be359ddf619744e8af4d643549e80":"Refaire les modifications (Ctrl+Shift+Z)","8406d1cce44230835932060649e999ca3283b413":"Zoom Avant (Ctrl + + )","1109673172af2c173c492622ff8a72c8f29f0e70":"Zoom Arrière (Ctrl + -)","44c22002c65d2871331263a23c3e09c0a1bfd847":"Réorganiser Verticalement","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"Afficher/masquer la fenêtre récapitulative","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"Lancer le bot","ba50a42d8d3228c37a817865fce49fbca692c2ad":"Arrêter le bot","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"Afficher log","91017ef9b165cd0e7475a770f318ea5e705e1321":"Afficher graphique","c89e3dd1cafcadcc0312e476ab58b2332209da23":"Afficher Trading View","b02c858e72be118a65c9393930351012b647cb9e":"Basculer l'en-tête","250be77f7605669a0b3d968b9ed381a3d9787ed1":"Ouvrir un fichier XML déjà sauvegardé et récupérer ses blocs","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"Binary Bot","608061fb5aab975013fa70c5c814a1d8ba30c152":"Gérez vos opérations de trading plus efficacement que jamais","e4ce8dc3e416e69262ba642dc57d3975d6616980":"Vous envisagez d'automatiser vos meilleures stratégies de trading d'options binaires ?","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"Binary Bot est notre outil de programmation de pointe qui vous permet de créer des applications de trading à l'aide d'un simple clic","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"Inventez autant de robots de trading d'options binaires que vous le souhaitez, des formules les plus simples aux algorithmes les plus complexes. Ensuite, laissez-les gérer vos opérations pour vous, même lorsque vous dormez.","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"Commencez dès maintenant la création de votre robot","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"Besoin de renseignements supplémentaires ?","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"BESOIN D'AIDE ?","d635b53e59c9aad8c5d78458826beffb029b27bf":"Merci, nous vous répondrons dans les 24 heures","a69a8fc21499d0fd85e87bab467699827547a5bc":"Veuillez saisir une URL de serveur valide","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"Le marché sous-jacent n'est pas sélectionné","50050f06645ad2743165b429a8f7deebd285fd63":"Le type de contrat n'est pas sélectionné","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"Veuillez vous connecter","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"La durée doit être un nombre entier positif","4df6e872792d72aea8a2f6b831d00b554464da23":"Le montant doit être un nombre positif","001e68df3a4b32a4d57148d9d407f44eee3b7436":"La bougie en question n'est pas valide","04f14ea7c92e0b2b5ae005c696245063ec641d66":"La liste de la bougie en question n'est pas valide","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"nouvelle tentative dans","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"Taux maximal atteint pour","094628ce13fc0e78f07b697d1cc9421bb2edd666":"Échec de la requête pour","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"Non","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"Oui","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"relevé","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"prix de demande","50e72909992bdc37c7c07769d1b7efac5e52874c":"paiement","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"profits","c980b910204c7babdffe8ff3f7e755f30133383c":"type de contrat","a726c6955157f1b8b92f9932652434a7150f80f8":"point d'entrée","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"valeur d'entrée","3905be81561384dc8c43d6127c57ed1e0eb03b74":"valeur d'entrée de chaîne","7674920c033ca14277c577e19c037a6754d4fa80":"point de sortie","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"valeur de sortie","06ecea26625359f7dcf5ff5c47af6174ff815257":"valeur de sortie de chaîne","779455ee3bde8494d9629b353e17b19e92357ba8":"barrière","37a5301a88da334dc5afc5b63979daa0f3f45e68":"résultat","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"Gain","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"Perte","563339f82447b4e758ad76d5a0b63b5698594fba":"Hausse","5c1ae82c29543ac887703776bf3da2c7dcce683d":"Baisse","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"Pas de changement","ecb252044b5ea0f679ee78ec1a12904739e2904d":"chaîne","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"nombre","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"vert","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"bleu","96de5543d183d7de52ac5fa21c46fc811f673f89":"jaune","78988010b890ce6f4d2136481f392787ec6d6106":"rouge","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"Silencieux","cf84a98d6cf7f156862a08ba8236467b6f471004":"Annonce","eee2facd669d1434848c24da5527b3e87d9a12d5":"Gagner de l’argent","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"Travail accompli","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"Erreur","a3b1583d377f37ac20de7e089edfa0920a078e57":"Erreur grave","66c8b6848eee629c4ac551bf2b5fa591571654be":"La hausse est égale à","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"La baisse est égale à","062787aa328047e189774b3703d983b83938f6e9":"Supérieur","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"Inférieur","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"Touche","7d7932bcc2e262ae98cf09dc5445130fb3881769":"Ne touche pas","a16814a48ec58c2e24ba224a80921a5c02361abe":"Termine dans la zone","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"Termine hors de la zone","534ec5da4e82ec419abc170e1a8448f55a01664f":"Reste dans la zone","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"Sort de la zone","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"Asiatique/hausse","c098658ce3d3a258e4d155949a60072966b36db7":"Asiatique/baisse","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"Égal","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"Différent","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"Pair","dc28f5f3c65ec611f0f30022650d24382d27448e":"Impair","18a63f5512afb5573e5b44deba78d629f0635317":"Au dessus","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"En dessous","2155c8b38181dd2552e84a94049aacd33ef9c607":"Tick Haut","1408cfd2b064b923f024fbe590e27db8282941a5":"Tick Bas","b86eb15dc4f13e4c2972de158d3038d9f657242f":"Reset Call","669a1f3d9a8f601a84da536cfdad1de4092b1926":"Reset Put","844d1a5c99a0a668383340cc095d040eef998c79":"Que des Montées","87293a146cd481a2b30cf74282ec061dc4cf0735":"Que des Descentes","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"Ouverture","b1a5954a483f8f8b0207385095f74aeb409b3f80":"Haut","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"Bas","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"Fermeture","1173872a4fb205b713702f0eec5cf2c732c828fd":"Heure d'ouverture","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"Par défaut","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"1 minute","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"2 minutes","24e46784cbce32443db5a2638b1a7d3201543e9b":"3 minutes","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"5 minutes","a6f151883b736f0470d33492e61c72a7d059d065":"10 minutes","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"15 minutes","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"30 minutes","f030c3d667652646b86732ad7bc67e226c49cd3a":"1 heure","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"2 heures","7b47150d431db70d783724007f07ab894eb8ac2e":"4 heures","191800b7e9a48680792c0dd77cb6cac00c4514c6":"8 heures","2d8a6f7c34468578640b333b8650131de06ac770":"1 jour","cd1495cb4c60266a6abad9024022ae079bf7e416":"(1) Définir votre contrat binaire","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"(2) Suivre et acheter votre contrat","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"Négocier des Options","160f06d4799c85021a810f68c5b517eea37a2737":"Acheter","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"Hausse/Baisse","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"Hausse/Baisse Égale","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"Asiatiques","2260ce49306460c8a2ef501939f29ad6ddd4e934":"Chiffres","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"Touche/Ne touche pas","f7de1f66f0979667da275b7e8996e805395025a1":"Termine dans/hors de la zone","a431deecd4c2258097adae418d496fe9a8179fee":"Reste dans/Sort de la zone","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"Ticks Haut/Bas","12a3f461cdebbc8f335190413ee6c57442743bba":"Reset Call/Reset Put","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"Que des Montées/Que des Descentes","91a64e3f83c91acf336c631fba295f297f94c399":"Exécuter après n secondes","024696596f26a4db232fd9e966eadfeb27c0bd1a":"Exécuter toutes les n secondes","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"supérieur","85c274929bc0e28eafd3734f2c25046c3b95b36b":"médian","346e3ee198e98146993894d3de8ecab1a86c3e80":"inférieur","f16459104f92ab6b38aa265adb4ecbfc3768e303":"Histogramme","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"MACD","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"Signal","19eabc961735d78f12fc7be906ffcb033853cf85":"Marquage temporel","68f4145fee7dde76afceb910165924ad14cf0d00":"Message","e99811bd3b1ad17e74614060ecb180602be35ad6":"Vous avez été déconnecté !","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"bloc doit être ajouté à l'espace de travail","1fde9f1ebca07dcbc704130bd18645bce7718b55":"le bloc doit être activé","d466687f90ba548434d65186d11a80c4204f9ad6":"doit être ajouté à l’intérieur de :","629777b7d4d610ace6dee24442730f27d7d0853e":"Format non pris en charge :","0b93c14956403c2e5c9e79f5c836babc56912006":"Binary Bot ne placera pas des nouvelles trades. Toutes les trades déjà placées (mais non expirées) seront parachevées par notre système. Toutes les modifications non enregistrées seront perdues.","c1458ff86fd60d9544d7cd8a67437df2b766f482":"Remarque : Veuillez consulter la page de déclaration Binary.com pour plus de détails sur toutes les transactions confirmées.","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"Toutes les modifications non enregistrées seront perdues.","410bf23a3f080def9c7a976a16305bcde7943ed1":"Êtes-vous sûr ?","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"Malheureusement, Binary Bot n'est pas disponible dans votre pays","901624741023fcfc805ce43c94b8012e3b1d1c99":"Vous souhaitez trader des CFD sur MT5 ? Vous aurez accès au forex, aux actions, aux indices boursiers, aux matières premières, aux cryptomonnaies et aux synthétiques.","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"Stratégies","910ec7aa40b04ec6ba51162f4de7850569326cb6":"Une erreur s'est produite lors du chargement du script Google API.","8f51f350debde84e067e1a0405fb6304922a7d4b":"Une erreur s'est produite lors de l'initialisation de Google Drive.","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"Une erreur s'est produite lors du chargement des bibliothèques de Google Drive","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"Veuillez accorder l'autorisation d'afficher et de gérer vos fichiers Google Drive","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"Format de fichier non reconnu","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"Une erreur s'est produite lors de l'extraction des données de Google Drive","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"Sélectionnez une stratégie de Binary Bot","2db43c69a4b96454914f0b8272bc869984529e6e":"Il y a eu une erreur en listant les fichiers de Google Drive","0dcea5f584938e0fff00084b83156ab31d641ab3":"Une erreur s'est produite lors de la récupération des fichiers de Google Drive","18da95988117ff029393f3f5c881d70ef47f7385":"Une erreur s'est produite lors du traitement de votre demande","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"Sélectionnez un dossier","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"La notification par Telegram n'a pas pu être envoyée","3f370309b6280eb100f898426d8605c1f45d558d":"Horodatage non valide","af6a4e2a5582be89ac930e946eaed86e01cac58b":"Date/heure invalide","49d51398b574e7312d99b18d2b93d2ede416f053":"Impossible d'envoyer le webhook","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"Les propositions ne sont pas prêtes","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"La proposition retenue n’existe pas","6ea4a034747d020b1d8ce4848def95d537555dd6":"Acheté","89f89c02cf47e091e726a4e07b88af0966806897":"ID","1200c1af2f7bba4e29a34112865662748c9d41df":"La revente de ce contrat n’est pas offert.","62d6180e55905f7b996d442c53631981a4ef8b5b":"Vendu pour","ed4978867de1da05b336b724a3fb96222a29ebec":"L'index doit être un nombre entier positif","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"Le montant du profit","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"Le montant des pertes","46fc6f27a835486d63d9e927c6687e4508cb3087":"Nombre maximal de transactions atteint","9202ddae4cea16513e53bbc965d88ed975e59512":"Montant maximal de perte atteint","5f52b397b7e5f538681f0f5717a88aa626349c7a":"Bot.init n’est pas appelé","66c7734789e19cbeef3a5ac185ea732139aed213":"Graphique","3b662fb2e8bafce29aa98321b18874bb44905488":"Intégration de Google Drive","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"Veuillez définir votre limite de perte quotidienne dans la page Option d'auto exclusion pour permettre le trading.","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"Le nombre maximum de trades consécutifs doit être compris entre 1 et 100","93039e609d94a24f3572b794a31b21525a09af2b":"Non défini","a85b8cc112a8597df1612d60a74faa818c25d1b3":"Nous vous demandons de définir des limites de transaction conformément aux réglementations commerciales. Veuillez noter que votre robot ne s'arrêtera que si l'une ou les deux conditions ci-dessous sont remplies.","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"Limite journalière des pertes :","95052a29f213e9698b593418fe396ecc21032f9b":"Il s'agit du seuil qui limite vos pertes potentielles pour la journée sur toutes les plateformes Binary.com. Une fois que votre perte totale atteint ou dépasse ce montant, votre robot arrêtera de trader. Veuillez définir une valeur dans la page {$0}Option d'auto exclusion{$1}.","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"Nombre maximum de trades consécutifs","730657200c17321d926e1bd08dbf65bd96855a8a":"Il s'agit du nombre maximum de transactions que vous autorisez votre robot à exécuter pour ce cycle.","952f375412e89ff213a8aca383d18e5691354347":"Début","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"Limites de trading","095ba68888b5ace5f4515f5acab76dfa1073544e":"Mon ordinateur","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"Chargez","248e224f533752db28a1aab3519a58569ad96140":"Chargez les blocs","c7097e97dcc446ca889d3ca6be733a65e2728afe":"Téléchargé avec succès sur Google Drive","a6b977714595aa01678fca98e86553aaeac05c92":"Enregistrez vos blocs individuellement dans une collection. Ils seront ajoutés à votre espace de travail existant (les blocs principaux seront remplacés) lors du chargement.","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"Enregistrez en tant que collection","611ebbfb080284312904de925ef0f75f4cb56ad2":"Sauvegardez vos blocs et paramètres pour les réutiliser dans d'autres stratégies","efc007a393f66cdb14d57d385822a3d9e36ef873":"Enregistrer","a638caa8ab2b7ff7980a571334217339e6d1d634":"Sauvegarder les blocs","39fca63515c105918f03e4908ec12df675b07f92":"Affichage en mode trading","e643975ea5296d9de4486458f31ab0a5a2b228bf":"Cela effacera toutes les transactions dans le panneau récapitulatif, et tous les compteurs seront remis à zéro.","85dfa32c97d8618d1bea083609e2c8a29845abe5":"Compte","d847919a30d31c0be624087f3370492b3fdf80c6":"Nb. d'exécutions","5cd6978d63540c8a490ef76f43219de6362f958e":"Mise totale","17410d7b62b8b1de981cfebada24632987edf186":"Versement total","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"Total des profits/pertes","90eef613042c5a51f542421065b68b886d473807":"Solde","db1c784524e1b54011a95823026161f7c8517fe0":"Référence","4db3e9e4aecd187db9339a10d2629fef46724dc4":"Types de transaction","1bb4086b66659d8580f9be4beef69931aeea3cad":"Point d'entrée","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"Point de sortie","ba7be969e7c1bb5f22489e843478e3d721aaa843":"Prix d'achat","772fbced18230220d2d9be1456be16fc1b271d25":"Profits/pertes","bae7d5be70820ed56467bd9a63744e23b47bd711":"Statut","96f608c16cef16caa06bf38901fb5f618a35a70b":"En attente","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"Réglée","82a82f798dd773717ec37d15fd4405510291734e":"Le bot n'est pas en marche.","6a88e58aa1798626f94cf17f1a91618b405bb289":"Le robot se met en marche...","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"Le bot est en marche...","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"Le Bot est en train de s'arrêter...","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"Le bot s'est arrêté.","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"Tentative d'achat","4684ee1026d9b4c872d016c3c4588a0c479a451c":"Acheter le montant","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"Achat réussi","f02760cd2eac28169f0a990c950c3dfe8427f772":"Contrat fermé","c7363d8a0748d4a7e2cc968335dc9716f290359d":"Arrêter le bot empêcheront d'autres trades. Les trades en cours seront complétés par notre système. S’il vous plaît soyez conscient que certaines transactions complétées ne peuvent pas être affichées dans le tableau si le bot est arrêté tout en plaçant des trades. Vous pouvez consulter la page de déclaration Binary.com pour les détails de toutes les transactions complétées.","fadc0ef93d1ff13370524ce8481ddc4a71195934":"Réorganiser verticalement","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"Télécharger","e4458464df6cbb8da1134875ba51519c5d244d9f":"Les blocs doivent être à l'intérieur des porte-blocs, des blocs principaux ou des fonctions principales","e9c45563358e813f157ba81b33143542165ba84e":"Avertissement","31cb6f44d030abeabcc7046555dea851602a87a5":"Cette stratégie n’est pas disponible dans votre pays.","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"OK","9970168c192807246fad6138344e5a96449afbdd":"Le fichier XML est vide. Veuillez vérifier ou modifier le fichier.","a594b427eaf0f108d3e9cc20d70e15da811c760c":"Stratégie non prise en charge","04a5090686ac7b54822e00a9ff08c38a107601e7":"Désolé, cette stratégie ne peut pas être utilisée avec Binary Bot. Vous ne pouvez l'utiliser qu'avec DBot.","77dfd2135f4db726c47299bb55be26f7f4525a46":"Annuler","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"Aller vers DBot","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"Le fichier que vous essayez d'ouvrir contient des éléments non pris en charge dans le bloc suivant : {$0} Veuillez vérifier votre fichier et réessayer.","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"Impossible de charger le fichier bloc","af145748c9cf765a3b059eec20cb1dbb899297d8":"Les blocs ont bien été chargés","11ee9c5d534cc8d22651092222b532917594161a":"La durée minimale est","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"Le nombre de ticks doit se situer entre 5 et 10","ace1342bc3720b77ce510b93074041e7386d209e":"L'heure d'expiration ne peut être identique à l'heure de début","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"La prédiction doit être un chiffre","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"doit être ajouté dans","33aa6ff282ee509d37c6f758274c9156b419ff73":"La stratégie que vous avez essayé d’importer est invalide.","da162a909c2981ed318d23cd9a6be1d66e0a8400":"Format de fichier non reconnu.","5e719fa76e1b6cb396376c82ebdd04bec7253229":"Les blocs distants à télécharger doivent être une collection.","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"Impossible de charger le fichier bloc.","df84a88f38b03b5b342362d72370b0d66afdae35":"La cible doit être un fichier xml","cd680fd936e9559ef1d95efac7a71680e2b13a89":"Cette URL est déjà chargée","34c59389053701a04127f74d32315e0206e076f8":"Une erreur est survenue lors de la tentative de chargement de l'Url","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"Vérifiez l'existence de « Access-Control-Allow-Origin » dans la réponse du serveur","988df856c066143616bd33d5904bbcdc22ff129e":"Binary.com migre vers Deriv","2fccaab15d71b00c19da7053135471d510b513db":"Tradez sur Deriv","3ead0b14c72503187691a7a6d7121987299bd401":"Ce n’est pas une version officielle du Bot binaire, utilisez à vos propres risques.","27401c9c8e476d659c8382e05c6d70a4a82be468":"Version officielle","bc981983e7f547dc62e19a1e383acfe00782a6d5":"Suivant","b52b36b7269fbfc58ec24bb724691951a3decbe8":"Retour","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"Terminé","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"Accédez à un aperçu rapide","a48e81d4a8da67637b46725824177a959fe99b21":"Êtes-vous prêt(e) à apprendre à comment utiliser Binary Bot ?","6f3e6ebf249947cec4f64117253a8fe43335ae79":"Non merci","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"Ne plus me le demander.","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"Espace de travail","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"Glissez et déposez des fichiers de blocs ou créez vos propres stratégies.","d171baee235d4c93f63755a876782dc5be4c3e47":"Boîte à outils des blocs","056f19272d96f902c38207cf163ea8dbff7fbd32":"Ajoutez des blocs à votre robot à partir d'ici.","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"Comptes","f5c47fd3b3553b10441a06054078cea745177dea":"Connectez-vous avant de démarrer votre robot. Veillez à toujours tester vos stratégies avec un compte virtuel.","fd825ae94aa79500a878dd4590a4b360e7162663":"Commandes robot","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"Contrôlez vos blocs. Pour obtenir des informations supplémentaires, maintenez le curseur sur chaque bouton.","f5169c84497de3aea74f7da9e7e177d1427e736b":"Nous vous souhaitons un agréable moment !","4f1b3d682c2a00b393c33637da402463bc11d5ff":"Vous souhaitez signaler un problème ou demander de l’aide ?","0049f8894e41937ebb9111cd3def6749049fb50f":"Cliquez ici","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"Où trouver Binary Bot sur Deriv","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"Sur la page d'accueil de Deriv, cliquez sur Trade en haut de la page et choisissez Binary Bot.","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"Essayer Binary Bot sur Deriv","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"C'est le même Binary Bot que vous connaissez et appréciez","169dd3b2025485a48b8f9f3f6ef89f5586714140":"Tout est exactement comme vous l'aimez.","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"Faites évoluer vos bots en toute transparence","b763f8cbfa6396f195781032619a99bba04bc939":"Vos stratégies de Binary.com peuvent être utilisées sur Deriv. Il suffit de charger vos fichiers XML et de commencer à trader.","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"7 plateformes de trading - les plateformes traditionnelles et des nouvelles aussi","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"Vous trouverez Binary Bot et SmartTrader aux côtés de nouvelles plateformes comme DBot et DTrader. Quel que soit votre style de trading, nous avons la plateforme qu'il vous faut.","0ce7480da93c1c9839818d0720b77931d1637574":"Dépôts en cryptomonnaie via fiat on-ramp","6e6a4c6839d2e859758a517865b095c1b8298dd6":"Effectuez facilement des dépôts en cryptomonnaie via des services d'échange tels que Changelly, Banxa et XanPool.","c1b51f196c97b4781a354457579e9699b09de087":"3 types de trade","4708f7e87263464b130b987e4b9aed981c4f455d":"Tradez les CFD, les options digitales et les multiplicateurs, un nouveau type de trade passionnant qui augmente vos profits potentiels avec un risque limité.","b7fceac7d5f885d735aeda6e4654487467d33fa3":"Dépôts et retraits en peer-to-peer","79a206119137878eb6be7c60f7ed34135194bdf0":"Échangez votre devise locale avec d'autres traders pour obtenir des fonds dans et hors de votre compte avec Deriv P2P.","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"6 types de marché","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"Développez votre portefeuille avec un large éventail de marchés tels que le forex, les actions, les cryptomonnaies, les synthétiques, et plus encore.","14b2a808fdec3702e5a6b9152e13288c87a4768a":"Apprenez avec Deriv Academy","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"Profitez d'articles et de vidéos gratuits pour vous aider à apprendre les ficelles du trading en ligne.","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"Cliquez pour sélectionner","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"Non disponible","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"Ticks","5fb1db527825d2996e37c655e5dec49d4da80c09":"Secondes","092f99ea11a34a8490e7a767a83a42fc45634f82":"Minutes","9e25a34e635a123f8958bbe26e7c4843278597fb":"Heures","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"Jours","db6708630fc646eb98298d9acd701e0a1ac051c2":"Sauvegardez vos blocs et stratégies sur Google Drive","85538d002a336c5addef8d189d80976cf7758f8c":"Vous êtes connecté en tant que","b65463cb6a42a17de514acc4659f7fd331e0876a":"Connecter","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"Déconnecter","cd5f85b6f187605f82386eacd680f93820af8d11":"Le résultat est","1e38ce3d180cefae485a6986ca7c67841e30376f":"Vrai si le résultat correspond à la sélection","5c89497fc3c128e2ff865ce8df15356054f2c028":"(4) Obtenir le résultat de votre opération et effectuer à nouveau une opération","14ea81918758c994cbe3178e695e56afc1ef2b45":"Obtenir les informations et le résultat de l'opération précédente, puis effectuer à nouveau une opération (s'exécute à la clôture de l'opération)","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"Détail du contrat :","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"Affiche une option sélectionnée dans la liste des détails du contrat","b3b543c80063a116ced4965d8537b7b62d14c0b7":"Exécuter à nouveau l'opération","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"Exécute à nouveau le bloc de trading","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"Prix de la demande","343fda69c73b78b84967055aae97f790c422adfd":"Prix de demande pour la proposition sélectionnée","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"Suivre le flux des ticks et acheter le contrat souhaité (s'exécute à la mise à jour des ticks)","9bb396940adb9705fe57eba6ea8b578e6aafa792":"Paiement","87da93a46d143f6019979b3548414d9d7adabb35":"Paiement pour la proposition sélectionnée","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"Achète le contrat sélectionné.","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"Une option de vente est disponible","03bad10717e183b24829baf483dc715e1a44bf7b":"Vrai si la vente au prix du marché est disponible","2c71ed279a402e93312dbda173ab18f244d6bf46":"(3) Suivre et vendre le contrat acheté","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"Suivre les informations relatives au contrat acheté et vendre au prix du marché sicette option est disponible (s'exécute à la mise à jour du contrat)","579607dc4f989ce2b94b558431666a0ab07ac1f3":"Vendre au marché","e20afd5cf3811a42071c9a312abb2afdad4c590b":"Vendre au marché.","4712cbff8e92822fc960ef9c0197293a19675eae":"Profits/pertes de vente","df817b48c7a076561b4f8bedc52d65d2e351ab52":"Indique les profits pour une vente au prix du marché.","b44e884c355e447d0da0e6ba45caaff18c84373b":"Bandes de Bollinger","d6a2a207343bd83aacdc80b579ff4419713a256e":"Liste d'entrée","170a28a9db6d27d7212fc6dc249434a57517e7bc":"Période","b833989d69900a4be9e32d1bab65c8f8233f099e":"Multiplicateur de l’Écart Type à la Hausse","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"Multiplicateur de l’Écart Type à la Baisse","974da601086448d0060aeed90e53ddd5acd17b91":"Calcule les Bandes de Bolliger (BB) à partir d'une liste avec une période","d5b65cac1f1cf9421ac978eebe532de99040cca6":"Tableau des Bandes de Bollinger","58de49791c64aba14e36e5887244a5ef088286cd":"Calcule la liste des Bandes de Bolliger (BB) à partir d'une liste avec une période","4bd99f76f1104229744455d93df0ff76b9eeed58":"Moyenne Mobile Exponentielle","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"Calcule la Moyenne Mobile Exponentielle (MME) à partir d'une liste avec une période","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"Tableau de la Moyenne Mobile Exponentielle","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"Calcule la liste de moyenne mobile exponentielle (MME) à partir d'une liste de valeurs avec une période","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"Tableau MACD","b18e572ea14edd48587145f1ef50718adbf256c6":"Période EMA rapide","974023bddd6249d0f6404872cfcae205b2599ea2":"Période EMA lente","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"Période du signal EMA","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"Calcule la liste de convergence/divergence de la moyenne mobile (MACD) à partir d'une liste","95ec92885c855ba9cf734c17a43f081901e4d2cc":"Indice de Force Relative","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"Index de force relative (RSI en anglais) d’une liste avec une période","4034de66995b876b2ba9bfd0274025e39168e05d":"Tableau d’Indice de Force Relative","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"Calcule la liste de l'Indice de force Relative (RSI en anglais) d’une liste de valeurs avec une période","a9842c95766da40bf4ea6ee263cb5a5985847763":"Moyenne mobile simple","347775a293c14362d492f019e677c965be1d6e7d":"Calcule la moyenne mobile simple (MMS) à partir d'une liste avec une période","4cc7b9e53d082896ad884eb01be16320af65f282":"Tableau de la Moyenne Mobile Simple","2c75179a57af3c36581008b65e86ed81c4a4cbea":"Calcule la liste de Moyenne Mobile Simple (MMS) à partir d'une liste de valeurs avec une période","39f024cf49724fe7ffdea7773c72ed06eec998e1":"avec intervalle","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"La direction est","ad47561efb1dcbd7246d9b64487f615647fda036":"Vrai si la direction correspond à la sélection","05bef508aadd62bf3967dcf67d769da296f19989":"Direction du tick","21bfc78607d3a64de767a6677d1db42156d5039d":"Indique la direction du tick reçu par un bloc « avant l'achat », sa valeur peut être « hausse » si le tick est supérieur au précédent, « baisse » si le tick est inférieur au précédent, ou vide ('') si le tick est égal au précédent","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"Le bloc de direction est obsolète, utilisez plutôt le bloc de direction contrôle","cdb31fc857f01a59f664413498293c714285f46d":"dans la liste de la bougie","20fd5f86f08796f145d69dedc209a27e459b2f51":"obtenir le numéro à partir de la fin","a96606af8c33ac3428b45abc4782dbf93f458d29":"Obtenir la énième récente bougie","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"Liste du dernier chiffre","248428facb97408414180d4de74e4db35360fbc4":"Retourne la liste des valeurs du dernier chiffre","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"Dernier chiffre","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"Indique le dernier chiffre du dernier tick","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"Liste des bougies","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"Retourne la liste de la bougie","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"Faites une Liste de","a4220593d385a720886f7af1ed3c478fd0c6339c":"valeurs dans la liste de bougies","cd8cdf3d47e921c8a72addae9269e66041d417c5":"Retourne une liste des valeurs de bougie sélectionnées","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"Lire la liste des bougies ","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"# à partir de la fin","aba43a580daa7f306956ec69b83e6e37e7233126":"Lire la valeur sélectionnée de bougie dans la nième récente bougie","e04b522218a181cf0223042dd18ae08dcc22d8d3":"Dernier tick","6ee445fc253a55c9ed54c009c3f020ac65200d80":"Retourne la valeur tick reçue par un achat avant bloc","ed44b69176217a1251c04f0c13d23ac789ea60b2":"Dernière chaîne de tick","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"Renvoie la valeur de tick reçue par un bloc avant achat (chaîne)","4b2340a890e88d1886757c3f7172e273a1edc31f":"Ce bloc est appelé pour chaque tick","b54d7b4590559dad64f02d09aacbf6d9863e2624":"Vous pouvez utiliser ce bloc pour analyser les ticks indépendamment de vos transactions","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"Liste des ticks","17649cac8739adcae95e641f794880272ad33bd1":"Retourne la liste des valeurs tick","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"Liste des chaînes de tiques","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"Renvoie la liste des valeurs de tick (chaîne)","c67ded6b64019212eb2bc69afd761f5b3f626040":"Ajouter un signe à un nombre pour définir une Marge de barrière.","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"Marché","74751e67c3e1010c343095eaf543e7cb21ced2ef":"Type d'option","1f4698382842477e211eb46de81fa506f01a8c34":"Les deux","c1baf816aac5a5cd849768773fc248cd249dc296":"Type de contrat :","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"Intervalle de bougie par défaut :","9693aeaaf68e3929b59b79306feaa0a847d01192":"Durée :","78d7103a319e808455d397513279d99f3b3f3768":"Investissement","10c02649e226d430bd75a5b6315a41c0db9992a2":"Barrière","837276742aa90209dde3b4eef07d8e7ab26731ef":"Prédiction ","258b49925b41751c6bd790a0848246566ba61440":"Redémarrer la procédure Acheter/vendre en cas d’erreur","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"désactiver pour améliorer les performances","b410994b67e37d9516eb9b866c85a8c639f79e68":"Redémarrez le dernier trade en cas d’erreur","2260c5a971c2602834ef8feeb5fa522f900b469f":"le bot ignore les trades infructueux","0745acf92abd7b60598f161717884cc45dab8694":"Exécuter une fois au démarrage","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"Définir les Options de Transaction","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"Définissez votre contrat de trading et initiez la transaction, ajoutez des initialisations ici. (Exécution à l'initialisation)","4d22b565e4253e92a908f216184779679bb1a044":"Barrière supérieure","b70c38c6db3127422e05315c30bdf76c7c36c480":"Barrière inférieure","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"Absolue","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"Solde :","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"Obtenir le numéro du solde ou chaîne","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"Les blocs situés à l'intérieur sont ignorés","d072c2ceeb5c1217722d14c74de7aeab945b4215":"Placez vos blocs ici pour empêcher leur suppression","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"Clé: %1 Valeur: %2","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"Renvoie une représentation sous forme de chaîne d'une paire clé/valeur","b06acc4158c824231f727a13e1c9811f43d5be42":"Télécharger bloc à partir de","661db37251a1ed1afe357ee13895f37a623d7cbf":"Télécharger des blocs à partir de l'URL","6c03ee54ad3a51fc92a1d69943e99667847705b6":"Notifier","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"avec du son","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"Crée une notification","6e0fc122f936f808bc2e3af661121b65712ae855":"Alerter Telegram %1 Jeton d'Accès : %2 ID de Conversation : %3 Message : %4","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"Envoie un message à Telegram","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"Total des profits","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"Retourne le total des profits","532e65f6e266db0bb442d1f426d44d7d32962340":"Chaîne de profit total","78e84591ff76f992953a8e19b57c7eab7546d638":"Renvoyer le profit total (chaîne)","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"Nb. d'exécutions","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"Retourne le nombre d'exécutions depuis le début","7d500ebe352ccfa932b253e21938813a06fcff8e":"Webhook URL: %1","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"Envoie une requête POST à ​​une URL","a35646754dbe7a9211ba8b81338a5d64580eb276":"Payload vide","69b0648eddd207cd45a9e1ba973dae287b535576":"Payload:","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"la bougie est-elle noire ?","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"Vérifie si la bougie concernée est noire et indique vrai si le cours de clôture est inférieur au cours d'ouverture dans la bougie en question.","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"Faites une liste de","5925d08228e246f07b790b88ad70c1b73a97d2bc":"valeurs dans la liste de bougies","852b438f91ad9eb2cdd84419a675a216d543c687":"Lire","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"valeur en bougie","d79d854dcd0829e2177a47beab6a55569e781ab1":"Lire un champ dans une bougie (lire à partir de la liste des bougies)","5606b4460ac96063b8a8e5647008f3ec97252fc5":"Secondes depuis Époque","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"Indique le temps d'époque (secondes depuis époque)","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"Exécuter toutes les","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"Seconde(s)","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"Exécuter les blocs inclus toutes les n secondes","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"L’exécution des bloc secondes est obsolète. S’il vous plaît contactez nous si vous avez un cas d’utilisation valide.","7b9c76088576a64f32d67ec335162b9f73eaa026":"Exécuter après","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"Exécuter les blocs inclus après n secondes","e9fb732dde76a6977bcaa2818b0f56125b183648":"À ce jour/heure","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"Convertit un nombre de secondes depuis Epoch en une chaîne représentant la date et l'heure. Exemple : 1546347825 sera converti en 2019-01-01 21:03:45.","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"A marquage temporel","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"Convertit une chaîne représentant une chaîne de date/heure en secondes depuis Epoch. Exemple: 2019-01-01 21:03:45 GMT + 0800 sera converti en 1546347825. L'heure et le décalage du fuseau horaire sont facultatifs.","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"Commencez à utiliser Deriv avec votre email et mot de passe Binary.com.","64f72129852fb7bdff0725c71324a012630f53bf":"Dans l'UE, les produits financiers sont offerts par Binary Investments (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malte, réglementé comme un fournisseur de Services d’investissement de Catégorie 3 par l'Autorité des Services Financiers de Malte ({$0}numéro de licence IS/70156{$1}).","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"Hors de l’UE, les produits financiers sont offerts par Binary (SVG) Ltd, Immeuble Hinds, Kingstown, Saint-Vincent-et-les-Grenadines ; Binary (V) Ltd, Immeuble Govant, Port Vila, PO Box 1276, Vanuatu, réglementée par la Commission des Services Financiers de Vanuatu ({$0}voir licence{$1}) ; Binary (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, Iles Vierges Britanniques, réglementée par la Commission des Services Financiers des Iles Vierges Britanniques ({$2}n° de licence SIBA/L/18/1114{$3}) ; et Binary (FX) Ltd., Lot No. F16, Premier Étage, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaisie, réglementée par l'autorité des Services Financiers de Labuan afin d’exploiter une entreprise de courtage monétaire ({$4}n° de licence MB/18/0024{$5}).","10dd345bc3319e2151794428b2c709dc5fc381a7":"Les services de ce site Web ne sont pas offerts dans certains pays comme les États-Unis, le Canada, le Hong Kong, le Japon ou aux personnes âgées de moins de 18 ans.","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"Avertissement de Risque","ad0fc99c05681528248b73007dba16fd760a81c6":"Les produits offerts par l’intermédiaire de ce site Web incluent des options binaires, des contrats de différence (« CFD ») et autres dérivés complexes. Le trading d’options binaires peut ne pas convenir à tout le monde. Le trading de CFD comporte un niveau élevé de risque étant donné que l’effet de levier peut fonctionner aussi bien à votre avantage qu'à votre désavantage. En conséquence, les produits offerts sur ce site peuvent ne pas être adaptés à tout investisseur, à cause du risque de perdre tout votre capital investi. Vous ne devez jamais investir l’argent que vous ne supporteriez pas de perdre et ne jamais trader avec de l’argent emprunté. Avant de trader les produits complexes offerts, veuillez être sûr de comprendre les risques impliqués et d'en savoir plus sur le {$0}Trading Responsable{$1}.","1fda2716eb92e0195ff59b110af23d86b43fd909":"Dans l'UE, les produits financiers sont offerts par Binary Investments (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malte, agréé et réglementé comme un fournisseur de Services d’investissement de Catégorie 3 par l'Autorité des Services Financiers de Malte (numéro de licence IS/70156).","be7786af641b859c03ec152461d791480cf676ed":"Dans l'île de Man et le Royaume Uni, les Indices de Volatilité sont offerts par Binary (IOM) Ltd., 1er étage, Millennium House, Victoria Road, Douglas, IM2 4RW, île de Man, îles Britanniques, autorisé et régulé respectivement par (1) la Commission de Supervision des Jeux dans l'île de Man (licence actuelle émise le 31 Août 2017) et par (2) la Commission des Jeux du Royaume-Uni (licence {$0}no référence: 39172{$1}).","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"Dans le reste de l’UE, les Indices de Volatilité sont offerts par Binary (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malte ; agréée et régulée par (1) l'Autorité des Jeux de Malte à Malte (no. de licence MGA/B2C/102/2000 délivré le 1er août 2018), pour les clients britanniques par (2) la Commission des jeux du Royaume Uni (licence {$0}référence ne : 39495{$1}) et pour les clients irlandais par (3) les Commissionaires du Revenu en Irlande (Licence de bookmaker à distance n ° 1010285 publié le 1er juillet 2017). Voir l'ensemble des {$2}informations réglementaires{$1}.","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"Binary.com est un fournisseur de trading en ligne primé qui aide ses clients à trader sur les marchés financiers par le biais d’options binaires et CFDs. Le Trading d’options binaires et CFDs sur Indices de volatilité est classé comme une activité de jeu. N’oubliez pas que le jeu peut être addictif – veuillez jouer de façon responsable. En savoir plus sur le {$0}Trading responsable{$1}. Certains produits ne sont pas disponibles dans tous les pays. Les services du site Internet ne sont pas rendus disponibles dans certains pays comme les Etats-Unis, Canada, Hong Kong, ou aux personnes de moins de 18 ans.","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"Le trading d’options binaires peut ne pas convenir à tout le monde, donc veuillez vous assurer que vous comprenez les risques encourus. Vos pertes peuvent dépasser votre dépôt initial et vous ne possédez ni n'avez aucun intérêt dans l’actif sous-jacent.","496a99878841de69368c33af9e88eb37c0da5712":"Les CFD sont des instruments complexes et comportent un risque élevé de perdre rapidement de l'argent en raison de l'effet de levier. 78,6% des comptes d'investisseurs particuliers perdent de l'argent lors du trading de CFDs. Vous devriez vous demander si vous comprenez le fonctionnement des CFDs et si vous pouvez vous permettre de prendre le risque élevé de perdre votre argent.","a726d863bbdceba7b06a1083026a53db76de47b7":"Tradez les multiplicateurs","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"Amplifiez votre profit potentiel sans risquer plus que votre mise.","febe8aef26fb3017be5bf43d66f7972731c20833":"Paiements en peer-to-peer","a8c1114d1c88db12afa05b331188ceb77afad6e3":"Indices Crash/Boom","d29324705a18a81ffc0376f3f37639a68827f3e6":"Prédisez et bénéficiez potentiellement de pics et de creux passionnants. Disponible uniquement avec les multiplicateurs sur DTrader.","ba2098a209e375402a0cf222cec87cce26440767":"En exclusivité sur Deriv","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"Un bel avenir vous attend.","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"Retrouvez ces fonctions supplémentaires et plus encore sur Deriv :","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"Découvrir","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"SmartTrader","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"Notre plateforme traditionnelle de trading d'options","64dfd7424a05133b74cfb93fcbe385ede6539855":"Notre plateforme traditionnelle de trading automatisé","824d76b124e6289f372e2ff6bcba91e8939343bd":"En savoir plus","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"Deriv MT5","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"La célèbre plateforme mondiale de trading de CFD","54617a018fc6dffb3a70627b97f0db5c52a4081d":"DTrader","dbcd68f389d64fc531a650652c87b7d83fc82d94":"Notre plateforme phare de trading d'options et de multiplicateurs","dd69c213333a751a0ab3bc9ce6368588bf971b61":"DBot","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"Notre plateforme de trading automatisée de nouvelle génération","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"Deriv GO","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"Tradez n'importe où avec notre plateforme de trading mobile","f63714db18c58c6b4a7a7bad09178faaeca05104":"Deriv X","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"Notre plateforme de trading de CFD personnalisable","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"Tout ce que vous aimez sur Binary.com et plus encore","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"Choisir parmi 7 plateformes","029582bad299ab8f44c57b961210e56569efd536":"Vous trouverez SmartTrader et Binary Bot aux côtés de nouvelles plateformes comme DTrader et Deriv X. Quel que soit votre style de trading, nous avons la plateforme qu'il vous faut.","9a07439b57e510e8e33b372aad2c360dbc39e79c":"Tradez les CFD, les options digitales et les multiplicateurs, un nouveau type de trade passionnant qui augmente vos profits potentiels avec un risque limité.","3d0be0e8eb736257254698ba821c45389e385f1e":"Dépôts en crypto via fiat on-ramp","c4303d30e60f01fa922400e52df4e96d71b35d6e":"Plus de 100 instruments","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"Tradez ce que vous voulez : forex, matières premières, actions, indices boursiers et indices synthétiques. ","f30ce7459f29851b219b504216581bf3d3446de0":"Aide lorsque vous en avez besoin","6df6091514ee13992a3ac28445af1d9a1afbcb67":"Bénéficiez d'un service client 24h/24 et d'un accès au centre d'aide.","92c8b7b779e7cf179b89484285fd766274b3bf1f":"Explorez Deriv dès maintenant","a87a92c5ce4925186a081cf4478639fcc31b12ed":"Dans l'UE, les produits financiers sont proposés par Deriv Investments (Europe) Limited, W Business Centre, Level 3, Triq Dun Karm, Birkirkara BKR 9033, Malte, titulaire d'une licence à Malte ","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"(licence no. IS/70156)","720280451c98ceeb796f3c7fa118813fc8da694d":"et réglementé par la Malta Financial Services Authority, Triq l-Imdina, Zone 1, Central Business District, Birkirkara CBD 1010, Malte, en vertu de la loi sur les services d'investissement. Autorisé par la Financial Conduct Authority et avec une modification présumée de l'autorisation. Soumis à la réglementation de la Financial Conduct Authority. La nature et l'étendue des protections des consommateurs peuvent différer de celles des entreprises basées au Royaume-Uni. Les détails du régime des contrats de services financiers, qui permet aux entreprises basées dans l'EEE d'opérer au Royaume-Uni pendant une période limitée pour exercer des activités nécessaires à l'exécution de contrats préexistants, sont disponibles sur le site web de la Financial Conduct Authority.","0f1dda628bebb4748de6df05fa3bff4989c1b476":"En dehors de l'UE, les produits financiers sont proposés par les sociétés suivantes : Deriv (FX) Ltd, F16, Level 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaisie, autorisée par la Labuan Financial Services Authority ","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"(licence no. MB/18/0024);","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"Deriv (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, Îles Vierges britanniques, agréé par la Commission des services financiers des Îles Vierges britanniques ","a56aa088dfea506d5dbe18f385c29418f771a639":"(licence no.SIBA/L/18/1114);","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":" Deriv (V) Ltd, 1276, Kumul Highway, Port Vila, Vanuatu, autorisée et réglementée par la Commission des services financiers de Vanuatu ; et Deriv (SVG) LLC, Hinds Buildings, Kingstown, St. Vincent et les Grenadines.","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"Deriv Limited — 13 Castle Street, St. Helier, JE2 3BT, Jersey — est la société holding des filiales ci-dessus.","74e8fa69aad80f93303a7723e5a304f3d43560b6":"Les services de ce site Web ne sont pas disponibles dans certains pays, y compris les États-Unis, le Canada et Hong Kong, ni aux personnes de moins de 18 ans.","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"Les CFD sont considérés comme des dérivés complexes et peuvent ne pas convenir aux clients de détail. Les CFD sont des instruments complexes et comportent un risque élevé de perdre de l'argent rapidement en raison de l'effet de levier. Vous devez vous demander si vous comprenez comment fonctionnent les CFD et si vous pouvez vous permettre de prendre le risque élevé de perdre votre argent. Les produits mentionnés ici peuvent être affectés par les variations des taux de change. Si vous investissez dans ces produits, vous risquez de perdre tout ou partie de votre investissement et la valeur de votre investissement peut fluctuer. Vous ne devriez jamais investir de l'argent que vous ne pouvez pas vous permettre de perdre et ne jamais trader avec de l'argent emprunté.","5bb3f3499158dbe30af5c725694b321dfe821433":"Avant de trader les produits financiers complexes proposés, assurez-vous de bien comprendre les risques encourus et de vous renseigner sur ","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"Trading sécurisé et responsable.","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"On déménage !","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"Nous sommes","991753597fde70aab5791de6d50ee8cc49a0bdcc":" Binary.com","efa99ab039a285c6264580bea691a4ffefcbeee7":" depuis deux décennies et il est temps d'ouvrir un nouveau chapitre passionnant.","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"Découvrez notre nouveau site,","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":" Deriv.","52b8454dc755419beeff2f90cd0fc91def428244":"Bonjour Deriv !","27ad1d8334221366694c7acdd70fb380857d1e6e":"Peut-être plus tard","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"Aller vers Deriv","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"Il est si facile de passer à Deriv","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"Connectez-vous simplement en utilisant vos identifiants Binary.com. Aucune inscription n'est nécessaire.","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"Essayez dès maintenant","63fbf7977349e32e4a124ffa047549b720806d73":"Ayez toujours Deriv sur vous","03d42257a2263b2841b9e0ae4b94de117228a33a":"Téléchargez l'appli mobile Deriv GO et tradez où que vous soyez. Ne manquez plus jamais les occasions en or.","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"Scannez ce QR code pour télécharger Deriv GO","6b7499b1513a3cec3da3ff07cdad9b358954021e":"N'attendez pas","b23efda40ddeb801beeebf915669d806744014af":"Assurez l'avenir de vos transactions. Venez sur Deriv dès à présent.","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"Entrez dans l'univers de Deriv","34075438f939258908cc21d28bf59ab5126dc2d6":"Venez sur Deriv et préparez vos futurs trades dès maintenant.","e669443b63757b5ad8571e52393caf2a0a812be3":"6 raisons pour lesquelles vous adorerez Deriv","2c141583afaaa12438b16ee67355c6e3eaf77763":"Binary Bot a une nouvelle adresse","4e0e045da59b385138ced3203cdb81c3b4cdd135":"Nous sommes Binary.com depuis deux décennies et il est temps d'entamer un nouveau chapitre passionnant. Votre constructeur de robots préféré, Binary Bot, est maintenant sur Deriv, notre nouvelle adresse. Venez y jeter un coup d'œil.","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"Aller vers Binary Bot sur Deriv","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"Utilisez Binary Bot sur Deriv, notre nouvelle adresse","1071c645f523394b408a6d285e95331bc583f14c":"En 5 minutes, nous vous montrerons les avantages du trading de Binary Bot sur Deriv. Si vous ignorez ce message, nous vous le rappellerons dans 3 semaines.","be43a8989c5745ec7386ca7c69442165f55dee8e":"Montrez-moi les avantages maintenant","074603c9aef93515ed33d179e982c67ea7abdb45":"Tradez Binary Bot sur Deriv"}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"Logic","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"Math","c3328c39b0e29f78e9ff45db674248b1d245887d":"Text","4d064726954a17487f94e931f5b157b733ec22ed":"Advanced","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"List","19de69cb601f53a4ea7af22a65c71ae63251365c":"Variable","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"Functions","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"Loop","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"Binary","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"Trade Definition","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"Before Purchase","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"During Purchase","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"After Purchase","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"Tick Analysis","8cf71374fa095a64b5295b672daef8507ec7be6a":"Indicators","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"Tools","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"Time","8d8fd6765e184419cad8b88d1a60c895d79578c2":"Candle","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"Misc.","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"Log","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"Summary","9feddbabd7e7309e96c590069057158e96baa8f6":"Reality Check","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"Options trading can become a real addiction, as can any other activity pushed to its limits. To avoid the danger of such an addiction, we provide a reality-check that gives you a summary of your trades and accounts on a regular basis.","4152043e8c670075d2c919677e835edb0d923cab":"Please specify your preferred reality-check interval in minutes","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"Please enter a number between 10 to 60.","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"Continue Trading","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"Statement","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"Log out","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"Contact us","f7c400ed695f898b8ee9d21664aa17b5bb693828":"Log in","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"Reset the blocks to their initial state","f98595d541778d86f75ef22b3328a031d20aa16b":"Load new blocks (xml file)","4a1e616226c329a94da7768bc0435a3284478010":"Save the existing blocks (xml file)","6b3465ace62f33f0687b4669ac26d95895e9ca52":"Connect Binary Bot to your Google Drive to easily save and re-use your blocks","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"Undo the changes (Ctrl+Z)","937f5055f05be359ddf619744e8af4d643549e80":"Redo the changes (Ctrl+Shift+Z)","8406d1cce44230835932060649e999ca3283b413":"Zoom In (Ctrl + +)","1109673172af2c173c492622ff8a72c8f29f0e70":"Zoom Out (Ctrl + -)","44c22002c65d2871331263a23c3e09c0a1bfd847":"Rearrange Vertically","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"Show/hide the summary pop-up","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"Run the bot","ba50a42d8d3228c37a817865fce49fbca692c2ad":"Stop the bot","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"Show log","91017ef9b165cd0e7475a770f318ea5e705e1321":"Show chart","c89e3dd1cafcadcc0312e476ab58b2332209da23":"Show Trading View","b02c858e72be118a65c9393930351012b647cb9e":"Toggle header","250be77f7605669a0b3d968b9ed381a3d9787ed1":"Open an already saved XML file and retrieve its blocks","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"Binary Bot","608061fb5aab975013fa70c5c814a1d8ba30c152":"Trade More Efficiently Than You Ever Thought Possible","e4ce8dc3e416e69262ba642dc57d3975d6616980":"Interested in automating your preferred strategies for trading binary options?","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"Binary Bot is our leading-edge programming tool which allows you to build trading apps with a simple","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"Dream up any number of binary options trading bots, from incredibly simple formulas to vastly complex algorithms. Then let them trade for you, even while you sleep.","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"Begin Building a Bot Now","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"Need further assistance?","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"NEED HELP?","d635b53e59c9aad8c5d78458826beffb029b27bf":"Thank you, we'll get back to you within 24 hours","a69a8fc21499d0fd85e87bab467699827547a5bc":"Please enter a valid server URL","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"Underlying market is not selected","50050f06645ad2743165b429a8f7deebd285fd63":"Contract type is not selected","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"Please login","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"Duration must be a positive integer","4df6e872792d72aea8a2f6b831d00b554464da23":"Amount must be a positive number","001e68df3a4b32a4d57148d9d407f44eee3b7436":"Given candle is not valid","04f14ea7c92e0b2b5ae005c696245063ec641d66":"Given candle list is not valid","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"retrying in","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"Rate limit reached for","094628ce13fc0e78f07b697d1cc9421bb2edd666":"Request failed for","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"No","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"Yes","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"statement","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"ask price","50e72909992bdc37c7c07769d1b7efac5e52874c":"payout","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"profit","c980b910204c7babdffe8ff3f7e755f30133383c":"contract type","a726c6955157f1b8b92f9932652434a7150f80f8":"entry spot","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"entry value","3905be81561384dc8c43d6127c57ed1e0eb03b74":"entry value string","7674920c033ca14277c577e19c037a6754d4fa80":"exit spot","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"exit value","06ecea26625359f7dcf5ff5c47af6174ff815257":"exit value string","779455ee3bde8494d9629b353e17b19e92357ba8":"barrier","37a5301a88da334dc5afc5b63979daa0f3f45e68":"result","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"Win","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"Loss","563339f82447b4e758ad76d5a0b63b5698594fba":"Rise","5c1ae82c29543ac887703776bf3da2c7dcce683d":"Fall","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"No Change","ecb252044b5ea0f679ee78ec1a12904739e2904d":"string","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"number","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"green","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"blue","96de5543d183d7de52ac5fa21c46fc811f673f89":"yellow","78988010b890ce6f4d2136481f392787ec6d6106":"red","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"Silent","cf84a98d6cf7f156862a08ba8236467b6f471004":"Announcement","eee2facd669d1434848c24da5527b3e87d9a12d5":"Earned money","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"Job done","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"Error","a3b1583d377f37ac20de7e089edfa0920a078e57":"Severe error","66c8b6848eee629c4ac551bf2b5fa591571654be":"Rise Equals","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"Fall Equals","062787aa328047e189774b3703d983b83938f6e9":"Higher","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"Lower","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"Touch","7d7932bcc2e262ae98cf09dc5445130fb3881769":"No Touch","a16814a48ec58c2e24ba224a80921a5c02361abe":"Ends In","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"Ends Out","534ec5da4e82ec419abc170e1a8448f55a01664f":"Stays In","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"Goes Out","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"Asian Up","c098658ce3d3a258e4d155949a60072966b36db7":"Asian Down","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"Matches","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"Differs","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"Even","dc28f5f3c65ec611f0f30022650d24382d27448e":"Odd","18a63f5512afb5573e5b44deba78d629f0635317":"Over","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"Under","2155c8b38181dd2552e84a94049aacd33ef9c607":"High Tick","1408cfd2b064b923f024fbe590e27db8282941a5":"Low Tick","b86eb15dc4f13e4c2972de158d3038d9f657242f":"Reset Call","669a1f3d9a8f601a84da536cfdad1de4092b1926":"Reset Put","844d1a5c99a0a668383340cc095d040eef998c79":"Only Ups","87293a146cd481a2b30cf74282ec061dc4cf0735":"Only Downs","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"Open","b1a5954a483f8f8b0207385095f74aeb409b3f80":"High","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"Low","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"Close","1173872a4fb205b713702f0eec5cf2c732c828fd":"Open Time","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"Default","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"1 minute","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"2 minutes","24e46784cbce32443db5a2638b1a7d3201543e9b":"3 minutes","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"5 minutes","a6f151883b736f0470d33492e61c72a7d059d065":"10 minutes","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"15 minutes","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"30 minutes","f030c3d667652646b86732ad7bc67e226c49cd3a":"1 hour","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"2 hours","7b47150d431db70d783724007f07ab894eb8ac2e":"4 hours","191800b7e9a48680792c0dd77cb6cac00c4514c6":"8 hours","2d8a6f7c34468578640b333b8650131de06ac770":"1 day","cd1495cb4c60266a6abad9024022ae079bf7e416":"(1) Define your trade contract","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"(2) Watch and purchase your contract","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"Trade Options","160f06d4799c85021a810f68c5b517eea37a2737":"Purchase","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"Up/Down","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"Up/Down Equals","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"Asians","2260ce49306460c8a2ef501939f29ad6ddd4e934":"Digits","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"Touch/No Touch","f7de1f66f0979667da275b7e8996e805395025a1":"Ends In/Out","a431deecd4c2258097adae418d496fe9a8179fee":"Stays In/Goes Out","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"High/Low Ticks","12a3f461cdebbc8f335190413ee6c57442743bba":"Reset Call/Reset Put","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"Only Ups/Only Downs","91a64e3f83c91acf336c631fba295f297f94c399":"Run After n Seconds","024696596f26a4db232fd9e966eadfeb27c0bd1a":"Run Every n Seconds","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"upper","85c274929bc0e28eafd3734f2c25046c3b95b36b":"middle","346e3ee198e98146993894d3de8ecab1a86c3e80":"lower","f16459104f92ab6b38aa265adb4ecbfc3768e303":"Histogram","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"MACD","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"Signal","19eabc961735d78f12fc7be906ffcb033853cf85":"Timestamp","68f4145fee7dde76afceb910165924ad14cf0d00":"Message","e99811bd3b1ad17e74614060ecb180602be35ad6":"Logged you out!","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"block should be added to the workspace","1fde9f1ebca07dcbc704130bd18645bce7718b55":"block should be enabled","d466687f90ba548434d65186d11a80c4204f9ad6":"must be added inside:","629777b7d4d610ace6dee24442730f27d7d0853e":"File is not supported:","0b93c14956403c2e5c9e79f5c836babc56912006":"Binary Bot will not place any new trades. Any trades already placed (but not expired) will be completed by our system. Any unsaved changes will be lost.","c1458ff86fd60d9544d7cd8a67437df2b766f482":"Note: Please see the Binary.com statement page for details of all confirmed transactions.","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"Any unsaved changes will be lost.","410bf23a3f080def9c7a976a16305bcde7943ed1":"Are you sure?","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"Unfortunately, Binary Bot isn’t available in your country","901624741023fcfc805ce43c94b8012e3b1d1c99":"Want to trade CFDs on MT5? You’ll have access to forex, stocks, stock indices, commodities, cryptocurrencies, and synthetics.","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"Strategies","910ec7aa40b04ec6ba51162f4de7850569326cb6":"There was an error loading Google API script.","8f51f350debde84e067e1a0405fb6304922a7d4b":"There was an error initialising Google Drive.","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"There was an error loading Google Drive libraries","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"Please grant permission to view and manage your Google Drive files","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"Unrecognized file format","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"There was an error retrieving data from Google Drive","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"Select a Binary Bot strategy","2db43c69a4b96454914f0b8272bc869984529e6e":"There was an error listing files from Google Drive","0dcea5f584938e0fff00084b83156ab31d641ab3":"There was an error retrieving files from Google Drive","18da95988117ff029393f3f5c881d70ef47f7385":"There was an error processing your request","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"Select a folder","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"The Telegram notification could not be sent","3f370309b6280eb100f898426d8605c1f45d558d":"Invalid timestamp","af6a4e2a5582be89ac930e946eaed86e01cac58b":"Invalid date/time","49d51398b574e7312d99b18d2b93d2ede416f053":"Unable to send webhook","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"Proposals are not ready","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"Selected proposal does not exist","6ea4a034747d020b1d8ce4848def95d537555dd6":"Bought","89f89c02cf47e091e726a4e07b88af0966806897":"ID","1200c1af2f7bba4e29a34112865662748c9d41df":"Resale of this contract is not offered.","62d6180e55905f7b996d442c53631981a4ef8b5b":"Sold for","ed4978867de1da05b336b724a3fb96222a29ebec":"Index must be a positive integer","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"Profit amount","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"Loss amount","46fc6f27a835486d63d9e927c6687e4508cb3087":"Maximum number of trades reached","9202ddae4cea16513e53bbc965d88ed975e59512":"Maximum loss amount reached","5f52b397b7e5f538681f0f5717a88aa626349c7a":"Bot.init is not called","66c7734789e19cbeef3a5ac185ea732139aed213":"Chart","3b662fb2e8bafce29aa98321b18874bb44905488":"Google Drive Integration","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"Please set your daily loss limit in the Self-Exclusion Facilities page to allow trading.","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"Maximum consecutive trades should be between 1 and 100","93039e609d94a24f3572b794a31b21525a09af2b":"Not set","a85b8cc112a8597df1612d60a74faa818c25d1b3":"We require you to set trade limitations in compliance with business regulations. Please note that your bot will only stop trading if any or both of the conditions below are met.","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"Daily limit on losses:","95052a29f213e9698b593418fe396ecc21032f9b":"This is the threshold that limits your potential losses for the day in all Binary.com platforms. Once your total loss reaches or exceeds this amount, your bot will stop trading. Please set a value in the {$0}Self-Exclusion Facilities page{$1}.","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"Maximum consecutive trades","730657200c17321d926e1bd08dbf65bd96855a8a":"This is the maximum number of trades that you allow your bot to execute for this run.","952f375412e89ff213a8aca383d18e5691354347":"Start","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"Trade Limitations","095ba68888b5ace5f4515f5acab76dfa1073544e":"My computer","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"Load","248e224f533752db28a1aab3519a58569ad96140":"Load blocks","c7097e97dcc446ca889d3ca6be733a65e2728afe":"Successfully uploaded to Google Drive","a6b977714595aa01678fca98e86553aaeac05c92":"Save your blocks individually in a collection. They will be added to your existing workspace (main blocks will be replaced) when loaded.","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"Save as collection","611ebbfb080284312904de925ef0f75f4cb56ad2":"Save your blocks and settings for re-use in other strategies","efc007a393f66cdb14d57d385822a3d9e36ef873":"Save","a638caa8ab2b7ff7980a571334217339e6d1d634":"Save blocks","39fca63515c105918f03e4908ec12df675b07f92":"Trading View","e643975ea5296d9de4486458f31ab0a5a2b228bf":"This will clear all transactions in the summary panel, and all counters will be reset to zero.","85dfa32c97d8618d1bea083609e2c8a29845abe5":"Account","d847919a30d31c0be624087f3370492b3fdf80c6":"No. of runs","5cd6978d63540c8a490ef76f43219de6362f958e":"Total stake","17410d7b62b8b1de981cfebada24632987edf186":"Total payout","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"Total profit/loss","90eef613042c5a51f542421065b68b886d473807":"Balance","db1c784524e1b54011a95823026161f7c8517fe0":"Reference","4db3e9e4aecd187db9339a10d2629fef46724dc4":"Trade type","1bb4086b66659d8580f9be4beef69931aeea3cad":"Entry spot","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"Exit spot","ba7be969e7c1bb5f22489e843478e3d721aaa843":"Buy price","772fbced18230220d2d9be1456be16fc1b271d25":"Profit/Loss","bae7d5be70820ed56467bd9a63744e23b47bd711":"Status","96f608c16cef16caa06bf38901fb5f618a35a70b":"Pending","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"Settled","82a82f798dd773717ec37d15fd4405510291734e":"Bot is not running.","6a88e58aa1798626f94cf17f1a91618b405bb289":"Bot is starting...","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"Bot is running...","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"Bot is stopping...","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"Bot has stopped.","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"Attempting to Buy","4684ee1026d9b4c872d016c3c4588a0c479a451c":"Buy amount","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"Buy succeeded","f02760cd2eac28169f0a990c950c3dfe8427f772":"Contract closed","c7363d8a0748d4a7e2cc968335dc9716f290359d":"Stopping the bot will prevent further trades. Any ongoing trades will be completed by our system. Please be aware that some completed transactions may not be displayed in the table if the bot is stopped while placing trades. You may refer to the Binary.com statement page for details of all completed transactions.","fadc0ef93d1ff13370524ce8481ddc4a71195934":"Rearrange vertically","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"Download","e4458464df6cbb8da1134875ba51519c5d244d9f":"Blocks must be inside block holders, main blocks or functions","e9c45563358e813f157ba81b33143542165ba84e":"Warning","31cb6f44d030abeabcc7046555dea851602a87a5":"This strategy is not available in your country.","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"OK","9970168c192807246fad6138344e5a96449afbdd":"XML file is empty. Please check or modify file.","a594b427eaf0f108d3e9cc20d70e15da811c760c":"Unsupported strategy","04a5090686ac7b54822e00a9ff08c38a107601e7":"Sorry, this strategy can’t be used with Binary Bot. You may only use it with DBot.","77dfd2135f4db726c47299bb55be26f7f4525a46":"Cancel","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"Take me to DBot","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"The file you’re trying to open contains unsupported elements in the following block: {$0} Please check your file and try again.","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"Unable to load the block file","af145748c9cf765a3b059eec20cb1dbb899297d8":"Blocks are loaded successfully","11ee9c5d534cc8d22651092222b532917594161a":"Minimum duration is","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"Number of ticks must be between 5 and 10","ace1342bc3720b77ce510b93074041e7386d209e":"Expiry time cannot be equal to start time","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"Prediction must be one digit","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"must be added inside","33aa6ff282ee509d37c6f758274c9156b419ff73":"The strategy you tried to import is invalid.","da162a909c2981ed318d23cd9a6be1d66e0a8400":"Unrecognized file format.","5e719fa76e1b6cb396376c82ebdd04bec7253229":"Remote blocks to load must be a collection.","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"Unable to load the block file.","df84a88f38b03b5b342362d72370b0d66afdae35":"Target must be an xml file","cd680fd936e9559ef1d95efac7a71680e2b13a89":"This url is already loaded","34c59389053701a04127f74d32315e0206e076f8":"An error occurred while trying to load the url","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"Make sure 'Access-Control-Allow-Origin' exists in the response from the server","988df856c066143616bd33d5904bbcdc22ff129e":"Binary.com is moving to Deriv","2fccaab15d71b00c19da7053135471d510b513db":"Trade on Deriv","3ead0b14c72503187691a7a6d7121987299bd401":"This is not an official version of Binary Bot, use at your own risk.","27401c9c8e476d659c8382e05c6d70a4a82be468":"Official Version","bc981983e7f547dc62e19a1e383acfe00782a6d5":"Next","b52b36b7269fbfc58ec24bb724691951a3decbe8":"Back","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"Done","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"Take a quick tour","a48e81d4a8da67637b46725824177a959fe99b21":"Ready to learn how to use Binary Bot?","6f3e6ebf249947cec4f64117253a8fe43335ae79":"No Thanks","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"Do not ask me again.","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"Workspace","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"Drag and drop block files or make your own strategies.","d171baee235d4c93f63755a876782dc5be4c3e47":"Blocks toolbox","056f19272d96f902c38207cf163ea8dbff7fbd32":"Add more blocks from here to your bot.","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"Accounts","f5c47fd3b3553b10441a06054078cea745177dea":"Login before starting your bot. Always test your strategies with the virtual account.","fd825ae94aa79500a878dd4590a4b360e7162663":"Bot controls","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"Control your blocks. Hold the cursor on each button for more info.","f5169c84497de3aea74f7da9e7e177d1427e736b":"Enjoy!","4f1b3d682c2a00b393c33637da402463bc11d5ff":"Want to report an issue or ask for help?","0049f8894e41937ebb9111cd3def6749049fb50f":"Click here","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"Where to find Binary Bot on Deriv","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"On the Deriv homepage, hit Trade at the top of the page and choose Binary Bot.","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"Try Binary Bot on Deriv","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"It’s the same Binary Bot you know and love","169dd3b2025485a48b8f9f3f6ef89f5586714140":"Everything is exactly the way you like it.","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"Bring your bots across seamlessly","b763f8cbfa6396f195781032619a99bba04bc939":"Your strategies from Binary.com can be used on Deriv. Just load your XML files and get trading.","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"7 trading platforms — old favourites and new ones, too","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"You’ll find Binary Bot and SmartTrader alongside new platforms like DBot and DTrader. Whatever your trading style, we’ve got the platform for you.","0ce7480da93c1c9839818d0720b77931d1637574":"Cryptocurrency deposits via fiat on-ramp","6e6a4c6839d2e859758a517865b095c1b8298dd6":"Make crypto deposits easily via exchange services such as Changelly, Banxa, and XanPool.","c1b51f196c97b4781a354457579e9699b09de087":"3 trade types","4708f7e87263464b130b987e4b9aed981c4f455d":"Trade CFDs, digital options, and multipliers, a new, exciting trade type that boosts your potential profits with limited risk.","b7fceac7d5f885d735aeda6e4654487467d33fa3":"Peer-to-peer deposits and withdrawals","79a206119137878eb6be7c60f7ed34135194bdf0":"Exchange your local currency with fellow traders to get funds in and out of your account with Deriv P2P.","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"6 market types","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"Expand your portfolio with a wide range of markets such as forex, stocks, cryptocurrencies, synthetics, and more.","14b2a808fdec3702e5a6b9152e13288c87a4768a":"Learn with Deriv Academy","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"Enjoy complimentary articles and videos to help you learn the ropes of online trading.","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"Click to select","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"Not available","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"Ticks","5fb1db527825d2996e37c655e5dec49d4da80c09":"Seconds","092f99ea11a34a8490e7a767a83a42fc45634f82":"Minutes","9e25a34e635a123f8958bbe26e7c4843278597fb":"Hours","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"Days","db6708630fc646eb98298d9acd701e0a1ac051c2":"Save your blocks and strategies to Google Drive","85538d002a336c5addef8d189d80976cf7758f8c":"You are logged in as","b65463cb6a42a17de514acc4659f7fd331e0876a":"Connect","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"Disconnect","cd5f85b6f187605f82386eacd680f93820af8d11":"Result is","1e38ce3d180cefae485a6986ca7c67841e30376f":"True if the result matches the selection","5c89497fc3c128e2ff865ce8df15356054f2c028":"(4) Get your trade result and trade again","14ea81918758c994cbe3178e695e56afc1ef2b45":"Get the previous trade information and result, then trade again (Runs on trade finish)","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"Contract Detail:","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"Reads a selected option from contract details list","b3b543c80063a116ced4965d8537b7b62d14c0b7":"Trade Again","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"Runs the trade block again","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"Ask Price","343fda69c73b78b84967055aae97f790c422adfd":"Ask Price for selected proposal","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"Watch the tick stream and purchase the desired contract (Runs on tick update)","9bb396940adb9705fe57eba6ea8b578e6aafa792":"Payout","87da93a46d143f6019979b3548414d9d7adabb35":"Payout for selected proposal","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"Purchases a chosen contract.","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"Sell is available","03bad10717e183b24829baf483dc715e1a44bf7b":"True if sell at market is available","2c71ed279a402e93312dbda173ab18f244d6bf46":"(3) Watch and sell your purchased contract","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"Watch the purchased contract info and sell at market if available (Runs on contract update)","579607dc4f989ce2b94b558431666a0ab07ac1f3":"Sell at market","e20afd5cf3811a42071c9a312abb2afdad4c590b":"Sell at market.","4712cbff8e92822fc960ef9c0197293a19675eae":"Sell profit/loss","df817b48c7a076561b4f8bedc52d65d2e351ab52":"Returns the profit for sell at market.","b44e884c355e447d0da0e6ba45caaff18c84373b":"Bollinger Bands","d6a2a207343bd83aacdc80b579ff4419713a256e":"Input List","170a28a9db6d27d7212fc6dc249434a57517e7bc":"Period","b833989d69900a4be9e32d1bab65c8f8233f099e":"Std. Dev. Up Multiplier","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"Std. Dev. Down Multiplier","974da601086448d0060aeed90e53ddd5acd17b91":"Calculates Bollinger Bands (BB) from a list with a period","d5b65cac1f1cf9421ac978eebe532de99040cca6":"Bollinger Bands Array","58de49791c64aba14e36e5887244a5ef088286cd":"Calculates Bollinger Bands (BB) list from a list with a period","4bd99f76f1104229744455d93df0ff76b9eeed58":"Exponential Moving Average","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"Calculates Exponential Moving Average (EMA) from a list with a period","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"Exponential Moving Average Array","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"Calculates Exponential Moving Average (EMA) list from a list of values with a period","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"MACD Array","b18e572ea14edd48587145f1ef50718adbf256c6":"Fast EMA Period","974023bddd6249d0f6404872cfcae205b2599ea2":"Slow EMA Period","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"Signal EMA Period","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"Calculates Moving Average Convergence Divergence (MACD) list from a list","95ec92885c855ba9cf734c17a43f081901e4d2cc":"Relative Strength Index","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"Relative Strength Index (RSI) from a list with a period","4034de66995b876b2ba9bfd0274025e39168e05d":"Relative Strength Index Array","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"Calculates Relative Strength Index (RSI) list from a list of values with a period","a9842c95766da40bf4ea6ee263cb5a5985847763":"Simple Moving Average","347775a293c14362d492f019e677c965be1d6e7d":"Calculates Simple Moving Average (SMA) from a list with a period","4cc7b9e53d082896ad884eb01be16320af65f282":"Simple Moving Average Array","2c75179a57af3c36581008b65e86ed81c4a4cbea":"Calculates Simple Moving Average (SMA) list from a list of values with a period","39f024cf49724fe7ffdea7773c72ed06eec998e1":"with interval","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"Direction is","ad47561efb1dcbd7246d9b64487f615647fda036":"True if the direction matches the selection","05bef508aadd62bf3967dcf67d769da296f19989":"Tick Direction","21bfc78607d3a64de767a6677d1db42156d5039d":"Returns the tick direction received by a before purchase block, its value could be 'up' if the tick is more than before, 'down' if less than before and empty ('') if the tick is equal to the previous tick","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"Direction block is deprecated, please use the check direction block instead","cdb31fc857f01a59f664413498293c714285f46d":"in candle list","20fd5f86f08796f145d69dedc209a27e459b2f51":"get # from end","a96606af8c33ac3428b45abc4782dbf93f458d29":"Get the nth recent candle","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"Last Digit List","248428facb97408414180d4de74e4db35360fbc4":"Returns the list of last digit values","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"Last Digit","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"Returns the last digit of the latest tick","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"Candles List","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"Returns the candle list","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"Make a List of","a4220593d385a720886f7af1ed3c478fd0c6339c":"values in candles list","cd8cdf3d47e921c8a72addae9269e66041d417c5":"Returns a list of the selected candle values","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"In candles list read ","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"# from end","aba43a580daa7f306956ec69b83e6e37e7233126":"Read the selected candle value in the nth recent candle","e04b522218a181cf0223042dd18ae08dcc22d8d3":"Last Tick","6ee445fc253a55c9ed54c009c3f020ac65200d80":"Returns the tick value received by a before purchase block","ed44b69176217a1251c04f0c13d23ac789ea60b2":"Last Tick String","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"Returns the tick value received by a before purchase block (String)","4b2340a890e88d1886757c3f7172e273a1edc31f":"This block is called on every tick","b54d7b4590559dad64f02d09aacbf6d9863e2624":"You can use this block to analyze the ticks, regardless of your trades","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"Ticks List","17649cac8739adcae95e641f794880272ad33bd1":"Returns the list of tick values","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"Ticks String List","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"Returns the list of tick values (String)","c67ded6b64019212eb2bc69afd761f5b3f626040":"Add sign to a number to make a Barrier Offset.","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"Market","74751e67c3e1010c343095eaf543e7cb21ced2ef":"Trade Type","1f4698382842477e211eb46de81fa506f01a8c34":"Both","c1baf816aac5a5cd849768773fc248cd249dc296":"Contract Type:","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"Default Candle Interval:","9693aeaaf68e3929b59b79306feaa0a847d01192":"Duration:","78d7103a319e808455d397513279d99f3b3f3768":"Stake","10c02649e226d430bd75a5b6315a41c0db9992a2":"Barrier","837276742aa90209dde3b4eef07d8e7ab26731ef":"Prediction","258b49925b41751c6bd790a0848246566ba61440":"Restart buy/sell on error","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"disable for better performance","b410994b67e37d9516eb9b866c85a8c639f79e68":"Restart last trade on error","2260c5a971c2602834ef8feeb5fa522f900b469f":"bot ignores the unsuccessful trade","0745acf92abd7b60598f161717884cc45dab8694":"Run Once at Start","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"Define Trade Options","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"Define your trade contract and start the trade, add initializations here. (Runs on start)","4d22b565e4253e92a908f216184779679bb1a044":"High barrier","b70c38c6db3127422e05315c30bdf76c7c36c480":"Low barrier","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"Absolute","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"Balance:","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"Get balance number or string","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"Blocks inside are ignored","d072c2ceeb5c1217722d14c74de7aeab945b4215":"Put your blocks in here to prevent them from being removed","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"Key: %1 Value: %2","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"Returns a string representation of a key value pair","b06acc4158c824231f727a13e1c9811f43d5be42":"Load Block From","661db37251a1ed1afe357ee13895f37a623d7cbf":"Load blocks from url","6c03ee54ad3a51fc92a1d69943e99667847705b6":"Notify","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"with sound","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"Creates notification","6e0fc122f936f808bc2e3af661121b65712ae855":"Notify Telegram %1 Access Token: %2 Chat ID: %3 Message: %4","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"Sends a message to Telegram","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"Total Profit","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"Returns the total profit","532e65f6e266db0bb442d1f426d44d7d32962340":"Total Profit String","78e84591ff76f992953a8e19b57c7eab7546d638":"Return the total profit (String)","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"No. Of Runs","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"Returns the number of runs since the beginning","7d500ebe352ccfa932b253e21938813a06fcff8e":"Webhook URL: %1","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"Sends a POST request to a URL","a35646754dbe7a9211ba8b81338a5d64580eb276":"Empty payload","69b0648eddd207cd45a9e1ba973dae287b535576":"Payload:","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"is candle black?","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"Checks if the given candle is black, returns true if close is less than open in the given candle.","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"Make a list of","5925d08228e246f07b790b88ad70c1b73a97d2bc":"values from candles list","852b438f91ad9eb2cdd84419a675a216d543c687":"Read","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"value in candle","d79d854dcd0829e2177a47beab6a55569e781ab1":"Read a field in a candle (read from the Candles list)","5606b4460ac96063b8a8e5647008f3ec97252fc5":"Seconds Since Epoch","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"Returns the epoch time (seconds since epoch)","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"Run Every","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"Second(s)","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"Run the blocks inside every n seconds","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"Run every seconds block has been deprecated. Please contact us if you have a valid use case.","7b9c76088576a64f32d67ec335162b9f73eaa026":"Run After","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"Run the blocks inside after n seconds","e9fb732dde76a6977bcaa2818b0f56125b183648":"To Date/Time","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"Converts a number of seconds since Epoch into a string representing date and time. Example: 1546347825 will be converted to 2019-01-01 21:03:45.","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"To Timestamp","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"Converts a string representing a date/time string into seconds since Epoch. Example: 2019-01-01 21:03:45 GMT+0800 will be converted to 1546347825. Time and time zone offset are optional.","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"Start using Deriv with your Binary.com email and password.","64f72129852fb7bdff0725c71324a012630f53bf":"In the EU, financial products are offered by Binary Investments (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, regulated as a Category 3 Investment Services provider by the Malta Financial Services Authority ({$0}licence no. IS/70156{$1}).","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"Outside the EU, financial products are offered by Binary (SVG) Ltd, Hinds Building, Kingstown, St. Vincent and the Grenadines; Binary (V) Ltd, Govant Building, Port Vila, PO Box 1276, Vanuatu, regulated by the Vanuatu Financial Services Commission ({$0}view licence{$1}); Binary (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands, regulated by the British Virgin Islands Financial Services Commission ({$2}licence no. SIBA/L/18/1114{$3}); and Binary (FX) Ltd., Lot No. F16, First Floor, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia, regulated by the Labuan Financial Services Authority to carry on a money-broking business ({$4}licence no. MB/18/0024{$5}).","10dd345bc3319e2151794428b2c709dc5fc381a7":"This website's services are not made available in certain countries such as the USA, Canada, Hong Kong, Japan, or to persons under age 18.","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"Risk Warning","ad0fc99c05681528248b73007dba16fd760a81c6":"The products offered via this website include binary options, contracts for difference (\"CFDs\") and other complex derivatives. Trading binary options may not be suitable for everyone. Trading CFDs carries a high level of risk since leverage can work both to your advantage and disadvantage. As a result, the products offered on this website may not be suitable for all investors because of the risk of losing all of your invested capital. You should never invest money that you cannot afford to lose, and never trade with borrowed money. Before trading in the complex products offered, please be sure to understand the risks involved and learn about {$0}Responsible Trading{$1}.","1fda2716eb92e0195ff59b110af23d86b43fd909":"In the EU, financial products are offered by Binary Investments (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, licensed and regulated as a Category 3 Investment Services provider by the Malta Financial Services Authority (licence no. IS/70156).","be7786af641b859c03ec152461d791480cf676ed":"In the Isle of Man and the UK, Volatility Indices are offered by Binary (IOM) Ltd., First Floor, Millennium House, Victoria Road, Douglas, IM2 4RW, Isle of Man, British Isles; licensed and regulated respectively by (1) the Gambling Supervision Commission in the Isle of Man (current licence issued on 31 August 2017) and by (2) the Gambling Commission in the UK (licence {$0}reference no: 39172{$1}).","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"In the rest of the EU, Volatility Indices are offered by Binary (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta; licensed and regulated by (1) the Malta Gaming Authority in Malta (licence no. MGA/B2C/102/2000 issued on 01 August 2018), for UK clients by (2) the UK Gambling Commission (licence {$0}reference no: 39495{$1}), and for Irish clients by (3) the Revenue Commissioners in Ireland (Remote Bookmaker's Licence no. 1010285 issued on 1 July 2017). View complete {$2}Regulatory Information{$1}.","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"Binary.com is an award-winning online trading provider that helps its clients to trade on financial markets through binary options and CFDs. Trading binary options and CFDs on Volatility Indices is classified as a gambling activity. Remember that gambling can be addictive – please play responsibly. Learn more about {$0}Responsible Trading{$1}. Some products are not available in all countries. This website's services are not made available in certain countries such as the USA, Canada, Hong Kong, or to persons under age 18.","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"Trading binary options may not be suitable for everyone, so please ensure that you fully understand the risks involved. Your losses can exceed your initial deposit and you do not own or have any interest in the underlying asset.","496a99878841de69368c33af9e88eb37c0da5712":"CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. 78.6% of retail investor accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.","a726d863bbdceba7b06a1083026a53db76de47b7":"Trade multipliers","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"Amplify your potential profit without risking more than your stake.","febe8aef26fb3017be5bf43d66f7972731c20833":"Peer-to-peer payments","a8c1114d1c88db12afa05b331188ceb77afad6e3":"Crash/Boom indices","d29324705a18a81ffc0376f3f37639a68827f3e6":"Predict and potentially gain from exciting spikes and dips. Only available with multipliers on DTrader.","ba2098a209e375402a0cf222cec87cce26440767":"Exclusively on Deriv","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"There’s a bright future ahead.","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"Find these bonus features and more on Deriv:","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"Check it out","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"SmartTrader","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"Our classic options trading platform","64dfd7424a05133b74cfb93fcbe385ede6539855":"Our classic automated trading platform","824d76b124e6289f372e2ff6bcba91e8939343bd":"Learn more","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"Deriv MT5","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"The world-famous CFD trading platform","54617a018fc6dffb3a70627b97f0db5c52a4081d":"DTrader","dbcd68f389d64fc531a650652c87b7d83fc82d94":"Our flagship options and multipliers trading platform","dd69c213333a751a0ab3bc9ce6368588bf971b61":"DBot","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"Our next generation automated trading platform","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"Deriv GO","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"Trade on-the-go with our mobile trading platform","f63714db18c58c6b4a7a7bad09178faaeca05104":"Deriv X","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"Our customisable CFD trading platform","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"Everything you love about Binary.com and more","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"7 platforms to choose from","029582bad299ab8f44c57b961210e56569efd536":"You’ll find SmartTrader and Binary Bot alongside new platforms like DTrader and Deriv X. Whatever your trading style, we’ve got the platform for you.","9a07439b57e510e8e33b372aad2c360dbc39e79c":"Trade CFDs, digital options, and multipliers, a new exciting trade type that boosts your potential profits with limited risk.","3d0be0e8eb736257254698ba821c45389e385f1e":"Crypto deposits via fiat on-ramp","c4303d30e60f01fa922400e52df4e96d71b35d6e":"Over 100+ instruments","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"Trade what you like — forex, commodities, stocks, stock indices, and synthetic indices. ","f30ce7459f29851b219b504216581bf3d3446de0":"Support when you need it","6df6091514ee13992a3ac28445af1d9a1afbcb67":"Get round-the-clock customer support and access to the Help Centre.","92c8b7b779e7cf179b89484285fd766274b3bf1f":"Explore Deriv now","a87a92c5ce4925186a081cf4478639fcc31b12ed":"In the EU, financial products are offered by Deriv Investments (Europe) Limited, W Business Centre, Level 3, Triq Dun Karm, Birkirkara BKR 9033, Malta, licensed in Malta ","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"(licence no. IS/70156)","720280451c98ceeb796f3c7fa118813fc8da694d":"and regulated by the Malta Financial Services Authority, Triq l-Imdina, Zone 1, Central Business District, Birkirkara CBD 1010, Malta, under the Investments Services Act. Authorised by the Financial Conduct Authority and with deemed variation of permission. Subject to regulation by the Financial Conduct Authority. The nature and extent of consumer protections may differ from those for firms based in the UK. Details of the Financial Services Contracts Regime, which allows EEA-based firms to operate in the UK for a limited period to carry on activities that are necessary for the performance of pre-existing contracts, are available on the Financial Conduct Authority’s website.","0f1dda628bebb4748de6df05fa3bff4989c1b476":"Outside the EU, financial products are offered by the following companies: Deriv (FX) Ltd, F16, Level 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia, licensed by Labuan Financial Services Authority ","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"(licence no. MB/18/0024);","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"Deriv (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands, licensed by the British Virgin Islands Financial Services Commission ","a56aa088dfea506d5dbe18f385c29418f771a639":"(licence no.SIBA/L/18/1114);","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":" Deriv (V) Ltd, 1276, Kumul Highway, Port Vila, Vanuatu, licensed and regulated by the Vanuatu Financial Services Commission; and Deriv (SVG) LLC, Hinds Buildings, Kingstown, St. Vincent and the Grenadines.","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"Deriv Limited — 13 Castle Street, St. Helier, JE2 3BT, Jersey — is the holding company for the above subsidiaries.","74e8fa69aad80f93303a7723e5a304f3d43560b6":"This website's services are not available in certain countries, including the USA, Canada, and Hong Kong, or to persons below 18.","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"CFDs are considered complex derivatives and may not be suitable for retail clients. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money. The products mentioned here may be affected by changes in currency exchange rates. If you invest in these products, you may lose some or all of your investment, and the value of your investment may fluctuate. You should never invest money that you cannot afford to lose and never trade with borrowed money.","5bb3f3499158dbe30af5c725694b321dfe821433":"Before trading in the complex financial products offered, please be sure to understand the risks involved and learn about ","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"Secure and responsible trading.","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"We’re moving!","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"We’ve been","991753597fde70aab5791de6d50ee8cc49a0bdcc":" Binary.com","efa99ab039a285c6264580bea691a4ffefcbeee7":" for 2 decades and it’s time for an exciting new chapter.","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"Say hello to our new home,","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":" Deriv.","52b8454dc755419beeff2f90cd0fc91def428244":"Hello Deriv!","27ad1d8334221366694c7acdd70fb380857d1e6e":"Maybe later","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"Take me to Deriv","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"It’s so easy to switch to Deriv","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"Just log in using your Binary.com credentials. No sign-up needed.","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"Try it now","63fbf7977349e32e4a124ffa047549b720806d73":"Take Deriv with you","03d42257a2263b2841b9e0ae4b94de117228a33a":"Get the Deriv GO mobile app and trade on the go. Never miss golden opportunities again.","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"Scan this QR code to download Deriv GO","6b7499b1513a3cec3da3ff07cdad9b358954021e":"Don’t wait","b23efda40ddeb801beeebf915669d806744014af":"Future-proof your trading. Come over to Deriv now.","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"Enter the Deriv experience","34075438f939258908cc21d28bf59ab5126dc2d6":"Come over to Deriv and future-proof your trading now.","e669443b63757b5ad8571e52393caf2a0a812be3":"6 reasons you’ll love Deriv","2c141583afaaa12438b16ee67355c6e3eaf77763":"Binary Bot has a new home","4e0e045da59b385138ced3203cdb81c3b4cdd135":"We’ve been Binary.com for 2 decades and it’s time for an exciting new chapter. Your favourite bot builder, Binary Bot, is now on Deriv, our new home. Come take a peek.","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"Take me to Binary Bot on Deriv","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"Use Binary Bot on Deriv, our new home","1071c645f523394b408a6d285e95331bc583f14c":"In 5 minutes, we’ll show you the benefits of trading Binary Bot on Deriv.If you ignore this message, we’ll remind you again in 3 weeks.","be43a8989c5745ec7386ca7c69442165f55dee8e":"Show me the benefits now","074603c9aef93515ed33d179e982c67ea7abdb45":"Trade Binary Bot on Deriv"}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = {"3d52a6d8fedcc48a65297c07bf5f7e3e41aab5aa":"crwdns18731:0crwdne18731:0","3edf0df49942da6d11a1a217e4d3af4a5a8e64f2":"crwdns18732:0crwdne18732:0","c3328c39b0e29f78e9ff45db674248b1d245887d":"crwdns18733:0crwdne18733:0","4d064726954a17487f94e931f5b157b733ec22ed":"crwdns18734:0crwdne18734:0","a1fffaaafb7cc996685bceb829c053cc4f7de43d":"crwdns18735:0crwdne18735:0","19de69cb601f53a4ea7af22a65c71ae63251365c":"crwdns18736:0crwdne18736:0","2b961dea1dc0c60ddf9a2c8e9d090f6f7d082483":"crwdns18737:0crwdne18737:0","dc7f77b4ccfc9f70a78bd97303bd10ba4c9d70c8":"crwdns18738:0crwdne18738:0","66639f7d455dd71faa9147f5d69e5ce885d8bebd":"crwdns18739:0crwdne18739:0","0ba66deaab2f2cd3b0793d03f600ee2b8f577fbc":"crwdns18740:0crwdne18740:0","9201c6ac624e98e168e6ccddbcd5a9b5cdff06b3":"crwdns18741:0crwdne18741:0","44ab9a87268d3fd74040ed0b55c04f83294cfdef":"crwdns18742:0crwdne18742:0","c415c9399b7ae7285d2c1c880a6a0aa18f62ff8c":"crwdns18743:0crwdne18743:0","d07ffc19d51f0973859a0d95c1d15cd9f22388ca":"crwdns18744:0crwdne18744:0","8cf71374fa095a64b5295b672daef8507ec7be6a":"crwdns18749:0crwdne18749:0","4fa8cc860c52b268dc6a3adcde7305e9415db5bb":"crwdns18745:0crwdne18745:0","6c82e6dd86807ee3db07e3c82bec1ae1ce00b08b":"crwdns18746:0crwdne18746:0","8d8fd6765e184419cad8b88d1a60c895d79578c2":"crwdns18747:0crwdne18747:0","548f449b63ff41eaaff5a2d679ffa56b2015fc20":"crwdns18748:0crwdne18748:0","8bf95ea372568c7a254ba9fada5f6f1701ebc5b5":"crwdns53898:0crwdne53898:0","12b71c3e0fe5f7c0b8d17cc03186e281412da4a8":"crwdns53900:0crwdne53900:0","9feddbabd7e7309e96c590069057158e96baa8f6":"crwdns18750:0crwdne18750:0","038fe2bdb7ec6ee078f60bdb5bee94654ec6a81d":"crwdns18751:0crwdne18751:0","4152043e8c670075d2c919677e835edb0d923cab":"crwdns18752:0crwdne18752:0","d9fff2df19e90f2c7ea6bb30fde4e0da119d13d1":"crwdns43091:0crwdne43091:0","2439f2f199b2a3e798aa9b4feaa9248bdec9bc0b":"crwdns18756:0crwdne18756:0","a72ca256dc49e55a1a57b9a727fbde9834c9a3f7":"crwdns18755:0crwdne18755:0","6e78c91f5a05fc0d4f1a787d38e3d6fe2f856d46":"crwdns18754:0crwdne18754:0","4832e45812a2724f16a15f9ae87adfc8ae4168cf":"crwdns18790:0crwdne18790:0","f7c400ed695f898b8ee9d21664aa17b5bb693828":"crwdns18761:0crwdne18761:0","5ea75f1605a4bf1db5c39fcc61854627478c0a7d":"crwdns53902:0crwdne53902:0","f98595d541778d86f75ef22b3328a031d20aa16b":"crwdns53904:0crwdne53904:0","4a1e616226c329a94da7768bc0435a3284478010":"crwdns53906:0crwdne53906:0","6b3465ace62f33f0687b4669ac26d95895e9ca52":"crwdns53908:0crwdne53908:0","8e4ec2c451ec7b1bf68d72fe9086ec978e41feb7":"crwdns53910:0crwdne53910:0","937f5055f05be359ddf619744e8af4d643549e80":"crwdns53912:0crwdne53912:0","8406d1cce44230835932060649e999ca3283b413":"crwdns53914:0crwdne53914:0","1109673172af2c173c492622ff8a72c8f29f0e70":"crwdns53916:0crwdne53916:0","44c22002c65d2871331263a23c3e09c0a1bfd847":"crwdns53918:0crwdne53918:0","ebd0945359e5578ff9bd3a2ab490ca84c225d8f5":"crwdns53920:0crwdne53920:0","76bb05950f80f3a88ee05ef3276c5934fd355e8d":"crwdns53922:0crwdne53922:0","ba50a42d8d3228c37a817865fce49fbca692c2ad":"crwdns52880:0crwdne52880:0","4f4aa4117318a8ddf8783885d4f3542c5b2733bd":"crwdns53924:0crwdne53924:0","91017ef9b165cd0e7475a770f318ea5e705e1321":"crwdns53926:0crwdne53926:0","c89e3dd1cafcadcc0312e476ab58b2332209da23":"crwdns53928:0crwdne53928:0","b02c858e72be118a65c9393930351012b647cb9e":"crwdns53930:0crwdne53930:0","250be77f7605669a0b3d968b9ed381a3d9787ed1":"crwdns53932:0crwdne53932:0","ff29ccd7a6c6073cc462ed590d27a91632fdf67e":"crwdns18780:0crwdne18780:0","608061fb5aab975013fa70c5c814a1d8ba30c152":"crwdns18781:0crwdne18781:0","e4ce8dc3e416e69262ba642dc57d3975d6616980":"crwdns18782:0crwdne18782:0","4706a3fa83c1037ecb4a9ca428be7042443e4cb1":"crwdns838452:0crwdne838452:0","f6c85c68616eeaaa15fcd53fdc52f6eb5c886357":"crwdns18784:0crwdne18784:0","0606f0b7763ee6e8094a3dab7873d34c08fd3670":"crwdns18788:0crwdne18788:0","221acaf3a0290adafe08cdcb8c66121c73d8b4a3":"crwdns18789:0crwdne18789:0","308ec8ac6a7ded0ae9bbd4cd39854df3779e9ca5":"crwdns163616:0crwdne163616:0","d635b53e59c9aad8c5d78458826beffb029b27bf":"crwdns52840:0crwdne52840:0","a69a8fc21499d0fd85e87bab467699827547a5bc":"crwdns121040:0crwdne121040:0","1de91e827ec70ca735abc2c71b0a89cb0cfc4ce1":"crwdns19751:0crwdne19751:0","50050f06645ad2743165b429a8f7deebd285fd63":"crwdns19752:0crwdne19752:0","6a7d1a3a17c4e8ae6712cb60d46db1edf0aa2667":"crwdns19753:0crwdne19753:0","2f9f9096be1a1c0569a9ce54e57f0420f6b3c2e9":"crwdns18871:0crwdne18871:0","4df6e872792d72aea8a2f6b831d00b554464da23":"crwdns19755:0crwdne19755:0","001e68df3a4b32a4d57148d9d407f44eee3b7436":"crwdns19756:0crwdne19756:0","04f14ea7c92e0b2b5ae005c696245063ec641d66":"crwdns19757:0crwdne19757:0","c1bbfcbb4f57d3a56c1239af0c2138321589efd2":"crwdns19758:0crwdne19758:0","57b453bb26b1c28dfe362b7cc9f17f0be93dd581":"crwdns19759:0crwdne19759:0","094628ce13fc0e78f07b697d1cc9421bb2edd666":"crwdns19760:0crwdne19760:0","816c52fd2bdd94a63cd0944823a6c0aa9384c103":"crwdns45980:0crwdne45980:0","5397e0583f14f6c88de06b1ef28f460a1fb5b0ae":"crwdns19079:0crwdne19079:0","bbb930cc426507ed3f6b7c343c75dd0e041494b7":"crwdns18793:0crwdne18793:0","e6e886cdcdefeb6d3edb4c31bed06dd183ac4153":"crwdns18794:0crwdne18794:0","50e72909992bdc37c7c07769d1b7efac5e52874c":"crwdns18795:0crwdne18795:0","ecb5ba7044417916ba12de5fa9e6fccac3e5d475":"crwdns18796:0crwdne18796:0","c980b910204c7babdffe8ff3f7e755f30133383c":"crwdns18797:0crwdne18797:0","a726c6955157f1b8b92f9932652434a7150f80f8":"crwdns18798:0crwdne18798:0","a66d5c7ef2c63dbc9a8f9e6ae4e2bc575e74a36e":"crwdns18799:0crwdne18799:0","3905be81561384dc8c43d6127c57ed1e0eb03b74":"crwdns121042:0crwdne121042:0","7674920c033ca14277c577e19c037a6754d4fa80":"crwdns18800:0crwdne18800:0","e8b8bd9f2eabc12875605a37c93e7f04a713fcb8":"crwdns18801:0crwdne18801:0","06ecea26625359f7dcf5ff5c47af6174ff815257":"crwdns121044:0crwdne121044:0","779455ee3bde8494d9629b353e17b19e92357ba8":"crwdns18802:0crwdne18802:0","37a5301a88da334dc5afc5b63979daa0f3f45e68":"crwdns18803:0crwdne18803:0","4973f4c599d5f42cf7bde52d66c3ed8ef77accb1":"crwdns18767:0crwdne18767:0","12e24a7d8ac40579e8a0aef4869288afe7ed6745":"crwdns18768:0crwdne18768:0","563339f82447b4e758ad76d5a0b63b5698594fba":"crwdns18804:0crwdne18804:0","5c1ae82c29543ac887703776bf3da2c7dcce683d":"crwdns18805:0crwdne18805:0","2fc096bb7b6596ab243d0286c9f43fdf2b9b406d":"crwdns18806:0crwdne18806:0","ecb252044b5ea0f679ee78ec1a12904739e2904d":"crwdns18807:0crwdne18807:0","53b0a1b2fadf4e040cdc2155a7340de24aca93cb":"crwdns18808:0crwdne18808:0","bc74f4f071a5a33f00ab88a6d6385b5e6638b86c":"crwdns18809:0crwdne18809:0","4c9a82ce72ca2519f38d0af0abbb4cecb9fceca9":"crwdns18810:0crwdne18810:0","96de5543d183d7de52ac5fa21c46fc811f673f89":"crwdns18811:0crwdne18811:0","78988010b890ce6f4d2136481f392787ec6d6106":"crwdns18812:0crwdne18812:0","aa9330a16e5b055de809256dad6b4d1cbd2999e7":"crwdns29876:0crwdne29876:0","cf84a98d6cf7f156862a08ba8236467b6f471004":"crwdns29877:0crwdne29877:0","eee2facd669d1434848c24da5527b3e87d9a12d5":"crwdns29878:0crwdne29878:0","9d705578b0f1f0ce3a06dc5e82f9a1e6078f81e1":"crwdns29879:0crwdne29879:0","7f2f6a15cf8da2b27e5a4af47b58e7ad71c0b3d9":"crwdns29880:0crwdne29880:0","a3b1583d377f37ac20de7e089edfa0920a078e57":"crwdns29881:0crwdne29881:0","66c8b6848eee629c4ac551bf2b5fa591571654be":"crwdns46213:0crwdne46213:0","5649dce3367d490fa19d563ee9e3d4c4b6f7c642":"crwdns46214:0crwdne46214:0","062787aa328047e189774b3703d983b83938f6e9":"crwdns18813:0crwdne18813:0","b91eed4b7a80cd9572a27e65ebdff9caa4b3b9a4":"crwdns18814:0crwdne18814:0","e3f139abb7a549a1210b36f7dbf89215ad6c9902":"crwdns18815:0crwdne18815:0","7d7932bcc2e262ae98cf09dc5445130fb3881769":"crwdns18816:0crwdne18816:0","a16814a48ec58c2e24ba224a80921a5c02361abe":"crwdns18817:0crwdne18817:0","391d02cd75ebcd6ed26f5f45ddf7d40bf13e9dc5":"crwdns18818:0crwdne18818:0","534ec5da4e82ec419abc170e1a8448f55a01664f":"crwdns18819:0crwdne18819:0","98cbe1998effd8b1a8aefdcc538573055e99a5f5":"crwdns18820:0crwdne18820:0","93d13bad1d2c2841db127cb70cc35bfc98059fc9":"crwdns18821:0crwdne18821:0","c098658ce3d3a258e4d155949a60072966b36db7":"crwdns18822:0crwdne18822:0","ee2dbd5d6d82d0833069b07e7dd2848d3bf4d83a":"crwdns18823:0crwdne18823:0","8444b7ce28bbc3443cc5cf73359b8353989b2a4b":"crwdns18824:0crwdne18824:0","9e767ad03e5547f251044e0724dc1d9f3e75aeed":"crwdns18825:0crwdne18825:0","dc28f5f3c65ec611f0f30022650d24382d27448e":"crwdns18826:0crwdne18826:0","18a63f5512afb5573e5b44deba78d629f0635317":"crwdns18827:0crwdne18827:0","2a268b89b83f8cb38ea48e46e93dd8840db512f9":"crwdns18828:0crwdne18828:0","2155c8b38181dd2552e84a94049aacd33ef9c607":"crwdns52842:0crwdne52842:0","1408cfd2b064b923f024fbe590e27db8282941a5":"crwdns52844:0crwdne52844:0","b86eb15dc4f13e4c2972de158d3038d9f657242f":"crwdns52846:0crwdne52846:0","669a1f3d9a8f601a84da536cfdad1de4092b1926":"crwdns52848:0crwdne52848:0","844d1a5c99a0a668383340cc095d040eef998c79":"crwdns53186:0crwdne53186:0","87293a146cd481a2b30cf74282ec061dc4cf0735":"crwdns53188:0crwdne53188:0","cf9b77061f7b3126b49d50a6fa68f7ca8c26b7a3":"crwdns18829:0crwdne18829:0","b1a5954a483f8f8b0207385095f74aeb409b3f80":"crwdns18830:0crwdne18830:0","a124947cbd2d1d92b47e027274c3269ff0c7a84b":"crwdns18831:0crwdne18831:0","bbfa773e5a63a5ea58c9b6207e608ca0120e592a":"crwdns18832:0crwdne18832:0","1173872a4fb205b713702f0eec5cf2c732c828fd":"crwdns18833:0crwdne18833:0","808d7dca8a74d84af27a2d6602c3d786de45fe1e":"crwdns29883:0crwdne29883:0","62957ecfdc50957e8957c11d2eae74d078f0ef1a":"crwdns52850:0crwdne52850:0","1dd3e663dfa7ac9cb77cfddd2cf8ac700657e2d6":"crwdns52852:0crwdne52852:0","24e46784cbce32443db5a2638b1a7d3201543e9b":"crwdns52854:0crwdne52854:0","3aa5819ed8a0b94d0f293db8e9c9598298ddd402":"crwdns52856:0crwdne52856:0","a6f151883b736f0470d33492e61c72a7d059d065":"crwdns52858:0crwdne52858:0","899761ff5425abd2ee214fa7aa46e27c6c8b5aae":"crwdns52860:0crwdne52860:0","31bbe8890d28d183f8f7f2c160fa892c444c0ec7":"crwdns52862:0crwdne52862:0","f030c3d667652646b86732ad7bc67e226c49cd3a":"crwdns52864:0crwdne52864:0","2046e49e33c040e08dbd6fd83df3e1846015e6f1":"crwdns52866:0crwdne52866:0","7b47150d431db70d783724007f07ab894eb8ac2e":"crwdns52868:0crwdne52868:0","191800b7e9a48680792c0dd77cb6cac00c4514c6":"crwdns52870:0crwdne52870:0","2d8a6f7c34468578640b333b8650131de06ac770":"crwdns52872:0crwdne52872:0","cd1495cb4c60266a6abad9024022ae079bf7e416":"crwdns19022:0crwdne19022:0","d4d34ce9d9dd7e87213469f88cb7ac43725675d5":"crwdns18963:0crwdne18963:0","d571f33d957ebcab086ecf38eedd71b6ef0c5820":"crwdns19779:0crwdne19779:0","160f06d4799c85021a810f68c5b517eea37a2737":"crwdns18966:0crwdne18966:0","f94510322ecd9b3a2af67a10bd51ecc4ac6a24e7":"crwdns18838:0crwdne18838:0","c1365a35e99d0f9147ebc72f21534cf471fa7d95":"crwdns52874:0crwdne52874:0","9c7960c6b11d35ac9d6cdc1ebaad3af43b2065c5":"crwdns18839:0crwdne18839:0","2260ce49306460c8a2ef501939f29ad6ddd4e934":"crwdns18840:0crwdne18840:0","0186aa73a1b75fa8f0eb98bbd9ad01102bb09ec1":"crwdns18841:0crwdne18841:0","f7de1f66f0979667da275b7e8996e805395025a1":"crwdns18842:0crwdne18842:0","a431deecd4c2258097adae418d496fe9a8179fee":"crwdns18843:0crwdne18843:0","256fe245cb7d3d673095f7faaa8c9ff81b985ad1":"crwdns52876:0crwdne52876:0","12a3f461cdebbc8f335190413ee6c57442743bba":"crwdns52878:0crwdne52878:0","e696144fa588782e6d6b2c97e2d3ed1adf52bd5c":"crwdns53190:0crwdne53190:0","91a64e3f83c91acf336c631fba295f297f94c399":"crwdns18844:0crwdne18844:0","024696596f26a4db232fd9e966eadfeb27c0bd1a":"crwdns18845:0crwdne18845:0","c538c170bdc6b0f3bb98dce44a016a2e2d45a6e7":"crwdns18846:0crwdne18846:0","85c274929bc0e28eafd3734f2c25046c3b95b36b":"crwdns18847:0crwdne18847:0","346e3ee198e98146993894d3de8ecab1a86c3e80":"crwdns18848:0crwdne18848:0","f16459104f92ab6b38aa265adb4ecbfc3768e303":"crwdns19104:0crwdne19104:0","e09f635f4e77476c9ca1c37bc9992e9ace3431c1":"crwdns19105:0crwdne19105:0","27bed13a88c60350c3de92ec3820e1cc4f7d6ec3":"crwdns19106:0crwdne19106:0","19eabc961735d78f12fc7be906ffcb033853cf85":"crwdns27131:0crwdne27131:0","68f4145fee7dde76afceb910165924ad14cf0d00":"crwdns27132:0crwdne27132:0","e99811bd3b1ad17e74614060ecb180602be35ad6":"crwdns18864:0crwdne18864:0","2ef4a36421cf147db8a7bf45cde03c0224fd3323":"crwdns163618:0crwdne163618:0","1fde9f1ebca07dcbc704130bd18645bce7718b55":"crwdns163620:0crwdne163620:0","d466687f90ba548434d65186d11a80c4204f9ad6":"crwdns19676:0crwdne19676:0","629777b7d4d610ace6dee24442730f27d7d0853e":"crwdns18863:0crwdne18863:0","0b93c14956403c2e5c9e79f5c836babc56912006":"crwdns165741:0crwdne165741:0","c1458ff86fd60d9544d7cd8a67437df2b766f482":"crwdns165743:0crwdne165743:0","beb040c8fabd007c9cc5ac6a9feb6bdb05d33dac":"crwdns52832:0crwdne52832:0","410bf23a3f080def9c7a976a16305bcde7943ed1":"crwdns53192:0crwdne53192:0","4e4e5563897bb7c6696a685bc134b7aa4c55ebcb":"crwdns688036:0crwdne688036:0","901624741023fcfc805ce43c94b8012e3b1d1c99":"crwdns688038:0crwdne688038:0","876f3e0202ca40dedf2e5ab6577eba1ae637fb53":"crwdns53564:0crwdne53564:0","910ec7aa40b04ec6ba51162f4de7850569326cb6":"crwdns688040:0crwdne688040:0","8f51f350debde84e067e1a0405fb6304922a7d4b":"crwdns688042:0crwdne688042:0","8ce80462febd4d573cb2f9c1984fdc93b7c21c57":"crwdns53566:0crwdne53566:0","c4c758b5c8f5b3985f6bf7382c848bb44e0a5b74":"crwdns121046:0crwdne121046:0","3b6bbab905129dd36b8d4e99947fa30540ed7b2a":"crwdns53570:0crwdne53570:0","3d6b44df6eaf6236b4abc1aadcf8f5b1cda769c1":"crwdns53572:0crwdne53572:0","cdfe947b0c089a4a1f78c11299f25c32a124f1a6":"crwdns53574:0crwdne53574:0","2db43c69a4b96454914f0b8272bc869984529e6e":"crwdns53576:0crwdne53576:0","0dcea5f584938e0fff00084b83156ab31d641ab3":"crwdns53578:0crwdne53578:0","18da95988117ff029393f3f5c881d70ef47f7385":"crwdns53580:0crwdne53580:0","04226bcf91195130e25fe7a8e8ea4d3e058efcb7":"crwdns53582:0crwdne53582:0","aee24f2456ea8516b024a5d3e2b815ae7f2239d9":"crwdns67006:0crwdne67006:0","3f370309b6280eb100f898426d8605c1f45d558d":"crwdns121048:0crwdne121048:0","af6a4e2a5582be89ac930e946eaed86e01cac58b":"crwdns121050:0crwdne121050:0","49d51398b574e7312d99b18d2b93d2ede416f053":"crwdns121052:0crwdne121052:0","05754ed14275a070a20a1d5cd65f0cea66f1da7f":"crwdns19761:0crwdne19761:0","79222cd9892a434aa61fc7dc01c3839951eb8d1e":"crwdns19762:0crwdne19762:0","6ea4a034747d020b1d8ce4848def95d537555dd6":"crwdns19763:0crwdne19763:0","89f89c02cf47e091e726a4e07b88af0966806897":"crwdns45814:0crwdne45814:0","1200c1af2f7bba4e29a34112865662748c9d41df":"crwdns67008:0crwdne67008:0","62d6180e55905f7b996d442c53631981a4ef8b5b":"crwdns19765:0crwdne19765:0","ed4978867de1da05b336b724a3fb96222a29ebec":"crwdns19766:0crwdne19766:0","87e2e01f93d25ba7ed582cc81ef5c9ab2959f4c6":"crwdns19767:0crwdne19767:0","b2a4553586d1062c21323bca1dc0589f7a9d5cf7":"crwdns19768:0crwdne19768:0","46fc6f27a835486d63d9e927c6687e4508cb3087":"crwdns18861:0crwdne18861:0","9202ddae4cea16513e53bbc965d88ed975e59512":"crwdns18862:0crwdne18862:0","5f52b397b7e5f538681f0f5717a88aa626349c7a":"crwdns19769:0crwdne19769:0","66c7734789e19cbeef3a5ac185ea732139aed213":"crwdns27129:0crwdne27129:0","3b662fb2e8bafce29aa98321b18874bb44905488":"crwdns53584:0crwdne53584:0","da1b1a6f62f8f5d8db05677187c756af7a2e3b94":"crwdns165747:0crwdne165747:0","7ee0ff5eaa6fa82bd6d83a2f4ca446c663f097cb":"crwdns53698:0crwdne53698:0","93039e609d94a24f3572b794a31b21525a09af2b":"crwdns53700:0crwdne53700:0","a85b8cc112a8597df1612d60a74faa818c25d1b3":"crwdns165749:0crwdne165749:0","ea67c8023c75375484f3a5f1aeb009b20059d5bc":"crwdns53702:0crwdne53702:0","95052a29f213e9698b593418fe396ecc21032f9b":"crwdns165751:0{$0}crwdnd165751:0{$1}crwdne165751:0","b1946e5b4b78465b7661fd4bc89ff52de6c633e7":"crwdns53704:0crwdne53704:0","730657200c17321d926e1bd08dbf65bd96855a8a":"crwdns165753:0crwdne165753:0","952f375412e89ff213a8aca383d18e5691354347":"crwdns18892:0crwdne18892:0","9f1c61cc03f3ef9324db05502f7f0b61e61e1521":"crwdns18889:0crwdne18889:0","095ba68888b5ace5f4515f5acab76dfa1073544e":"crwdns53586:0crwdne53586:0","ddcb77ff769ea54ca622848f6bedd4004fa4f4fa":"crwdns53588:0crwdne53588:0","248e224f533752db28a1aab3519a58569ad96140":"crwdns53590:0crwdne53590:0","c7097e97dcc446ca889d3ca6be733a65e2728afe":"crwdns53592:0crwdne53592:0","a6b977714595aa01678fca98e86553aaeac05c92":"crwdns165755:0crwdne165755:0","3218e5a460e82d7bdea9ce0f145cab2f47ba9a4b":"crwdns53594:0crwdne53594:0","611ebbfb080284312904de925ef0f75f4cb56ad2":"crwdns53596:0crwdne53596:0","efc007a393f66cdb14d57d385822a3d9e36ef873":"crwdns18899:0crwdne18899:0","a638caa8ab2b7ff7980a571334217339e6d1d634":"crwdns53598:0crwdne53598:0","39fca63515c105918f03e4908ec12df675b07f92":"crwdns27130:0crwdne27130:0","e643975ea5296d9de4486458f31ab0a5a2b228bf":"crwdns165757:0crwdne165757:0","85dfa32c97d8618d1bea083609e2c8a29845abe5":"crwdns33427:0crwdne33427:0","d847919a30d31c0be624087f3370492b3fdf80c6":"crwdns18764:0crwdne18764:0","5cd6978d63540c8a490ef76f43219de6362f958e":"crwdns19668:0crwdne19668:0","17410d7b62b8b1de981cfebada24632987edf186":"crwdns19669:0crwdne19669:0","b841eeb091f1ff0e14be08e5ea1b93e4cf147ed3":"crwdns19670:0crwdne19670:0","90eef613042c5a51f542421065b68b886d473807":"crwdns18770:0crwdne18770:0","db1c784524e1b54011a95823026161f7c8517fe0":"crwdns18773:0crwdne18773:0","4db3e9e4aecd187db9339a10d2629fef46724dc4":"crwdns19671:0crwdne19671:0","1bb4086b66659d8580f9be4beef69931aeea3cad":"crwdns19672:0crwdne19672:0","8bf249c4855e591964bd5bdd35c8ef2ee107342d":"crwdns19673:0crwdne19673:0","ba7be969e7c1bb5f22489e843478e3d721aaa843":"crwdns19674:0crwdne19674:0","772fbced18230220d2d9be1456be16fc1b271d25":"crwdns18779:0crwdne18779:0","bae7d5be70820ed56467bd9a63744e23b47bd711":"crwdns53934:0crwdne53934:0","96f608c16cef16caa06bf38901fb5f618a35a70b":"crwdns53936:0crwdne53936:0","7fb3a9b5101bcd45e2dca077191693a5199bafa9":"crwdns53938:0crwdne53938:0","82a82f798dd773717ec37d15fd4405510291734e":"crwdns52882:0crwdne52882:0","6a88e58aa1798626f94cf17f1a91618b405bb289":"crwdns53600:0crwdne53600:0","624cc7f40b68faace7e78d8e5c5be1d4f15facda":"crwdns52884:0crwdne52884:0","788180a6ddbbbcca10f6f49d8e85d557934bae0e":"crwdns52886:0crwdne52886:0","d907a40a4a15da3c21a6e0f8ace3f987d482f92c":"crwdns52888:0crwdne52888:0","4f219c17ab9ab76aa1cd431b4e0e5ecf5520e8e4":"crwdns46217:0crwdne46217:0","4684ee1026d9b4c872d016c3c4588a0c479a451c":"crwdns46218:0crwdne46218:0","ca92c55b9e4233d771d5b6300fe751a9678d1deb":"crwdns46219:0crwdne46219:0","f02760cd2eac28169f0a990c950c3dfe8427f772":"crwdns46220:0crwdne46220:0","c7363d8a0748d4a7e2cc968335dc9716f290359d":"crwdns165759:0crwdne165759:0","fadc0ef93d1ff13370524ce8481ddc4a71195934":"crwdns52892:0crwdne52892:0","a479c9c34e878d07b4d67a73a48f432ad7dc53c8":"crwdns18869:0crwdne18869:0","e4458464df6cbb8da1134875ba51519c5d244d9f":"crwdns18867:0crwdne18867:0","e9c45563358e813f157ba81b33143542165ba84e":"crwdns53194:0crwdne53194:0","31cb6f44d030abeabcc7046555dea851602a87a5":"crwdns52838:0crwdne52838:0","9ce3bd4224c8c1780db56b4125ecf3f24bf748b7":"crwdns52890:0crwdne52890:0","9970168c192807246fad6138344e5a96449afbdd":"crwdns688044:0crwdne688044:0","a594b427eaf0f108d3e9cc20d70e15da811c760c":"crwdns121056:0crwdne121056:0","04a5090686ac7b54822e00a9ff08c38a107601e7":"crwdns121058:0crwdne121058:0","77dfd2135f4db726c47299bb55be26f7f4525a46":"crwdns121060:0crwdne121060:0","fdaa08aeaee0bf9b78d83ea19ef9e9bd019e8193":"crwdns121062:0crwdne121062:0","b15d2f692ff6986ba69df8a7de6c676b63e28a48":"crwdns688046:0{$0}crwdne688046:0","f1d8b7b118d6f82f95614d476bc11af650aed3bc":"crwdns53602:0crwdne53602:0","af145748c9cf765a3b059eec20cb1dbb899297d8":"crwdns18868:0crwdne18868:0","11ee9c5d534cc8d22651092222b532917594161a":"crwdns18872:0crwdne18872:0","5283ac04c9a8ba8a937d1edb4ba986aeefce8bf1":"crwdns18873:0crwdne18873:0","ace1342bc3720b77ce510b93074041e7386d209e":"crwdns18874:0crwdne18874:0","fed3e7bd6696fb97a12d720845ab5388456bfc3b":"crwdns18875:0crwdne18875:0","6ddf2b3075ac9ab5d66b40e15ea9a34c087672ea":"crwdns19057:0crwdne19057:0","33aa6ff282ee509d37c6f758274c9156b419ff73":"crwdns52894:0crwdne52894:0","da162a909c2981ed318d23cd9a6be1d66e0a8400":"crwdns18870:0crwdne18870:0","5e719fa76e1b6cb396376c82ebdd04bec7253229":"crwdns18882:0crwdne18882:0","b0d2de25daf6ba09a5e710c6968ffded29c4dae1":"crwdns19770:0crwdne19770:0","df84a88f38b03b5b342362d72370b0d66afdae35":"crwdns18883:0crwdne18883:0","cd680fd936e9559ef1d95efac7a71680e2b13a89":"crwdns18884:0crwdne18884:0","34c59389053701a04127f74d32315e0206e076f8":"crwdns43092:0crwdne43092:0","ca92532fe6eddc40c362c56b3b996d6851baa6d1":"crwdns165761:0crwdne165761:0","988df856c066143616bd33d5904bbcdc22ff129e":"crwdns688048:0crwdne688048:0","2fccaab15d71b00c19da7053135471d510b513db":"crwdns688050:0crwdne688050:0","3ead0b14c72503187691a7a6d7121987299bd401":"crwdns19771:0crwdne19771:0","27401c9c8e476d659c8382e05c6d70a4a82be468":"crwdns19677:0crwdne19677:0","bc981983e7f547dc62e19a1e383acfe00782a6d5":"crwdns19072:0crwdne19072:0","b52b36b7269fbfc58ec24bb724691951a3decbe8":"crwdns19073:0crwdne19073:0","e9b450d14bc2363d292c84f17cfad5cfbd58a458":"crwdns19074:0crwdne19074:0","29cadadfebdd578a50b7b3d1b2c5b33e424d5de7":"crwdns19075:0crwdne19075:0","a48e81d4a8da67637b46725824177a959fe99b21":"crwdns19076:0crwdne19076:0","6f3e6ebf249947cec4f64117253a8fe43335ae79":"crwdns19078:0crwdne19078:0","fcb6e90e7223e1d1d735f15dbb7ded9d81bbe7ef":"crwdns19077:0crwdne19077:0","4ca0a75c2b7fa7da4364d03b72c46fee1860a2bf":"crwdns19080:0crwdne19080:0","fe6e18b8a20bcadd6c2d0dffa913e7a47089ae51":"crwdns165621:0crwdne165621:0","d171baee235d4c93f63755a876782dc5be4c3e47":"crwdns19084:0crwdne19084:0","056f19272d96f902c38207cf163ea8dbff7fbd32":"crwdns19085:0crwdne19085:0","36bae31694f85bd7a5b0ad45e51ef622b95baadb":"crwdns19086:0crwdne19086:0","f5c47fd3b3553b10441a06054078cea745177dea":"crwdns19087:0crwdne19087:0","fd825ae94aa79500a878dd4590a4b360e7162663":"crwdns19088:0crwdne19088:0","6ee7980833e1ed72901b919ffd0fa20e1a251d3f":"crwdns19089:0crwdne19089:0","f5169c84497de3aea74f7da9e7e177d1427e736b":"crwdns19090:0crwdne19090:0","4f1b3d682c2a00b393c33637da402463bc11d5ff":"crwdns19091:0crwdne19091:0","0049f8894e41937ebb9111cd3def6749049fb50f":"crwdns19092:0crwdne19092:0","ae4bd34230b59288f30cf8eabb61f624d8a2395e":"crwdns914410:0crwdne914410:0","9b8f0fe1166c5d0caa189837c73fd20f2cc47832":"crwdns914412:0crwdne914412:0","c7203807dc0c59bc8309ae9419e58aeefc9a1d85":"crwdns914414:0crwdne914414:0","ddc276ad13af5a78ab33c0c2a8f70f135c28c345":"crwdns914416:0crwdne914416:0","169dd3b2025485a48b8f9f3f6ef89f5586714140":"crwdns914418:0crwdne914418:0","420b40e4b9718b4c48f1acce5abd0b737b7d83f3":"crwdns914420:0crwdne914420:0","b763f8cbfa6396f195781032619a99bba04bc939":"crwdns914422:0crwdne914422:0","e9e8c0f9148c1e5de530906ab27a3879754f4a45":"crwdns688066:0crwdne688066:0","0b0eab6610f3ee14b733eefdab36f52c79e201c8":"crwdns914424:0crwdne914424:0","0ce7480da93c1c9839818d0720b77931d1637574":"crwdns914426:0crwdne914426:0","6e6a4c6839d2e859758a517865b095c1b8298dd6":"crwdns688080:0crwdne688080:0","c1b51f196c97b4781a354457579e9699b09de087":"crwdns688070:0crwdne688070:0","4708f7e87263464b130b987e4b9aed981c4f455d":"crwdns914428:0crwdne914428:0","b7fceac7d5f885d735aeda6e4654487467d33fa3":"crwdns914430:0crwdne914430:0","79a206119137878eb6be7c60f7ed34135194bdf0":"crwdns838444:0crwdne838444:0","18bfc7db963cbdfb1987f7a6cc787d7389b03b06":"crwdns688074:0crwdne688074:0","7e8a262afe09b59e895255948e13d85c1f5bd8b9":"crwdns688076:0crwdne688076:0","14b2a808fdec3702e5a6b9152e13288c87a4768a":"crwdns838446:0crwdne838446:0","b9fc69c87a2a8e9f3a46a7680f06c9031e484257":"crwdns838448:0crwdne838448:0","aac1569ccf6b1a11b0ad0fbefdb9ffc777b4c733":"crwdns18881:0crwdne18881:0","d1a17af19f5388af9d6596cc0ea7dbb1d739e255":"crwdns52904:0crwdne52904:0","53adebdc2b1cbbedb56395b19a73fe47b87cc554":"crwdns18834:0crwdne18834:0","5fb1db527825d2996e37c655e5dec49d4da80c09":"crwdns18835:0crwdne18835:0","092f99ea11a34a8490e7a767a83a42fc45634f82":"crwdns18836:0crwdne18836:0","9e25a34e635a123f8958bbe26e7c4843278597fb":"crwdns18837:0crwdne18837:0","f6bb0f468a8569c67b3d6826e57e62c5500c3681":"crwdns52898:0crwdne52898:0","db6708630fc646eb98298d9acd701e0a1ac051c2":"crwdns53604:0crwdne53604:0","85538d002a336c5addef8d189d80976cf7758f8c":"crwdns53606:0crwdne53606:0","b65463cb6a42a17de514acc4659f7fd331e0876a":"crwdns53608:0crwdne53608:0","ed28e0686e1251ba046f582a3e9ec02470a5e78d":"crwdns53610:0crwdne53610:0","cd5f85b6f187605f82386eacd680f93820af8d11":"crwdns18949:0crwdne18949:0","1e38ce3d180cefae485a6986ca7c67841e30376f":"crwdns18950:0crwdne18950:0","5c89497fc3c128e2ff865ce8df15356054f2c028":"crwdns18953:0crwdne18953:0","14ea81918758c994cbe3178e695e56afc1ef2b45":"crwdns18954:0crwdne18954:0","5098e2bcc96ee227983c9f7eeddfd226c220ca00":"crwdns18955:0crwdne18955:0","251c830f8f869e0887e8b4dc4c30ba1738c7097e":"crwdns18956:0crwdne18956:0","b3b543c80063a116ced4965d8537b7b62d14c0b7":"crwdns18959:0crwdne18959:0","a1eeb7c1e92e9a5d9323ed8ebd7ca7ffed8b0232":"crwdns18960:0crwdne18960:0","da3105e38c42a481ad7230ed393b0e12bebe9c4f":"crwdns18961:0crwdne18961:0","343fda69c73b78b84967055aae97f790c422adfd":"crwdns18962:0crwdne18962:0","fb61a3c71f4c488b3b470cb7daf502a3e9b5ad48":"crwdns18964:0crwdne18964:0","9bb396940adb9705fe57eba6ea8b578e6aafa792":"crwdns18791:0crwdne18791:0","87da93a46d143f6019979b3548414d9d7adabb35":"crwdns18965:0crwdne18965:0","4c2fdde3d9c1950498ed263d6ce21d4bf3d0800b":"crwdns18967:0crwdne18967:0","ca5586bdb5bdc1a2c0baf53ed0ecd21fafabebe7":"crwdns18968:0crwdne18968:0","03bad10717e183b24829baf483dc715e1a44bf7b":"crwdns18969:0crwdne18969:0","2c71ed279a402e93312dbda173ab18f244d6bf46":"crwdns18970:0crwdne18970:0","17632a9f51611d2579d95b4b1ccb9476566d7ccf":"crwdns18971:0crwdne18971:0","579607dc4f989ce2b94b558431666a0ab07ac1f3":"crwdns18972:0crwdne18972:0","e20afd5cf3811a42071c9a312abb2afdad4c590b":"crwdns18973:0crwdne18973:0","4712cbff8e92822fc960ef9c0197293a19675eae":"crwdns18974:0crwdne18974:0","df817b48c7a076561b4f8bedc52d65d2e351ab52":"crwdns18975:0crwdne18975:0","b44e884c355e447d0da0e6ba45caaff18c84373b":"crwdns19030:0crwdne19030:0","d6a2a207343bd83aacdc80b579ff4419713a256e":"crwdns19031:0crwdne19031:0","170a28a9db6d27d7212fc6dc249434a57517e7bc":"crwdns19032:0crwdne19032:0","b833989d69900a4be9e32d1bab65c8f8233f099e":"crwdns19033:0crwdne19033:0","1cee82f19c0bedef64f68b32e6b02128efe7c61b":"crwdns19034:0crwdne19034:0","974da601086448d0060aeed90e53ddd5acd17b91":"crwdns19035:0crwdne19035:0","d5b65cac1f1cf9421ac978eebe532de99040cca6":"crwdns19036:0crwdne19036:0","58de49791c64aba14e36e5887244a5ef088286cd":"crwdns19037:0crwdne19037:0","4bd99f76f1104229744455d93df0ff76b9eeed58":"crwdns19038:0crwdne19038:0","ea615c6d6a74e25a6d2f1bc9980b46e73508c2eb":"crwdns19039:0crwdne19039:0","4082d9379e59b38c891d046312f8d3c4b64ae3b1":"crwdns19040:0crwdne19040:0","562edc102c5dd9e2fbbede1140b8a5461c2d4dc8":"crwdns19041:0crwdne19041:0","a537f4f3c0f6c68bf896fb23cb2ecdc658488ea2":"crwdns19107:0crwdne19107:0","b18e572ea14edd48587145f1ef50718adbf256c6":"crwdns19108:0crwdne19108:0","974023bddd6249d0f6404872cfcae205b2599ea2":"crwdns19109:0crwdne19109:0","5c2adcb3d1bfd6b9f5c2dec13d02a9473e4445a1":"crwdns52900:0crwdne52900:0","6b15ce93fd68d80aeee7f7964c1306044c3c1baf":"crwdns19111:0crwdne19111:0","95ec92885c855ba9cf734c17a43f081901e4d2cc":"crwdns19042:0crwdne19042:0","b033619e108c9e43bfd8a42cd97bf5c5dc86dc65":"crwdns19043:0crwdne19043:0","4034de66995b876b2ba9bfd0274025e39168e05d":"crwdns19044:0crwdne19044:0","f9da880c8b0e4cce4431912c24eba939e6bc06e1":"crwdns19045:0crwdne19045:0","a9842c95766da40bf4ea6ee263cb5a5985847763":"crwdns19046:0crwdne19046:0","347775a293c14362d492f019e677c965be1d6e7d":"crwdns19047:0crwdne19047:0","4cc7b9e53d082896ad884eb01be16320af65f282":"crwdns19048:0crwdne19048:0","2c75179a57af3c36581008b65e86ed81c4a4cbea":"crwdns19049:0crwdne19049:0","39f024cf49724fe7ffdea7773c72ed06eec998e1":"crwdns29884:0crwdne29884:0","e4bed3e67e58b2334ee4b9c6ce59ac7a95d80aaf":"crwdns18980:0crwdne18980:0","ad47561efb1dcbd7246d9b64487f615647fda036":"crwdns18981:0crwdne18981:0","05bef508aadd62bf3967dcf67d769da296f19989":"crwdns18982:0crwdne18982:0","21bfc78607d3a64de767a6677d1db42156d5039d":"crwdns165763:0crwdne165763:0","d089ab98a846a521b09aad6ff3fefa728bfa8b42":"crwdns19678:0crwdne19678:0","cdb31fc857f01a59f664413498293c714285f46d":"crwdns18984:0crwdne18984:0","20fd5f86f08796f145d69dedc209a27e459b2f51":"crwdns18985:0crwdne18985:0","a96606af8c33ac3428b45abc4782dbf93f458d29":"crwdns18986:0crwdne18986:0","90ed0e1ea5c1907f8a32d8051a66e845857bb2a4":"crwdns33430:0crwdne33430:0","248428facb97408414180d4de74e4db35360fbc4":"crwdns33431:0crwdne33431:0","2e4202acde880b7b1c3686f0335ff879fc1e5c7a":"crwdns18987:0crwdne18987:0","e46e0bd2f7fe37217dec8aa26ebce8ffa3608663":"crwdns18988:0crwdne18988:0","d5fde4c9d5edf660f760fc226df4d2678d3334ab":"crwdns18989:0crwdne18989:0","95e552a40d3446c96905cd3ec7e3d123d0246ce8":"crwdns18990:0crwdne18990:0","5a0ed227a01b7d30b05dcaf3e1c23b74b9be6ff4":"crwdns19772:0crwdne19772:0","a4220593d385a720886f7af1ed3c478fd0c6339c":"crwdns19773:0crwdne19773:0","cd8cdf3d47e921c8a72addae9269e66041d417c5":"crwdns18992:0crwdne18992:0","3e4f335e7a6f79bd1bafd219ddde30acbf16a7ac":"crwdns19774:0crwdne19774:0","34037f9452fdb66c9ca27ebcc0afe9d5139e9e24":"crwdns19775:0crwdne19775:0","aba43a580daa7f306956ec69b83e6e37e7233126":"crwdns18979:0crwdne18979:0","e04b522218a181cf0223042dd18ae08dcc22d8d3":"crwdns18993:0crwdne18993:0","6ee445fc253a55c9ed54c009c3f020ac65200d80":"crwdns18994:0crwdne18994:0","ed44b69176217a1251c04f0c13d23ac789ea60b2":"crwdns121064:0crwdne121064:0","ea24dd1988c6534a5f0d11b8fbbc6c374fe68766":"crwdns121066:0crwdne121066:0","4b2340a890e88d1886757c3f7172e273a1edc31f":"crwdns18995:0crwdne18995:0","b54d7b4590559dad64f02d09aacbf6d9863e2624":"crwdns29885:0crwdne29885:0","ebffc758056e6b2fc2af99af17fbc6853e5d3583":"crwdns18997:0crwdne18997:0","17649cac8739adcae95e641f794880272ad33bd1":"crwdns18998:0crwdne18998:0","46ecdefde6a8dd5872cc6e0e52afb717f1140426":"crwdns121068:0crwdne121068:0","3bdc75d5d68b05dfd3ce6dcdf7d9773e60ed0a51":"crwdns121070:0crwdne121070:0","c67ded6b64019212eb2bc69afd761f5b3f626040":"crwdns19011:0crwdne19011:0","569bbd757e1bb8bbccd250b98dc2bb37cb47b787":"crwdns19012:0crwdne19012:0","74751e67c3e1010c343095eaf543e7cb21ced2ef":"crwdns18774:0crwdne18774:0","1f4698382842477e211eb46de81fa506f01a8c34":"crwdns19014:0crwdne19014:0","c1baf816aac5a5cd849768773fc248cd249dc296":"crwdns19015:0crwdne19015:0","c93025710d1ae6cbaf8e710f63eca8edfa0c9399":"crwdns19776:0crwdne19776:0","9693aeaaf68e3929b59b79306feaa0a847d01192":"crwdns19017:0crwdne19017:0","78d7103a319e808455d397513279d99f3b3f3768":"crwdns18792:0crwdne18792:0","10c02649e226d430bd75a5b6315a41c0db9992a2":"crwdns53196:0crwdne53196:0","837276742aa90209dde3b4eef07d8e7ab26731ef":"crwdns53198:0crwdne53198:0","258b49925b41751c6bd790a0848246566ba61440":"crwdns27133:0crwdne27133:0","c55ee3445cd391ab299b6f85a6ea9a68a65ea64d":"crwdns27134:0crwdne27134:0","b410994b67e37d9516eb9b866c85a8c639f79e68":"crwdns27135:0crwdne27135:0","2260c5a971c2602834ef8feeb5fa522f900b469f":"crwdns27136:0crwdne27136:0","0745acf92abd7b60598f161717884cc45dab8694":"crwdns19777:0crwdne19777:0","999e1ade10ff5ee1d115f5a6288bfd2e0d0736e6":"crwdns19778:0crwdne19778:0","a43c3299d30a5bc7e31a574cdc87f59cbc8fe585":"crwdns19023:0crwdne19023:0","4d22b565e4253e92a908f216184779679bb1a044":"crwdns53200:0crwdne53200:0","b70c38c6db3127422e05315c30bdf76c7c36c480":"crwdns53202:0crwdne53202:0","a6c5f081b3addee364af1c8cdb84853f49dc8e07":"crwdns53204:0crwdne53204:0","802dc02469ae51067ca620ff57dfb5bdb3e524ac":"crwdns18999:0crwdne18999:0","c4ee8e12b2484cd5b47cdf00bfa2c50b83e91d3d":"crwdns19000:0crwdne19000:0","69280143949fcd59c171dd60f6b6e13d0cc08fe6":"crwdns19061:0crwdne19061:0","d072c2ceeb5c1217722d14c74de7aeab945b4215":"crwdns19002:0crwdne19002:0","e98ea4ac4e2cfd6a4c84386534c5d1acd7ec85d3":"crwdns121072:0%1crwdnd121072:0%2crwdne121072:0","27305f6365c38dd36f5b5eb781e05b5e2e4e3f6e":"crwdns121074:0crwdne121074:0","b06acc4158c824231f727a13e1c9811f43d5be42":"crwdns19003:0crwdne19003:0","661db37251a1ed1afe357ee13895f37a623d7cbf":"crwdns19004:0crwdne19004:0","6c03ee54ad3a51fc92a1d69943e99667847705b6":"crwdns19005:0crwdne19005:0","b1bec5d06e3672915d81b2fbc2347c8b4947a954":"crwdns29882:0crwdne29882:0","a2d0c89fdfff3176efd4a443eb0f6607067b93e7":"crwdns19006:0crwdne19006:0","6e0fc122f936f808bc2e3af661121b65712ae855":"crwdns67010:0%1crwdnd67010:0%2crwdnd67010:0%3crwdnd67010:0%4crwdne67010:0","1aeb6caed9e46edf5d6224adc905ffb8ee3a7708":"crwdns67012:0crwdne67012:0","45ebd38f4c641ebf6f72be8c3a79dfa50cf9f20e":"crwdns19007:0crwdne19007:0","ffb465875e1ff2b49bcaa7c6b70965ffe39fa59d":"crwdns19008:0crwdne19008:0","532e65f6e266db0bb442d1f426d44d7d32962340":"crwdns121076:0crwdne121076:0","78e84591ff76f992953a8e19b57c7eab7546d638":"crwdns121078:0crwdne121078:0","bc528d26f66fe8c4aa4bb24ec9c99dff12c055e0":"crwdns19009:0crwdne19009:0","bea5756b18644ccfab01c1c0dbd6fa9db7103379":"crwdns19010:0crwdne19010:0","7d500ebe352ccfa932b253e21938813a06fcff8e":"crwdns121080:0%1crwdne121080:0","e770fd2a6b980a0815592b1bd499127c5a5cfe39":"crwdns121082:0crwdne121082:0","a35646754dbe7a9211ba8b81338a5d64580eb276":"crwdns121084:0crwdne121084:0","69b0648eddd207cd45a9e1ba973dae287b535576":"crwdns121086:0crwdne121086:0","0f2ba74929aca6fea950e351dcd576b7cd841fa4":"crwdns19026:0crwdne19026:0","6f69eb9519c0ac8fa014de9fbbc1f3054663440f":"crwdns165765:0crwdne165765:0","7cb3b482ab66947d439642ec64dc7f5bd4e065dc":"crwdns19780:0crwdne19780:0","5925d08228e246f07b790b88ad70c1b73a97d2bc":"crwdns19781:0crwdne19781:0","852b438f91ad9eb2cdd84419a675a216d543c687":"crwdns18976:0crwdne18976:0","67d3b35a0b740127b56bcd44d3bcb1ccc20e0b48":"crwdns19782:0crwdne19782:0","d79d854dcd0829e2177a47beab6a55569e781ab1":"crwdns19029:0crwdne19029:0","5606b4460ac96063b8a8e5647008f3ec97252fc5":"crwdns19050:0crwdne19050:0","2de20bdeecb1a8c28bd36fe75f028ed4318d0348":"crwdns19051:0crwdne19051:0","f43cb41af7ce8a69c7aecbc1c603bb0381270982":"crwdns19052:0crwdne19052:0","4b6fe6898f0f956d48a4c8172c6dfbcb4159ab09":"crwdns19053:0crwdne19053:0","2eea87bb804e4e73e3f8e9c41140f7ed83ea8875":"crwdns19054:0crwdne19054:0","e0af6ddc8a892704f64680bcb22b30c4bfcefec5":"crwdns19783:0crwdne19783:0","7b9c76088576a64f32d67ec335162b9f73eaa026":"crwdns19055:0crwdne19055:0","ff56ffac023cf69ca5c7f71d407499536f4f86b5":"crwdns19056:0crwdne19056:0","e9fb732dde76a6977bcaa2818b0f56125b183648":"crwdns121088:0crwdne121088:0","b86e1d757d9ef3e53efb6886fec88b7742174ad8":"crwdns165767:0crwdne165767:0","1a90ae7cb728e7f25b031d7e844882f75e74ab5c":"crwdns121090:0crwdne121090:0","7f6c7119203ceef19d6d6eb3dd6cd43e0b2d6adc":"crwdns165769:0crwdne165769:0","32d0aa17deb526e558836ab4f6d2a0871a1e637d":"crwdns688090:0crwdne688090:0","64f72129852fb7bdff0725c71324a012630f53bf":"crwdns163622:0{$0}crwdnd163622:0{$1}crwdne163622:0","8034ed3111d20cf13519b3c9a31ffe2a2c1e3975":"crwdns163624:0{$0}crwdnd163624:0{$1}crwdnd163624:0{$2}crwdnd163624:0{$3}crwdnd163624:0{$4}crwdnd163624:0{$5}crwdne163624:0","10dd345bc3319e2151794428b2c709dc5fc381a7":"crwdns163626:0crwdne163626:0","6bb34efcfdb48440f9c813feb12ca5fb76c88f29":"crwdns163628:0crwdne163628:0","ad0fc99c05681528248b73007dba16fd760a81c6":"crwdns163630:0{$0}crwdnd163630:0{$1}crwdne163630:0","1fda2716eb92e0195ff59b110af23d86b43fd909":"crwdns163632:0crwdne163632:0","be7786af641b859c03ec152461d791480cf676ed":"crwdns163634:0{$0}crwdnd163634:0{$1}crwdne163634:0","33e5b173ac5d54798a2b39560896f6ecac5e23f5":"crwdns163646:0{$0}crwdnd163646:0{$1}crwdnd163646:0{$2}crwdnd163646:0{$1}crwdne163646:0","512b301aa6fd33dd6772c0a637a42855aa1a55f5":"crwdns163644:0{$0}crwdnd163644:0{$1}crwdne163644:0","d87250dbe6a9bad6d94ba629e1b1140c80268de0":"crwdns163640:0crwdne163640:0","496a99878841de69368c33af9e88eb37c0da5712":"crwdns163642:0crwdne163642:0","a726d863bbdceba7b06a1083026a53db76de47b7":"crwdns838454:0crwdne838454:0","8040c5a2eb78ff6e3337939cf5bdcd6ea2827c97":"crwdns838456:0crwdne838456:0","febe8aef26fb3017be5bf43d66f7972731c20833":"crwdns838458:0crwdne838458:0","a8c1114d1c88db12afa05b331188ceb77afad6e3":"crwdns838460:0crwdne838460:0","d29324705a18a81ffc0376f3f37639a68827f3e6":"crwdns838462:0crwdne838462:0","ba2098a209e375402a0cf222cec87cce26440767":"crwdns838464:0crwdne838464:0","62c2b38dbae81f8f78c380c7a4a2c16e31efa9e0":"crwdns838466:0crwdne838466:0","f24b296f15100128ceb9a4463c82d0193a7f5ec3":"crwdns838468:0crwdne838468:0","3b0585be5b6872a83ec3bd80b281cc9f69908f9f":"crwdns838470:0crwdne838470:0","f0519ce6c2c213196e4e569427bbd1d3eb339dd9":"crwdns838472:0crwdne838472:0","a9cc5de91e2d20184f6bf373463f776e38bb4dfa":"crwdns838474:0crwdne838474:0","64dfd7424a05133b74cfb93fcbe385ede6539855":"crwdns838476:0crwdne838476:0","824d76b124e6289f372e2ff6bcba91e8939343bd":"crwdns838478:0crwdne838478:0","a6f6fd7bee6b5b613188cd3662db0c6354b6b542":"crwdns838480:0crwdne838480:0","d9fb7b44655fe2a14db955d5df7f3c0c1f394a4d":"crwdns838482:0crwdne838482:0","54617a018fc6dffb3a70627b97f0db5c52a4081d":"crwdns838484:0crwdne838484:0","dbcd68f389d64fc531a650652c87b7d83fc82d94":"crwdns838486:0crwdne838486:0","dd69c213333a751a0ab3bc9ce6368588bf971b61":"crwdns838488:0crwdne838488:0","bb4a2e7e4a20edc5badcf1e414de83a418e15d36":"crwdns838490:0crwdne838490:0","2b5284aee7302c1f590167d1cbc8f4810ad7d24b":"crwdns838492:0crwdne838492:0","9d8390b240fae20d85ae2d9e1f4688763cb9213e":"crwdns838494:0crwdne838494:0","f63714db18c58c6b4a7a7bad09178faaeca05104":"crwdns838496:0crwdne838496:0","4c692c7d1d9763fb01911e9b58cc579d70a06d42":"crwdns838498:0crwdne838498:0","d85438daeed7ba0f0e7d1ceb63f60d65241dba60":"crwdns838500:0crwdne838500:0","22bc7a19c16cd544acf3dcbe5b84ea3770cb2100":"crwdns838502:0crwdne838502:0","029582bad299ab8f44c57b961210e56569efd536":"crwdns838504:0crwdne838504:0","9a07439b57e510e8e33b372aad2c360dbc39e79c":"crwdns838506:0crwdne838506:0","3d0be0e8eb736257254698ba821c45389e385f1e":"crwdns838508:0crwdne838508:0","c4303d30e60f01fa922400e52df4e96d71b35d6e":"crwdns838510:0crwdne838510:0","91ec40abb1d4e21820b2533a6d4272a7afaa2160":"crwdns838512:0crwdne838512:0","f30ce7459f29851b219b504216581bf3d3446de0":"crwdns838514:0crwdne838514:0","6df6091514ee13992a3ac28445af1d9a1afbcb67":"crwdns838516:0crwdne838516:0","92c8b7b779e7cf179b89484285fd766274b3bf1f":"crwdns838518:0crwdne838518:0","a87a92c5ce4925186a081cf4478639fcc31b12ed":"crwdns688094:0crwdne688094:0","a46db859f2ffc329f3d01c5b315a9a56f6105ec1":"crwdns688096:0crwdne688096:0","720280451c98ceeb796f3c7fa118813fc8da694d":"crwdns688098:0crwdne688098:0","0f1dda628bebb4748de6df05fa3bff4989c1b476":"crwdns688100:0crwdne688100:0","3e6255d32f531dbf1aaf124e80575f421e1b7ddb":"crwdns688102:0crwdne688102:0","54117fc5c73f8eabc7d4751ea2acf8c7d820ecef":"crwdns688104:0crwdne688104:0","a56aa088dfea506d5dbe18f385c29418f771a639":"crwdns688106:0crwdne688106:0","82e976b58ebedb2b5e92a92e2ebaacb599fb2479":"crwdns688108:0crwdne688108:0","9e90017ca77d770a6f8c040203bdba0160f8aaa6":"crwdns688110:0crwdne688110:0","74e8fa69aad80f93303a7723e5a304f3d43560b6":"crwdns688112:0crwdne688112:0","0ceb7d8f887dce9b65a7a6798c27ab2594a43794":"crwdns688114:0crwdne688114:0","5bb3f3499158dbe30af5c725694b321dfe821433":"crwdns688116:0crwdne688116:0","1247fb4b977efecd8d37a5b9ca3d7ffcf5caad5d":"crwdns688118:0crwdne688118:0","833e86e728ce51b58e8ec2a077b794607b4eb0fe":"crwdns838520:0crwdne838520:0","f49e0100f196ee1063a6173f5a471f2c7a0d575d":"crwdns838522:0crwdne838522:0","991753597fde70aab5791de6d50ee8cc49a0bdcc":"crwdns838524:0crwdne838524:0","efa99ab039a285c6264580bea691a4ffefcbeee7":"crwdns838526:0crwdne838526:0","1fb089892f544af053e9e5bc8f8dacc0f3243dee":"crwdns838528:0crwdne838528:0","1899bfb0a01633771c2d59182e9be8fc1df9bbbf":"crwdns838530:0crwdne838530:0","52b8454dc755419beeff2f90cd0fc91def428244":"crwdns838532:0crwdne838532:0","27ad1d8334221366694c7acdd70fb380857d1e6e":"crwdns688126:0crwdne688126:0","8f7c467cca3c83a35c630a9fb1511e0cc73eb072":"crwdns838750:0crwdne838750:0","0d03fb62cc4445a0c1ec1c137fa78f0522b0db73":"crwdns688136:0crwdne688136:0","dfaef702b4f00d1e312a377a9b2fa7e8d50f1c5d":"crwdns688138:0crwdne688138:0","35eeb4246a88571478c1ec33e2b6e1ac302a987e":"crwdns688140:0crwdne688140:0","63fbf7977349e32e4a124ffa047549b720806d73":"crwdns838536:0crwdne838536:0","03d42257a2263b2841b9e0ae4b94de117228a33a":"crwdns838538:0crwdne838538:0","c0655f2649787bef336b5bd4cdf6a9e3cfbdad8b":"crwdns838540:0crwdne838540:0","6b7499b1513a3cec3da3ff07cdad9b358954021e":"crwdns688142:0crwdne688142:0","b23efda40ddeb801beeebf915669d806744014af":"crwdns688144:0crwdne688144:0","36f5564b8219dabd18d50d58e1b175f37e2ccdff":"crwdns838542:0crwdne838542:0","34075438f939258908cc21d28bf59ab5126dc2d6":"crwdns838544:0crwdne838544:0","e669443b63757b5ad8571e52393caf2a0a812be3":"crwdns688092:0crwdne688092:0","2c141583afaaa12438b16ee67355c6e3eaf77763":"crwdns688120:0crwdne688120:0","4e0e045da59b385138ced3203cdb81c3b4cdd135":"crwdns688122:0crwdne688122:0","ea766ab28278cfd896ba57264caf9b2ca8bfd912":"crwdns688134:0crwdne688134:0","d94b3a1a4a8c9de87b83fb14776fc30000bb79fe":"crwdns688128:0crwdne688128:0","1071c645f523394b408a6d285e95331bc583f14c":"crwdns688130:0crwdne688130:0","be43a8989c5745ec7386ca7c69442165f55dee8e":"crwdns688132:0crwdne688132:0","074603c9aef93515ed33d179e982c67ea7abdb45":"crwdns688146:0crwdne688146:0"}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);



var Hero = function Hero() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "hero"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "hero-inner section-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "hero-inner__content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Binary Bot has a new home')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('We’ve been Binary.com for 2 decades and it’s time for an exciting new chapter. Your favourite bot builder, Binary Bot, is now on Deriv, our new home. Come take a peek.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "btn-group"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://bot.deriv.com"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "l-btn primary"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Take me to Binary Bot on Deriv'))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "hero-inner__placeholder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: ""
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "hero-inner__binary_logo",
    src: "image/binary.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/laptop-1.webp"
  }))));
};

/* harmony default export */ __webpack_exports__["a"] = (Hero);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_appId__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_tools__ = __webpack_require__(49);





var SwitchSection = function SwitchSection() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "switch"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "switch-inner section-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "switch-inner__placeholder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/sectionTwoLandingImages.png"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "switch-inner__content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('It’s so easy to switch to Deriv')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Just log in using your Binary.com credentials. No sign-up needed.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "btn-group"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: Object(__WEBPACK_IMPORTED_MODULE_2__common_appId__["i" /* getOAuthURLDeriv */])()
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "l-btn danger"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Try it now')))))));
};

/* harmony default export */ __webpack_exports__["a"] = (SwitchSection);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_i18n__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Translations__ = __webpack_require__(182);






var Carousel = function Carousel() {
  var settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    nextArrow: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
      className: "arrow right"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      src: "./image/icon.svg"
    })),
    prevArrow: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
      className: "arrow"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      src: "./image/icon.svg"
    })),
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 700,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "carousel-wrapper section-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slick___default.a, settings, __WEBPACK_IMPORTED_MODULE_4__Translations__["a" /* default */].carouselContentArray.map(function (slide, index) {
    var title = slide.title,
        content = slide.content,
        action_text = slide.action_text,
        img = slide.img;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", {
      className: "landing_carousel",
      key: index
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "landing_carousel_content"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(title)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(content)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
      href: "https://bot.deriv.com"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
      className: "l-btn danger"
    }, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(action_text)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "landing_carousel_placeholder"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "bot-gif-placeholder"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "bot-gif-placeholder__background"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      src: "image/laptop_carousel.webp"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "bot-gif-placeholder__background__overlay"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("video", {
      autoPlay: true,
      muted: true,
      loop: true
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("source", {
      src: img,
      type: "video/mp4"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("source", {
      src: img,
      type: "video/ogg"
    })))))));
  })));
};

/* harmony default export */ __webpack_exports__["a"] = (Carousel);

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _innerSlider = __webpack_require__(282);

var _json2mq = _interopRequireDefault(__webpack_require__(289));

var _defaultProps = _interopRequireDefault(__webpack_require__(291));

var _innerSliderUtils = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(292);

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
      } else {
        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _initialState = _interopRequireDefault(__webpack_require__(283));

var _lodash = _interopRequireDefault(__webpack_require__(284));

var _classnames = _interopRequireDefault(__webpack_require__(107));

var _innerSliderUtils = __webpack_require__(88);

var _track = __webpack_require__(285);

var _dots = __webpack_require__(286);

var _arrows = __webpack_require__(287);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(288));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }

  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(107));

var _innerSliderUtils = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread(_objectSpread({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  var _super = _createSuper(Track);

  function Track() {
    var _this;

    _classCallCheck(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "node", null);

    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(107));

var _innerSliderUtils = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  var _super = _createSuper(Dots);

  function Dots() {
    _classCallCheck(this, Dots);

    return _super.apply(this, arguments);
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrevArrow = exports.NextArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(107));

var _innerSliderUtils = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  var _super = _createSuper(PrevArrow);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _super.apply(this, arguments);
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  var _super2 = _createSuper(NextArrow);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _super2.apply(this, arguments);
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(290);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 290 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(293);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(294);
var Util = __webpack_require__(181);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(295);
var each = __webpack_require__(181).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);



var WaitSection = function WaitSection() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "wait-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "wait-wrapper-inner section-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "wait-wrapper-inner-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Don’t wait')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Future-proof your trading. Come over to Deriv now.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "btn-group"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://bot.deriv.com"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "l-btn danger"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Trade Binary Bot on Deriv'))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "wait-wrapper-inner-placeholder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/dont-wait-image.svg "
  }))));
};

/* harmony default export */ __webpack_exports__["a"] = (WaitSection);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_i18n__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translations__ = __webpack_require__(182);





var ChooseSection = function ChooseSection() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", {
    className: "choose-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "choose-wrapper-inner section-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", {
    className: "choose-wrapper-inner-title"
  }, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('6 reasons you’ll love Deriv')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "choose-wrapper-inner-section-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "choose-wrapper-inner-section-content-row"
  }, __WEBPACK_IMPORTED_MODULE_3__Translations__["a" /* default */].carouselContentArrayOne.map(function (slide, index) {
    var title = slide.title,
        content = slide.content,
        img = slide.img;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "choose-wrapper-inner-section-content-row-inner",
      key: index
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "choose-wrapper-inner-section-content-row-inner-placeholder"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      src: img
    })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "choose-wrapper-inner-section-content-row-inner-description"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])(title)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])(content))));
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "choose-wrapper-inner-section-content-row"
  }, __WEBPACK_IMPORTED_MODULE_3__Translations__["a" /* default */].carouselContentArrayTwo.map(function (slide, index) {
    var title = slide.title,
        content = slide.content,
        img = slide.img;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "choose-wrapper-inner-section-content-row-inner",
      key: index
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "choose-wrapper-inner-section-content-row-inner-placeholder"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      src: img
    })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "choose-wrapper-inner-section-content-row-inner-description"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])(title)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])(content))));
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "choose-wrapper-inner-section-content-row"
  }, __WEBPACK_IMPORTED_MODULE_3__Translations__["a" /* default */].carouselContentArrayThree.map(function (slide, index) {
    var title = slide.title,
        content = slide.content,
        img = slide.img;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "choose-wrapper-inner-section-content-row-inner",
      key: index
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "choose-wrapper-inner-section-content-row-inner-placeholder"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      src: img
    })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "choose-wrapper-inner-section-content-row-inner-description"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])(title)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])(content))));
  })))));
};

/* harmony default export */ __webpack_exports__["a"] = (ChooseSection);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);

 // TODO :- NEED TO IMPORT TEXT FROM TRANSLATONS.JS FILE

var Footer = function Footer() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "about-trade-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner section-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner-social-icons-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-deriv-icons"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/derivLogo.png"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-social-icons"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.reddit.com/user/Deriv_official/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/reddit.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://t.me/derivdotcomofficial",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/telegram.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.facebook.com/derivdotcom",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/facebook.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://twitter.com/derivdotcom/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/twitter.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.instagram.com/deriv_official/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/instagram.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.linkedin.com/company/derivdotcom/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/linkedin.svg"
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner-social-icons-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.reddit.com/user/Deriv_official/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/reddit.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://t.me/derivdotcomofficial",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/telegram.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.facebook.com/derivdotcom",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/facebook.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://twitter.com/derivdotcom/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/twitter.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.instagram.com/deriv_official/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/instagram.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.linkedin.com/company/derivdotcom/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/linkedin.svg"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner-info"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner-info-location"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('In the EU, financial products are offered by Deriv Investments (Europe) Limited, W Business Centre, Level 3, Triq Dun Karm, Birkirkara BKR 9033, Malta, licensed in Malta '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://deriv.com/regulatory/Deriv_Investments_(Europe)_Limited.pdf",
    target: "_blank"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('(licence no. IS/70156)'))), " ", Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('and regulated by the Malta Financial Services Authority, Triq l-Imdina, Zone 1, Central Business District, Birkirkara CBD 1010, Malta, under the Investments Services Act. Authorised by the Financial Conduct Authority and with deemed variation of permission. Subject to regulation by the Financial Conduct Authority. The nature and extent of consumer protections may differ from those for firms based in the UK. Details of the Financial Services Contracts Regime, which allows EEA-based firms to operate in the UK for a limited period to carry on activities that are necessary for the performance of pre-existing contracts, are available on the Financial Conduct Authority’s website.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Outside the EU, financial products are offered by the following companies: Deriv (FX) Ltd, F16, Level 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia, licensed by Labuan Financial Services Authority '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://deriv.com/regulatory/Deriv_(FX)_Ltd.pdf",
    target: "_blank"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('(licence no. MB/18/0024);'))), " ", Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Deriv (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands, licensed by the British Virgin Islands Financial Services Commission '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://deriv.com/regulatory/Deriv_(BVI)_Ltd.pdf",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('(licence no.SIBA/L/18/1114);'))), Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])(' Deriv (V) Ltd, 1276, Kumul Highway, Port Vila, Vanuatu, licensed and regulated by the Vanuatu Financial Services Commission; and Deriv (SVG) LLC, Hinds Buildings, Kingstown, St. Vincent and the Grenadines.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Deriv Limited — 13 Castle Street, St. Helier, JE2 3BT, Jersey — is the holding company for the above subsidiaries.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('This website\'s services are not available in certain countries, including the USA, Canada, and Hong Kong, or to persons below 18.'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner-info-trade"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('CFDs are considered complex derivatives and may not be suitable for retail clients. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money. The products mentioned here may be affected by changes in currency exchange rates. If you invest in these products, you may lose some or all of your investment, and the value of your investment may fluctuate. You should never invest money that you cannot afford to lose and never trade with borrowed money.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Before trading in the complex financial products offered, please be sure to understand the risks involved and learn about '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://deriv.com/responsible/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Secure and responsible trading.'))))))));
};

/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showHideEuElements; });
/* unused harmony export isEuLandingCompany */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasEuAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isEuCountry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_iterator_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_web_dom_iterable_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_symbol_async_iterator_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_symbol_async_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_symbol_async_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_function_name_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_slice_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appId__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_storageManager__ = __webpack_require__(39);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }













function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* eslint-disable import/prefer-default-export */


var showHideEuElements = function showHideEuElements(isEu) {
  document.querySelectorAll('.eu-hide').forEach(function (el) {
    if (!isEu && el.classList.contains('invisible')) {
      // Keep original display type if invisible was specified.
      el.classList.remove('invisible');
    } else {
      // Default to setting display to block.
      el.setAttribute('display', "".concat(!isEu ? 'block' : 'none', " !important"));
    }
  });
  document.querySelectorAll('.eu-show', '.eu-only').forEach(function (el) {
    if (isEu && el.classList.contains('invisible')) {
      el.classList.remove('invisible');
    } else {
      el.setAttribute('display', "".concat(isEu ? 'block' : 'none', " !important"));
    }
  });
};
/* eslint-disable camelcase */

var isEuLandingCompany = function isEuLandingCompany(landing_company) {
  return /^(maltainvest|malta|iom)$/.test(landing_company);
};
var hasEuAccount = function hasEuAccount(token_list) {
  return token_list.some(function (token_obj) {
    return isEuLandingCompany(token_obj.loginInfo.landing_company_name);
  });
};
var isEuCountry = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var api,
        _yield$api$send,
        website_status,
        clients_country,
        _yield$api$send2,
        landing_company,
        financial_company,
        gaming_company,
        eu_excluded_regexp,
        financial_shortcode,
        gaming_shortcode,
        _args = arguments;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api = _args.length > 0 && _args[0] !== undefined ? _args[0] : Object(__WEBPACK_IMPORTED_MODULE_11__appId__["c" /* generateLiveApiInstance */])();
            _context.next = 3;
            return api.send({
              website_status: 1
            });

          case 3:
            _yield$api$send = _context.sent;
            website_status = _yield$api$send.website_status;
            clients_country = website_status.clients_country; // isLoggedin

            if (Object(__WEBPACK_IMPORTED_MODULE_12__utils_storageManager__["d" /* getTokenList */])().length) {
              clients_country = localStorage.getItem('residence');
            }

            _context.next = 9;
            return api.send({
              landing_company: clients_country
            });

          case 9:
            _yield$api$send2 = _context.sent;
            landing_company = _yield$api$send2.landing_company;
            financial_company = landing_company.financial_company, gaming_company = landing_company.gaming_company;
            eu_excluded_regexp = /^mt$/;
            financial_shortcode = financial_company ? financial_company.shortcode : false;
            gaming_shortcode = gaming_company ? gaming_company.shortcode : false;

            if (!(financial_shortcode || gaming_shortcode)) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", isEuLandingCompany(financial_shortcode) || isEuLandingCompany(gaming_shortcode));

          case 17:
            return _context.abrupt("return", eu_excluded_regexp.test(clients_country));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function isEuCountry() {
    return _ref.apply(this, arguments);
  };
}();
/* eslint-enable */

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js__);



/* eslint-disable */

/*
 * js code for Drop-Down Menu
 */
function hide_menu($element) {
  $element.animate({
    opacity: 0
  }, 100, function () {
    $element.css('visibility', 'hidden').css('display', 'none');
  });
}

function show_menu($element) {
  $element.css('visibility', 'visible').css('display', 'block').animate({
    opacity: 1
  }, 100);
}

function navMenuListener() {
  $('.nav-menu').on('click', function (event) {
    event.stopPropagation();
    hide_menu($('.top-nav-menu li ul'));
    hide_menu($('#language_select, #select_language'));
    var $el;

    if ($(this).is('#toolbox-main-account')) {
      $el = $('#toolbox-all-accounts');
      hide_menu($('#all-accounts'));
    } else {
      $el = $('#all-accounts');
      hide_menu($('#toolbox-all-accounts'));
    }

    if ($el.css('opacity') == 1) {
      hide_menu($el);
    } else {
      show_menu($el);
    }
  });
}

function topNavMenuListener() {
  $('.top-nav-menu > li').on('click', function (event) {
    event.stopPropagation();
    hide_menu($('#all-accounts, #toolbox-all-accounts'));
    hide_menu($('#language_select, #select_language'));
    var childMenu = $(this).find(' > ul'),
        $el = $('.top-nav-menu li ul');

    if (childMenu.css('opacity') == 1 && $(event.target).find('span').hasClass('nav-caret')) {
      hide_menu($el);
    } else if (childMenu.css('opacity') == 0 && $(event.target).find('span').hasClass('nav-caret')) {
      $el.animate({
        opacity: 0
      }, 100, function () {
        $el.css('visibility', 'hidden');
        show_menu(childMenu);
      });
    }
  });
}

function documentListener() {
  $(document).on('click', function () {
    hide_menu($('#all-accounts, #toolbox-all-accounts'));
    hide_menu($('.top-nav-menu li ul'));
    hide_menu($('#language_select, #select_language'));
  });
}

function langListener() {
  $('.languages').on('click', function (event) {
    event.stopPropagation();
    hide_menu($('.top-nav-menu li ul'));
    hide_menu($('#all-accounts, #toolbox-all-accounts'));
    var $el = $('#language_select, #select_language');

    if ($el.css('opacity') == 1) {
      hide_menu($el);
    } else {
      show_menu($el);
    }
  });
}

function initMenuContent(_menu_containers) {
  var listeners_events = [];

  _menu_containers.filter(':not(.follow-default)').delegate('.tm-a,.tm-a-2', 'click', function (event) {
    event.preventDefault();
    var target = $(event.target);
    var tab_id = target.parents('li:first').attr('id');

    if (tab_id) {
      var tab_container = target.parents('.tm-ul');
      var selected_tab = // find previously active tab
      tab_container.find('.tm-a,.tm-a-2') // remove previously active tab
      .removeClass('a-active').end() // unwrap previously active tab
      .find('.menu-wrap-a .tm-a').unwrap().unwrap() // go back to selected target
      .end().end() // set active class to it
      .addClass('a-active') // set active class to its parent as well
      .parents('.tm-li').addClass('active').removeClass('hover').find('.tm-li-2').addClass('active').end() // wrap it
      .find('.tm-a').wrap('<span class="menu-wrap-a"><span class="menu-wrap-b"></span></span>').end() // remove previously active parent
      .siblings().removeClass('active').find('.tm-li-2').removeClass('active').end().end().end(); // replace span to a, to make it clickable for real

      var span_tm_a = tab_container.find('span.tm-a');
      span_tm_a.replaceWith('<a href="#" class="' + span_tm_a.attr('class') + '">' + span_tm_a.html() + '</a>');
      var menu_li = selected_tab.parents('li');
      var sub_menu_selected = menu_li.find('.tm-ul-2 .a-active');
      var selected_tab_id = menu_li.attr('id');

      if (!sub_menu_selected.length) {
        sub_menu_selected = menu_li.find('.tm-a-2:first').addClass('a-active');

        if (sub_menu_selected.length) {
          selected_tab = sub_menu_selected;
          selected_tab_id = sub_menu_selected.parents('li').attr('id');
          selected_content = $('#' + selected_tab_id + '-content').removeClass('invisible');
        } else {
          selected_tab_id = menu_li.attr('id');
        }
      }

      var selected_content = $('#' + selected_tab_id + '-content') // show selected tab content
      .removeClass('invisible') // and hide the rest
      .siblings(':not(.sticky)').addClass('invisible').end();
      push_to_listeners({
        id: selected_tab_id,
        target: selected_tab,
        content: selected_content,
        menu: menu_li.parents('ul.tm-ul'),
        event: event
      });
    }

    return false;
  });

  function push_to_listeners(info) {
    // push to listeners events
    for (var i = 0; i < listeners_events.length; i++) {
      listeners_events[i](info);
    }
  }
}

navMenuListener();
topNavMenuListener();
documentListener();
langListener();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bannerToken", function() { return bannerToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expirationDate", function() { return expirationDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcSetTimeoutValueBanner", function() { return calcSetTimeoutValueBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timerForBanner", function() { return timerForBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getComponent", function() { return getComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTimeOutBanner", function() { return setTimeOutBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderBanner", function() { return renderBanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__endpoint__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__react_components_logo_jsx__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__react_components_footer_jsx__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_appId__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_footer_checks__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_gtm__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_lang__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_utils_utility__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_utils_tools__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_binary_ui_dropdown__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__react_components_bot_landing__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__react_components_binary_landing__ = __webpack_require__(944);


















var today = new Date().getTime(); // eslint-disable-next-line one-var

var oneMilliSec = 1000;
var sevenDays = 7;
var oneMinute = 60;
var oneDay = 24; // eslint-disable-next-line one-var

var bannerToken = true;

if (bannerToken) {
  Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["e" /* remove */])('setDueDateForBanner');
} // eslint-disable-next-line arrow-body-style


var expirationDate = function expirationDate() {
  return today + oneMilliSec * oneMinute * oneMinute * oneDay * sevenDays;
};
var calcSetTimeoutValueBanner = expirationDate() - new Date().getTime(); // eslint-disable-next-line import/no-mutable-exports

var timerForBanner;

var checkifBotRunning = function checkifBotRunning() {
  if (document.getElementById('runButton').style.display === 'none') {
    return true;
  }

  return false;
};

var Component, dynamicRoutePathanme;
var getComponent = function getComponent() {
  if (window.location.pathname === '/movetoderiv.html') {
    Component = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__react_components_binary_landing__["a" /* default */], null);
    dynamicRoutePathanme = 'movetoderiv';
  } else {
    Component = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__react_components_bot_landing__["a" /* default */], null);
    dynamicRoutePathanme = 'bot-landing';
  }

  return {
    Component: Component,
    dynamicRoutePathanme: dynamicRoutePathanme
  };
};
var setTimeOutBanner = function setTimeOutBanner(route) {
  var bannerDisplayed;
  var qs = Object(__WEBPACK_IMPORTED_MODULE_14__common_utils_tools__["g" /* parseQueryString */])(); // eslint-disable-next-line consistent-return

  timerForBanner = setTimeout(function () {
    if (route === 'index' && !!bannerDisplayed === false || route === 'views' && checkifBotRunning() === false) {
      var getDefaultPath = window.location.href.replace(/\/bot(\.html)?/, Object(__WEBPACK_IMPORTED_MODULE_14__common_utils_tools__["i" /* serialize */])(qs));
      window.location.replace(getDefaultPath); // renderBanner();
    } else if (route === 'index' && !!bannerDisplayed === true || route === 'views' && checkifBotRunning() === true) {
      Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["e" /* remove */])('setDueDateForBanner');
      return false;
    }
  }, calcSetTimeoutValueBanner);
};
var renderBanner = function renderBanner() {
  if (window.location.pathname.indexOf('/bot') === -1 || window.location.pathname === '/movetoderiv.html') {
    getComponent();
    Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["render"])(Component, document.getElementById(dynamicRoutePathanme));
    document.getElementById(dynamicRoutePathanme).classList.remove('hidden');
    document.getElementById('topbar').classList.remove('hidden');
    $('.barspinner').hide();
  }
}; // eslint-disable-next-line consistent-return

var renderElements = function renderElements() {
  // eslint-disable-next-line one-var, no-unused-vars
  getComponent();
  setTimeOutBanner('index');
  $('.barspinner').show();

  if (!bannerToken) {
    if (window.location.pathname.indexOf('/bot') === -1) {// renderBanner();
      // document.getElementById('bot-main').classList.add('hidden');
    }
  } else {
    // render(<Footer />, document.getElementById('footer'));
    Object(__WEBPACK_IMPORTED_MODULE_9__common_footer_checks__["b" /* isEuCountry */])().then(function (isEu) {
      return Object(__WEBPACK_IMPORTED_MODULE_9__common_footer_checks__["c" /* showHideEuElements */])(isEu);
    });
    Object(__WEBPACK_IMPORTED_MODULE_11__common_lang__["c" /* showBanner */])();
    $('#shop-url').attr('href', Object(__WEBPACK_IMPORTED_MODULE_14__common_utils_tools__["a" /* createUrl */])({
      subdomain: 'shop',
      path: 'collections/strategies',
      isNonBotPage: true
    })); // document.getElementById(dynamicRoutePathanme).classList.add('hidden');

    setTimeout(function () {
      $('.barspinner').hide();
    }, 2000);
  }
};

var loginCheck = function loginCheck() {
  if (Object(__WEBPACK_IMPORTED_MODULE_5__endpoint__["a" /* default */])()) return; // moveToDeriv();

  if (window.location.pathname.indexOf('/bot') === -1) {
    Object(__WEBPACK_IMPORTED_MODULE_11__common_lang__["b" /* load */])();
  }

  $('.show-on-load').show();

  if (bannerToken && window.location.pathname !== '/movetoderiv.html') {
    if (Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["d" /* getTokenList */])().length) {
      if (!window.location.pathname.includes('/bot')) {
        window.location.pathname = "".concat(window.location.pathname.replace(/\/+$/, ''), "/bot.html");
      } // document.getElementById('bot-main').classList.remove('hidden');

    } else {
      Object(__WEBPACK_IMPORTED_MODULE_8__common_appId__["k" /* oauthLogin */])(function () {
        $('.barspinner').hide();
        renderElements();
        __WEBPACK_IMPORTED_MODULE_10__common_gtm__["a" /* default */].init();
      });
    }
  } else {// setTimeout(() => {
    //     renderBanner();
    //     document.getElementById('bot-main').classList.add('hidden');
    // }, 0);
  }
};

loginCheck();

if (!__WEBPACK_IMPORTED_MODULE_14__common_utils_tools__["e" /* isBinaryDomain */]) {
  var _document$getElements, _document$getElements2, _document$getElements3;

  // eslint-disable-next-line no-unused-expressions
  (_document$getElements = document.getElementsByClassName('half-width bottom-image puzzle-logo')[0]) === null || _document$getElements === void 0 ? void 0 : _document$getElements.remove(); // eslint-disable-next-line no-unused-expressions

  (_document$getElements2 = document.getElementsByClassName('dbot-banner__separator')[0]) === null || _document$getElements2 === void 0 ? void 0 : _document$getElements2.remove(); // eslint-disable-next-line no-unused-expressions

  (_document$getElements3 = document.getElementsByClassName('half-width top-image')[0]) === null || _document$getElements3 === void 0 ? void 0 : _document$getElements3.remove();
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = endpoint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_to_string_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_promise_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_symbol_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_string_iterator_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_iterable_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_symbol_async_iterator_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_symbol_async_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_symbol_async_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_slice_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_appId__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_i18n__ = __webpack_require__(2);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

















var MessageProperties = {
  connected: function connected() {
    return "<b>Connected to the Endpoint ".concat(Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["b" /* get */])('config.server_url'), "!</b>");
  },
  error: function error() {
    return "Unable to connect to ".concat(Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["b" /* get */])('config.server_url'), ". Switching connection to default endpoint.");
  }
};
function endpoint() {
  if (!document.location.pathname.includes('/endpoint')) return false;
  $(document).ready(function () {
    $('#error').hide();
    $('#connected').hide();
    $('#new_endpoint').click(addEndpoint);
    $('#reset').click(resetEndpoint);
    init();
  });
  return true;
}
var api; // to close the error connection

function checkConnection(_x, _x2) {
  return _checkConnection.apply(this, arguments);
}

function _checkConnection() {
  _checkConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(appId, apiUrl) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (api && api.disconnect) {
              api.disconnect();
            }

            api = Object(__WEBPACK_IMPORTED_MODULE_14__common_appId__["d" /* generateTestLiveApiInstance */])({
              appId: appId,
              apiUrl: Object(__WEBPACK_IMPORTED_MODULE_14__common_appId__["e" /* generateWebSocketURL */])(apiUrl)
            });
            _context.prev = 2;
            _context.next = 5;
            return api.ping();

          case 5:
            $('#connected').html(MessageProperties.connected()).show();
            _context.next = 14;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            $('#error').html(MessageProperties.error()).show();
            resetEndpoint();
            init();
            checkConnection(Object(__WEBPACK_IMPORTED_MODULE_14__common_appId__["g" /* getDefaultEndpoint */])().appId, Object(__WEBPACK_IMPORTED_MODULE_14__common_appId__["g" /* getDefaultEndpoint */])().url);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8]]);
  }));
  return _checkConnection.apply(this, arguments);
}

function init() {
  var serverUrl = Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["b" /* get */])('config.server_url');
  $('#server_url').val(serverUrl || Object(__WEBPACK_IMPORTED_MODULE_14__common_appId__["g" /* getDefaultEndpoint */])().url);
  $('#app_id').val(Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["b" /* get */])('config.app_id') || Object(__WEBPACK_IMPORTED_MODULE_14__common_appId__["g" /* getDefaultEndpoint */])().appId);
}

function addEndpoint(e) {
  $('#error').hide();
  $('#connected').hide();
  e.preventDefault();
  var serverUrl = $('#server_url').val();
  var appId = $('#app_id').val();
  Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["h" /* set */])('config.server_url', serverUrl);
  Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["h" /* set */])('config.app_id', appId);
  var urlReg = /^(?:http(s)?:\/\/)?[\w.-]+(?:.[\w.-]+)+[\w-._~:?#[\]@!$&'()*+,;=.]+$/;

  if (!urlReg.test(serverUrl)) {
    $('#error').html(Object(__WEBPACK_IMPORTED_MODULE_15__common_i18n__["c" /* translate */])('Please enter a valid server URL')).show();
    return;
  }

  checkConnection(appId, serverUrl);
}

function resetEndpoint() {
  Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["h" /* set */])('config.app_id', Object(__WEBPACK_IMPORTED_MODULE_14__common_appId__["g" /* getDefaultEndpoint */])().appId);
  Object(__WEBPACK_IMPORTED_MODULE_13__common_utils_storageManager__["h" /* set */])('config.server_url', Object(__WEBPACK_IMPORTED_MODULE_14__common_appId__["g" /* getDefaultEndpoint */])().url);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils_tools__ = __webpack_require__(49);



var Logo = function Logo() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: Object(__WEBPACK_IMPORTED_MODULE_1__common_utils_tools__["a" /* createUrl */])({
      path: '',
      isNonBotPage: true
    }),
    target: "blank",
    id: "logo"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "logo-parent"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "responsive",
    src: 'image/binary-style/logo/symbol.svg',
    alt: "Binary logo"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-logo-text"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "responsive",
    src: 'image/binary-style/logo/type.svg',
    alt: "Binary logo"
  }))));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Logo);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_i18n__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_tools__ = __webpack_require__(49);





var SocialIcons = function SocialIcons(_ref) {
  var networks = _ref.networks;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    id: "social-icons",
    className: "social-icons flex-row"
  }, networks.map(function (net, idx) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
      key: idx,
      href: net.href,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      src: "image/footer/".concat(net.media, ".svg")
    }));
  }));
};

var Footer = function Footer() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    id: "footer-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    id: "footer-regulatory",
    className: "primary-bg-color-dark gr-padding-10\""
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "container eu-hide invisible"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-12"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "icon-row flex-row gr-child"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "regulation-logos flex-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    className: "vanuatu-icon",
    href: "https://www.vfsc.vu/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
    className: "responsive",
    src: 'image/footer/vanuatu-logo.png'
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    className: "bvi-icon",
    href: "http://www.bvifsc.vg/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
    className: "responsive",
    src: 'image/footer/bvi.png'
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    className: "labuan-icon",
    href: "https://www.labuanibfc.com/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
    className: "responsive",
    src: 'image/footer/labuan_FSA.svg'
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SocialIcons, {
    networks: [{
      media: 'youtube',
      href: 'https://www.youtube.com/user/BinaryTradingVideos'
    }, {
      media: 'facebook',
      href: 'https://www.facebook.com/derivdotcom'
    }, {
      media: 'twitter',
      href: 'https://twitter.com/derivdotcom'
    }, {
      media: 'telegram',
      href: 'https://t.me/binarydotcom'
    }, {
      media: 'reddit',
      href: 'https://www.reddit.com/r/binarydotcom/'
    }]
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-12"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('In the EU, financial products are offered by Binary Investments (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, regulated as a Category 3 Investment Services provider by the Malta Financial Services Authority ({$0}licence no. IS/70156{$1}).', ["<a href=\"".concat(Object(__WEBPACK_IMPORTED_MODULE_3__common_utils_tools__["a" /* createUrl */])({
    path: 'download/WS-Binary-Investments-Europe-Limited.pdf',
    isNonBotPage: true
  }), "\" target=\"_blank\">"), '</a>'])), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Outside the EU, financial products are offered by Binary (SVG) Ltd, Hinds Building, Kingstown, St. Vincent and the Grenadines; Binary (V) Ltd, Govant Building, Port Vila, PO Box 1276, Vanuatu, regulated by the Vanuatu Financial Services Commission ({$0}view licence{$1}); Binary (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands, regulated by the British Virgin Islands Financial Services Commission ({$2}licence no. SIBA/L/18/1114{$3}); and Binary (FX) Ltd., Lot No. F16, First Floor, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia, regulated by the Labuan Financial Services Authority to carry on a money-broking business ({$4}licence no. MB/18/0024{$5}).', ['<a href="https://www.vfsc.vu/wp-content/uploads/2015/12/List-of-Licensees-under-Dealers-in-Securities-Licensing-Act-CAP-70-18.11.2016.pdf" target="_blank" rel="noopener noreferrer">', '</a>', "<a href=\"".concat(Object(__WEBPACK_IMPORTED_MODULE_3__common_utils_tools__["a" /* createUrl */])({
    path: 'download/regulation/BVI_license.pdf',
    isNonBotPage: true
  }), "\" target=\"_blank\">"), '</a>', "<a href=\"".concat(Object(__WEBPACK_IMPORTED_MODULE_3__common_utils_tools__["a" /* createUrl */])({
    path: 'download/regulation/Labuan-license.pdf',
    isNonBotPage: true
  }), "\" target=\"_blank\">"), '</a>'])), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('This website\'s services are not made available in certain countries such as the USA, Canada, Hong Kong, Japan, or to persons under age 18.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("fieldset", {
    className: "fld-risk-warning"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("legend", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Risk Warning')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('The products offered via this website include binary options, contracts for difference ("CFDs") and other complex derivatives. Trading binary options may not be suitable for everyone. Trading CFDs carries a high level of risk since leverage can work both to your advantage and disadvantage. As a result, the products offered on this website may not be suitable for all investors because of the risk of losing all of your invested capital. You should never invest money that you cannot afford to lose, and never trade with borrowed money. Before trading in the complex products offered, please be sure to understand the risks involved and learn about {$0}Responsible Trading{$1}.', ["<a href=\"".concat(Object(__WEBPACK_IMPORTED_MODULE_3__common_utils_tools__["a" /* createUrl */])({
    path: 'responsible-trading',
    addLanguage: true,
    addHtmlExtension: true,
    isNonBotPage: true
  }), "\">"), '</a>'])))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "container eu-show invisible"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-12"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "icon-row flex-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "regulation-logos flex-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    className: "iom-icon",
    href: "https://www.gov.im/gambling/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
    className: "responsive",
    src: 'image/footer/isle-of-man.png'
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "lga-gamstop-icon-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    className: "gamstop-icon",
    href: "https://www.gamstop.co.uk",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
    className: "responsive",
    src: 'image/footer/gamstop.svg'
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    className: "lga-icon",
    href: "https://www.authorisation.mga.org.mt/verification.aspx?lang=EN&company=a5fd1edc-d072-4c26-b0cd-ab3fa0f0cc40&details=1",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
    className: "responsive",
    src: 'image/footer/mga-logo-footer.svg'
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "age-restriction"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
    className: "responsive",
    src: 'image/footer/18+.svg'
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SocialIcons, {
    networks: [{
      media: 'youtube',
      href: 'https://www.youtube.com/user/BinaryTradingVideos'
    }, {
      media: 'facebook',
      href: 'https://www.facebook.com/binarydotcom'
    }, {
      media: 'twitter',
      href: 'https://twitter.com/Binarydotcom'
    }, {
      media: 'telegram',
      href: 'https://t.me/binarydotcom'
    }, {
      media: 'reddit',
      href: 'https://www.reddit.com/r/binarydotcom/'
    }]
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-12"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('In the EU, financial products are offered by Binary Investments (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta, licensed and regulated as a Category 3 Investment Services provider by the Malta Financial Services Authority (licence no. IS/70156).')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('In the Isle of Man and the UK, Volatility Indices are offered by Binary (IOM) Ltd., First Floor, Millennium House, Victoria Road, Douglas, IM2 4RW, Isle of Man, British Isles; licensed and regulated respectively by (1) the Gambling Supervision Commission in the Isle of Man (current licence issued on 31 August 2017) and by (2) the Gambling Commission in the UK (licence {$0}reference no: 39172{$1}).', ['<a href="https://secure.gamblingcommission.gov.uk/PublicRegister/Search/Detail/39172" target="_blank" rel="noopener noreferrer">', '</a>'])), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('In the rest of the EU, Volatility Indices are offered by Binary (Europe) Ltd., W Business Centre, Level 3, Triq Dun Karm, Birkirkara, BKR 9033, Malta; licensed and regulated by (1) the Malta Gaming Authority in Malta (licence no. MGA/B2C/102/2000 issued on 01 August 2018), for UK clients by (2) the UK Gambling Commission (licence {$0}reference no: 39495{$1}), and for Irish clients by (3) the Revenue Commissioners in Ireland (Remote Bookmaker\'s Licence no. 1010285 issued on 1 July 2017). View complete {$2}Regulatory Information{$1}.', ['<a href="https://secure.gamblingcommission.gov.uk/PublicRegister/Search/Detail/39495" target="_blank" rel="noopener noreferrer">', '</a>', "<a href=\"".concat(Object(__WEBPACK_IMPORTED_MODULE_3__common_utils_tools__["a" /* createUrl */])({
    path: 'regulation',
    addLanguage: true,
    addHtmlExtension: true,
    isNonBotPage: true
  }), "\">")])))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-12"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "about-binary"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Binary.com is an award-winning online trading provider that helps its clients to trade on financial markets through binary options and CFDs. Trading binary options and CFDs on Volatility Indices is classified as a gambling activity. Remember that gambling can be addictive – please play responsibly. Learn more about {$0}Responsible Trading{$1}. Some products are not available in all countries. This website\'s services are not made available in certain countries such as the USA, Canada, Hong Kong, or to persons under age 18.', ["<a href=\"".concat(Object(__WEBPACK_IMPORTED_MODULE_3__common_utils_tools__["a" /* createUrl */])({
    path: 'responsible-trading',
    addLanguage: true,
    addHtmlExtension: true,
    isNonBotPage: true
  }), "\">"), '</a>']))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "gr-12"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "risk-warning"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Trading binary options may not be suitable for everyone, so please ensure that you fully understand the risks involved. Your losses can exceed your initial deposit and you do not own or have any interest in the underlying asset.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
    className: "eu-only invisible"
  }, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. 78.6% of retail investor accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.'))))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    id: "end-note",
    className: "invisible content-inverse-color center-text"
  }));
};

/* unused harmony default export */ var _unused_webpack_default_export = (Footer);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navigation_jsx__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Hero_jsx__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SwitchSection_jsx__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Carousel_jsx__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Card_jsx__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WaitSection_jsx__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChooseSection_jsx__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Footer_jsx__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselTitle_jsx__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TakeDeriv_jsx__ = __webpack_require__(954);










 // eslint-disable-next-line arrow-body-style

var BinaryLanding = function BinaryLanding() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Navigation_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Hero_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SwitchSection_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CarouselTitle_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Carousel_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ChooseSection_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TakeDeriv_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Card_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__WaitSection_jsx__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Footer_jsx__["a" /* default */], null));
};

/* harmony default export */ __webpack_exports__["a"] = (BinaryLanding);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);



var MoveToDerivNav = function MoveToDerivNav() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "navigation"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "navigation-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "navigation-logo"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "#"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/binary.png"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://oauth.deriv.com/oauth2/authorize?app_id=16929&l=en&brand=deriv",
    className: "navigation-to-deriv",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "btn-group right-btn"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Take me to Deriv')))));
};

/* harmony default export */ __webpack_exports__["a"] = (MoveToDerivNav);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_i18n__ = __webpack_require__(2);




var carouselImages = ['image/hero-dmt5.png', 'image/hero-derivgo.png', 'image/hero-derivx.png', 'image/hero-dtrader.png'];
var carouselSettings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 700,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};

var Hero = function Hero() {
  var renderContent = function renderContent() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "hero-wrapper-container_box-binary hero-wrapper-container-left-binary"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('We’re moving!')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('We’ve been'), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b", null, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(' Binary.com')), Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(' for 2 decades and it’s time for an exciting new chapter.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Say hello to our new home,'), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b", null, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(' Deriv.'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "btn-group"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
      href: "https://deriv.com"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
      className: "l-btn primary"
    }, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Hello Deriv!'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
      href: "https://www.binary.com?binary-bot-lp",
      id: "logo"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
      className: "l-btn"
    }, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Maybe later')))));
  };

  var renderCarousel = function renderCarousel() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "hero-wrapper-container_box-binary hero-wrapper-container-right-binary"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slick___default.a, carouselSettings, carouselImages.map(function (slide, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        key: index,
        src: slide
      });
    })));
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "hero-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", {
    className: "hero-wrapper-container"
  }, renderContent(), renderCarousel(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "hero-wrapper-container-logo-binary"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
    src: "image/binary.png"
  }))));
};

/* harmony default export */ __webpack_exports__["a"] = (Hero);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);



var SwitchSection = function SwitchSection() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "switch"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "switch-inner section-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "switch-inner__placeholder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/sectionTwoLandingImages.png"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "switch-inner__content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('It’s so easy to switch to Deriv')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Just log in using your Binary.com credentials. No sign-up needed.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "btn-group"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://oauth.deriv.com/oauth2/authorize?app_id=16929&l=en&brand=deriv",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "l-btn danger"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Try it now'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.binary.com?binary-bot-lp"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "l-btn transparent"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Maybe later')))))));
};

/* harmony default export */ __webpack_exports__["a"] = (SwitchSection);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_i18n__ = __webpack_require__(2);




var carouselContentArray = [{
  url: 'https://smarttrader.deriv.com/',
  action_text: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Check it out'),
  img: 'image/landing-carousel/smart-trader.png',
  platform_title: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('SmartTrader'),
  platform_description: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Our classic options trading platform')
}, {
  url: 'https://bot.deriv.com/',
  action_text: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Check it out'),
  img: 'image/landing-carousel/binary-bot.png',
  platform_title: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Binary Bot'),
  platform_description: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Our classic automated trading platform')
}, {
  url: 'https://deriv.com/dmt5/',
  action_text: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Learn more'),
  img: 'image/landing-carousel/mt5.png',
  platform_title: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Deriv MT5'),
  platform_description: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('The world-famous CFD trading platform')
}, {
  url: 'https://deriv.com/dtrader/',
  action_text: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Learn more'),
  img: 'image/landing-carousel/dtrader.png',
  platform_title: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('DTrader'),
  platform_description: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Our flagship options and multipliers trading platform')
}, {
  url: 'https://deriv.com/dbot/',
  action_text: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Learn more'),
  img: 'image/landing-carousel/dbot.png',
  platform_title: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('DBot'),
  platform_description: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Our next generation automated trading platform')
}, {
  url: 'https://deriv.com/landing/deriv-go/',
  action_text: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Learn more'),
  img: 'image/landing-carousel/deriv-go.png',
  platform_title: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Deriv GO'),
  platform_description: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Trade on-the-go with our mobile trading platform')
}, {
  url: 'https://deriv.com/derivx/',
  action_text: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Learn more'),
  img: 'image/landing-carousel/derivX.png',
  platform_title: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Deriv X'),
  platform_description: Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])('Our customisable CFD trading platform')
}];

var Carousel = function Carousel() {
  var settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    // initialSlide: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 700,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "carousel_section"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "carousel_section__desktop"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slick___default.a, settings, carouselContentArray.map(function (slide, index) {
    var url = slide.url,
        action_text = slide.action_text,
        img = slide.img,
        platform_title = slide.platform_title,
        platform_description = slide.platform_description;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "carousel_section__slide_card"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "carousel_slide_info_wrapper"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", {
      className: "platform_title"
    }, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(platform_title)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", {
      className: "platform_description"
    }, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(platform_description))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      className: "carousel_section__slide_img",
      src: img
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
      href: url
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
      className: "carousel_section__arrow-btn"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "carousel_section__btn_inner"
    }, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(action_text), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      src: 'image/landing-carousel/arrow.svg'
    })))));
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "carousel_section__mobile"
  }, carouselContentArray.map(function (slide, index) {
    var url = slide.url,
        action_text = slide.action_text,
        img = slide.img,
        platform_title = slide.platform_title,
        platform_description = slide.platform_description;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "carousel_section__slide_card"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "carousel_slide_info_wrapper"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", {
      className: "platform_title"
    }, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(platform_title)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", {
      className: "platform_description"
    }, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(platform_description))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      className: "carousel_section__slide_img",
      src: img
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
      href: url
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
      className: "carousel_section__arrow-btn"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "carousel_section__btn_inner"
    }, Object(__WEBPACK_IMPORTED_MODULE_3__common_i18n__["c" /* translate */])(action_text), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      src: 'image/landing-carousel/arrow.svg'
    })))));
  })));
};

/* harmony default export */ __webpack_exports__["a"] = (Carousel);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_i18n__ = __webpack_require__(2);




var CardSection = function CardSection() {
  var cardContentArray = [{
    title: Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Trade multipliers'),
    content: Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Amplify your potential profit without risking more than your stake.'),
    img: 'image/multiplier.png'
  }, {
    title: Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Peer-to-peer payments'),
    content: Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Exchange your local currency with fellow traders to get funds in and out of your account with Deriv P2P.'),
    img: 'image/p2p.png'
  }, {
    title: Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Learn with Deriv Academy'),
    content: Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Enjoy complimentary articles and videos to help you learn the ropes of online trading.'),
    img: 'image/academy.png'
  }, {
    title: Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Crash/Boom indices'),
    content: Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Predict and potentially gain from exciting spikes and dips. Only available with multipliers on DTrader.'),
    img: 'image/crashboom.png'
  }];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "card-container card-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "section-container-holder card-wrapper-holder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "container-header  card-wrapper-holder-header"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Exclusively on Deriv')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('There’s a bright future ahead.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])('Find these bonus features and more on Deriv:')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "card-container card-wrapper-holder-container"
  }, cardContentArray.map(function (card, index) {
    var title = card.title,
        content = card.content,
        img = card.img;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "card-wrapper-holder-container-content",
      key: index
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      src: img
    })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])(title)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_2__common_i18n__["c" /* translate */])(content)));
  })));
};

/* harmony default export */ __webpack_exports__["a"] = (CardSection);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);



var WaitSection = function WaitSection() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "binary-wait-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-wait-wrapper-inner binary-section-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-wait-wrapper-inner-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Don’t wait')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Future-proof your trading. Come over to Deriv now.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "btn-group"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://oauth.deriv.com/oauth2/authorize?app_id=16929&l=en&brand=deriv"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "l-btn danger"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Enter the Deriv experience'))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "../image/dont-wait-image.png",
    className: "binary-wait-wrapper-inner-placeholder-binary-desktop"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-wait-wrapper-inner-placeholder-binary"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "../image/dtrader-mobile.png",
    className: "binary-wait-wrapper-inner-placeholder-binary-mobile"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Come over to Deriv and future-proof your trading now.')))));
};

/* harmony default export */ __webpack_exports__["a"] = (WaitSection);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);



var ChooseSection = function ChooseSection() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "binary-choose-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner binary-section-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", {
    className: "binary-choose-wrapper-inner-title"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Everything you love about Binary.com and more')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-section-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-left"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-left-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-placeholder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/trading-platforms.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-description"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('7 platforms to choose from')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('You’ll find SmartTrader and Binary Bot alongside new platforms like DTrader and Deriv X. Whatever your trading style, we’ve got the platform for you.')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-left-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-placeholder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/trade-types.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-description"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('3 trade types')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Trade CFDs, digital options, and multipliers, a new exciting trade type that boosts your potential profits with limited risk.')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-right-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-placeholder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/fiat-on-ramp.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-description"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", {
    className: "mb0"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Crypto deposits via fiat on-ramp')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Make crypto deposits easily via exchange services such as Changelly, Banxa, and XanPool.'))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-right"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-right-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-placeholder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/instruments.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-description"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Over 100+ instruments')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Trade what you like — forex, commodities, stocks, stock indices, and synthetic indices. ')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-left-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-placeholder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/market_types.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-description"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('6 market types')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Expand your portfolio with a wide range of markets such as forex, stocks, cryptocurrencies, synthetics, and more.')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-right-content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-placeholder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/support.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner-description"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Support when you need it')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Get round-the-clock customer support and access to the Help Centre.')))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "binary-choose-wrapper-inner_btn"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "http://deriv.com/"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "l-btn danger"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Explore Deriv now'))))));
};

/* harmony default export */ __webpack_exports__["a"] = (ChooseSection);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);

 // TODO :- NEED TO IMPORT TEXT FROM TRANSLATONS.JS FILE

var Footer = function Footer() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "about-trade-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner section-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner-social-icons-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-deriv-icons"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/derivLogo.png"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-social-icons"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.reddit.com/user/Deriv_official/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/reddit.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://t.me/derivdotcomofficial",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/telegram.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.facebook.com/derivdotcom",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/facebook.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://twitter.com/derivdotcom/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/twitter.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.instagram.com/deriv_official/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/instagram.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.linkedin.com/company/derivdotcom/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/linkedin.svg"
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner-social-icons-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.reddit.com/user/Deriv_official/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/reddit.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://t.me/derivdotcomofficial",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/telegram.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.facebook.com/derivdotcom",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/facebook.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://twitter.com/derivdotcom/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/twitter.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.instagram.com/deriv_official/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/instagram.svg"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.linkedin.com/company/derivdotcom/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "image/linkedin.svg"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner-info"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner-info-location"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('In the EU, financial products are offered by Deriv Investments (Europe) Limited, W Business Centre, Level 3, Triq Dun Karm, Birkirkara BKR 9033, Malta, licensed in Malta '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://deriv.com/regulatory/Deriv_Investments_(Europe)_Limited.pdf",
    target: "_blank"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('(licence no. IS/70156)'))), " ", Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('and regulated by the Malta Financial Services Authority, Triq l-Imdina, Zone 1, Central Business District, Birkirkara CBD 1010, Malta, under the Investments Services Act. Authorised by the Financial Conduct Authority and with deemed variation of permission. Subject to regulation by the Financial Conduct Authority. The nature and extent of consumer protections may differ from those for firms based in the UK. Details of the Financial Services Contracts Regime, which allows EEA-based firms to operate in the UK for a limited period to carry on activities that are necessary for the performance of pre-existing contracts, are available on the Financial Conduct Authority’s website.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Outside the EU, financial products are offered by the following companies: Deriv (FX) Ltd, F16, Level 1, Paragon Labuan, Jalan Tun Mustapha, 87000 Labuan, Malaysia, licensed by Labuan Financial Services Authority '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://deriv.com/regulatory/Deriv_(FX)_Ltd.pdf",
    target: "_blank"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('(licence no. MB/18/0024);'))), " ", Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Deriv (BVI) Ltd, Kingston Chambers, P.O. Box 173, Road Town, Tortola, British Virgin Islands, licensed by the British Virgin Islands Financial Services Commission '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://deriv.com/regulatory/Deriv_(BVI)_Ltd.pdf",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('(licence no.SIBA/L/18/1114);'))), Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])(' Deriv (V) Ltd, 1276, Kumul Highway, Port Vila, Vanuatu, licensed and regulated by the Vanuatu Financial Services Commission; and Deriv (SVG) LLC, Hinds Buildings, Kingstown, St. Vincent and the Grenadines.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Deriv Limited — 13 Castle Street, St. Helier, JE2 3BT, Jersey — is the holding company for the above subsidiaries.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('This website\'s services are not available in certain countries, including the USA, Canada, and Hong Kong, or to persons below 18.'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "about-trade-wrapper-inner-info-trade"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('CFDs are considered complex derivatives and may not be suitable for retail clients. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money. The products mentioned here may be affected by changes in currency exchange rates. If you invest in these products, you may lose some or all of your investment, and the value of your investment may fluctuate. You should never invest money that you cannot afford to lose and never trade with borrowed money.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Before trading in the complex financial products offered, please be sure to understand the risks involved and learn about '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://deriv.com/responsible/",
    target: "_blank"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Secure and responsible trading.'))))))));
};

/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);



var CarouselTitle = function CarouselTitle() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "carousel-title"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "carousel-title__content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('7 trading platforms — old favourites and new ones, too'))));
};

/* harmony default export */ __webpack_exports__["a"] = (CarouselTitle);

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_i18n__ = __webpack_require__(2);



var TakeDeriv = function TakeDeriv() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "take-deriv"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "take-deriv_background"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "take-deriv_iphone"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "../image/phone-desctop.png"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "take-deriv_qr-code"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Take Deriv with you')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Get the Deriv GO mobile app and trade on the go. Never miss golden opportunities again.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "../image/qr-code.png"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, Object(__WEBPACK_IMPORTED_MODULE_1__common_i18n__["c" /* translate */])('Scan this QR code to download Deriv GO')))));
};

/* harmony default export */ __webpack_exports__["a"] = (TakeDeriv);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.min.js